// This file is auto-generated by @hey-api/openapi-ts

export type AIChatRelatedData = {
    ai_chat_session_uuid?: string | null;
    ai_chat_session_message_uuid?: string | null;
};

export type AIChatSession = {
    readonly uuid: string;
    readonly created_at: string;
    readonly messages: Array<AIChatSessionMessage>;
    readonly documents: Array<Document>;
    title?: string;
    description?: string;
    readonly session_state: SessionStateEnum;
    session_type?: AIChatSessionTypeEnum;
    readonly session_group: string;
    readonly started_by_user: string;
    readonly started_by_user_data: CustomerOrganisationUser;
    readonly system_rating: string | null;
    human_rating?: string | null;
    readonly system_rating_explanation: string;
    readonly system_rating_improvement_suggestions: string;
};

export type AIChatSessionEnhancePromptRequestRequest = {
    /**
     * The original prompt content to enhance.
     */
    content: string;
};

export type AIChatSessionEnhancePromptResponse = {
    /**
     * The enhanced version of the prompt.
     */
    enhanced_content: string;
};

export type AIChatSessionMessage = {
    content: string;
    role: AIChatSessionMessageRoleEnum;
    created_at?: string | null;
    uuid?: string | null;
    user_uuid?: string | null;
    context?: CaseAiContext | null;
    organization_context?: OrganizationAiContext | null;
    preference_suggestion?: PreferenceSuggestionData | null;
    case_specific_info_unavailable?: boolean | null;
};

export type AIChatSessionMessageRoleEnum = 'system' | 'user' | 'assistant';

export const AIChatSessionMessageRoleEnum = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
} as const;

export type AIChatSessionRequest = {
    title?: string;
    description?: string;
    session_type?: AIChatSessionTypeEnum;
    case_uuid?: string;
    session_group_uuid?: string | null;
    human_rating?: string | null;
};

export type AIChatSessionSendMessageRequestRequest = {
    /**
     * The message to send to the AI chat session.
     */
    content: string;
};

export type AIChatSessionSendMessageResponse = {
    message: string;
};

/**
 * * `GLOBAL` - Global
 * * `CASE` - Case
 */
export type AIChatSessionTypeEnum = 'GLOBAL' | 'CASE';

/**
 * * `GLOBAL` - Global
 * * `CASE` - Case
 */
export const AIChatSessionTypeEnum = {
    GLOBAL: 'GLOBAL',
    CASE: 'CASE'
} as const;

/**
 * Response serializer for individual AI split groups.
 */
export type AISplitGroupResponse = {
    /**
     * Suggested name for the document group
     */
    name: string;
    /**
     * Page numbers to include in this group
     */
    pages: Array<(number)>;
    /**
     * Explanation for why this split makes sense
     */
    reasoning: string;
    /**
     * Confidence score for this split (0.0-1.0)
     */
    confidence: number;
};

export type ActaportDataRequest = {
    clerk: string;
    assistant: string;
    title: string;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
    wegen?: string;
    link_decisions?: {
        [key: string]: LinkDecisionValueRequest;
    };
};

/**
 * Field-level match scores for fuzzy matching.
 */
export type ActaportFieldScores = {
    email?: number | null;
    date_of_birth?: number | null;
    name?: number | null;
    phone?: number | null;
    address?: number | null;
};

/**
 * Request serializer for finding party matches.
 */
export type ActaportPartyMatchingRequestRequest = {
    /**
     * UUID of the case being exported
     */
    case_uuid: string;
    /**
     * List of entity UUIDs to check for matches
     */
    participant_uuids: Array<(string)>;
};

/**
 * Complete response for party matching operation.
 */
export type ActaportPartyMatchingResponse = {
    /**
     * True if any parties have potential matches requiring user review
     */
    needs_user_review: boolean;
    total_parties: number;
    parties_with_matches_count: number;
    parties_without_matches_count: number;
    parties_already_linked_count: number;
    parties_with_matches: Array<ActaportPartyWithMatches>;
};

/**
 * A JUPUS entity with its potential Actaport contact matches.
 */
export type ActaportPartyWithMatches = {
    entity_uuid: string;
    entity_name: string;
    entity_type: string;
    entity_email: string | null;
    entity_phone: string | null;
    entity_address: string | null;
    entity_date_of_birth: string | null;
    entity_roles: Array<(string)>;
    has_matches: boolean;
    is_already_linked: boolean;
    existing_actaport_id: string | null;
    match_count: number;
    potential_matches: Array<ActaportPotentialMatch>;
};

/**
 * A potential Actaport contact match with similarity scores.
 */
export type ActaportPotentialMatch = {
    actaport_id: string;
    contact_type: string;
    display_name: string;
    email: string | null;
    phone: string | null;
    address: string | null;
    date_of_birth: string | null;
    overall_score: number;
    /**
     * Match similarity as integer percentage (0-100)
     */
    match_percentage: number;
    matched_fields: Array<(string)>;
    field_scores: ActaportFieldScores;
    highlights: Array<FieldHighlight>;
};

/**
 * Serializer for Actaport integration settings in Organisation model.
 */
export type ActaportSettings = {
    is_actaport_export_integration_enabled?: boolean;
    actaport_client_id?: string | null;
    actaport_client_secret?: string | null;
    actaport_realm?: string | null;
    actaport_username?: string | null;
    actaport_password?: string | null;
};

/**
 * Serializer for Actaport integration settings in Organisation model.
 */
export type ActaportSettingsRequest = {
    is_actaport_export_integration_enabled?: boolean;
    actaport_client_id?: string | null;
    actaport_client_secret?: string | null;
    actaport_realm?: string | null;
    actaport_username?: string | null;
    actaport_password?: string | null;
};

/**
 * * `link` - link
 * * `create_new` - create_new
 */
export type ActionEnum = 'link' | 'create_new';

/**
 * * `link` - link
 * * `create_new` - create_new
 */
export const ActionEnum = {
    LINK: 'link',
    CREATE_NEW: 'create_new'
} as const;

/**
 * * `DRAFT_WORD_DOCUMENT_TEMPLATE` - Draft Word Document Template
 * * `CASE_ASSIGN_LIFECYCLE_WORKFLOW` - Case Assign Lifecycle Workflow
 * * `SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT` - Send Appointment Booking Link To Client
 * * `SEND_CLIENT_TEMPLATE_EMAIL` - Send Client Template Email
 * * `CASE_ASSIGN_LAWYER` - Case Assign Lawyer
 * * `CASE_ASSIGN_LAW_DOMAIN` - Case Assign Law Domain
 * * `CASE_ASSIGN_STATUS` - Case Assign Status
 */
export type ActionTypeEnum = 'DRAFT_WORD_DOCUMENT_TEMPLATE' | 'CASE_ASSIGN_LIFECYCLE_WORKFLOW' | 'SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT' | 'SEND_CLIENT_TEMPLATE_EMAIL' | 'CASE_ASSIGN_LAWYER' | 'CASE_ASSIGN_LAW_DOMAIN' | 'CASE_ASSIGN_STATUS';

/**
 * * `DRAFT_WORD_DOCUMENT_TEMPLATE` - Draft Word Document Template
 * * `CASE_ASSIGN_LIFECYCLE_WORKFLOW` - Case Assign Lifecycle Workflow
 * * `SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT` - Send Appointment Booking Link To Client
 * * `SEND_CLIENT_TEMPLATE_EMAIL` - Send Client Template Email
 * * `CASE_ASSIGN_LAWYER` - Case Assign Lawyer
 * * `CASE_ASSIGN_LAW_DOMAIN` - Case Assign Law Domain
 * * `CASE_ASSIGN_STATUS` - Case Assign Status
 */
export const ActionTypeEnum = {
    DRAFT_WORD_DOCUMENT_TEMPLATE: 'DRAFT_WORD_DOCUMENT_TEMPLATE',
    CASE_ASSIGN_LIFECYCLE_WORKFLOW: 'CASE_ASSIGN_LIFECYCLE_WORKFLOW',
    SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT: 'SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT',
    SEND_CLIENT_TEMPLATE_EMAIL: 'SEND_CLIENT_TEMPLATE_EMAIL',
    CASE_ASSIGN_LAWYER: 'CASE_ASSIGN_LAWYER',
    CASE_ASSIGN_LAW_DOMAIN: 'CASE_ASSIGN_LAW_DOMAIN',
    CASE_ASSIGN_STATUS: 'CASE_ASSIGN_STATUS'
} as const;

/**
 * Base serializer for Activity model.
 */
export type Activity = {
    uuid?: string;
    readonly created_at: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
};

/**
 * Base serializer for Activity model.
 */
export type ActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
};

/**
 * * `DOCUMENT_SIGNED` - Document Signed
 * * `QUESTIONNAIRE_CLOSED` - Questionnaire Closed
 * * `EMAIL_RECEIVED` - Email Received
 * * `EMAIL_SENT` - Email Sent
 * * `CASE_CREATED` - Case Created
 * * `APPOINTMENT_CREATED` - Appointment Created
 */
export type ActivityTypeEnum = 'DOCUMENT_SIGNED' | 'QUESTIONNAIRE_CLOSED' | 'EMAIL_RECEIVED' | 'EMAIL_SENT' | 'CASE_CREATED' | 'APPOINTMENT_CREATED';

/**
 * * `DOCUMENT_SIGNED` - Document Signed
 * * `QUESTIONNAIRE_CLOSED` - Questionnaire Closed
 * * `EMAIL_RECEIVED` - Email Received
 * * `EMAIL_SENT` - Email Sent
 * * `CASE_CREATED` - Case Created
 * * `APPOINTMENT_CREATED` - Appointment Created
 */
export const ActivityTypeEnum = {
    DOCUMENT_SIGNED: 'DOCUMENT_SIGNED',
    QUESTIONNAIRE_CLOSED: 'QUESTIONNAIRE_CLOSED',
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    EMAIL_SENT: 'EMAIL_SENT',
    CASE_CREATED: 'CASE_CREATED',
    APPOINTMENT_CREATED: 'APPOINTMENT_CREATED'
} as const;

export type AdvoluxDataRequest = {
    label: string;
    caseGroup?: number | null;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

/**
 * Serializer for Advolux integration settings in Organisation model.
 */
export type AdvoluxSettings = {
    is_advolux_export_integration_enabled?: boolean;
};

/**
 * Serializer for Advolux integration settings in Organisation model.
 */
export type AdvoluxSettingsRequest = {
    is_advolux_export_integration_enabled?: boolean;
};

export type AdvowareDataRequest = {
    rubrum: string;
    lawField: string;
    lawTopic: string;
    clerk: string;
    rvg?: AdvowareRVGChoiceEnum | NullEnum | null;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

/**
 * * `None` - RVG 2025
 * * `0` - BRAGO
 * * `1` - RVG 2004
 * * `2` - RVG 2006
 * * `3` - Pauschale
 * * `8` - RVG 2013
 * * `9` - StBVV
 * * `10` - Zeithonorar
 * * `14` - Akte nicht abrechnen
 * * `15` - kanzleispezifische Rechnung
 * * `16` - RVG 2021
 * * `21` - StBVV 2025
 */
export type AdvowareRVGChoiceEnum = 0 | 1 | 2 | 3 | 8 | 9 | 10 | 14 | 15 | 16 | 21;

/**
 * * `None` - RVG 2025
 * * `0` - BRAGO
 * * `1` - RVG 2004
 * * `2` - RVG 2006
 * * `3` - Pauschale
 * * `8` - RVG 2013
 * * `9` - StBVV
 * * `10` - Zeithonorar
 * * `14` - Akte nicht abrechnen
 * * `15` - kanzleispezifische Rechnung
 * * `16` - RVG 2021
 * * `21` - StBVV 2025
 */
export const AdvowareRVGChoiceEnum = {
    '_0': 0,
    '_1': 1,
    '_2': 2,
    '_3': 3,
    '_8': 8,
    '_9': 9,
    '_10': 10,
    '_14': 14,
    '_15': 15,
    '_16': 16,
    '_21': 21
} as const;

/**
 * Serializer for a single entity role mapping.
 */
export type AdvowareRoleMapping = {
    entity_uuid: string;
    jupus_role: string;
    advoware_role: string;
};

/**
 * Serializer for Advoware role request.
 */
export type AdvowareRoleRequestRequest = {
    case_uuid: string;
    entity_uuids: Array<(string)>;
};

/**
 * Serializer for Advoware integration settings in Organisation model.
 */
export type AdvowareSettings = {
    is_advoware_export_integration_enabled?: boolean;
    advoware_lawfirm_id?: string | null;
    advoware_database?: string | null;
    advoware_user?: string | null;
    advoware_password?: string;
};

/**
 * Serializer for Advoware integration settings in Organisation model.
 */
export type AdvowareSettingsRequest = {
    is_advoware_export_integration_enabled?: boolean;
    advoware_lawfirm_id?: string | null;
    advoware_database?: string | null;
    advoware_user?: string | null;
    advoware_password?: string;
};

/**
 * Serializer for committing an agent action.
 */
export type AgentActionCommitRequest = {
    /**
     * UUID of the agent action to commit
     */
    agent_action_uuid: string;
    /**
     * Payload to commit the agent action with. Optional, depending on the action.
     */
    payload?: string | null;
};

/**
 * Serializer for rating an agent action.
 */
export type AgentActionRateRequest = {
    /**
     * UUID of the agent action to rate
     */
    agent_action_uuid: string;
    /**
     * Rating value from 0.0 to 5.0
     */
    rating: string;
    /**
     * Variant for negative rating feedback
     *
     * * `INSTRUCTIONS_NOT_FOLLOWED` - Instructions Not Followed
     * * `PAYLOAD_NOT_CORRECT` - Payload Not Correct
     * * `ACTION_NOT_NEEDED` - Action Not Needed
     * * `OTHER` - Other
     */
    rating_negative_variant?: RatingNegativeVariantEnum | NullEnum | null;
    /**
     * Additional comment for negative rating
     */
    rating_negative_comment?: string | null;
};

export type AgentActionRelatedData = {
    agent_action_uuid?: string | null;
};

/**
 * Serializer for reverting an agent action.
 */
export type AgentActionRevertRequest = {
    /**
     * UUID of the agent action to revert
     */
    agent_action_uuid: string;
    /**
     * Payload to revert the agent action with. Optional, depending on the action.
     */
    revert_payload?: string | null;
};

export type AiAnalysisRelatedData = {
    ai_augmentation_uuid?: string | null;
};

/**
 * * `entities.field.address_line_2` - entities.field.address_line_2
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.is_valid_email` - entities.field.is_valid_email
 * * `entities.field.is_valid_phone_number` - entities.field.is_valid_phone_number
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 * * `law.civil_law_accessories_sold_separately` - law.civil_law_accessories_sold_separately
 * * `law.civil_law_case_number` - law.civil_law_case_number
 * * `law.civil_law_claim_amount` - law.civil_law_claim_amount
 * * `law.civil_law_contract_date` - law.civil_law_contract_date
 * * `law.civil_law_contract_duration` - law.civil_law_contract_duration
 * * `law.civil_law_contract_end_date` - law.civil_law_contract_end_date
 * * `law.civil_law_contract` - law.civil_law_contract
 * * `law.civil_law_contract_object` - law.civil_law_contract_object
 * * `law.civil_law_contract_start_date` - law.civil_law_contract_start_date
 * * `law.civil_law_contract_value` - law.civil_law_contract_value
 * * `law.civil_law_correspondence` - law.civil_law_correspondence
 * * `law.civil_law_court_costs` - law.civil_law_court_costs
 * * `law.civil_law_court_document` - law.civil_law_court_document
 * * `law.civil_law_court_name` - law.civil_law_court_name
 * * `law.civil_law_damage_amount` - law.civil_law_damage_amount
 * * `law.civil_law_damage_cause` - law.civil_law_damage_cause
 * * `law.civil_law_damage_claim` - law.civil_law_damage_claim
 * * `law.civil_law_damage_date` - law.civil_law_damage_date
 * * `law.civil_law_damage_description` - law.civil_law_damage_description
 * * `law.civil_law_default_interest` - law.civil_law_default_interest
 * * `law.civil_law_defects` - law.civil_law_defects
 * * `law.civil_law_defects_present` - law.civil_law_defects_present
 * * `law.civil_law_delivery_date` - law.civil_law_delivery_date
 * * `law.civil_law_document_date` - law.civil_law_document_date
 * * `law.civil_law_file_reference` - law.civil_law_file_reference
 * * `law.civil_law_handover_date` - law.civil_law_handover_date
 * * `law.civil_law_hearing_date` - law.civil_law_hearing_date
 * * `law.civil_law_insurance_claim_number` - law.civil_law_insurance_claim_number
 * * `law.civil_law_interest_rate` - law.civil_law_interest_rate
 * * `law.civil_law_judgment_date` - law.civil_law_judgment_date
 * * `law.civil_law_liability_percentage` - law.civil_law_liability_percentage
 * * `law.civil_law_notarial_certification_date` - law.civil_law_notarial_certification_date
 * * `law.civil_law_payment_due_date` - law.civil_law_payment_due_date
 * * `law.civil_law_purchase_agreement` - law.civil_law_purchase_agreement
 * * `law.civil_law_purchase_contract_file_reference` - law.civil_law_purchase_contract_file_reference
 * * `law.civil_law_purchase_date` - law.civil_law_purchase_date
 * * `law.civil_law_purchase_object` - law.civil_law_purchase_object
 * * `law.civil_law_purchase_price_components` - law.civil_law_purchase_price_components
 * * `law.civil_law_purchase_price` - law.civil_law_purchase_price
 * * `law.civil_law_purchase_price_paid_amount` - law.civil_law_purchase_price_paid_amount
 * * `law.civil_law_purchase_price_paid_boolean` - law.civil_law_purchase_price_paid_boolean
 * * `law.civil_law_purchase_price_paid_date` - law.civil_law_purchase_price_paid_date
 * * `law.civil_law_purchase_price_paid` - law.civil_law_purchase_price_paid
 * * `law.civil_law_purchase_price_payment_date` - law.civil_law_purchase_price_payment_date
 * * `law.civil_law_subject_line` - law.civil_law_subject_line
 * * `law.civil_law_termination_notice_period` - law.civil_law_termination_notice_period
 * * `law.civil_law_vehicle_make` - law.civil_law_vehicle_make
 * * `law.civil_law_vehicle_mileage` - law.civil_law_vehicle_mileage
 * * `law.civil_law_vehicle_model` - law.civil_law_vehicle_model
 * * `law.civil_law_vehicle_vin` - law.civil_law_vehicle_vin
 * * `law.civil_law_vehicle_year` - law.civil_law_vehicle_year
 * * `law.civil_law_warranty_period` - law.civil_law_warranty_period
 * * `law.criminal_law_amount_of_daily_rates` - law.criminal_law_amount_of_daily_rates
 * * `law.criminal_law_applicable_laws` - law.criminal_law_applicable_laws
 * * `law.criminal_law_charge_description` - law.criminal_law_charge_description
 * * `law.criminal_law_complaint` - law.criminal_law_complaint
 * * `law.criminal_law_criminal_warrant` - law.criminal_law_criminal_warrant
 * * `law.criminal_law_damage_description` - law.criminal_law_damage_description
 * * `law.criminal_law_damage_value` - law.criminal_law_damage_value
 * * `law.criminal_law_date_of_offense` - law.criminal_law_date_of_offense
 * * `law.criminal_law_duration_of_prison_sentence` - law.criminal_law_duration_of_prison_sentence
 * * `law.criminal_law_evidence_location` - law.criminal_law_evidence_location
 * * `law.criminal_law_evidence` - law.criminal_law_evidence
 * * `law.criminal_law_incident_description` - law.criminal_law_incident_description
 * * `law.criminal_law_indictment_date` - law.criminal_law_indictment_date
 * * `law.criminal_law_indictment_delivery_date` - law.criminal_law_indictment_delivery_date
 * * `law.criminal_law_indictment` - law.criminal_law_indictment
 * * `law.criminal_law_legal_classification_of_offense` - law.criminal_law_legal_classification_of_offense
 * * `law.criminal_law_means_of_evidence` - law.criminal_law_means_of_evidence
 * * `law.criminal_law_number_of_daily_rates` - law.criminal_law_number_of_daily_rates
 * * `law.criminal_law_offense_type` - law.criminal_law_offense_type
 * * `law.criminal_law_penalty_infromation` - law.criminal_law_penalty_infromation
 * * `law.criminal_law_physical_evidence` - law.criminal_law_physical_evidence
 * * `law.criminal_law_place_of_offense` - law.criminal_law_place_of_offense
 * * `law.criminal_law_police_file_number` - law.criminal_law_police_file_number
 * * `law.criminal_law_preliminary_proceedings_date` - law.criminal_law_preliminary_proceedings_date
 * * `law.criminal_law_prison_sentence` - law.criminal_law_prison_sentence
 * * `law.criminal_law_probation` - law.criminal_law_probation
 * * `law.criminal_law_prosecution_file_number` - law.criminal_law_prosecution_file_number
 * * `law.criminal_law_report_date` - law.criminal_law_report_date
 * * `law.criminal_law_report_time` - law.criminal_law_report_time
 * * `law.criminal_law_time_of_offense` - law.criminal_law_time_of_offense
 * * `law.debt_collection_law_business_fee` - law.debt_collection_law_business_fee
 * * `law.debt_collection_law_case_value` - law.debt_collection_law_case_value
 * * `law.debt_collection_law_invoice_amount` - law.debt_collection_law_invoice_amount
 * * `law.debt_collection_law_invoice_date` - law.debt_collection_law_invoice_date
 * * `law.debt_collection_law_invoice_ground` - law.debt_collection_law_invoice_ground
 * * `law.debt_collection_law_invoice_lawyer` - law.debt_collection_law_invoice_lawyer
 * * `law.debt_collection_law_invoice` - law.debt_collection_law_invoice
 * * `law.debt_collection_law_invoice_number` - law.debt_collection_law_invoice_number
 * * `law.debt_collection_law_invoice_recipient` - law.debt_collection_law_invoice_recipient
 * * `law.debt_collection_law_invoice_tax_number` - law.debt_collection_law_invoice_tax_number
 * * `law.debt_collection_law_lumps_sum_expenses` - law.debt_collection_law_lumps_sum_expenses
 * * `law.debt_collection_law_sales_tax` - law.debt_collection_law_sales_tax
 * * `law.debt_collection_law_subtotal_lawyer_fees` - law.debt_collection_law_subtotal_lawyer_fees
 * * `law.debt_collection_law_total_amount` - law.debt_collection_law_total_amount
 * * `law.external_case_id` - law.external_case_id
 * * `law.family_law_average_net_income` - law.family_law_average_net_income
 * * `law.family_law_birth_certificate` - law.family_law_birth_certificate
 * * `law.family_law_birth_register_number` - law.family_law_birth_register_number
 * * `law.family_law_birth_register_office_location` - law.family_law_birth_register_office_location
 * * `law.family_law_children` - law.family_law_children
 * * `law.family_law_date_of_marriage` - law.family_law_date_of_marriage
 * * `law.family_law_divorce_application` - law.family_law_divorce_application
 * * `law.family_law_divorce_settlement_agreement` - law.family_law_divorce_settlement_agreement
 * * `law.family_law_marriage_certificate` - law.family_law_marriage_certificate
 * * `law.family_law_marriage_contract_date` - law.family_law_marriage_contract_date
 * * `law.family_law_marriage_contract` - law.family_law_marriage_contract
 * * `law.family_law_marriage_register_number` - law.family_law_marriage_register_number
 * * `law.family_law_registry_office_location` - law.family_law_registry_office_location
 * * `law.family_law_separation_date` - law.family_law_separation_date
 * * `law.field` - law.field
 * * `law.general_law_amount_net` - law.general_law_amount_net
 * * `law.general_law_amount_total` - law.general_law_amount_total
 * * `law.general_law_appendices` - law.general_law_appendices
 * * `law.general_law_case_number` - law.general_law_case_number
 * * `law.general_law_court_costs` - law.general_law_court_costs
 * * `law.general_law_court_name` - law.general_law_court_name
 * * `law.general_law_doc_date` - law.general_law_doc_date
 * * `law.general_law_due_date` - law.general_law_due_date
 * * `law.general_law_file_ref` - law.general_law_file_ref
 * * `law.general_law_hearing_date` - law.general_law_hearing_date
 * * `law.general_law_invoice_date` - law.general_law_invoice_date
 * * `law.general_law_invoice_number` - law.general_law_invoice_number
 * * `law.general_law_judgment_date` - law.general_law_judgment_date
 * * `law.general_law_correspondence` - law.general_law_correspondence
 * * `law.general_law_court_document` - law.general_law_court_document
 * * `law.general_law_invoice` - law.general_law_invoice
 * * `law.general_law_payment_terms` - law.general_law_payment_terms
 * * `law.general_law_prior_ref` - law.general_law_prior_ref
 * * `law.general_law_subject` - law.general_law_subject
 * * `law.general_law_vat` - law.general_law_vat
 * * `law.generic_document` - law.generic_document
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - law.inheritance_law_certificate_of_inheritance_applicable_law
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - law.inheritance_law_certificate_of_inheritance_date_death
 * * `law.inheritance_law_certificate_of_inheritance_date` - law.inheritance_law_certificate_of_inheritance_date
 * * `law.inheritance_law_certificate_of_inheritance` - law.inheritance_law_certificate_of_inheritance
 * * `law.inheritance_law_certificate_of_inheritance_number` - law.inheritance_law_certificate_of_inheritance_number
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - law.inheritance_law_certificate_of_inheritance_place_of_death
 * * `law.inheritance_law_death_certificate_date_death` - law.inheritance_law_death_certificate_date_death
 * * `law.inheritance_law_death_certificate_date` - law.inheritance_law_death_certificate_date
 * * `law.inheritance_law_death_certificate` - law.inheritance_law_death_certificate
 * * `law.inheritance_law_death_certificate_number` - law.inheritance_law_death_certificate_number
 * * `law.inheritance_law_death_certificate_place_death` - law.inheritance_law_death_certificate_place_death
 * * `law.inheritance_law_death_certificate_place` - law.inheritance_law_death_certificate_place
 * * `law.inheritance_law_death_certificate_time_death` - law.inheritance_law_death_certificate_time_death
 * * `law.inheritance_law_estate_inventory_amount` - law.inheritance_law_estate_inventory_amount
 * * `law.inheritance_law_estate_inventory_date` - law.inheritance_law_estate_inventory_date
 * * `law.inheritance_law_estate_inventory_status` - law.inheritance_law_estate_inventory_status
 * * `law.inheritance_law_inheritance_contract_date` - law.inheritance_law_inheritance_contract_date
 * * `law.inheritance_law_inheritance_contract` - law.inheritance_law_inheritance_contract
 * * `law.inheritance_law_lasting_power_of_attorney_date` - law.inheritance_law_lasting_power_of_attorney_date
 * * `law.inheritance_law_lasting_power_of_attorney` - law.inheritance_law_lasting_power_of_attorney
 * * `law.inheritance_law_list_of_estate` - law.inheritance_law_list_of_estate
 * * `law.inheritance_law_living_will` - law.inheritance_law_living_will
 * * `law.inheritance_law_patient_enrollment_date` - law.inheritance_law_patient_enrollment_date
 * * `law.inheritance_law_testament_date` - law.inheritance_law_testament_date
 * * `law.inheritance_law_will` - law.inheritance_law_will
 * * `law.labor_law_amount_dependent_children` - law.labor_law_amount_dependent_children
 * * `law.labor_law_beginning_of_employment` - law.labor_law_beginning_of_employment
 * * `law.labor_law_certificate_clause` - law.labor_law_certificate_clause
 * * `law.labor_law_child_allowances` - law.labor_law_child_allowances
 * * `law.labor_law_collective_agreement` - law.labor_law_collective_agreement
 * * `law.labor_law_company_agreement` - law.labor_law_company_agreement
 * * `law.labor_law_company_hearing` - law.labor_law_company_hearing
 * * `law.labor_law_dependent_children` - law.labor_law_dependent_children
 * * `law.labor_law_different_place_of_work` - law.labor_law_different_place_of_work
 * * `law.labor_law_disability` - law.labor_law_disability
 * * `law.labor_law_employee_probation_period_end_date` - law.labor_law_employee_probation_period_end_date
 * * `law.labor_law_end_of_employment` - law.labor_law_end_of_employment
 * * `law.labor_law_exemption_irrevocable` - law.labor_law_exemption_irrevocable
 * * `law.labor_law_exemption_revocable` - law.labor_law_exemption_revocable
 * * `law.labor_law_fixed_term_contract_duration` - law.labor_law_fixed_term_contract_duration
 * * `law.labor_law_fixed_term_contract` - law.labor_law_fixed_term_contract
 * * `law.labor_law_grade_certificate_clause` - law.labor_law_grade_certificate_clause
 * * `law.labor_law_is_employee_in_probation_period` - law.labor_law_is_employee_in_probation_period
 * * `law.labor_law_job_title` - law.labor_law_job_title
 * * `law.labor_law_local_transfer_clause` - law.labor_law_local_transfer_clause
 * * `law.labor_law_LTI` - law.labor_law_LTI
 * * `law.labor_law_married` - law.labor_law_married
 * * `law.labor_law_monthly_gross_salary` - law.labor_law_monthly_gross_salary
 * * `law.labor_law_monthly_working_days` - law.labor_law_monthly_working_days
 * * `law.labor_law_notice_period` - law.labor_law_notice_period
 * * `law.labor_law_notice_period_observed` - law.labor_law_notice_period_observed
 * * `law.labor_law_payslip` - law.labor_law_payslip
 * * `law.labor_law_percent_sprinter_clause` - law.labor_law_percent_sprinter_clause
 * * `law.labor_law_place_of_work` - law.labor_law_place_of_work
 * * `law.labor_law_pregnancy` - law.labor_law_pregnancy
 * * `law.labor_law_reaction_company_hering` - law.labor_law_reaction_company_hering
 * * `law.labor_law_reason_for_termination_given` - law.labor_law_reason_for_termination_given
 * * `law.labor_law_return_of_company_property` - law.labor_law_return_of_company_property
 * * `law.labor_law_settlement_agreement_date` - law.labor_law_settlement_agreement_date
 * * `law.labor_law_settlement_agreement` - law.labor_law_settlement_agreement
 * * `law.labor_law_severance_amount` - law.labor_law_severance_amount
 * * `law.labor_law_signature_of_employer` - law.labor_law_signature_of_employer
 * * `law.labor_law_special_documents` - law.labor_law_special_documents
 * * `law.labor_law_special_payments_amount` - law.labor_law_special_payments_amount
 * * `law.labor_law_special_payments` - law.labor_law_special_payments
 * * `law.labor_law_special_personal_circumstances` - law.labor_law_special_personal_circumstances
 * * `law.labor_law_special_protection_against_dismissal` - law.labor_law_special_protection_against_dismissal
 * * `law.labor_law_special_sentence` - law.labor_law_special_sentence
 * * `law.labor_law_sprinter_clause` - law.labor_law_sprinter_clause
 * * `law.labor_law_termination_access_to_termination_to_employee` - law.labor_law_termination_access_to_termination_to_employee
 * * `law.labor_law_termination_agreement_date` - law.labor_law_termination_agreement_date
 * * `law.labor_law_termination_agreement` - law.labor_law_termination_agreement
 * * `law.labor_law_termination_agreement_severance_pay_amount` - law.labor_law_termination_agreement_severance_pay_amount
 * * `law.labor_law_termination_agreement_termination_date` - law.labor_law_termination_agreement_termination_date
 * * `law.labor_law_termination_authorization` - law.labor_law_termination_authorization
 * * `law.labor_law_termination_date_effective` - law.labor_law_termination_date_effective
 * * `law.labor_law_termination_date` - law.labor_law_termination_date
 * * `law.labor_law_termination_employer_more_than_10_employees` - law.labor_law_termination_employer_more_than_10_employees
 * * `law.labor_law_termination_is_agreement_severance_pay` - law.labor_law_termination_is_agreement_severance_pay
 * * `law.labor_law_termination` - law.labor_law_termination
 * * `law.labor_law_termination_operational_reasons` - law.labor_law_termination_operational_reasons
 * * `law.labor_law_termination_without_notice` - law.labor_law_termination_without_notice
 * * `law.labor_law_total_gross_salary` - law.labor_law_total_gross_salary
 * * `law.labor_law_vacation_days` - law.labor_law_vacation_days
 * * `law.labor_law_visum` - law.labor_law_visum
 * * `law.labor_law_VSOP` - law.labor_law_VSOP
 * * `law.labor_law_warning_letter_access_to_warning_letter_to_employee` - law.labor_law_warning_letter_access_to_warning_letter_to_employee
 * * `law.labor_law_warning_letter_date` - law.labor_law_warning_letter_date
 * * `law.labor_law_warning_letter_incident_date` - law.labor_law_warning_letter_incident_date
 * * `law.labor_law_warning_letter_incident_location` - law.labor_law_warning_letter_incident_location
 * * `law.labor_law_warning_letter_incident_time` - law.labor_law_warning_letter_incident_time
 * * `law.labor_law_warning_letter` - law.labor_law_warning_letter
 * * `law.labor_law_warning_letter_reason` - law.labor_law_warning_letter_reason
 * * `law.labor_law_work_contract` - law.labor_law_work_contract
 * * `law.labor_law_work_council` - law.labor_law_work_council
 * * `law.labor_law_work_hours_per_week` - law.labor_law_work_hours_per_week
 * * `law.labor_law_works_council_membership` - law.labor_law_works_council_membership
 * * `law.labor_law_yearly_gross_salary` - law.labor_law_yearly_gross_salary
 * * `law.labor_law_years_of_employment` - law.labor_law_years_of_employment
 * * `law.medicine_law_health_insurance_letter_date` - law.medicine_law_health_insurance_letter_date
 * * `law.medicine_law_health_insurance_letter_decision_justification` - law.medicine_law_health_insurance_letter_decision_justification
 * * `law.medicine_law_health_insurance_letter_decision` - law.medicine_law_health_insurance_letter_decision
 * * `law.medicine_law_health_insurance_letter_legal_remedy_instruction` - law.medicine_law_health_insurance_letter_legal_remedy_instruction
 * * `law.medicine_law_health_insurance_letter` - law.medicine_law_health_insurance_letter
 * * `law.medicine_law_health_insurance_letter_reference_to_application` - law.medicine_law_health_insurance_letter_reference_to_application
 * * `law.medicine_law_hospital_records_admission_date` - law.medicine_law_hospital_records_admission_date
 * * `law.medicine_law_hospital_records_diagnoses_icd_codes` - law.medicine_law_hospital_records_diagnoses_icd_codes
 * * `law.medicine_law_hospital_records_discharge_date` - law.medicine_law_hospital_records_discharge_date
 * * `law.medicine_law_hospital_records_discharge_prognosis` - law.medicine_law_hospital_records_discharge_prognosis
 * * `law.medicine_law_hospital_records_documented_complications` - law.medicine_law_hospital_records_documented_complications
 * * `law.medicine_law_hospital_records` - law.medicine_law_hospital_records
 * * `law.medicine_law_hospital_records_medication_during_stay` - law.medicine_law_hospital_records_medication_during_stay
 * * `law.medicine_law_hospital_records_operation_date` - law.medicine_law_hospital_records_operation_date
 * * `law.medicine_law_hospital_records_operations` - law.medicine_law_hospital_records_operations
 * * `law.medicine_law_hospital_records_station` - law.medicine_law_hospital_records_station
 * * `law.medicine_law_laboratory_results_examination_date` - law.medicine_law_laboratory_results_examination_date
 * * `law.medicine_law_laboratory_results_examination_type` - law.medicine_law_laboratory_results_examination_type
 * * `law.medicine_law_laboratory_results_further_investigation_recommendation` - law.medicine_law_laboratory_results_further_investigation_recommendation
 * * `law.medicine_law_laboratory_results` - law.medicine_law_laboratory_results
 * * `law.medicine_law_laboratory_results_relevant_deviations` - law.medicine_law_laboratory_results_relevant_deviations
 * * `law.medicine_law_medical_bill_cost_bearer` - law.medicine_law_medical_bill_cost_bearer
 * * `law.medicine_law_medical_bill_invoice_date` - law.medicine_law_medical_bill_invoice_date
 * * `law.medicine_law_medical_bill_invoice_number` - law.medicine_law_medical_bill_invoice_number
 * * `law.medicine_law_medical_bill` - law.medicine_law_medical_bill
 * * `law.medicine_law_medical_bill_payment_deadline` - law.medicine_law_medical_bill_payment_deadline
 * * `law.medicine_law_medical_bill_service_period` - law.medicine_law_medical_bill_service_period
 * * `law.medicine_law_medical_bill_services_list` - law.medicine_law_medical_bill_services_list
 * * `law.medicine_law_medical_bill_total_amount` - law.medicine_law_medical_bill_total_amount
 * * `law.medicine_law_medical_expertise_date` - law.medicine_law_medical_expertise_date
 * * `law.medicine_law_medical_expertise_justification` - law.medicine_law_medical_expertise_justification
 * * `law.medicine_law_medical_expertise` - law.medicine_law_medical_expertise
 * * `law.medicine_law_medical_expertise_medical_assessment` - law.medicine_law_medical_expertise_medical_assessment
 * * `law.medicine_law_medical_expertise_question_posed` - law.medicine_law_medical_expertise_question_posed
 * * `law.medicine_law_medical_expertise_result` - law.medicine_law_medical_expertise_result
 * * `law.medicine_law_medical_report_complications` - law.medicine_law_medical_report_complications
 * * `law.medicine_law_medical_report_date` - law.medicine_law_medical_report_date
 * * `law.medicine_law_medical_report_diagnosis_icd_code` - law.medicine_law_medical_report_diagnosis_icd_code
 * * `law.medicine_law_medical_report_diagnosis_short_text` - law.medicine_law_medical_report_diagnosis_short_text
 * * `law.medicine_law_medical_report_further_treatment` - law.medicine_law_medical_report_further_treatment
 * * `law.medicine_law_medical_report` - law.medicine_law_medical_report
 * * `law.medicine_law_medical_report_surgery_date` - law.medicine_law_medical_report_surgery_date
 * * `law.medicine_law_medical_report_treatment_measures` - law.medicine_law_medical_report_treatment_measures
 * * `law.medicine_law_medical_report_treatment_period` - law.medicine_law_medical_report_treatment_period
 * * `law.migration_law_approval_notice_case_number` - law.migration_law_approval_notice_case_number
 * * `law.migration_law_approval_notice_conditions` - law.migration_law_approval_notice_conditions
 * * `law.migration_law_approval_notice_decision_date` - law.migration_law_approval_notice_decision_date
 * * `law.migration_law_approval_notice_issuing_authority` - law.migration_law_approval_notice_issuing_authority
 * * `law.migration_law_approval_notice` - law.migration_law_approval_notice
 * * `law.migration_law_approval_notice_permit_type` - law.migration_law_approval_notice_permit_type
 * * `law.migration_law_approval_notice_pickup_deadline` - law.migration_law_approval_notice_pickup_deadline
 * * `law.migration_law_approval_notice_validity_period` - law.migration_law_approval_notice_validity_period
 * * `law.migration_law_asylum_seeker_certificate_application_number` - law.migration_law_asylum_seeker_certificate_application_number
 * * `law.migration_law_asylum_seeker_certificate_first_registration_date` - law.migration_law_asylum_seeker_certificate_first_registration_date
 * * `law.migration_law_asylum_seeker_certificate_issue_date` - law.migration_law_asylum_seeker_certificate_issue_date
 * * `law.migration_law_asylum_seeker_certificate_issuing_authority` - law.migration_law_asylum_seeker_certificate_issuing_authority
 * * `law.migration_law_asylum_seeker_certificate` - law.migration_law_asylum_seeker_certificate
 * * `law.migration_law_asylum_seeker_certificate_residence_obligation` - law.migration_law_asylum_seeker_certificate_residence_obligation
 * * `law.migration_law_asylum_seeker_certificate_valid_until` - law.migration_law_asylum_seeker_certificate_valid_until
 * * `law.migration_law_asylum_seeker_certificate_work_permission` - law.migration_law_asylum_seeker_certificate_work_permission
 * * `law.migration_law_cooperation_letter_attachments` - law.migration_law_cooperation_letter_attachments
 * * `law.migration_law_cooperation_letter_date` - law.migration_law_cooperation_letter_date
 * * `law.migration_law_cooperation_letter_deadlines` - law.migration_law_cooperation_letter_deadlines
 * * `law.migration_law_cooperation_letter_file_number` - law.migration_law_cooperation_letter_file_number
 * * `law.migration_law_cooperation_letter` - law.migration_law_cooperation_letter
 * * `law.migration_law_cooperation_letter_non_cooperation_consequences` - law.migration_law_cooperation_letter_non_cooperation_consequences
 * * `law.migration_law_cooperation_letter_specified_obligations` - law.migration_law_cooperation_letter_specified_obligations
 * * `law.migration_law_fictional_certificate_authority` - law.migration_law_fictional_certificate_authority
 * * `law.migration_law_fictional_certificate_fiction_type` - law.migration_law_fictional_certificate_fiction_type
 * * `law.migration_law_fictional_certificate_issue_date` - law.migration_law_fictional_certificate_issue_date
 * * `law.migration_law_fictional_certificate_legal_basis` - law.migration_law_fictional_certificate_legal_basis
 * * `law.migration_law_fictional_certificate` - law.migration_law_fictional_certificate
 * * `law.migration_law_fictional_certificate_reason_for_issuance` - law.migration_law_fictional_certificate_reason_for_issuance
 * * `law.migration_law_fictional_certificate_valid_until` - law.migration_law_fictional_certificate_valid_until
 * * `law.migration_law_hearing_letter_date` - law.migration_law_hearing_letter_date
 * * `law.migration_law_hearing_letter_intended_measure_justification` - law.migration_law_hearing_letter_intended_measure_justification
 * * `law.migration_law_hearing_letter_legal_advice` - law.migration_law_hearing_letter_legal_advice
 * * `law.migration_law_hearing_letter` - law.migration_law_hearing_letter
 * * `law.migration_law_hearing_letter_requested_documents` - law.migration_law_hearing_letter_requested_documents
 * * `law.migration_law_hearing_letter_response_deadline` - law.migration_law_hearing_letter_response_deadline
 * * `law.migration_law_other_letters_action_required` - law.migration_law_other_letters_action_required
 * * `law.migration_law_other_letters_date` - law.migration_law_other_letters_date
 * * `law.migration_law_other_letters_deadlines` - law.migration_law_other_letters_deadlines
 * * `law.migration_law_other_letters_file_number` - law.migration_law_other_letters_file_number
 * * `law.migration_law_other_letters_issuing_authority` - law.migration_law_other_letters_issuing_authority
 * * `law.migration_law_other_letters_legal_basis` - law.migration_law_other_letters_legal_basis
 * * `law.migration_law_other_letters` - law.migration_law_other_letters
 * * `law.migration_law_other_letters_matter_purpose` - law.migration_law_other_letters_matter_purpose
 * * `law.migration_law_other_letters_subject` - law.migration_law_other_letters_subject
 * * `law.migration_law_rejection_notice_case_number` - law.migration_law_rejection_notice_case_number
 * * `law.migration_law_rejection_notice_decision_date` - law.migration_law_rejection_notice_decision_date
 * * `law.migration_law_rejection_notice_legal_grounds` - law.migration_law_rejection_notice_legal_grounds
 * * `law.migration_law_rejection_notice_legal_remedy_deadline` - law.migration_law_rejection_notice_legal_remedy_deadline
 * * `law.migration_law_rejection_notice` - law.migration_law_rejection_notice
 * * `law.migration_law_rejection_notice_officer_name` - law.migration_law_rejection_notice_officer_name
 * * `law.migration_law_rejection_notice_reasoning` - law.migration_law_rejection_notice_reasoning
 * * `law.migration_law_rejection_notice_signature_seal` - law.migration_law_rejection_notice_signature_seal
 * * `law.migration_law_rejection_notice_subject` - law.migration_law_rejection_notice_subject
 * * `law.migration_law_residence_permit_conditions` - law.migration_law_residence_permit_conditions
 * * `law.migration_law_residence_permit_issue_date` - law.migration_law_residence_permit_issue_date
 * * `law.migration_law_residence_permit_issuing_authority` - law.migration_law_residence_permit_issuing_authority
 * * `law.migration_law_residence_permit` - law.migration_law_residence_permit
 * * `law.migration_law_residence_permit_national_id_number` - law.migration_law_residence_permit_national_id_number
 * * `law.migration_law_residence_permit_passport_number` - law.migration_law_residence_permit_passport_number
 * * `law.migration_law_residence_permit_purpose` - law.migration_law_residence_permit_purpose
 * * `law.migration_law_residence_permit_type` - law.migration_law_residence_permit_type
 * * `law.migration_law_residence_permit_valid_until` - law.migration_law_residence_permit_valid_until
 * * `law.migration_law_toleration_issue_date` - law.migration_law_toleration_issue_date
 * * `law.migration_law_toleration_issuing_authority` - law.migration_law_toleration_issuing_authority
 * * `law.migration_law_toleration_legal_basis` - law.migration_law_toleration_legal_basis
 * * `law.migration_law_toleration` - law.migration_law_toleration
 * * `law.migration_law_toleration_reason` - law.migration_law_toleration_reason
 * * `law.migration_law_toleration_restrictions` - law.migration_law_toleration_restrictions
 * * `law.migration_law_toleration_valid_until` - law.migration_law_toleration_valid_until
 * * `law.real_estate_law_basic_debts_amount` - law.real_estate_law_basic_debts_amount
 * * `law.real_estate_law_broker_commission_amount` - law.real_estate_law_broker_commission_amount
 * * `law.real_estate_law_broker_contract_type` - law.real_estate_law_broker_contract_type
 * * `law.real_estate_law_broker_scope_of_work` - law.real_estate_law_broker_scope_of_work
 * * `law.real_estate_law_broker_termination_periods` - law.real_estate_law_broker_termination_periods
 * * `law.real_estate_law_brokerage_contract_date` - law.real_estate_law_brokerage_contract_date
 * * `law.real_estate_law_brokerage_contract` - law.real_estate_law_brokerage_contract
 * * `law.real_estate_law_brokerage_fee` - law.real_estate_law_brokerage_fee
 * * `law.real_estate_law_building_dimensions` - law.real_estate_law_building_dimensions
 * * `law.real_estate_law_building_permit_date` - law.real_estate_law_building_permit_date
 * * `law.real_estate_law_building_permit` - law.real_estate_law_building_permit
 * * `law.real_estate_law_building_permit_number` - law.real_estate_law_building_permit_number
 * * `law.real_estate_law_building_permit_validity_duration` - law.real_estate_law_building_permit_validity_duration
 * * `law.real_estate_law_building_plan` - law.real_estate_law_building_plan
 * * `law.real_estate_law_building_restrictions_clause` - law.real_estate_law_building_restrictions_clause
 * * `law.real_estate_law_building_usage` - law.real_estate_law_building_usage
 * * `law.real_estate_law_co_ownership_share` - law.real_estate_law_co_ownership_share
 * * `law.real_estate_law_commission_percentage` - law.real_estate_law_commission_percentage
 * * `law.real_estate_law_contaminated_sites_clause` - law.real_estate_law_contaminated_sites_clause
 * * `law.real_estate_law_declaration_of_division` - law.real_estate_law_declaration_of_division
 * * `law.real_estate_law_division_declaration_date` - law.real_estate_law_division_declaration_date
 * * `law.real_estate_law_encumbrance_restrictions` - law.real_estate_law_encumbrance_restrictions
 * * `law.real_estate_law_encumbrances_section_ii` - law.real_estate_law_encumbrances_section_ii
 * * `law.real_estate_law_encumbrances_section_iii` - law.real_estate_law_encumbrances_section_iii
 * * `law.real_estate_law_exclusive_brokerage_contract` - law.real_estate_law_exclusive_brokerage_contract
 * * `law.real_estate_law_full_repayment_date` - law.real_estate_law_full_repayment_date
 * * `law.real_estate_law_installment_amount` - law.real_estate_law_installment_amount
 * * `law.real_estate_law_interest_rate` - law.real_estate_law_interest_rate
 * * `law.real_estate_law_land_register_address` - law.real_estate_law_land_register_address
 * * `law.real_estate_law_land_register_city` - law.real_estate_law_land_register_city
 * * `law.real_estate_law_land_register_date` - law.real_estate_law_land_register_date
 * * `law.real_estate_law_land_register` - law.real_estate_law_land_register
 * * `law.real_estate_law_land_register_number` - law.real_estate_law_land_register_number
 * * `law.real_estate_law_land_register_plot_of_land` - law.real_estate_law_land_register_plot_of_land
 * * `law.real_estate_law_legal_defects_clause` - law.real_estate_law_legal_defects_clause
 * * `law.real_estate_law_loan_agreement` - law.real_estate_law_loan_agreement
 * * `law.real_estate_law_loan_amount` - law.real_estate_law_loan_amount
 * * `law.real_estate_law_loan_security` - law.real_estate_law_loan_security
 * * `law.real_estate_law_monument_protection_basis` - law.real_estate_law_monument_protection_basis
 * * `law.real_estate_law_monument_protection_notice` - law.real_estate_law_monument_protection_notice
 * * `law.real_estate_law_monument_protection_order_date` - law.real_estate_law_monument_protection_order_date
 * * `law.real_estate_law_monument_protection_order_number` - law.real_estate_law_monument_protection_order_number
 * * `law.real_estate_law_monument_protection_requirements` - law.real_estate_law_monument_protection_requirements
 * * `law.real_estate_law_monument_registration_date` - law.real_estate_law_monument_registration_date
 * * `law.real_estate_law_plan_author` - law.real_estate_law_plan_author
 * * `law.real_estate_law_plan_designation` - law.real_estate_law_plan_designation
 * * `law.real_estate_law_plan_scale` - law.real_estate_law_plan_scale
 * * `law.real_estate_law_plot_size` - law.real_estate_law_plot_size
 * * `law.real_estate_law_property_brokered_by_agent` - law.real_estate_law_property_brokered_by_agent
 * * `law.real_estate_law_purchase_contract_amount` - law.real_estate_law_purchase_contract_amount
 * * `law.real_estate_law_purchase_contract_date` - law.real_estate_law_purchase_contract_date
 * * `law.real_estate_law_purchase_contract_description` - law.real_estate_law_purchase_contract_description
 * * `law.real_estate_law_purchase_contract` - law.real_estate_law_purchase_contract
 * * `law.real_estate_law_purchase_contract_registration_date` - law.real_estate_law_purchase_contract_registration_date
 * * `law.real_estate_law_purchase_contract_registration_number` - law.real_estate_law_purchase_contract_registration_number
 * * `law.real_estate_law_purchase_object_rented` - law.real_estate_law_purchase_object_rented
 * * `law.real_estate_law_purchase_price_loan_financed` - law.real_estate_law_purchase_price_loan_financed
 * * `law.real_estate_law_repayment_rate` - law.real_estate_law_repayment_rate
 * * `law.real_estate_law_withdrawal_instruction_date` - law.real_estate_law_withdrawal_instruction_date
 * * `law.residential_property_law_co_ownership_shares` - law.residential_property_law_co_ownership_shares
 * * `law.residential_property_law_contract_date` - law.residential_property_law_contract_date
 * * `law.residential_property_law_contract` - law.residential_property_law_contract
 * * `law.residential_property_law_inventory` - law.residential_property_law_inventory
 * * `law.residential_property_law_land_register_address` - law.residential_property_law_land_register_address
 * * `law.residential_property_law_land_register_city` - law.residential_property_law_land_register_city
 * * `law.residential_property_law_land_register_number` - law.residential_property_law_land_register_number
 * * `law.residential_property_law_land_register_plot_of_land` - law.residential_property_law_land_register_plot_of_land
 * * `law.social_law_affected_benefit` - law.social_law_affected_benefit
 * * `law.social_law_application_arrival_date` - law.social_law_application_arrival_date
 * * `law.social_law_application_date` - law.social_law_application_date
 * * `law.social_law_application_file_reference` - law.social_law_application_file_reference
 * * `law.social_law_application_form` - law.social_law_application_form
 * * `law.social_law_appointment_date` - law.social_law_appointment_date
 * * `law.social_law_appointment_file_reference` - law.social_law_appointment_file_reference
 * * `law.social_law_appointment_invitation` - law.social_law_appointment_invitation
 * * `law.social_law_appointment_purpose` - law.social_law_appointment_purpose
 * * `law.social_law_appointment_required_documents` - law.social_law_appointment_required_documents
 * * `law.social_law_appointment_time` - law.social_law_appointment_time
 * * `law.social_law_approval_file_reference` - law.social_law_approval_file_reference
 * * `law.social_law_approval_internal_reference` - law.social_law_approval_internal_reference
 * * `law.social_law_approval_legal_basis` - law.social_law_approval_legal_basis
 * * `law.social_law_approval_notice_date` - law.social_law_approval_notice_date
 * * `law.social_law_approval_notice` - law.social_law_approval_notice
 * * `law.social_law_approval_period_end` - law.social_law_approval_period_end
 * * `law.social_law_approval_period_start` - law.social_law_approval_period_start
 * * `law.social_law_approved_benefit_amount` - law.social_law_approved_benefit_amount
 * * `law.social_law_approved_benefit_period` - law.social_law_approved_benefit_period
 * * `law.social_law_approved_benefit_type` - law.social_law_approved_benefit_type
 * * `law.social_law_asset_type` - law.social_law_asset_type
 * * `law.social_law_attachment_list` - law.social_law_attachment_list
 * * `law.social_law_benefit_type` - law.social_law_benefit_type
 * * `law.social_law_change_description` - law.social_law_change_description
 * * `law.social_law_change_file_reference` - law.social_law_change_file_reference
 * * `law.social_law_change_notification_date` - law.social_law_change_notification_date
 * * `law.social_law_change_notification` - law.social_law_change_notification
 * * `law.social_law_change_reason` - law.social_law_change_reason
 * * `law.social_law_creditable_income` - law.social_law_creditable_income
 * * `law.social_law_disability_card_issue_date` - law.social_law_disability_card_issue_date
 * * `law.social_law_disability_card` - law.social_law_disability_card
 * * `law.social_law_disability_card_markers` - law.social_law_disability_card_markers
 * * `law.social_law_disability_card_validity_period` - law.social_law_disability_card_validity_period
 * * `law.social_law_disability_degree` - law.social_law_disability_degree
 * * `law.social_law_disability_file_reference` - law.social_law_disability_file_reference
 * * `law.social_law_employment_income` - law.social_law_employment_income
 * * `law.social_law_follow_up_application_notes` - law.social_law_follow_up_application_notes
 * * `law.social_law_hearing_file_reference` - law.social_law_hearing_file_reference
 * * `law.social_law_hearing_letter_date` - law.social_law_hearing_letter_date
 * * `law.social_law_hearing_letter` - law.social_law_hearing_letter
 * * `law.social_law_hearing_planned_administrative_act` - law.social_law_hearing_planned_administrative_act
 * * `law.social_law_housing_costs_amount` - law.social_law_housing_costs_amount
 * * `law.social_law_income_amount` - law.social_law_income_amount
 * * `law.social_law_income_date` - law.social_law_income_date
 * * `law.social_law_income_legal_basis` - law.social_law_income_legal_basis
 * * `law.social_law_income_provider` - law.social_law_income_provider
 * * `law.social_law_income_source` - law.social_law_income_source
 * * `law.social_law_income_type` - law.social_law_income_type
 * * `law.social_law_interim_legal_protection` - law.social_law_interim_legal_protection
 * * `law.social_law_interim_protection_affidavit` - law.social_law_interim_protection_affidavit
 * * `law.social_law_interim_protection_attachment_list` - law.social_law_interim_protection_attachment_list
 * * `law.social_law_interim_protection_file_reference` - law.social_law_interim_protection_file_reference
 * * `law.social_law_interim_protection_request_date` - law.social_law_interim_protection_request_date
 * * `law.social_law_interim_protection_request_text` - law.social_law_interim_protection_request_text
 * * `law.social_law_interim_protection_urgency_reason` - law.social_law_interim_protection_urgency_reason
 * * `law.social_law_lawsuit_alternative_request` - law.social_law_lawsuit_alternative_request
 * * `law.social_law_lawsuit_attachment_list` - law.social_law_lawsuit_attachment_list
 * * `law.social_law_lawsuit_cost_request` - law.social_law_lawsuit_cost_request
 * * `law.social_law_lawsuit_court_file_number` - law.social_law_lawsuit_court_file_number
 * * `law.social_law_lawsuit_delivery_date` - law.social_law_lawsuit_delivery_date
 * * `law.social_law_lawsuit_dispute_value` - law.social_law_lawsuit_dispute_value
 * * `law.social_law_lawsuit_disputed_amount` - law.social_law_lawsuit_disputed_amount
 * * `law.social_law_lawsuit_evidence_requests` - law.social_law_lawsuit_evidence_requests
 * * `law.social_law_lawsuit_file_reference` - law.social_law_lawsuit_file_reference
 * * `law.social_law_lawsuit_filing_date` - law.social_law_lawsuit_filing_date
 * * `law.social_law_lawsuit_income_amount` - law.social_law_lawsuit_income_amount
 * * `law.social_law_lawsuit_legal_basis` - law.social_law_lawsuit_legal_basis
 * * `law.social_law_lawsuit_main_request` - law.social_law_lawsuit_main_request
 * * `law.social_law_lawsuit` - law.social_law_lawsuit
 * * `law.social_law_lawsuit_monthly_benefit_amount` - law.social_law_lawsuit_monthly_benefit_amount
 * * `law.social_law_lawsuit_objection_decision_date` - law.social_law_lawsuit_objection_decision_date
 * * `law.social_law_lawsuit_objection_filing_date` - law.social_law_lawsuit_objection_filing_date
 * * `law.social_law_lawsuit_original_decision_date` - law.social_law_lawsuit_original_decision_date
 * * `law.social_law_lawsuit_subject` - law.social_law_lawsuit_subject
 * * `law.social_law_lawsuit_type` - law.social_law_lawsuit_type
 * * `law.social_law_legal_basis` - law.social_law_legal_basis
 * * `law.social_law_medical_certificate` - law.social_law_medical_certificate
 * * `law.social_law_medical_diagnosis` - law.social_law_medical_diagnosis
 * * `law.social_law_medical_examination_date` - law.social_law_medical_examination_date
 * * `law.social_law_medical_file_reference` - law.social_law_medical_file_reference
 * * `law.social_law_medical_icd_code` - law.social_law_medical_icd_code
 * * `law.social_law_medical_limitations` - law.social_law_medical_limitations
 * * `law.social_law_medical_prognosis` - law.social_law_medical_prognosis
 * * `law.social_law_medical_work_capacity_relation` - law.social_law_medical_work_capacity_relation
 * * `law.social_law_monthly_payment_amount` - law.social_law_monthly_payment_amount
 * * `law.social_law_needs_cost_breakdown` - law.social_law_needs_cost_breakdown
 * * `law.social_law_needs_file_reference` - law.social_law_needs_file_reference
 * * `law.social_law_needs_proof_basis` - law.social_law_needs_proof_basis
 * * `law.social_law_needs_proof_date` - law.social_law_needs_proof_date
 * * `law.social_law_needs_proof` - law.social_law_needs_proof
 * * `law.social_law_needs_type` - law.social_law_needs_type
 * * `law.social_law_notice_date` - law.social_law_notice_date
 * * `law.social_law_notice_of_objection_date` - law.social_law_notice_of_objection_date
 * * `law.social_law_notice_of_objection_file_reference` - law.social_law_notice_of_objection_file_reference
 * * `law.social_law_notice_of_objection` - law.social_law_notice_of_objection
 * * `law.social_law_notification_date` - law.social_law_notification_date
 * * `law.social_law_notification_legal_basis` - law.social_law_notification_legal_basis
 * * `law.social_law_notification_source` - law.social_law_notification_source
 * * `law.social_law_objection_challenged_notice` - law.social_law_objection_challenged_notice
 * * `law.social_law_objection_date` - law.social_law_objection_date
 * * `law.social_law_objection_evidence` - law.social_law_objection_evidence
 * * `law.social_law_objection_file_reference` - law.social_law_objection_file_reference
 * * `law.social_law_objection` - law.social_law_objection
 * * `law.social_law_objection_reasoning` - law.social_law_objection_reasoning
 * * `law.social_law_objection_suspension_request` - law.social_law_objection_suspension_request
 * * `law.social_law_original_decision_date` - law.social_law_original_decision_date
 * * `law.social_law_other_income` - law.social_law_other_income
 * * `law.social_law_own_income_amount` - law.social_law_own_income_amount
 * * `law.social_law_reclaim_amount` - law.social_law_reclaim_amount
 * * `law.social_law_reclaim_file_reference` - law.social_law_reclaim_file_reference
 * * `law.social_law_reclaim_legal_basis` - law.social_law_reclaim_legal_basis
 * * `law.social_law_reclaim_legal_norm` - law.social_law_reclaim_legal_norm
 * * `law.social_law_reclaim_notice_date` - law.social_law_reclaim_notice_date
 * * `law.social_law_reclaim_notice` - law.social_law_reclaim_notice
 * * `law.social_law_reclaim_payment_deadline` - law.social_law_reclaim_payment_deadline
 * * `law.social_law_reclaim_payment_terms` - law.social_law_reclaim_payment_terms
 * * `law.social_law_regelbedarf_amount` - law.social_law_regelbedarf_amount
 * * `law.social_law_rejection_file_reference` - law.social_law_rejection_file_reference
 * * `law.social_law_rejection_legal_norm` - law.social_law_rejection_legal_norm
 * * `law.social_law_rejection_notice_date` - law.social_law_rejection_notice_date
 * * `law.social_law_rejection_notice` - law.social_law_rejection_notice
 * * `law.social_law_rejection_reason` - law.social_law_rejection_reason
 * * `law.social_law_residence_status` - law.social_law_residence_status
 * * `law.social_law_revocation_benefit_type` - law.social_law_revocation_benefit_type
 * * `law.social_law_revocation_file_reference` - law.social_law_revocation_file_reference
 * * `law.social_law_revocation_legal_norm` - law.social_law_revocation_legal_norm
 * * `law.social_law_revocation_notice_date` - law.social_law_revocation_notice_date
 * * `law.social_law_revocation_notice` - law.social_law_revocation_notice
 * * `law.social_law_revocation_period_end` - law.social_law_revocation_period_end
 * * `law.social_law_revocation_period_start` - law.social_law_revocation_period_start
 * * `law.social_law_revocation_reason` - law.social_law_revocation_reason
 * * `law.social_law_revocation_reclaim_notes` - law.social_law_revocation_reclaim_notes
 * * `law.social_law_social_benefit_type` - law.social_law_social_benefit_type
 * * `law.social_law_summary_grounds_opposition` - law.social_law_summary_grounds_opposition
 * * `law.social_law_total_need_amount` - law.social_law_total_need_amount
 * * `law.social_law_total_reclaim_amount` - law.social_law_total_reclaim_amount
 * * `law.social_law_violation_type` - law.social_law_violation_type
 * * `law.tenancy_law_adress_rental_property` - law.tenancy_law_adress_rental_property
 * * `law.tenancy_law_advance_payment_service_charge` - law.tenancy_law_advance_payment_service_charge
 * * `law.tenancy_law_advance_payment_service_charges` - law.tenancy_law_advance_payment_service_charges
 * * `law.tenancy_law_bank_guarantee` - law.tenancy_law_bank_guarantee
 * * `law.tenancy_law_cash_deposit_agreed` - law.tenancy_law_cash_deposit_agreed
 * * `law.tenancy_law_cash_deposit_payment_date` - law.tenancy_law_cash_deposit_payment_date
 * * `law.tenancy_law_competent_court` - law.tenancy_law_competent_court
 * * `law.tenancy_law_cost_share` - law.tenancy_law_cost_share
 * * `law.tenancy_law_cost_shares` - law.tenancy_law_cost_shares
 * * `law.tenancy_law_counter_number` - law.tenancy_law_counter_number
 * * `law.tenancy_law_court_case_number` - law.tenancy_law_court_case_number
 * * `law.tenancy_law_court_proceedings_pending` - law.tenancy_law_court_proceedings_pending
 * * `law.tenancy_law_description_of_rental_property` - law.tenancy_law_description_of_rental_property
 * * `law.tenancy_law_duration_of_lease` - law.tenancy_law_duration_of_lease
 * * `law.tenancy_law_expert_report_commission_date` - law.tenancy_law_expert_report_commission_date
 * * `law.tenancy_law_expert_report_damage_description` - law.tenancy_law_expert_report_damage_description
 * * `law.tenancy_law_expert_report_damage_number` - law.tenancy_law_expert_report_damage_number
 * * `law.tenancy_law_expert_report_date` - law.tenancy_law_expert_report_date
 * * `law.tenancy_law_expert_report_inspection_date` - law.tenancy_law_expert_report_inspection_date
 * * `law.tenancy_law_expert_report` - law.tenancy_law_expert_report
 * * `law.tenancy_law_expert_report_object_address` - law.tenancy_law_expert_report_object_address
 * * `law.tenancy_law_expert_report_purpose` - law.tenancy_law_expert_report_purpose
 * * `law.tenancy_law_expert_report_repair_duration` - law.tenancy_law_expert_report_repair_duration
 * * `law.tenancy_law_expert_report_subject` - law.tenancy_law_expert_report_subject
 * * `law.tenancy_law_extension_option_count` - law.tenancy_law_extension_option_count
 * * `law.tenancy_law_extension_option_duration` - law.tenancy_law_extension_option_duration
 * * `law.tenancy_law_fixed_term_tenancy` - law.tenancy_law_fixed_term_tenancy
 * * `law.tenancy_law_garage_available` - law.tenancy_law_garage_available
 * * `law.tenancy_law_garage_costs` - law.tenancy_law_garage_costs
 * * `law.tenancy_law_general_status_documents` - law.tenancy_law_general_status_documents
 * * `law.tenancy_law_gross_rent` - law.tenancy_law_gross_rent
 * * `law.tenancy_law_handover_counter` - law.tenancy_law_handover_counter
 * * `law.tenancy_law_handover_date` - law.tenancy_law_handover_date
 * * `law.tenancy_law_handover_defects` - law.tenancy_law_handover_defects
 * * `law.tenancy_law_handover_protocol` - law.tenancy_law_handover_protocol
 * * `law.tenancy_law_landlord_termination_given` - law.tenancy_law_landlord_termination_given
 * * `law.tenancy_law_last_rent_increase_letter_date` - law.tenancy_law_last_rent_increase_letter_date
 * * `law.tenancy_law_last_signature_date` - law.tenancy_law_last_signature_date
 * * `law.tenancy_law_lease_agreement` - law.tenancy_law_lease_agreement
 * * `law.tenancy_law_location_in_rental_property` - law.tenancy_law_location_in_rental_property
 * * `law.tenancy_law_net_rent` - law.tenancy_law_net_rent
 * * `law.tenancy_law_operating_costs_agreement` - law.tenancy_law_operating_costs_agreement
 * * `law.tenancy_law_parking_space_available` - law.tenancy_law_parking_space_available
 * * `law.tenancy_law_parking_space_costs` - law.tenancy_law_parking_space_costs
 * * `law.tenancy_law_property_return_date` - law.tenancy_law_property_return_date
 * * `law.tenancy_law_rent_increase_effective_date` - law.tenancy_law_rent_increase_effective_date
 * * `law.tenancy_law_rent_increase_notice` - law.tenancy_law_rent_increase_notice
 * * `law.tenancy_law_rental_agreement_date` - law.tenancy_law_rental_agreement_date
 * * `law.tenancy_law_rental_agreement_duration` - law.tenancy_law_rental_agreement_duration
 * * `law.tenancy_law_rental_agreement` - law.tenancy_law_rental_agreement
 * * `law.tenancy_law_rental_agreement_validity_end` - law.tenancy_law_rental_agreement_validity_end
 * * `law.tenancy_law_rental_agreement_validity_start` - law.tenancy_law_rental_agreement_validity_start
 * * `law.tenancy_law_rental_object_size_sqm` - law.tenancy_law_rental_object_size_sqm
 * * `law.tenancy_law_repayment` - law.tenancy_law_repayment
 * * `law.tenancy_law_repayment_period_end` - law.tenancy_law_repayment_period_end
 * * `law.tenancy_law_repayment_period_start` - law.tenancy_law_repayment_period_start
 * * `law.tenancy_law_security_deposit_additional_regulations` - law.tenancy_law_security_deposit_additional_regulations
 * * `law.tenancy_law_security_deposit_amount` - law.tenancy_law_security_deposit_amount
 * * `law.tenancy_law_service_charge_settlement` - law.tenancy_law_service_charge_settlement
 * * `law.tenancy_law_staggered_rental_agreement` - law.tenancy_law_staggered_rental_agreement
 * * `law.tenancy_law_start_of_lease` - law.tenancy_law_start_of_lease
 * * `law.tenancy_law_tenancy_terminated` - law.tenancy_law_tenancy_terminated
 * * `law.tenancy_law_tenancy_termination_date` - law.tenancy_law_tenancy_termination_date
 * * `law.tenancy_law_tenant_extension_option` - law.tenancy_law_tenant_extension_option
 * * `law.tenancy_law_tenant_warned` - law.tenancy_law_tenant_warned
 * * `law.tenancy_law_termination_declared_date` - law.tenancy_law_termination_declared_date
 * * `law.tenancy_law_termination_letter_date` - law.tenancy_law_termination_letter_date
 * * `law.tenancy_law_termination_notice` - law.tenancy_law_termination_notice
 * * `law.tenancy_law_termination_notice_period` - law.tenancy_law_termination_notice_period
 * * `law.tenancy_law_total_cost_service_charge` - law.tenancy_law_total_cost_service_charge
 * * `law.tenancy_law_total_rent` - law.tenancy_law_total_rent
 * * `law.tenancy_law_unlimited_term_tenancy` - law.tenancy_law_unlimited_term_tenancy
 * * `law.tenancy_law_value_security_clause` - law.tenancy_law_value_security_clause
 * * `law.tenancy_law_warning_letter_date` - law.tenancy_law_warning_letter_date
 * * `law.tenancy_law_warning_letter` - law.tenancy_law_warning_letter
 * * `law.topic` - law.topic
 * * `law.traffic_law_accident_date` - law.traffic_law_accident_date
 * * `law.traffic_law_accident_report` - law.traffic_law_accident_report
 * * `law.traffic_law_amount_of_fine` - law.traffic_law_amount_of_fine
 * * `law.traffic_law_appeal_instruction` - law.traffic_law_appeal_instruction
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - law.traffic_law_at_fault_driver_drivers_license_issued_by
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - law.traffic_law_at_fault_driver_drivers_license_valid_until
 * * `law.traffic_law_at_fault_driver_green_card_number` - law.traffic_law_at_fault_driver_green_card_number
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - law.traffic_law_at_fault_driver_insurance_expiry_date
 * * `law.traffic_law_at_fault_driver_insurance_number` - law.traffic_law_at_fault_driver_insurance_number
 * * `law.traffic_law_at_fault_driver_insurer` - law.traffic_law_at_fault_driver_insurer
 * * `law.traffic_law_blood_alcohol_concentration` - law.traffic_law_blood_alcohol_concentration
 * * `law.traffic_law_calculated_total_damage_costs` - law.traffic_law_calculated_total_damage_costs
 * * `law.traffic_law_calculated_total_days` - law.traffic_law_calculated_total_days
 * * `law.traffic_law_charges` - law.traffic_law_charges
 * * `law.traffic_law_cost_per_scale` - law.traffic_law_cost_per_scale
 * * `law.traffic_law_daily_rate` - law.traffic_law_daily_rate
 * * `law.traffic_law_damage_amount_net` - law.traffic_law_damage_amount_net
 * * `law.traffic_law_damage_number` - law.traffic_law_damage_number
 * * `law.traffic_law_damage_scope` - law.traffic_law_damage_scope
 * * `law.traffic_law_date_of_accident` - law.traffic_law_date_of_accident
 * * `law.traffic_law_date_of_crime` - law.traffic_law_date_of_crime
 * * `law.traffic_law_date_of_fine` - law.traffic_law_date_of_fine
 * * `law.traffic_law_date_of_infraction` - law.traffic_law_date_of_infraction
 * * `law.traffic_law_date_of_inspection` - law.traffic_law_date_of_inspection
 * * `law.traffic_law_date_of_issue` - law.traffic_law_date_of_issue
 * * `law.traffic_law_date_of_offense` - law.traffic_law_date_of_offense
 * * `law.traffic_law_date_of_report` - law.traffic_law_date_of_report
 * * `law.traffic_law_differencial_tax` - law.traffic_law_differencial_tax
 * * `law.traffic_law_driver_logbook_required` - law.traffic_law_driver_logbook_required
 * * `law.traffic_law_driving_ban_duration` - law.traffic_law_driving_ban_duration
 * * `law.traffic_law_driving_ban` - law.traffic_law_driving_ban
 * * `law.traffic_law_evidence_infraction` - law.traffic_law_evidence_infraction
 * * `law.traffic_law_expert_cost` - law.traffic_law_expert_cost
 * * `law.traffic_law_expert_date` - law.traffic_law_expert_date
 * * `law.traffic_law_expert_report` - law.traffic_law_expert_report
 * * `law.traffic_law_expert_report_number` - law.traffic_law_expert_report_number
 * * `law.traffic_law_file_number` - law.traffic_law_file_number
 * * `law.traffic_law_fine` - law.traffic_law_fine
 * * `law.traffic_law_fine_notice` - law.traffic_law_fine_notice
 * * `law.traffic_law_gross_gross_replacement_value` - law.traffic_law_gross_gross_replacement_value
 * * `law.traffic_law_gross_replacement_value` - law.traffic_law_gross_replacement_value
 * * `law.traffic_law_injured` - law.traffic_law_injured
 * * `law.traffic_law_insurance_holder` - law.traffic_law_insurance_holder
 * * `law.traffic_law_insurance` - law.traffic_law_insurance
 * * `law.traffic_law_insurance_policy_number` - law.traffic_law_insurance_policy_number
 * * `law.traffic_law_legal_basis_infraction` - law.traffic_law_legal_basis_infraction
 * * `law.traffic_law_legal_basis` - law.traffic_law_legal_basis
 * * `law.traffic_law_licenseplate_at_fault_driver` - law.traffic_law_licenseplate_at_fault_driver
 * * `law.traffic_law_licenseplate` - law.traffic_law_licenseplate
 * * `law.traffic_law_licenseplate_victim_driver` - law.traffic_law_licenseplate_victim_driver
 * * `law.traffic_law_loss_amount_repair_case` - law.traffic_law_loss_amount_repair_case
 * * `law.traffic_law_loss_amount_total_damage_case` - law.traffic_law_loss_amount_total_damage_case
 * * `law.traffic_law_loss_of_use_per_day` - law.traffic_law_loss_of_use_per_day
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - law.traffic_law_mark_and_type_of_at_fault_driver
 * * `law.traffic_law_mark_and_type_of_victim_driver` - law.traffic_law_mark_and_type_of_victim_driver
 * * `law.traffic_law_merantile_value_loss` - law.traffic_law_merantile_value_loss
 * * `law.traffic_law_net_gross_replacement_value` - law.traffic_law_net_gross_replacement_value
 * * `law.traffic_law_net_replacement_value` - law.traffic_law_net_replacement_value
 * * `law.traffic_law_number_of_daily_rates` - law.traffic_law_number_of_daily_rates
 * * `law.traffic_law_offense_infraction_description` - law.traffic_law_offense_infraction_description
 * * `law.traffic_law_other_damages` - law.traffic_law_other_damages
 * * `law.traffic_law_payment_deadline` - law.traffic_law_payment_deadline
 * * `law.traffic_law_penalty_order` - law.traffic_law_penalty_order
 * * `law.traffic_law_place_of_accident` - law.traffic_law_place_of_accident
 * * `law.traffic_law_place_of_crime` - law.traffic_law_place_of_crime
 * * `law.traffic_law_place_of_infraction` - law.traffic_law_place_of_infraction
 * * `law.traffic_law_place_of_inspection` - law.traffic_law_place_of_inspection
 * * `law.traffic_law_place_of_issue` - law.traffic_law_place_of_issue
 * * `law.traffic_law_place_of_offense` - law.traffic_law_place_of_offense
 * * `law.traffic_law_points_for_offense` - law.traffic_law_points_for_offense
 * * `law.traffic_law_police_case_number` - law.traffic_law_police_case_number
 * * `law.traffic_law_procedure_costs` - law.traffic_law_procedure_costs
 * * `law.traffic_law_prosecution_number` - law.traffic_law_prosecution_number
 * * `law.traffic_law_regular_tax` - law.traffic_law_regular_tax
 * * `law.traffic_law_repair_costs_with_vat` - law.traffic_law_repair_costs_with_vat
 * * `law.traffic_law_repair_costs_without_vat` - law.traffic_law_repair_costs_without_vat
 * * `law.traffic_law_repair_damage` - law.traffic_law_repair_damage
 * * `law.traffic_law_repair_duration` - law.traffic_law_repair_duration
 * * `law.traffic_law_replacement_cost` - law.traffic_law_replacement_cost
 * * `law.traffic_law_replacement_value` - law.traffic_law_replacement_value
 * * `law.traffic_law_reregistration_cost` - law.traffic_law_reregistration_cost
 * * `law.traffic_law_residual_value` - law.traffic_law_residual_value
 * * `law.traffic_law_speed_allowed` - law.traffic_law_speed_allowed
 * * `law.traffic_law_speed_driven` - law.traffic_law_speed_driven
 * * `law.traffic_law_speed_too_high` - law.traffic_law_speed_too_high
 * * `law.traffic_law_time_of_accident` - law.traffic_law_time_of_accident
 * * `law.traffic_law_time_of_crime` - law.traffic_law_time_of_crime
 * * `law.traffic_law_time_of_infraction` - law.traffic_law_time_of_infraction
 * * `law.traffic_law_time_of_inspection` - law.traffic_law_time_of_inspection
 * * `law.traffic_law_time_of_issue` - law.traffic_law_time_of_issue
 * * `law.traffic_law_time_of_offense` - law.traffic_law_time_of_offense
 * * `law.traffic_law_total_damage` - law.traffic_law_total_damage
 * * `law.traffic_law_value_improvement` - law.traffic_law_value_improvement
 * * `law.traffic_law_vehicle_age_months` - law.traffic_law_vehicle_age_months
 * * `law.traffic_law_vehicle_mileage` - law.traffic_law_vehicle_mileage
 * * `law.traffic_law_vehicle_type_and_brand` - law.traffic_law_vehicle_type_and_brand
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - law.traffic_law_victim_driver_drivers_license_issued_by
 * * `law.traffic_law_victim_driver_green_card_number` - law.traffic_law_victim_driver_green_card_number
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - law.traffic_law_victim_driver_insurance_expiry_date
 * * `law.traffic_law_victim_driver_insurance_number` - law.traffic_law_victim_driver_insurance_number
 * * `law.traffic_law_victim_driver_insurer` - law.traffic_law_victim_driver_insurer
 * * `law.traffic_law_victim_driver_license_valid_until` - law.traffic_law_victim_driver_license_valid_until
 * * `law.traffic_law_violated_section` - law.traffic_law_violated_section
 * * `law.traffic_law_violation_type` - law.traffic_law_violation_type
 * * `law.traffic_law_warning_fee_infraction` - law.traffic_law_warning_fee_infraction
 * * `law.traffic_law_warning_notice` - law.traffic_law_warning_notice
 */
export type AiAugmentedByMapperKeysEnum = 'entities.field.address_line_2' | 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.is_valid_email' | 'entities.field.is_valid_phone_number' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip' | 'law.civil_law_accessories_sold_separately' | 'law.civil_law_case_number' | 'law.civil_law_claim_amount' | 'law.civil_law_contract_date' | 'law.civil_law_contract_duration' | 'law.civil_law_contract_end_date' | 'law.civil_law_contract' | 'law.civil_law_contract_object' | 'law.civil_law_contract_start_date' | 'law.civil_law_contract_value' | 'law.civil_law_correspondence' | 'law.civil_law_court_costs' | 'law.civil_law_court_document' | 'law.civil_law_court_name' | 'law.civil_law_damage_amount' | 'law.civil_law_damage_cause' | 'law.civil_law_damage_claim' | 'law.civil_law_damage_date' | 'law.civil_law_damage_description' | 'law.civil_law_default_interest' | 'law.civil_law_defects' | 'law.civil_law_defects_present' | 'law.civil_law_delivery_date' | 'law.civil_law_document_date' | 'law.civil_law_file_reference' | 'law.civil_law_handover_date' | 'law.civil_law_hearing_date' | 'law.civil_law_insurance_claim_number' | 'law.civil_law_interest_rate' | 'law.civil_law_judgment_date' | 'law.civil_law_liability_percentage' | 'law.civil_law_notarial_certification_date' | 'law.civil_law_payment_due_date' | 'law.civil_law_purchase_agreement' | 'law.civil_law_purchase_contract_file_reference' | 'law.civil_law_purchase_date' | 'law.civil_law_purchase_object' | 'law.civil_law_purchase_price_components' | 'law.civil_law_purchase_price' | 'law.civil_law_purchase_price_paid_amount' | 'law.civil_law_purchase_price_paid_boolean' | 'law.civil_law_purchase_price_paid_date' | 'law.civil_law_purchase_price_paid' | 'law.civil_law_purchase_price_payment_date' | 'law.civil_law_subject_line' | 'law.civil_law_termination_notice_period' | 'law.civil_law_vehicle_make' | 'law.civil_law_vehicle_mileage' | 'law.civil_law_vehicle_model' | 'law.civil_law_vehicle_vin' | 'law.civil_law_vehicle_year' | 'law.civil_law_warranty_period' | 'law.criminal_law_amount_of_daily_rates' | 'law.criminal_law_applicable_laws' | 'law.criminal_law_charge_description' | 'law.criminal_law_complaint' | 'law.criminal_law_criminal_warrant' | 'law.criminal_law_damage_description' | 'law.criminal_law_damage_value' | 'law.criminal_law_date_of_offense' | 'law.criminal_law_duration_of_prison_sentence' | 'law.criminal_law_evidence_location' | 'law.criminal_law_evidence' | 'law.criminal_law_incident_description' | 'law.criminal_law_indictment_date' | 'law.criminal_law_indictment_delivery_date' | 'law.criminal_law_indictment' | 'law.criminal_law_legal_classification_of_offense' | 'law.criminal_law_means_of_evidence' | 'law.criminal_law_number_of_daily_rates' | 'law.criminal_law_offense_type' | 'law.criminal_law_penalty_infromation' | 'law.criminal_law_physical_evidence' | 'law.criminal_law_place_of_offense' | 'law.criminal_law_police_file_number' | 'law.criminal_law_preliminary_proceedings_date' | 'law.criminal_law_prison_sentence' | 'law.criminal_law_probation' | 'law.criminal_law_prosecution_file_number' | 'law.criminal_law_report_date' | 'law.criminal_law_report_time' | 'law.criminal_law_time_of_offense' | 'law.debt_collection_law_business_fee' | 'law.debt_collection_law_case_value' | 'law.debt_collection_law_invoice_amount' | 'law.debt_collection_law_invoice_date' | 'law.debt_collection_law_invoice_ground' | 'law.debt_collection_law_invoice_lawyer' | 'law.debt_collection_law_invoice' | 'law.debt_collection_law_invoice_number' | 'law.debt_collection_law_invoice_recipient' | 'law.debt_collection_law_invoice_tax_number' | 'law.debt_collection_law_lumps_sum_expenses' | 'law.debt_collection_law_sales_tax' | 'law.debt_collection_law_subtotal_lawyer_fees' | 'law.debt_collection_law_total_amount' | 'law.external_case_id' | 'law.family_law_average_net_income' | 'law.family_law_birth_certificate' | 'law.family_law_birth_register_number' | 'law.family_law_birth_register_office_location' | 'law.family_law_children' | 'law.family_law_date_of_marriage' | 'law.family_law_divorce_application' | 'law.family_law_divorce_settlement_agreement' | 'law.family_law_marriage_certificate' | 'law.family_law_marriage_contract_date' | 'law.family_law_marriage_contract' | 'law.family_law_marriage_register_number' | 'law.family_law_registry_office_location' | 'law.family_law_separation_date' | 'law.field' | 'law.general_law_amount_net' | 'law.general_law_amount_total' | 'law.general_law_appendices' | 'law.general_law_case_number' | 'law.general_law_court_costs' | 'law.general_law_court_name' | 'law.general_law_doc_date' | 'law.general_law_due_date' | 'law.general_law_file_ref' | 'law.general_law_hearing_date' | 'law.general_law_invoice_date' | 'law.general_law_invoice_number' | 'law.general_law_judgment_date' | 'law.general_law_correspondence' | 'law.general_law_court_document' | 'law.general_law_invoice' | 'law.general_law_payment_terms' | 'law.general_law_prior_ref' | 'law.general_law_subject' | 'law.general_law_vat' | 'law.generic_document' | 'law.inheritance_law_certificate_of_inheritance_applicable_law' | 'law.inheritance_law_certificate_of_inheritance_date_death' | 'law.inheritance_law_certificate_of_inheritance_date' | 'law.inheritance_law_certificate_of_inheritance' | 'law.inheritance_law_certificate_of_inheritance_number' | 'law.inheritance_law_certificate_of_inheritance_place_of_death' | 'law.inheritance_law_death_certificate_date_death' | 'law.inheritance_law_death_certificate_date' | 'law.inheritance_law_death_certificate' | 'law.inheritance_law_death_certificate_number' | 'law.inheritance_law_death_certificate_place_death' | 'law.inheritance_law_death_certificate_place' | 'law.inheritance_law_death_certificate_time_death' | 'law.inheritance_law_estate_inventory_amount' | 'law.inheritance_law_estate_inventory_date' | 'law.inheritance_law_estate_inventory_status' | 'law.inheritance_law_inheritance_contract_date' | 'law.inheritance_law_inheritance_contract' | 'law.inheritance_law_lasting_power_of_attorney_date' | 'law.inheritance_law_lasting_power_of_attorney' | 'law.inheritance_law_list_of_estate' | 'law.inheritance_law_living_will' | 'law.inheritance_law_patient_enrollment_date' | 'law.inheritance_law_testament_date' | 'law.inheritance_law_will' | 'law.labor_law_amount_dependent_children' | 'law.labor_law_beginning_of_employment' | 'law.labor_law_certificate_clause' | 'law.labor_law_child_allowances' | 'law.labor_law_collective_agreement' | 'law.labor_law_company_agreement' | 'law.labor_law_company_hearing' | 'law.labor_law_dependent_children' | 'law.labor_law_different_place_of_work' | 'law.labor_law_disability' | 'law.labor_law_employee_probation_period_end_date' | 'law.labor_law_end_of_employment' | 'law.labor_law_exemption_irrevocable' | 'law.labor_law_exemption_revocable' | 'law.labor_law_fixed_term_contract_duration' | 'law.labor_law_fixed_term_contract' | 'law.labor_law_grade_certificate_clause' | 'law.labor_law_is_employee_in_probation_period' | 'law.labor_law_job_title' | 'law.labor_law_local_transfer_clause' | 'law.labor_law_LTI' | 'law.labor_law_married' | 'law.labor_law_monthly_gross_salary' | 'law.labor_law_monthly_working_days' | 'law.labor_law_notice_period' | 'law.labor_law_notice_period_observed' | 'law.labor_law_payslip' | 'law.labor_law_percent_sprinter_clause' | 'law.labor_law_place_of_work' | 'law.labor_law_pregnancy' | 'law.labor_law_reaction_company_hering' | 'law.labor_law_reason_for_termination_given' | 'law.labor_law_return_of_company_property' | 'law.labor_law_settlement_agreement_date' | 'law.labor_law_settlement_agreement' | 'law.labor_law_severance_amount' | 'law.labor_law_signature_of_employer' | 'law.labor_law_special_documents' | 'law.labor_law_special_payments_amount' | 'law.labor_law_special_payments' | 'law.labor_law_special_personal_circumstances' | 'law.labor_law_special_protection_against_dismissal' | 'law.labor_law_special_sentence' | 'law.labor_law_sprinter_clause' | 'law.labor_law_termination_access_to_termination_to_employee' | 'law.labor_law_termination_agreement_date' | 'law.labor_law_termination_agreement' | 'law.labor_law_termination_agreement_severance_pay_amount' | 'law.labor_law_termination_agreement_termination_date' | 'law.labor_law_termination_authorization' | 'law.labor_law_termination_date_effective' | 'law.labor_law_termination_date' | 'law.labor_law_termination_employer_more_than_10_employees' | 'law.labor_law_termination_is_agreement_severance_pay' | 'law.labor_law_termination' | 'law.labor_law_termination_operational_reasons' | 'law.labor_law_termination_without_notice' | 'law.labor_law_total_gross_salary' | 'law.labor_law_vacation_days' | 'law.labor_law_visum' | 'law.labor_law_VSOP' | 'law.labor_law_warning_letter_access_to_warning_letter_to_employee' | 'law.labor_law_warning_letter_date' | 'law.labor_law_warning_letter_incident_date' | 'law.labor_law_warning_letter_incident_location' | 'law.labor_law_warning_letter_incident_time' | 'law.labor_law_warning_letter' | 'law.labor_law_warning_letter_reason' | 'law.labor_law_work_contract' | 'law.labor_law_work_council' | 'law.labor_law_work_hours_per_week' | 'law.labor_law_works_council_membership' | 'law.labor_law_yearly_gross_salary' | 'law.labor_law_years_of_employment' | 'law.medicine_law_health_insurance_letter_date' | 'law.medicine_law_health_insurance_letter_decision_justification' | 'law.medicine_law_health_insurance_letter_decision' | 'law.medicine_law_health_insurance_letter_legal_remedy_instruction' | 'law.medicine_law_health_insurance_letter' | 'law.medicine_law_health_insurance_letter_reference_to_application' | 'law.medicine_law_hospital_records_admission_date' | 'law.medicine_law_hospital_records_diagnoses_icd_codes' | 'law.medicine_law_hospital_records_discharge_date' | 'law.medicine_law_hospital_records_discharge_prognosis' | 'law.medicine_law_hospital_records_documented_complications' | 'law.medicine_law_hospital_records' | 'law.medicine_law_hospital_records_medication_during_stay' | 'law.medicine_law_hospital_records_operation_date' | 'law.medicine_law_hospital_records_operations' | 'law.medicine_law_hospital_records_station' | 'law.medicine_law_laboratory_results_examination_date' | 'law.medicine_law_laboratory_results_examination_type' | 'law.medicine_law_laboratory_results_further_investigation_recommendation' | 'law.medicine_law_laboratory_results' | 'law.medicine_law_laboratory_results_relevant_deviations' | 'law.medicine_law_medical_bill_cost_bearer' | 'law.medicine_law_medical_bill_invoice_date' | 'law.medicine_law_medical_bill_invoice_number' | 'law.medicine_law_medical_bill' | 'law.medicine_law_medical_bill_payment_deadline' | 'law.medicine_law_medical_bill_service_period' | 'law.medicine_law_medical_bill_services_list' | 'law.medicine_law_medical_bill_total_amount' | 'law.medicine_law_medical_expertise_date' | 'law.medicine_law_medical_expertise_justification' | 'law.medicine_law_medical_expertise' | 'law.medicine_law_medical_expertise_medical_assessment' | 'law.medicine_law_medical_expertise_question_posed' | 'law.medicine_law_medical_expertise_result' | 'law.medicine_law_medical_report_complications' | 'law.medicine_law_medical_report_date' | 'law.medicine_law_medical_report_diagnosis_icd_code' | 'law.medicine_law_medical_report_diagnosis_short_text' | 'law.medicine_law_medical_report_further_treatment' | 'law.medicine_law_medical_report' | 'law.medicine_law_medical_report_surgery_date' | 'law.medicine_law_medical_report_treatment_measures' | 'law.medicine_law_medical_report_treatment_period' | 'law.migration_law_approval_notice_case_number' | 'law.migration_law_approval_notice_conditions' | 'law.migration_law_approval_notice_decision_date' | 'law.migration_law_approval_notice_issuing_authority' | 'law.migration_law_approval_notice' | 'law.migration_law_approval_notice_permit_type' | 'law.migration_law_approval_notice_pickup_deadline' | 'law.migration_law_approval_notice_validity_period' | 'law.migration_law_asylum_seeker_certificate_application_number' | 'law.migration_law_asylum_seeker_certificate_first_registration_date' | 'law.migration_law_asylum_seeker_certificate_issue_date' | 'law.migration_law_asylum_seeker_certificate_issuing_authority' | 'law.migration_law_asylum_seeker_certificate' | 'law.migration_law_asylum_seeker_certificate_residence_obligation' | 'law.migration_law_asylum_seeker_certificate_valid_until' | 'law.migration_law_asylum_seeker_certificate_work_permission' | 'law.migration_law_cooperation_letter_attachments' | 'law.migration_law_cooperation_letter_date' | 'law.migration_law_cooperation_letter_deadlines' | 'law.migration_law_cooperation_letter_file_number' | 'law.migration_law_cooperation_letter' | 'law.migration_law_cooperation_letter_non_cooperation_consequences' | 'law.migration_law_cooperation_letter_specified_obligations' | 'law.migration_law_fictional_certificate_authority' | 'law.migration_law_fictional_certificate_fiction_type' | 'law.migration_law_fictional_certificate_issue_date' | 'law.migration_law_fictional_certificate_legal_basis' | 'law.migration_law_fictional_certificate' | 'law.migration_law_fictional_certificate_reason_for_issuance' | 'law.migration_law_fictional_certificate_valid_until' | 'law.migration_law_hearing_letter_date' | 'law.migration_law_hearing_letter_intended_measure_justification' | 'law.migration_law_hearing_letter_legal_advice' | 'law.migration_law_hearing_letter' | 'law.migration_law_hearing_letter_requested_documents' | 'law.migration_law_hearing_letter_response_deadline' | 'law.migration_law_other_letters_action_required' | 'law.migration_law_other_letters_date' | 'law.migration_law_other_letters_deadlines' | 'law.migration_law_other_letters_file_number' | 'law.migration_law_other_letters_issuing_authority' | 'law.migration_law_other_letters_legal_basis' | 'law.migration_law_other_letters' | 'law.migration_law_other_letters_matter_purpose' | 'law.migration_law_other_letters_subject' | 'law.migration_law_rejection_notice_case_number' | 'law.migration_law_rejection_notice_decision_date' | 'law.migration_law_rejection_notice_legal_grounds' | 'law.migration_law_rejection_notice_legal_remedy_deadline' | 'law.migration_law_rejection_notice' | 'law.migration_law_rejection_notice_officer_name' | 'law.migration_law_rejection_notice_reasoning' | 'law.migration_law_rejection_notice_signature_seal' | 'law.migration_law_rejection_notice_subject' | 'law.migration_law_residence_permit_conditions' | 'law.migration_law_residence_permit_issue_date' | 'law.migration_law_residence_permit_issuing_authority' | 'law.migration_law_residence_permit' | 'law.migration_law_residence_permit_national_id_number' | 'law.migration_law_residence_permit_passport_number' | 'law.migration_law_residence_permit_purpose' | 'law.migration_law_residence_permit_type' | 'law.migration_law_residence_permit_valid_until' | 'law.migration_law_toleration_issue_date' | 'law.migration_law_toleration_issuing_authority' | 'law.migration_law_toleration_legal_basis' | 'law.migration_law_toleration' | 'law.migration_law_toleration_reason' | 'law.migration_law_toleration_restrictions' | 'law.migration_law_toleration_valid_until' | 'law.real_estate_law_basic_debts_amount' | 'law.real_estate_law_broker_commission_amount' | 'law.real_estate_law_broker_contract_type' | 'law.real_estate_law_broker_scope_of_work' | 'law.real_estate_law_broker_termination_periods' | 'law.real_estate_law_brokerage_contract_date' | 'law.real_estate_law_brokerage_contract' | 'law.real_estate_law_brokerage_fee' | 'law.real_estate_law_building_dimensions' | 'law.real_estate_law_building_permit_date' | 'law.real_estate_law_building_permit' | 'law.real_estate_law_building_permit_number' | 'law.real_estate_law_building_permit_validity_duration' | 'law.real_estate_law_building_plan' | 'law.real_estate_law_building_restrictions_clause' | 'law.real_estate_law_building_usage' | 'law.real_estate_law_co_ownership_share' | 'law.real_estate_law_commission_percentage' | 'law.real_estate_law_contaminated_sites_clause' | 'law.real_estate_law_declaration_of_division' | 'law.real_estate_law_division_declaration_date' | 'law.real_estate_law_encumbrance_restrictions' | 'law.real_estate_law_encumbrances_section_ii' | 'law.real_estate_law_encumbrances_section_iii' | 'law.real_estate_law_exclusive_brokerage_contract' | 'law.real_estate_law_full_repayment_date' | 'law.real_estate_law_installment_amount' | 'law.real_estate_law_interest_rate' | 'law.real_estate_law_land_register_address' | 'law.real_estate_law_land_register_city' | 'law.real_estate_law_land_register_date' | 'law.real_estate_law_land_register' | 'law.real_estate_law_land_register_number' | 'law.real_estate_law_land_register_plot_of_land' | 'law.real_estate_law_legal_defects_clause' | 'law.real_estate_law_loan_agreement' | 'law.real_estate_law_loan_amount' | 'law.real_estate_law_loan_security' | 'law.real_estate_law_monument_protection_basis' | 'law.real_estate_law_monument_protection_notice' | 'law.real_estate_law_monument_protection_order_date' | 'law.real_estate_law_monument_protection_order_number' | 'law.real_estate_law_monument_protection_requirements' | 'law.real_estate_law_monument_registration_date' | 'law.real_estate_law_plan_author' | 'law.real_estate_law_plan_designation' | 'law.real_estate_law_plan_scale' | 'law.real_estate_law_plot_size' | 'law.real_estate_law_property_brokered_by_agent' | 'law.real_estate_law_purchase_contract_amount' | 'law.real_estate_law_purchase_contract_date' | 'law.real_estate_law_purchase_contract_description' | 'law.real_estate_law_purchase_contract' | 'law.real_estate_law_purchase_contract_registration_date' | 'law.real_estate_law_purchase_contract_registration_number' | 'law.real_estate_law_purchase_object_rented' | 'law.real_estate_law_purchase_price_loan_financed' | 'law.real_estate_law_repayment_rate' | 'law.real_estate_law_withdrawal_instruction_date' | 'law.residential_property_law_co_ownership_shares' | 'law.residential_property_law_contract_date' | 'law.residential_property_law_contract' | 'law.residential_property_law_inventory' | 'law.residential_property_law_land_register_address' | 'law.residential_property_law_land_register_city' | 'law.residential_property_law_land_register_number' | 'law.residential_property_law_land_register_plot_of_land' | 'law.social_law_affected_benefit' | 'law.social_law_application_arrival_date' | 'law.social_law_application_date' | 'law.social_law_application_file_reference' | 'law.social_law_application_form' | 'law.social_law_appointment_date' | 'law.social_law_appointment_file_reference' | 'law.social_law_appointment_invitation' | 'law.social_law_appointment_purpose' | 'law.social_law_appointment_required_documents' | 'law.social_law_appointment_time' | 'law.social_law_approval_file_reference' | 'law.social_law_approval_internal_reference' | 'law.social_law_approval_legal_basis' | 'law.social_law_approval_notice_date' | 'law.social_law_approval_notice' | 'law.social_law_approval_period_end' | 'law.social_law_approval_period_start' | 'law.social_law_approved_benefit_amount' | 'law.social_law_approved_benefit_period' | 'law.social_law_approved_benefit_type' | 'law.social_law_asset_type' | 'law.social_law_attachment_list' | 'law.social_law_benefit_type' | 'law.social_law_change_description' | 'law.social_law_change_file_reference' | 'law.social_law_change_notification_date' | 'law.social_law_change_notification' | 'law.social_law_change_reason' | 'law.social_law_creditable_income' | 'law.social_law_disability_card_issue_date' | 'law.social_law_disability_card' | 'law.social_law_disability_card_markers' | 'law.social_law_disability_card_validity_period' | 'law.social_law_disability_degree' | 'law.social_law_disability_file_reference' | 'law.social_law_employment_income' | 'law.social_law_follow_up_application_notes' | 'law.social_law_hearing_file_reference' | 'law.social_law_hearing_letter_date' | 'law.social_law_hearing_letter' | 'law.social_law_hearing_planned_administrative_act' | 'law.social_law_housing_costs_amount' | 'law.social_law_income_amount' | 'law.social_law_income_date' | 'law.social_law_income_legal_basis' | 'law.social_law_income_provider' | 'law.social_law_income_source' | 'law.social_law_income_type' | 'law.social_law_interim_legal_protection' | 'law.social_law_interim_protection_affidavit' | 'law.social_law_interim_protection_attachment_list' | 'law.social_law_interim_protection_file_reference' | 'law.social_law_interim_protection_request_date' | 'law.social_law_interim_protection_request_text' | 'law.social_law_interim_protection_urgency_reason' | 'law.social_law_lawsuit_alternative_request' | 'law.social_law_lawsuit_attachment_list' | 'law.social_law_lawsuit_cost_request' | 'law.social_law_lawsuit_court_file_number' | 'law.social_law_lawsuit_delivery_date' | 'law.social_law_lawsuit_dispute_value' | 'law.social_law_lawsuit_disputed_amount' | 'law.social_law_lawsuit_evidence_requests' | 'law.social_law_lawsuit_file_reference' | 'law.social_law_lawsuit_filing_date' | 'law.social_law_lawsuit_income_amount' | 'law.social_law_lawsuit_legal_basis' | 'law.social_law_lawsuit_main_request' | 'law.social_law_lawsuit' | 'law.social_law_lawsuit_monthly_benefit_amount' | 'law.social_law_lawsuit_objection_decision_date' | 'law.social_law_lawsuit_objection_filing_date' | 'law.social_law_lawsuit_original_decision_date' | 'law.social_law_lawsuit_subject' | 'law.social_law_lawsuit_type' | 'law.social_law_legal_basis' | 'law.social_law_medical_certificate' | 'law.social_law_medical_diagnosis' | 'law.social_law_medical_examination_date' | 'law.social_law_medical_file_reference' | 'law.social_law_medical_icd_code' | 'law.social_law_medical_limitations' | 'law.social_law_medical_prognosis' | 'law.social_law_medical_work_capacity_relation' | 'law.social_law_monthly_payment_amount' | 'law.social_law_needs_cost_breakdown' | 'law.social_law_needs_file_reference' | 'law.social_law_needs_proof_basis' | 'law.social_law_needs_proof_date' | 'law.social_law_needs_proof' | 'law.social_law_needs_type' | 'law.social_law_notice_date' | 'law.social_law_notice_of_objection_date' | 'law.social_law_notice_of_objection_file_reference' | 'law.social_law_notice_of_objection' | 'law.social_law_notification_date' | 'law.social_law_notification_legal_basis' | 'law.social_law_notification_source' | 'law.social_law_objection_challenged_notice' | 'law.social_law_objection_date' | 'law.social_law_objection_evidence' | 'law.social_law_objection_file_reference' | 'law.social_law_objection' | 'law.social_law_objection_reasoning' | 'law.social_law_objection_suspension_request' | 'law.social_law_original_decision_date' | 'law.social_law_other_income' | 'law.social_law_own_income_amount' | 'law.social_law_reclaim_amount' | 'law.social_law_reclaim_file_reference' | 'law.social_law_reclaim_legal_basis' | 'law.social_law_reclaim_legal_norm' | 'law.social_law_reclaim_notice_date' | 'law.social_law_reclaim_notice' | 'law.social_law_reclaim_payment_deadline' | 'law.social_law_reclaim_payment_terms' | 'law.social_law_regelbedarf_amount' | 'law.social_law_rejection_file_reference' | 'law.social_law_rejection_legal_norm' | 'law.social_law_rejection_notice_date' | 'law.social_law_rejection_notice' | 'law.social_law_rejection_reason' | 'law.social_law_residence_status' | 'law.social_law_revocation_benefit_type' | 'law.social_law_revocation_file_reference' | 'law.social_law_revocation_legal_norm' | 'law.social_law_revocation_notice_date' | 'law.social_law_revocation_notice' | 'law.social_law_revocation_period_end' | 'law.social_law_revocation_period_start' | 'law.social_law_revocation_reason' | 'law.social_law_revocation_reclaim_notes' | 'law.social_law_social_benefit_type' | 'law.social_law_summary_grounds_opposition' | 'law.social_law_total_need_amount' | 'law.social_law_total_reclaim_amount' | 'law.social_law_violation_type' | 'law.tenancy_law_adress_rental_property' | 'law.tenancy_law_advance_payment_service_charge' | 'law.tenancy_law_advance_payment_service_charges' | 'law.tenancy_law_bank_guarantee' | 'law.tenancy_law_cash_deposit_agreed' | 'law.tenancy_law_cash_deposit_payment_date' | 'law.tenancy_law_competent_court' | 'law.tenancy_law_cost_share' | 'law.tenancy_law_cost_shares' | 'law.tenancy_law_counter_number' | 'law.tenancy_law_court_case_number' | 'law.tenancy_law_court_proceedings_pending' | 'law.tenancy_law_description_of_rental_property' | 'law.tenancy_law_duration_of_lease' | 'law.tenancy_law_expert_report_commission_date' | 'law.tenancy_law_expert_report_damage_description' | 'law.tenancy_law_expert_report_damage_number' | 'law.tenancy_law_expert_report_date' | 'law.tenancy_law_expert_report_inspection_date' | 'law.tenancy_law_expert_report' | 'law.tenancy_law_expert_report_object_address' | 'law.tenancy_law_expert_report_purpose' | 'law.tenancy_law_expert_report_repair_duration' | 'law.tenancy_law_expert_report_subject' | 'law.tenancy_law_extension_option_count' | 'law.tenancy_law_extension_option_duration' | 'law.tenancy_law_fixed_term_tenancy' | 'law.tenancy_law_garage_available' | 'law.tenancy_law_garage_costs' | 'law.tenancy_law_general_status_documents' | 'law.tenancy_law_gross_rent' | 'law.tenancy_law_handover_counter' | 'law.tenancy_law_handover_date' | 'law.tenancy_law_handover_defects' | 'law.tenancy_law_handover_protocol' | 'law.tenancy_law_landlord_termination_given' | 'law.tenancy_law_last_rent_increase_letter_date' | 'law.tenancy_law_last_signature_date' | 'law.tenancy_law_lease_agreement' | 'law.tenancy_law_location_in_rental_property' | 'law.tenancy_law_net_rent' | 'law.tenancy_law_operating_costs_agreement' | 'law.tenancy_law_parking_space_available' | 'law.tenancy_law_parking_space_costs' | 'law.tenancy_law_property_return_date' | 'law.tenancy_law_rent_increase_effective_date' | 'law.tenancy_law_rent_increase_notice' | 'law.tenancy_law_rental_agreement_date' | 'law.tenancy_law_rental_agreement_duration' | 'law.tenancy_law_rental_agreement' | 'law.tenancy_law_rental_agreement_validity_end' | 'law.tenancy_law_rental_agreement_validity_start' | 'law.tenancy_law_rental_object_size_sqm' | 'law.tenancy_law_repayment' | 'law.tenancy_law_repayment_period_end' | 'law.tenancy_law_repayment_period_start' | 'law.tenancy_law_security_deposit_additional_regulations' | 'law.tenancy_law_security_deposit_amount' | 'law.tenancy_law_service_charge_settlement' | 'law.tenancy_law_staggered_rental_agreement' | 'law.tenancy_law_start_of_lease' | 'law.tenancy_law_tenancy_terminated' | 'law.tenancy_law_tenancy_termination_date' | 'law.tenancy_law_tenant_extension_option' | 'law.tenancy_law_tenant_warned' | 'law.tenancy_law_termination_declared_date' | 'law.tenancy_law_termination_letter_date' | 'law.tenancy_law_termination_notice' | 'law.tenancy_law_termination_notice_period' | 'law.tenancy_law_total_cost_service_charge' | 'law.tenancy_law_total_rent' | 'law.tenancy_law_unlimited_term_tenancy' | 'law.tenancy_law_value_security_clause' | 'law.tenancy_law_warning_letter_date' | 'law.tenancy_law_warning_letter' | 'law.topic' | 'law.traffic_law_accident_date' | 'law.traffic_law_accident_report' | 'law.traffic_law_amount_of_fine' | 'law.traffic_law_appeal_instruction' | 'law.traffic_law_at_fault_driver_drivers_license_issued_by' | 'law.traffic_law_at_fault_driver_drivers_license_valid_until' | 'law.traffic_law_at_fault_driver_green_card_number' | 'law.traffic_law_at_fault_driver_insurance_expiry_date' | 'law.traffic_law_at_fault_driver_insurance_number' | 'law.traffic_law_at_fault_driver_insurer' | 'law.traffic_law_blood_alcohol_concentration' | 'law.traffic_law_calculated_total_damage_costs' | 'law.traffic_law_calculated_total_days' | 'law.traffic_law_charges' | 'law.traffic_law_cost_per_scale' | 'law.traffic_law_daily_rate' | 'law.traffic_law_damage_amount_net' | 'law.traffic_law_damage_number' | 'law.traffic_law_damage_scope' | 'law.traffic_law_date_of_accident' | 'law.traffic_law_date_of_crime' | 'law.traffic_law_date_of_fine' | 'law.traffic_law_date_of_infraction' | 'law.traffic_law_date_of_inspection' | 'law.traffic_law_date_of_issue' | 'law.traffic_law_date_of_offense' | 'law.traffic_law_date_of_report' | 'law.traffic_law_differencial_tax' | 'law.traffic_law_driver_logbook_required' | 'law.traffic_law_driving_ban_duration' | 'law.traffic_law_driving_ban' | 'law.traffic_law_evidence_infraction' | 'law.traffic_law_expert_cost' | 'law.traffic_law_expert_date' | 'law.traffic_law_expert_report' | 'law.traffic_law_expert_report_number' | 'law.traffic_law_file_number' | 'law.traffic_law_fine' | 'law.traffic_law_fine_notice' | 'law.traffic_law_gross_gross_replacement_value' | 'law.traffic_law_gross_replacement_value' | 'law.traffic_law_injured' | 'law.traffic_law_insurance_holder' | 'law.traffic_law_insurance' | 'law.traffic_law_insurance_policy_number' | 'law.traffic_law_legal_basis_infraction' | 'law.traffic_law_legal_basis' | 'law.traffic_law_licenseplate_at_fault_driver' | 'law.traffic_law_licenseplate' | 'law.traffic_law_licenseplate_victim_driver' | 'law.traffic_law_loss_amount_repair_case' | 'law.traffic_law_loss_amount_total_damage_case' | 'law.traffic_law_loss_of_use_per_day' | 'law.traffic_law_mark_and_type_of_at_fault_driver' | 'law.traffic_law_mark_and_type_of_victim_driver' | 'law.traffic_law_merantile_value_loss' | 'law.traffic_law_net_gross_replacement_value' | 'law.traffic_law_net_replacement_value' | 'law.traffic_law_number_of_daily_rates' | 'law.traffic_law_offense_infraction_description' | 'law.traffic_law_other_damages' | 'law.traffic_law_payment_deadline' | 'law.traffic_law_penalty_order' | 'law.traffic_law_place_of_accident' | 'law.traffic_law_place_of_crime' | 'law.traffic_law_place_of_infraction' | 'law.traffic_law_place_of_inspection' | 'law.traffic_law_place_of_issue' | 'law.traffic_law_place_of_offense' | 'law.traffic_law_points_for_offense' | 'law.traffic_law_police_case_number' | 'law.traffic_law_procedure_costs' | 'law.traffic_law_prosecution_number' | 'law.traffic_law_regular_tax' | 'law.traffic_law_repair_costs_with_vat' | 'law.traffic_law_repair_costs_without_vat' | 'law.traffic_law_repair_damage' | 'law.traffic_law_repair_duration' | 'law.traffic_law_replacement_cost' | 'law.traffic_law_replacement_value' | 'law.traffic_law_reregistration_cost' | 'law.traffic_law_residual_value' | 'law.traffic_law_speed_allowed' | 'law.traffic_law_speed_driven' | 'law.traffic_law_speed_too_high' | 'law.traffic_law_time_of_accident' | 'law.traffic_law_time_of_crime' | 'law.traffic_law_time_of_infraction' | 'law.traffic_law_time_of_inspection' | 'law.traffic_law_time_of_issue' | 'law.traffic_law_time_of_offense' | 'law.traffic_law_total_damage' | 'law.traffic_law_value_improvement' | 'law.traffic_law_vehicle_age_months' | 'law.traffic_law_vehicle_mileage' | 'law.traffic_law_vehicle_type_and_brand' | 'law.traffic_law_victim_driver_drivers_license_issued_by' | 'law.traffic_law_victim_driver_green_card_number' | 'law.traffic_law_victim_driver_insurance_expiry_date' | 'law.traffic_law_victim_driver_insurance_number' | 'law.traffic_law_victim_driver_insurer' | 'law.traffic_law_victim_driver_license_valid_until' | 'law.traffic_law_violated_section' | 'law.traffic_law_violation_type' | 'law.traffic_law_warning_fee_infraction' | 'law.traffic_law_warning_notice';

/**
 * * `entities.field.address_line_2` - entities.field.address_line_2
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.is_valid_email` - entities.field.is_valid_email
 * * `entities.field.is_valid_phone_number` - entities.field.is_valid_phone_number
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 * * `law.civil_law_accessories_sold_separately` - law.civil_law_accessories_sold_separately
 * * `law.civil_law_case_number` - law.civil_law_case_number
 * * `law.civil_law_claim_amount` - law.civil_law_claim_amount
 * * `law.civil_law_contract_date` - law.civil_law_contract_date
 * * `law.civil_law_contract_duration` - law.civil_law_contract_duration
 * * `law.civil_law_contract_end_date` - law.civil_law_contract_end_date
 * * `law.civil_law_contract` - law.civil_law_contract
 * * `law.civil_law_contract_object` - law.civil_law_contract_object
 * * `law.civil_law_contract_start_date` - law.civil_law_contract_start_date
 * * `law.civil_law_contract_value` - law.civil_law_contract_value
 * * `law.civil_law_correspondence` - law.civil_law_correspondence
 * * `law.civil_law_court_costs` - law.civil_law_court_costs
 * * `law.civil_law_court_document` - law.civil_law_court_document
 * * `law.civil_law_court_name` - law.civil_law_court_name
 * * `law.civil_law_damage_amount` - law.civil_law_damage_amount
 * * `law.civil_law_damage_cause` - law.civil_law_damage_cause
 * * `law.civil_law_damage_claim` - law.civil_law_damage_claim
 * * `law.civil_law_damage_date` - law.civil_law_damage_date
 * * `law.civil_law_damage_description` - law.civil_law_damage_description
 * * `law.civil_law_default_interest` - law.civil_law_default_interest
 * * `law.civil_law_defects` - law.civil_law_defects
 * * `law.civil_law_defects_present` - law.civil_law_defects_present
 * * `law.civil_law_delivery_date` - law.civil_law_delivery_date
 * * `law.civil_law_document_date` - law.civil_law_document_date
 * * `law.civil_law_file_reference` - law.civil_law_file_reference
 * * `law.civil_law_handover_date` - law.civil_law_handover_date
 * * `law.civil_law_hearing_date` - law.civil_law_hearing_date
 * * `law.civil_law_insurance_claim_number` - law.civil_law_insurance_claim_number
 * * `law.civil_law_interest_rate` - law.civil_law_interest_rate
 * * `law.civil_law_judgment_date` - law.civil_law_judgment_date
 * * `law.civil_law_liability_percentage` - law.civil_law_liability_percentage
 * * `law.civil_law_notarial_certification_date` - law.civil_law_notarial_certification_date
 * * `law.civil_law_payment_due_date` - law.civil_law_payment_due_date
 * * `law.civil_law_purchase_agreement` - law.civil_law_purchase_agreement
 * * `law.civil_law_purchase_contract_file_reference` - law.civil_law_purchase_contract_file_reference
 * * `law.civil_law_purchase_date` - law.civil_law_purchase_date
 * * `law.civil_law_purchase_object` - law.civil_law_purchase_object
 * * `law.civil_law_purchase_price_components` - law.civil_law_purchase_price_components
 * * `law.civil_law_purchase_price` - law.civil_law_purchase_price
 * * `law.civil_law_purchase_price_paid_amount` - law.civil_law_purchase_price_paid_amount
 * * `law.civil_law_purchase_price_paid_boolean` - law.civil_law_purchase_price_paid_boolean
 * * `law.civil_law_purchase_price_paid_date` - law.civil_law_purchase_price_paid_date
 * * `law.civil_law_purchase_price_paid` - law.civil_law_purchase_price_paid
 * * `law.civil_law_purchase_price_payment_date` - law.civil_law_purchase_price_payment_date
 * * `law.civil_law_subject_line` - law.civil_law_subject_line
 * * `law.civil_law_termination_notice_period` - law.civil_law_termination_notice_period
 * * `law.civil_law_vehicle_make` - law.civil_law_vehicle_make
 * * `law.civil_law_vehicle_mileage` - law.civil_law_vehicle_mileage
 * * `law.civil_law_vehicle_model` - law.civil_law_vehicle_model
 * * `law.civil_law_vehicle_vin` - law.civil_law_vehicle_vin
 * * `law.civil_law_vehicle_year` - law.civil_law_vehicle_year
 * * `law.civil_law_warranty_period` - law.civil_law_warranty_period
 * * `law.criminal_law_amount_of_daily_rates` - law.criminal_law_amount_of_daily_rates
 * * `law.criminal_law_applicable_laws` - law.criminal_law_applicable_laws
 * * `law.criminal_law_charge_description` - law.criminal_law_charge_description
 * * `law.criminal_law_complaint` - law.criminal_law_complaint
 * * `law.criminal_law_criminal_warrant` - law.criminal_law_criminal_warrant
 * * `law.criminal_law_damage_description` - law.criminal_law_damage_description
 * * `law.criminal_law_damage_value` - law.criminal_law_damage_value
 * * `law.criminal_law_date_of_offense` - law.criminal_law_date_of_offense
 * * `law.criminal_law_duration_of_prison_sentence` - law.criminal_law_duration_of_prison_sentence
 * * `law.criminal_law_evidence_location` - law.criminal_law_evidence_location
 * * `law.criminal_law_evidence` - law.criminal_law_evidence
 * * `law.criminal_law_incident_description` - law.criminal_law_incident_description
 * * `law.criminal_law_indictment_date` - law.criminal_law_indictment_date
 * * `law.criminal_law_indictment_delivery_date` - law.criminal_law_indictment_delivery_date
 * * `law.criminal_law_indictment` - law.criminal_law_indictment
 * * `law.criminal_law_legal_classification_of_offense` - law.criminal_law_legal_classification_of_offense
 * * `law.criminal_law_means_of_evidence` - law.criminal_law_means_of_evidence
 * * `law.criminal_law_number_of_daily_rates` - law.criminal_law_number_of_daily_rates
 * * `law.criminal_law_offense_type` - law.criminal_law_offense_type
 * * `law.criminal_law_penalty_infromation` - law.criminal_law_penalty_infromation
 * * `law.criminal_law_physical_evidence` - law.criminal_law_physical_evidence
 * * `law.criminal_law_place_of_offense` - law.criminal_law_place_of_offense
 * * `law.criminal_law_police_file_number` - law.criminal_law_police_file_number
 * * `law.criminal_law_preliminary_proceedings_date` - law.criminal_law_preliminary_proceedings_date
 * * `law.criminal_law_prison_sentence` - law.criminal_law_prison_sentence
 * * `law.criminal_law_probation` - law.criminal_law_probation
 * * `law.criminal_law_prosecution_file_number` - law.criminal_law_prosecution_file_number
 * * `law.criminal_law_report_date` - law.criminal_law_report_date
 * * `law.criminal_law_report_time` - law.criminal_law_report_time
 * * `law.criminal_law_time_of_offense` - law.criminal_law_time_of_offense
 * * `law.debt_collection_law_business_fee` - law.debt_collection_law_business_fee
 * * `law.debt_collection_law_case_value` - law.debt_collection_law_case_value
 * * `law.debt_collection_law_invoice_amount` - law.debt_collection_law_invoice_amount
 * * `law.debt_collection_law_invoice_date` - law.debt_collection_law_invoice_date
 * * `law.debt_collection_law_invoice_ground` - law.debt_collection_law_invoice_ground
 * * `law.debt_collection_law_invoice_lawyer` - law.debt_collection_law_invoice_lawyer
 * * `law.debt_collection_law_invoice` - law.debt_collection_law_invoice
 * * `law.debt_collection_law_invoice_number` - law.debt_collection_law_invoice_number
 * * `law.debt_collection_law_invoice_recipient` - law.debt_collection_law_invoice_recipient
 * * `law.debt_collection_law_invoice_tax_number` - law.debt_collection_law_invoice_tax_number
 * * `law.debt_collection_law_lumps_sum_expenses` - law.debt_collection_law_lumps_sum_expenses
 * * `law.debt_collection_law_sales_tax` - law.debt_collection_law_sales_tax
 * * `law.debt_collection_law_subtotal_lawyer_fees` - law.debt_collection_law_subtotal_lawyer_fees
 * * `law.debt_collection_law_total_amount` - law.debt_collection_law_total_amount
 * * `law.external_case_id` - law.external_case_id
 * * `law.family_law_average_net_income` - law.family_law_average_net_income
 * * `law.family_law_birth_certificate` - law.family_law_birth_certificate
 * * `law.family_law_birth_register_number` - law.family_law_birth_register_number
 * * `law.family_law_birth_register_office_location` - law.family_law_birth_register_office_location
 * * `law.family_law_children` - law.family_law_children
 * * `law.family_law_date_of_marriage` - law.family_law_date_of_marriage
 * * `law.family_law_divorce_application` - law.family_law_divorce_application
 * * `law.family_law_divorce_settlement_agreement` - law.family_law_divorce_settlement_agreement
 * * `law.family_law_marriage_certificate` - law.family_law_marriage_certificate
 * * `law.family_law_marriage_contract_date` - law.family_law_marriage_contract_date
 * * `law.family_law_marriage_contract` - law.family_law_marriage_contract
 * * `law.family_law_marriage_register_number` - law.family_law_marriage_register_number
 * * `law.family_law_registry_office_location` - law.family_law_registry_office_location
 * * `law.family_law_separation_date` - law.family_law_separation_date
 * * `law.field` - law.field
 * * `law.general_law_amount_net` - law.general_law_amount_net
 * * `law.general_law_amount_total` - law.general_law_amount_total
 * * `law.general_law_appendices` - law.general_law_appendices
 * * `law.general_law_case_number` - law.general_law_case_number
 * * `law.general_law_court_costs` - law.general_law_court_costs
 * * `law.general_law_court_name` - law.general_law_court_name
 * * `law.general_law_doc_date` - law.general_law_doc_date
 * * `law.general_law_due_date` - law.general_law_due_date
 * * `law.general_law_file_ref` - law.general_law_file_ref
 * * `law.general_law_hearing_date` - law.general_law_hearing_date
 * * `law.general_law_invoice_date` - law.general_law_invoice_date
 * * `law.general_law_invoice_number` - law.general_law_invoice_number
 * * `law.general_law_judgment_date` - law.general_law_judgment_date
 * * `law.general_law_correspondence` - law.general_law_correspondence
 * * `law.general_law_court_document` - law.general_law_court_document
 * * `law.general_law_invoice` - law.general_law_invoice
 * * `law.general_law_payment_terms` - law.general_law_payment_terms
 * * `law.general_law_prior_ref` - law.general_law_prior_ref
 * * `law.general_law_subject` - law.general_law_subject
 * * `law.general_law_vat` - law.general_law_vat
 * * `law.generic_document` - law.generic_document
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - law.inheritance_law_certificate_of_inheritance_applicable_law
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - law.inheritance_law_certificate_of_inheritance_date_death
 * * `law.inheritance_law_certificate_of_inheritance_date` - law.inheritance_law_certificate_of_inheritance_date
 * * `law.inheritance_law_certificate_of_inheritance` - law.inheritance_law_certificate_of_inheritance
 * * `law.inheritance_law_certificate_of_inheritance_number` - law.inheritance_law_certificate_of_inheritance_number
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - law.inheritance_law_certificate_of_inheritance_place_of_death
 * * `law.inheritance_law_death_certificate_date_death` - law.inheritance_law_death_certificate_date_death
 * * `law.inheritance_law_death_certificate_date` - law.inheritance_law_death_certificate_date
 * * `law.inheritance_law_death_certificate` - law.inheritance_law_death_certificate
 * * `law.inheritance_law_death_certificate_number` - law.inheritance_law_death_certificate_number
 * * `law.inheritance_law_death_certificate_place_death` - law.inheritance_law_death_certificate_place_death
 * * `law.inheritance_law_death_certificate_place` - law.inheritance_law_death_certificate_place
 * * `law.inheritance_law_death_certificate_time_death` - law.inheritance_law_death_certificate_time_death
 * * `law.inheritance_law_estate_inventory_amount` - law.inheritance_law_estate_inventory_amount
 * * `law.inheritance_law_estate_inventory_date` - law.inheritance_law_estate_inventory_date
 * * `law.inheritance_law_estate_inventory_status` - law.inheritance_law_estate_inventory_status
 * * `law.inheritance_law_inheritance_contract_date` - law.inheritance_law_inheritance_contract_date
 * * `law.inheritance_law_inheritance_contract` - law.inheritance_law_inheritance_contract
 * * `law.inheritance_law_lasting_power_of_attorney_date` - law.inheritance_law_lasting_power_of_attorney_date
 * * `law.inheritance_law_lasting_power_of_attorney` - law.inheritance_law_lasting_power_of_attorney
 * * `law.inheritance_law_list_of_estate` - law.inheritance_law_list_of_estate
 * * `law.inheritance_law_living_will` - law.inheritance_law_living_will
 * * `law.inheritance_law_patient_enrollment_date` - law.inheritance_law_patient_enrollment_date
 * * `law.inheritance_law_testament_date` - law.inheritance_law_testament_date
 * * `law.inheritance_law_will` - law.inheritance_law_will
 * * `law.labor_law_amount_dependent_children` - law.labor_law_amount_dependent_children
 * * `law.labor_law_beginning_of_employment` - law.labor_law_beginning_of_employment
 * * `law.labor_law_certificate_clause` - law.labor_law_certificate_clause
 * * `law.labor_law_child_allowances` - law.labor_law_child_allowances
 * * `law.labor_law_collective_agreement` - law.labor_law_collective_agreement
 * * `law.labor_law_company_agreement` - law.labor_law_company_agreement
 * * `law.labor_law_company_hearing` - law.labor_law_company_hearing
 * * `law.labor_law_dependent_children` - law.labor_law_dependent_children
 * * `law.labor_law_different_place_of_work` - law.labor_law_different_place_of_work
 * * `law.labor_law_disability` - law.labor_law_disability
 * * `law.labor_law_employee_probation_period_end_date` - law.labor_law_employee_probation_period_end_date
 * * `law.labor_law_end_of_employment` - law.labor_law_end_of_employment
 * * `law.labor_law_exemption_irrevocable` - law.labor_law_exemption_irrevocable
 * * `law.labor_law_exemption_revocable` - law.labor_law_exemption_revocable
 * * `law.labor_law_fixed_term_contract_duration` - law.labor_law_fixed_term_contract_duration
 * * `law.labor_law_fixed_term_contract` - law.labor_law_fixed_term_contract
 * * `law.labor_law_grade_certificate_clause` - law.labor_law_grade_certificate_clause
 * * `law.labor_law_is_employee_in_probation_period` - law.labor_law_is_employee_in_probation_period
 * * `law.labor_law_job_title` - law.labor_law_job_title
 * * `law.labor_law_local_transfer_clause` - law.labor_law_local_transfer_clause
 * * `law.labor_law_LTI` - law.labor_law_LTI
 * * `law.labor_law_married` - law.labor_law_married
 * * `law.labor_law_monthly_gross_salary` - law.labor_law_monthly_gross_salary
 * * `law.labor_law_monthly_working_days` - law.labor_law_monthly_working_days
 * * `law.labor_law_notice_period` - law.labor_law_notice_period
 * * `law.labor_law_notice_period_observed` - law.labor_law_notice_period_observed
 * * `law.labor_law_payslip` - law.labor_law_payslip
 * * `law.labor_law_percent_sprinter_clause` - law.labor_law_percent_sprinter_clause
 * * `law.labor_law_place_of_work` - law.labor_law_place_of_work
 * * `law.labor_law_pregnancy` - law.labor_law_pregnancy
 * * `law.labor_law_reaction_company_hering` - law.labor_law_reaction_company_hering
 * * `law.labor_law_reason_for_termination_given` - law.labor_law_reason_for_termination_given
 * * `law.labor_law_return_of_company_property` - law.labor_law_return_of_company_property
 * * `law.labor_law_settlement_agreement_date` - law.labor_law_settlement_agreement_date
 * * `law.labor_law_settlement_agreement` - law.labor_law_settlement_agreement
 * * `law.labor_law_severance_amount` - law.labor_law_severance_amount
 * * `law.labor_law_signature_of_employer` - law.labor_law_signature_of_employer
 * * `law.labor_law_special_documents` - law.labor_law_special_documents
 * * `law.labor_law_special_payments_amount` - law.labor_law_special_payments_amount
 * * `law.labor_law_special_payments` - law.labor_law_special_payments
 * * `law.labor_law_special_personal_circumstances` - law.labor_law_special_personal_circumstances
 * * `law.labor_law_special_protection_against_dismissal` - law.labor_law_special_protection_against_dismissal
 * * `law.labor_law_special_sentence` - law.labor_law_special_sentence
 * * `law.labor_law_sprinter_clause` - law.labor_law_sprinter_clause
 * * `law.labor_law_termination_access_to_termination_to_employee` - law.labor_law_termination_access_to_termination_to_employee
 * * `law.labor_law_termination_agreement_date` - law.labor_law_termination_agreement_date
 * * `law.labor_law_termination_agreement` - law.labor_law_termination_agreement
 * * `law.labor_law_termination_agreement_severance_pay_amount` - law.labor_law_termination_agreement_severance_pay_amount
 * * `law.labor_law_termination_agreement_termination_date` - law.labor_law_termination_agreement_termination_date
 * * `law.labor_law_termination_authorization` - law.labor_law_termination_authorization
 * * `law.labor_law_termination_date_effective` - law.labor_law_termination_date_effective
 * * `law.labor_law_termination_date` - law.labor_law_termination_date
 * * `law.labor_law_termination_employer_more_than_10_employees` - law.labor_law_termination_employer_more_than_10_employees
 * * `law.labor_law_termination_is_agreement_severance_pay` - law.labor_law_termination_is_agreement_severance_pay
 * * `law.labor_law_termination` - law.labor_law_termination
 * * `law.labor_law_termination_operational_reasons` - law.labor_law_termination_operational_reasons
 * * `law.labor_law_termination_without_notice` - law.labor_law_termination_without_notice
 * * `law.labor_law_total_gross_salary` - law.labor_law_total_gross_salary
 * * `law.labor_law_vacation_days` - law.labor_law_vacation_days
 * * `law.labor_law_visum` - law.labor_law_visum
 * * `law.labor_law_VSOP` - law.labor_law_VSOP
 * * `law.labor_law_warning_letter_access_to_warning_letter_to_employee` - law.labor_law_warning_letter_access_to_warning_letter_to_employee
 * * `law.labor_law_warning_letter_date` - law.labor_law_warning_letter_date
 * * `law.labor_law_warning_letter_incident_date` - law.labor_law_warning_letter_incident_date
 * * `law.labor_law_warning_letter_incident_location` - law.labor_law_warning_letter_incident_location
 * * `law.labor_law_warning_letter_incident_time` - law.labor_law_warning_letter_incident_time
 * * `law.labor_law_warning_letter` - law.labor_law_warning_letter
 * * `law.labor_law_warning_letter_reason` - law.labor_law_warning_letter_reason
 * * `law.labor_law_work_contract` - law.labor_law_work_contract
 * * `law.labor_law_work_council` - law.labor_law_work_council
 * * `law.labor_law_work_hours_per_week` - law.labor_law_work_hours_per_week
 * * `law.labor_law_works_council_membership` - law.labor_law_works_council_membership
 * * `law.labor_law_yearly_gross_salary` - law.labor_law_yearly_gross_salary
 * * `law.labor_law_years_of_employment` - law.labor_law_years_of_employment
 * * `law.medicine_law_health_insurance_letter_date` - law.medicine_law_health_insurance_letter_date
 * * `law.medicine_law_health_insurance_letter_decision_justification` - law.medicine_law_health_insurance_letter_decision_justification
 * * `law.medicine_law_health_insurance_letter_decision` - law.medicine_law_health_insurance_letter_decision
 * * `law.medicine_law_health_insurance_letter_legal_remedy_instruction` - law.medicine_law_health_insurance_letter_legal_remedy_instruction
 * * `law.medicine_law_health_insurance_letter` - law.medicine_law_health_insurance_letter
 * * `law.medicine_law_health_insurance_letter_reference_to_application` - law.medicine_law_health_insurance_letter_reference_to_application
 * * `law.medicine_law_hospital_records_admission_date` - law.medicine_law_hospital_records_admission_date
 * * `law.medicine_law_hospital_records_diagnoses_icd_codes` - law.medicine_law_hospital_records_diagnoses_icd_codes
 * * `law.medicine_law_hospital_records_discharge_date` - law.medicine_law_hospital_records_discharge_date
 * * `law.medicine_law_hospital_records_discharge_prognosis` - law.medicine_law_hospital_records_discharge_prognosis
 * * `law.medicine_law_hospital_records_documented_complications` - law.medicine_law_hospital_records_documented_complications
 * * `law.medicine_law_hospital_records` - law.medicine_law_hospital_records
 * * `law.medicine_law_hospital_records_medication_during_stay` - law.medicine_law_hospital_records_medication_during_stay
 * * `law.medicine_law_hospital_records_operation_date` - law.medicine_law_hospital_records_operation_date
 * * `law.medicine_law_hospital_records_operations` - law.medicine_law_hospital_records_operations
 * * `law.medicine_law_hospital_records_station` - law.medicine_law_hospital_records_station
 * * `law.medicine_law_laboratory_results_examination_date` - law.medicine_law_laboratory_results_examination_date
 * * `law.medicine_law_laboratory_results_examination_type` - law.medicine_law_laboratory_results_examination_type
 * * `law.medicine_law_laboratory_results_further_investigation_recommendation` - law.medicine_law_laboratory_results_further_investigation_recommendation
 * * `law.medicine_law_laboratory_results` - law.medicine_law_laboratory_results
 * * `law.medicine_law_laboratory_results_relevant_deviations` - law.medicine_law_laboratory_results_relevant_deviations
 * * `law.medicine_law_medical_bill_cost_bearer` - law.medicine_law_medical_bill_cost_bearer
 * * `law.medicine_law_medical_bill_invoice_date` - law.medicine_law_medical_bill_invoice_date
 * * `law.medicine_law_medical_bill_invoice_number` - law.medicine_law_medical_bill_invoice_number
 * * `law.medicine_law_medical_bill` - law.medicine_law_medical_bill
 * * `law.medicine_law_medical_bill_payment_deadline` - law.medicine_law_medical_bill_payment_deadline
 * * `law.medicine_law_medical_bill_service_period` - law.medicine_law_medical_bill_service_period
 * * `law.medicine_law_medical_bill_services_list` - law.medicine_law_medical_bill_services_list
 * * `law.medicine_law_medical_bill_total_amount` - law.medicine_law_medical_bill_total_amount
 * * `law.medicine_law_medical_expertise_date` - law.medicine_law_medical_expertise_date
 * * `law.medicine_law_medical_expertise_justification` - law.medicine_law_medical_expertise_justification
 * * `law.medicine_law_medical_expertise` - law.medicine_law_medical_expertise
 * * `law.medicine_law_medical_expertise_medical_assessment` - law.medicine_law_medical_expertise_medical_assessment
 * * `law.medicine_law_medical_expertise_question_posed` - law.medicine_law_medical_expertise_question_posed
 * * `law.medicine_law_medical_expertise_result` - law.medicine_law_medical_expertise_result
 * * `law.medicine_law_medical_report_complications` - law.medicine_law_medical_report_complications
 * * `law.medicine_law_medical_report_date` - law.medicine_law_medical_report_date
 * * `law.medicine_law_medical_report_diagnosis_icd_code` - law.medicine_law_medical_report_diagnosis_icd_code
 * * `law.medicine_law_medical_report_diagnosis_short_text` - law.medicine_law_medical_report_diagnosis_short_text
 * * `law.medicine_law_medical_report_further_treatment` - law.medicine_law_medical_report_further_treatment
 * * `law.medicine_law_medical_report` - law.medicine_law_medical_report
 * * `law.medicine_law_medical_report_surgery_date` - law.medicine_law_medical_report_surgery_date
 * * `law.medicine_law_medical_report_treatment_measures` - law.medicine_law_medical_report_treatment_measures
 * * `law.medicine_law_medical_report_treatment_period` - law.medicine_law_medical_report_treatment_period
 * * `law.migration_law_approval_notice_case_number` - law.migration_law_approval_notice_case_number
 * * `law.migration_law_approval_notice_conditions` - law.migration_law_approval_notice_conditions
 * * `law.migration_law_approval_notice_decision_date` - law.migration_law_approval_notice_decision_date
 * * `law.migration_law_approval_notice_issuing_authority` - law.migration_law_approval_notice_issuing_authority
 * * `law.migration_law_approval_notice` - law.migration_law_approval_notice
 * * `law.migration_law_approval_notice_permit_type` - law.migration_law_approval_notice_permit_type
 * * `law.migration_law_approval_notice_pickup_deadline` - law.migration_law_approval_notice_pickup_deadline
 * * `law.migration_law_approval_notice_validity_period` - law.migration_law_approval_notice_validity_period
 * * `law.migration_law_asylum_seeker_certificate_application_number` - law.migration_law_asylum_seeker_certificate_application_number
 * * `law.migration_law_asylum_seeker_certificate_first_registration_date` - law.migration_law_asylum_seeker_certificate_first_registration_date
 * * `law.migration_law_asylum_seeker_certificate_issue_date` - law.migration_law_asylum_seeker_certificate_issue_date
 * * `law.migration_law_asylum_seeker_certificate_issuing_authority` - law.migration_law_asylum_seeker_certificate_issuing_authority
 * * `law.migration_law_asylum_seeker_certificate` - law.migration_law_asylum_seeker_certificate
 * * `law.migration_law_asylum_seeker_certificate_residence_obligation` - law.migration_law_asylum_seeker_certificate_residence_obligation
 * * `law.migration_law_asylum_seeker_certificate_valid_until` - law.migration_law_asylum_seeker_certificate_valid_until
 * * `law.migration_law_asylum_seeker_certificate_work_permission` - law.migration_law_asylum_seeker_certificate_work_permission
 * * `law.migration_law_cooperation_letter_attachments` - law.migration_law_cooperation_letter_attachments
 * * `law.migration_law_cooperation_letter_date` - law.migration_law_cooperation_letter_date
 * * `law.migration_law_cooperation_letter_deadlines` - law.migration_law_cooperation_letter_deadlines
 * * `law.migration_law_cooperation_letter_file_number` - law.migration_law_cooperation_letter_file_number
 * * `law.migration_law_cooperation_letter` - law.migration_law_cooperation_letter
 * * `law.migration_law_cooperation_letter_non_cooperation_consequences` - law.migration_law_cooperation_letter_non_cooperation_consequences
 * * `law.migration_law_cooperation_letter_specified_obligations` - law.migration_law_cooperation_letter_specified_obligations
 * * `law.migration_law_fictional_certificate_authority` - law.migration_law_fictional_certificate_authority
 * * `law.migration_law_fictional_certificate_fiction_type` - law.migration_law_fictional_certificate_fiction_type
 * * `law.migration_law_fictional_certificate_issue_date` - law.migration_law_fictional_certificate_issue_date
 * * `law.migration_law_fictional_certificate_legal_basis` - law.migration_law_fictional_certificate_legal_basis
 * * `law.migration_law_fictional_certificate` - law.migration_law_fictional_certificate
 * * `law.migration_law_fictional_certificate_reason_for_issuance` - law.migration_law_fictional_certificate_reason_for_issuance
 * * `law.migration_law_fictional_certificate_valid_until` - law.migration_law_fictional_certificate_valid_until
 * * `law.migration_law_hearing_letter_date` - law.migration_law_hearing_letter_date
 * * `law.migration_law_hearing_letter_intended_measure_justification` - law.migration_law_hearing_letter_intended_measure_justification
 * * `law.migration_law_hearing_letter_legal_advice` - law.migration_law_hearing_letter_legal_advice
 * * `law.migration_law_hearing_letter` - law.migration_law_hearing_letter
 * * `law.migration_law_hearing_letter_requested_documents` - law.migration_law_hearing_letter_requested_documents
 * * `law.migration_law_hearing_letter_response_deadline` - law.migration_law_hearing_letter_response_deadline
 * * `law.migration_law_other_letters_action_required` - law.migration_law_other_letters_action_required
 * * `law.migration_law_other_letters_date` - law.migration_law_other_letters_date
 * * `law.migration_law_other_letters_deadlines` - law.migration_law_other_letters_deadlines
 * * `law.migration_law_other_letters_file_number` - law.migration_law_other_letters_file_number
 * * `law.migration_law_other_letters_issuing_authority` - law.migration_law_other_letters_issuing_authority
 * * `law.migration_law_other_letters_legal_basis` - law.migration_law_other_letters_legal_basis
 * * `law.migration_law_other_letters` - law.migration_law_other_letters
 * * `law.migration_law_other_letters_matter_purpose` - law.migration_law_other_letters_matter_purpose
 * * `law.migration_law_other_letters_subject` - law.migration_law_other_letters_subject
 * * `law.migration_law_rejection_notice_case_number` - law.migration_law_rejection_notice_case_number
 * * `law.migration_law_rejection_notice_decision_date` - law.migration_law_rejection_notice_decision_date
 * * `law.migration_law_rejection_notice_legal_grounds` - law.migration_law_rejection_notice_legal_grounds
 * * `law.migration_law_rejection_notice_legal_remedy_deadline` - law.migration_law_rejection_notice_legal_remedy_deadline
 * * `law.migration_law_rejection_notice` - law.migration_law_rejection_notice
 * * `law.migration_law_rejection_notice_officer_name` - law.migration_law_rejection_notice_officer_name
 * * `law.migration_law_rejection_notice_reasoning` - law.migration_law_rejection_notice_reasoning
 * * `law.migration_law_rejection_notice_signature_seal` - law.migration_law_rejection_notice_signature_seal
 * * `law.migration_law_rejection_notice_subject` - law.migration_law_rejection_notice_subject
 * * `law.migration_law_residence_permit_conditions` - law.migration_law_residence_permit_conditions
 * * `law.migration_law_residence_permit_issue_date` - law.migration_law_residence_permit_issue_date
 * * `law.migration_law_residence_permit_issuing_authority` - law.migration_law_residence_permit_issuing_authority
 * * `law.migration_law_residence_permit` - law.migration_law_residence_permit
 * * `law.migration_law_residence_permit_national_id_number` - law.migration_law_residence_permit_national_id_number
 * * `law.migration_law_residence_permit_passport_number` - law.migration_law_residence_permit_passport_number
 * * `law.migration_law_residence_permit_purpose` - law.migration_law_residence_permit_purpose
 * * `law.migration_law_residence_permit_type` - law.migration_law_residence_permit_type
 * * `law.migration_law_residence_permit_valid_until` - law.migration_law_residence_permit_valid_until
 * * `law.migration_law_toleration_issue_date` - law.migration_law_toleration_issue_date
 * * `law.migration_law_toleration_issuing_authority` - law.migration_law_toleration_issuing_authority
 * * `law.migration_law_toleration_legal_basis` - law.migration_law_toleration_legal_basis
 * * `law.migration_law_toleration` - law.migration_law_toleration
 * * `law.migration_law_toleration_reason` - law.migration_law_toleration_reason
 * * `law.migration_law_toleration_restrictions` - law.migration_law_toleration_restrictions
 * * `law.migration_law_toleration_valid_until` - law.migration_law_toleration_valid_until
 * * `law.real_estate_law_basic_debts_amount` - law.real_estate_law_basic_debts_amount
 * * `law.real_estate_law_broker_commission_amount` - law.real_estate_law_broker_commission_amount
 * * `law.real_estate_law_broker_contract_type` - law.real_estate_law_broker_contract_type
 * * `law.real_estate_law_broker_scope_of_work` - law.real_estate_law_broker_scope_of_work
 * * `law.real_estate_law_broker_termination_periods` - law.real_estate_law_broker_termination_periods
 * * `law.real_estate_law_brokerage_contract_date` - law.real_estate_law_brokerage_contract_date
 * * `law.real_estate_law_brokerage_contract` - law.real_estate_law_brokerage_contract
 * * `law.real_estate_law_brokerage_fee` - law.real_estate_law_brokerage_fee
 * * `law.real_estate_law_building_dimensions` - law.real_estate_law_building_dimensions
 * * `law.real_estate_law_building_permit_date` - law.real_estate_law_building_permit_date
 * * `law.real_estate_law_building_permit` - law.real_estate_law_building_permit
 * * `law.real_estate_law_building_permit_number` - law.real_estate_law_building_permit_number
 * * `law.real_estate_law_building_permit_validity_duration` - law.real_estate_law_building_permit_validity_duration
 * * `law.real_estate_law_building_plan` - law.real_estate_law_building_plan
 * * `law.real_estate_law_building_restrictions_clause` - law.real_estate_law_building_restrictions_clause
 * * `law.real_estate_law_building_usage` - law.real_estate_law_building_usage
 * * `law.real_estate_law_co_ownership_share` - law.real_estate_law_co_ownership_share
 * * `law.real_estate_law_commission_percentage` - law.real_estate_law_commission_percentage
 * * `law.real_estate_law_contaminated_sites_clause` - law.real_estate_law_contaminated_sites_clause
 * * `law.real_estate_law_declaration_of_division` - law.real_estate_law_declaration_of_division
 * * `law.real_estate_law_division_declaration_date` - law.real_estate_law_division_declaration_date
 * * `law.real_estate_law_encumbrance_restrictions` - law.real_estate_law_encumbrance_restrictions
 * * `law.real_estate_law_encumbrances_section_ii` - law.real_estate_law_encumbrances_section_ii
 * * `law.real_estate_law_encumbrances_section_iii` - law.real_estate_law_encumbrances_section_iii
 * * `law.real_estate_law_exclusive_brokerage_contract` - law.real_estate_law_exclusive_brokerage_contract
 * * `law.real_estate_law_full_repayment_date` - law.real_estate_law_full_repayment_date
 * * `law.real_estate_law_installment_amount` - law.real_estate_law_installment_amount
 * * `law.real_estate_law_interest_rate` - law.real_estate_law_interest_rate
 * * `law.real_estate_law_land_register_address` - law.real_estate_law_land_register_address
 * * `law.real_estate_law_land_register_city` - law.real_estate_law_land_register_city
 * * `law.real_estate_law_land_register_date` - law.real_estate_law_land_register_date
 * * `law.real_estate_law_land_register` - law.real_estate_law_land_register
 * * `law.real_estate_law_land_register_number` - law.real_estate_law_land_register_number
 * * `law.real_estate_law_land_register_plot_of_land` - law.real_estate_law_land_register_plot_of_land
 * * `law.real_estate_law_legal_defects_clause` - law.real_estate_law_legal_defects_clause
 * * `law.real_estate_law_loan_agreement` - law.real_estate_law_loan_agreement
 * * `law.real_estate_law_loan_amount` - law.real_estate_law_loan_amount
 * * `law.real_estate_law_loan_security` - law.real_estate_law_loan_security
 * * `law.real_estate_law_monument_protection_basis` - law.real_estate_law_monument_protection_basis
 * * `law.real_estate_law_monument_protection_notice` - law.real_estate_law_monument_protection_notice
 * * `law.real_estate_law_monument_protection_order_date` - law.real_estate_law_monument_protection_order_date
 * * `law.real_estate_law_monument_protection_order_number` - law.real_estate_law_monument_protection_order_number
 * * `law.real_estate_law_monument_protection_requirements` - law.real_estate_law_monument_protection_requirements
 * * `law.real_estate_law_monument_registration_date` - law.real_estate_law_monument_registration_date
 * * `law.real_estate_law_plan_author` - law.real_estate_law_plan_author
 * * `law.real_estate_law_plan_designation` - law.real_estate_law_plan_designation
 * * `law.real_estate_law_plan_scale` - law.real_estate_law_plan_scale
 * * `law.real_estate_law_plot_size` - law.real_estate_law_plot_size
 * * `law.real_estate_law_property_brokered_by_agent` - law.real_estate_law_property_brokered_by_agent
 * * `law.real_estate_law_purchase_contract_amount` - law.real_estate_law_purchase_contract_amount
 * * `law.real_estate_law_purchase_contract_date` - law.real_estate_law_purchase_contract_date
 * * `law.real_estate_law_purchase_contract_description` - law.real_estate_law_purchase_contract_description
 * * `law.real_estate_law_purchase_contract` - law.real_estate_law_purchase_contract
 * * `law.real_estate_law_purchase_contract_registration_date` - law.real_estate_law_purchase_contract_registration_date
 * * `law.real_estate_law_purchase_contract_registration_number` - law.real_estate_law_purchase_contract_registration_number
 * * `law.real_estate_law_purchase_object_rented` - law.real_estate_law_purchase_object_rented
 * * `law.real_estate_law_purchase_price_loan_financed` - law.real_estate_law_purchase_price_loan_financed
 * * `law.real_estate_law_repayment_rate` - law.real_estate_law_repayment_rate
 * * `law.real_estate_law_withdrawal_instruction_date` - law.real_estate_law_withdrawal_instruction_date
 * * `law.residential_property_law_co_ownership_shares` - law.residential_property_law_co_ownership_shares
 * * `law.residential_property_law_contract_date` - law.residential_property_law_contract_date
 * * `law.residential_property_law_contract` - law.residential_property_law_contract
 * * `law.residential_property_law_inventory` - law.residential_property_law_inventory
 * * `law.residential_property_law_land_register_address` - law.residential_property_law_land_register_address
 * * `law.residential_property_law_land_register_city` - law.residential_property_law_land_register_city
 * * `law.residential_property_law_land_register_number` - law.residential_property_law_land_register_number
 * * `law.residential_property_law_land_register_plot_of_land` - law.residential_property_law_land_register_plot_of_land
 * * `law.social_law_affected_benefit` - law.social_law_affected_benefit
 * * `law.social_law_application_arrival_date` - law.social_law_application_arrival_date
 * * `law.social_law_application_date` - law.social_law_application_date
 * * `law.social_law_application_file_reference` - law.social_law_application_file_reference
 * * `law.social_law_application_form` - law.social_law_application_form
 * * `law.social_law_appointment_date` - law.social_law_appointment_date
 * * `law.social_law_appointment_file_reference` - law.social_law_appointment_file_reference
 * * `law.social_law_appointment_invitation` - law.social_law_appointment_invitation
 * * `law.social_law_appointment_purpose` - law.social_law_appointment_purpose
 * * `law.social_law_appointment_required_documents` - law.social_law_appointment_required_documents
 * * `law.social_law_appointment_time` - law.social_law_appointment_time
 * * `law.social_law_approval_file_reference` - law.social_law_approval_file_reference
 * * `law.social_law_approval_internal_reference` - law.social_law_approval_internal_reference
 * * `law.social_law_approval_legal_basis` - law.social_law_approval_legal_basis
 * * `law.social_law_approval_notice_date` - law.social_law_approval_notice_date
 * * `law.social_law_approval_notice` - law.social_law_approval_notice
 * * `law.social_law_approval_period_end` - law.social_law_approval_period_end
 * * `law.social_law_approval_period_start` - law.social_law_approval_period_start
 * * `law.social_law_approved_benefit_amount` - law.social_law_approved_benefit_amount
 * * `law.social_law_approved_benefit_period` - law.social_law_approved_benefit_period
 * * `law.social_law_approved_benefit_type` - law.social_law_approved_benefit_type
 * * `law.social_law_asset_type` - law.social_law_asset_type
 * * `law.social_law_attachment_list` - law.social_law_attachment_list
 * * `law.social_law_benefit_type` - law.social_law_benefit_type
 * * `law.social_law_change_description` - law.social_law_change_description
 * * `law.social_law_change_file_reference` - law.social_law_change_file_reference
 * * `law.social_law_change_notification_date` - law.social_law_change_notification_date
 * * `law.social_law_change_notification` - law.social_law_change_notification
 * * `law.social_law_change_reason` - law.social_law_change_reason
 * * `law.social_law_creditable_income` - law.social_law_creditable_income
 * * `law.social_law_disability_card_issue_date` - law.social_law_disability_card_issue_date
 * * `law.social_law_disability_card` - law.social_law_disability_card
 * * `law.social_law_disability_card_markers` - law.social_law_disability_card_markers
 * * `law.social_law_disability_card_validity_period` - law.social_law_disability_card_validity_period
 * * `law.social_law_disability_degree` - law.social_law_disability_degree
 * * `law.social_law_disability_file_reference` - law.social_law_disability_file_reference
 * * `law.social_law_employment_income` - law.social_law_employment_income
 * * `law.social_law_follow_up_application_notes` - law.social_law_follow_up_application_notes
 * * `law.social_law_hearing_file_reference` - law.social_law_hearing_file_reference
 * * `law.social_law_hearing_letter_date` - law.social_law_hearing_letter_date
 * * `law.social_law_hearing_letter` - law.social_law_hearing_letter
 * * `law.social_law_hearing_planned_administrative_act` - law.social_law_hearing_planned_administrative_act
 * * `law.social_law_housing_costs_amount` - law.social_law_housing_costs_amount
 * * `law.social_law_income_amount` - law.social_law_income_amount
 * * `law.social_law_income_date` - law.social_law_income_date
 * * `law.social_law_income_legal_basis` - law.social_law_income_legal_basis
 * * `law.social_law_income_provider` - law.social_law_income_provider
 * * `law.social_law_income_source` - law.social_law_income_source
 * * `law.social_law_income_type` - law.social_law_income_type
 * * `law.social_law_interim_legal_protection` - law.social_law_interim_legal_protection
 * * `law.social_law_interim_protection_affidavit` - law.social_law_interim_protection_affidavit
 * * `law.social_law_interim_protection_attachment_list` - law.social_law_interim_protection_attachment_list
 * * `law.social_law_interim_protection_file_reference` - law.social_law_interim_protection_file_reference
 * * `law.social_law_interim_protection_request_date` - law.social_law_interim_protection_request_date
 * * `law.social_law_interim_protection_request_text` - law.social_law_interim_protection_request_text
 * * `law.social_law_interim_protection_urgency_reason` - law.social_law_interim_protection_urgency_reason
 * * `law.social_law_lawsuit_alternative_request` - law.social_law_lawsuit_alternative_request
 * * `law.social_law_lawsuit_attachment_list` - law.social_law_lawsuit_attachment_list
 * * `law.social_law_lawsuit_cost_request` - law.social_law_lawsuit_cost_request
 * * `law.social_law_lawsuit_court_file_number` - law.social_law_lawsuit_court_file_number
 * * `law.social_law_lawsuit_delivery_date` - law.social_law_lawsuit_delivery_date
 * * `law.social_law_lawsuit_dispute_value` - law.social_law_lawsuit_dispute_value
 * * `law.social_law_lawsuit_disputed_amount` - law.social_law_lawsuit_disputed_amount
 * * `law.social_law_lawsuit_evidence_requests` - law.social_law_lawsuit_evidence_requests
 * * `law.social_law_lawsuit_file_reference` - law.social_law_lawsuit_file_reference
 * * `law.social_law_lawsuit_filing_date` - law.social_law_lawsuit_filing_date
 * * `law.social_law_lawsuit_income_amount` - law.social_law_lawsuit_income_amount
 * * `law.social_law_lawsuit_legal_basis` - law.social_law_lawsuit_legal_basis
 * * `law.social_law_lawsuit_main_request` - law.social_law_lawsuit_main_request
 * * `law.social_law_lawsuit` - law.social_law_lawsuit
 * * `law.social_law_lawsuit_monthly_benefit_amount` - law.social_law_lawsuit_monthly_benefit_amount
 * * `law.social_law_lawsuit_objection_decision_date` - law.social_law_lawsuit_objection_decision_date
 * * `law.social_law_lawsuit_objection_filing_date` - law.social_law_lawsuit_objection_filing_date
 * * `law.social_law_lawsuit_original_decision_date` - law.social_law_lawsuit_original_decision_date
 * * `law.social_law_lawsuit_subject` - law.social_law_lawsuit_subject
 * * `law.social_law_lawsuit_type` - law.social_law_lawsuit_type
 * * `law.social_law_legal_basis` - law.social_law_legal_basis
 * * `law.social_law_medical_certificate` - law.social_law_medical_certificate
 * * `law.social_law_medical_diagnosis` - law.social_law_medical_diagnosis
 * * `law.social_law_medical_examination_date` - law.social_law_medical_examination_date
 * * `law.social_law_medical_file_reference` - law.social_law_medical_file_reference
 * * `law.social_law_medical_icd_code` - law.social_law_medical_icd_code
 * * `law.social_law_medical_limitations` - law.social_law_medical_limitations
 * * `law.social_law_medical_prognosis` - law.social_law_medical_prognosis
 * * `law.social_law_medical_work_capacity_relation` - law.social_law_medical_work_capacity_relation
 * * `law.social_law_monthly_payment_amount` - law.social_law_monthly_payment_amount
 * * `law.social_law_needs_cost_breakdown` - law.social_law_needs_cost_breakdown
 * * `law.social_law_needs_file_reference` - law.social_law_needs_file_reference
 * * `law.social_law_needs_proof_basis` - law.social_law_needs_proof_basis
 * * `law.social_law_needs_proof_date` - law.social_law_needs_proof_date
 * * `law.social_law_needs_proof` - law.social_law_needs_proof
 * * `law.social_law_needs_type` - law.social_law_needs_type
 * * `law.social_law_notice_date` - law.social_law_notice_date
 * * `law.social_law_notice_of_objection_date` - law.social_law_notice_of_objection_date
 * * `law.social_law_notice_of_objection_file_reference` - law.social_law_notice_of_objection_file_reference
 * * `law.social_law_notice_of_objection` - law.social_law_notice_of_objection
 * * `law.social_law_notification_date` - law.social_law_notification_date
 * * `law.social_law_notification_legal_basis` - law.social_law_notification_legal_basis
 * * `law.social_law_notification_source` - law.social_law_notification_source
 * * `law.social_law_objection_challenged_notice` - law.social_law_objection_challenged_notice
 * * `law.social_law_objection_date` - law.social_law_objection_date
 * * `law.social_law_objection_evidence` - law.social_law_objection_evidence
 * * `law.social_law_objection_file_reference` - law.social_law_objection_file_reference
 * * `law.social_law_objection` - law.social_law_objection
 * * `law.social_law_objection_reasoning` - law.social_law_objection_reasoning
 * * `law.social_law_objection_suspension_request` - law.social_law_objection_suspension_request
 * * `law.social_law_original_decision_date` - law.social_law_original_decision_date
 * * `law.social_law_other_income` - law.social_law_other_income
 * * `law.social_law_own_income_amount` - law.social_law_own_income_amount
 * * `law.social_law_reclaim_amount` - law.social_law_reclaim_amount
 * * `law.social_law_reclaim_file_reference` - law.social_law_reclaim_file_reference
 * * `law.social_law_reclaim_legal_basis` - law.social_law_reclaim_legal_basis
 * * `law.social_law_reclaim_legal_norm` - law.social_law_reclaim_legal_norm
 * * `law.social_law_reclaim_notice_date` - law.social_law_reclaim_notice_date
 * * `law.social_law_reclaim_notice` - law.social_law_reclaim_notice
 * * `law.social_law_reclaim_payment_deadline` - law.social_law_reclaim_payment_deadline
 * * `law.social_law_reclaim_payment_terms` - law.social_law_reclaim_payment_terms
 * * `law.social_law_regelbedarf_amount` - law.social_law_regelbedarf_amount
 * * `law.social_law_rejection_file_reference` - law.social_law_rejection_file_reference
 * * `law.social_law_rejection_legal_norm` - law.social_law_rejection_legal_norm
 * * `law.social_law_rejection_notice_date` - law.social_law_rejection_notice_date
 * * `law.social_law_rejection_notice` - law.social_law_rejection_notice
 * * `law.social_law_rejection_reason` - law.social_law_rejection_reason
 * * `law.social_law_residence_status` - law.social_law_residence_status
 * * `law.social_law_revocation_benefit_type` - law.social_law_revocation_benefit_type
 * * `law.social_law_revocation_file_reference` - law.social_law_revocation_file_reference
 * * `law.social_law_revocation_legal_norm` - law.social_law_revocation_legal_norm
 * * `law.social_law_revocation_notice_date` - law.social_law_revocation_notice_date
 * * `law.social_law_revocation_notice` - law.social_law_revocation_notice
 * * `law.social_law_revocation_period_end` - law.social_law_revocation_period_end
 * * `law.social_law_revocation_period_start` - law.social_law_revocation_period_start
 * * `law.social_law_revocation_reason` - law.social_law_revocation_reason
 * * `law.social_law_revocation_reclaim_notes` - law.social_law_revocation_reclaim_notes
 * * `law.social_law_social_benefit_type` - law.social_law_social_benefit_type
 * * `law.social_law_summary_grounds_opposition` - law.social_law_summary_grounds_opposition
 * * `law.social_law_total_need_amount` - law.social_law_total_need_amount
 * * `law.social_law_total_reclaim_amount` - law.social_law_total_reclaim_amount
 * * `law.social_law_violation_type` - law.social_law_violation_type
 * * `law.tenancy_law_adress_rental_property` - law.tenancy_law_adress_rental_property
 * * `law.tenancy_law_advance_payment_service_charge` - law.tenancy_law_advance_payment_service_charge
 * * `law.tenancy_law_advance_payment_service_charges` - law.tenancy_law_advance_payment_service_charges
 * * `law.tenancy_law_bank_guarantee` - law.tenancy_law_bank_guarantee
 * * `law.tenancy_law_cash_deposit_agreed` - law.tenancy_law_cash_deposit_agreed
 * * `law.tenancy_law_cash_deposit_payment_date` - law.tenancy_law_cash_deposit_payment_date
 * * `law.tenancy_law_competent_court` - law.tenancy_law_competent_court
 * * `law.tenancy_law_cost_share` - law.tenancy_law_cost_share
 * * `law.tenancy_law_cost_shares` - law.tenancy_law_cost_shares
 * * `law.tenancy_law_counter_number` - law.tenancy_law_counter_number
 * * `law.tenancy_law_court_case_number` - law.tenancy_law_court_case_number
 * * `law.tenancy_law_court_proceedings_pending` - law.tenancy_law_court_proceedings_pending
 * * `law.tenancy_law_description_of_rental_property` - law.tenancy_law_description_of_rental_property
 * * `law.tenancy_law_duration_of_lease` - law.tenancy_law_duration_of_lease
 * * `law.tenancy_law_expert_report_commission_date` - law.tenancy_law_expert_report_commission_date
 * * `law.tenancy_law_expert_report_damage_description` - law.tenancy_law_expert_report_damage_description
 * * `law.tenancy_law_expert_report_damage_number` - law.tenancy_law_expert_report_damage_number
 * * `law.tenancy_law_expert_report_date` - law.tenancy_law_expert_report_date
 * * `law.tenancy_law_expert_report_inspection_date` - law.tenancy_law_expert_report_inspection_date
 * * `law.tenancy_law_expert_report` - law.tenancy_law_expert_report
 * * `law.tenancy_law_expert_report_object_address` - law.tenancy_law_expert_report_object_address
 * * `law.tenancy_law_expert_report_purpose` - law.tenancy_law_expert_report_purpose
 * * `law.tenancy_law_expert_report_repair_duration` - law.tenancy_law_expert_report_repair_duration
 * * `law.tenancy_law_expert_report_subject` - law.tenancy_law_expert_report_subject
 * * `law.tenancy_law_extension_option_count` - law.tenancy_law_extension_option_count
 * * `law.tenancy_law_extension_option_duration` - law.tenancy_law_extension_option_duration
 * * `law.tenancy_law_fixed_term_tenancy` - law.tenancy_law_fixed_term_tenancy
 * * `law.tenancy_law_garage_available` - law.tenancy_law_garage_available
 * * `law.tenancy_law_garage_costs` - law.tenancy_law_garage_costs
 * * `law.tenancy_law_general_status_documents` - law.tenancy_law_general_status_documents
 * * `law.tenancy_law_gross_rent` - law.tenancy_law_gross_rent
 * * `law.tenancy_law_handover_counter` - law.tenancy_law_handover_counter
 * * `law.tenancy_law_handover_date` - law.tenancy_law_handover_date
 * * `law.tenancy_law_handover_defects` - law.tenancy_law_handover_defects
 * * `law.tenancy_law_handover_protocol` - law.tenancy_law_handover_protocol
 * * `law.tenancy_law_landlord_termination_given` - law.tenancy_law_landlord_termination_given
 * * `law.tenancy_law_last_rent_increase_letter_date` - law.tenancy_law_last_rent_increase_letter_date
 * * `law.tenancy_law_last_signature_date` - law.tenancy_law_last_signature_date
 * * `law.tenancy_law_lease_agreement` - law.tenancy_law_lease_agreement
 * * `law.tenancy_law_location_in_rental_property` - law.tenancy_law_location_in_rental_property
 * * `law.tenancy_law_net_rent` - law.tenancy_law_net_rent
 * * `law.tenancy_law_operating_costs_agreement` - law.tenancy_law_operating_costs_agreement
 * * `law.tenancy_law_parking_space_available` - law.tenancy_law_parking_space_available
 * * `law.tenancy_law_parking_space_costs` - law.tenancy_law_parking_space_costs
 * * `law.tenancy_law_property_return_date` - law.tenancy_law_property_return_date
 * * `law.tenancy_law_rent_increase_effective_date` - law.tenancy_law_rent_increase_effective_date
 * * `law.tenancy_law_rent_increase_notice` - law.tenancy_law_rent_increase_notice
 * * `law.tenancy_law_rental_agreement_date` - law.tenancy_law_rental_agreement_date
 * * `law.tenancy_law_rental_agreement_duration` - law.tenancy_law_rental_agreement_duration
 * * `law.tenancy_law_rental_agreement` - law.tenancy_law_rental_agreement
 * * `law.tenancy_law_rental_agreement_validity_end` - law.tenancy_law_rental_agreement_validity_end
 * * `law.tenancy_law_rental_agreement_validity_start` - law.tenancy_law_rental_agreement_validity_start
 * * `law.tenancy_law_rental_object_size_sqm` - law.tenancy_law_rental_object_size_sqm
 * * `law.tenancy_law_repayment` - law.tenancy_law_repayment
 * * `law.tenancy_law_repayment_period_end` - law.tenancy_law_repayment_period_end
 * * `law.tenancy_law_repayment_period_start` - law.tenancy_law_repayment_period_start
 * * `law.tenancy_law_security_deposit_additional_regulations` - law.tenancy_law_security_deposit_additional_regulations
 * * `law.tenancy_law_security_deposit_amount` - law.tenancy_law_security_deposit_amount
 * * `law.tenancy_law_service_charge_settlement` - law.tenancy_law_service_charge_settlement
 * * `law.tenancy_law_staggered_rental_agreement` - law.tenancy_law_staggered_rental_agreement
 * * `law.tenancy_law_start_of_lease` - law.tenancy_law_start_of_lease
 * * `law.tenancy_law_tenancy_terminated` - law.tenancy_law_tenancy_terminated
 * * `law.tenancy_law_tenancy_termination_date` - law.tenancy_law_tenancy_termination_date
 * * `law.tenancy_law_tenant_extension_option` - law.tenancy_law_tenant_extension_option
 * * `law.tenancy_law_tenant_warned` - law.tenancy_law_tenant_warned
 * * `law.tenancy_law_termination_declared_date` - law.tenancy_law_termination_declared_date
 * * `law.tenancy_law_termination_letter_date` - law.tenancy_law_termination_letter_date
 * * `law.tenancy_law_termination_notice` - law.tenancy_law_termination_notice
 * * `law.tenancy_law_termination_notice_period` - law.tenancy_law_termination_notice_period
 * * `law.tenancy_law_total_cost_service_charge` - law.tenancy_law_total_cost_service_charge
 * * `law.tenancy_law_total_rent` - law.tenancy_law_total_rent
 * * `law.tenancy_law_unlimited_term_tenancy` - law.tenancy_law_unlimited_term_tenancy
 * * `law.tenancy_law_value_security_clause` - law.tenancy_law_value_security_clause
 * * `law.tenancy_law_warning_letter_date` - law.tenancy_law_warning_letter_date
 * * `law.tenancy_law_warning_letter` - law.tenancy_law_warning_letter
 * * `law.topic` - law.topic
 * * `law.traffic_law_accident_date` - law.traffic_law_accident_date
 * * `law.traffic_law_accident_report` - law.traffic_law_accident_report
 * * `law.traffic_law_amount_of_fine` - law.traffic_law_amount_of_fine
 * * `law.traffic_law_appeal_instruction` - law.traffic_law_appeal_instruction
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - law.traffic_law_at_fault_driver_drivers_license_issued_by
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - law.traffic_law_at_fault_driver_drivers_license_valid_until
 * * `law.traffic_law_at_fault_driver_green_card_number` - law.traffic_law_at_fault_driver_green_card_number
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - law.traffic_law_at_fault_driver_insurance_expiry_date
 * * `law.traffic_law_at_fault_driver_insurance_number` - law.traffic_law_at_fault_driver_insurance_number
 * * `law.traffic_law_at_fault_driver_insurer` - law.traffic_law_at_fault_driver_insurer
 * * `law.traffic_law_blood_alcohol_concentration` - law.traffic_law_blood_alcohol_concentration
 * * `law.traffic_law_calculated_total_damage_costs` - law.traffic_law_calculated_total_damage_costs
 * * `law.traffic_law_calculated_total_days` - law.traffic_law_calculated_total_days
 * * `law.traffic_law_charges` - law.traffic_law_charges
 * * `law.traffic_law_cost_per_scale` - law.traffic_law_cost_per_scale
 * * `law.traffic_law_daily_rate` - law.traffic_law_daily_rate
 * * `law.traffic_law_damage_amount_net` - law.traffic_law_damage_amount_net
 * * `law.traffic_law_damage_number` - law.traffic_law_damage_number
 * * `law.traffic_law_damage_scope` - law.traffic_law_damage_scope
 * * `law.traffic_law_date_of_accident` - law.traffic_law_date_of_accident
 * * `law.traffic_law_date_of_crime` - law.traffic_law_date_of_crime
 * * `law.traffic_law_date_of_fine` - law.traffic_law_date_of_fine
 * * `law.traffic_law_date_of_infraction` - law.traffic_law_date_of_infraction
 * * `law.traffic_law_date_of_inspection` - law.traffic_law_date_of_inspection
 * * `law.traffic_law_date_of_issue` - law.traffic_law_date_of_issue
 * * `law.traffic_law_date_of_offense` - law.traffic_law_date_of_offense
 * * `law.traffic_law_date_of_report` - law.traffic_law_date_of_report
 * * `law.traffic_law_differencial_tax` - law.traffic_law_differencial_tax
 * * `law.traffic_law_driver_logbook_required` - law.traffic_law_driver_logbook_required
 * * `law.traffic_law_driving_ban_duration` - law.traffic_law_driving_ban_duration
 * * `law.traffic_law_driving_ban` - law.traffic_law_driving_ban
 * * `law.traffic_law_evidence_infraction` - law.traffic_law_evidence_infraction
 * * `law.traffic_law_expert_cost` - law.traffic_law_expert_cost
 * * `law.traffic_law_expert_date` - law.traffic_law_expert_date
 * * `law.traffic_law_expert_report` - law.traffic_law_expert_report
 * * `law.traffic_law_expert_report_number` - law.traffic_law_expert_report_number
 * * `law.traffic_law_file_number` - law.traffic_law_file_number
 * * `law.traffic_law_fine` - law.traffic_law_fine
 * * `law.traffic_law_fine_notice` - law.traffic_law_fine_notice
 * * `law.traffic_law_gross_gross_replacement_value` - law.traffic_law_gross_gross_replacement_value
 * * `law.traffic_law_gross_replacement_value` - law.traffic_law_gross_replacement_value
 * * `law.traffic_law_injured` - law.traffic_law_injured
 * * `law.traffic_law_insurance_holder` - law.traffic_law_insurance_holder
 * * `law.traffic_law_insurance` - law.traffic_law_insurance
 * * `law.traffic_law_insurance_policy_number` - law.traffic_law_insurance_policy_number
 * * `law.traffic_law_legal_basis_infraction` - law.traffic_law_legal_basis_infraction
 * * `law.traffic_law_legal_basis` - law.traffic_law_legal_basis
 * * `law.traffic_law_licenseplate_at_fault_driver` - law.traffic_law_licenseplate_at_fault_driver
 * * `law.traffic_law_licenseplate` - law.traffic_law_licenseplate
 * * `law.traffic_law_licenseplate_victim_driver` - law.traffic_law_licenseplate_victim_driver
 * * `law.traffic_law_loss_amount_repair_case` - law.traffic_law_loss_amount_repair_case
 * * `law.traffic_law_loss_amount_total_damage_case` - law.traffic_law_loss_amount_total_damage_case
 * * `law.traffic_law_loss_of_use_per_day` - law.traffic_law_loss_of_use_per_day
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - law.traffic_law_mark_and_type_of_at_fault_driver
 * * `law.traffic_law_mark_and_type_of_victim_driver` - law.traffic_law_mark_and_type_of_victim_driver
 * * `law.traffic_law_merantile_value_loss` - law.traffic_law_merantile_value_loss
 * * `law.traffic_law_net_gross_replacement_value` - law.traffic_law_net_gross_replacement_value
 * * `law.traffic_law_net_replacement_value` - law.traffic_law_net_replacement_value
 * * `law.traffic_law_number_of_daily_rates` - law.traffic_law_number_of_daily_rates
 * * `law.traffic_law_offense_infraction_description` - law.traffic_law_offense_infraction_description
 * * `law.traffic_law_other_damages` - law.traffic_law_other_damages
 * * `law.traffic_law_payment_deadline` - law.traffic_law_payment_deadline
 * * `law.traffic_law_penalty_order` - law.traffic_law_penalty_order
 * * `law.traffic_law_place_of_accident` - law.traffic_law_place_of_accident
 * * `law.traffic_law_place_of_crime` - law.traffic_law_place_of_crime
 * * `law.traffic_law_place_of_infraction` - law.traffic_law_place_of_infraction
 * * `law.traffic_law_place_of_inspection` - law.traffic_law_place_of_inspection
 * * `law.traffic_law_place_of_issue` - law.traffic_law_place_of_issue
 * * `law.traffic_law_place_of_offense` - law.traffic_law_place_of_offense
 * * `law.traffic_law_points_for_offense` - law.traffic_law_points_for_offense
 * * `law.traffic_law_police_case_number` - law.traffic_law_police_case_number
 * * `law.traffic_law_procedure_costs` - law.traffic_law_procedure_costs
 * * `law.traffic_law_prosecution_number` - law.traffic_law_prosecution_number
 * * `law.traffic_law_regular_tax` - law.traffic_law_regular_tax
 * * `law.traffic_law_repair_costs_with_vat` - law.traffic_law_repair_costs_with_vat
 * * `law.traffic_law_repair_costs_without_vat` - law.traffic_law_repair_costs_without_vat
 * * `law.traffic_law_repair_damage` - law.traffic_law_repair_damage
 * * `law.traffic_law_repair_duration` - law.traffic_law_repair_duration
 * * `law.traffic_law_replacement_cost` - law.traffic_law_replacement_cost
 * * `law.traffic_law_replacement_value` - law.traffic_law_replacement_value
 * * `law.traffic_law_reregistration_cost` - law.traffic_law_reregistration_cost
 * * `law.traffic_law_residual_value` - law.traffic_law_residual_value
 * * `law.traffic_law_speed_allowed` - law.traffic_law_speed_allowed
 * * `law.traffic_law_speed_driven` - law.traffic_law_speed_driven
 * * `law.traffic_law_speed_too_high` - law.traffic_law_speed_too_high
 * * `law.traffic_law_time_of_accident` - law.traffic_law_time_of_accident
 * * `law.traffic_law_time_of_crime` - law.traffic_law_time_of_crime
 * * `law.traffic_law_time_of_infraction` - law.traffic_law_time_of_infraction
 * * `law.traffic_law_time_of_inspection` - law.traffic_law_time_of_inspection
 * * `law.traffic_law_time_of_issue` - law.traffic_law_time_of_issue
 * * `law.traffic_law_time_of_offense` - law.traffic_law_time_of_offense
 * * `law.traffic_law_total_damage` - law.traffic_law_total_damage
 * * `law.traffic_law_value_improvement` - law.traffic_law_value_improvement
 * * `law.traffic_law_vehicle_age_months` - law.traffic_law_vehicle_age_months
 * * `law.traffic_law_vehicle_mileage` - law.traffic_law_vehicle_mileage
 * * `law.traffic_law_vehicle_type_and_brand` - law.traffic_law_vehicle_type_and_brand
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - law.traffic_law_victim_driver_drivers_license_issued_by
 * * `law.traffic_law_victim_driver_green_card_number` - law.traffic_law_victim_driver_green_card_number
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - law.traffic_law_victim_driver_insurance_expiry_date
 * * `law.traffic_law_victim_driver_insurance_number` - law.traffic_law_victim_driver_insurance_number
 * * `law.traffic_law_victim_driver_insurer` - law.traffic_law_victim_driver_insurer
 * * `law.traffic_law_victim_driver_license_valid_until` - law.traffic_law_victim_driver_license_valid_until
 * * `law.traffic_law_violated_section` - law.traffic_law_violated_section
 * * `law.traffic_law_violation_type` - law.traffic_law_violation_type
 * * `law.traffic_law_warning_fee_infraction` - law.traffic_law_warning_fee_infraction
 * * `law.traffic_law_warning_notice` - law.traffic_law_warning_notice
 */
export const AiAugmentedByMapperKeysEnum = {
    ENTITIES_FIELD_ADDRESS_LINE_2: 'entities.field.address_line_2',
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_IS_VALID_EMAIL: 'entities.field.is_valid_email',
    ENTITIES_FIELD_IS_VALID_PHONE_NUMBER: 'entities.field.is_valid_phone_number',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip',
    LAW_CIVIL_LAW_ACCESSORIES_SOLD_SEPARATELY: 'law.civil_law_accessories_sold_separately',
    LAW_CIVIL_LAW_CASE_NUMBER: 'law.civil_law_case_number',
    LAW_CIVIL_LAW_CLAIM_AMOUNT: 'law.civil_law_claim_amount',
    LAW_CIVIL_LAW_CONTRACT_DATE: 'law.civil_law_contract_date',
    LAW_CIVIL_LAW_CONTRACT_DURATION: 'law.civil_law_contract_duration',
    LAW_CIVIL_LAW_CONTRACT_END_DATE: 'law.civil_law_contract_end_date',
    LAW_CIVIL_LAW_CONTRACT: 'law.civil_law_contract',
    LAW_CIVIL_LAW_CONTRACT_OBJECT: 'law.civil_law_contract_object',
    LAW_CIVIL_LAW_CONTRACT_START_DATE: 'law.civil_law_contract_start_date',
    LAW_CIVIL_LAW_CONTRACT_VALUE: 'law.civil_law_contract_value',
    LAW_CIVIL_LAW_CORRESPONDENCE: 'law.civil_law_correspondence',
    LAW_CIVIL_LAW_COURT_COSTS: 'law.civil_law_court_costs',
    LAW_CIVIL_LAW_COURT_DOCUMENT: 'law.civil_law_court_document',
    LAW_CIVIL_LAW_COURT_NAME: 'law.civil_law_court_name',
    LAW_CIVIL_LAW_DAMAGE_AMOUNT: 'law.civil_law_damage_amount',
    LAW_CIVIL_LAW_DAMAGE_CAUSE: 'law.civil_law_damage_cause',
    LAW_CIVIL_LAW_DAMAGE_CLAIM: 'law.civil_law_damage_claim',
    LAW_CIVIL_LAW_DAMAGE_DATE: 'law.civil_law_damage_date',
    LAW_CIVIL_LAW_DAMAGE_DESCRIPTION: 'law.civil_law_damage_description',
    LAW_CIVIL_LAW_DEFAULT_INTEREST: 'law.civil_law_default_interest',
    LAW_CIVIL_LAW_DEFECTS: 'law.civil_law_defects',
    LAW_CIVIL_LAW_DEFECTS_PRESENT: 'law.civil_law_defects_present',
    LAW_CIVIL_LAW_DELIVERY_DATE: 'law.civil_law_delivery_date',
    LAW_CIVIL_LAW_DOCUMENT_DATE: 'law.civil_law_document_date',
    LAW_CIVIL_LAW_FILE_REFERENCE: 'law.civil_law_file_reference',
    LAW_CIVIL_LAW_HANDOVER_DATE: 'law.civil_law_handover_date',
    LAW_CIVIL_LAW_HEARING_DATE: 'law.civil_law_hearing_date',
    LAW_CIVIL_LAW_INSURANCE_CLAIM_NUMBER: 'law.civil_law_insurance_claim_number',
    LAW_CIVIL_LAW_INTEREST_RATE: 'law.civil_law_interest_rate',
    LAW_CIVIL_LAW_JUDGMENT_DATE: 'law.civil_law_judgment_date',
    LAW_CIVIL_LAW_LIABILITY_PERCENTAGE: 'law.civil_law_liability_percentage',
    LAW_CIVIL_LAW_NOTARIAL_CERTIFICATION_DATE: 'law.civil_law_notarial_certification_date',
    LAW_CIVIL_LAW_PAYMENT_DUE_DATE: 'law.civil_law_payment_due_date',
    LAW_CIVIL_LAW_PURCHASE_AGREEMENT: 'law.civil_law_purchase_agreement',
    LAW_CIVIL_LAW_PURCHASE_CONTRACT_FILE_REFERENCE: 'law.civil_law_purchase_contract_file_reference',
    LAW_CIVIL_LAW_PURCHASE_DATE: 'law.civil_law_purchase_date',
    LAW_CIVIL_LAW_PURCHASE_OBJECT: 'law.civil_law_purchase_object',
    LAW_CIVIL_LAW_PURCHASE_PRICE_COMPONENTS: 'law.civil_law_purchase_price_components',
    LAW_CIVIL_LAW_PURCHASE_PRICE: 'law.civil_law_purchase_price',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_AMOUNT: 'law.civil_law_purchase_price_paid_amount',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_BOOLEAN: 'law.civil_law_purchase_price_paid_boolean',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_DATE: 'law.civil_law_purchase_price_paid_date',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID: 'law.civil_law_purchase_price_paid',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAYMENT_DATE: 'law.civil_law_purchase_price_payment_date',
    LAW_CIVIL_LAW_SUBJECT_LINE: 'law.civil_law_subject_line',
    LAW_CIVIL_LAW_TERMINATION_NOTICE_PERIOD: 'law.civil_law_termination_notice_period',
    LAW_CIVIL_LAW_VEHICLE_MAKE: 'law.civil_law_vehicle_make',
    LAW_CIVIL_LAW_VEHICLE_MILEAGE: 'law.civil_law_vehicle_mileage',
    LAW_CIVIL_LAW_VEHICLE_MODEL: 'law.civil_law_vehicle_model',
    LAW_CIVIL_LAW_VEHICLE_VIN: 'law.civil_law_vehicle_vin',
    LAW_CIVIL_LAW_VEHICLE_YEAR: 'law.civil_law_vehicle_year',
    LAW_CIVIL_LAW_WARRANTY_PERIOD: 'law.civil_law_warranty_period',
    LAW_CRIMINAL_LAW_AMOUNT_OF_DAILY_RATES: 'law.criminal_law_amount_of_daily_rates',
    LAW_CRIMINAL_LAW_APPLICABLE_LAWS: 'law.criminal_law_applicable_laws',
    LAW_CRIMINAL_LAW_CHARGE_DESCRIPTION: 'law.criminal_law_charge_description',
    LAW_CRIMINAL_LAW_COMPLAINT: 'law.criminal_law_complaint',
    LAW_CRIMINAL_LAW_CRIMINAL_WARRANT: 'law.criminal_law_criminal_warrant',
    LAW_CRIMINAL_LAW_DAMAGE_DESCRIPTION: 'law.criminal_law_damage_description',
    LAW_CRIMINAL_LAW_DAMAGE_VALUE: 'law.criminal_law_damage_value',
    LAW_CRIMINAL_LAW_DATE_OF_OFFENSE: 'law.criminal_law_date_of_offense',
    LAW_CRIMINAL_LAW_DURATION_OF_PRISON_SENTENCE: 'law.criminal_law_duration_of_prison_sentence',
    LAW_CRIMINAL_LAW_EVIDENCE_LOCATION: 'law.criminal_law_evidence_location',
    LAW_CRIMINAL_LAW_EVIDENCE: 'law.criminal_law_evidence',
    LAW_CRIMINAL_LAW_INCIDENT_DESCRIPTION: 'law.criminal_law_incident_description',
    LAW_CRIMINAL_LAW_INDICTMENT_DATE: 'law.criminal_law_indictment_date',
    LAW_CRIMINAL_LAW_INDICTMENT_DELIVERY_DATE: 'law.criminal_law_indictment_delivery_date',
    LAW_CRIMINAL_LAW_INDICTMENT: 'law.criminal_law_indictment',
    LAW_CRIMINAL_LAW_LEGAL_CLASSIFICATION_OF_OFFENSE: 'law.criminal_law_legal_classification_of_offense',
    LAW_CRIMINAL_LAW_MEANS_OF_EVIDENCE: 'law.criminal_law_means_of_evidence',
    LAW_CRIMINAL_LAW_NUMBER_OF_DAILY_RATES: 'law.criminal_law_number_of_daily_rates',
    LAW_CRIMINAL_LAW_OFFENSE_TYPE: 'law.criminal_law_offense_type',
    LAW_CRIMINAL_LAW_PENALTY_INFROMATION: 'law.criminal_law_penalty_infromation',
    LAW_CRIMINAL_LAW_PHYSICAL_EVIDENCE: 'law.criminal_law_physical_evidence',
    LAW_CRIMINAL_LAW_PLACE_OF_OFFENSE: 'law.criminal_law_place_of_offense',
    LAW_CRIMINAL_LAW_POLICE_FILE_NUMBER: 'law.criminal_law_police_file_number',
    LAW_CRIMINAL_LAW_PRELIMINARY_PROCEEDINGS_DATE: 'law.criminal_law_preliminary_proceedings_date',
    LAW_CRIMINAL_LAW_PRISON_SENTENCE: 'law.criminal_law_prison_sentence',
    LAW_CRIMINAL_LAW_PROBATION: 'law.criminal_law_probation',
    LAW_CRIMINAL_LAW_PROSECUTION_FILE_NUMBER: 'law.criminal_law_prosecution_file_number',
    LAW_CRIMINAL_LAW_REPORT_DATE: 'law.criminal_law_report_date',
    LAW_CRIMINAL_LAW_REPORT_TIME: 'law.criminal_law_report_time',
    LAW_CRIMINAL_LAW_TIME_OF_OFFENSE: 'law.criminal_law_time_of_offense',
    LAW_DEBT_COLLECTION_LAW_BUSINESS_FEE: 'law.debt_collection_law_business_fee',
    LAW_DEBT_COLLECTION_LAW_CASE_VALUE: 'law.debt_collection_law_case_value',
    LAW_DEBT_COLLECTION_LAW_INVOICE_AMOUNT: 'law.debt_collection_law_invoice_amount',
    LAW_DEBT_COLLECTION_LAW_INVOICE_DATE: 'law.debt_collection_law_invoice_date',
    LAW_DEBT_COLLECTION_LAW_INVOICE_GROUND: 'law.debt_collection_law_invoice_ground',
    LAW_DEBT_COLLECTION_LAW_INVOICE_LAWYER: 'law.debt_collection_law_invoice_lawyer',
    LAW_DEBT_COLLECTION_LAW_INVOICE: 'law.debt_collection_law_invoice',
    LAW_DEBT_COLLECTION_LAW_INVOICE_NUMBER: 'law.debt_collection_law_invoice_number',
    LAW_DEBT_COLLECTION_LAW_INVOICE_RECIPIENT: 'law.debt_collection_law_invoice_recipient',
    LAW_DEBT_COLLECTION_LAW_INVOICE_TAX_NUMBER: 'law.debt_collection_law_invoice_tax_number',
    LAW_DEBT_COLLECTION_LAW_LUMPS_SUM_EXPENSES: 'law.debt_collection_law_lumps_sum_expenses',
    LAW_DEBT_COLLECTION_LAW_SALES_TAX: 'law.debt_collection_law_sales_tax',
    LAW_DEBT_COLLECTION_LAW_SUBTOTAL_LAWYER_FEES: 'law.debt_collection_law_subtotal_lawyer_fees',
    LAW_DEBT_COLLECTION_LAW_TOTAL_AMOUNT: 'law.debt_collection_law_total_amount',
    LAW_EXTERNAL_CASE_ID: 'law.external_case_id',
    LAW_FAMILY_LAW_AVERAGE_NET_INCOME: 'law.family_law_average_net_income',
    LAW_FAMILY_LAW_BIRTH_CERTIFICATE: 'law.family_law_birth_certificate',
    LAW_FAMILY_LAW_BIRTH_REGISTER_NUMBER: 'law.family_law_birth_register_number',
    LAW_FAMILY_LAW_BIRTH_REGISTER_OFFICE_LOCATION: 'law.family_law_birth_register_office_location',
    LAW_FAMILY_LAW_CHILDREN: 'law.family_law_children',
    LAW_FAMILY_LAW_DATE_OF_MARRIAGE: 'law.family_law_date_of_marriage',
    LAW_FAMILY_LAW_DIVORCE_APPLICATION: 'law.family_law_divorce_application',
    LAW_FAMILY_LAW_DIVORCE_SETTLEMENT_AGREEMENT: 'law.family_law_divorce_settlement_agreement',
    LAW_FAMILY_LAW_MARRIAGE_CERTIFICATE: 'law.family_law_marriage_certificate',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT_DATE: 'law.family_law_marriage_contract_date',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT: 'law.family_law_marriage_contract',
    LAW_FAMILY_LAW_MARRIAGE_REGISTER_NUMBER: 'law.family_law_marriage_register_number',
    LAW_FAMILY_LAW_REGISTRY_OFFICE_LOCATION: 'law.family_law_registry_office_location',
    LAW_FAMILY_LAW_SEPARATION_DATE: 'law.family_law_separation_date',
    LAW_FIELD: 'law.field',
    LAW_GENERAL_LAW_AMOUNT_NET: 'law.general_law_amount_net',
    LAW_GENERAL_LAW_AMOUNT_TOTAL: 'law.general_law_amount_total',
    LAW_GENERAL_LAW_APPENDICES: 'law.general_law_appendices',
    LAW_GENERAL_LAW_CASE_NUMBER: 'law.general_law_case_number',
    LAW_GENERAL_LAW_COURT_COSTS: 'law.general_law_court_costs',
    LAW_GENERAL_LAW_COURT_NAME: 'law.general_law_court_name',
    LAW_GENERAL_LAW_DOC_DATE: 'law.general_law_doc_date',
    LAW_GENERAL_LAW_DUE_DATE: 'law.general_law_due_date',
    LAW_GENERAL_LAW_FILE_REF: 'law.general_law_file_ref',
    LAW_GENERAL_LAW_HEARING_DATE: 'law.general_law_hearing_date',
    LAW_GENERAL_LAW_INVOICE_DATE: 'law.general_law_invoice_date',
    LAW_GENERAL_LAW_INVOICE_NUMBER: 'law.general_law_invoice_number',
    LAW_GENERAL_LAW_JUDGMENT_DATE: 'law.general_law_judgment_date',
    LAW_GENERAL_LAW_CORRESPONDENCE: 'law.general_law_correspondence',
    LAW_GENERAL_LAW_COURT_DOCUMENT: 'law.general_law_court_document',
    LAW_GENERAL_LAW_INVOICE: 'law.general_law_invoice',
    LAW_GENERAL_LAW_PAYMENT_TERMS: 'law.general_law_payment_terms',
    LAW_GENERAL_LAW_PRIOR_REF: 'law.general_law_prior_ref',
    LAW_GENERAL_LAW_SUBJECT: 'law.general_law_subject',
    LAW_GENERAL_LAW_VAT: 'law.general_law_vat',
    LAW_GENERIC_DOCUMENT: 'law.generic_document',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_APPLICABLE_LAW: 'law.inheritance_law_certificate_of_inheritance_applicable_law',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE_DEATH: 'law.inheritance_law_certificate_of_inheritance_date_death',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE: 'law.inheritance_law_certificate_of_inheritance_date',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE: 'law.inheritance_law_certificate_of_inheritance',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_NUMBER: 'law.inheritance_law_certificate_of_inheritance_number',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_PLACE_OF_DEATH: 'law.inheritance_law_certificate_of_inheritance_place_of_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE_DEATH: 'law.inheritance_law_death_certificate_date_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE: 'law.inheritance_law_death_certificate_date',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE: 'law.inheritance_law_death_certificate',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_NUMBER: 'law.inheritance_law_death_certificate_number',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE_DEATH: 'law.inheritance_law_death_certificate_place_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE: 'law.inheritance_law_death_certificate_place',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_TIME_DEATH: 'law.inheritance_law_death_certificate_time_death',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_AMOUNT: 'law.inheritance_law_estate_inventory_amount',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_DATE: 'law.inheritance_law_estate_inventory_date',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_STATUS: 'law.inheritance_law_estate_inventory_status',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT_DATE: 'law.inheritance_law_inheritance_contract_date',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT: 'law.inheritance_law_inheritance_contract',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY_DATE: 'law.inheritance_law_lasting_power_of_attorney_date',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY: 'law.inheritance_law_lasting_power_of_attorney',
    LAW_INHERITANCE_LAW_LIST_OF_ESTATE: 'law.inheritance_law_list_of_estate',
    LAW_INHERITANCE_LAW_LIVING_WILL: 'law.inheritance_law_living_will',
    LAW_INHERITANCE_LAW_PATIENT_ENROLLMENT_DATE: 'law.inheritance_law_patient_enrollment_date',
    LAW_INHERITANCE_LAW_TESTAMENT_DATE: 'law.inheritance_law_testament_date',
    LAW_INHERITANCE_LAW_WILL: 'law.inheritance_law_will',
    LAW_LABOR_LAW_AMOUNT_DEPENDENT_CHILDREN: 'law.labor_law_amount_dependent_children',
    LAW_LABOR_LAW_BEGINNING_OF_EMPLOYMENT: 'law.labor_law_beginning_of_employment',
    LAW_LABOR_LAW_CERTIFICATE_CLAUSE: 'law.labor_law_certificate_clause',
    LAW_LABOR_LAW_CHILD_ALLOWANCES: 'law.labor_law_child_allowances',
    LAW_LABOR_LAW_COLLECTIVE_AGREEMENT: 'law.labor_law_collective_agreement',
    LAW_LABOR_LAW_COMPANY_AGREEMENT: 'law.labor_law_company_agreement',
    LAW_LABOR_LAW_COMPANY_HEARING: 'law.labor_law_company_hearing',
    LAW_LABOR_LAW_DEPENDENT_CHILDREN: 'law.labor_law_dependent_children',
    LAW_LABOR_LAW_DIFFERENT_PLACE_OF_WORK: 'law.labor_law_different_place_of_work',
    LAW_LABOR_LAW_DISABILITY: 'law.labor_law_disability',
    LAW_LABOR_LAW_EMPLOYEE_PROBATION_PERIOD_END_DATE: 'law.labor_law_employee_probation_period_end_date',
    LAW_LABOR_LAW_END_OF_EMPLOYMENT: 'law.labor_law_end_of_employment',
    LAW_LABOR_LAW_EXEMPTION_IRREVOCABLE: 'law.labor_law_exemption_irrevocable',
    LAW_LABOR_LAW_EXEMPTION_REVOCABLE: 'law.labor_law_exemption_revocable',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT_DURATION: 'law.labor_law_fixed_term_contract_duration',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT: 'law.labor_law_fixed_term_contract',
    LAW_LABOR_LAW_GRADE_CERTIFICATE_CLAUSE: 'law.labor_law_grade_certificate_clause',
    LAW_LABOR_LAW_IS_EMPLOYEE_IN_PROBATION_PERIOD: 'law.labor_law_is_employee_in_probation_period',
    LAW_LABOR_LAW_JOB_TITLE: 'law.labor_law_job_title',
    LAW_LABOR_LAW_LOCAL_TRANSFER_CLAUSE: 'law.labor_law_local_transfer_clause',
    LAW_LABOR_LAW_LTI: 'law.labor_law_LTI',
    LAW_LABOR_LAW_MARRIED: 'law.labor_law_married',
    LAW_LABOR_LAW_MONTHLY_GROSS_SALARY: 'law.labor_law_monthly_gross_salary',
    LAW_LABOR_LAW_MONTHLY_WORKING_DAYS: 'law.labor_law_monthly_working_days',
    LAW_LABOR_LAW_NOTICE_PERIOD: 'law.labor_law_notice_period',
    LAW_LABOR_LAW_NOTICE_PERIOD_OBSERVED: 'law.labor_law_notice_period_observed',
    LAW_LABOR_LAW_PAYSLIP: 'law.labor_law_payslip',
    LAW_LABOR_LAW_PERCENT_SPRINTER_CLAUSE: 'law.labor_law_percent_sprinter_clause',
    LAW_LABOR_LAW_PLACE_OF_WORK: 'law.labor_law_place_of_work',
    LAW_LABOR_LAW_PREGNANCY: 'law.labor_law_pregnancy',
    LAW_LABOR_LAW_REACTION_COMPANY_HERING: 'law.labor_law_reaction_company_hering',
    LAW_LABOR_LAW_REASON_FOR_TERMINATION_GIVEN: 'law.labor_law_reason_for_termination_given',
    LAW_LABOR_LAW_RETURN_OF_COMPANY_PROPERTY: 'law.labor_law_return_of_company_property',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT_DATE: 'law.labor_law_settlement_agreement_date',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT: 'law.labor_law_settlement_agreement',
    LAW_LABOR_LAW_SEVERANCE_AMOUNT: 'law.labor_law_severance_amount',
    LAW_LABOR_LAW_SIGNATURE_OF_EMPLOYER: 'law.labor_law_signature_of_employer',
    LAW_LABOR_LAW_SPECIAL_DOCUMENTS: 'law.labor_law_special_documents',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS_AMOUNT: 'law.labor_law_special_payments_amount',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS: 'law.labor_law_special_payments',
    LAW_LABOR_LAW_SPECIAL_PERSONAL_CIRCUMSTANCES: 'law.labor_law_special_personal_circumstances',
    LAW_LABOR_LAW_SPECIAL_PROTECTION_AGAINST_DISMISSAL: 'law.labor_law_special_protection_against_dismissal',
    LAW_LABOR_LAW_SPECIAL_SENTENCE: 'law.labor_law_special_sentence',
    LAW_LABOR_LAW_SPRINTER_CLAUSE: 'law.labor_law_sprinter_clause',
    LAW_LABOR_LAW_TERMINATION_ACCESS_TO_TERMINATION_TO_EMPLOYEE: 'law.labor_law_termination_access_to_termination_to_employee',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_DATE: 'law.labor_law_termination_agreement_date',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT: 'law.labor_law_termination_agreement',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_SEVERANCE_PAY_AMOUNT: 'law.labor_law_termination_agreement_severance_pay_amount',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_TERMINATION_DATE: 'law.labor_law_termination_agreement_termination_date',
    LAW_LABOR_LAW_TERMINATION_AUTHORIZATION: 'law.labor_law_termination_authorization',
    LAW_LABOR_LAW_TERMINATION_DATE_EFFECTIVE: 'law.labor_law_termination_date_effective',
    LAW_LABOR_LAW_TERMINATION_DATE: 'law.labor_law_termination_date',
    LAW_LABOR_LAW_TERMINATION_EMPLOYER_MORE_THAN_10_EMPLOYEES: 'law.labor_law_termination_employer_more_than_10_employees',
    LAW_LABOR_LAW_TERMINATION_IS_AGREEMENT_SEVERANCE_PAY: 'law.labor_law_termination_is_agreement_severance_pay',
    LAW_LABOR_LAW_TERMINATION: 'law.labor_law_termination',
    LAW_LABOR_LAW_TERMINATION_OPERATIONAL_REASONS: 'law.labor_law_termination_operational_reasons',
    LAW_LABOR_LAW_TERMINATION_WITHOUT_NOTICE: 'law.labor_law_termination_without_notice',
    LAW_LABOR_LAW_TOTAL_GROSS_SALARY: 'law.labor_law_total_gross_salary',
    LAW_LABOR_LAW_VACATION_DAYS: 'law.labor_law_vacation_days',
    LAW_LABOR_LAW_VISUM: 'law.labor_law_visum',
    LAW_LABOR_LAW_VSOP: 'law.labor_law_VSOP',
    LAW_LABOR_LAW_WARNING_LETTER_ACCESS_TO_WARNING_LETTER_TO_EMPLOYEE: 'law.labor_law_warning_letter_access_to_warning_letter_to_employee',
    LAW_LABOR_LAW_WARNING_LETTER_DATE: 'law.labor_law_warning_letter_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_DATE: 'law.labor_law_warning_letter_incident_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_LOCATION: 'law.labor_law_warning_letter_incident_location',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_TIME: 'law.labor_law_warning_letter_incident_time',
    LAW_LABOR_LAW_WARNING_LETTER: 'law.labor_law_warning_letter',
    LAW_LABOR_LAW_WARNING_LETTER_REASON: 'law.labor_law_warning_letter_reason',
    LAW_LABOR_LAW_WORK_CONTRACT: 'law.labor_law_work_contract',
    LAW_LABOR_LAW_WORK_COUNCIL: 'law.labor_law_work_council',
    LAW_LABOR_LAW_WORK_HOURS_PER_WEEK: 'law.labor_law_work_hours_per_week',
    LAW_LABOR_LAW_WORKS_COUNCIL_MEMBERSHIP: 'law.labor_law_works_council_membership',
    LAW_LABOR_LAW_YEARLY_GROSS_SALARY: 'law.labor_law_yearly_gross_salary',
    LAW_LABOR_LAW_YEARS_OF_EMPLOYMENT: 'law.labor_law_years_of_employment',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DATE: 'law.medicine_law_health_insurance_letter_date',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DECISION_JUSTIFICATION: 'law.medicine_law_health_insurance_letter_decision_justification',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DECISION: 'law.medicine_law_health_insurance_letter_decision',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_LEGAL_REMEDY_INSTRUCTION: 'law.medicine_law_health_insurance_letter_legal_remedy_instruction',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER: 'law.medicine_law_health_insurance_letter',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_REFERENCE_TO_APPLICATION: 'law.medicine_law_health_insurance_letter_reference_to_application',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_ADMISSION_DATE: 'law.medicine_law_hospital_records_admission_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DIAGNOSES_ICD_CODES: 'law.medicine_law_hospital_records_diagnoses_icd_codes',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DISCHARGE_DATE: 'law.medicine_law_hospital_records_discharge_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DISCHARGE_PROGNOSIS: 'law.medicine_law_hospital_records_discharge_prognosis',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DOCUMENTED_COMPLICATIONS: 'law.medicine_law_hospital_records_documented_complications',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS: 'law.medicine_law_hospital_records',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_MEDICATION_DURING_STAY: 'law.medicine_law_hospital_records_medication_during_stay',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_OPERATION_DATE: 'law.medicine_law_hospital_records_operation_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_OPERATIONS: 'law.medicine_law_hospital_records_operations',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_STATION: 'law.medicine_law_hospital_records_station',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_EXAMINATION_DATE: 'law.medicine_law_laboratory_results_examination_date',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_EXAMINATION_TYPE: 'law.medicine_law_laboratory_results_examination_type',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_FURTHER_INVESTIGATION_RECOMMENDATION: 'law.medicine_law_laboratory_results_further_investigation_recommendation',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS: 'law.medicine_law_laboratory_results',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_RELEVANT_DEVIATIONS: 'law.medicine_law_laboratory_results_relevant_deviations',
    LAW_MEDICINE_LAW_MEDICAL_BILL_COST_BEARER: 'law.medicine_law_medical_bill_cost_bearer',
    LAW_MEDICINE_LAW_MEDICAL_BILL_INVOICE_DATE: 'law.medicine_law_medical_bill_invoice_date',
    LAW_MEDICINE_LAW_MEDICAL_BILL_INVOICE_NUMBER: 'law.medicine_law_medical_bill_invoice_number',
    LAW_MEDICINE_LAW_MEDICAL_BILL: 'law.medicine_law_medical_bill',
    LAW_MEDICINE_LAW_MEDICAL_BILL_PAYMENT_DEADLINE: 'law.medicine_law_medical_bill_payment_deadline',
    LAW_MEDICINE_LAW_MEDICAL_BILL_SERVICE_PERIOD: 'law.medicine_law_medical_bill_service_period',
    LAW_MEDICINE_LAW_MEDICAL_BILL_SERVICES_LIST: 'law.medicine_law_medical_bill_services_list',
    LAW_MEDICINE_LAW_MEDICAL_BILL_TOTAL_AMOUNT: 'law.medicine_law_medical_bill_total_amount',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_DATE: 'law.medicine_law_medical_expertise_date',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_JUSTIFICATION: 'law.medicine_law_medical_expertise_justification',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE: 'law.medicine_law_medical_expertise',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_MEDICAL_ASSESSMENT: 'law.medicine_law_medical_expertise_medical_assessment',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_QUESTION_POSED: 'law.medicine_law_medical_expertise_question_posed',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_RESULT: 'law.medicine_law_medical_expertise_result',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_COMPLICATIONS: 'law.medicine_law_medical_report_complications',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DATE: 'law.medicine_law_medical_report_date',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DIAGNOSIS_ICD_CODE: 'law.medicine_law_medical_report_diagnosis_icd_code',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DIAGNOSIS_SHORT_TEXT: 'law.medicine_law_medical_report_diagnosis_short_text',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_FURTHER_TREATMENT: 'law.medicine_law_medical_report_further_treatment',
    LAW_MEDICINE_LAW_MEDICAL_REPORT: 'law.medicine_law_medical_report',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_SURGERY_DATE: 'law.medicine_law_medical_report_surgery_date',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_TREATMENT_MEASURES: 'law.medicine_law_medical_report_treatment_measures',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_TREATMENT_PERIOD: 'law.medicine_law_medical_report_treatment_period',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_CASE_NUMBER: 'law.migration_law_approval_notice_case_number',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_CONDITIONS: 'law.migration_law_approval_notice_conditions',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_DECISION_DATE: 'law.migration_law_approval_notice_decision_date',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_ISSUING_AUTHORITY: 'law.migration_law_approval_notice_issuing_authority',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE: 'law.migration_law_approval_notice',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_PERMIT_TYPE: 'law.migration_law_approval_notice_permit_type',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_PICKUP_DEADLINE: 'law.migration_law_approval_notice_pickup_deadline',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_VALIDITY_PERIOD: 'law.migration_law_approval_notice_validity_period',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_APPLICATION_NUMBER: 'law.migration_law_asylum_seeker_certificate_application_number',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_FIRST_REGISTRATION_DATE: 'law.migration_law_asylum_seeker_certificate_first_registration_date',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_ISSUE_DATE: 'law.migration_law_asylum_seeker_certificate_issue_date',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_ISSUING_AUTHORITY: 'law.migration_law_asylum_seeker_certificate_issuing_authority',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE: 'law.migration_law_asylum_seeker_certificate',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_RESIDENCE_OBLIGATION: 'law.migration_law_asylum_seeker_certificate_residence_obligation',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_VALID_UNTIL: 'law.migration_law_asylum_seeker_certificate_valid_until',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_WORK_PERMISSION: 'law.migration_law_asylum_seeker_certificate_work_permission',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_ATTACHMENTS: 'law.migration_law_cooperation_letter_attachments',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_DATE: 'law.migration_law_cooperation_letter_date',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_DEADLINES: 'law.migration_law_cooperation_letter_deadlines',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_FILE_NUMBER: 'law.migration_law_cooperation_letter_file_number',
    LAW_MIGRATION_LAW_COOPERATION_LETTER: 'law.migration_law_cooperation_letter',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_NON_COOPERATION_CONSEQUENCES: 'law.migration_law_cooperation_letter_non_cooperation_consequences',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_SPECIFIED_OBLIGATIONS: 'law.migration_law_cooperation_letter_specified_obligations',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_AUTHORITY: 'law.migration_law_fictional_certificate_authority',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_FICTION_TYPE: 'law.migration_law_fictional_certificate_fiction_type',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_ISSUE_DATE: 'law.migration_law_fictional_certificate_issue_date',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_LEGAL_BASIS: 'law.migration_law_fictional_certificate_legal_basis',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE: 'law.migration_law_fictional_certificate',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_REASON_FOR_ISSUANCE: 'law.migration_law_fictional_certificate_reason_for_issuance',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_VALID_UNTIL: 'law.migration_law_fictional_certificate_valid_until',
    LAW_MIGRATION_LAW_HEARING_LETTER_DATE: 'law.migration_law_hearing_letter_date',
    LAW_MIGRATION_LAW_HEARING_LETTER_INTENDED_MEASURE_JUSTIFICATION: 'law.migration_law_hearing_letter_intended_measure_justification',
    LAW_MIGRATION_LAW_HEARING_LETTER_LEGAL_ADVICE: 'law.migration_law_hearing_letter_legal_advice',
    LAW_MIGRATION_LAW_HEARING_LETTER: 'law.migration_law_hearing_letter',
    LAW_MIGRATION_LAW_HEARING_LETTER_REQUESTED_DOCUMENTS: 'law.migration_law_hearing_letter_requested_documents',
    LAW_MIGRATION_LAW_HEARING_LETTER_RESPONSE_DEADLINE: 'law.migration_law_hearing_letter_response_deadline',
    LAW_MIGRATION_LAW_OTHER_LETTERS_ACTION_REQUIRED: 'law.migration_law_other_letters_action_required',
    LAW_MIGRATION_LAW_OTHER_LETTERS_DATE: 'law.migration_law_other_letters_date',
    LAW_MIGRATION_LAW_OTHER_LETTERS_DEADLINES: 'law.migration_law_other_letters_deadlines',
    LAW_MIGRATION_LAW_OTHER_LETTERS_FILE_NUMBER: 'law.migration_law_other_letters_file_number',
    LAW_MIGRATION_LAW_OTHER_LETTERS_ISSUING_AUTHORITY: 'law.migration_law_other_letters_issuing_authority',
    LAW_MIGRATION_LAW_OTHER_LETTERS_LEGAL_BASIS: 'law.migration_law_other_letters_legal_basis',
    LAW_MIGRATION_LAW_OTHER_LETTERS: 'law.migration_law_other_letters',
    LAW_MIGRATION_LAW_OTHER_LETTERS_MATTER_PURPOSE: 'law.migration_law_other_letters_matter_purpose',
    LAW_MIGRATION_LAW_OTHER_LETTERS_SUBJECT: 'law.migration_law_other_letters_subject',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_CASE_NUMBER: 'law.migration_law_rejection_notice_case_number',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_DECISION_DATE: 'law.migration_law_rejection_notice_decision_date',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_LEGAL_GROUNDS: 'law.migration_law_rejection_notice_legal_grounds',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_LEGAL_REMEDY_DEADLINE: 'law.migration_law_rejection_notice_legal_remedy_deadline',
    LAW_MIGRATION_LAW_REJECTION_NOTICE: 'law.migration_law_rejection_notice',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_OFFICER_NAME: 'law.migration_law_rejection_notice_officer_name',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_REASONING: 'law.migration_law_rejection_notice_reasoning',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_SIGNATURE_SEAL: 'law.migration_law_rejection_notice_signature_seal',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_SUBJECT: 'law.migration_law_rejection_notice_subject',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_CONDITIONS: 'law.migration_law_residence_permit_conditions',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_ISSUE_DATE: 'law.migration_law_residence_permit_issue_date',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_ISSUING_AUTHORITY: 'law.migration_law_residence_permit_issuing_authority',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT: 'law.migration_law_residence_permit',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_NATIONAL_ID_NUMBER: 'law.migration_law_residence_permit_national_id_number',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_PASSPORT_NUMBER: 'law.migration_law_residence_permit_passport_number',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_PURPOSE: 'law.migration_law_residence_permit_purpose',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_TYPE: 'law.migration_law_residence_permit_type',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_VALID_UNTIL: 'law.migration_law_residence_permit_valid_until',
    LAW_MIGRATION_LAW_TOLERATION_ISSUE_DATE: 'law.migration_law_toleration_issue_date',
    LAW_MIGRATION_LAW_TOLERATION_ISSUING_AUTHORITY: 'law.migration_law_toleration_issuing_authority',
    LAW_MIGRATION_LAW_TOLERATION_LEGAL_BASIS: 'law.migration_law_toleration_legal_basis',
    LAW_MIGRATION_LAW_TOLERATION: 'law.migration_law_toleration',
    LAW_MIGRATION_LAW_TOLERATION_REASON: 'law.migration_law_toleration_reason',
    LAW_MIGRATION_LAW_TOLERATION_RESTRICTIONS: 'law.migration_law_toleration_restrictions',
    LAW_MIGRATION_LAW_TOLERATION_VALID_UNTIL: 'law.migration_law_toleration_valid_until',
    LAW_REAL_ESTATE_LAW_BASIC_DEBTS_AMOUNT: 'law.real_estate_law_basic_debts_amount',
    LAW_REAL_ESTATE_LAW_BROKER_COMMISSION_AMOUNT: 'law.real_estate_law_broker_commission_amount',
    LAW_REAL_ESTATE_LAW_BROKER_CONTRACT_TYPE: 'law.real_estate_law_broker_contract_type',
    LAW_REAL_ESTATE_LAW_BROKER_SCOPE_OF_WORK: 'law.real_estate_law_broker_scope_of_work',
    LAW_REAL_ESTATE_LAW_BROKER_TERMINATION_PERIODS: 'law.real_estate_law_broker_termination_periods',
    LAW_REAL_ESTATE_LAW_BROKERAGE_CONTRACT_DATE: 'law.real_estate_law_brokerage_contract_date',
    LAW_REAL_ESTATE_LAW_BROKERAGE_CONTRACT: 'law.real_estate_law_brokerage_contract',
    LAW_REAL_ESTATE_LAW_BROKERAGE_FEE: 'law.real_estate_law_brokerage_fee',
    LAW_REAL_ESTATE_LAW_BUILDING_DIMENSIONS: 'law.real_estate_law_building_dimensions',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_DATE: 'law.real_estate_law_building_permit_date',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT: 'law.real_estate_law_building_permit',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_NUMBER: 'law.real_estate_law_building_permit_number',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_VALIDITY_DURATION: 'law.real_estate_law_building_permit_validity_duration',
    LAW_REAL_ESTATE_LAW_BUILDING_PLAN: 'law.real_estate_law_building_plan',
    LAW_REAL_ESTATE_LAW_BUILDING_RESTRICTIONS_CLAUSE: 'law.real_estate_law_building_restrictions_clause',
    LAW_REAL_ESTATE_LAW_BUILDING_USAGE: 'law.real_estate_law_building_usage',
    LAW_REAL_ESTATE_LAW_CO_OWNERSHIP_SHARE: 'law.real_estate_law_co_ownership_share',
    LAW_REAL_ESTATE_LAW_COMMISSION_PERCENTAGE: 'law.real_estate_law_commission_percentage',
    LAW_REAL_ESTATE_LAW_CONTAMINATED_SITES_CLAUSE: 'law.real_estate_law_contaminated_sites_clause',
    LAW_REAL_ESTATE_LAW_DECLARATION_OF_DIVISION: 'law.real_estate_law_declaration_of_division',
    LAW_REAL_ESTATE_LAW_DIVISION_DECLARATION_DATE: 'law.real_estate_law_division_declaration_date',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCE_RESTRICTIONS: 'law.real_estate_law_encumbrance_restrictions',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCES_SECTION_II: 'law.real_estate_law_encumbrances_section_ii',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCES_SECTION_III: 'law.real_estate_law_encumbrances_section_iii',
    LAW_REAL_ESTATE_LAW_EXCLUSIVE_BROKERAGE_CONTRACT: 'law.real_estate_law_exclusive_brokerage_contract',
    LAW_REAL_ESTATE_LAW_FULL_REPAYMENT_DATE: 'law.real_estate_law_full_repayment_date',
    LAW_REAL_ESTATE_LAW_INSTALLMENT_AMOUNT: 'law.real_estate_law_installment_amount',
    LAW_REAL_ESTATE_LAW_INTEREST_RATE: 'law.real_estate_law_interest_rate',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_ADDRESS: 'law.real_estate_law_land_register_address',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_CITY: 'law.real_estate_law_land_register_city',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_DATE: 'law.real_estate_law_land_register_date',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER: 'law.real_estate_law_land_register',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_NUMBER: 'law.real_estate_law_land_register_number',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.real_estate_law_land_register_plot_of_land',
    LAW_REAL_ESTATE_LAW_LEGAL_DEFECTS_CLAUSE: 'law.real_estate_law_legal_defects_clause',
    LAW_REAL_ESTATE_LAW_LOAN_AGREEMENT: 'law.real_estate_law_loan_agreement',
    LAW_REAL_ESTATE_LAW_LOAN_AMOUNT: 'law.real_estate_law_loan_amount',
    LAW_REAL_ESTATE_LAW_LOAN_SECURITY: 'law.real_estate_law_loan_security',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_BASIS: 'law.real_estate_law_monument_protection_basis',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_NOTICE: 'law.real_estate_law_monument_protection_notice',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_ORDER_DATE: 'law.real_estate_law_monument_protection_order_date',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_ORDER_NUMBER: 'law.real_estate_law_monument_protection_order_number',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_REQUIREMENTS: 'law.real_estate_law_monument_protection_requirements',
    LAW_REAL_ESTATE_LAW_MONUMENT_REGISTRATION_DATE: 'law.real_estate_law_monument_registration_date',
    LAW_REAL_ESTATE_LAW_PLAN_AUTHOR: 'law.real_estate_law_plan_author',
    LAW_REAL_ESTATE_LAW_PLAN_DESIGNATION: 'law.real_estate_law_plan_designation',
    LAW_REAL_ESTATE_LAW_PLAN_SCALE: 'law.real_estate_law_plan_scale',
    LAW_REAL_ESTATE_LAW_PLOT_SIZE: 'law.real_estate_law_plot_size',
    LAW_REAL_ESTATE_LAW_PROPERTY_BROKERED_BY_AGENT: 'law.real_estate_law_property_brokered_by_agent',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_AMOUNT: 'law.real_estate_law_purchase_contract_amount',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DATE: 'law.real_estate_law_purchase_contract_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DESCRIPTION: 'law.real_estate_law_purchase_contract_description',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT: 'law.real_estate_law_purchase_contract',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_DATE: 'law.real_estate_law_purchase_contract_registration_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_NUMBER: 'law.real_estate_law_purchase_contract_registration_number',
    LAW_REAL_ESTATE_LAW_PURCHASE_OBJECT_RENTED: 'law.real_estate_law_purchase_object_rented',
    LAW_REAL_ESTATE_LAW_PURCHASE_PRICE_LOAN_FINANCED: 'law.real_estate_law_purchase_price_loan_financed',
    LAW_REAL_ESTATE_LAW_REPAYMENT_RATE: 'law.real_estate_law_repayment_rate',
    LAW_REAL_ESTATE_LAW_WITHDRAWAL_INSTRUCTION_DATE: 'law.real_estate_law_withdrawal_instruction_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CO_OWNERSHIP_SHARES: 'law.residential_property_law_co_ownership_shares',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT_DATE: 'law.residential_property_law_contract_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT: 'law.residential_property_law_contract',
    LAW_RESIDENTIAL_PROPERTY_LAW_INVENTORY: 'law.residential_property_law_inventory',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_ADDRESS: 'law.residential_property_law_land_register_address',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_CITY: 'law.residential_property_law_land_register_city',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_NUMBER: 'law.residential_property_law_land_register_number',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.residential_property_law_land_register_plot_of_land',
    LAW_SOCIAL_LAW_AFFECTED_BENEFIT: 'law.social_law_affected_benefit',
    LAW_SOCIAL_LAW_APPLICATION_ARRIVAL_DATE: 'law.social_law_application_arrival_date',
    LAW_SOCIAL_LAW_APPLICATION_DATE: 'law.social_law_application_date',
    LAW_SOCIAL_LAW_APPLICATION_FILE_REFERENCE: 'law.social_law_application_file_reference',
    LAW_SOCIAL_LAW_APPLICATION_FORM: 'law.social_law_application_form',
    LAW_SOCIAL_LAW_APPOINTMENT_DATE: 'law.social_law_appointment_date',
    LAW_SOCIAL_LAW_APPOINTMENT_FILE_REFERENCE: 'law.social_law_appointment_file_reference',
    LAW_SOCIAL_LAW_APPOINTMENT_INVITATION: 'law.social_law_appointment_invitation',
    LAW_SOCIAL_LAW_APPOINTMENT_PURPOSE: 'law.social_law_appointment_purpose',
    LAW_SOCIAL_LAW_APPOINTMENT_REQUIRED_DOCUMENTS: 'law.social_law_appointment_required_documents',
    LAW_SOCIAL_LAW_APPOINTMENT_TIME: 'law.social_law_appointment_time',
    LAW_SOCIAL_LAW_APPROVAL_FILE_REFERENCE: 'law.social_law_approval_file_reference',
    LAW_SOCIAL_LAW_APPROVAL_INTERNAL_REFERENCE: 'law.social_law_approval_internal_reference',
    LAW_SOCIAL_LAW_APPROVAL_LEGAL_BASIS: 'law.social_law_approval_legal_basis',
    LAW_SOCIAL_LAW_APPROVAL_NOTICE_DATE: 'law.social_law_approval_notice_date',
    LAW_SOCIAL_LAW_APPROVAL_NOTICE: 'law.social_law_approval_notice',
    LAW_SOCIAL_LAW_APPROVAL_PERIOD_END: 'law.social_law_approval_period_end',
    LAW_SOCIAL_LAW_APPROVAL_PERIOD_START: 'law.social_law_approval_period_start',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_AMOUNT: 'law.social_law_approved_benefit_amount',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_PERIOD: 'law.social_law_approved_benefit_period',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_TYPE: 'law.social_law_approved_benefit_type',
    LAW_SOCIAL_LAW_ASSET_TYPE: 'law.social_law_asset_type',
    LAW_SOCIAL_LAW_ATTACHMENT_LIST: 'law.social_law_attachment_list',
    LAW_SOCIAL_LAW_BENEFIT_TYPE: 'law.social_law_benefit_type',
    LAW_SOCIAL_LAW_CHANGE_DESCRIPTION: 'law.social_law_change_description',
    LAW_SOCIAL_LAW_CHANGE_FILE_REFERENCE: 'law.social_law_change_file_reference',
    LAW_SOCIAL_LAW_CHANGE_NOTIFICATION_DATE: 'law.social_law_change_notification_date',
    LAW_SOCIAL_LAW_CHANGE_NOTIFICATION: 'law.social_law_change_notification',
    LAW_SOCIAL_LAW_CHANGE_REASON: 'law.social_law_change_reason',
    LAW_SOCIAL_LAW_CREDITABLE_INCOME: 'law.social_law_creditable_income',
    LAW_SOCIAL_LAW_DISABILITY_CARD_ISSUE_DATE: 'law.social_law_disability_card_issue_date',
    LAW_SOCIAL_LAW_DISABILITY_CARD: 'law.social_law_disability_card',
    LAW_SOCIAL_LAW_DISABILITY_CARD_MARKERS: 'law.social_law_disability_card_markers',
    LAW_SOCIAL_LAW_DISABILITY_CARD_VALIDITY_PERIOD: 'law.social_law_disability_card_validity_period',
    LAW_SOCIAL_LAW_DISABILITY_DEGREE: 'law.social_law_disability_degree',
    LAW_SOCIAL_LAW_DISABILITY_FILE_REFERENCE: 'law.social_law_disability_file_reference',
    LAW_SOCIAL_LAW_EMPLOYMENT_INCOME: 'law.social_law_employment_income',
    LAW_SOCIAL_LAW_FOLLOW_UP_APPLICATION_NOTES: 'law.social_law_follow_up_application_notes',
    LAW_SOCIAL_LAW_HEARING_FILE_REFERENCE: 'law.social_law_hearing_file_reference',
    LAW_SOCIAL_LAW_HEARING_LETTER_DATE: 'law.social_law_hearing_letter_date',
    LAW_SOCIAL_LAW_HEARING_LETTER: 'law.social_law_hearing_letter',
    LAW_SOCIAL_LAW_HEARING_PLANNED_ADMINISTRATIVE_ACT: 'law.social_law_hearing_planned_administrative_act',
    LAW_SOCIAL_LAW_HOUSING_COSTS_AMOUNT: 'law.social_law_housing_costs_amount',
    LAW_SOCIAL_LAW_INCOME_AMOUNT: 'law.social_law_income_amount',
    LAW_SOCIAL_LAW_INCOME_DATE: 'law.social_law_income_date',
    LAW_SOCIAL_LAW_INCOME_LEGAL_BASIS: 'law.social_law_income_legal_basis',
    LAW_SOCIAL_LAW_INCOME_PROVIDER: 'law.social_law_income_provider',
    LAW_SOCIAL_LAW_INCOME_SOURCE: 'law.social_law_income_source',
    LAW_SOCIAL_LAW_INCOME_TYPE: 'law.social_law_income_type',
    LAW_SOCIAL_LAW_INTERIM_LEGAL_PROTECTION: 'law.social_law_interim_legal_protection',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_AFFIDAVIT: 'law.social_law_interim_protection_affidavit',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_ATTACHMENT_LIST: 'law.social_law_interim_protection_attachment_list',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_FILE_REFERENCE: 'law.social_law_interim_protection_file_reference',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_REQUEST_DATE: 'law.social_law_interim_protection_request_date',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_REQUEST_TEXT: 'law.social_law_interim_protection_request_text',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_URGENCY_REASON: 'law.social_law_interim_protection_urgency_reason',
    LAW_SOCIAL_LAW_LAWSUIT_ALTERNATIVE_REQUEST: 'law.social_law_lawsuit_alternative_request',
    LAW_SOCIAL_LAW_LAWSUIT_ATTACHMENT_LIST: 'law.social_law_lawsuit_attachment_list',
    LAW_SOCIAL_LAW_LAWSUIT_COST_REQUEST: 'law.social_law_lawsuit_cost_request',
    LAW_SOCIAL_LAW_LAWSUIT_COURT_FILE_NUMBER: 'law.social_law_lawsuit_court_file_number',
    LAW_SOCIAL_LAW_LAWSUIT_DELIVERY_DATE: 'law.social_law_lawsuit_delivery_date',
    LAW_SOCIAL_LAW_LAWSUIT_DISPUTE_VALUE: 'law.social_law_lawsuit_dispute_value',
    LAW_SOCIAL_LAW_LAWSUIT_DISPUTED_AMOUNT: 'law.social_law_lawsuit_disputed_amount',
    LAW_SOCIAL_LAW_LAWSUIT_EVIDENCE_REQUESTS: 'law.social_law_lawsuit_evidence_requests',
    LAW_SOCIAL_LAW_LAWSUIT_FILE_REFERENCE: 'law.social_law_lawsuit_file_reference',
    LAW_SOCIAL_LAW_LAWSUIT_FILING_DATE: 'law.social_law_lawsuit_filing_date',
    LAW_SOCIAL_LAW_LAWSUIT_INCOME_AMOUNT: 'law.social_law_lawsuit_income_amount',
    LAW_SOCIAL_LAW_LAWSUIT_LEGAL_BASIS: 'law.social_law_lawsuit_legal_basis',
    LAW_SOCIAL_LAW_LAWSUIT_MAIN_REQUEST: 'law.social_law_lawsuit_main_request',
    LAW_SOCIAL_LAW_LAWSUIT: 'law.social_law_lawsuit',
    LAW_SOCIAL_LAW_LAWSUIT_MONTHLY_BENEFIT_AMOUNT: 'law.social_law_lawsuit_monthly_benefit_amount',
    LAW_SOCIAL_LAW_LAWSUIT_OBJECTION_DECISION_DATE: 'law.social_law_lawsuit_objection_decision_date',
    LAW_SOCIAL_LAW_LAWSUIT_OBJECTION_FILING_DATE: 'law.social_law_lawsuit_objection_filing_date',
    LAW_SOCIAL_LAW_LAWSUIT_ORIGINAL_DECISION_DATE: 'law.social_law_lawsuit_original_decision_date',
    LAW_SOCIAL_LAW_LAWSUIT_SUBJECT: 'law.social_law_lawsuit_subject',
    LAW_SOCIAL_LAW_LAWSUIT_TYPE: 'law.social_law_lawsuit_type',
    LAW_SOCIAL_LAW_LEGAL_BASIS: 'law.social_law_legal_basis',
    LAW_SOCIAL_LAW_MEDICAL_CERTIFICATE: 'law.social_law_medical_certificate',
    LAW_SOCIAL_LAW_MEDICAL_DIAGNOSIS: 'law.social_law_medical_diagnosis',
    LAW_SOCIAL_LAW_MEDICAL_EXAMINATION_DATE: 'law.social_law_medical_examination_date',
    LAW_SOCIAL_LAW_MEDICAL_FILE_REFERENCE: 'law.social_law_medical_file_reference',
    LAW_SOCIAL_LAW_MEDICAL_ICD_CODE: 'law.social_law_medical_icd_code',
    LAW_SOCIAL_LAW_MEDICAL_LIMITATIONS: 'law.social_law_medical_limitations',
    LAW_SOCIAL_LAW_MEDICAL_PROGNOSIS: 'law.social_law_medical_prognosis',
    LAW_SOCIAL_LAW_MEDICAL_WORK_CAPACITY_RELATION: 'law.social_law_medical_work_capacity_relation',
    LAW_SOCIAL_LAW_MONTHLY_PAYMENT_AMOUNT: 'law.social_law_monthly_payment_amount',
    LAW_SOCIAL_LAW_NEEDS_COST_BREAKDOWN: 'law.social_law_needs_cost_breakdown',
    LAW_SOCIAL_LAW_NEEDS_FILE_REFERENCE: 'law.social_law_needs_file_reference',
    LAW_SOCIAL_LAW_NEEDS_PROOF_BASIS: 'law.social_law_needs_proof_basis',
    LAW_SOCIAL_LAW_NEEDS_PROOF_DATE: 'law.social_law_needs_proof_date',
    LAW_SOCIAL_LAW_NEEDS_PROOF: 'law.social_law_needs_proof',
    LAW_SOCIAL_LAW_NEEDS_TYPE: 'law.social_law_needs_type',
    LAW_SOCIAL_LAW_NOTICE_DATE: 'law.social_law_notice_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_DATE: 'law.social_law_notice_of_objection_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_FILE_REFERENCE: 'law.social_law_notice_of_objection_file_reference',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION: 'law.social_law_notice_of_objection',
    LAW_SOCIAL_LAW_NOTIFICATION_DATE: 'law.social_law_notification_date',
    LAW_SOCIAL_LAW_NOTIFICATION_LEGAL_BASIS: 'law.social_law_notification_legal_basis',
    LAW_SOCIAL_LAW_NOTIFICATION_SOURCE: 'law.social_law_notification_source',
    LAW_SOCIAL_LAW_OBJECTION_CHALLENGED_NOTICE: 'law.social_law_objection_challenged_notice',
    LAW_SOCIAL_LAW_OBJECTION_DATE: 'law.social_law_objection_date',
    LAW_SOCIAL_LAW_OBJECTION_EVIDENCE: 'law.social_law_objection_evidence',
    LAW_SOCIAL_LAW_OBJECTION_FILE_REFERENCE: 'law.social_law_objection_file_reference',
    LAW_SOCIAL_LAW_OBJECTION: 'law.social_law_objection',
    LAW_SOCIAL_LAW_OBJECTION_REASONING: 'law.social_law_objection_reasoning',
    LAW_SOCIAL_LAW_OBJECTION_SUSPENSION_REQUEST: 'law.social_law_objection_suspension_request',
    LAW_SOCIAL_LAW_ORIGINAL_DECISION_DATE: 'law.social_law_original_decision_date',
    LAW_SOCIAL_LAW_OTHER_INCOME: 'law.social_law_other_income',
    LAW_SOCIAL_LAW_OWN_INCOME_AMOUNT: 'law.social_law_own_income_amount',
    LAW_SOCIAL_LAW_RECLAIM_AMOUNT: 'law.social_law_reclaim_amount',
    LAW_SOCIAL_LAW_RECLAIM_FILE_REFERENCE: 'law.social_law_reclaim_file_reference',
    LAW_SOCIAL_LAW_RECLAIM_LEGAL_BASIS: 'law.social_law_reclaim_legal_basis',
    LAW_SOCIAL_LAW_RECLAIM_LEGAL_NORM: 'law.social_law_reclaim_legal_norm',
    LAW_SOCIAL_LAW_RECLAIM_NOTICE_DATE: 'law.social_law_reclaim_notice_date',
    LAW_SOCIAL_LAW_RECLAIM_NOTICE: 'law.social_law_reclaim_notice',
    LAW_SOCIAL_LAW_RECLAIM_PAYMENT_DEADLINE: 'law.social_law_reclaim_payment_deadline',
    LAW_SOCIAL_LAW_RECLAIM_PAYMENT_TERMS: 'law.social_law_reclaim_payment_terms',
    LAW_SOCIAL_LAW_REGELBEDARF_AMOUNT: 'law.social_law_regelbedarf_amount',
    LAW_SOCIAL_LAW_REJECTION_FILE_REFERENCE: 'law.social_law_rejection_file_reference',
    LAW_SOCIAL_LAW_REJECTION_LEGAL_NORM: 'law.social_law_rejection_legal_norm',
    LAW_SOCIAL_LAW_REJECTION_NOTICE_DATE: 'law.social_law_rejection_notice_date',
    LAW_SOCIAL_LAW_REJECTION_NOTICE: 'law.social_law_rejection_notice',
    LAW_SOCIAL_LAW_REJECTION_REASON: 'law.social_law_rejection_reason',
    LAW_SOCIAL_LAW_RESIDENCE_STATUS: 'law.social_law_residence_status',
    LAW_SOCIAL_LAW_REVOCATION_BENEFIT_TYPE: 'law.social_law_revocation_benefit_type',
    LAW_SOCIAL_LAW_REVOCATION_FILE_REFERENCE: 'law.social_law_revocation_file_reference',
    LAW_SOCIAL_LAW_REVOCATION_LEGAL_NORM: 'law.social_law_revocation_legal_norm',
    LAW_SOCIAL_LAW_REVOCATION_NOTICE_DATE: 'law.social_law_revocation_notice_date',
    LAW_SOCIAL_LAW_REVOCATION_NOTICE: 'law.social_law_revocation_notice',
    LAW_SOCIAL_LAW_REVOCATION_PERIOD_END: 'law.social_law_revocation_period_end',
    LAW_SOCIAL_LAW_REVOCATION_PERIOD_START: 'law.social_law_revocation_period_start',
    LAW_SOCIAL_LAW_REVOCATION_REASON: 'law.social_law_revocation_reason',
    LAW_SOCIAL_LAW_REVOCATION_RECLAIM_NOTES: 'law.social_law_revocation_reclaim_notes',
    LAW_SOCIAL_LAW_SOCIAL_BENEFIT_TYPE: 'law.social_law_social_benefit_type',
    LAW_SOCIAL_LAW_SUMMARY_GROUNDS_OPPOSITION: 'law.social_law_summary_grounds_opposition',
    LAW_SOCIAL_LAW_TOTAL_NEED_AMOUNT: 'law.social_law_total_need_amount',
    LAW_SOCIAL_LAW_TOTAL_RECLAIM_AMOUNT: 'law.social_law_total_reclaim_amount',
    LAW_SOCIAL_LAW_VIOLATION_TYPE: 'law.social_law_violation_type',
    LAW_TENANCY_LAW_ADRESS_RENTAL_PROPERTY: 'law.tenancy_law_adress_rental_property',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGE: 'law.tenancy_law_advance_payment_service_charge',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGES: 'law.tenancy_law_advance_payment_service_charges',
    LAW_TENANCY_LAW_BANK_GUARANTEE: 'law.tenancy_law_bank_guarantee',
    LAW_TENANCY_LAW_CASH_DEPOSIT_AGREED: 'law.tenancy_law_cash_deposit_agreed',
    LAW_TENANCY_LAW_CASH_DEPOSIT_PAYMENT_DATE: 'law.tenancy_law_cash_deposit_payment_date',
    LAW_TENANCY_LAW_COMPETENT_COURT: 'law.tenancy_law_competent_court',
    LAW_TENANCY_LAW_COST_SHARE: 'law.tenancy_law_cost_share',
    LAW_TENANCY_LAW_COST_SHARES: 'law.tenancy_law_cost_shares',
    LAW_TENANCY_LAW_COUNTER_NUMBER: 'law.tenancy_law_counter_number',
    LAW_TENANCY_LAW_COURT_CASE_NUMBER: 'law.tenancy_law_court_case_number',
    LAW_TENANCY_LAW_COURT_PROCEEDINGS_PENDING: 'law.tenancy_law_court_proceedings_pending',
    LAW_TENANCY_LAW_DESCRIPTION_OF_RENTAL_PROPERTY: 'law.tenancy_law_description_of_rental_property',
    LAW_TENANCY_LAW_DURATION_OF_LEASE: 'law.tenancy_law_duration_of_lease',
    LAW_TENANCY_LAW_EXPERT_REPORT_COMMISSION_DATE: 'law.tenancy_law_expert_report_commission_date',
    LAW_TENANCY_LAW_EXPERT_REPORT_DAMAGE_DESCRIPTION: 'law.tenancy_law_expert_report_damage_description',
    LAW_TENANCY_LAW_EXPERT_REPORT_DAMAGE_NUMBER: 'law.tenancy_law_expert_report_damage_number',
    LAW_TENANCY_LAW_EXPERT_REPORT_DATE: 'law.tenancy_law_expert_report_date',
    LAW_TENANCY_LAW_EXPERT_REPORT_INSPECTION_DATE: 'law.tenancy_law_expert_report_inspection_date',
    LAW_TENANCY_LAW_EXPERT_REPORT: 'law.tenancy_law_expert_report',
    LAW_TENANCY_LAW_EXPERT_REPORT_OBJECT_ADDRESS: 'law.tenancy_law_expert_report_object_address',
    LAW_TENANCY_LAW_EXPERT_REPORT_PURPOSE: 'law.tenancy_law_expert_report_purpose',
    LAW_TENANCY_LAW_EXPERT_REPORT_REPAIR_DURATION: 'law.tenancy_law_expert_report_repair_duration',
    LAW_TENANCY_LAW_EXPERT_REPORT_SUBJECT: 'law.tenancy_law_expert_report_subject',
    LAW_TENANCY_LAW_EXTENSION_OPTION_COUNT: 'law.tenancy_law_extension_option_count',
    LAW_TENANCY_LAW_EXTENSION_OPTION_DURATION: 'law.tenancy_law_extension_option_duration',
    LAW_TENANCY_LAW_FIXED_TERM_TENANCY: 'law.tenancy_law_fixed_term_tenancy',
    LAW_TENANCY_LAW_GARAGE_AVAILABLE: 'law.tenancy_law_garage_available',
    LAW_TENANCY_LAW_GARAGE_COSTS: 'law.tenancy_law_garage_costs',
    LAW_TENANCY_LAW_GENERAL_STATUS_DOCUMENTS: 'law.tenancy_law_general_status_documents',
    LAW_TENANCY_LAW_GROSS_RENT: 'law.tenancy_law_gross_rent',
    LAW_TENANCY_LAW_HANDOVER_COUNTER: 'law.tenancy_law_handover_counter',
    LAW_TENANCY_LAW_HANDOVER_DATE: 'law.tenancy_law_handover_date',
    LAW_TENANCY_LAW_HANDOVER_DEFECTS: 'law.tenancy_law_handover_defects',
    LAW_TENANCY_LAW_HANDOVER_PROTOCOL: 'law.tenancy_law_handover_protocol',
    LAW_TENANCY_LAW_LANDLORD_TERMINATION_GIVEN: 'law.tenancy_law_landlord_termination_given',
    LAW_TENANCY_LAW_LAST_RENT_INCREASE_LETTER_DATE: 'law.tenancy_law_last_rent_increase_letter_date',
    LAW_TENANCY_LAW_LAST_SIGNATURE_DATE: 'law.tenancy_law_last_signature_date',
    LAW_TENANCY_LAW_LEASE_AGREEMENT: 'law.tenancy_law_lease_agreement',
    LAW_TENANCY_LAW_LOCATION_IN_RENTAL_PROPERTY: 'law.tenancy_law_location_in_rental_property',
    LAW_TENANCY_LAW_NET_RENT: 'law.tenancy_law_net_rent',
    LAW_TENANCY_LAW_OPERATING_COSTS_AGREEMENT: 'law.tenancy_law_operating_costs_agreement',
    LAW_TENANCY_LAW_PARKING_SPACE_AVAILABLE: 'law.tenancy_law_parking_space_available',
    LAW_TENANCY_LAW_PARKING_SPACE_COSTS: 'law.tenancy_law_parking_space_costs',
    LAW_TENANCY_LAW_PROPERTY_RETURN_DATE: 'law.tenancy_law_property_return_date',
    LAW_TENANCY_LAW_RENT_INCREASE_EFFECTIVE_DATE: 'law.tenancy_law_rent_increase_effective_date',
    LAW_TENANCY_LAW_RENT_INCREASE_NOTICE: 'law.tenancy_law_rent_increase_notice',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DATE: 'law.tenancy_law_rental_agreement_date',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DURATION: 'law.tenancy_law_rental_agreement_duration',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT: 'law.tenancy_law_rental_agreement',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_END: 'law.tenancy_law_rental_agreement_validity_end',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_START: 'law.tenancy_law_rental_agreement_validity_start',
    LAW_TENANCY_LAW_RENTAL_OBJECT_SIZE_SQM: 'law.tenancy_law_rental_object_size_sqm',
    LAW_TENANCY_LAW_REPAYMENT: 'law.tenancy_law_repayment',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_END: 'law.tenancy_law_repayment_period_end',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_START: 'law.tenancy_law_repayment_period_start',
    LAW_TENANCY_LAW_SECURITY_DEPOSIT_ADDITIONAL_REGULATIONS: 'law.tenancy_law_security_deposit_additional_regulations',
    LAW_TENANCY_LAW_SECURITY_DEPOSIT_AMOUNT: 'law.tenancy_law_security_deposit_amount',
    LAW_TENANCY_LAW_SERVICE_CHARGE_SETTLEMENT: 'law.tenancy_law_service_charge_settlement',
    LAW_TENANCY_LAW_STAGGERED_RENTAL_AGREEMENT: 'law.tenancy_law_staggered_rental_agreement',
    LAW_TENANCY_LAW_START_OF_LEASE: 'law.tenancy_law_start_of_lease',
    LAW_TENANCY_LAW_TENANCY_TERMINATED: 'law.tenancy_law_tenancy_terminated',
    LAW_TENANCY_LAW_TENANCY_TERMINATION_DATE: 'law.tenancy_law_tenancy_termination_date',
    LAW_TENANCY_LAW_TENANT_EXTENSION_OPTION: 'law.tenancy_law_tenant_extension_option',
    LAW_TENANCY_LAW_TENANT_WARNED: 'law.tenancy_law_tenant_warned',
    LAW_TENANCY_LAW_TERMINATION_DECLARED_DATE: 'law.tenancy_law_termination_declared_date',
    LAW_TENANCY_LAW_TERMINATION_LETTER_DATE: 'law.tenancy_law_termination_letter_date',
    LAW_TENANCY_LAW_TERMINATION_NOTICE: 'law.tenancy_law_termination_notice',
    LAW_TENANCY_LAW_TERMINATION_NOTICE_PERIOD: 'law.tenancy_law_termination_notice_period',
    LAW_TENANCY_LAW_TOTAL_COST_SERVICE_CHARGE: 'law.tenancy_law_total_cost_service_charge',
    LAW_TENANCY_LAW_TOTAL_RENT: 'law.tenancy_law_total_rent',
    LAW_TENANCY_LAW_UNLIMITED_TERM_TENANCY: 'law.tenancy_law_unlimited_term_tenancy',
    LAW_TENANCY_LAW_VALUE_SECURITY_CLAUSE: 'law.tenancy_law_value_security_clause',
    LAW_TENANCY_LAW_WARNING_LETTER_DATE: 'law.tenancy_law_warning_letter_date',
    LAW_TENANCY_LAW_WARNING_LETTER: 'law.tenancy_law_warning_letter',
    LAW_TOPIC: 'law.topic',
    LAW_TRAFFIC_LAW_ACCIDENT_DATE: 'law.traffic_law_accident_date',
    LAW_TRAFFIC_LAW_ACCIDENT_REPORT: 'law.traffic_law_accident_report',
    LAW_TRAFFIC_LAW_AMOUNT_OF_FINE: 'law.traffic_law_amount_of_fine',
    LAW_TRAFFIC_LAW_APPEAL_INSTRUCTION: 'law.traffic_law_appeal_instruction',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_at_fault_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_VALID_UNTIL: 'law.traffic_law_at_fault_driver_drivers_license_valid_until',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_at_fault_driver_green_card_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_at_fault_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_at_fault_driver_insurance_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURER: 'law.traffic_law_at_fault_driver_insurer',
    LAW_TRAFFIC_LAW_BLOOD_ALCOHOL_CONCENTRATION: 'law.traffic_law_blood_alcohol_concentration',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAMAGE_COSTS: 'law.traffic_law_calculated_total_damage_costs',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAYS: 'law.traffic_law_calculated_total_days',
    LAW_TRAFFIC_LAW_CHARGES: 'law.traffic_law_charges',
    LAW_TRAFFIC_LAW_COST_PER_SCALE: 'law.traffic_law_cost_per_scale',
    LAW_TRAFFIC_LAW_DAILY_RATE: 'law.traffic_law_daily_rate',
    LAW_TRAFFIC_LAW_DAMAGE_AMOUNT_NET: 'law.traffic_law_damage_amount_net',
    LAW_TRAFFIC_LAW_DAMAGE_NUMBER: 'law.traffic_law_damage_number',
    LAW_TRAFFIC_LAW_DAMAGE_SCOPE: 'law.traffic_law_damage_scope',
    LAW_TRAFFIC_LAW_DATE_OF_ACCIDENT: 'law.traffic_law_date_of_accident',
    LAW_TRAFFIC_LAW_DATE_OF_CRIME: 'law.traffic_law_date_of_crime',
    LAW_TRAFFIC_LAW_DATE_OF_FINE: 'law.traffic_law_date_of_fine',
    LAW_TRAFFIC_LAW_DATE_OF_INFRACTION: 'law.traffic_law_date_of_infraction',
    LAW_TRAFFIC_LAW_DATE_OF_INSPECTION: 'law.traffic_law_date_of_inspection',
    LAW_TRAFFIC_LAW_DATE_OF_ISSUE: 'law.traffic_law_date_of_issue',
    LAW_TRAFFIC_LAW_DATE_OF_OFFENSE: 'law.traffic_law_date_of_offense',
    LAW_TRAFFIC_LAW_DATE_OF_REPORT: 'law.traffic_law_date_of_report',
    LAW_TRAFFIC_LAW_DIFFERENCIAL_TAX: 'law.traffic_law_differencial_tax',
    LAW_TRAFFIC_LAW_DRIVER_LOGBOOK_REQUIRED: 'law.traffic_law_driver_logbook_required',
    LAW_TRAFFIC_LAW_DRIVING_BAN_DURATION: 'law.traffic_law_driving_ban_duration',
    LAW_TRAFFIC_LAW_DRIVING_BAN: 'law.traffic_law_driving_ban',
    LAW_TRAFFIC_LAW_EVIDENCE_INFRACTION: 'law.traffic_law_evidence_infraction',
    LAW_TRAFFIC_LAW_EXPERT_COST: 'law.traffic_law_expert_cost',
    LAW_TRAFFIC_LAW_EXPERT_DATE: 'law.traffic_law_expert_date',
    LAW_TRAFFIC_LAW_EXPERT_REPORT: 'law.traffic_law_expert_report',
    LAW_TRAFFIC_LAW_EXPERT_REPORT_NUMBER: 'law.traffic_law_expert_report_number',
    LAW_TRAFFIC_LAW_FILE_NUMBER: 'law.traffic_law_file_number',
    LAW_TRAFFIC_LAW_FINE: 'law.traffic_law_fine',
    LAW_TRAFFIC_LAW_FINE_NOTICE: 'law.traffic_law_fine_notice',
    LAW_TRAFFIC_LAW_GROSS_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_gross_replacement_value',
    LAW_TRAFFIC_LAW_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_replacement_value',
    LAW_TRAFFIC_LAW_INJURED: 'law.traffic_law_injured',
    LAW_TRAFFIC_LAW_INSURANCE_HOLDER: 'law.traffic_law_insurance_holder',
    LAW_TRAFFIC_LAW_INSURANCE: 'law.traffic_law_insurance',
    LAW_TRAFFIC_LAW_INSURANCE_POLICY_NUMBER: 'law.traffic_law_insurance_policy_number',
    LAW_TRAFFIC_LAW_LEGAL_BASIS_INFRACTION: 'law.traffic_law_legal_basis_infraction',
    LAW_TRAFFIC_LAW_LEGAL_BASIS: 'law.traffic_law_legal_basis',
    LAW_TRAFFIC_LAW_LICENSEPLATE_AT_FAULT_DRIVER: 'law.traffic_law_licenseplate_at_fault_driver',
    LAW_TRAFFIC_LAW_LICENSEPLATE: 'law.traffic_law_licenseplate',
    LAW_TRAFFIC_LAW_LICENSEPLATE_VICTIM_DRIVER: 'law.traffic_law_licenseplate_victim_driver',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_REPAIR_CASE: 'law.traffic_law_loss_amount_repair_case',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_TOTAL_DAMAGE_CASE: 'law.traffic_law_loss_amount_total_damage_case',
    LAW_TRAFFIC_LAW_LOSS_OF_USE_PER_DAY: 'law.traffic_law_loss_of_use_per_day',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_AT_FAULT_DRIVER: 'law.traffic_law_mark_and_type_of_at_fault_driver',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_VICTIM_DRIVER: 'law.traffic_law_mark_and_type_of_victim_driver',
    LAW_TRAFFIC_LAW_MERANTILE_VALUE_LOSS: 'law.traffic_law_merantile_value_loss',
    LAW_TRAFFIC_LAW_NET_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_net_gross_replacement_value',
    LAW_TRAFFIC_LAW_NET_REPLACEMENT_VALUE: 'law.traffic_law_net_replacement_value',
    LAW_TRAFFIC_LAW_NUMBER_OF_DAILY_RATES: 'law.traffic_law_number_of_daily_rates',
    LAW_TRAFFIC_LAW_OFFENSE_INFRACTION_DESCRIPTION: 'law.traffic_law_offense_infraction_description',
    LAW_TRAFFIC_LAW_OTHER_DAMAGES: 'law.traffic_law_other_damages',
    LAW_TRAFFIC_LAW_PAYMENT_DEADLINE: 'law.traffic_law_payment_deadline',
    LAW_TRAFFIC_LAW_PENALTY_ORDER: 'law.traffic_law_penalty_order',
    LAW_TRAFFIC_LAW_PLACE_OF_ACCIDENT: 'law.traffic_law_place_of_accident',
    LAW_TRAFFIC_LAW_PLACE_OF_CRIME: 'law.traffic_law_place_of_crime',
    LAW_TRAFFIC_LAW_PLACE_OF_INFRACTION: 'law.traffic_law_place_of_infraction',
    LAW_TRAFFIC_LAW_PLACE_OF_INSPECTION: 'law.traffic_law_place_of_inspection',
    LAW_TRAFFIC_LAW_PLACE_OF_ISSUE: 'law.traffic_law_place_of_issue',
    LAW_TRAFFIC_LAW_PLACE_OF_OFFENSE: 'law.traffic_law_place_of_offense',
    LAW_TRAFFIC_LAW_POINTS_FOR_OFFENSE: 'law.traffic_law_points_for_offense',
    LAW_TRAFFIC_LAW_POLICE_CASE_NUMBER: 'law.traffic_law_police_case_number',
    LAW_TRAFFIC_LAW_PROCEDURE_COSTS: 'law.traffic_law_procedure_costs',
    LAW_TRAFFIC_LAW_PROSECUTION_NUMBER: 'law.traffic_law_prosecution_number',
    LAW_TRAFFIC_LAW_REGULAR_TAX: 'law.traffic_law_regular_tax',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITH_VAT: 'law.traffic_law_repair_costs_with_vat',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITHOUT_VAT: 'law.traffic_law_repair_costs_without_vat',
    LAW_TRAFFIC_LAW_REPAIR_DAMAGE: 'law.traffic_law_repair_damage',
    LAW_TRAFFIC_LAW_REPAIR_DURATION: 'law.traffic_law_repair_duration',
    LAW_TRAFFIC_LAW_REPLACEMENT_COST: 'law.traffic_law_replacement_cost',
    LAW_TRAFFIC_LAW_REPLACEMENT_VALUE: 'law.traffic_law_replacement_value',
    LAW_TRAFFIC_LAW_REREGISTRATION_COST: 'law.traffic_law_reregistration_cost',
    LAW_TRAFFIC_LAW_RESIDUAL_VALUE: 'law.traffic_law_residual_value',
    LAW_TRAFFIC_LAW_SPEED_ALLOWED: 'law.traffic_law_speed_allowed',
    LAW_TRAFFIC_LAW_SPEED_DRIVEN: 'law.traffic_law_speed_driven',
    LAW_TRAFFIC_LAW_SPEED_TOO_HIGH: 'law.traffic_law_speed_too_high',
    LAW_TRAFFIC_LAW_TIME_OF_ACCIDENT: 'law.traffic_law_time_of_accident',
    LAW_TRAFFIC_LAW_TIME_OF_CRIME: 'law.traffic_law_time_of_crime',
    LAW_TRAFFIC_LAW_TIME_OF_INFRACTION: 'law.traffic_law_time_of_infraction',
    LAW_TRAFFIC_LAW_TIME_OF_INSPECTION: 'law.traffic_law_time_of_inspection',
    LAW_TRAFFIC_LAW_TIME_OF_ISSUE: 'law.traffic_law_time_of_issue',
    LAW_TRAFFIC_LAW_TIME_OF_OFFENSE: 'law.traffic_law_time_of_offense',
    LAW_TRAFFIC_LAW_TOTAL_DAMAGE: 'law.traffic_law_total_damage',
    LAW_TRAFFIC_LAW_VALUE_IMPROVEMENT: 'law.traffic_law_value_improvement',
    LAW_TRAFFIC_LAW_VEHICLE_AGE_MONTHS: 'law.traffic_law_vehicle_age_months',
    LAW_TRAFFIC_LAW_VEHICLE_MILEAGE: 'law.traffic_law_vehicle_mileage',
    LAW_TRAFFIC_LAW_VEHICLE_TYPE_AND_BRAND: 'law.traffic_law_vehicle_type_and_brand',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_victim_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_victim_driver_green_card_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_victim_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_victim_driver_insurance_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURER: 'law.traffic_law_victim_driver_insurer',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_LICENSE_VALID_UNTIL: 'law.traffic_law_victim_driver_license_valid_until',
    LAW_TRAFFIC_LAW_VIOLATED_SECTION: 'law.traffic_law_violated_section',
    LAW_TRAFFIC_LAW_VIOLATION_TYPE: 'law.traffic_law_violation_type',
    LAW_TRAFFIC_LAW_WARNING_FEE_INFRACTION: 'law.traffic_law_warning_fee_infraction',
    LAW_TRAFFIC_LAW_WARNING_NOTICE: 'law.traffic_law_warning_notice'
} as const;

export type AiAugmentedFieldsRequest = {
    client: EntityAugmentedFieldsRequest;
    opponent: EntityAugmentedFieldsRequest;
    law: LawAugmentedFieldsRequest;
};

export type AiChatQuestionTemplate = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    readonly is_jupus_template: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly created_by_user: string | null;
    prompt: string;
    title: string;
    description?: string;
    readonly org: string;
    readonly is_favorite: string;
};

export type AiChatQuestionTemplateRequest = {
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    prompt: string;
    title: string;
    description?: string;
};

/**
 * Base announcement serializer for public viewing.
 *
 * Returns only essential fields for displaying active announcements.
 */
export type Announcement = {
    readonly uuid: string;
    /**
     * The announcement message to display
     */
    readonly message: string;
    /**
     * The type of announcement (determines color/styling)
     *
     * * `INFO` - Info
     * * `WARNING` - Warning
     * * `ERROR` - Error
     * * `SUCCESS` - Success
     */
    readonly message_type: MessageTypeEnum;
    /**
     * Whether users can dismiss this announcement
     */
    readonly dismissible: boolean;
};

export type AppointmentSettings = {
    start_of_working_day: string;
    end_of_working_day: string;
    working_days?: unknown;
};

/**
 * * `CONFIRMED` - Bestätigt
 * * `TENTATIVE` - Unbestätigt
 * * `CANCELLED` - Abgesagt
 * * `UNKNOWN` - Unbekannt
 */
export type AppointmentStatusEnum = 'CONFIRMED' | 'TENTATIVE' | 'CANCELLED' | 'UNKNOWN';

/**
 * * `CONFIRMED` - Bestätigt
 * * `TENTATIVE` - Unbestätigt
 * * `CANCELLED` - Abgesagt
 * * `UNKNOWN` - Unbekannt
 */
export const AppointmentStatusEnum = {
    CONFIRMED: 'CONFIRMED',
    TENTATIVE: 'TENTATIVE',
    CANCELLED: 'CANCELLED',
    UNKNOWN: 'UNKNOWN'
} as const;

/**
 * * `client` - client
 * * `lawyer` - lawyer
 */
export type AssignedToEnum = 'client' | 'lawyer';

/**
 * * `client` - client
 * * `lawyer` - lawyer
 */
export const AssignedToEnum = {
    CLIENT: 'client',
    LAWYER: 'lawyer'
} as const;

/**
 * * `DOCUMENT ANALYSIS` - Document Analysis
 * * `EMAIL EXTRACTION` - Email Extraction
 * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
 * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
 * * `CALL` - Call
 * * `CHATBOT` - Chatbot
 * * `AGENT` - Agent
 */
export type AugmentationVariantEnum = 'DOCUMENT ANALYSIS' | 'EMAIL EXTRACTION' | 'CONTEXTUAL ANALYSIS' | 'UNIVERSAL ENTITY EXTRACTION' | 'CALL' | 'CHATBOT' | 'AGENT';

/**
 * * `DOCUMENT ANALYSIS` - Document Analysis
 * * `EMAIL EXTRACTION` - Email Extraction
 * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
 * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
 * * `CALL` - Call
 * * `CHATBOT` - Chatbot
 * * `AGENT` - Agent
 */
export const AugmentationVariantEnum = {
    DOCUMENT_ANALYSIS: 'DOCUMENT ANALYSIS',
    EMAIL_EXTRACTION: 'EMAIL EXTRACTION',
    CONTEXTUAL_ANALYSIS: 'CONTEXTUAL ANALYSIS',
    UNIVERSAL_ENTITY_EXTRACTION: 'UNIVERSAL ENTITY EXTRACTION',
    CALL: 'CALL',
    CHATBOT: 'CHATBOT',
    AGENT: 'AGENT'
} as const;

export type BlankEnum = '';

export const BlankEnum = {
    EMPTY_STRING: ''
} as const;

export type BlockEvaluation = {
    block_variable: string;
    german_label?: string | null;
    english_label?: string | null;
    is_true: boolean;
};

/**
 * * `top-left` - Oben links
 * * `top-right` - Oben rechts
 * * `top-center` - Oben zentriert
 * * `bottom-left` - Unten links
 * * `bottom-right` - Unten rechts
 * * `bottom-center` - Unten zentriert
 * * `middle-left` - Links zentriert
 * * `middle-right` - Rechts zentriert
 * * `none` - Nicht anzeigen
 */
export type BotButtonPositionEnum = 'top-left' | 'top-right' | 'top-center' | 'bottom-left' | 'bottom-right' | 'bottom-center' | 'middle-left' | 'middle-right' | 'none';

/**
 * * `top-left` - Oben links
 * * `top-right` - Oben rechts
 * * `top-center` - Oben zentriert
 * * `bottom-left` - Unten links
 * * `bottom-right` - Unten rechts
 * * `bottom-center` - Unten zentriert
 * * `middle-left` - Links zentriert
 * * `middle-right` - Rechts zentriert
 * * `none` - Nicht anzeigen
 */
export const BotButtonPositionEnum = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center',
    MIDDLE_LEFT: 'middle-left',
    MIDDLE_RIGHT: 'middle-right',
    NONE: 'none'
} as const;

/**
 * Request serializer for bulk syncing documents between platforms.
 */
export type BulkSyncDocumentsRequestRequest = {
    /**
     * List of JUPUS document UUIDs to send to Actaport
     */
    document_uuids?: Array<(string)>;
    /**
     * List of Actaport document IDs to import into JUPUS
     */
    actaport_document_ids?: Array<(string)>;
};

/**
 * Response serializer for bulk sync endpoint.
 */
export type BulkSyncDocumentsResponse = {
    /**
     * Status of the bulk sync operation
     *
     * * `syncing` - syncing
     * * `error` - error
     */
    status: BulkSyncDocumentsResponseStatusEnum;
    /**
     * Number of documents being sent to Actaport
     */
    sending_count: number;
    /**
     * Number of documents being imported from Actaport
     */
    importing_count: number;
    /**
     * Description of the sync operation
     */
    message: string;
};

/**
 * * `syncing` - syncing
 * * `error` - error
 */
export type BulkSyncDocumentsResponseStatusEnum = 'syncing' | 'error';

/**
 * * `syncing` - syncing
 * * `error` - error
 */
export const BulkSyncDocumentsResponseStatusEnum = {
    SYNCING: 'syncing',
    ERROR: 'error'
} as const;

/**
 * Serializer for bulk uploading Word document templates.
 */
export type BulkUploadRequest = {
    /**
     * List of .docx files to upload
     */
    files: Array<((Blob | File))>;
};

export type Calendar = {
    uuid?: string;
    readonly id: number;
    name?: string;
    avatar?: string | null;
    calendar_id: string;
    readonly availability_query: {
        [key: string]: unknown;
    };
    readonly account: CustomerAccount;
};

export type CalendarRequest = {
    uuid?: string;
    name?: string;
    avatar?: (Blob | File) | null;
    calendar_id: string;
};

export type CallTranscriptMessage = {
    role: string;
    content: string;
};

export type CallTranscriptMessageRequest = {
    role: string;
    content: string;
};

export type CaseAiContext = {
    created_at?: string | null;
    case_created_at: string;
    updated_document_context_at?: string | null;
    inquiry: string;
    note?: string | null;
    data: CaseDataAiContext;
    entities: CaseEntityAiContext;
    documents: DocumentAiContext;
    preferences?: ChatPreferenceAiContext | null;
};

export type CaseAppointments = CustomerAppointment | CustomerAdminAppointment | SuperUserAppointment;

export type CaseCreateEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    institution_name?: string;
    phone?: string;
    email?: string;
    date_of_birth?: string | null;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
};

export type CaseCreateInstructionsAdvisory = {
    revised_case_acceptance_instructions_html: string;
    suggestions_html: string;
    is_original_case_acceptance_instructions_valid: boolean;
    errors_html: string;
};

/**
 * Serializer for requesting case create instructions advisory.
 */
export type CaseCreateInstructionsAdvisoryRequestRequest = {
    /**
     * The case acceptance instructions to validate and get advisory for
     */
    case_acceptance_instructions: string;
};

/**
 * Serializer for case create instructions advisory response.
 */
export type CaseCreateInstructionsAdvisoryResponse = {
    /**
     * Case create instructions advisory response
     */
    advisory: CaseCreateInstructionsAdvisory;
};

export type CaseCreateLawRequest = {
    field: FieldEnum | BlankEnum;
    topic: TopicEnum | BlankEnum;
};

export type CaseCreateRequest = {
    clerk_uuid: string | null;
    client: CaseCreateEntityRequest;
    opponent: CaseCreateEntityRequest;
    law: CaseCreateLawRequest;
    inquiry?: string;
    note?: string;
    document_uuids: Array<(string)>;
    ai_augmented_fields: (AiAugmentedFieldsRequest) | null;
};

export type CaseCreatorTempDocument = {
    readonly uuid: string;
    readonly created_at: string;
    original_filename: string;
    file: string;
    readonly extraction_result: UUIDExtractionResult;
    readonly images: Array<ImageproxyImagePreset>;
};

export type CaseCreatorTempDocumentRequest = {
    original_filename: string;
    file: (Blob | File);
};

export type CaseDashboardWidgetsEnum = 'CASE_DATA' | 'CLIENT_DATA' | 'CURRENT_STATE' | 'OPPONENT_DATA' | 'ACTIVITIES' | 'EMAILS' | 'APPOINTMENTS' | 'AI_CHAT' | 'LAW_SPECIFIC_DATA' | 'DOCUMENTS' | 'GENERATED_DOCUMENTS' | 'ENTITIES' | 'NOTES';

export const CaseDashboardWidgetsEnum = {
    CASE_DATA: 'CASE_DATA',
    CLIENT_DATA: 'CLIENT_DATA',
    CURRENT_STATE: 'CURRENT_STATE',
    OPPONENT_DATA: 'OPPONENT_DATA',
    ACTIVITIES: 'ACTIVITIES',
    EMAILS: 'EMAILS',
    APPOINTMENTS: 'APPOINTMENTS',
    AI_CHAT: 'AI_CHAT',
    LAW_SPECIFIC_DATA: 'LAW_SPECIFIC_DATA',
    DOCUMENTS: 'DOCUMENTS',
    GENERATED_DOCUMENTS: 'GENERATED_DOCUMENTS',
    ENTITIES: 'ENTITIES',
    NOTES: 'NOTES'
} as const;

export type CaseDataAiContext = {
    key: string;
    label: string;
    data?: string | null;
    is_default: boolean;
    uuid: string;
};

export type CaseEntityAiContext = {
    uuid: string;
    entity_type: EntityTypeC7aEnum;
    first_name?: string | null;
    last_name?: string | null;
    company_name?: string | null;
    institution_name?: string | null;
};

/**
 * Minimal case info for calls that are connected to cases
 */
export type CaseInfo = {
    uuid: string;
    pk: number;
    note: string | null;
    readonly clerk: CustomerOrganisationUser;
    law_field: string;
    law_topic: string;
};

/**
 * Minimal case info for calls that are connected to cases
 */
export type CaseInfoRequest = {
    uuid: string;
    pk: number;
    note: string | null;
    law_field: string;
    law_topic: string;
};

/**
 * Serializer for rating a case lifecycle state.
 */
export type CaseLifecycleStateRateRequest = {
    /**
     * Rating value from 0.0 to 5.0
     */
    rating: string;
    /**
     * Additional comment for negative rating
     */
    rating_negative_comment?: string | null;
};

/**
 * Serializer for Case Lifecycle State Reasoning.
 */
export type CaseLifecycleStateReasoning = {
    readonly uuid: string;
    reasoning?: (Translation) | null;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Serializer for Case Lifecycle State Reasoning.
 */
export type CaseLifecycleStateReasoningRequest = {
    reasoning?: (Translation) | null;
};

export type CaseLifecycleStateRelatedData = {
    case_uuid?: string | null;
};

/**
 * Serializer for Case Lifecycle State Transition Result.
 */
export type CaseLifecycleStateTransitionResult = {
    readonly uuid: string;
    readonly next_state: NextStateEnum | NullEnum | null;
    readonly confidence_score: number | null;
    readonly reasoning: CaseLifecycleStateReasoning;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Serializer for case state counts response.
 *
 * Returns counts for all case states, both unfiltered (total)
 * and optionally filtered based on query parameters.
 *
 * :param total: Total counts per state without additional filters
 * :param filtered: Counts per state with additional filters applied (if any filters provided)
 * :param has_filters: Whether additional filters were applied
 */
export type CaseStateCounts = {
    total: TotalCounts;
    filtered?: (FilteredCounts) | null;
    has_filters: boolean;
};

/**
 * * `API` - API
 * * `CHAT BOT` - Chat
 * * `QUESTIONNAIRE` - Fragebogen
 * * `EMAIL` - E-Mail
 * * `MANUAL` - Manuell
 * * `PHONE` - Telefon
 * * `APPOINTMENT` - Terminbuchung
 * * `AI_GENERATED` - KI generiert
 * * `ONSITE` - VOR ORT
 */
export type CaseType = 'API' | 'CHAT BOT' | 'QUESTIONNAIRE' | 'EMAIL' | 'MANUAL' | 'PHONE' | 'APPOINTMENT' | 'AI_GENERATED' | 'ONSITE';

/**
 * * `API` - API
 * * `CHAT BOT` - Chat
 * * `QUESTIONNAIRE` - Fragebogen
 * * `EMAIL` - E-Mail
 * * `MANUAL` - Manuell
 * * `PHONE` - Telefon
 * * `APPOINTMENT` - Terminbuchung
 * * `AI_GENERATED` - KI generiert
 * * `ONSITE` - VOR ORT
 */
export const CaseType = {
    API: 'API',
    CHAT_BOT: 'CHAT BOT',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    EMAIL: 'EMAIL',
    MANUAL: 'MANUAL',
    PHONE: 'PHONE',
    APPOINTMENT: 'APPOINTMENT',
    AI_GENERATED: 'AI_GENERATED',
    ONSITE: 'ONSITE'
} as const;

/**
 * * `Allgemein` - General
 * * `Rechtsspezifisch` - Law Specific
 */
export type CategoryEnum = 'Allgemein' | 'Rechtsspezifisch';

/**
 * * `Allgemein` - General
 * * `Rechtsspezifisch` - Law Specific
 */
export const CategoryEnum = {
    ALLGEMEIN: 'Allgemein',
    RECHTSSPEZIFISCH: 'Rechtsspezifisch'
} as const;

/**
 * Serializer for password change request.
 */
export type ChangePasswordRequest = {
    new_password1: string;
    new_password2: string;
};

/**
 * Serializer for password change response.
 */
export type ChangePasswordResponse = {
    readonly message: string;
};

/**
 * * `USER` - User
 * * `AI` - Ai
 * * `QUESTIONNAIRE` - Questionnaire
 * * `APPOINTMENT` - Appointment
 * * `SYSTEM` - System
 * * `PDF_FORM` - Pdf Form
 */
export type ChangeSourceEnum = 'USER' | 'AI' | 'QUESTIONNAIRE' | 'APPOINTMENT' | 'SYSTEM' | 'PDF_FORM';

/**
 * * `USER` - User
 * * `AI` - Ai
 * * `QUESTIONNAIRE` - Questionnaire
 * * `APPOINTMENT` - Appointment
 * * `SYSTEM` - System
 * * `PDF_FORM` - Pdf Form
 */
export const ChangeSourceEnum = {
    USER: 'USER',
    AI: 'AI',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    APPOINTMENT: 'APPOINTMENT',
    SYSTEM: 'SYSTEM',
    PDF_FORM: 'PDF_FORM'
} as const;

/**
 * Serializer for the ChatPreference model.
 */
export type ChatPreference = {
    readonly uuid: string;
    title: string;
    content: string;
    scope?: ScopeEnum;
    source?: ChatPreferenceSourceEnum | BlankEnum | NullEnum | null;
    org?: number | null;
    created_by_user?: number | null;
    readonly created_by_user_name: string;
    user?: number | null;
    case?: number | null;
    readonly case_uuid: string;
    /**
     * UUID of the AI chat message this preference was created from
     */
    message_uuid?: string | null;
    is_active?: boolean;
    readonly created_at: string;
    readonly updated_at: string;
    /**
     * Sentiment classification (like, dislike, neutral, etc.)
     */
    sentiment?: string | null;
    /**
     * Confidence score for the sentiment classification (0.0-1.0)
     */
    confidence?: number | null;
    /**
     * Entity or topic this preference relates to
     */
    entity?: string | null;
    /**
     * Number of positive interactions with this preference
     */
    frequency_positive?: number;
    /**
     * Number of negative interactions with this preference
     */
    frequency_negative?: number;
    /**
     * Last time this preference was accessed/used
     */
    last_accessed?: string | null;
    readonly max_preferences: string;
    readonly max_active_preferences: string;
};

export type ChatPreferenceAiContext = {
    uuid: string;
    title: string;
    content: string;
    scope: string;
    created_at: string;
    created_by: string;
    sentiment?: string | null;
    confidence?: number | null;
    entity?: string | null;
    computed_score?: number | null;
};

/**
 * Serializer for the ChatPreference model.
 */
export type ChatPreferenceRequest = {
    title: string;
    content: string;
    scope?: ScopeEnum;
    source?: ChatPreferenceSourceEnum | BlankEnum | NullEnum | null;
    org?: number | null;
    created_by_user?: number | null;
    user?: number | null;
    case?: number | null;
    /**
     * UUID of the AI chat message this preference was created from
     */
    message_uuid?: string | null;
    is_active?: boolean;
    /**
     * Sentiment classification (like, dislike, neutral, etc.)
     */
    sentiment?: string | null;
    /**
     * Confidence score for the sentiment classification (0.0-1.0)
     */
    confidence?: number | null;
    /**
     * Entity or topic this preference relates to
     */
    entity?: string | null;
    /**
     * Number of positive interactions with this preference
     */
    frequency_positive?: number;
    /**
     * Number of negative interactions with this preference
     */
    frequency_negative?: number;
    /**
     * Last time this preference was accessed/used
     */
    last_accessed?: string | null;
};

/**
 * * `AI_CHAT` - AI Chat
 * * `DOCUMENT_GENERATION` - Document Generation
 * * `ALL` - All
 */
export type ChatPreferenceSourceEnum = 'AI_CHAT' | 'DOCUMENT_GENERATION' | 'ALL';

/**
 * * `AI_CHAT` - AI Chat
 * * `DOCUMENT_GENERATION` - Document Generation
 * * `ALL` - All
 */
export const ChatPreferenceSourceEnum = {
    AI_CHAT: 'AI_CHAT',
    DOCUMENT_GENERATION: 'DOCUMENT_GENERATION',
    ALL: 'ALL'
} as const;

/**
 * * `EXISTING_CLIENT_CALL_BACK` - Bestandsmandant
 * * `NEW_CLIENT_CALL` - Neumandant
 * * `GENERAL_ENQUIRY` - Allgemeine Anfrage
 * * `QUESTION` - Frage
 * * `NOT_COMPLETED` - Unvollständig
 * * `LAWFIRM_PARTNER` - Geschäftspartner
 * * `CALL_FORWARDED` - Anruf weitergeleitet
 * * `WITHOUT_MESSAGE` - Ohne Nachricht
 * * `COURT` - Gericht
 * * `SPAM` - Spam
 */
export type ClassificationEnum = 'EXISTING_CLIENT_CALL_BACK' | 'NEW_CLIENT_CALL' | 'GENERAL_ENQUIRY' | 'QUESTION' | 'NOT_COMPLETED' | 'LAWFIRM_PARTNER' | 'CALL_FORWARDED' | 'WITHOUT_MESSAGE' | 'COURT' | 'SPAM';

/**
 * * `EXISTING_CLIENT_CALL_BACK` - Bestandsmandant
 * * `NEW_CLIENT_CALL` - Neumandant
 * * `GENERAL_ENQUIRY` - Allgemeine Anfrage
 * * `QUESTION` - Frage
 * * `NOT_COMPLETED` - Unvollständig
 * * `LAWFIRM_PARTNER` - Geschäftspartner
 * * `CALL_FORWARDED` - Anruf weitergeleitet
 * * `WITHOUT_MESSAGE` - Ohne Nachricht
 * * `COURT` - Gericht
 * * `SPAM` - Spam
 */
export const ClassificationEnum = {
    EXISTING_CLIENT_CALL_BACK: 'EXISTING_CLIENT_CALL_BACK',
    NEW_CLIENT_CALL: 'NEW_CLIENT_CALL',
    GENERAL_ENQUIRY: 'GENERAL_ENQUIRY',
    QUESTION: 'QUESTION',
    NOT_COMPLETED: 'NOT_COMPLETED',
    LAWFIRM_PARTNER: 'LAWFIRM_PARTNER',
    CALL_FORWARDED: 'CALL_FORWARDED',
    WITHOUT_MESSAGE: 'WITHOUT_MESSAGE',
    COURT: 'COURT',
    SPAM: 'SPAM'
} as const;

export type ClientAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type ClientAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type ClientAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type ClientAiAugmentationRequest = {
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * Case representation for clients.
 */
export type ClientCase = {
    readonly uuid: string;
    readonly questionnaire_submissions: Array<ClientQuestionnaireSubmission>;
    readonly form_requests: Array<ClientRequest>;
    readonly pdf_form_submissions: Array<ClientPDFFormSubmission>;
    readonly org: ClientOrganisation;
    readonly user_access_token: string;
    readonly activities: Array<Activity>;
    readonly client_first_name: string;
    readonly client_last_name: string;
};

/**
 * Entity representation for clients.
 */
export type ClientEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<(number)>;
};

/**
 * Entity representation for clients.
 */
export type ClientEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Form representation for clients.
 */
export type ClientForm = {
    readonly id: string;
    readonly organisation: ClientOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly tag: FormTag;
    readonly title: string;
    readonly description: string;
    readonly file: string | null;
    readonly due_at: string;
    readonly document_name: string;
};

/**
 * Organisation representation for clients.
 */
export type ClientOrganisation = {
    readonly uuid: string;
    readonly name: string | null;
    readonly logo: string | null;
    readonly description: string;
    readonly theme: ThemeEnum;
};

/**
 * PDF form submission serializer for client portal.
 *
 * The frontend handles PDF form submissions separately from legacy forms via type guards.
 */
export type ClientPDFFormSubmission = {
    readonly uuid: string;
    /**
     * Snapshot of template name at submission creation time
     */
    readonly template_name: string;
    /**
     * Snapshot of template description at submission creation time
     */
    readonly template_description: string;
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    readonly submission_status: SubmissionStatusEnum;
    /**
     * Completion percentage (0-100)
     */
    readonly progress_percentage: number;
    /**
     * External submission linked to existing case for third-party completion
     */
    readonly is_external: boolean;
    readonly created_at: string;
    /**
     * Calculate due date as 3 days from creation.
     */
    readonly due_at: string | null;
    readonly document_uuid: string | null;
    readonly processed_pdf: string;
    readonly flattened_pdf: string | null;
    readonly org: ClientOrganisation;
    readonly images: Array<ImageproxyImagePreset>;
};

/**
 * Questionnaire submission representation for clients.
 */
export type ClientQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly is_third_party_questionnaire: boolean;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for clients.
 */
export type ClientQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type ClientRequest = {
    readonly id: string;
    token: string;
    form: ClientForm;
    readonly response_present: {
        [key: string]: unknown;
    };
    readonly document_uuid: string;
    is_third_party?: boolean;
};

export type ClientRequestRequest = {
    token: string;
    is_third_party?: boolean;
};

/**
 * * `` -
 * * `GmbH` - GmbH
 * * `UG (haftungsbeschränkt)` - UG (haftungsbeschränkt)
 * * `GmbH & Co. KG` - GmbH & Co. KG
 * * `AG` - AG
 * * `AG & Co. KG` - AG & Co. KG
 * * `KG` - KG
 * * `OHG` - OHG
 * * `GBR` - GbR
 * * `PartG` - PartG
 * * `PartG mbB` - PartG mbB
 * * `KGaA` - KGaA
 * * `eG` - eG
 * * `eV` - eV
 * * `Einzelunternehmen` - Einzelunternehmen
 * * `Stiftung` - Stiftung
 * * `WEG` - WEG
 * * `SE` - SE
 * * `EWIV` - EWIV
 * * `Limited` - Limited
 * * `PLC` - PLC
 * * `SARL` - SARL
 * * `SAS` - SAS
 * * `SA (FR)` - SA (FR)
 * * `SCN` - SCN
 * * `S.A.R.L.` - S.A.R.L.
 * * `SRL` - SRL
 * * `SPA` - SPA
 * * `SL` - SL
 * * `SA (ES)` - SA (ES)
 * * `BV` - BV
 * * `NV` - NV
 * * `AB` - AB
 * * `Oy` - Oy
 * * `AS` - AS
 * * `s.r.o.` - s.r.o.
 * * `Kft.` - Kft.
 * * `Sp. z o.o.` - Sp. z o.o.
 * * `OOO` - OOO
 */
export type CompanyLegalFormEnum = 'GmbH' | 'UG (haftungsbeschränkt)' | 'GmbH & Co. KG' | 'AG' | 'AG & Co. KG' | 'KG' | 'OHG' | 'GBR' | 'PartG' | 'PartG mbB' | 'KGaA' | 'eG' | 'eV' | 'Einzelunternehmen' | 'Stiftung' | 'WEG' | 'SE' | 'EWIV' | 'Limited' | 'PLC' | 'SARL' | 'SAS' | 'SA (FR)' | 'SCN' | 'S.A.R.L.' | 'SRL' | 'SPA' | 'SL' | 'SA (ES)' | 'BV' | 'NV' | 'AB' | 'Oy' | 'AS' | 's.r.o.' | 'Kft.' | 'Sp. z o.o.' | 'OOO';

/**
 * * `` -
 * * `GmbH` - GmbH
 * * `UG (haftungsbeschränkt)` - UG (haftungsbeschränkt)
 * * `GmbH & Co. KG` - GmbH & Co. KG
 * * `AG` - AG
 * * `AG & Co. KG` - AG & Co. KG
 * * `KG` - KG
 * * `OHG` - OHG
 * * `GBR` - GbR
 * * `PartG` - PartG
 * * `PartG mbB` - PartG mbB
 * * `KGaA` - KGaA
 * * `eG` - eG
 * * `eV` - eV
 * * `Einzelunternehmen` - Einzelunternehmen
 * * `Stiftung` - Stiftung
 * * `WEG` - WEG
 * * `SE` - SE
 * * `EWIV` - EWIV
 * * `Limited` - Limited
 * * `PLC` - PLC
 * * `SARL` - SARL
 * * `SAS` - SAS
 * * `SA (FR)` - SA (FR)
 * * `SCN` - SCN
 * * `S.A.R.L.` - S.A.R.L.
 * * `SRL` - SRL
 * * `SPA` - SPA
 * * `SL` - SL
 * * `SA (ES)` - SA (ES)
 * * `BV` - BV
 * * `NV` - NV
 * * `AB` - AB
 * * `Oy` - Oy
 * * `AS` - AS
 * * `s.r.o.` - s.r.o.
 * * `Kft.` - Kft.
 * * `Sp. z o.o.` - Sp. z o.o.
 * * `OOO` - OOO
 */
export const CompanyLegalFormEnum = {
    GMB_H: 'GmbH',
    'UG__HAFTUNGSBESCHRÄNKT_': 'UG (haftungsbeschränkt)',
    GMB_H___CO__KG: 'GmbH & Co. KG',
    AG: 'AG',
    AG___CO__KG: 'AG & Co. KG',
    KG: 'KG',
    OHG: 'OHG',
    GBR: 'GBR',
    PART_G: 'PartG',
    PART_G_MB_B: 'PartG mbB',
    KGA_A: 'KGaA',
    E_G: 'eG',
    E_V: 'eV',
    EINZELUNTERNEHMEN: 'Einzelunternehmen',
    STIFTUNG: 'Stiftung',
    WEG: 'WEG',
    SE: 'SE',
    EWIV: 'EWIV',
    LIMITED: 'Limited',
    PLC: 'PLC',
    SARL: 'SARL',
    SAS: 'SAS',
    SA__FR_: 'SA (FR)',
    SCN: 'SCN',
    S_A_R_L_: 'S.A.R.L.',
    SRL: 'SRL',
    SPA: 'SPA',
    SL: 'SL',
    SA__ES_: 'SA (ES)',
    BV: 'BV',
    NV: 'NV',
    AB: 'AB',
    OY: 'Oy',
    AS: 'AS',
    S_R_O_: 's.r.o.',
    KFT_: 'Kft.',
    SP__Z_O_O_: 'Sp. z o.o.',
    OOO: 'OOO'
} as const;

export type ContextRequest = {
    key: string;
    context: {
        [key: string]: unknown;
    };
};

export type CreateCaseFromInboundEmailRequest = {
    inquiry: string;
    client_title: string;
    client_first_name?: string;
    client_last_name: string;
    client_email: string;
    client_phone?: string;
    legal_insurance?: boolean | null;
    legal_insurance_name?: string;
    legal_insurance_number?: string;
};

/**
 * Serializer for creating new organisation employees.
 */
export type CreateOrganisationEmployeeRequest = {
    email: string;
    first_name: string;
    last_name: string;
    role: string;
    phone?: string | null;
};

/**
 * Serializer for creating new PDF form templates.
 */
export type CreatePDFFormTemplateRequest = {
    name: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf: (Blob | File);
};

export type CreateSessionFromPackageRequest = {
    package_uuid: string;
    source?: CreateSessionFromPackageSourceEnum | NullEnum | null;
};

/**
 * * `link` - link
 * * `qr_code` - qr_code
 */
export type CreateSessionFromPackageSourceEnum = 'link' | 'qr_code';

/**
 * * `link` - link
 * * `qr_code` - qr_code
 */
export const CreateSessionFromPackageSourceEnum = {
    LINK: 'link',
    QR_CODE: 'qr_code'
} as const;

export type CreateWordDocumentFromPlaceholderValuesRequestRequest = {
    word_document_template_uuid: string;
    name: string;
    placeholder_values: Array<PlaceholderValueRequest>;
    create_pdf?: boolean;
};

export type CreateWordDocumentFromPlaceholderValuesResponse = {
    url: string;
    document_uuid: string;
};

export type CreateWordDocumentPreviewBlobRequest = {
    word_document_template_uuid: string;
    placeholder_values: Array<PlaceholderValueRequest>;
    /**
     * If true, use the AI-generated template with placeholders instead of the original template
     */
    use_ai_template?: boolean;
};

export type CreateWordDocumentRequestRequest = {
    name: string;
    html: string;
    create_pdf: boolean;
};

export type CreateWordDocumentResponse = {
    url: string;
    document_uuid: string;
};

/**
 * Serializer for creating Word document template with placeholders.
 */
export type CreateWordDocumentTemplateDocxWithPlaceholdersRequest = {
    word_document_template_uuid: string;
};

/**
 * * `CREATED` - Created
 * * `CLIENT_INFO_GATHERING` - Client Info Gathering
 * * `PRE_CASE_CONTEXT_GATHERING` - Pre Case Context Gathering
 * * `CASE_CONTEXT_GATHERING` - Case Context Gathering
 * * `POST_CASE_CONTEXT_GATHERING` - Post Case Context Gathering
 * * `LEGAL_DOMAIN_CLASSIFICATION` - Legal Domain Classification
 * * `WORKFLOW_ASSIGNMENT` - Workflow Assignment
 * * `READY_FOR_ONBOARDING_STEP_1` - Ready For Onboarding Step 1
 * * `READY_FOR_ONBOARDING_STEP_2` - Ready For Onboarding Step 2
 * * `DATA_COLLECTION` - Data Collection
 * * `ALL_DATA_COLLECTED` - All Data Collected
 * * `DOCUMENT_DRAFTING` - Document Drafting
 * * `ALL_DOCUMENTS_DRAFTED` - All Documents Drafted
 * * `READY_FOR_EXPORT` - Ready For Export
 * * `EXPORTED` - Exported
 * * `ABORTED` - Aborted
 */
export type CurrentStateEnum = 'CREATED' | 'CLIENT_INFO_GATHERING' | 'PRE_CASE_CONTEXT_GATHERING' | 'CASE_CONTEXT_GATHERING' | 'POST_CASE_CONTEXT_GATHERING' | 'LEGAL_DOMAIN_CLASSIFICATION' | 'WORKFLOW_ASSIGNMENT' | 'READY_FOR_ONBOARDING_STEP_1' | 'READY_FOR_ONBOARDING_STEP_2' | 'DATA_COLLECTION' | 'ALL_DATA_COLLECTED' | 'DOCUMENT_DRAFTING' | 'ALL_DOCUMENTS_DRAFTED' | 'READY_FOR_EXPORT' | 'EXPORTED' | 'ABORTED';

/**
 * * `CREATED` - Created
 * * `CLIENT_INFO_GATHERING` - Client Info Gathering
 * * `PRE_CASE_CONTEXT_GATHERING` - Pre Case Context Gathering
 * * `CASE_CONTEXT_GATHERING` - Case Context Gathering
 * * `POST_CASE_CONTEXT_GATHERING` - Post Case Context Gathering
 * * `LEGAL_DOMAIN_CLASSIFICATION` - Legal Domain Classification
 * * `WORKFLOW_ASSIGNMENT` - Workflow Assignment
 * * `READY_FOR_ONBOARDING_STEP_1` - Ready For Onboarding Step 1
 * * `READY_FOR_ONBOARDING_STEP_2` - Ready For Onboarding Step 2
 * * `DATA_COLLECTION` - Data Collection
 * * `ALL_DATA_COLLECTED` - All Data Collected
 * * `DOCUMENT_DRAFTING` - Document Drafting
 * * `ALL_DOCUMENTS_DRAFTED` - All Documents Drafted
 * * `READY_FOR_EXPORT` - Ready For Export
 * * `EXPORTED` - Exported
 * * `ABORTED` - Aborted
 */
export const CurrentStateEnum = {
    CREATED: 'CREATED',
    CLIENT_INFO_GATHERING: 'CLIENT_INFO_GATHERING',
    PRE_CASE_CONTEXT_GATHERING: 'PRE_CASE_CONTEXT_GATHERING',
    CASE_CONTEXT_GATHERING: 'CASE_CONTEXT_GATHERING',
    POST_CASE_CONTEXT_GATHERING: 'POST_CASE_CONTEXT_GATHERING',
    LEGAL_DOMAIN_CLASSIFICATION: 'LEGAL_DOMAIN_CLASSIFICATION',
    WORKFLOW_ASSIGNMENT: 'WORKFLOW_ASSIGNMENT',
    READY_FOR_ONBOARDING_STEP_1: 'READY_FOR_ONBOARDING_STEP_1',
    READY_FOR_ONBOARDING_STEP_2: 'READY_FOR_ONBOARDING_STEP_2',
    DATA_COLLECTION: 'DATA_COLLECTION',
    ALL_DATA_COLLECTED: 'ALL_DATA_COLLECTED',
    DOCUMENT_DRAFTING: 'DOCUMENT_DRAFTING',
    ALL_DOCUMENTS_DRAFTED: 'ALL_DOCUMENTS_DRAFTED',
    READY_FOR_EXPORT: 'READY_FOR_EXPORT',
    EXPORTED: 'EXPORTED',
    ABORTED: 'ABORTED'
} as const;

export type CustomerAccount = {
    uuid?: string;
    account_id: string;
};

export type CustomerAccountRequest = {
    uuid?: string;
    account_id: string;
};

/**
 * ActionAutoCommitSettings representation for customers.
 */
export type CustomerActionAutoCommitSettings = {
    readonly uuid: string;
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * ActionAutoCommitSettings representation for customers.
 */
export type CustomerActionAutoCommitSettingsRequest = {
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for customer role.
 */
export type CustomerActivity = {
    uuid?: string;
    readonly created_at: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
    readonly case_uuid: string;
    readonly case_client_display_name: string;
    readonly case_client_initials: string;
    readonly case_client_email: string;
    readonly clerk_uuid: string | null;
    readonly clerk_first_name: string | null;
    readonly clerk_last_name: string | null;
    readonly document_title: string | null;
    readonly questionnaire_title: string | null;
    readonly email_from: string | null;
    readonly email_to: string;
    readonly appointment_start: string | null;
    readonly appointment_is_confirmed: boolean | null;
};

/**
 * Activity serializer for customer role.
 */
export type CustomerActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
};

export type CustomerAdminAccount = {
    uuid?: string;
    account_id: string;
};

export type CustomerAdminAccountRequest = {
    uuid?: string;
    account_id: string;
};

/**
 * ActionAutoCommitSettings representation for customer admins.
 */
export type CustomerAdminActionAutoCommitSettings = {
    readonly uuid: string;
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * ActionAutoCommitSettings representation for customer admins.
 */
export type CustomerAdminActionAutoCommitSettingsRequest = {
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for customer admin role.
 */
export type CustomerAdminActivity = {
    uuid?: string;
    readonly created_at: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
    readonly case_uuid: string;
    readonly case_client_display_name: string;
    readonly case_client_initials: string;
    readonly case_client_email: string;
    readonly clerk_uuid: string | null;
    readonly clerk_first_name: string | null;
    readonly clerk_last_name: string | null;
    readonly document_title: string | null;
    readonly questionnaire_title: string | null;
    readonly email_from: string | null;
    readonly email_to: string;
    readonly appointment_start: string | null;
    readonly appointment_is_confirmed: boolean | null;
};

/**
 * Activity serializer for customer admin role.
 */
export type CustomerAdminActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
};

/**
 * AgentAction representation for customer admins.
 */
export type CustomerAdminAgentAction = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    readonly agent: string;
    readonly agent_trace_id: string;
    readonly calling_agent: string | null;
    readonly calling_agent_trace_id: string | null;
    readonly action_type: ActionTypeEnum;
    readonly delivery_mode: DeliveryModeEnum;
    readonly reasoning_translation: string;
    readonly reasoning_commit_decision_translation: string;
    readonly payload: string;
    readonly revert_payload: string;
    readonly is_commitable: boolean;
    readonly is_committed: boolean;
    readonly is_committing: boolean;
    readonly commit_return_value: unknown;
    readonly commited_at: string | null;
    readonly commited_by_uuid: string;
    readonly has_commit_error: boolean | null;
    readonly commit_error: string | null;
    readonly is_revertable: boolean;
    readonly is_reverted: boolean;
    readonly is_reverting: boolean;
    readonly revert_return_value: unknown;
    readonly reverted_at: string | null;
    readonly reverted_by_uuid: string;
    readonly has_revert_error: boolean | null;
    readonly revert_error: string | null;
    readonly case_uuid: string;
    readonly org_uuid: string;
    readonly rating: string | null;
    readonly langfuse_trace_url: string;
};

export type CustomerAdminAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAdminAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAdminAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type CustomerAdminAiAugmentationRequest = {
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * AI Settings representation for customer admins.
 */
export type CustomerAdminAiSettings = {
    readonly uuid: string;
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * AI Settings representation for customer admins.
 */
export type CustomerAdminAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * Appointment representation for customer admins.
 */
export type CustomerAdminAppointment = {
    uuid?: string;
    readonly service: CustomerAdminService;
    readonly calendar: CustomerAdminCalendar;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: AppointmentStatusEnum;
    summary: string;
    /**
     * Whether this appointment was successfully synced to Cronofy calendar
     */
    cronofy_synced?: boolean;
};

export type CustomerAdminAppointmentProposal = {
    uuid?: string;
    readonly service: CustomerAdminService;
    readonly calendar: CustomerAdminCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message?: string | null;
    readonly channel: string | null;
};

export type CustomerAdminAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message?: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Customer admin workflow assignment response.
 */
export type CustomerAdminAssignWorkflowResponse = {
    /**
     * Assigned workflow details, null if no workflow is assigned
     */
    assigned_workflow: (CustomerAdminCaseLifecycleWorkflow) | null;
};

export type CustomerAdminCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: CustomerAdminAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type CustomerAdminCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Case representation for customer admins.
 */
export type CustomerAdminCase = {
    readonly id: number;
    uuid?: string;
    readonly questionnaire_submissions: Array<CustomerAdminQuestionnaireSubmission>;
    readonly form_requests: Array<CustomerRequest>;
    readonly org: CustomerAdminOrganisation;
    readonly modified_at: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerAdminCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    readonly pdf_form_submissions: string;
    readonly virtual_documents: string;
    readonly clerk: CustomerAdminOrganisationUser;
    readonly forms: Array<CustomerAdminForm>;
    readonly services: string;
    readonly chat_sessions: Array<AIChatSession>;
    readonly activities: Array<Activity>;
    readonly case_lifecycle_state: CustomerAdminCaseLifecycleState;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    readonly source_call_uuid: string;
    user_access_token?: string;
};

export type CustomerAdminCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<CustomerAdminEntityWithRelationship>;
    readonly changes: Array<CustomerAdminCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type CustomerAdminCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAdminAiAugmentation;
};

export type CustomerAdminCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAdminAiAugmentationRequest;
};

export type CustomerAdminCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Case Lifecycle State representation for customer admins.
 */
export type CustomerAdminCaseLifecycleState = {
    readonly uuid: string;
    readonly current_state: CurrentStateEnum;
    readonly assigned_workflow: CustomerAdminCaseLifecycleWorkflow;
    readonly state_transition_results: Array<CaseLifecycleStateTransitionResult>;
    is_agent_active?: boolean;
    readonly rating: string | null;
    readonly langfuse_session_url: string;
};

/**
 * Case Lifecycle State representation for customer admins.
 */
export type CustomerAdminCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for customer admins.
 */
export type CustomerAdminCaseLifecycleWorkflow = {
    readonly uuid: string;
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettings>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettings>;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Case Lifecycle Workflow representation for customer admins.
 */
export type CustomerAdminCaseLifecycleWorkflowRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for customer admins.
 */
export type CustomerAdminCaseRequest = {
    uuid?: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerAdminCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    user_access_token?: string;
};

export type CustomerAdminDeliveryEvent = {
    readonly uuid: string;
    readonly event: EventEnum;
    readonly event_description: string | null;
    readonly created_at: string;
    readonly updated_at: string;
};

export type CustomerAdminDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type CustomerAdminDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type CustomerAdminEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
    readonly direction: string;
    readonly source: string;
    readonly sent_at: string;
    readonly pdf_url: string;
    readonly relevant_delivery_event: CustomerAdminDeliveryEvent;
    readonly email_service: EmailServiceEnum;
};

export type CustomerAdminEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<CustomerAdminQuestionnaire>;
    readonly forms: Array<CustomerAdminForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type CustomerAdminEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for customer admins.
 */
export type CustomerAdminEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<CustomerAdminEntityChange>;
};

export type CustomerAdminEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAdminAiAugmentation;
};

export type CustomerAdminEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAdminAiAugmentationRequest;
};

/**
 * Entity representation for customer admins.
 */
export type CustomerAdminEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type CustomerAdminEntityWithRelationship = {
    uuid?: string;
    entity: CustomerAdminEntity;
    relationships: Array<EntityRelationship>;
};

export type CustomerAdminEntityWithRelationshipRequest = {
    uuid?: string;
    entity: CustomerAdminEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

/**
 * Form representation for customer admins.
 */
export type CustomerAdminForm = {
    readonly id: string;
    readonly organisation: CustomerAdminOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly created_by: CustomerAdminUser;
    readonly modified_by: CustomerAdminUser;
    readonly tag: FormTag;
    title?: string;
    description?: string;
    readonly md5: string;
    readonly file: string | null;
    readonly due_at: string;
    readonly document_name: string;
};

/**
 * Form representation for customer admins.
 */
export type CustomerAdminFormRequest = {
    title?: string;
    description?: string;
};

export type CustomerAdminOnboardingPackage = {
    readonly uuid: string;
    name: string;
    readonly questionnaires: Array<CustomerAdminQuestionnaire>;
    readonly forms: Array<CustomerAdminForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
    readonly created_by_name: string;
};

export type CustomerAdminOnboardingPackageRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Organisation representation for customer admins.
 */
export type CustomerAdminOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    description?: string;
    readonly law_fields: unknown;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    readonly inbound_email_slug: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    readonly seats: number;
    readonly appointments_seats: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    readonly is_actaport_export_integration_enabled: boolean;
    readonly questionnaire_creation_token: string;
    readonly ai_enabled: boolean;
    readonly enable_ai_workflows: boolean;
    readonly is_iusta_egress_integration_enabled: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    readonly is_advolux_export_integration_enabled: boolean;
    readonly is_webhooks_egress_integration_enabled: boolean;
    webhook_urls?: string | null;
    readonly is_email_egress_integration_enabled: boolean;
    email_egress_address?: string | null;
    readonly is_kleos_integration_enabled: boolean;
    readonly is_advoware_export_integration_enabled: boolean;
    readonly is_law_firm_software_exportation_enabled: boolean;
    readonly enable_appointments: boolean;
    readonly enable_voice: boolean;
    readonly enable_cases: boolean;
    readonly is_hubspot_egress_integration_enabled: boolean;
    readonly is_haveibeenpwned_integration_enabled: boolean;
    readonly is_jurnodes_export_integration_enabled: boolean;
    is_datev_export_integration_enabled?: boolean;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly users: Array<CustomerAdminOrganisationUser>;
    readonly receive_monthly_updates_summary: boolean;
    has_churned?: boolean;
    readonly enable_law_specific_data: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
    readonly is_new_ui_switch_enabled: boolean;
    readonly is_forced_to_use_new_ui: boolean;
    readonly is_phonebot_self_service_customer: boolean;
    readonly phonebot_self_service_plan: PhonebotSelfServicePlanEnum | NullEnum | null;
    readonly phonebot_trial_ends_at: string | null;
    readonly onboarding_start_date: string | null;
    theme?: ThemeEnum;
};

/**
 * Organisation representation for customer admins.
 */
export type CustomerAdminOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    is_datev_export_integration_enabled?: boolean;
    has_churned?: boolean;
    theme?: ThemeEnum;
};

export type CustomerAdminOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type CustomerAdminPhoneNumber = {
    readonly uuid: string;
    active?: boolean;
    readonly org: CustomerOrganisation;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
    readonly forwarding_rules: Array<PhoneForwardingRuleList>;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type CustomerAdminPhoneNumberRequest = {
    active?: boolean;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type CustomerAdminQuestionnaire = {
    readonly uuid: string;
    title: string;
    description?: string;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
    /**
     * True if this questionnaire is a Jupus template that can be copied by organizations
     */
    readonly is_jupus_template: boolean;
    readonly org: ClientOrganisation;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
    readonly created_by_name: string;
    readonly questionnaire_creation_token: string;
    readonly org_questionnaire_creation_token: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type CustomerAdminQuestionnaireRequest = {
    title: string;
    description?: string;
    schema: Array<QuestionnaireSectionRequest>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type CustomerAdminQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly is_third_party_questionnaire: boolean;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type CustomerAdminQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type CustomerAdminService = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
    readonly calendars: Array<Calendar>;
    readonly location_types: string;
    readonly availability_query: {
        [key: string]: unknown;
    };
};

export type CustomerAdminServiceRequest = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customer admins.
 */
export type CustomerAdminUser = {
    readonly uuid: string;
    readonly email: string;
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: string | null;
    readonly org: CustomerAdminOrganisation;
    readonly uid: number;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
    /**
     * Check if the current session is an impersonated session.
     *
     * :param obj: The user object being serialized
     * :return: True if this is an impersonated session, False otherwise
     */
    readonly is_impersonated_session: boolean;
};

/**
 * User representation for customer admins.
 */
export type CustomerAdminUserRequest = {
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type CustomerAdminWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    readonly original_docx_template: string | null;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type CustomerAdminWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

/**
 * AgentAction representation for customers.
 */
export type CustomerAgentAction = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    readonly agent: string;
    readonly agent_trace_id: string;
    readonly calling_agent: string | null;
    readonly calling_agent_trace_id: string | null;
    readonly action_type: ActionTypeEnum;
    readonly delivery_mode: DeliveryModeEnum;
    readonly reasoning_translation: string;
    readonly reasoning_commit_decision_translation: string;
    readonly payload: string;
    readonly revert_payload: string;
    readonly is_commitable: boolean;
    readonly is_committed: boolean;
    readonly is_committing: boolean;
    readonly commit_return_value: unknown;
    readonly commited_at: string | null;
    readonly commited_by_uuid: string;
    readonly has_commit_error: boolean | null;
    readonly commit_error: string | null;
    readonly is_revertable: boolean;
    readonly is_reverted: boolean;
    readonly is_reverting: boolean;
    readonly revert_return_value: unknown;
    readonly reverted_at: string | null;
    readonly reverted_by_uuid: string;
    readonly has_revert_error: boolean | null;
    readonly revert_error: string | null;
    readonly case_uuid: string;
    readonly org_uuid: string;
    readonly rating: string | null;
    readonly langfuse_trace_url: string;
};

export type CustomerAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type CustomerAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type CustomerAiAugmentationRequest = {
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * AI Settings representation for customers.
 */
export type CustomerAiSettings = {
    readonly uuid: string;
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * AI Settings representation for customers.
 */
export type CustomerAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * Appointment representation for customers.
 */
export type CustomerAppointment = {
    readonly uuid: string;
    service: CustomerService;
    calendar: CustomerCalendar;
    start: string;
    readonly end: string;
    location_types?: LocationTypesEnum;
    readonly location: unknown;
    readonly conferencing: unknown;
    readonly description: string;
    readonly status: AppointmentStatusEnum;
    readonly summary: string;
    /**
     * Whether this appointment was successfully synced to Cronofy calendar
     */
    readonly cronofy_synced: boolean;
};

export type CustomerAppointmentProposal = {
    uuid?: string;
    readonly service: CustomerService;
    readonly calendar: CustomerCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message?: string | null;
    readonly channel: string | null;
    readonly created_at: string | null;
};

export type CustomerAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message?: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Appointment representation for customers.
 */
export type CustomerAppointmentRequest = {
    service: CustomerServiceRequest;
    calendar: CustomerCalendarRequest;
    start: string;
    location_types?: LocationTypesEnum;
    case: number;
};

/**
 * Customer workflow assignment response.
 */
export type CustomerAssignWorkflowResponse = {
    /**
     * Assigned workflow details, null if no workflow is assigned
     */
    assigned_workflow: (CustomerCaseLifecycleWorkflow) | null;
};

export type CustomerCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: CustomerAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type CustomerCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Call representation for customers.
 */
export type CustomerCall = {
    readonly uuid: string;
    /**
     * Return the URL of the audio recording of the call.
     */
    readonly audio_recording_url: string | null;
    readonly call_start_time: string;
    readonly call_end_time: string | null;
    readonly phone_number: CustomerPhoneNumber;
    result: CustomerCallResult;
    readonly lawyer_feedback: CustomerLawyerFeedback;
    readonly duration: number;
    readonly case_uuid: string;
    readonly case_id: number;
    readonly case: CaseInfo;
    note?: string | null;
    readonly clerk: CustomerOrganisationUser;
    forward?: (Forward) | null;
};

/**
 * Call representation for customers.
 */
export type CustomerCallRequest = {
    result: CustomerCallResultRequest;
    note?: string | null;
    clerk_id?: string | null;
    forward?: (ForwardRequest) | null;
};

export type CustomerCallResult = {
    readonly uuid: string;
    readonly classification: ClassificationEnum;
    readonly inquiry: string;
    data: ShallowCaseData;
    readonly first_name_recording_start_seconds: string | null;
    readonly first_name_recording_end_seconds: string | null;
    readonly last_name_recording_start_seconds: string | null;
    readonly last_name_recording_end_seconds: string | null;
    readonly email_recording_start_seconds: string | null;
    readonly email_recording_end_seconds: string | null;
    readonly phone_number_recording_start_seconds: string | null;
    readonly phone_number_recording_end_seconds: string | null;
};

export type CustomerCallResultRequest = {
    data: ShallowCaseDataRequest;
};

/**
 * Case representation for customers.
 */
export type CustomerCase = {
    readonly id: number;
    uuid?: string;
    readonly questionnaire_submissions: Array<CustomerQuestionnaireSubmission>;
    readonly form_requests: Array<CustomerRequest>;
    readonly org: CustomerOrganisation;
    readonly modified_at: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    readonly pdf_form_submissions: string;
    readonly virtual_documents: string;
    readonly clerk: CustomerOrganisationUser;
    readonly services: string;
    readonly chat_sessions: Array<AIChatSession>;
    readonly activities: Array<Activity>;
    readonly case_lifecycle_state: CustomerCaseLifecycleState;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    readonly source_call_uuid: string;
    user_access_token?: string;
};

export type CustomerCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<CustomerEntityWithRelationship>;
    readonly changes: Array<CustomerCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type CustomerCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAiAugmentation;
};

export type CustomerCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAiAugmentationRequest;
};

export type CustomerCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Case Lifecycle State representation for customers.
 */
export type CustomerCaseLifecycleState = {
    readonly uuid: string;
    readonly current_state: CurrentStateEnum;
    readonly assigned_workflow: CustomerCaseLifecycleWorkflow;
    readonly state_transition_results: Array<CaseLifecycleStateTransitionResult>;
    is_agent_active?: boolean;
    readonly rating: string | null;
    readonly langfuse_session_url: string;
};

/**
 * Case Lifecycle State representation for customers.
 */
export type CustomerCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for customers.
 */
export type CustomerCaseLifecycleWorkflow = {
    readonly uuid: string;
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerActionAutoCommitSettings>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerActionAutoCommitSettings>;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Case Lifecycle Workflow representation for customers.
 */
export type CustomerCaseLifecycleWorkflowRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for customers.
 */
export type CustomerCaseRequest = {
    uuid?: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    user_access_token?: string;
};

export type CustomerDeliveryEvent = {
    readonly uuid: string;
    readonly event: EventEnum;
    readonly event_description: string | null;
    readonly created_at: string;
    readonly updated_at: string;
};

export type CustomerDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type CustomerDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type CustomerEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
    readonly direction: string;
    readonly source: string;
    readonly sent_at: string;
    readonly pdf_url: string;
    readonly relevant_delivery_event: CustomerDeliveryEvent;
    readonly email_service: EmailServiceEnum;
};

export type CustomerEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<CustomerQuestionnaire>;
    readonly forms: Array<CustomerForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type CustomerEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for customers.
 */
export type CustomerEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<CustomerEntityChange>;
};

export type CustomerEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: CustomerOrganisationUser;
    ai_augmentation: CustomerAiAugmentation;
};

export type CustomerEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: CustomerAiAugmentationRequest;
};

/**
 * Entity representation for customers.
 */
export type CustomerEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type CustomerEntityWithRelationship = {
    uuid?: string;
    entity: CustomerEntity;
    relationships: Array<EntityRelationship>;
};

export type CustomerEntityWithRelationshipRequest = {
    uuid?: string;
    entity: CustomerEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

/**
 * Form representation for customers.
 */
export type CustomerForm = {
    readonly id: string;
    readonly organisation: CustomerOrganisation;
    readonly created_at: string;
    readonly modified_at: string;
    readonly created_by: CustomerUser;
    readonly modified_by: CustomerUser;
    readonly tag: FormTag;
    title?: string;
    description?: string;
    readonly file: string | null;
    readonly due_at: string;
    readonly document_name: string;
};

/**
 * Form representation for customers.
 */
export type CustomerFormRequest = {
    title?: string;
    description?: string;
};

export type CustomerLawyerFeedback = {
    readonly uuid: string;
    rating: string;
    feedback?: string;
};

export type CustomerLawyerFeedbackRequest = {
    rating: string;
    feedback?: string;
    call_uuid: string;
};

export type CustomerOnboardingPackage = {
    readonly uuid: string;
    name: string;
    readonly questionnaires: Array<CustomerQuestionnaire>;
    readonly forms: Array<CustomerForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type CustomerOnboardingPackageRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Organisation representation for customers.
 */
export type CustomerOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    readonly law_fields: unknown;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    readonly inbound_email_slug: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    readonly seats: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    readonly is_actaport_export_integration_enabled: boolean;
    readonly questionnaire_creation_token: string;
    readonly ai_enabled: boolean;
    readonly enable_ai_workflows: boolean;
    readonly is_iusta_egress_integration_enabled: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    readonly ra_micro_export_integration_type: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    readonly ra_micro_oma_email_id: string | null;
    readonly ra_micro_oma_email: string | null;
    ra_micro_upload_limit_mb?: number;
    readonly is_advolux_export_integration_enabled: boolean;
    readonly is_webhooks_egress_integration_enabled: boolean;
    webhook_urls?: string | null;
    readonly is_email_egress_integration_enabled: boolean;
    email_egress_address?: string | null;
    readonly is_kleos_integration_enabled: boolean;
    readonly is_advoware_export_integration_enabled: boolean;
    readonly is_law_firm_software_exportation_enabled: boolean;
    readonly enable_appointments: boolean;
    readonly appointments_seats: number;
    enable_cases?: boolean;
    readonly enable_voice: boolean;
    readonly is_hubspot_egress_integration_enabled: boolean;
    readonly is_haveibeenpwned_integration_enabled: boolean;
    readonly is_jurnodes_export_integration_enabled: boolean;
    is_datev_export_integration_enabled?: boolean;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly users: Array<CustomerOrganisationUser>;
    receive_monthly_updates_summary?: boolean;
    readonly enable_law_specific_data: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
    readonly is_new_ui_switch_enabled: boolean;
    readonly is_forced_to_use_new_ui: boolean;
    readonly is_phonebot_self_service_customer: boolean;
    readonly phonebot_self_service_plan: PhonebotSelfServicePlanEnum | NullEnum | null;
    readonly phonebot_trial_ends_at: string | null;
    readonly onboarding_start_date: string | null;
    theme?: ThemeEnum;
};

/**
 * Organisation representation for customers.
 */
export type CustomerOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_upload_limit_mb?: number;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    enable_cases?: boolean;
    is_datev_export_integration_enabled?: boolean;
    receive_monthly_updates_summary?: boolean;
    theme?: ThemeEnum;
};

export type CustomerOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * PhoneNumber representation for customers.
 */
export type CustomerPhoneNumber = {
    readonly uuid: string;
    readonly active: boolean;
    readonly org: CustomerOrganisation;
    readonly phone_number: string | null;
    readonly law_fields: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    readonly description: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    readonly lawfirm_name: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    readonly address: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    readonly opening_hours: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    readonly lawyer_names: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    readonly has_free_initial_consultation: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    readonly original_phone_number: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    readonly can_record_calls: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    readonly begin_message: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    readonly forwarding_no_answer_message: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    readonly end_message: string;
    readonly forwarding_rules: Array<PhoneForwardingRuleList>;
};

/**
 * Questionnaire representation for customers.
 */
export type CustomerQuestionnaire = {
    readonly uuid: string;
    title: string;
    description?: string;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
    /**
     * True if this questionnaire is a Jupus template that can be copied by organizations
     */
    readonly is_jupus_template: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
    readonly created_by_name: string;
    readonly questionnaire_creation_token: string;
    readonly org: ClientOrganisation;
    readonly org_questionnaire_creation_token: string;
};

/**
 * Questionnaire representation for customers.
 */
export type CustomerQuestionnaireRequest = {
    title: string;
    description?: string;
    schema: Array<QuestionnaireSectionRequest>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
};

/**
 * Questionnaire submission representation for customers.
 */
export type CustomerQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly is_third_party_questionnaire: boolean;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for customers.
 */
export type CustomerQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type CustomerRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
    readonly document_uuid: string;
    is_third_party?: boolean;
};

export type CustomerRequestRequest = {
    token: string;
    form: string;
    is_third_party?: boolean;
};

export type CustomerService = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    readonly calendars: Array<Calendar>;
    readonly location_types: string;
    readonly availability_query: {
        [key: string]: unknown;
    };
};

export type CustomerServiceRequest = {
    uuid?: string;
    org: number;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
};

/**
 * User representation for customers.
 */
export type CustomerUser = {
    readonly uuid: string;
    readonly email: string;
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: string | null;
    readonly org: CustomerOrganisation;
    readonly uid: number;
    readonly role: Role5ccEnum | NullEnum | null;
    email_signature?: string;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
    /**
     * Check if the current session is an impersonated session.
     *
     * :param obj: The user object being serialized
     * :return: True if this is an impersonated session, False otherwise
     */
    readonly is_impersonated_session: boolean;
};

/**
 * User representation for customers.
 */
export type CustomerUserRequest = {
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    email_signature?: string;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type CustomerWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    readonly original_docx_template: string | null;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type CustomerWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

/**
 * Serializer for DATEV export integration data.
 * This handles the specific data needed for DATEV Anwalt Inkasso-Import format.
 */
export type DatevDataRequest = {
    fileData?: Array<FileDataRequest>;
    /**
     * List of entity relationship UUIDs to include in the export
     */
    entities_with_relationships: Array<(string)>;
    /**
     * Custom case name for the export
     */
    custom_case_name?: string;
    /**
     * Case group identifier
     */
    case_group?: string;
};

export type DeliveryEventRequest = {
    uuid?: string;
};

/**
 * * `RECOMMENDATION` - Recommendation
 * * `AUTO_COMMIT` - Auto Commit
 */
export type DeliveryModeEnum = 'RECOMMENDATION' | 'AUTO_COMMIT';

/**
 * * `RECOMMENDATION` - Recommendation
 * * `AUTO_COMMIT` - Auto Commit
 */
export const DeliveryModeEnum = {
    RECOMMENDATION: 'RECOMMENDATION',
    AUTO_COMMIT: 'AUTO_COMMIT'
} as const;

export type Document = {
    readonly uuid: string;
    readonly created_at: string;
    readonly document_type: DocumentTypeEnum;
    readonly title: string;
    readonly filename: string;
    readonly is_uploaded: boolean;
    readonly upload_origin: UploadOriginEnum | NullEnum | null;
    readonly url: string;
    readonly page_count: number;
    readonly filesize: number;
    readonly images: Array<ImageproxyImagePreset>;
    readonly needs_ocr: boolean;
    readonly ocr_started_at: string | null;
    readonly ocr_finished_at: string | null;
    readonly ocr_is_finished: boolean | null;
    readonly needs_embeddings: boolean;
    readonly embeddings_started_at: string | null;
    readonly embeddings_finished_at: string | null;
    readonly embeddings_is_finished: boolean | null;
    readonly needs_summary: boolean;
    readonly summary_started_at: string | null;
    readonly summary_finished_at: string | null;
    readonly summary_is_finished: boolean | null;
    readonly needs_summary_embedding: boolean;
    readonly summary_embedding_started_at: string | null;
    readonly summary_embedding_finished_at: string | null;
    readonly summary_embedding_is_finished: boolean | null;
    readonly needs_raptor_summaries: boolean;
    readonly raptor_summaries_started_at: string | null;
    readonly raptor_summaries_finished_at: string | null;
    readonly raptor_summaries_is_finished: boolean | null;
    readonly needs_analysis: boolean;
    readonly analysis_started_at: string | null;
    readonly analysis_finished_at: string | null;
    readonly analysis_is_finished: boolean | null;
    readonly needs_metadata_enrichment: boolean;
    readonly metadata_enrichment_started_at: string | null;
    readonly metadata_enrichment_finished_at: string | null;
    readonly metadata_enrichment_is_finished: boolean | null;
    readonly metadata_enrichment_error: string | null;
    readonly embeddings_error: string | null;
    readonly summary_error: string | null;
    readonly summary_embedding_error: string | null;
    readonly raptor_summaries_error: string | null;
    readonly analysis_error: string | null;
    readonly document_status: DocumentStatusEnum;
    readonly source_type: string;
    readonly source_id: string;
    /**
     * Return True if a modified PDF exists.
     */
    readonly is_pdf_modified: boolean;
    /**
     * Timestamp when the PDF was last modified
     */
    readonly pdf_modified_at: string | null;
    /**
     * Get the URL of the current PDF file (modified if available, otherwise original).
     *
     * :return: The URL of the current PDF file.
     */
    readonly current_pdf_url: string | null;
    /**
     * Get the URL of the original PDF file.
     *
     * :return: The URL of the original PDF file.
     */
    readonly original_pdf_url: string | null;
    readonly case_uuid: string;
    readonly case_number: string;
    readonly case_id: string;
    readonly organization_name: string;
    readonly organization_uuid: string;
    readonly organization_customer_number: string;
    readonly platform_sync_status: PlatformSyncStatusEnum;
    readonly actaport_id: string;
    readonly actaport_url: string;
    readonly is_virtual: string;
};

export type DocumentAiContext = {
    created_at: string;
    uuid: string;
    document_type: string;
    is_uploaded: boolean;
    upload_origin?: string | null;
    title: string;
    summary: string;
    relevant_content: DocumentContent;
};

export type DocumentContent = {
    pages: number;
    text: string;
};

/**
 * Response serializer for document edit token creation.
 */
export type DocumentEditTokenResponse = {
    token: string;
    expires_at: string;
    document_uuid: string;
    onlyoffice_jwt: string;
    resource_type: ResourceTypeEnum;
};

export type DocumentGeneratorRelatedData = {
    template_uuid?: string | null;
    document_uuid?: string | null;
};

/**
 * Serializer for document group state.
 */
export type DocumentGroupStateRequest = {
    /**
     * Name of the document group
     */
    name: string;
    /**
     * Pages in this document group
     */
    pages: Array<PageStateRequest>;
};

/**
 * Serializer for the complete document organization state.
 */
export type DocumentOrganizationStateRequest = {
    document_groups: Array<DocumentGroupStateRequest>;
};

export type DocumentPlaceholder = {
    readonly uuid: string;
    placeholder_name: string;
    german_label?: string | null;
    english_label?: string | null;
    readonly template_count: string;
    readonly created_at: string;
    readonly updated_at: string;
};

export type DocumentPlaceholderGenerateLabelsRequest = {
    placeholder_name: string;
};

export type DocumentPlaceholderLabelsResponse = {
    german_label?: string;
    english_label?: string;
};

export type DocumentPlaceholderRequest = {
    placeholder_name: string;
    german_label?: string | null;
    english_label?: string | null;
};

export type DocumentPlaceholderUpdate = {
    german_label?: string | null;
    english_label?: string | null;
};

export type DocumentPlaceholderUpdateRequest = {
    german_label?: string | null;
    english_label?: string | null;
};

/**
 * Serializer for document properties.
 */
export type DocumentProperties = {
    id: string;
    title: string;
    description: string;
    tag: string;
    readonly download: string;
    readonly annotationData: string;
    readonly signatures: string;
    md5: string;
    readonly filename: string;
};

/**
 * Serializer for document reorganization error responses.
 */
export type DocumentReorganizationErrorResponse = {
    /**
     * Error message describing what went wrong
     */
    error: string;
    /**
     * Detailed error information for debugging
     */
    details: string;
};

/**
 * Serializer for document reorganization requests.
 */
export type DocumentReorganizationRequestRequest = {
    /**
     * UUID of the case containing the documents
     */
    case_uuid: string;
    /**
     * List of reorganization operations to perform
     */
    operations: Array<ReorganizationOperationRequest>;
};

/**
 * Serializer for document reorganization responses.
 */
export type DocumentReorganizationResponse = {
    /**
     * Success message describing the operation result
     */
    message: string;
    /**
     * List of newly created documents from the reorganization
     */
    created_documents: Array<Document>;
    /**
     * List of UUIDs of deleted documents
     */
    deleted_documents: Array<(string)>;
    /**
     * Number of reorganization operations performed
     */
    operations_count: number;
};

/**
 * Request serializer for AI document splitting.
 */
export type DocumentSplitWithAIRequestRequest = {
    /**
     * UUID of the case containing the document
     */
    case_uuid: string;
    /**
     * UUID of the document to split
     */
    document_uuid: string;
    /**
     * Current state of document groups in the frontend
     */
    current_organization_state?: DocumentOrganizationStateRequest;
};

/**
 * Response serializer for AI document splitting.
 */
export type DocumentSplitWithAIResponse = {
    /**
     * Success message
     */
    message: string;
    /**
     * Suggested document groups
     */
    document_groups: Array<AISplitGroupResponse>;
};

/**
 * * `requested` - Requested
 * * `received` - Received
 * * `completed` - Completed
 */
export type DocumentStatusEnum = 'requested' | 'received' | 'completed';

/**
 * * `requested` - Requested
 * * `received` - Received
 * * `completed` - Completed
 */
export const DocumentStatusEnum = {
    REQUESTED: 'requested',
    RECEIVED: 'received',
    COMPLETED: 'completed'
} as const;

/**
 * Serializer specifically for document thumbnails.
 */
export type DocumentThumbnails = {
    readonly uuid: string;
    readonly thumbnails: Array<ImageproxyImagePreset>;
};

/**
 * * `Anfrage` - Case
 * * `Notiz` - Note
 * * `E-Mail` - Email
 * * `Upload` - Upload
 * * `Fragebogen` - Questionnaire
 * * `Dokumentenvorlage` - Pdf Template
 * * `Transkript` - Call Transcript
 * * `KI Dokumentengenerator Vorlage` - Ai Document Generator Template
 * * `KI generiertes Dokument` - Ai Generated Document
 * * `KI Chat` - Ai Case Chat
 * * `Globaler KI Chat` - Ai Global Chat
 */
export type DocumentTypeEnum = 'Anfrage' | 'Notiz' | 'E-Mail' | 'Upload' | 'Fragebogen' | 'Dokumentenvorlage' | 'Transkript' | 'KI Dokumentengenerator Vorlage' | 'KI generiertes Dokument' | 'KI Chat' | 'Globaler KI Chat';

/**
 * * `Anfrage` - Case
 * * `Notiz` - Note
 * * `E-Mail` - Email
 * * `Upload` - Upload
 * * `Fragebogen` - Questionnaire
 * * `Dokumentenvorlage` - Pdf Template
 * * `Transkript` - Call Transcript
 * * `KI Dokumentengenerator Vorlage` - Ai Document Generator Template
 * * `KI generiertes Dokument` - Ai Generated Document
 * * `KI Chat` - Ai Case Chat
 * * `Globaler KI Chat` - Ai Global Chat
 */
export const DocumentTypeEnum = {
    ANFRAGE: 'Anfrage',
    NOTIZ: 'Notiz',
    E_MAIL: 'E-Mail',
    UPLOAD: 'Upload',
    FRAGEBOGEN: 'Fragebogen',
    DOKUMENTENVORLAGE: 'Dokumentenvorlage',
    TRANSKRIPT: 'Transkript',
    KI_DOKUMENTENGENERATOR_VORLAGE: 'KI Dokumentengenerator Vorlage',
    KI_GENERIERTES_DOKUMENT: 'KI generiertes Dokument',
    KI_CHAT: 'KI Chat',
    GLOBALER_KI_CHAT: 'Globaler KI Chat'
} as const;

export type DocumentUploadRequest = {
    file: (Blob | File);
    /**
     * Origin of the document upload
     *
     * * `None` - Not Set
     * * `Chatbot Upload` - Chatbot
     * * `Email Anhang` - Email
     * * `Terminbuchung` - Appointment
     * * `Fragebogen` - Questionnaire
     * * `Manuell hinzugefügt` - Manual
     * * `AI CASE CHAT` - Ai Case Chat
     * * `AI Global Chat` - Ai Global Chat
     * * `Dokument neu organisiert` - Reorganization
     * * `External platform` - External Platform
     */
    upload_origin?: UploadOriginEnum;
};

/**
 * Serializer for editor upload requests.
 */
export type EditorUploadRequest = {
    is_private: boolean;
};

/**
 * Serializer for editor upload responses.
 */
export type EditorUploadResponse = {
    link: string;
};

export type EmailAddress = {
    uuid?: string;
    email: string;
    name: string;
};

/**
 * Serializer for Email Egress integration settings in Organisation model.
 */
export type EmailEgressSettings = {
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
};

/**
 * Serializer for Email Egress integration settings in Organisation model.
 */
export type EmailEgressSettingsRequest = {
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
};

export type EmailRenderTemplateRequestRequest = {
    template_html: string;
    case_uuid?: string | null;
    subject: string;
    contexts?: Array<ContextRequest>;
};

export type EmailRenderTemplateResponse = {
    subject: string;
    text: string;
    html: string;
};

export type EmailRequest = {
    uuid?: string;
};

/**
 * * `BREVO` - Brevo
 * * `OTHER` - Other
 */
export type EmailServiceEnum = 'BREVO' | 'OTHER';

/**
 * * `BREVO` - Brevo
 * * `OTHER` - Other
 */
export const EmailServiceEnum = {
    BREVO: 'BREVO',
    OTHER: 'OTHER'
} as const;

/**
 * * `create` - Mandatsaufnahme
 * * `reject` - Mandatsablehnung
 */
export type EmailTemplateType = 'create' | 'reject';

/**
 * * `create` - Mandatsaufnahme
 * * `reject` - Mandatsablehnung
 */
export const EmailTemplateType = {
    CREATE: 'create',
    REJECT: 'reject'
} as const;

/**
 * * `#000000` - Black
 * * `#28324E` - Dark Grey
 * * `#2969B0` - Darker Blue
 * * `#2C82C9` - Dark Blue
 * * `#553982` - Dark Purple
 * * `#E25041` - Dark Red
 * * `#475577` - Grey
 * * `#9365B8` - Purple
 * * `#A38F84` - Brown
 * * `#1ABC9C` - Teal
 * * `#00A885` - Aqua
 * * `#3D8EB9` - Light Blue
 * * `#61BD6D` - Green
 * * `#41A85F` - Light Green
 * * `#54ACD2` - Blue
 * * `#EB6B56` - Red
 * * `#FBA026` - Orange
 * * `#F7DA64` - Yellow
 * * `#CCCCCC` - Light Grey
 */
export type EmailTextColorEnum = '#000000' | '#28324E' | '#2969B0' | '#2C82C9' | '#553982' | '#E25041' | '#475577' | '#9365B8' | '#A38F84' | '#1ABC9C' | '#00A885' | '#3D8EB9' | '#61BD6D' | '#41A85F' | '#54ACD2' | '#EB6B56' | '#FBA026' | '#F7DA64' | '#CCCCCC';

/**
 * * `#000000` - Black
 * * `#28324E` - Dark Grey
 * * `#2969B0` - Darker Blue
 * * `#2C82C9` - Dark Blue
 * * `#553982` - Dark Purple
 * * `#E25041` - Dark Red
 * * `#475577` - Grey
 * * `#9365B8` - Purple
 * * `#A38F84` - Brown
 * * `#1ABC9C` - Teal
 * * `#00A885` - Aqua
 * * `#3D8EB9` - Light Blue
 * * `#61BD6D` - Green
 * * `#41A85F` - Light Green
 * * `#54ACD2` - Blue
 * * `#EB6B56` - Red
 * * `#FBA026` - Orange
 * * `#F7DA64` - Yellow
 * * `#CCCCCC` - Light Grey
 */
export const EmailTextColorEnum = {
    _000000: '#000000',
    _28324E: '#28324E',
    _2969B0: '#2969B0',
    _2C82C9: '#2C82C9',
    _553982: '#553982',
    _E25041: '#E25041',
    _475577: '#475577',
    _9365B8: '#9365B8',
    _A38F84: '#A38F84',
    _1ABC9C: '#1ABC9C',
    _00A885: '#00A885',
    _3D8EB9: '#3D8EB9',
    _61BD6D: '#61BD6D',
    _41A85F: '#41A85F',
    _54ACD2: '#54ACD2',
    _EB6B56: '#EB6B56',
    _FBA026: '#FBA026',
    _F7DA64: '#F7DA64',
    _CCCCCC: '#CCCCCC'
} as const;

/**
 * * `Arial,Helvetica,sans-serif` - Arial
 * * `Georgia,serif` - Georgia
 * * `Impact,Charcoal,sans-serif` - Impact
 * * `Tahoma,Geneva,sans-serif` - Tahoma
 * * `'Times New Roman',Times,serif` - Times New Roman
 * * `Verdana,Geneva,sans-serif` - Verdana
 */
export type EmailTextFontEnum = 'Arial,Helvetica,sans-serif' | 'Georgia,serif' | 'Impact,Charcoal,sans-serif' | 'Tahoma,Geneva,sans-serif' | "'Times New Roman',Times,serif" | 'Verdana,Geneva,sans-serif';

/**
 * * `Arial,Helvetica,sans-serif` - Arial
 * * `Georgia,serif` - Georgia
 * * `Impact,Charcoal,sans-serif` - Impact
 * * `Tahoma,Geneva,sans-serif` - Tahoma
 * * `'Times New Roman',Times,serif` - Times New Roman
 * * `Verdana,Geneva,sans-serif` - Verdana
 */
export const EmailTextFontEnum = {
    ARIAL_HELVETICA_SANS_SERIF: 'Arial,Helvetica,sans-serif',
    GEORGIA_SERIF: 'Georgia,serif',
    IMPACT_CHARCOAL_SANS_SERIF: 'Impact,Charcoal,sans-serif',
    TAHOMA_GENEVA_SANS_SERIF: 'Tahoma,Geneva,sans-serif',
    _TIMES_NEW_ROMAN__TIMES_SERIF: "'Times New Roman',Times,serif",
    VERDANA_GENEVA_SANS_SERIF: 'Verdana,Geneva,sans-serif'
} as const;

/**
 * * `8` - Size 8
 * * `9` - Size 9
 * * `10` - Size 10
 * * `11` - Size 11
 * * `12` - Size 12
 * * `14` - Size 14
 * * `18` - Size 18
 */
export type EmailTextSizeEnum = 8 | 9 | 10 | 11 | 12 | 14 | 18;

/**
 * * `8` - Size 8
 * * `9` - Size 9
 * * `10` - Size 10
 * * `11` - Size 11
 * * `12` - Size 12
 * * `14` - Size 14
 * * `18` - Size 18
 */
export const EmailTextSizeEnum = {
    '_8': 8,
    '_9': 9,
    '_10': 10,
    '_11': 11,
    '_12': 12,
    '_14': 14,
    '_18': 18
} as const;

/**
 * * `entities.field.address_line_2` - entities.field.address_line_2
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.is_valid_email` - entities.field.is_valid_email
 * * `entities.field.is_valid_phone_number` - entities.field.is_valid_phone_number
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 */
export type EntitiesMapperKeyEnum = 'entities.field.address_line_2' | 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.is_valid_email' | 'entities.field.is_valid_phone_number' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip';

/**
 * * `entities.field.address_line_2` - entities.field.address_line_2
 * * `entities.field.bank_name` - entities.field.bank_name
 * * `entities.field.bic` - entities.field.bic
 * * `entities.field.city` - entities.field.city
 * * `entities.field.company_legal_form` - entities.field.company_legal_form
 * * `entities.field.company_name` - entities.field.company_name
 * * `entities.field.company_register_court` - entities.field.company_register_court
 * * `entities.field.company_register_number` - entities.field.company_register_number
 * * `entities.field.company_tax_id` - entities.field.company_tax_id
 * * `entities.field.company_vat_id` - entities.field.company_vat_id
 * * `entities.field.date_of_birth` - entities.field.date_of_birth
 * * `entities.field.date_of_death` - entities.field.date_of_death
 * * `entities.field.email` - entities.field.email
 * * `entities.field.entity_type` - entities.field.entity_type
 * * `entities.field.fax` - entities.field.fax
 * * `entities.field.first_name` - entities.field.first_name
 * * `entities.field.iban` - entities.field.iban
 * * `entities.field.institution_name` - entities.field.institution_name
 * * `entities.field.is_entitled_to_deduct_vat` - entities.field.is_entitled_to_deduct_vat
 * * `entities.field.is_valid_email` - entities.field.is_valid_email
 * * `entities.field.is_valid_phone_number` - entities.field.is_valid_phone_number
 * * `entities.field.last_name` - entities.field.last_name
 * * `entities.field.legal_insurance_deductible_amount` - entities.field.legal_insurance_deductible_amount
 * * `entities.field.legal_insurance` - entities.field.legal_insurance
 * * `entities.field.legal_insurance_name` - entities.field.legal_insurance_name
 * * `entities.field.legal_insurance_number` - entities.field.legal_insurance_number
 * * `entities.field.marital_status` - entities.field.marital_status
 * * `entities.field.phone` - entities.field.phone
 * * `entities.field.specific_title` - entities.field.specific_title
 * * `entities.field.street` - entities.field.street
 * * `entities.field.street_number` - entities.field.street_number
 * * `entities.field.title` - entities.field.title
 * * `entities.field.website` - entities.field.website
 * * `entities.field.zip` - entities.field.zip
 */
export const EntitiesMapperKeyEnum = {
    ENTITIES_FIELD_ADDRESS_LINE_2: 'entities.field.address_line_2',
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_IS_VALID_EMAIL: 'entities.field.is_valid_email',
    ENTITIES_FIELD_IS_VALID_PHONE_NUMBER: 'entities.field.is_valid_phone_number',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip'
} as const;

export type Entity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<(number)>;
};

export type EntityAddCaseDataRelationshipRequest = {
    case_data_uuid: string;
    relationship_type: RelationshipTypeEnum;
    number?: number | null;
};

export type EntityAugmentedFieldsRequest = {
    entity_type: string | null;
    title: string | null;
    specific_title: string | null;
    first_name: string | null;
    last_name: string | null;
    company_name: string | null;
    company_legal_form: string | null;
    institution_name: string | null;
    phone: string | null;
    email: string | null;
    date_of_birth: string | null;
    street: string | null;
    street_number: string | null;
    address_line_2: string | null;
    zip: string | null;
    city: string | null;
    legal_insurance: string | null;
    legal_insurance_number: string | null;
    legal_insurance_name: string | null;
};

export type EntityRelationship = {
    uuid?: string;
    relationship_type: RelationshipTypeEnum;
    is_unique_per_case: boolean;
    number: number | null;
};

export type EntityRelationshipRequest = {
    uuid?: string;
    relationship_type: RelationshipTypeEnum;
    is_unique_per_case: boolean;
    number: number | null;
};

export type EntityRemoveCaseDataRelationshipCustomerResponse = {
    relationship: (CustomerEntityWithRelationship) | null;
};

export type EntityRemoveCaseDataRelationshipRequestRequest = {
    case_data_uuid: string;
    relationship_uuid?: string | null;
    remove_case_data_association_if_no_relationships_exist?: boolean;
};

export type EntityRemoveCaseDataRelationshipSuperUserResponse = {
    relationship: (SuperUserEntityWithRelationship) | null;
};

export type EntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type EntityTypeC7aEnum = 'natural_person' | 'legal_person' | 'institution';

export const EntityTypeC7aEnum = {
    NATURAL_PERSON: 'natural_person',
    LEGAL_PERSON: 'legal_person',
    INSTITUTION: 'institution'
} as const;

/**
 * * `natural_person` - Natürliche Person
 * * `legal_person` - Juristische Person
 * * `institution` - Institution
 */
export type EntityTypeEnum = 'natural_person' | 'legal_person' | 'institution';

/**
 * * `natural_person` - Natürliche Person
 * * `legal_person` - Juristische Person
 * * `institution` - Institution
 */
export const EntityTypeEnum = {
    NATURAL_PERSON: 'natural_person',
    LEGAL_PERSON: 'legal_person',
    INSTITUTION: 'institution'
} as const;

/**
 * * `SENT` - Sent
 * * `DELIVERED` - Delivered
 * * `HARD_BOUNCED` - Hard Bounced
 * * `SOFT_BOUNCED` - Soft Bounced
 * * `BLOCKED` - Blocked
 * * `SPAM` - Spam
 * * `UNSUBSCRIBED` - Unsubscribed
 * * `OPENED` - Opened
 * * `CLICKED` - Clicked
 * * `UNKNOWN` - Unknown
 */
export type EventEnum = 'SENT' | 'DELIVERED' | 'HARD_BOUNCED' | 'SOFT_BOUNCED' | 'BLOCKED' | 'SPAM' | 'UNSUBSCRIBED' | 'OPENED' | 'CLICKED' | 'UNKNOWN';

/**
 * * `SENT` - Sent
 * * `DELIVERED` - Delivered
 * * `HARD_BOUNCED` - Hard Bounced
 * * `SOFT_BOUNCED` - Soft Bounced
 * * `BLOCKED` - Blocked
 * * `SPAM` - Spam
 * * `UNSUBSCRIBED` - Unsubscribed
 * * `OPENED` - Opened
 * * `CLICKED` - Clicked
 * * `UNKNOWN` - Unknown
 */
export const EventEnum = {
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    HARD_BOUNCED: 'HARD_BOUNCED',
    SOFT_BOUNCED: 'SOFT_BOUNCED',
    BLOCKED: 'BLOCKED',
    SPAM: 'SPAM',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
    OPENED: 'OPENED',
    CLICKED: 'CLICKED',
    UNKNOWN: 'UNKNOWN'
} as const;

/**
 * * `Logout` - Logout
 * * `Login` - Login
 * * `Bot Display` - Bot Display
 * * `Bot Session Started` - Bot Session Started
 * * `Bot Session Ended` - Bot Session Ended
 * * `Questionnaire Sent` - Questionnaire Sent
 * * `Questionnaire Completed` - Questionnaire Completed
 * * `PDFDocument Sent` - Form Sent
 * * `PDFDocument Completed` - Form Completed
 * * `Email Sent` - Email Sent
 * * `Email Received` - Email Received
 * * `Email Template Edited` - Email Template Edited
 * * `Case Created` - Case Created
 * * `Case Rejected` - Case Rejected
 * * `Case Accepted` - Case Completed
 * * `Case In Progress` - Case In Progress
 * * `Case Deleted` - Case Deleted
 * * `Case Exported` - Case Exported
 * * `Calculator Opened` - Calculator Opened
 * * `Calculator Saved` - Calculator Saved
 * * `Appointment Account Authorized` - Appointment Account Authorized
 * * `Appointment Account Revoked` - Appointment Account Revoked
 * * `Appointment Service Created` - Appointment Service Created
 * * `Appointment Service Edited` - Appointment Service Edited
 * * `Appointment Service Enabled` - Appointment Service Enabled
 * * `Appointment Service Disabled` - Appointment Service Disabled
 * * `Appointment Service Soft Deleted` - Appointment Service Soft Deleted
 * * `Appointment Service Recovered` - Appointment Service Recovered
 * * `Appointment Calendar Created` - Appointment Calendar Created
 * * `Appointment Calendar Edited` - Appointment Calendar Edited
 * * `Appointment Calendar Enabled` - Appointment Calendar Enabled
 * * `Appointment Calendar Disabled` - Appointment Calendar Disabled
 * * `Appointment Lawfields Edited` - Appointment Lawfields Edited
 * * `Appointment Setup Completed` - Appointment Setup Completed
 * * `Appointment Created` - Appointment Created
 * * `Appointment Proposal Created` - Appointment Proposal Created
 * * `Appointment Settings Edited` - Appointment Settings Edited
 * * `Call Started` - Call Started
 * * `Call Ended` - Call Ended
 * * `Call Automated Rating Received` - Call Automated Rating
 * * `Call Human Rating Received` - Call Human Rating
 * * `Call Lawer Rating Received` - Call Lawer Rating
 * * `Phone Forwarding Rule Created` - Phone Forwarding Rule Created
 * * `Phone Forwarding Rule Updated` - Phone Forwarding Rule Updated
 * * `Entity Extraction Instructions Set` - Entity Extraction Instructions Set
 * * `AI Token Used` - Ai Token Used
 * * `AI Embedding Token Used` - Ai Embedding Token Used
 * * `AI Function Voice Call Used` - Ai Function Voice Call Used
 * * `AI Function Document Analysis Used` - Ai Function Document Analysis Used
 * * `AI Function Document Title Generation Used` - Ai Function Document Title Generation Used
 * * `AI Function Questionnaire Title Generation Used` - Ai Function Questionnaire Title Generation Used
 * * `AI Function Email Extraction Used` - Ai Function Email Extraction Used
 * * `AI Function Gender Detection Used` - Ai Function Gender Detection Used
 * * `AI Function Document Type Classification Used` - Ai Function Document Type Classification Used
 * * `AI Function Document Analysis Entity Classification Used` - Ai Function Document Analysis Entity Classification Used
 * * `AI Function Document Generation Used` - Ai Function Document Generation Used
 * * `AI Function Inquiry Summary Used` - Ai Function Inquiry Summary Used
 * * `AI Function Used Case Chat` - Ai Function Used Case Chat
 * * `AI Function Used Update Case Chat Document Context` - Ai Function Used Update Case Chat Document Context
 * * `AI Function Used Update Case Chat Document Context Alternative Queries` - Ai Function Used Update Case Chat Document Context Alternative Queries
 * * `AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
 * * `AI Function Case Create Document Entities Extraction Used` - Ai Function Case Create Document Entities Extraction Used
 * * `AI Function Universal Entity Extraction Used` - Ai Function Universal Entity Extraction Used
 * * `AI Function Document Template Generation Used` - Ai Function Document Template Generation Used
 * * `User Feedback` - User Feedback
 * * `Help Link Clicked` - Help Link Clicked
 * * `AI Function Document Summarization Used` - Ai Function Document Summarization Used
 * * `AI Function Document Raptor Summarization Used` - Ai Function Document Raptor Summarization Used
 * * `AI Function Used Rate AI Chat Session` - Ai Function Used Rate Ai Chat Session
 * * `AI Chat Session Rating` - Ai Chat Session Rating
 * * `AI Chat Session Human Rating` - Ai Chat Session Human Rating
 * * `Global AI Chat Folder Created` - Global Ai Chat Folder Created
 * * `Global AI Chat Folder Updated` - Global Ai Chat Folder Updated
 * * `Global AI Chat Folder Deleted` - Global Ai Chat Folder Deleted
 * * `Global AI Chat Session Created` - Global Ai Chat Session Created
 * * `Global AI Chat Session Deleted` - Global Ai Chat Session Deleted
 * * `Global AI Chat Visited` - Global Ai Chat Visited
 * * `AI Function Used Global Chat` - Ai Function Used Global Chat
 * * `Global Chat Case Specific Info Requested` - Global Chat Case Specific Info Requested
 * * `AI Function Template Description Generation Used` - Ai Function Template Description Generation Used
 * * `AI Function Memory Title Generation Used` - Ai Function Memory Title Generation Used
 * * `AI Function Used Chat Memory Embedding` - Ai Function Used Chat Memory Embedding
 * * `AI Function Used Chat Memory Importance Evaluation` - Ai Function Used Chat Memory Importance
 * * `AI Function Used Rate Memory Evaluation` - Ai Function Used Rate Memory Evaluation
 * * `AI Function Used Prompt Enhancement` - Ai Function Used Prompt Enhancement
 * * `AI Function Used Preference Suggestion Analysis` - Ai Function Used Preference Suggestion Analysis
 * * `AI Function Used Feedback Preference Suggestion` - Ai Function Used Feedback Preference Suggestion
 * * `AI Function Used Chat Preference Embedding` - Ai Function Used Chat Preference Embedding
 * * `AI Function Used Chat Preference Importance Evaluation` - Ai Function Used Chat Preference Importance
 * * `Snippet Button Clicked in Document Generator` - Snippet Button Clicked In Document Generator
 * * `Snippet Selected in Document Generator` - Snippet Selected In Document Generator
 * * `Document Metadata Enrichment Started` - Document Metadata Enrichment Started
 * * `Document Metadata Enrichment Finished` - Document Metadata Enrichment Finished
 * * `Document Metadata Enrichment Retry` - Document Metadata Enrichment Retry
 * * `Document OCR Started` - Document Ocr Started
 * * `Document OCR Finished` - Document Ocr Finished
 * * `Document Embeddings Started` - Document Embeddings Started
 * * `Document Embeddings Finished` - Document Embeddings Finished
 * * `Document Summary Started` - Document Summary Started
 * * `Document Summary Finished` - Document Summary Finished
 * * `Document Analysis Started` - Document Analysis Started
 * * `Document Analysis Finished` - Document Analysis Finished
 * * `Document Entity Extraction Started` - Document Entity Extraction Started
 * * `Document Entity Extraction Finished` - Document Entity Extraction Finished
 * * `Document Raptor Summaries Started` - Document Raptor Summaries Started
 * * `Document Raptor Summaries Finished` - Document Raptor Summaries Finished
 * * `Document Inline Edit Started` - Document Inline Edit Started
 * * `Document Rename AI Clicked` - Document Rename Ai Clicked
 * * `Document Rename AI Completed` - Document Rename Ai Completed
 * * `Document Rename AI Failed` - Document Rename Ai Failed
 * * `Document Rename Saved` - Document Rename Saved
 * * `Document Rename Cancelled` - Document Rename Cancelled
 * * `Document Preview Opened` - Document Preview Opened
 * * `Document Preview Closed` - Document Preview Closed
 * * `Document Downloaded` - Document Downloaded
 * * `Document Deleted` - Document Deleted
 * * `Document Organize Pages Opened` - Document Organize Pages Opened
 * * `Documents Bulk Selected` - Documents Bulk Selected
 * * `Documents Bulk Deselected` - Documents Bulk Deselected
 * * `Documents Bulk Rename Started` - Documents Bulk Rename Started
 * * `Documents Bulk Rename Completed` - Documents Bulk Rename Completed
 * * `Documents Bulk Rename Failed` - Documents Bulk Rename Failed
 * * `Documents Bulk Merge Started` - Documents Bulk Merge Started
 * * `Documents Bulk Download Started` - Documents Bulk Download Started
 * * `Documents Bulk Download Completed` - Documents Bulk Download Completed
 * * `Documents Bulk Download Failed` - Documents Bulk Download Failed
 * * `Documents Bulk Delete Started` - Documents Bulk Delete Started
 * * `Documents Bulk Delete Completed` - Documents Bulk Delete Completed
 * * `Documents Bulk Delete Failed` - Documents Bulk Delete Failed
 * * `PDF Organize View Opened` - Pdf Organize View Opened
 * * `PDF Organize View Closed` - Pdf Organize View Closed
 * * `PDF Organize Changes Saved` - Pdf Organize Changes Saved
 * * `PDF Organize Changes Discarded` - Pdf Organize Changes Discarded
 * * `PDF Organize Download Started` - Pdf Organize Download Started
 * * `PDF Organize Download Completed` - Pdf Organize Download Completed
 * * `PDF Organize Download Failed` - Pdf Organize Download Failed
 * * `PDF Document Merged` - Pdf Document Merged
 * * `PDF Documents Merged All` - Pdf Documents Merged All
 * * `PDF Document Split Manual` - Pdf Document Split Manual
 * * `PDF Document Split AI Started` - Pdf Document Split Ai Started
 * * `PDF Document Split AI Completed` - Pdf Document Split Ai Completed
 * * `PDF Document Split AI Failed` - Pdf Document Split Ai Failed
 * * `PDF Document Duplicated` - Pdf Document Duplicated
 * * `PDF Document Group Deleted` - Pdf Document Group Deleted
 * * `PDF Document Group Created` - Pdf Document Group Created
 * * `PDF Document Group Renamed` - Pdf Document Group Renamed
 * * `PDF Document Title AI Generated` - Pdf Document Title Ai Generated
 * * `PDF Pages Moved` - Pdf Pages Moved
 * * `PDF Pages Deleted` - Pdf Pages Deleted
 * * `PDF Pages Rotated` - Pdf Pages Rotated
 * * `PDF Pages Reordered` - Pdf Pages Reordered
 * * `PDF Pages Merged` - Pdf Pages Merged
 * * `PDF Add Documents Opened` - Pdf Add Documents Opened
 * * `PDF Documents Added` - Pdf Documents Added
 * * `PDF Viewer Edit Page Clicked` - Pdf Viewer Edit Page Clicked
 * * `PDF Viewer Organize Pages Clicked` - Pdf Viewer Organize Pages Clicked
 * * `PDF Viewer Download Clicked` - Pdf Viewer Download Clicked
 * * `PDF Viewer Reset Edits Started` - Pdf Viewer Reset Edits Started
 * * `PDF Viewer Reset Edits Completed` - Pdf Viewer Reset Edits Completed
 * * `PDF Viewer Reset Edits Cancelled` - Pdf Viewer Reset Edits Cancelled
 * * `Image Editor Opened` - Image Editor Opened
 * * `Image Editor Closed` - Image Editor Closed
 * * `Image Editor Mode Changed` - Image Editor Mode Changed
 * * `Image Editor Changes Applied` - Image Editor Changes Applied
 * * `Image Editor Changes Discarded` - Image Editor Changes Discarded
 * * `Image Editor Crop Region Added` - Image Editor Crop Region Added
 * * `Image Editor Crop Region Removed` - Image Editor Crop Region Removed
 * * `Image Editor Crop Applied` - Image Editor Crop Applied
 * * `Image Editor Crop Reset` - Image Editor Crop Reset
 * * `Image Editor Rotated` - Image Editor Rotated
 * * `Image Editor Rotation Reset` - Image Editor Rotation Reset
 * * `Image Editor Adjustment Changed` - Image Editor Adjustment Changed
 * * `Image Editor Adjustments Reset` - Image Editor Adjustments Reset
 * * `Image Editor Trim Applied` - Image Editor Trim Applied
 * * `Image Editor Trim Reset` - Image Editor Trim Reset
 * * `Actaport Document Imported` - Actaport Document Imported
 * * `Actaport Document Import Failed` - Actaport Document Import Failed
 * * `Actaport Document Exported` - Actaport Document Exported
 * * `Actaport Document Export Failed` - Actaport Document Export Failed
 * * `Actaport Documents Refresh` - Actaport Documents Refresh
 * * `Actaport API Rate Limit Hit` - Actaport Api Rate Limit Hit
 * * `Actaport Party Matching Searched` - Actaport Party Matching Searched
 * * `Actaport Case Exported` - Actaport Case Exported
 * * `PDF Form Template Created` - Pdf Form Template Created
 * * `PDF Form Template Duplicated` - Pdf Form Template Duplicated
 * * `PDF Form Template Updated` - Pdf Form Template Updated
 * * `PDF Form Template Deleted` - Pdf Form Template Deleted
 * * `PDF Form Template Edit Started` - Pdf Form Template Edit Started
 * * `PDF Form Template Edit Saved` - Pdf Form Template Edit Saved
 * * `PDF Form Template Edit Abandoned` - Pdf Form Template Edit Abandoned
 * * `PDF Form Template Field Added` - Pdf Form Template Field Added
 * * `PDF Form Template Field Removed` - Pdf Form Template Field Removed
 * * `PDF Form Template Previewed` - Pdf Form Template Previewed
 * * `PDF Form Template Used` - Pdf Form Template Used
 * * `PDF Form Submission Created` - Pdf Form Submission Created
 * * `PDF Form Submission Completed` - Pdf Form Submission Completed
 * * `PDF Form Submission Sent` - Pdf Form Submission Sent
 * * `PDF Form Flattened` - Pdf Form Flattened
 * * `Self Questionnaire Created` - Self Questionnaire Created
 * * `Self Questionnaire Updated` - Self Questionnaire Updated
 * * `Self Questionnaire Published` - Self Questionnaire Published
 * * `Self Questionnaire AI Generated` - Self Questionnaire Ai Generated
 * * `Self Questionnaire Copy` - Self Questionnaire Copy
 * * `Self Questionnaire Submission Partial Updated` - Self Questionnaire Submission Partial Updated
 * * `Self Questionnaire Submission Completed` - Self Questionnaire Submission Completed
 * * `Self Questionnaire Submission Created` - Self Questionnaire Submission Created
 * * `Onboarding Package Created` - Onboarding Package Created
 * * `Onboarding Package Edited` - Onboarding Package Edited
 * * `Onboarding Package Document Added` - Onboarding Package Document Added
 * * `Onboarding Package Questionnaire Added` - Onboarding Package Questionnaire Added
 * * `Onboarding Package Link Used` - Onboarding Package Link Used
 * * `Onboarding Package QR Code Used` - Onboarding Package Qr Code Used
 * * `Onboarding Package Inquiry Created` - Onboarding Package Inquiry Created
 * * `Case List Note Added` - Case List Note Added
 * * `Case List Note Edited` - Case List Note Edited
 * * `Case List Search Performed` - Case List Search Performed
 * * `Case List Clerk Assigned` - Case List Clerk Assigned
 * * `Case List Clerk Changed` - Case List Clerk Changed
 * * `Case List Clerk Removed` - Case List Clerk Removed
 * * `Case List Clerk Filter Used` - Case List Clerk Filter Used
 * * `Case List Law Field Filter Used` - Case List Law Field Filter Used
 * * `Case List Unseen Activity Filter Used` - Case List Unseen Activity Filter Used
 * * `Case List Sort Changed` - Case List Sort Changed
 */
export type EventNameEnum = 'Logout' | 'Login' | 'Bot Display' | 'Bot Session Started' | 'Bot Session Ended' | 'Questionnaire Sent' | 'Questionnaire Completed' | 'PDFDocument Sent' | 'PDFDocument Completed' | 'Email Sent' | 'Email Received' | 'Email Template Edited' | 'Case Created' | 'Case Rejected' | 'Case Accepted' | 'Case In Progress' | 'Case Deleted' | 'Case Exported' | 'Calculator Opened' | 'Calculator Saved' | 'Appointment Account Authorized' | 'Appointment Account Revoked' | 'Appointment Service Created' | 'Appointment Service Edited' | 'Appointment Service Enabled' | 'Appointment Service Disabled' | 'Appointment Service Soft Deleted' | 'Appointment Service Recovered' | 'Appointment Calendar Created' | 'Appointment Calendar Edited' | 'Appointment Calendar Enabled' | 'Appointment Calendar Disabled' | 'Appointment Lawfields Edited' | 'Appointment Setup Completed' | 'Appointment Created' | 'Appointment Proposal Created' | 'Appointment Settings Edited' | 'Call Started' | 'Call Ended' | 'Call Automated Rating Received' | 'Call Human Rating Received' | 'Call Lawer Rating Received' | 'Phone Forwarding Rule Created' | 'Phone Forwarding Rule Updated' | 'Entity Extraction Instructions Set' | 'AI Token Used' | 'AI Embedding Token Used' | 'AI Function Voice Call Used' | 'AI Function Document Analysis Used' | 'AI Function Document Title Generation Used' | 'AI Function Questionnaire Title Generation Used' | 'AI Function Email Extraction Used' | 'AI Function Gender Detection Used' | 'AI Function Document Type Classification Used' | 'AI Function Document Analysis Entity Classification Used' | 'AI Function Document Generation Used' | 'AI Function Inquiry Summary Used' | 'AI Function Used Case Chat' | 'AI Function Used Update Case Chat Document Context' | 'AI Function Used Update Case Chat Document Context Alternative Queries' | 'AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings' | 'AI Function Case Create Document Entities Extraction Used' | 'AI Function Universal Entity Extraction Used' | 'AI Function Document Template Generation Used' | 'User Feedback' | 'Help Link Clicked' | 'AI Function Document Summarization Used' | 'AI Function Document Raptor Summarization Used' | 'AI Function Used Rate AI Chat Session' | 'AI Chat Session Rating' | 'AI Chat Session Human Rating' | 'Global AI Chat Folder Created' | 'Global AI Chat Folder Updated' | 'Global AI Chat Folder Deleted' | 'Global AI Chat Session Created' | 'Global AI Chat Session Deleted' | 'Global AI Chat Visited' | 'AI Function Used Global Chat' | 'Global Chat Case Specific Info Requested' | 'AI Function Template Description Generation Used' | 'AI Function Memory Title Generation Used' | 'AI Function Used Chat Memory Embedding' | 'AI Function Used Chat Memory Importance Evaluation' | 'AI Function Used Rate Memory Evaluation' | 'AI Function Used Prompt Enhancement' | 'AI Function Used Preference Suggestion Analysis' | 'AI Function Used Feedback Preference Suggestion' | 'AI Function Used Chat Preference Embedding' | 'AI Function Used Chat Preference Importance Evaluation' | 'Snippet Button Clicked in Document Generator' | 'Snippet Selected in Document Generator' | 'Document Metadata Enrichment Started' | 'Document Metadata Enrichment Finished' | 'Document Metadata Enrichment Retry' | 'Document OCR Started' | 'Document OCR Finished' | 'Document Embeddings Started' | 'Document Embeddings Finished' | 'Document Summary Started' | 'Document Summary Finished' | 'Document Analysis Started' | 'Document Analysis Finished' | 'Document Entity Extraction Started' | 'Document Entity Extraction Finished' | 'Document Raptor Summaries Started' | 'Document Raptor Summaries Finished' | 'Document Inline Edit Started' | 'Document Rename AI Clicked' | 'Document Rename AI Completed' | 'Document Rename AI Failed' | 'Document Rename Saved' | 'Document Rename Cancelled' | 'Document Preview Opened' | 'Document Preview Closed' | 'Document Downloaded' | 'Document Deleted' | 'Document Organize Pages Opened' | 'Documents Bulk Selected' | 'Documents Bulk Deselected' | 'Documents Bulk Rename Started' | 'Documents Bulk Rename Completed' | 'Documents Bulk Rename Failed' | 'Documents Bulk Merge Started' | 'Documents Bulk Download Started' | 'Documents Bulk Download Completed' | 'Documents Bulk Download Failed' | 'Documents Bulk Delete Started' | 'Documents Bulk Delete Completed' | 'Documents Bulk Delete Failed' | 'PDF Organize View Opened' | 'PDF Organize View Closed' | 'PDF Organize Changes Saved' | 'PDF Organize Changes Discarded' | 'PDF Organize Download Started' | 'PDF Organize Download Completed' | 'PDF Organize Download Failed' | 'PDF Document Merged' | 'PDF Documents Merged All' | 'PDF Document Split Manual' | 'PDF Document Split AI Started' | 'PDF Document Split AI Completed' | 'PDF Document Split AI Failed' | 'PDF Document Duplicated' | 'PDF Document Group Deleted' | 'PDF Document Group Created' | 'PDF Document Group Renamed' | 'PDF Document Title AI Generated' | 'PDF Pages Moved' | 'PDF Pages Deleted' | 'PDF Pages Rotated' | 'PDF Pages Reordered' | 'PDF Pages Merged' | 'PDF Add Documents Opened' | 'PDF Documents Added' | 'PDF Viewer Edit Page Clicked' | 'PDF Viewer Organize Pages Clicked' | 'PDF Viewer Download Clicked' | 'PDF Viewer Reset Edits Started' | 'PDF Viewer Reset Edits Completed' | 'PDF Viewer Reset Edits Cancelled' | 'Image Editor Opened' | 'Image Editor Closed' | 'Image Editor Mode Changed' | 'Image Editor Changes Applied' | 'Image Editor Changes Discarded' | 'Image Editor Crop Region Added' | 'Image Editor Crop Region Removed' | 'Image Editor Crop Applied' | 'Image Editor Crop Reset' | 'Image Editor Rotated' | 'Image Editor Rotation Reset' | 'Image Editor Adjustment Changed' | 'Image Editor Adjustments Reset' | 'Image Editor Trim Applied' | 'Image Editor Trim Reset' | 'Actaport Document Imported' | 'Actaport Document Import Failed' | 'Actaport Document Exported' | 'Actaport Document Export Failed' | 'Actaport Documents Refresh' | 'Actaport API Rate Limit Hit' | 'Actaport Party Matching Searched' | 'Actaport Case Exported' | 'PDF Form Template Created' | 'PDF Form Template Duplicated' | 'PDF Form Template Updated' | 'PDF Form Template Deleted' | 'PDF Form Template Edit Started' | 'PDF Form Template Edit Saved' | 'PDF Form Template Edit Abandoned' | 'PDF Form Template Field Added' | 'PDF Form Template Field Removed' | 'PDF Form Template Previewed' | 'PDF Form Template Used' | 'PDF Form Submission Created' | 'PDF Form Submission Completed' | 'PDF Form Submission Sent' | 'PDF Form Flattened' | 'Self Questionnaire Created' | 'Self Questionnaire Updated' | 'Self Questionnaire Published' | 'Self Questionnaire AI Generated' | 'Self Questionnaire Copy' | 'Self Questionnaire Submission Partial Updated' | 'Self Questionnaire Submission Completed' | 'Self Questionnaire Submission Created' | 'Onboarding Package Created' | 'Onboarding Package Edited' | 'Onboarding Package Document Added' | 'Onboarding Package Questionnaire Added' | 'Onboarding Package Link Used' | 'Onboarding Package QR Code Used' | 'Onboarding Package Inquiry Created' | 'Case List Note Added' | 'Case List Note Edited' | 'Case List Search Performed' | 'Case List Clerk Assigned' | 'Case List Clerk Changed' | 'Case List Clerk Removed' | 'Case List Clerk Filter Used' | 'Case List Law Field Filter Used' | 'Case List Unseen Activity Filter Used' | 'Case List Sort Changed';

/**
 * * `Logout` - Logout
 * * `Login` - Login
 * * `Bot Display` - Bot Display
 * * `Bot Session Started` - Bot Session Started
 * * `Bot Session Ended` - Bot Session Ended
 * * `Questionnaire Sent` - Questionnaire Sent
 * * `Questionnaire Completed` - Questionnaire Completed
 * * `PDFDocument Sent` - Form Sent
 * * `PDFDocument Completed` - Form Completed
 * * `Email Sent` - Email Sent
 * * `Email Received` - Email Received
 * * `Email Template Edited` - Email Template Edited
 * * `Case Created` - Case Created
 * * `Case Rejected` - Case Rejected
 * * `Case Accepted` - Case Completed
 * * `Case In Progress` - Case In Progress
 * * `Case Deleted` - Case Deleted
 * * `Case Exported` - Case Exported
 * * `Calculator Opened` - Calculator Opened
 * * `Calculator Saved` - Calculator Saved
 * * `Appointment Account Authorized` - Appointment Account Authorized
 * * `Appointment Account Revoked` - Appointment Account Revoked
 * * `Appointment Service Created` - Appointment Service Created
 * * `Appointment Service Edited` - Appointment Service Edited
 * * `Appointment Service Enabled` - Appointment Service Enabled
 * * `Appointment Service Disabled` - Appointment Service Disabled
 * * `Appointment Service Soft Deleted` - Appointment Service Soft Deleted
 * * `Appointment Service Recovered` - Appointment Service Recovered
 * * `Appointment Calendar Created` - Appointment Calendar Created
 * * `Appointment Calendar Edited` - Appointment Calendar Edited
 * * `Appointment Calendar Enabled` - Appointment Calendar Enabled
 * * `Appointment Calendar Disabled` - Appointment Calendar Disabled
 * * `Appointment Lawfields Edited` - Appointment Lawfields Edited
 * * `Appointment Setup Completed` - Appointment Setup Completed
 * * `Appointment Created` - Appointment Created
 * * `Appointment Proposal Created` - Appointment Proposal Created
 * * `Appointment Settings Edited` - Appointment Settings Edited
 * * `Call Started` - Call Started
 * * `Call Ended` - Call Ended
 * * `Call Automated Rating Received` - Call Automated Rating
 * * `Call Human Rating Received` - Call Human Rating
 * * `Call Lawer Rating Received` - Call Lawer Rating
 * * `Phone Forwarding Rule Created` - Phone Forwarding Rule Created
 * * `Phone Forwarding Rule Updated` - Phone Forwarding Rule Updated
 * * `Entity Extraction Instructions Set` - Entity Extraction Instructions Set
 * * `AI Token Used` - Ai Token Used
 * * `AI Embedding Token Used` - Ai Embedding Token Used
 * * `AI Function Voice Call Used` - Ai Function Voice Call Used
 * * `AI Function Document Analysis Used` - Ai Function Document Analysis Used
 * * `AI Function Document Title Generation Used` - Ai Function Document Title Generation Used
 * * `AI Function Questionnaire Title Generation Used` - Ai Function Questionnaire Title Generation Used
 * * `AI Function Email Extraction Used` - Ai Function Email Extraction Used
 * * `AI Function Gender Detection Used` - Ai Function Gender Detection Used
 * * `AI Function Document Type Classification Used` - Ai Function Document Type Classification Used
 * * `AI Function Document Analysis Entity Classification Used` - Ai Function Document Analysis Entity Classification Used
 * * `AI Function Document Generation Used` - Ai Function Document Generation Used
 * * `AI Function Inquiry Summary Used` - Ai Function Inquiry Summary Used
 * * `AI Function Used Case Chat` - Ai Function Used Case Chat
 * * `AI Function Used Update Case Chat Document Context` - Ai Function Used Update Case Chat Document Context
 * * `AI Function Used Update Case Chat Document Context Alternative Queries` - Ai Function Used Update Case Chat Document Context Alternative Queries
 * * `AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
 * * `AI Function Case Create Document Entities Extraction Used` - Ai Function Case Create Document Entities Extraction Used
 * * `AI Function Universal Entity Extraction Used` - Ai Function Universal Entity Extraction Used
 * * `AI Function Document Template Generation Used` - Ai Function Document Template Generation Used
 * * `User Feedback` - User Feedback
 * * `Help Link Clicked` - Help Link Clicked
 * * `AI Function Document Summarization Used` - Ai Function Document Summarization Used
 * * `AI Function Document Raptor Summarization Used` - Ai Function Document Raptor Summarization Used
 * * `AI Function Used Rate AI Chat Session` - Ai Function Used Rate Ai Chat Session
 * * `AI Chat Session Rating` - Ai Chat Session Rating
 * * `AI Chat Session Human Rating` - Ai Chat Session Human Rating
 * * `Global AI Chat Folder Created` - Global Ai Chat Folder Created
 * * `Global AI Chat Folder Updated` - Global Ai Chat Folder Updated
 * * `Global AI Chat Folder Deleted` - Global Ai Chat Folder Deleted
 * * `Global AI Chat Session Created` - Global Ai Chat Session Created
 * * `Global AI Chat Session Deleted` - Global Ai Chat Session Deleted
 * * `Global AI Chat Visited` - Global Ai Chat Visited
 * * `AI Function Used Global Chat` - Ai Function Used Global Chat
 * * `Global Chat Case Specific Info Requested` - Global Chat Case Specific Info Requested
 * * `AI Function Template Description Generation Used` - Ai Function Template Description Generation Used
 * * `AI Function Memory Title Generation Used` - Ai Function Memory Title Generation Used
 * * `AI Function Used Chat Memory Embedding` - Ai Function Used Chat Memory Embedding
 * * `AI Function Used Chat Memory Importance Evaluation` - Ai Function Used Chat Memory Importance
 * * `AI Function Used Rate Memory Evaluation` - Ai Function Used Rate Memory Evaluation
 * * `AI Function Used Prompt Enhancement` - Ai Function Used Prompt Enhancement
 * * `AI Function Used Preference Suggestion Analysis` - Ai Function Used Preference Suggestion Analysis
 * * `AI Function Used Feedback Preference Suggestion` - Ai Function Used Feedback Preference Suggestion
 * * `AI Function Used Chat Preference Embedding` - Ai Function Used Chat Preference Embedding
 * * `AI Function Used Chat Preference Importance Evaluation` - Ai Function Used Chat Preference Importance
 * * `Snippet Button Clicked in Document Generator` - Snippet Button Clicked In Document Generator
 * * `Snippet Selected in Document Generator` - Snippet Selected In Document Generator
 * * `Document Metadata Enrichment Started` - Document Metadata Enrichment Started
 * * `Document Metadata Enrichment Finished` - Document Metadata Enrichment Finished
 * * `Document Metadata Enrichment Retry` - Document Metadata Enrichment Retry
 * * `Document OCR Started` - Document Ocr Started
 * * `Document OCR Finished` - Document Ocr Finished
 * * `Document Embeddings Started` - Document Embeddings Started
 * * `Document Embeddings Finished` - Document Embeddings Finished
 * * `Document Summary Started` - Document Summary Started
 * * `Document Summary Finished` - Document Summary Finished
 * * `Document Analysis Started` - Document Analysis Started
 * * `Document Analysis Finished` - Document Analysis Finished
 * * `Document Entity Extraction Started` - Document Entity Extraction Started
 * * `Document Entity Extraction Finished` - Document Entity Extraction Finished
 * * `Document Raptor Summaries Started` - Document Raptor Summaries Started
 * * `Document Raptor Summaries Finished` - Document Raptor Summaries Finished
 * * `Document Inline Edit Started` - Document Inline Edit Started
 * * `Document Rename AI Clicked` - Document Rename Ai Clicked
 * * `Document Rename AI Completed` - Document Rename Ai Completed
 * * `Document Rename AI Failed` - Document Rename Ai Failed
 * * `Document Rename Saved` - Document Rename Saved
 * * `Document Rename Cancelled` - Document Rename Cancelled
 * * `Document Preview Opened` - Document Preview Opened
 * * `Document Preview Closed` - Document Preview Closed
 * * `Document Downloaded` - Document Downloaded
 * * `Document Deleted` - Document Deleted
 * * `Document Organize Pages Opened` - Document Organize Pages Opened
 * * `Documents Bulk Selected` - Documents Bulk Selected
 * * `Documents Bulk Deselected` - Documents Bulk Deselected
 * * `Documents Bulk Rename Started` - Documents Bulk Rename Started
 * * `Documents Bulk Rename Completed` - Documents Bulk Rename Completed
 * * `Documents Bulk Rename Failed` - Documents Bulk Rename Failed
 * * `Documents Bulk Merge Started` - Documents Bulk Merge Started
 * * `Documents Bulk Download Started` - Documents Bulk Download Started
 * * `Documents Bulk Download Completed` - Documents Bulk Download Completed
 * * `Documents Bulk Download Failed` - Documents Bulk Download Failed
 * * `Documents Bulk Delete Started` - Documents Bulk Delete Started
 * * `Documents Bulk Delete Completed` - Documents Bulk Delete Completed
 * * `Documents Bulk Delete Failed` - Documents Bulk Delete Failed
 * * `PDF Organize View Opened` - Pdf Organize View Opened
 * * `PDF Organize View Closed` - Pdf Organize View Closed
 * * `PDF Organize Changes Saved` - Pdf Organize Changes Saved
 * * `PDF Organize Changes Discarded` - Pdf Organize Changes Discarded
 * * `PDF Organize Download Started` - Pdf Organize Download Started
 * * `PDF Organize Download Completed` - Pdf Organize Download Completed
 * * `PDF Organize Download Failed` - Pdf Organize Download Failed
 * * `PDF Document Merged` - Pdf Document Merged
 * * `PDF Documents Merged All` - Pdf Documents Merged All
 * * `PDF Document Split Manual` - Pdf Document Split Manual
 * * `PDF Document Split AI Started` - Pdf Document Split Ai Started
 * * `PDF Document Split AI Completed` - Pdf Document Split Ai Completed
 * * `PDF Document Split AI Failed` - Pdf Document Split Ai Failed
 * * `PDF Document Duplicated` - Pdf Document Duplicated
 * * `PDF Document Group Deleted` - Pdf Document Group Deleted
 * * `PDF Document Group Created` - Pdf Document Group Created
 * * `PDF Document Group Renamed` - Pdf Document Group Renamed
 * * `PDF Document Title AI Generated` - Pdf Document Title Ai Generated
 * * `PDF Pages Moved` - Pdf Pages Moved
 * * `PDF Pages Deleted` - Pdf Pages Deleted
 * * `PDF Pages Rotated` - Pdf Pages Rotated
 * * `PDF Pages Reordered` - Pdf Pages Reordered
 * * `PDF Pages Merged` - Pdf Pages Merged
 * * `PDF Add Documents Opened` - Pdf Add Documents Opened
 * * `PDF Documents Added` - Pdf Documents Added
 * * `PDF Viewer Edit Page Clicked` - Pdf Viewer Edit Page Clicked
 * * `PDF Viewer Organize Pages Clicked` - Pdf Viewer Organize Pages Clicked
 * * `PDF Viewer Download Clicked` - Pdf Viewer Download Clicked
 * * `PDF Viewer Reset Edits Started` - Pdf Viewer Reset Edits Started
 * * `PDF Viewer Reset Edits Completed` - Pdf Viewer Reset Edits Completed
 * * `PDF Viewer Reset Edits Cancelled` - Pdf Viewer Reset Edits Cancelled
 * * `Image Editor Opened` - Image Editor Opened
 * * `Image Editor Closed` - Image Editor Closed
 * * `Image Editor Mode Changed` - Image Editor Mode Changed
 * * `Image Editor Changes Applied` - Image Editor Changes Applied
 * * `Image Editor Changes Discarded` - Image Editor Changes Discarded
 * * `Image Editor Crop Region Added` - Image Editor Crop Region Added
 * * `Image Editor Crop Region Removed` - Image Editor Crop Region Removed
 * * `Image Editor Crop Applied` - Image Editor Crop Applied
 * * `Image Editor Crop Reset` - Image Editor Crop Reset
 * * `Image Editor Rotated` - Image Editor Rotated
 * * `Image Editor Rotation Reset` - Image Editor Rotation Reset
 * * `Image Editor Adjustment Changed` - Image Editor Adjustment Changed
 * * `Image Editor Adjustments Reset` - Image Editor Adjustments Reset
 * * `Image Editor Trim Applied` - Image Editor Trim Applied
 * * `Image Editor Trim Reset` - Image Editor Trim Reset
 * * `Actaport Document Imported` - Actaport Document Imported
 * * `Actaport Document Import Failed` - Actaport Document Import Failed
 * * `Actaport Document Exported` - Actaport Document Exported
 * * `Actaport Document Export Failed` - Actaport Document Export Failed
 * * `Actaport Documents Refresh` - Actaport Documents Refresh
 * * `Actaport API Rate Limit Hit` - Actaport Api Rate Limit Hit
 * * `Actaport Party Matching Searched` - Actaport Party Matching Searched
 * * `Actaport Case Exported` - Actaport Case Exported
 * * `PDF Form Template Created` - Pdf Form Template Created
 * * `PDF Form Template Duplicated` - Pdf Form Template Duplicated
 * * `PDF Form Template Updated` - Pdf Form Template Updated
 * * `PDF Form Template Deleted` - Pdf Form Template Deleted
 * * `PDF Form Template Edit Started` - Pdf Form Template Edit Started
 * * `PDF Form Template Edit Saved` - Pdf Form Template Edit Saved
 * * `PDF Form Template Edit Abandoned` - Pdf Form Template Edit Abandoned
 * * `PDF Form Template Field Added` - Pdf Form Template Field Added
 * * `PDF Form Template Field Removed` - Pdf Form Template Field Removed
 * * `PDF Form Template Previewed` - Pdf Form Template Previewed
 * * `PDF Form Template Used` - Pdf Form Template Used
 * * `PDF Form Submission Created` - Pdf Form Submission Created
 * * `PDF Form Submission Completed` - Pdf Form Submission Completed
 * * `PDF Form Submission Sent` - Pdf Form Submission Sent
 * * `PDF Form Flattened` - Pdf Form Flattened
 * * `Self Questionnaire Created` - Self Questionnaire Created
 * * `Self Questionnaire Updated` - Self Questionnaire Updated
 * * `Self Questionnaire Published` - Self Questionnaire Published
 * * `Self Questionnaire AI Generated` - Self Questionnaire Ai Generated
 * * `Self Questionnaire Copy` - Self Questionnaire Copy
 * * `Self Questionnaire Submission Partial Updated` - Self Questionnaire Submission Partial Updated
 * * `Self Questionnaire Submission Completed` - Self Questionnaire Submission Completed
 * * `Self Questionnaire Submission Created` - Self Questionnaire Submission Created
 * * `Onboarding Package Created` - Onboarding Package Created
 * * `Onboarding Package Edited` - Onboarding Package Edited
 * * `Onboarding Package Document Added` - Onboarding Package Document Added
 * * `Onboarding Package Questionnaire Added` - Onboarding Package Questionnaire Added
 * * `Onboarding Package Link Used` - Onboarding Package Link Used
 * * `Onboarding Package QR Code Used` - Onboarding Package Qr Code Used
 * * `Onboarding Package Inquiry Created` - Onboarding Package Inquiry Created
 * * `Case List Note Added` - Case List Note Added
 * * `Case List Note Edited` - Case List Note Edited
 * * `Case List Search Performed` - Case List Search Performed
 * * `Case List Clerk Assigned` - Case List Clerk Assigned
 * * `Case List Clerk Changed` - Case List Clerk Changed
 * * `Case List Clerk Removed` - Case List Clerk Removed
 * * `Case List Clerk Filter Used` - Case List Clerk Filter Used
 * * `Case List Law Field Filter Used` - Case List Law Field Filter Used
 * * `Case List Unseen Activity Filter Used` - Case List Unseen Activity Filter Used
 * * `Case List Sort Changed` - Case List Sort Changed
 */
export const EventNameEnum = {
    LOGOUT: 'Logout',
    LOGIN: 'Login',
    BOT_DISPLAY: 'Bot Display',
    BOT_SESSION_STARTED: 'Bot Session Started',
    BOT_SESSION_ENDED: 'Bot Session Ended',
    QUESTIONNAIRE_SENT: 'Questionnaire Sent',
    QUESTIONNAIRE_COMPLETED: 'Questionnaire Completed',
    PDFDOCUMENT_SENT: 'PDFDocument Sent',
    PDFDOCUMENT_COMPLETED: 'PDFDocument Completed',
    EMAIL_SENT: 'Email Sent',
    EMAIL_RECEIVED: 'Email Received',
    EMAIL_TEMPLATE_EDITED: 'Email Template Edited',
    CASE_CREATED: 'Case Created',
    CASE_REJECTED: 'Case Rejected',
    CASE_ACCEPTED: 'Case Accepted',
    CASE_IN_PROGRESS: 'Case In Progress',
    CASE_DELETED: 'Case Deleted',
    CASE_EXPORTED: 'Case Exported',
    CALCULATOR_OPENED: 'Calculator Opened',
    CALCULATOR_SAVED: 'Calculator Saved',
    APPOINTMENT_ACCOUNT_AUTHORIZED: 'Appointment Account Authorized',
    APPOINTMENT_ACCOUNT_REVOKED: 'Appointment Account Revoked',
    APPOINTMENT_SERVICE_CREATED: 'Appointment Service Created',
    APPOINTMENT_SERVICE_EDITED: 'Appointment Service Edited',
    APPOINTMENT_SERVICE_ENABLED: 'Appointment Service Enabled',
    APPOINTMENT_SERVICE_DISABLED: 'Appointment Service Disabled',
    APPOINTMENT_SERVICE_SOFT_DELETED: 'Appointment Service Soft Deleted',
    APPOINTMENT_SERVICE_RECOVERED: 'Appointment Service Recovered',
    APPOINTMENT_CALENDAR_CREATED: 'Appointment Calendar Created',
    APPOINTMENT_CALENDAR_EDITED: 'Appointment Calendar Edited',
    APPOINTMENT_CALENDAR_ENABLED: 'Appointment Calendar Enabled',
    APPOINTMENT_CALENDAR_DISABLED: 'Appointment Calendar Disabled',
    APPOINTMENT_LAWFIELDS_EDITED: 'Appointment Lawfields Edited',
    APPOINTMENT_SETUP_COMPLETED: 'Appointment Setup Completed',
    APPOINTMENT_CREATED: 'Appointment Created',
    APPOINTMENT_PROPOSAL_CREATED: 'Appointment Proposal Created',
    APPOINTMENT_SETTINGS_EDITED: 'Appointment Settings Edited',
    CALL_STARTED: 'Call Started',
    CALL_ENDED: 'Call Ended',
    CALL_AUTOMATED_RATING_RECEIVED: 'Call Automated Rating Received',
    CALL_HUMAN_RATING_RECEIVED: 'Call Human Rating Received',
    CALL_LAWER_RATING_RECEIVED: 'Call Lawer Rating Received',
    PHONE_FORWARDING_RULE_CREATED: 'Phone Forwarding Rule Created',
    PHONE_FORWARDING_RULE_UPDATED: 'Phone Forwarding Rule Updated',
    ENTITY_EXTRACTION_INSTRUCTIONS_SET: 'Entity Extraction Instructions Set',
    AI_TOKEN_USED: 'AI Token Used',
    AI_EMBEDDING_TOKEN_USED: 'AI Embedding Token Used',
    AI_FUNCTION_VOICE_CALL_USED: 'AI Function Voice Call Used',
    AI_FUNCTION_DOCUMENT_ANALYSIS_USED: 'AI Function Document Analysis Used',
    AI_FUNCTION_DOCUMENT_TITLE_GENERATION_USED: 'AI Function Document Title Generation Used',
    AI_FUNCTION_QUESTIONNAIRE_TITLE_GENERATION_USED: 'AI Function Questionnaire Title Generation Used',
    AI_FUNCTION_EMAIL_EXTRACTION_USED: 'AI Function Email Extraction Used',
    AI_FUNCTION_GENDER_DETECTION_USED: 'AI Function Gender Detection Used',
    AI_FUNCTION_DOCUMENT_TYPE_CLASSIFICATION_USED: 'AI Function Document Type Classification Used',
    AI_FUNCTION_DOCUMENT_ANALYSIS_ENTITY_CLASSIFICATION_USED: 'AI Function Document Analysis Entity Classification Used',
    AI_FUNCTION_DOCUMENT_GENERATION_USED: 'AI Function Document Generation Used',
    AI_FUNCTION_INQUIRY_SUMMARY_USED: 'AI Function Inquiry Summary Used',
    AI_FUNCTION_USED_CASE_CHAT: 'AI Function Used Case Chat',
    AI_FUNCTION_USED_UPDATE_CASE_CHAT_DOCUMENT_CONTEXT: 'AI Function Used Update Case Chat Document Context',
    AI_FUNCTION_USED_UPDATE_CASE_CHAT_DOCUMENT_CONTEXT_ALTERNATIVE_QUERIES: 'AI Function Used Update Case Chat Document Context Alternative Queries',
    AI_FUNCTION_USED_UPDATE_CASE_CHAT_DOCUMENT_CONTEXT_ALTERNATIVE_QUERIES_CREATE_EMBEDDINGS: 'AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings',
    AI_FUNCTION_CASE_CREATE_DOCUMENT_ENTITIES_EXTRACTION_USED: 'AI Function Case Create Document Entities Extraction Used',
    AI_FUNCTION_UNIVERSAL_ENTITY_EXTRACTION_USED: 'AI Function Universal Entity Extraction Used',
    AI_FUNCTION_DOCUMENT_TEMPLATE_GENERATION_USED: 'AI Function Document Template Generation Used',
    USER_FEEDBACK: 'User Feedback',
    HELP_LINK_CLICKED: 'Help Link Clicked',
    AI_FUNCTION_DOCUMENT_SUMMARIZATION_USED: 'AI Function Document Summarization Used',
    AI_FUNCTION_DOCUMENT_RAPTOR_SUMMARIZATION_USED: 'AI Function Document Raptor Summarization Used',
    AI_FUNCTION_USED_RATE_AI_CHAT_SESSION: 'AI Function Used Rate AI Chat Session',
    AI_CHAT_SESSION_RATING: 'AI Chat Session Rating',
    AI_CHAT_SESSION_HUMAN_RATING: 'AI Chat Session Human Rating',
    GLOBAL_AI_CHAT_FOLDER_CREATED: 'Global AI Chat Folder Created',
    GLOBAL_AI_CHAT_FOLDER_UPDATED: 'Global AI Chat Folder Updated',
    GLOBAL_AI_CHAT_FOLDER_DELETED: 'Global AI Chat Folder Deleted',
    GLOBAL_AI_CHAT_SESSION_CREATED: 'Global AI Chat Session Created',
    GLOBAL_AI_CHAT_SESSION_DELETED: 'Global AI Chat Session Deleted',
    GLOBAL_AI_CHAT_VISITED: 'Global AI Chat Visited',
    AI_FUNCTION_USED_GLOBAL_CHAT: 'AI Function Used Global Chat',
    GLOBAL_CHAT_CASE_SPECIFIC_INFO_REQUESTED: 'Global Chat Case Specific Info Requested',
    AI_FUNCTION_TEMPLATE_DESCRIPTION_GENERATION_USED: 'AI Function Template Description Generation Used',
    AI_FUNCTION_MEMORY_TITLE_GENERATION_USED: 'AI Function Memory Title Generation Used',
    AI_FUNCTION_USED_CHAT_MEMORY_EMBEDDING: 'AI Function Used Chat Memory Embedding',
    AI_FUNCTION_USED_CHAT_MEMORY_IMPORTANCE_EVALUATION: 'AI Function Used Chat Memory Importance Evaluation',
    AI_FUNCTION_USED_RATE_MEMORY_EVALUATION: 'AI Function Used Rate Memory Evaluation',
    AI_FUNCTION_USED_PROMPT_ENHANCEMENT: 'AI Function Used Prompt Enhancement',
    AI_FUNCTION_USED_PREFERENCE_SUGGESTION_ANALYSIS: 'AI Function Used Preference Suggestion Analysis',
    AI_FUNCTION_USED_FEEDBACK_PREFERENCE_SUGGESTION: 'AI Function Used Feedback Preference Suggestion',
    AI_FUNCTION_USED_CHAT_PREFERENCE_EMBEDDING: 'AI Function Used Chat Preference Embedding',
    AI_FUNCTION_USED_CHAT_PREFERENCE_IMPORTANCE_EVALUATION: 'AI Function Used Chat Preference Importance Evaluation',
    SNIPPET_BUTTON_CLICKED_IN_DOCUMENT_GENERATOR: 'Snippet Button Clicked in Document Generator',
    SNIPPET_SELECTED_IN_DOCUMENT_GENERATOR: 'Snippet Selected in Document Generator',
    DOCUMENT_METADATA_ENRICHMENT_STARTED: 'Document Metadata Enrichment Started',
    DOCUMENT_METADATA_ENRICHMENT_FINISHED: 'Document Metadata Enrichment Finished',
    DOCUMENT_METADATA_ENRICHMENT_RETRY: 'Document Metadata Enrichment Retry',
    DOCUMENT_OCR_STARTED: 'Document OCR Started',
    DOCUMENT_OCR_FINISHED: 'Document OCR Finished',
    DOCUMENT_EMBEDDINGS_STARTED: 'Document Embeddings Started',
    DOCUMENT_EMBEDDINGS_FINISHED: 'Document Embeddings Finished',
    DOCUMENT_SUMMARY_STARTED: 'Document Summary Started',
    DOCUMENT_SUMMARY_FINISHED: 'Document Summary Finished',
    DOCUMENT_ANALYSIS_STARTED: 'Document Analysis Started',
    DOCUMENT_ANALYSIS_FINISHED: 'Document Analysis Finished',
    DOCUMENT_ENTITY_EXTRACTION_STARTED: 'Document Entity Extraction Started',
    DOCUMENT_ENTITY_EXTRACTION_FINISHED: 'Document Entity Extraction Finished',
    DOCUMENT_RAPTOR_SUMMARIES_STARTED: 'Document Raptor Summaries Started',
    DOCUMENT_RAPTOR_SUMMARIES_FINISHED: 'Document Raptor Summaries Finished',
    DOCUMENT_INLINE_EDIT_STARTED: 'Document Inline Edit Started',
    DOCUMENT_RENAME_AI_CLICKED: 'Document Rename AI Clicked',
    DOCUMENT_RENAME_AI_COMPLETED: 'Document Rename AI Completed',
    DOCUMENT_RENAME_AI_FAILED: 'Document Rename AI Failed',
    DOCUMENT_RENAME_SAVED: 'Document Rename Saved',
    DOCUMENT_RENAME_CANCELLED: 'Document Rename Cancelled',
    DOCUMENT_PREVIEW_OPENED: 'Document Preview Opened',
    DOCUMENT_PREVIEW_CLOSED: 'Document Preview Closed',
    DOCUMENT_DOWNLOADED: 'Document Downloaded',
    DOCUMENT_DELETED: 'Document Deleted',
    DOCUMENT_ORGANIZE_PAGES_OPENED: 'Document Organize Pages Opened',
    DOCUMENTS_BULK_SELECTED: 'Documents Bulk Selected',
    DOCUMENTS_BULK_DESELECTED: 'Documents Bulk Deselected',
    DOCUMENTS_BULK_RENAME_STARTED: 'Documents Bulk Rename Started',
    DOCUMENTS_BULK_RENAME_COMPLETED: 'Documents Bulk Rename Completed',
    DOCUMENTS_BULK_RENAME_FAILED: 'Documents Bulk Rename Failed',
    DOCUMENTS_BULK_MERGE_STARTED: 'Documents Bulk Merge Started',
    DOCUMENTS_BULK_DOWNLOAD_STARTED: 'Documents Bulk Download Started',
    DOCUMENTS_BULK_DOWNLOAD_COMPLETED: 'Documents Bulk Download Completed',
    DOCUMENTS_BULK_DOWNLOAD_FAILED: 'Documents Bulk Download Failed',
    DOCUMENTS_BULK_DELETE_STARTED: 'Documents Bulk Delete Started',
    DOCUMENTS_BULK_DELETE_COMPLETED: 'Documents Bulk Delete Completed',
    DOCUMENTS_BULK_DELETE_FAILED: 'Documents Bulk Delete Failed',
    PDF_ORGANIZE_VIEW_OPENED: 'PDF Organize View Opened',
    PDF_ORGANIZE_VIEW_CLOSED: 'PDF Organize View Closed',
    PDF_ORGANIZE_CHANGES_SAVED: 'PDF Organize Changes Saved',
    PDF_ORGANIZE_CHANGES_DISCARDED: 'PDF Organize Changes Discarded',
    PDF_ORGANIZE_DOWNLOAD_STARTED: 'PDF Organize Download Started',
    PDF_ORGANIZE_DOWNLOAD_COMPLETED: 'PDF Organize Download Completed',
    PDF_ORGANIZE_DOWNLOAD_FAILED: 'PDF Organize Download Failed',
    PDF_DOCUMENT_MERGED: 'PDF Document Merged',
    PDF_DOCUMENTS_MERGED_ALL: 'PDF Documents Merged All',
    PDF_DOCUMENT_SPLIT_MANUAL: 'PDF Document Split Manual',
    PDF_DOCUMENT_SPLIT_AI_STARTED: 'PDF Document Split AI Started',
    PDF_DOCUMENT_SPLIT_AI_COMPLETED: 'PDF Document Split AI Completed',
    PDF_DOCUMENT_SPLIT_AI_FAILED: 'PDF Document Split AI Failed',
    PDF_DOCUMENT_DUPLICATED: 'PDF Document Duplicated',
    PDF_DOCUMENT_GROUP_DELETED: 'PDF Document Group Deleted',
    PDF_DOCUMENT_GROUP_CREATED: 'PDF Document Group Created',
    PDF_DOCUMENT_GROUP_RENAMED: 'PDF Document Group Renamed',
    PDF_DOCUMENT_TITLE_AI_GENERATED: 'PDF Document Title AI Generated',
    PDF_PAGES_MOVED: 'PDF Pages Moved',
    PDF_PAGES_DELETED: 'PDF Pages Deleted',
    PDF_PAGES_ROTATED: 'PDF Pages Rotated',
    PDF_PAGES_REORDERED: 'PDF Pages Reordered',
    PDF_PAGES_MERGED: 'PDF Pages Merged',
    PDF_ADD_DOCUMENTS_OPENED: 'PDF Add Documents Opened',
    PDF_DOCUMENTS_ADDED: 'PDF Documents Added',
    PDF_VIEWER_EDIT_PAGE_CLICKED: 'PDF Viewer Edit Page Clicked',
    PDF_VIEWER_ORGANIZE_PAGES_CLICKED: 'PDF Viewer Organize Pages Clicked',
    PDF_VIEWER_DOWNLOAD_CLICKED: 'PDF Viewer Download Clicked',
    PDF_VIEWER_RESET_EDITS_STARTED: 'PDF Viewer Reset Edits Started',
    PDF_VIEWER_RESET_EDITS_COMPLETED: 'PDF Viewer Reset Edits Completed',
    PDF_VIEWER_RESET_EDITS_CANCELLED: 'PDF Viewer Reset Edits Cancelled',
    IMAGE_EDITOR_OPENED: 'Image Editor Opened',
    IMAGE_EDITOR_CLOSED: 'Image Editor Closed',
    IMAGE_EDITOR_MODE_CHANGED: 'Image Editor Mode Changed',
    IMAGE_EDITOR_CHANGES_APPLIED: 'Image Editor Changes Applied',
    IMAGE_EDITOR_CHANGES_DISCARDED: 'Image Editor Changes Discarded',
    IMAGE_EDITOR_CROP_REGION_ADDED: 'Image Editor Crop Region Added',
    IMAGE_EDITOR_CROP_REGION_REMOVED: 'Image Editor Crop Region Removed',
    IMAGE_EDITOR_CROP_APPLIED: 'Image Editor Crop Applied',
    IMAGE_EDITOR_CROP_RESET: 'Image Editor Crop Reset',
    IMAGE_EDITOR_ROTATED: 'Image Editor Rotated',
    IMAGE_EDITOR_ROTATION_RESET: 'Image Editor Rotation Reset',
    IMAGE_EDITOR_ADJUSTMENT_CHANGED: 'Image Editor Adjustment Changed',
    IMAGE_EDITOR_ADJUSTMENTS_RESET: 'Image Editor Adjustments Reset',
    IMAGE_EDITOR_TRIM_APPLIED: 'Image Editor Trim Applied',
    IMAGE_EDITOR_TRIM_RESET: 'Image Editor Trim Reset',
    ACTAPORT_DOCUMENT_IMPORTED: 'Actaport Document Imported',
    ACTAPORT_DOCUMENT_IMPORT_FAILED: 'Actaport Document Import Failed',
    ACTAPORT_DOCUMENT_EXPORTED: 'Actaport Document Exported',
    ACTAPORT_DOCUMENT_EXPORT_FAILED: 'Actaport Document Export Failed',
    ACTAPORT_DOCUMENTS_REFRESH: 'Actaport Documents Refresh',
    ACTAPORT_API_RATE_LIMIT_HIT: 'Actaport API Rate Limit Hit',
    ACTAPORT_PARTY_MATCHING_SEARCHED: 'Actaport Party Matching Searched',
    ACTAPORT_CASE_EXPORTED: 'Actaport Case Exported',
    PDF_FORM_TEMPLATE_CREATED: 'PDF Form Template Created',
    PDF_FORM_TEMPLATE_DUPLICATED: 'PDF Form Template Duplicated',
    PDF_FORM_TEMPLATE_UPDATED: 'PDF Form Template Updated',
    PDF_FORM_TEMPLATE_DELETED: 'PDF Form Template Deleted',
    PDF_FORM_TEMPLATE_EDIT_STARTED: 'PDF Form Template Edit Started',
    PDF_FORM_TEMPLATE_EDIT_SAVED: 'PDF Form Template Edit Saved',
    PDF_FORM_TEMPLATE_EDIT_ABANDONED: 'PDF Form Template Edit Abandoned',
    PDF_FORM_TEMPLATE_FIELD_ADDED: 'PDF Form Template Field Added',
    PDF_FORM_TEMPLATE_FIELD_REMOVED: 'PDF Form Template Field Removed',
    PDF_FORM_TEMPLATE_PREVIEWED: 'PDF Form Template Previewed',
    PDF_FORM_TEMPLATE_USED: 'PDF Form Template Used',
    PDF_FORM_SUBMISSION_CREATED: 'PDF Form Submission Created',
    PDF_FORM_SUBMISSION_COMPLETED: 'PDF Form Submission Completed',
    PDF_FORM_SUBMISSION_SENT: 'PDF Form Submission Sent',
    PDF_FORM_FLATTENED: 'PDF Form Flattened',
    SELF_QUESTIONNAIRE_CREATED: 'Self Questionnaire Created',
    SELF_QUESTIONNAIRE_UPDATED: 'Self Questionnaire Updated',
    SELF_QUESTIONNAIRE_PUBLISHED: 'Self Questionnaire Published',
    SELF_QUESTIONNAIRE_AI_GENERATED: 'Self Questionnaire AI Generated',
    SELF_QUESTIONNAIRE_COPY: 'Self Questionnaire Copy',
    SELF_QUESTIONNAIRE_SUBMISSION_PARTIAL_UPDATED: 'Self Questionnaire Submission Partial Updated',
    SELF_QUESTIONNAIRE_SUBMISSION_COMPLETED: 'Self Questionnaire Submission Completed',
    SELF_QUESTIONNAIRE_SUBMISSION_CREATED: 'Self Questionnaire Submission Created',
    ONBOARDING_PACKAGE_CREATED: 'Onboarding Package Created',
    ONBOARDING_PACKAGE_EDITED: 'Onboarding Package Edited',
    ONBOARDING_PACKAGE_DOCUMENT_ADDED: 'Onboarding Package Document Added',
    ONBOARDING_PACKAGE_QUESTIONNAIRE_ADDED: 'Onboarding Package Questionnaire Added',
    ONBOARDING_PACKAGE_LINK_USED: 'Onboarding Package Link Used',
    ONBOARDING_PACKAGE_QR_CODE_USED: 'Onboarding Package QR Code Used',
    ONBOARDING_PACKAGE_INQUIRY_CREATED: 'Onboarding Package Inquiry Created',
    CASE_LIST_NOTE_ADDED: 'Case List Note Added',
    CASE_LIST_NOTE_EDITED: 'Case List Note Edited',
    CASE_LIST_SEARCH_PERFORMED: 'Case List Search Performed',
    CASE_LIST_CLERK_ASSIGNED: 'Case List Clerk Assigned',
    CASE_LIST_CLERK_CHANGED: 'Case List Clerk Changed',
    CASE_LIST_CLERK_REMOVED: 'Case List Clerk Removed',
    CASE_LIST_CLERK_FILTER_USED: 'Case List Clerk Filter Used',
    CASE_LIST_LAW_FIELD_FILTER_USED: 'Case List Law Field Filter Used',
    CASE_LIST_UNSEEN_ACTIVITY_FILTER_USED: 'Case List Unseen Activity Filter Used',
    CASE_LIST_SORT_CHANGED: 'Case List Sort Changed'
} as const;

export type ExternalIntegrationCaseCreationResponse = {
    caseId: string;
    status: string;
    message: string;
    actaport_case_number?: string | null;
    file_name?: string | null;
    file_number?: string | null;
    last_updated?: string | null;
};

export type ExternalIntegrationFileDownloadResponse = {
    fileName: string;
    content: string;
    contentType: string;
    message: string;
};

/**
 * Serializer for creating external PDF form submissions linked to cases.
 */
export type ExternalPDFFormSubmissionCreateRequest = {
    /**
     * UUID of the PDF form template
     */
    template_uuid: string;
    /**
     * UUID of the case to link the submission to
     */
    case_uuid: string;
};

/**
 * Response serializer for external PDF form submission creation.
 */
export type ExternalPDFFormSubmissionResponse = {
    /**
     * UUID of the created submission
     */
    submission_uuid: string;
    /**
     * Third-party access token for the submission
     */
    access_token: string;
    /**
     * Full URL to access the submission
     */
    submission_url: string;
};

/**
 * Serializer for creating questionnaire submissions using creation tokens.
 * Used for external creation without authentication.
 */
export type ExternalQuestionnaireSubmissionCreateRequest = {
    /**
     * Creation token for the questionnaire
     */
    questionnaire_creation_token: string;
    /**
     * Creation token for the organization
     */
    org_questionnaire_creation_token: string;
};

/**
 * Response serializer for external questionnaire submission creation.
 * Returns the created submission with access token.
 */
export type ExternalQuestionnaireSubmissionResponse = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly question_count: string;
    readonly required_question_count: string;
    readonly optional_question_count: string;
    readonly answered_question_count: string;
    readonly answered_required_questions_percent: string;
    readonly answered_optional_questions_count: string;
    readonly answered_questions_percent: string;
    readonly answered_optional_questions_percent: string;
    is_third_party_questionnaire?: boolean;
    readonly third_party_access_token: string;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Serializer for AI-extracted metadata response.
 */
export type ExtractedMetadata = {
    readonly id: string;
    /**
     * Extracted metadata including name, law_field, law_topic, description
     */
    extracted_metadata: {
        [key: string]: (string);
    };
    /**
     * Confidence scores for each extracted field
     */
    confidence_scores?: {
        [key: string]: (number);
    };
};

/**
 * * `ai_chat` - Ai Chat
 * * `document_generator` - Document Generator
 * * `ai_analysis` - Ai Analysis
 * * `new_case_page` - New Case Page
 * * `agent_action` - Agent Action
 * * `case_ai_workflow` - Case Ai Workflow
 */
export type FeatureEnum = 'ai_chat' | 'document_generator' | 'ai_analysis' | 'new_case_page' | 'agent_action' | 'case_ai_workflow';

/**
 * * `ai_chat` - Ai Chat
 * * `document_generator` - Document Generator
 * * `ai_analysis` - Ai Analysis
 * * `new_case_page` - New Case Page
 * * `agent_action` - Agent Action
 * * `case_ai_workflow` - Case Ai Workflow
 */
export const FeatureEnum = {
    AI_CHAT: 'ai_chat',
    DOCUMENT_GENERATOR: 'document_generator',
    AI_ANALYSIS: 'ai_analysis',
    NEW_CASE_PAGE: 'new_case_page',
    AGENT_ACTION: 'agent_action',
    CASE_AI_WORKFLOW: 'case_ai_workflow'
} as const;

/**
 * Serializer for feature flag check requests.
 */
export type FeatureFlagCheckRequestRequest = {
    /**
     * The feature flag to check
     *
     * * `ACTAPORT_PARTY_MATCHING` - Actaport Party Matching
     * * `ACTAPORT_V2_ENABLED` - Actaport V2 Enabled
     * * `ACTAPORT_V2_TWO_WAY_SYNC` - Actaport V2 Two Way Sync
     * * `ADMIN_SET_INTEGRATIONS` - Admin Set Integrations
     * * `AGENTIC_WORKFLOWS` - Agentic Workflows
     * * `CASE_DETAIL_PAGE_V3_API` - Case Detail Page V3 Api
     * * `CASE_LIST_VIEW_V3` - Case List View V3
     * * `CLIENT_ONBOARDING` - Client Onboarding
     * * `CLIENT_PORTAL_V3_API` - Client Portal V3 Api
     * * `EMAIL_PLACEHOLDER_REGEX_FIX` - Email Placeholder Regex Fix
     * * `ENABLE_INTERCOM_CHAT` - Enable Intercom Chat
     * * `GLOBAL_AI_CHAT` - Global Ai Chat
     * * `INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT` - Incoming Email Entity Extraction Agent
     * * `NEW_ACTIVITIES_VIEW` - New Activities View
     * * `NEW_ADMIN_QUESTIONNAIRE_EDITOR` - New Admin Questionnaire Editor
     * * `NEW_PDF_EDITOR` - New Pdf Editor
     * * `OFFICE_DOCUMENT_EDITING` - Office Document Editing
     * * `PDF_FORM_TEMPLATES` - Pdf Form Templates
     * * `PDF_FORM_TEMPLATES_ADMIN` - Pdf Form Templates Admin
     * * `PREFLIGHT_DOCUMENT_EXTRACTION_AGENT` - Preflight Document Extraction Agent
     * * `QUESTIONNAIRE_SELF_SERVICE` - Questionnaire Self Service
     * * `USE_AGENT_API` - Use Agent Api
     * * `USE_POSTHOG_METRICS` - Use Posthog Metrics
     * * `USE_SEGMENT_METRICS` - Use Segment Metrics
     */
    flag: FlagEnum;
};

/**
 * Serializer for feature flag check responses.
 */
export type FeatureFlagCheckResponse = {
    /**
     * Whether the feature flag is enabled
     */
    enabled: boolean;
};

export type Feedback = {
    readonly uuid: string;
    readonly created_at: string;
    url: string;
    readonly user: number | null;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

export type FeedbackRelatedData = {
    document_generator?: DocumentGeneratorRelatedData | null;
    ai_chat?: AIChatRelatedData | null;
    ai_analysis?: AiAnalysisRelatedData | null;
    agent_action?: AgentActionRelatedData | null;
    case_lifecycle_state?: CaseLifecycleStateRelatedData | null;
};

export type FeedbackRequest = {
    url: string;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

/**
 * * `Allgemein` - Allgemein
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen Löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - It Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-Und Presserecht
 * * `Medizinrecht` - Medizinrecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export type FieldEnum = 'Allgemein' | 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'Immobilienrecht' | 'Inkasso' | 'IT Recht' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Medizinrecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';

/**
 * * `Allgemein` - Allgemein
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen Löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - It Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-Und Presserecht
 * * `Medizinrecht` - Medizinrecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export const FieldEnum = {
    ALLGEMEIN: 'Allgemein',
    ARBEITSRECHT: 'Arbeitsrecht',
    ASYLRECHT: 'Asylrecht',
    'AUSLÄNDERRECHT': 'Ausländerrecht',
    BANKRECHT: 'Bankrecht',
    BAURECHT: 'Baurecht',
    BEAMTENRECHT: 'Beamtenrecht',
    'BEWERTUNGEN_LÖSCHEN': 'Bewertungen löschen',
    CASINO: 'Casino',
    COACHING: 'Coaching',
    COMPLIANCE: 'Compliance',
    'CORONA_ÜBERBRÜCKUNGSHILFE': 'Corona Überbrückungshilfe',
    DATENLECK: 'Datenleck',
    ERBRECHT: 'Erbrecht',
    FAMILIENRECHT: 'Familienrecht',
    GESELLSCHAFTSRECHT: 'Gesellschaftsrecht',
    GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT: 'Gewerblicher Rechtsschutz/Urheberrecht',
    HOCHSCHULRECHT: 'Hochschulrecht',
    IMMOBILIENRECHT: 'Immobilienrecht',
    INKASSO: 'Inkasso',
    IT_RECHT: 'IT Recht',
    INSOLVENZBERATUNG: 'Insolvenzberatung',
    MARKENRECHT: 'Markenrecht',
    MEDIEN_UND_PRESSERECHT: 'Medien-und Presserecht',
    MEDIZINRECHT: 'Medizinrecht',
    MIETRECHT: 'Mietrecht',
    MIGRATIONSRECHT: 'Migrationsrecht',
    MUSIKRECHT: 'Musikrecht',
    NOTARIAT: 'Notariat',
    'PERSONENSCHÄDEN': 'Personenschäden',
    SCHUFA: 'Schufa',
    SCHULRECHT: 'Schulrecht',
    SOCIAL_MEDIA_RECHT: 'Social Media Recht',
    SOZIALRECHT: 'Sozialrecht',
    STEUERBERATUNG: 'Steuerberatung',
    STEUERRECHT: 'Steuerrecht',
    STRAFRECHT: 'Strafrecht',
    TESLA_WIDERRUF: 'Tesla_Widerruf',
    TIERRECHT: 'Tierrecht',
    VERKEHRSRECHT: 'Verkehrsrecht',
    VERSICHERUNGSRECHT: 'Versicherungsrecht',
    VERWALTUNGSRECHT: 'Verwaltungsrecht',
    WEGRECHT: 'Wegrecht',
    ZIVILRECHT: 'Zivilrecht'
} as const;

/**
 * Exact field match for highlighting in the UI.
 */
export type FieldHighlight = {
    /**
     * Field name (e.g., first_name, last_name, city)
     */
    field: string;
    /**
     * The exact matching text
     */
    text: string;
    /**
     * Full value from JUPUS entity
     */
    entity_value: string;
    /**
     * Full value from Actaport contact
     */
    contact_value: string;
};

/**
 * * `multiselect` - multiselect
 * * `select` - select
 * * `textarea` - textarea
 * * `filefield` - filefield
 * * `multifilefield` - multifilefield
 * * `timefield` - timefield
 * * `decimalnumberinput` - decimalnumberinput
 * * `datefield` - datefield
 * * `textinput` - textinput
 * * `numberinput` - numberinput
 * * `emailinput` - emailinput
 * * `phoneinput` - phoneinput
 * * `urlinput` - urlinput
 * * `yesno` - yesno
 */
export type FieldTypeEnum = 'multiselect' | 'select' | 'textarea' | 'filefield' | 'multifilefield' | 'timefield' | 'decimalnumberinput' | 'datefield' | 'textinput' | 'numberinput' | 'emailinput' | 'phoneinput' | 'urlinput' | 'yesno';

/**
 * * `multiselect` - multiselect
 * * `select` - select
 * * `textarea` - textarea
 * * `filefield` - filefield
 * * `multifilefield` - multifilefield
 * * `timefield` - timefield
 * * `decimalnumberinput` - decimalnumberinput
 * * `datefield` - datefield
 * * `textinput` - textinput
 * * `numberinput` - numberinput
 * * `emailinput` - emailinput
 * * `phoneinput` - phoneinput
 * * `urlinput` - urlinput
 * * `yesno` - yesno
 */
export const FieldTypeEnum = {
    MULTISELECT: 'multiselect',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    FILEFIELD: 'filefield',
    MULTIFILEFIELD: 'multifilefield',
    TIMEFIELD: 'timefield',
    DECIMALNUMBERINPUT: 'decimalnumberinput',
    DATEFIELD: 'datefield',
    TEXTINPUT: 'textinput',
    NUMBERINPUT: 'numberinput',
    EMAILINPUT: 'emailinput',
    PHONEINPUT: 'phoneinput',
    URLINPUT: 'urlinput',
    YESNO: 'yesno'
} as const;

export type FileDataRequest = {
    uuid: string;
    filename: string;
};

export type FileUploadRequest = {
    file: (Blob | File);
    page_index: number;
    item_index: number;
};

export type FileUploadResponse = {
    uuid: string;
    url: string;
    filename: string;
    title: string;
    hash: string;
};

/**
 * Counts per state with additional filters applied.
 */
export type FilteredCounts = {
    NEW: StateCount;
    IN_PROGRESS: StateCount;
    COMPLETED: StateCount;
    REJECTED: StateCount;
};

export type FindWordDocumentTemplatePlaceholderValuesRequestRequest = {
    word_document_template_uuid: string;
};

export type FindWordDocumentTemplatePlaceholderValuesResponse = {
    readonly replaceable_variables: ReplaceableVariables;
};

/**
 * * `ACTAPORT_PARTY_MATCHING` - Actaport Party Matching
 * * `ACTAPORT_V2_ENABLED` - Actaport V2 Enabled
 * * `ACTAPORT_V2_TWO_WAY_SYNC` - Actaport V2 Two Way Sync
 * * `ADMIN_SET_INTEGRATIONS` - Admin Set Integrations
 * * `AGENTIC_WORKFLOWS` - Agentic Workflows
 * * `CASE_DETAIL_PAGE_V3_API` - Case Detail Page V3 Api
 * * `CASE_LIST_VIEW_V3` - Case List View V3
 * * `CLIENT_ONBOARDING` - Client Onboarding
 * * `CLIENT_PORTAL_V3_API` - Client Portal V3 Api
 * * `EMAIL_PLACEHOLDER_REGEX_FIX` - Email Placeholder Regex Fix
 * * `ENABLE_INTERCOM_CHAT` - Enable Intercom Chat
 * * `GLOBAL_AI_CHAT` - Global Ai Chat
 * * `INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT` - Incoming Email Entity Extraction Agent
 * * `NEW_ACTIVITIES_VIEW` - New Activities View
 * * `NEW_ADMIN_QUESTIONNAIRE_EDITOR` - New Admin Questionnaire Editor
 * * `NEW_PDF_EDITOR` - New Pdf Editor
 * * `OFFICE_DOCUMENT_EDITING` - Office Document Editing
 * * `PDF_FORM_TEMPLATES` - Pdf Form Templates
 * * `PDF_FORM_TEMPLATES_ADMIN` - Pdf Form Templates Admin
 * * `PREFLIGHT_DOCUMENT_EXTRACTION_AGENT` - Preflight Document Extraction Agent
 * * `QUESTIONNAIRE_SELF_SERVICE` - Questionnaire Self Service
 * * `USE_AGENT_API` - Use Agent Api
 * * `USE_POSTHOG_METRICS` - Use Posthog Metrics
 * * `USE_SEGMENT_METRICS` - Use Segment Metrics
 */
export type FlagEnum = 'ACTAPORT_PARTY_MATCHING' | 'ACTAPORT_V2_ENABLED' | 'ACTAPORT_V2_TWO_WAY_SYNC' | 'ADMIN_SET_INTEGRATIONS' | 'AGENTIC_WORKFLOWS' | 'CASE_DETAIL_PAGE_V3_API' | 'CASE_LIST_VIEW_V3' | 'CLIENT_ONBOARDING' | 'CLIENT_PORTAL_V3_API' | 'EMAIL_PLACEHOLDER_REGEX_FIX' | 'ENABLE_INTERCOM_CHAT' | 'GLOBAL_AI_CHAT' | 'INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT' | 'NEW_ACTIVITIES_VIEW' | 'NEW_ADMIN_QUESTIONNAIRE_EDITOR' | 'NEW_PDF_EDITOR' | 'OFFICE_DOCUMENT_EDITING' | 'PDF_FORM_TEMPLATES' | 'PDF_FORM_TEMPLATES_ADMIN' | 'PREFLIGHT_DOCUMENT_EXTRACTION_AGENT' | 'QUESTIONNAIRE_SELF_SERVICE' | 'USE_AGENT_API' | 'USE_POSTHOG_METRICS' | 'USE_SEGMENT_METRICS';

/**
 * * `ACTAPORT_PARTY_MATCHING` - Actaport Party Matching
 * * `ACTAPORT_V2_ENABLED` - Actaport V2 Enabled
 * * `ACTAPORT_V2_TWO_WAY_SYNC` - Actaport V2 Two Way Sync
 * * `ADMIN_SET_INTEGRATIONS` - Admin Set Integrations
 * * `AGENTIC_WORKFLOWS` - Agentic Workflows
 * * `CASE_DETAIL_PAGE_V3_API` - Case Detail Page V3 Api
 * * `CASE_LIST_VIEW_V3` - Case List View V3
 * * `CLIENT_ONBOARDING` - Client Onboarding
 * * `CLIENT_PORTAL_V3_API` - Client Portal V3 Api
 * * `EMAIL_PLACEHOLDER_REGEX_FIX` - Email Placeholder Regex Fix
 * * `ENABLE_INTERCOM_CHAT` - Enable Intercom Chat
 * * `GLOBAL_AI_CHAT` - Global Ai Chat
 * * `INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT` - Incoming Email Entity Extraction Agent
 * * `NEW_ACTIVITIES_VIEW` - New Activities View
 * * `NEW_ADMIN_QUESTIONNAIRE_EDITOR` - New Admin Questionnaire Editor
 * * `NEW_PDF_EDITOR` - New Pdf Editor
 * * `OFFICE_DOCUMENT_EDITING` - Office Document Editing
 * * `PDF_FORM_TEMPLATES` - Pdf Form Templates
 * * `PDF_FORM_TEMPLATES_ADMIN` - Pdf Form Templates Admin
 * * `PREFLIGHT_DOCUMENT_EXTRACTION_AGENT` - Preflight Document Extraction Agent
 * * `QUESTIONNAIRE_SELF_SERVICE` - Questionnaire Self Service
 * * `USE_AGENT_API` - Use Agent Api
 * * `USE_POSTHOG_METRICS` - Use Posthog Metrics
 * * `USE_SEGMENT_METRICS` - Use Segment Metrics
 */
export const FlagEnum = {
    ACTAPORT_PARTY_MATCHING: 'ACTAPORT_PARTY_MATCHING',
    ACTAPORT_V2_ENABLED: 'ACTAPORT_V2_ENABLED',
    ACTAPORT_V2_TWO_WAY_SYNC: 'ACTAPORT_V2_TWO_WAY_SYNC',
    ADMIN_SET_INTEGRATIONS: 'ADMIN_SET_INTEGRATIONS',
    AGENTIC_WORKFLOWS: 'AGENTIC_WORKFLOWS',
    CASE_DETAIL_PAGE_V3_API: 'CASE_DETAIL_PAGE_V3_API',
    CASE_LIST_VIEW_V3: 'CASE_LIST_VIEW_V3',
    CLIENT_ONBOARDING: 'CLIENT_ONBOARDING',
    CLIENT_PORTAL_V3_API: 'CLIENT_PORTAL_V3_API',
    EMAIL_PLACEHOLDER_REGEX_FIX: 'EMAIL_PLACEHOLDER_REGEX_FIX',
    ENABLE_INTERCOM_CHAT: 'ENABLE_INTERCOM_CHAT',
    GLOBAL_AI_CHAT: 'GLOBAL_AI_CHAT',
    INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT: 'INCOMING_EMAIL_ENTITY_EXTRACTION_AGENT',
    NEW_ACTIVITIES_VIEW: 'NEW_ACTIVITIES_VIEW',
    NEW_ADMIN_QUESTIONNAIRE_EDITOR: 'NEW_ADMIN_QUESTIONNAIRE_EDITOR',
    NEW_PDF_EDITOR: 'NEW_PDF_EDITOR',
    OFFICE_DOCUMENT_EDITING: 'OFFICE_DOCUMENT_EDITING',
    PDF_FORM_TEMPLATES: 'PDF_FORM_TEMPLATES',
    PDF_FORM_TEMPLATES_ADMIN: 'PDF_FORM_TEMPLATES_ADMIN',
    PREFLIGHT_DOCUMENT_EXTRACTION_AGENT: 'PREFLIGHT_DOCUMENT_EXTRACTION_AGENT',
    QUESTIONNAIRE_SELF_SERVICE: 'QUESTIONNAIRE_SELF_SERVICE',
    USE_AGENT_API: 'USE_AGENT_API',
    USE_POSTHOG_METRICS: 'USE_POSTHOG_METRICS',
    USE_SEGMENT_METRICS: 'USE_SEGMENT_METRICS'
} as const;

/**
 * Serializer for individual form fields.
 */
export type FormField = {
    uuid?: string;
    type: FormFieldTypeEnum;
    tag?: string | null;
    tag_relationship?: TagRelationshipEnum | BlankEnum | NullEnum | null;
    placeholder?: string;
    required: boolean;
    assigned_to: AssignedToEnum;
    coordinates: FormFieldCoordinates;
};

/**
 * Serializer for form field coordinates.
 */
export type FormFieldCoordinates = {
    x: number;
    y: number;
    width: number;
    height: number;
    page: number;
};

/**
 * Serializer for form field coordinates.
 */
export type FormFieldCoordinatesRequest = {
    x: number;
    y: number;
    width: number;
    height: number;
    page: number;
};

/**
 * Serializer for individual form fields.
 */
export type FormFieldRequest = {
    uuid?: string;
    type: FormFieldTypeEnum;
    tag?: string | null;
    tag_relationship?: TagRelationshipEnum | BlankEnum | NullEnum | null;
    placeholder?: string;
    required: boolean;
    assigned_to: AssignedToEnum;
    coordinates: FormFieldCoordinatesRequest;
};

/**
 * * `textinput` - Text
 * * `textarea` - Textarea
 * * `datefield` - Date
 * * `checkbox` - Checkbox
 * * `signature` - Signature
 */
export type FormFieldTypeEnum = 'textinput' | 'textarea' | 'datefield' | 'checkbox' | 'signature';

/**
 * * `textinput` - Text
 * * `textarea` - Textarea
 * * `datefield` - Date
 * * `checkbox` - Checkbox
 * * `signature` - Signature
 */
export const FormFieldTypeEnum = {
    TEXTINPUT: 'textinput',
    TEXTAREA: 'textarea',
    DATEFIELD: 'datefield',
    CHECKBOX: 'checkbox',
    SIGNATURE: 'signature'
} as const;

/**
 * * `MASTER` - Master
 * * `PREFILLED` - Prefilled
 * * `SIGNED` - Signed
 */
export type FormTag = 'MASTER' | 'PREFILLED' | 'SIGNED';

/**
 * * `MASTER` - Master
 * * `PREFILLED` - Prefilled
 * * `SIGNED` - Signed
 */
export const FormTag = {
    MASTER: 'MASTER',
    PREFILLED: 'PREFILLED',
    SIGNED: 'SIGNED'
} as const;

export type Forward = {
    /**
     * UUID of the forwarding rule that was applied
     */
    rule_uuid: string;
    /**
     * Status of the forwarding attempt
     *
     * * `succeeded` - Succeeded
     * * `failed` - Failed
     */
    status: ForwardStatusEnum;
    /**
     * Reason for the forwarding status (success details or failure reason)
     */
    reason: string;
};

export type ForwardRequest = {
    /**
     * UUID of the forwarding rule that was applied
     */
    rule_uuid: string;
    /**
     * Status of the forwarding attempt
     *
     * * `succeeded` - Succeeded
     * * `failed` - Failed
     */
    status: ForwardStatusEnum;
    /**
     * Reason for the forwarding status (success details or failure reason)
     */
    reason: string;
};

/**
 * * `succeeded` - Succeeded
 * * `failed` - Failed
 */
export type ForwardStatusEnum = 'succeeded' | 'failed';

/**
 * * `succeeded` - Succeeded
 * * `failed` - Failed
 */
export const ForwardStatusEnum = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed'
} as const;

/**
 * Serializer for Gemini extracted entity with timestamps.
 */
export type GeminiExtractedEntityRequest = {
    value?: string | null;
    timestamp?: string | null;
    end_timestamp?: string | null;
};

/**
 * Serializer for reading GeminiShadowComparison data.
 */
export type GeminiShadowComparison = {
    readonly id: number;
    readonly created_at: string;
    /**
     * Gemini model used for extraction
     */
    readonly model: string;
    /**
     * Processing time in milliseconds
     */
    readonly latency_ms: number;
    readonly input_tokens: number;
    readonly output_tokens: number;
    readonly total_tokens: number;
    readonly input_cost_usd: string;
    readonly output_cost_usd: string;
    readonly total_cost_usd: string;
    readonly gpt_first_name: string | null;
    readonly gpt_last_name: string | null;
    readonly gpt_email: string | null;
    readonly gpt_phone: string | null;
    /**
     * {'value': str, 'timestamp': str, 'end_timestamp': str}
     */
    readonly gemini_first_name: unknown;
    /**
     * {'value': str, 'timestamp': str, 'end_timestamp': str}
     */
    readonly gemini_last_name: unknown;
    /**
     * {'value': str, 'timestamp': str, 'end_timestamp': str}
     */
    readonly gemini_email: unknown;
    /**
     * {'value': str, 'timestamp': str, 'end_timestamp': str}
     */
    readonly gemini_phone: unknown;
    readonly match_first_name: boolean;
    readonly match_last_name: boolean;
    readonly match_email: boolean;
    readonly match_phone: boolean;
    /**
     * Gemini transcription with speaker diarization
     */
    readonly transcription: unknown;
    readonly match_count: number;
    readonly match_rate: number;
    readonly all_match: boolean;
};

/**
 * Serializer for receiving shadow comparison data from voice service.
 *
 * This serializer validates the incoming webhook payload from the voice
 * service and creates a GeminiShadowComparison record.
 *
 * The voice service sends a flat payload structure with individual fields
 * like gpt_first_name, gemini_first_name, match_first_name, etc.
 */
export type GeminiShadowComparisonInputRequest = {
    /**
     * UUID of the call this comparison belongs to
     */
    call_id: string;
    /**
     * Gemini model used for extraction
     */
    model?: string;
    /**
     * Processing time in milliseconds
     */
    latency_ms?: number;
    input_tokens?: number;
    output_tokens?: number;
    total_tokens?: number;
    input_cost_usd?: string;
    output_cost_usd?: string;
    total_cost_usd?: string;
    gpt_first_name?: string | null;
    gpt_last_name?: string | null;
    gpt_email?: string | null;
    gpt_phone?: string | null;
    gemini_first_name?: (GeminiExtractedEntityRequest) | null;
    gemini_last_name?: (GeminiExtractedEntityRequest) | null;
    gemini_email?: (GeminiExtractedEntityRequest) | null;
    gemini_phone?: (GeminiExtractedEntityRequest) | null;
    match_first_name?: boolean;
    match_last_name?: boolean;
    match_email?: boolean;
    match_phone?: boolean;
    /**
     * Gemini transcription with speaker diarization
     */
    transcription?: Array<GeminiTranscriptSegmentRequest>;
};

/**
 * Serializer for a single transcript segment.
 */
export type GeminiTranscriptSegmentRequest = {
    timestamp: string;
    speaker: SpeakerEnum;
    text: string;
};

export type GenerateDocumentChatRequest = {
    role: GenerateDocumentChatRoleEnum;
    content: string;
    is_template: boolean;
};

/**
 * * `system` - System
 * * `user` - User
 * * `assistant` - Assistant
 */
export type GenerateDocumentChatRoleEnum = 'system' | 'user' | 'assistant';

/**
 * * `system` - System
 * * `user` - User
 * * `assistant` - Assistant
 */
export const GenerateDocumentChatRoleEnum = {
    SYSTEM: 'system',
    USER: 'user',
    ASSISTANT: 'assistant'
} as const;

export type GenerateDocumentRequestRequest = {
    document_template_uuid: string;
    chat: Array<GenerateDocumentChatRequest>;
};

/**
 * Serializer for generate document response.
 */
export type GenerateDocumentResponse = {
    document_blob: string;
    filename: string;
    validation_data: unknown;
};

/**
 * Serializer for generating a title for a chat preference.
 */
export type GenerateTitleRequestRequest = {
    content: string;
};

/**
 * Response serializer for AI title generation.
 */
export type GenerateTitleResponse = {
    suggested_title: string;
    confidence: number;
};

/**
 * Request serializer for AI title generation with current document state.
 */
export type GenerateTitleWithStateRequestRequest = {
    /**
     * Current state of document groups in the frontend
     */
    current_organization_state?: DocumentOrganizationStateRequest;
    /**
     * Name of the specific document group to generate title for
     */
    document_group_name?: string;
};

export type GenericDataMapper = {
    key: AiAugmentedByMapperKeysEnum;
    label: string;
    field_type: FieldTypeEnum;
    choices?: Array<(string)>;
    is_law_specific_field: boolean;
    is_entity_field: boolean;
    law_field?: LawFieldEnum;
    max_length?: number | null;
    is_nullable: boolean;
    default: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    starts_ai_analysis: boolean;
    ai_augments_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
    ai_augmented_by_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
};

export type GenericDataMapperRequest = {
    key: AiAugmentedByMapperKeysEnum;
    label: string;
    field_type: FieldTypeEnum;
    choices?: Array<(string)>;
    is_law_specific_field: boolean;
    is_entity_field: boolean;
    law_field?: LawFieldEnum;
    max_length?: number | null;
    is_nullable: boolean;
    default: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    starts_ai_analysis: boolean;
    ai_augments_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
    ai_augmented_by_mapper_keys?: Array<AiAugmentedByMapperKeysEnum>;
};

/**
 * Serializer for generic metric events from frontend.
 */
export type GenericMetricEvent = {
    /**
     * Name of the event to track
     *
     * * `Logout` - Logout
     * * `Login` - Login
     * * `Bot Display` - Bot Display
     * * `Bot Session Started` - Bot Session Started
     * * `Bot Session Ended` - Bot Session Ended
     * * `Questionnaire Sent` - Questionnaire Sent
     * * `Questionnaire Completed` - Questionnaire Completed
     * * `PDFDocument Sent` - Form Sent
     * * `PDFDocument Completed` - Form Completed
     * * `Email Sent` - Email Sent
     * * `Email Received` - Email Received
     * * `Email Template Edited` - Email Template Edited
     * * `Case Created` - Case Created
     * * `Case Rejected` - Case Rejected
     * * `Case Accepted` - Case Completed
     * * `Case In Progress` - Case In Progress
     * * `Case Deleted` - Case Deleted
     * * `Case Exported` - Case Exported
     * * `Calculator Opened` - Calculator Opened
     * * `Calculator Saved` - Calculator Saved
     * * `Appointment Account Authorized` - Appointment Account Authorized
     * * `Appointment Account Revoked` - Appointment Account Revoked
     * * `Appointment Service Created` - Appointment Service Created
     * * `Appointment Service Edited` - Appointment Service Edited
     * * `Appointment Service Enabled` - Appointment Service Enabled
     * * `Appointment Service Disabled` - Appointment Service Disabled
     * * `Appointment Service Soft Deleted` - Appointment Service Soft Deleted
     * * `Appointment Service Recovered` - Appointment Service Recovered
     * * `Appointment Calendar Created` - Appointment Calendar Created
     * * `Appointment Calendar Edited` - Appointment Calendar Edited
     * * `Appointment Calendar Enabled` - Appointment Calendar Enabled
     * * `Appointment Calendar Disabled` - Appointment Calendar Disabled
     * * `Appointment Lawfields Edited` - Appointment Lawfields Edited
     * * `Appointment Setup Completed` - Appointment Setup Completed
     * * `Appointment Created` - Appointment Created
     * * `Appointment Proposal Created` - Appointment Proposal Created
     * * `Appointment Settings Edited` - Appointment Settings Edited
     * * `Call Started` - Call Started
     * * `Call Ended` - Call Ended
     * * `Call Automated Rating Received` - Call Automated Rating
     * * `Call Human Rating Received` - Call Human Rating
     * * `Call Lawer Rating Received` - Call Lawer Rating
     * * `Phone Forwarding Rule Created` - Phone Forwarding Rule Created
     * * `Phone Forwarding Rule Updated` - Phone Forwarding Rule Updated
     * * `Entity Extraction Instructions Set` - Entity Extraction Instructions Set
     * * `AI Token Used` - Ai Token Used
     * * `AI Embedding Token Used` - Ai Embedding Token Used
     * * `AI Function Voice Call Used` - Ai Function Voice Call Used
     * * `AI Function Document Analysis Used` - Ai Function Document Analysis Used
     * * `AI Function Document Title Generation Used` - Ai Function Document Title Generation Used
     * * `AI Function Questionnaire Title Generation Used` - Ai Function Questionnaire Title Generation Used
     * * `AI Function Email Extraction Used` - Ai Function Email Extraction Used
     * * `AI Function Gender Detection Used` - Ai Function Gender Detection Used
     * * `AI Function Document Type Classification Used` - Ai Function Document Type Classification Used
     * * `AI Function Document Analysis Entity Classification Used` - Ai Function Document Analysis Entity Classification Used
     * * `AI Function Document Generation Used` - Ai Function Document Generation Used
     * * `AI Function Inquiry Summary Used` - Ai Function Inquiry Summary Used
     * * `AI Function Used Case Chat` - Ai Function Used Case Chat
     * * `AI Function Used Update Case Chat Document Context` - Ai Function Used Update Case Chat Document Context
     * * `AI Function Used Update Case Chat Document Context Alternative Queries` - Ai Function Used Update Case Chat Document Context Alternative Queries
     * * `AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
     * * `AI Function Case Create Document Entities Extraction Used` - Ai Function Case Create Document Entities Extraction Used
     * * `AI Function Universal Entity Extraction Used` - Ai Function Universal Entity Extraction Used
     * * `AI Function Document Template Generation Used` - Ai Function Document Template Generation Used
     * * `User Feedback` - User Feedback
     * * `Help Link Clicked` - Help Link Clicked
     * * `AI Function Document Summarization Used` - Ai Function Document Summarization Used
     * * `AI Function Document Raptor Summarization Used` - Ai Function Document Raptor Summarization Used
     * * `AI Function Used Rate AI Chat Session` - Ai Function Used Rate Ai Chat Session
     * * `AI Chat Session Rating` - Ai Chat Session Rating
     * * `AI Chat Session Human Rating` - Ai Chat Session Human Rating
     * * `Global AI Chat Folder Created` - Global Ai Chat Folder Created
     * * `Global AI Chat Folder Updated` - Global Ai Chat Folder Updated
     * * `Global AI Chat Folder Deleted` - Global Ai Chat Folder Deleted
     * * `Global AI Chat Session Created` - Global Ai Chat Session Created
     * * `Global AI Chat Session Deleted` - Global Ai Chat Session Deleted
     * * `Global AI Chat Visited` - Global Ai Chat Visited
     * * `AI Function Used Global Chat` - Ai Function Used Global Chat
     * * `Global Chat Case Specific Info Requested` - Global Chat Case Specific Info Requested
     * * `AI Function Template Description Generation Used` - Ai Function Template Description Generation Used
     * * `AI Function Memory Title Generation Used` - Ai Function Memory Title Generation Used
     * * `AI Function Used Chat Memory Embedding` - Ai Function Used Chat Memory Embedding
     * * `AI Function Used Chat Memory Importance Evaluation` - Ai Function Used Chat Memory Importance
     * * `AI Function Used Rate Memory Evaluation` - Ai Function Used Rate Memory Evaluation
     * * `AI Function Used Prompt Enhancement` - Ai Function Used Prompt Enhancement
     * * `AI Function Used Preference Suggestion Analysis` - Ai Function Used Preference Suggestion Analysis
     * * `AI Function Used Feedback Preference Suggestion` - Ai Function Used Feedback Preference Suggestion
     * * `AI Function Used Chat Preference Embedding` - Ai Function Used Chat Preference Embedding
     * * `AI Function Used Chat Preference Importance Evaluation` - Ai Function Used Chat Preference Importance
     * * `Snippet Button Clicked in Document Generator` - Snippet Button Clicked In Document Generator
     * * `Snippet Selected in Document Generator` - Snippet Selected In Document Generator
     * * `Document Metadata Enrichment Started` - Document Metadata Enrichment Started
     * * `Document Metadata Enrichment Finished` - Document Metadata Enrichment Finished
     * * `Document Metadata Enrichment Retry` - Document Metadata Enrichment Retry
     * * `Document OCR Started` - Document Ocr Started
     * * `Document OCR Finished` - Document Ocr Finished
     * * `Document Embeddings Started` - Document Embeddings Started
     * * `Document Embeddings Finished` - Document Embeddings Finished
     * * `Document Summary Started` - Document Summary Started
     * * `Document Summary Finished` - Document Summary Finished
     * * `Document Analysis Started` - Document Analysis Started
     * * `Document Analysis Finished` - Document Analysis Finished
     * * `Document Entity Extraction Started` - Document Entity Extraction Started
     * * `Document Entity Extraction Finished` - Document Entity Extraction Finished
     * * `Document Raptor Summaries Started` - Document Raptor Summaries Started
     * * `Document Raptor Summaries Finished` - Document Raptor Summaries Finished
     * * `Document Inline Edit Started` - Document Inline Edit Started
     * * `Document Rename AI Clicked` - Document Rename Ai Clicked
     * * `Document Rename AI Completed` - Document Rename Ai Completed
     * * `Document Rename AI Failed` - Document Rename Ai Failed
     * * `Document Rename Saved` - Document Rename Saved
     * * `Document Rename Cancelled` - Document Rename Cancelled
     * * `Document Preview Opened` - Document Preview Opened
     * * `Document Preview Closed` - Document Preview Closed
     * * `Document Downloaded` - Document Downloaded
     * * `Document Deleted` - Document Deleted
     * * `Document Organize Pages Opened` - Document Organize Pages Opened
     * * `Documents Bulk Selected` - Documents Bulk Selected
     * * `Documents Bulk Deselected` - Documents Bulk Deselected
     * * `Documents Bulk Rename Started` - Documents Bulk Rename Started
     * * `Documents Bulk Rename Completed` - Documents Bulk Rename Completed
     * * `Documents Bulk Rename Failed` - Documents Bulk Rename Failed
     * * `Documents Bulk Merge Started` - Documents Bulk Merge Started
     * * `Documents Bulk Download Started` - Documents Bulk Download Started
     * * `Documents Bulk Download Completed` - Documents Bulk Download Completed
     * * `Documents Bulk Download Failed` - Documents Bulk Download Failed
     * * `Documents Bulk Delete Started` - Documents Bulk Delete Started
     * * `Documents Bulk Delete Completed` - Documents Bulk Delete Completed
     * * `Documents Bulk Delete Failed` - Documents Bulk Delete Failed
     * * `PDF Organize View Opened` - Pdf Organize View Opened
     * * `PDF Organize View Closed` - Pdf Organize View Closed
     * * `PDF Organize Changes Saved` - Pdf Organize Changes Saved
     * * `PDF Organize Changes Discarded` - Pdf Organize Changes Discarded
     * * `PDF Organize Download Started` - Pdf Organize Download Started
     * * `PDF Organize Download Completed` - Pdf Organize Download Completed
     * * `PDF Organize Download Failed` - Pdf Organize Download Failed
     * * `PDF Document Merged` - Pdf Document Merged
     * * `PDF Documents Merged All` - Pdf Documents Merged All
     * * `PDF Document Split Manual` - Pdf Document Split Manual
     * * `PDF Document Split AI Started` - Pdf Document Split Ai Started
     * * `PDF Document Split AI Completed` - Pdf Document Split Ai Completed
     * * `PDF Document Split AI Failed` - Pdf Document Split Ai Failed
     * * `PDF Document Duplicated` - Pdf Document Duplicated
     * * `PDF Document Group Deleted` - Pdf Document Group Deleted
     * * `PDF Document Group Created` - Pdf Document Group Created
     * * `PDF Document Group Renamed` - Pdf Document Group Renamed
     * * `PDF Document Title AI Generated` - Pdf Document Title Ai Generated
     * * `PDF Pages Moved` - Pdf Pages Moved
     * * `PDF Pages Deleted` - Pdf Pages Deleted
     * * `PDF Pages Rotated` - Pdf Pages Rotated
     * * `PDF Pages Reordered` - Pdf Pages Reordered
     * * `PDF Pages Merged` - Pdf Pages Merged
     * * `PDF Add Documents Opened` - Pdf Add Documents Opened
     * * `PDF Documents Added` - Pdf Documents Added
     * * `PDF Viewer Edit Page Clicked` - Pdf Viewer Edit Page Clicked
     * * `PDF Viewer Organize Pages Clicked` - Pdf Viewer Organize Pages Clicked
     * * `PDF Viewer Download Clicked` - Pdf Viewer Download Clicked
     * * `PDF Viewer Reset Edits Started` - Pdf Viewer Reset Edits Started
     * * `PDF Viewer Reset Edits Completed` - Pdf Viewer Reset Edits Completed
     * * `PDF Viewer Reset Edits Cancelled` - Pdf Viewer Reset Edits Cancelled
     * * `Image Editor Opened` - Image Editor Opened
     * * `Image Editor Closed` - Image Editor Closed
     * * `Image Editor Mode Changed` - Image Editor Mode Changed
     * * `Image Editor Changes Applied` - Image Editor Changes Applied
     * * `Image Editor Changes Discarded` - Image Editor Changes Discarded
     * * `Image Editor Crop Region Added` - Image Editor Crop Region Added
     * * `Image Editor Crop Region Removed` - Image Editor Crop Region Removed
     * * `Image Editor Crop Applied` - Image Editor Crop Applied
     * * `Image Editor Crop Reset` - Image Editor Crop Reset
     * * `Image Editor Rotated` - Image Editor Rotated
     * * `Image Editor Rotation Reset` - Image Editor Rotation Reset
     * * `Image Editor Adjustment Changed` - Image Editor Adjustment Changed
     * * `Image Editor Adjustments Reset` - Image Editor Adjustments Reset
     * * `Image Editor Trim Applied` - Image Editor Trim Applied
     * * `Image Editor Trim Reset` - Image Editor Trim Reset
     * * `Actaport Document Imported` - Actaport Document Imported
     * * `Actaport Document Import Failed` - Actaport Document Import Failed
     * * `Actaport Document Exported` - Actaport Document Exported
     * * `Actaport Document Export Failed` - Actaport Document Export Failed
     * * `Actaport Documents Refresh` - Actaport Documents Refresh
     * * `Actaport API Rate Limit Hit` - Actaport Api Rate Limit Hit
     * * `Actaport Party Matching Searched` - Actaport Party Matching Searched
     * * `Actaport Case Exported` - Actaport Case Exported
     * * `PDF Form Template Created` - Pdf Form Template Created
     * * `PDF Form Template Duplicated` - Pdf Form Template Duplicated
     * * `PDF Form Template Updated` - Pdf Form Template Updated
     * * `PDF Form Template Deleted` - Pdf Form Template Deleted
     * * `PDF Form Template Edit Started` - Pdf Form Template Edit Started
     * * `PDF Form Template Edit Saved` - Pdf Form Template Edit Saved
     * * `PDF Form Template Edit Abandoned` - Pdf Form Template Edit Abandoned
     * * `PDF Form Template Field Added` - Pdf Form Template Field Added
     * * `PDF Form Template Field Removed` - Pdf Form Template Field Removed
     * * `PDF Form Template Previewed` - Pdf Form Template Previewed
     * * `PDF Form Template Used` - Pdf Form Template Used
     * * `PDF Form Submission Created` - Pdf Form Submission Created
     * * `PDF Form Submission Completed` - Pdf Form Submission Completed
     * * `PDF Form Submission Sent` - Pdf Form Submission Sent
     * * `PDF Form Flattened` - Pdf Form Flattened
     * * `Self Questionnaire Created` - Self Questionnaire Created
     * * `Self Questionnaire Updated` - Self Questionnaire Updated
     * * `Self Questionnaire Published` - Self Questionnaire Published
     * * `Self Questionnaire AI Generated` - Self Questionnaire Ai Generated
     * * `Self Questionnaire Copy` - Self Questionnaire Copy
     * * `Self Questionnaire Submission Partial Updated` - Self Questionnaire Submission Partial Updated
     * * `Self Questionnaire Submission Completed` - Self Questionnaire Submission Completed
     * * `Self Questionnaire Submission Created` - Self Questionnaire Submission Created
     * * `Onboarding Package Created` - Onboarding Package Created
     * * `Onboarding Package Edited` - Onboarding Package Edited
     * * `Onboarding Package Document Added` - Onboarding Package Document Added
     * * `Onboarding Package Questionnaire Added` - Onboarding Package Questionnaire Added
     * * `Onboarding Package Link Used` - Onboarding Package Link Used
     * * `Onboarding Package QR Code Used` - Onboarding Package Qr Code Used
     * * `Onboarding Package Inquiry Created` - Onboarding Package Inquiry Created
     * * `Case List Note Added` - Case List Note Added
     * * `Case List Note Edited` - Case List Note Edited
     * * `Case List Search Performed` - Case List Search Performed
     * * `Case List Clerk Assigned` - Case List Clerk Assigned
     * * `Case List Clerk Changed` - Case List Clerk Changed
     * * `Case List Clerk Removed` - Case List Clerk Removed
     * * `Case List Clerk Filter Used` - Case List Clerk Filter Used
     * * `Case List Law Field Filter Used` - Case List Law Field Filter Used
     * * `Case List Unseen Activity Filter Used` - Case List Unseen Activity Filter Used
     * * `Case List Sort Changed` - Case List Sort Changed
     */
    event_name: EventNameEnum;
    /**
     * Additional properties for the event
     */
    properties?: unknown;
};

/**
 * Serializer for generic metric events from frontend.
 */
export type GenericMetricEventRequest = {
    /**
     * Name of the event to track
     *
     * * `Logout` - Logout
     * * `Login` - Login
     * * `Bot Display` - Bot Display
     * * `Bot Session Started` - Bot Session Started
     * * `Bot Session Ended` - Bot Session Ended
     * * `Questionnaire Sent` - Questionnaire Sent
     * * `Questionnaire Completed` - Questionnaire Completed
     * * `PDFDocument Sent` - Form Sent
     * * `PDFDocument Completed` - Form Completed
     * * `Email Sent` - Email Sent
     * * `Email Received` - Email Received
     * * `Email Template Edited` - Email Template Edited
     * * `Case Created` - Case Created
     * * `Case Rejected` - Case Rejected
     * * `Case Accepted` - Case Completed
     * * `Case In Progress` - Case In Progress
     * * `Case Deleted` - Case Deleted
     * * `Case Exported` - Case Exported
     * * `Calculator Opened` - Calculator Opened
     * * `Calculator Saved` - Calculator Saved
     * * `Appointment Account Authorized` - Appointment Account Authorized
     * * `Appointment Account Revoked` - Appointment Account Revoked
     * * `Appointment Service Created` - Appointment Service Created
     * * `Appointment Service Edited` - Appointment Service Edited
     * * `Appointment Service Enabled` - Appointment Service Enabled
     * * `Appointment Service Disabled` - Appointment Service Disabled
     * * `Appointment Service Soft Deleted` - Appointment Service Soft Deleted
     * * `Appointment Service Recovered` - Appointment Service Recovered
     * * `Appointment Calendar Created` - Appointment Calendar Created
     * * `Appointment Calendar Edited` - Appointment Calendar Edited
     * * `Appointment Calendar Enabled` - Appointment Calendar Enabled
     * * `Appointment Calendar Disabled` - Appointment Calendar Disabled
     * * `Appointment Lawfields Edited` - Appointment Lawfields Edited
     * * `Appointment Setup Completed` - Appointment Setup Completed
     * * `Appointment Created` - Appointment Created
     * * `Appointment Proposal Created` - Appointment Proposal Created
     * * `Appointment Settings Edited` - Appointment Settings Edited
     * * `Call Started` - Call Started
     * * `Call Ended` - Call Ended
     * * `Call Automated Rating Received` - Call Automated Rating
     * * `Call Human Rating Received` - Call Human Rating
     * * `Call Lawer Rating Received` - Call Lawer Rating
     * * `Phone Forwarding Rule Created` - Phone Forwarding Rule Created
     * * `Phone Forwarding Rule Updated` - Phone Forwarding Rule Updated
     * * `Entity Extraction Instructions Set` - Entity Extraction Instructions Set
     * * `AI Token Used` - Ai Token Used
     * * `AI Embedding Token Used` - Ai Embedding Token Used
     * * `AI Function Voice Call Used` - Ai Function Voice Call Used
     * * `AI Function Document Analysis Used` - Ai Function Document Analysis Used
     * * `AI Function Document Title Generation Used` - Ai Function Document Title Generation Used
     * * `AI Function Questionnaire Title Generation Used` - Ai Function Questionnaire Title Generation Used
     * * `AI Function Email Extraction Used` - Ai Function Email Extraction Used
     * * `AI Function Gender Detection Used` - Ai Function Gender Detection Used
     * * `AI Function Document Type Classification Used` - Ai Function Document Type Classification Used
     * * `AI Function Document Analysis Entity Classification Used` - Ai Function Document Analysis Entity Classification Used
     * * `AI Function Document Generation Used` - Ai Function Document Generation Used
     * * `AI Function Inquiry Summary Used` - Ai Function Inquiry Summary Used
     * * `AI Function Used Case Chat` - Ai Function Used Case Chat
     * * `AI Function Used Update Case Chat Document Context` - Ai Function Used Update Case Chat Document Context
     * * `AI Function Used Update Case Chat Document Context Alternative Queries` - Ai Function Used Update Case Chat Document Context Alternative Queries
     * * `AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
     * * `AI Function Case Create Document Entities Extraction Used` - Ai Function Case Create Document Entities Extraction Used
     * * `AI Function Universal Entity Extraction Used` - Ai Function Universal Entity Extraction Used
     * * `AI Function Document Template Generation Used` - Ai Function Document Template Generation Used
     * * `User Feedback` - User Feedback
     * * `Help Link Clicked` - Help Link Clicked
     * * `AI Function Document Summarization Used` - Ai Function Document Summarization Used
     * * `AI Function Document Raptor Summarization Used` - Ai Function Document Raptor Summarization Used
     * * `AI Function Used Rate AI Chat Session` - Ai Function Used Rate Ai Chat Session
     * * `AI Chat Session Rating` - Ai Chat Session Rating
     * * `AI Chat Session Human Rating` - Ai Chat Session Human Rating
     * * `Global AI Chat Folder Created` - Global Ai Chat Folder Created
     * * `Global AI Chat Folder Updated` - Global Ai Chat Folder Updated
     * * `Global AI Chat Folder Deleted` - Global Ai Chat Folder Deleted
     * * `Global AI Chat Session Created` - Global Ai Chat Session Created
     * * `Global AI Chat Session Deleted` - Global Ai Chat Session Deleted
     * * `Global AI Chat Visited` - Global Ai Chat Visited
     * * `AI Function Used Global Chat` - Ai Function Used Global Chat
     * * `Global Chat Case Specific Info Requested` - Global Chat Case Specific Info Requested
     * * `AI Function Template Description Generation Used` - Ai Function Template Description Generation Used
     * * `AI Function Memory Title Generation Used` - Ai Function Memory Title Generation Used
     * * `AI Function Used Chat Memory Embedding` - Ai Function Used Chat Memory Embedding
     * * `AI Function Used Chat Memory Importance Evaluation` - Ai Function Used Chat Memory Importance
     * * `AI Function Used Rate Memory Evaluation` - Ai Function Used Rate Memory Evaluation
     * * `AI Function Used Prompt Enhancement` - Ai Function Used Prompt Enhancement
     * * `AI Function Used Preference Suggestion Analysis` - Ai Function Used Preference Suggestion Analysis
     * * `AI Function Used Feedback Preference Suggestion` - Ai Function Used Feedback Preference Suggestion
     * * `AI Function Used Chat Preference Embedding` - Ai Function Used Chat Preference Embedding
     * * `AI Function Used Chat Preference Importance Evaluation` - Ai Function Used Chat Preference Importance
     * * `Snippet Button Clicked in Document Generator` - Snippet Button Clicked In Document Generator
     * * `Snippet Selected in Document Generator` - Snippet Selected In Document Generator
     * * `Document Metadata Enrichment Started` - Document Metadata Enrichment Started
     * * `Document Metadata Enrichment Finished` - Document Metadata Enrichment Finished
     * * `Document Metadata Enrichment Retry` - Document Metadata Enrichment Retry
     * * `Document OCR Started` - Document Ocr Started
     * * `Document OCR Finished` - Document Ocr Finished
     * * `Document Embeddings Started` - Document Embeddings Started
     * * `Document Embeddings Finished` - Document Embeddings Finished
     * * `Document Summary Started` - Document Summary Started
     * * `Document Summary Finished` - Document Summary Finished
     * * `Document Analysis Started` - Document Analysis Started
     * * `Document Analysis Finished` - Document Analysis Finished
     * * `Document Entity Extraction Started` - Document Entity Extraction Started
     * * `Document Entity Extraction Finished` - Document Entity Extraction Finished
     * * `Document Raptor Summaries Started` - Document Raptor Summaries Started
     * * `Document Raptor Summaries Finished` - Document Raptor Summaries Finished
     * * `Document Inline Edit Started` - Document Inline Edit Started
     * * `Document Rename AI Clicked` - Document Rename Ai Clicked
     * * `Document Rename AI Completed` - Document Rename Ai Completed
     * * `Document Rename AI Failed` - Document Rename Ai Failed
     * * `Document Rename Saved` - Document Rename Saved
     * * `Document Rename Cancelled` - Document Rename Cancelled
     * * `Document Preview Opened` - Document Preview Opened
     * * `Document Preview Closed` - Document Preview Closed
     * * `Document Downloaded` - Document Downloaded
     * * `Document Deleted` - Document Deleted
     * * `Document Organize Pages Opened` - Document Organize Pages Opened
     * * `Documents Bulk Selected` - Documents Bulk Selected
     * * `Documents Bulk Deselected` - Documents Bulk Deselected
     * * `Documents Bulk Rename Started` - Documents Bulk Rename Started
     * * `Documents Bulk Rename Completed` - Documents Bulk Rename Completed
     * * `Documents Bulk Rename Failed` - Documents Bulk Rename Failed
     * * `Documents Bulk Merge Started` - Documents Bulk Merge Started
     * * `Documents Bulk Download Started` - Documents Bulk Download Started
     * * `Documents Bulk Download Completed` - Documents Bulk Download Completed
     * * `Documents Bulk Download Failed` - Documents Bulk Download Failed
     * * `Documents Bulk Delete Started` - Documents Bulk Delete Started
     * * `Documents Bulk Delete Completed` - Documents Bulk Delete Completed
     * * `Documents Bulk Delete Failed` - Documents Bulk Delete Failed
     * * `PDF Organize View Opened` - Pdf Organize View Opened
     * * `PDF Organize View Closed` - Pdf Organize View Closed
     * * `PDF Organize Changes Saved` - Pdf Organize Changes Saved
     * * `PDF Organize Changes Discarded` - Pdf Organize Changes Discarded
     * * `PDF Organize Download Started` - Pdf Organize Download Started
     * * `PDF Organize Download Completed` - Pdf Organize Download Completed
     * * `PDF Organize Download Failed` - Pdf Organize Download Failed
     * * `PDF Document Merged` - Pdf Document Merged
     * * `PDF Documents Merged All` - Pdf Documents Merged All
     * * `PDF Document Split Manual` - Pdf Document Split Manual
     * * `PDF Document Split AI Started` - Pdf Document Split Ai Started
     * * `PDF Document Split AI Completed` - Pdf Document Split Ai Completed
     * * `PDF Document Split AI Failed` - Pdf Document Split Ai Failed
     * * `PDF Document Duplicated` - Pdf Document Duplicated
     * * `PDF Document Group Deleted` - Pdf Document Group Deleted
     * * `PDF Document Group Created` - Pdf Document Group Created
     * * `PDF Document Group Renamed` - Pdf Document Group Renamed
     * * `PDF Document Title AI Generated` - Pdf Document Title Ai Generated
     * * `PDF Pages Moved` - Pdf Pages Moved
     * * `PDF Pages Deleted` - Pdf Pages Deleted
     * * `PDF Pages Rotated` - Pdf Pages Rotated
     * * `PDF Pages Reordered` - Pdf Pages Reordered
     * * `PDF Pages Merged` - Pdf Pages Merged
     * * `PDF Add Documents Opened` - Pdf Add Documents Opened
     * * `PDF Documents Added` - Pdf Documents Added
     * * `PDF Viewer Edit Page Clicked` - Pdf Viewer Edit Page Clicked
     * * `PDF Viewer Organize Pages Clicked` - Pdf Viewer Organize Pages Clicked
     * * `PDF Viewer Download Clicked` - Pdf Viewer Download Clicked
     * * `PDF Viewer Reset Edits Started` - Pdf Viewer Reset Edits Started
     * * `PDF Viewer Reset Edits Completed` - Pdf Viewer Reset Edits Completed
     * * `PDF Viewer Reset Edits Cancelled` - Pdf Viewer Reset Edits Cancelled
     * * `Image Editor Opened` - Image Editor Opened
     * * `Image Editor Closed` - Image Editor Closed
     * * `Image Editor Mode Changed` - Image Editor Mode Changed
     * * `Image Editor Changes Applied` - Image Editor Changes Applied
     * * `Image Editor Changes Discarded` - Image Editor Changes Discarded
     * * `Image Editor Crop Region Added` - Image Editor Crop Region Added
     * * `Image Editor Crop Region Removed` - Image Editor Crop Region Removed
     * * `Image Editor Crop Applied` - Image Editor Crop Applied
     * * `Image Editor Crop Reset` - Image Editor Crop Reset
     * * `Image Editor Rotated` - Image Editor Rotated
     * * `Image Editor Rotation Reset` - Image Editor Rotation Reset
     * * `Image Editor Adjustment Changed` - Image Editor Adjustment Changed
     * * `Image Editor Adjustments Reset` - Image Editor Adjustments Reset
     * * `Image Editor Trim Applied` - Image Editor Trim Applied
     * * `Image Editor Trim Reset` - Image Editor Trim Reset
     * * `Actaport Document Imported` - Actaport Document Imported
     * * `Actaport Document Import Failed` - Actaport Document Import Failed
     * * `Actaport Document Exported` - Actaport Document Exported
     * * `Actaport Document Export Failed` - Actaport Document Export Failed
     * * `Actaport Documents Refresh` - Actaport Documents Refresh
     * * `Actaport API Rate Limit Hit` - Actaport Api Rate Limit Hit
     * * `Actaport Party Matching Searched` - Actaport Party Matching Searched
     * * `Actaport Case Exported` - Actaport Case Exported
     * * `PDF Form Template Created` - Pdf Form Template Created
     * * `PDF Form Template Duplicated` - Pdf Form Template Duplicated
     * * `PDF Form Template Updated` - Pdf Form Template Updated
     * * `PDF Form Template Deleted` - Pdf Form Template Deleted
     * * `PDF Form Template Edit Started` - Pdf Form Template Edit Started
     * * `PDF Form Template Edit Saved` - Pdf Form Template Edit Saved
     * * `PDF Form Template Edit Abandoned` - Pdf Form Template Edit Abandoned
     * * `PDF Form Template Field Added` - Pdf Form Template Field Added
     * * `PDF Form Template Field Removed` - Pdf Form Template Field Removed
     * * `PDF Form Template Previewed` - Pdf Form Template Previewed
     * * `PDF Form Template Used` - Pdf Form Template Used
     * * `PDF Form Submission Created` - Pdf Form Submission Created
     * * `PDF Form Submission Completed` - Pdf Form Submission Completed
     * * `PDF Form Submission Sent` - Pdf Form Submission Sent
     * * `PDF Form Flattened` - Pdf Form Flattened
     * * `Self Questionnaire Created` - Self Questionnaire Created
     * * `Self Questionnaire Updated` - Self Questionnaire Updated
     * * `Self Questionnaire Published` - Self Questionnaire Published
     * * `Self Questionnaire AI Generated` - Self Questionnaire Ai Generated
     * * `Self Questionnaire Copy` - Self Questionnaire Copy
     * * `Self Questionnaire Submission Partial Updated` - Self Questionnaire Submission Partial Updated
     * * `Self Questionnaire Submission Completed` - Self Questionnaire Submission Completed
     * * `Self Questionnaire Submission Created` - Self Questionnaire Submission Created
     * * `Onboarding Package Created` - Onboarding Package Created
     * * `Onboarding Package Edited` - Onboarding Package Edited
     * * `Onboarding Package Document Added` - Onboarding Package Document Added
     * * `Onboarding Package Questionnaire Added` - Onboarding Package Questionnaire Added
     * * `Onboarding Package Link Used` - Onboarding Package Link Used
     * * `Onboarding Package QR Code Used` - Onboarding Package Qr Code Used
     * * `Onboarding Package Inquiry Created` - Onboarding Package Inquiry Created
     * * `Case List Note Added` - Case List Note Added
     * * `Case List Note Edited` - Case List Note Edited
     * * `Case List Search Performed` - Case List Search Performed
     * * `Case List Clerk Assigned` - Case List Clerk Assigned
     * * `Case List Clerk Changed` - Case List Clerk Changed
     * * `Case List Clerk Removed` - Case List Clerk Removed
     * * `Case List Clerk Filter Used` - Case List Clerk Filter Used
     * * `Case List Law Field Filter Used` - Case List Law Field Filter Used
     * * `Case List Unseen Activity Filter Used` - Case List Unseen Activity Filter Used
     * * `Case List Sort Changed` - Case List Sort Changed
     */
    event_name: EventNameEnum;
    /**
     * Additional properties for the event
     */
    properties?: unknown;
};

/**
 * Serializer for Have I Been Pwned (HIBP) integration settings in Organisation model.
 */
export type HibpSettings = {
    is_haveibeenpwned_integration_enabled?: boolean;
    haveibeenpwned_api_key?: string | null;
    haveibeenpwned_active_breaches?: unknown;
};

/**
 * Serializer for Have I Been Pwned (HIBP) integration settings in Organisation model.
 */
export type HibpSettingsRequest = {
    is_haveibeenpwned_integration_enabled?: boolean;
    haveibeenpwned_api_key?: string | null;
    haveibeenpwned_active_breaches?: unknown;
};

/**
 * Serializer for HubSpot company candidates with match metadata.
 */
export type HubSpotCompanyCandidate = {
    uuid: string;
    hubspot_id: string;
    name: string | null;
    domain: string | null;
    hubspot_url: string;
    /**
     * List of domains that matched this HubSpot company
     */
    matched_domains: Array<(string)>;
};

/**
 * Serializer for company onboarding data from HubSpot.
 *
 * This serializer is used to return onboarding data for a company,
 * including company details and associated contacts that can be used
 * to prefill customer creation forms.
 */
export type HubSpotCompanyOnboardingData = {
    name?: string | null;
    phone?: string | null;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    domain?: string | null;
    contacts?: Array<HubSpotContactOnboardingData>;
};

/**
 * Serializer for contact onboarding data from HubSpot.
 */
export type HubSpotContactOnboardingData = {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
};

/**
 * Serializer for HubSpot integration settings in Organisation model.
 */
export type HubspotSettings = {
    is_hubspot_egress_integration_enabled?: boolean;
    hubspot_private_key?: string | null;
};

/**
 * Serializer for HubSpot integration settings in Organisation model.
 */
export type HubspotSettingsRequest = {
    is_hubspot_egress_integration_enabled?: boolean;
    hubspot_private_key?: string | null;
};

/**
 * * `thumbnail` - thumbnail
 * * `small` - small
 * * `medium` - medium
 * * `large` - large
 */
export type ImagePresetEnum = 'thumbnail' | 'small' | 'medium' | 'large';

/**
 * * `thumbnail` - thumbnail
 * * `small` - small
 * * `medium` - medium
 * * `large` - large
 */
export const ImagePresetEnum = {
    THUMBNAIL: 'thumbnail',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
} as const;

export type ImageproxyImagePreset = {
    url: string;
    image_preset: ImagePresetEnum;
};

export type ImageproxyImagePresetRequest = {
    url: string;
    image_preset: ImagePresetEnum;
};

/**
 * Request serializer for importing a document from Actaport.
 */
export type ImportDocumentRequestRequest = {
    /**
     * ID of the document in Actaport to import
     */
    actaport_document_id: string;
};

/**
 * Response serializer for import document endpoint.
 */
export type ImportDocumentResponse = {
    /**
     * Status of the import operation
     *
     * * `importing` - importing
     * * `error` - error
     */
    status: ImportDocumentResponseStatusEnum;
    /**
     * Optional message about the import status
     */
    message?: string;
};

/**
 * * `importing` - importing
 * * `error` - error
 */
export type ImportDocumentResponseStatusEnum = 'importing' | 'error';

/**
 * * `importing` - importing
 * * `error` - error
 */
export const ImportDocumentResponseStatusEnum = {
    IMPORTING: 'importing',
    ERROR: 'error'
} as const;

export type InboundEmailAttachment = {
    uuid?: string;
    file_name: string;
    file: string;
};

export type InboundEmailRequest = {
    uuid?: string;
};

export type IntegrationError = {
    error: string;
    integrationType: string;
    errorType: string;
};

export type IntegrationSpecificDataRequest = ActaportDataRequest | AdvoluxDataRequest | AdvowareDataRequest | LawFirmSoftwareDataRequest | RaMicroDataRequest | RaMicroApiDataRequest | JurnodesDataRequest | KleosDataRequest | DatevDataRequest;

/**
 * * `actaport` - Actaport
 * * `advolux` - Advolux
 * * `advoware` - Advoware
 * * `lawfirmsoftware` - LawFirmSoftware
 * * `ramicro` - RaMicro
 * * `ramicroapi` - RaMicroApi
 * * `jurnodes` - Jurnodes
 * * `kleos` - Kleos
 * * `datev` - DATEV
 */
export type IntegrationTypeEnum = 'actaport' | 'advolux' | 'advoware' | 'lawfirmsoftware' | 'ramicro' | 'ramicroapi' | 'jurnodes' | 'kleos' | 'datev';

/**
 * * `actaport` - Actaport
 * * `advolux` - Advolux
 * * `advoware` - Advoware
 * * `lawfirmsoftware` - LawFirmSoftware
 * * `ramicro` - RaMicro
 * * `ramicroapi` - RaMicroApi
 * * `jurnodes` - Jurnodes
 * * `kleos` - Kleos
 * * `datev` - DATEV
 */
export const IntegrationTypeEnum = {
    ACTAPORT: 'actaport',
    ADVOLUX: 'advolux',
    ADVOWARE: 'advoware',
    LAWFIRMSOFTWARE: 'lawfirmsoftware',
    RAMICRO: 'ramicro',
    RAMICROAPI: 'ramicroapi',
    JURNODES: 'jurnodes',
    KLEOS: 'kleos',
    DATEV: 'datev'
} as const;

/**
 * Serializer for Iusta integration settings in Organisation model.
 */
export type IustaSettings = {
    is_iusta_egress_integration_enabled?: boolean;
    iusta_api_key?: string | null;
    /**
     * https://api.ihrname.iusta.io/api
     */
    iusta_api_base_url?: string | null;
    iusta_case_group_id?: number | null;
    iusta_json_category_id?: number | null;
    iusta_text_category_id?: number | null;
    iusta_document_category_id?: number | null;
    iusta_workflow_instance_id?: number | null;
    iusta_jupus_tag_id?: number | null;
    iusta_date_tag_id?: number | null;
    iusta_law_field_tag_id?: string | null;
};

/**
 * Serializer for Iusta integration settings in Organisation model.
 */
export type IustaSettingsRequest = {
    is_iusta_egress_integration_enabled?: boolean;
    iusta_api_key?: string | null;
    /**
     * https://api.ihrname.iusta.io/api
     */
    iusta_api_base_url?: string | null;
    iusta_case_group_id?: number | null;
    iusta_json_category_id?: number | null;
    iusta_text_category_id?: number | null;
    iusta_document_category_id?: number | null;
    iusta_workflow_instance_id?: number | null;
    iusta_jupus_tag_id?: number | null;
    iusta_date_tag_id?: number | null;
    iusta_law_field_tag_id?: string | null;
};

export type JumpTo = {
    uuid: string | null;
    value: string;
};

export type JumpToRequest = {
    uuid: string | null;
    value: string;
};

export type JurnodesDataRequest = {
    datapool: number;
    rubrum: string;
    lawCategory: number;
    recordSchema: number;
    lawyers?: Array<(number)>;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

export type JurnodesLawCategory = {
    id: number;
    name: string;
};

export type JurnodesRecordSchema = {
    id: number;
    name: string;
    lawCategory: number;
};

/**
 * Serializer for Jurnodes integration settings in Organisation model.
 */
export type JurnodesSettings = {
    is_jurnodes_export_integration_enabled?: boolean;
    jurnodes_api_user?: string | null;
    jurnodes_api_url?: string | null;
    jurnodes_api_token?: string;
};

/**
 * Serializer for Jurnodes integration settings in Organisation model.
 */
export type JurnodesSettingsRequest = {
    is_jurnodes_export_integration_enabled?: boolean;
    jurnodes_api_user?: string | null;
    jurnodes_api_url?: string | null;
    jurnodes_api_token?: string;
};

export type JurnodesUser = {
    id: number;
    displayName: string;
    abbreviation: string;
    department: string;
    position: string;
    privateFileFolder: string;
    contact: string;
};

export type KleosCaseType = {
    id: number;
    name: string;
    defaultRegister: number | null;
};

export type KleosCaseTypes = {
    caseTypes: Array<KleosCaseType>;
};

export type KleosDataRequest = {
    name: string;
    description: string | null;
    caseResponsibleId?: number | null;
    typeId: number;
    creationDate: string;
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

/**
 * Serializer for Kleos integration settings in Organisation model.
 */
export type KleosSettings = {
    is_kleos_integration_enabled?: boolean;
    kleos_client_id?: string | null;
    kleos_client_secret?: string;
};

/**
 * Serializer for Kleos integration settings in Organisation model.
 */
export type KleosSettingsRequest = {
    is_kleos_integration_enabled?: boolean;
    kleos_client_id?: string | null;
    kleos_client_secret?: string;
};

export type LawAugmentedFieldsRequest = {
    field: string | null;
    topic: string | null;
};

export type LawData = {
    uuid?: string;
    readonly created_at: string;
    readonly updated_at: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_end_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_local_transfer_clause?: boolean | null;
    labor_law_VSOP?: boolean | null;
    labor_law_LTI?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_notice_period_observed?: boolean | null;
    labor_law_termination_without_notice?: boolean | null;
    labor_law_reason_for_termination_given?: boolean | null;
    labor_law_exemption_revocable?: boolean | null;
    labor_law_exemption_irrevocable?: boolean | null;
    labor_law_return_of_company_property?: boolean | null;
    labor_law_termination_operational_reasons?: boolean | null;
    labor_law_company_hearing?: boolean | null;
    labor_law_reaction_company_hering?: string | null;
    labor_law_termination_authorization?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_warning_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_special_sentence?: boolean | null;
    labor_law_sprinter_clause?: boolean | null;
    labor_law_percent_sprinter_clause?: number | null;
    labor_law_certificate_clause?: boolean | null;
    labor_law_grade_certificate_clause?: string;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    labor_law_dependent_children?: boolean | null;
    labor_law_amount_dependent_children?: number | null;
    labor_law_years_of_employment?: string | null;
    labor_law_total_gross_salary?: string | null;
    labor_law_severance_amount?: string | null;
    labor_law_works_council_membership?: boolean | null;
    labor_law_pregnancy?: boolean | null;
    labor_law_disability?: boolean | null;
    labor_law_special_personal_circumstances?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_value_improvement?: string | null;
    traffic_law_damage_amount_net?: string | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    traffic_law_repair_damage?: boolean | null;
    traffic_law_total_damage?: boolean | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_application_file_reference?: string | null;
    social_law_legal_basis?: string | null;
    social_law_benefit_type?: string | null;
    social_law_own_income_amount?: string | null;
    social_law_social_benefit_type?: string | null;
    social_law_residence_status?: string | null;
    social_law_income_type?: string | null;
    social_law_asset_type?: string | null;
    social_law_approval_file_reference?: string | null;
    social_law_approval_notice_date?: string | null;
    social_law_approval_legal_basis?: string | null;
    social_law_approval_internal_reference?: string | null;
    social_law_approved_benefit_type?: string | null;
    social_law_approved_benefit_amount?: string | null;
    social_law_approved_benefit_period?: string | null;
    social_law_follow_up_application_notes?: string | null;
    social_law_approval_period_start?: string | null;
    social_law_approval_period_end?: string | null;
    social_law_regelbedarf_amount?: string | null;
    social_law_housing_costs_amount?: string | null;
    social_law_total_need_amount?: string | null;
    social_law_monthly_payment_amount?: string | null;
    social_law_employment_income?: string | null;
    social_law_other_income?: string | null;
    social_law_creditable_income?: string | null;
    social_law_change_file_reference?: string | null;
    social_law_change_notification_date?: string | null;
    social_law_affected_benefit?: string | null;
    social_law_change_description?: string | null;
    social_law_change_reason?: string | null;
    social_law_attachment_list?: string | null;
    social_law_rejection_file_reference?: string | null;
    social_law_rejection_legal_norm?: string | null;
    social_law_rejection_reason?: string | null;
    social_law_rejection_notice_date?: string | null;
    social_law_revocation_file_reference?: string | null;
    social_law_revocation_legal_norm?: string | null;
    social_law_revocation_reason?: string | null;
    social_law_revocation_notice_date?: string | null;
    social_law_revocation_reclaim_notes?: string | null;
    social_law_revocation_benefit_type?: string | null;
    social_law_revocation_period_start?: string | null;
    social_law_revocation_period_end?: string | null;
    social_law_original_decision_date?: string | null;
    social_law_total_reclaim_amount?: string | null;
    social_law_income_source?: string | null;
    social_law_income_amount?: string | null;
    social_law_income_date?: string | null;
    social_law_income_provider?: string | null;
    social_law_notification_date?: string | null;
    social_law_notification_source?: string | null;
    social_law_violation_type?: string | null;
    social_law_income_legal_basis?: string | null;
    social_law_reclaim_legal_basis?: string | null;
    social_law_notification_legal_basis?: string | null;
    social_law_reclaim_file_reference?: string | null;
    social_law_reclaim_legal_norm?: string | null;
    social_law_reclaim_amount?: string | null;
    social_law_reclaim_payment_deadline?: string | null;
    social_law_reclaim_notice_date?: string | null;
    social_law_reclaim_payment_terms?: string | null;
    social_law_objection_file_reference?: string | null;
    social_law_objection_challenged_notice?: string | null;
    social_law_objection_reasoning?: string | null;
    social_law_objection_date?: string | null;
    social_law_objection_suspension_request?: string | null;
    social_law_objection_evidence?: string | null;
    social_law_notice_of_objection_file_reference?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    social_law_lawsuit_file_reference?: string | null;
    social_law_lawsuit_subject?: string | null;
    social_law_lawsuit_filing_date?: string | null;
    social_law_lawsuit_evidence_requests?: string | null;
    social_law_lawsuit_attachment_list?: string | null;
    social_law_lawsuit_court_file_number?: string | null;
    social_law_lawsuit_legal_basis?: string | null;
    social_law_lawsuit_type?: string | null;
    social_law_lawsuit_main_request?: string | null;
    social_law_lawsuit_alternative_request?: string | null;
    social_law_lawsuit_cost_request?: string | null;
    social_law_lawsuit_original_decision_date?: string | null;
    social_law_lawsuit_objection_decision_date?: string | null;
    social_law_lawsuit_objection_filing_date?: string | null;
    social_law_lawsuit_delivery_date?: string | null;
    social_law_lawsuit_dispute_value?: string | null;
    social_law_lawsuit_disputed_amount?: string | null;
    social_law_lawsuit_monthly_benefit_amount?: string | null;
    social_law_lawsuit_income_amount?: string | null;
    social_law_interim_protection_file_reference?: string | null;
    social_law_interim_protection_request_text?: string | null;
    social_law_interim_protection_urgency_reason?: string | null;
    social_law_interim_protection_request_date?: string | null;
    social_law_interim_protection_affidavit?: boolean | null;
    social_law_interim_protection_attachment_list?: string | null;
    social_law_medical_file_reference?: string | null;
    social_law_medical_examination_date?: string | null;
    social_law_medical_diagnosis?: string | null;
    social_law_medical_work_capacity_relation?: string | null;
    social_law_medical_prognosis?: string | null;
    social_law_medical_limitations?: string | null;
    social_law_medical_icd_code?: string | null;
    social_law_needs_file_reference?: string | null;
    social_law_needs_type?: string | null;
    social_law_needs_proof_basis?: string | null;
    social_law_needs_cost_breakdown?: string | null;
    social_law_needs_proof_date?: string | null;
    social_law_disability_file_reference?: string | null;
    social_law_disability_degree?: string | null;
    social_law_disability_card_issue_date?: string | null;
    social_law_disability_card_markers?: string | null;
    social_law_disability_card_validity_period?: string | null;
    social_law_hearing_file_reference?: string | null;
    social_law_hearing_planned_administrative_act?: string | null;
    social_law_hearing_letter_date?: string | null;
    social_law_appointment_file_reference?: string | null;
    social_law_appointment_date?: string | null;
    social_law_appointment_time?: string | null;
    social_law_appointment_purpose?: string | null;
    social_law_appointment_required_documents?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_object_size_sqm?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_last_signature_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_duration?: number | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_value_security_clause?: boolean | null;
    tenancy_law_tenant_extension_option?: boolean | null;
    tenancy_law_extension_option_count?: number | null;
    tenancy_law_extension_option_duration?: string | null;
    tenancy_law_security_deposit_amount?: string | null;
    tenancy_law_security_deposit_additional_regulations?: string | null;
    tenancy_law_cash_deposit_agreed?: boolean | null;
    tenancy_law_cash_deposit_payment_date?: string | null;
    tenancy_law_bank_guarantee?: boolean | null;
    tenancy_law_operating_costs_agreement?: string | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_garage_available?: boolean | null;
    tenancy_law_garage_costs?: string | null;
    tenancy_law_parking_space_available?: boolean | null;
    tenancy_law_parking_space_costs?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    tenancy_law_expert_report_damage_number?: string | null;
    tenancy_law_expert_report_object_address?: string | null;
    tenancy_law_expert_report_subject?: string | null;
    tenancy_law_expert_report_date?: string | null;
    tenancy_law_expert_report_purpose?: string | null;
    tenancy_law_expert_report_commission_date?: string | null;
    tenancy_law_expert_report_inspection_date?: string | null;
    tenancy_law_expert_report_damage_description?: string | null;
    tenancy_law_expert_report_repair_duration?: string | null;
    tenancy_law_tenant_warned?: boolean | null;
    tenancy_law_warning_letter_date?: string | null;
    tenancy_law_landlord_termination_given?: boolean | null;
    tenancy_law_termination_declared_date?: string | null;
    tenancy_law_termination_notice_period?: string | null;
    tenancy_law_termination_letter_date?: string | null;
    tenancy_law_tenancy_terminated?: boolean | null;
    tenancy_law_tenancy_termination_date?: string | null;
    tenancy_law_property_return_date?: string | null;
    tenancy_law_court_proceedings_pending?: boolean | null;
    tenancy_law_competent_court?: string | null;
    tenancy_law_court_case_number?: string | null;
    tenancy_law_last_rent_increase_letter_date?: string | null;
    tenancy_law_rent_increase_effective_date?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_plot_size?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    real_estate_law_purchase_contract_registration_number?: string | null;
    real_estate_law_brokerage_fee?: string | null;
    real_estate_law_property_brokered_by_agent?: boolean | null;
    real_estate_law_purchase_object_rented?: boolean | null;
    real_estate_law_encumbrances_section_ii?: string | null;
    real_estate_law_encumbrances_section_iii?: string | null;
    real_estate_law_building_restrictions_clause?: string | null;
    real_estate_law_contaminated_sites_clause?: string | null;
    real_estate_law_legal_defects_clause?: string | null;
    real_estate_law_purchase_price_loan_financed?: boolean | null;
    real_estate_law_withdrawal_instruction_date?: string | null;
    real_estate_law_building_permit_validity_duration?: string | null;
    real_estate_law_building_permit_date?: string | null;
    real_estate_law_building_permit_number?: string | null;
    real_estate_law_co_ownership_share?: string | null;
    real_estate_law_division_declaration_date?: string | null;
    real_estate_law_plan_designation?: string | null;
    real_estate_law_plan_scale?: string | null;
    real_estate_law_plan_author?: string | null;
    real_estate_law_building_usage?: string | null;
    real_estate_law_building_dimensions?: string | null;
    real_estate_law_monument_protection_order_number?: string | null;
    real_estate_law_monument_protection_order_date?: string | null;
    real_estate_law_monument_protection_basis?: string | null;
    real_estate_law_monument_registration_date?: string | null;
    real_estate_law_monument_protection_requirements?: string | null;
    real_estate_law_loan_amount?: string | null;
    real_estate_law_interest_rate?: string | null;
    real_estate_law_installment_amount?: string | null;
    real_estate_law_full_repayment_date?: string | null;
    real_estate_law_loan_security?: string | null;
    real_estate_law_repayment_rate?: string | null;
    real_estate_law_broker_commission_amount?: string | null;
    real_estate_law_broker_scope_of_work?: string | null;
    real_estate_law_broker_termination_periods?: string | null;
    real_estate_law_broker_contract_type?: string | null;
    real_estate_law_brokerage_contract_date?: string | null;
    real_estate_law_exclusive_brokerage_contract?: boolean | null;
    real_estate_law_commission_percentage?: string | null;
    migration_law_residence_permit_issue_date?: string | null;
    migration_law_residence_permit_valid_until?: string | null;
    migration_law_residence_permit_type?: string | null;
    migration_law_residence_permit_purpose?: string | null;
    migration_law_residence_permit_issuing_authority?: string | null;
    migration_law_residence_permit_conditions?: string | null;
    migration_law_residence_permit_passport_number?: string | null;
    migration_law_residence_permit_national_id_number?: string | null;
    migration_law_fictional_certificate_issue_date?: string | null;
    migration_law_fictional_certificate_valid_until?: string | null;
    migration_law_fictional_certificate_legal_basis?: string | null;
    migration_law_fictional_certificate_fiction_type?: string | null;
    migration_law_fictional_certificate_reason_for_issuance?: string | null;
    migration_law_fictional_certificate_authority?: string | null;
    migration_law_toleration_issue_date?: string | null;
    migration_law_toleration_valid_until?: string | null;
    migration_law_toleration_reason?: string | null;
    migration_law_toleration_legal_basis?: string | null;
    migration_law_toleration_restrictions?: string | null;
    migration_law_toleration_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_issue_date?: string | null;
    migration_law_asylum_seeker_certificate_valid_until?: string | null;
    migration_law_asylum_seeker_certificate_application_number?: string | null;
    migration_law_asylum_seeker_certificate_first_registration_date?: string | null;
    migration_law_asylum_seeker_certificate_residence_obligation?: string | null;
    migration_law_asylum_seeker_certificate_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_work_permission?: string | null;
    migration_law_rejection_notice_case_number?: string | null;
    migration_law_rejection_notice_decision_date?: string | null;
    migration_law_rejection_notice_subject?: string | null;
    migration_law_rejection_notice_legal_remedy_deadline?: string | null;
    migration_law_rejection_notice_reasoning?: string | null;
    migration_law_rejection_notice_legal_grounds?: string | null;
    migration_law_rejection_notice_officer_name?: string | null;
    migration_law_rejection_notice_signature_seal?: string | null;
    migration_law_approval_notice_case_number?: string | null;
    migration_law_approval_notice_decision_date?: string | null;
    migration_law_approval_notice_permit_type?: string | null;
    migration_law_approval_notice_validity_period?: string | null;
    migration_law_approval_notice_conditions?: string | null;
    migration_law_approval_notice_pickup_deadline?: string | null;
    migration_law_approval_notice_issuing_authority?: string | null;
    migration_law_hearing_letter_date?: string | null;
    migration_law_hearing_letter_response_deadline?: string | null;
    migration_law_hearing_letter_intended_measure_justification?: string | null;
    migration_law_hearing_letter_legal_advice?: string | null;
    migration_law_hearing_letter_requested_documents?: string | null;
    migration_law_cooperation_letter_date?: string | null;
    migration_law_cooperation_letter_file_number?: string | null;
    migration_law_cooperation_letter_specified_obligations?: string | null;
    migration_law_cooperation_letter_non_cooperation_consequences?: string | null;
    migration_law_cooperation_letter_deadlines?: string | null;
    migration_law_cooperation_letter_attachments?: string | null;
    migration_law_other_letters_issuing_authority?: string | null;
    migration_law_other_letters_file_number?: string | null;
    migration_law_other_letters_date?: string | null;
    migration_law_other_letters_subject?: string | null;
    migration_law_other_letters_matter_purpose?: string | null;
    migration_law_other_letters_legal_basis?: string | null;
    migration_law_other_letters_deadlines?: string | null;
    migration_law_other_letters_action_required?: string | null;
    civil_law_file_reference?: string | null;
    civil_law_document_date?: string | null;
    civil_law_subject_line?: string | null;
    civil_law_contract_date?: string | null;
    civil_law_contract_start_date?: string | null;
    civil_law_contract_end_date?: string | null;
    civil_law_contract_duration?: number | null;
    civil_law_contract_value?: string | null;
    civil_law_contract_object?: string | null;
    civil_law_termination_notice_period?: string | null;
    civil_law_notarial_certification_date?: string | null;
    civil_law_purchase_price?: string | null;
    civil_law_purchase_price_components?: string | null;
    civil_law_accessories_sold_separately?: boolean | null;
    civil_law_purchase_contract_file_reference?: string | null;
    civil_law_handover_date?: string | null;
    civil_law_purchase_price_paid?: boolean | null;
    civil_law_purchase_price_payment_date?: string | null;
    civil_law_purchase_price_paid_boolean?: boolean | null;
    civil_law_purchase_price_paid_date?: string | null;
    civil_law_purchase_price_paid_amount?: string | null;
    civil_law_purchase_object?: string | null;
    civil_law_purchase_date?: string | null;
    civil_law_delivery_date?: string | null;
    civil_law_warranty_period?: string | null;
    civil_law_defects?: string | null;
    civil_law_defects_present?: boolean | null;
    civil_law_vehicle_make?: string | null;
    civil_law_vehicle_model?: string | null;
    civil_law_vehicle_year?: number | null;
    civil_law_vehicle_mileage?: number | null;
    civil_law_vehicle_vin?: string | null;
    civil_law_damage_amount?: string | null;
    civil_law_damage_date?: string | null;
    civil_law_damage_description?: string | null;
    civil_law_damage_cause?: string | null;
    civil_law_liability_percentage?: string | null;
    civil_law_insurance_claim_number?: string | null;
    civil_law_court_name?: string | null;
    civil_law_case_number?: string | null;
    civil_law_hearing_date?: string | null;
    civil_law_judgment_date?: string | null;
    civil_law_claim_amount?: string | null;
    civil_law_court_costs?: string | null;
    civil_law_payment_due_date?: string | null;
    civil_law_interest_rate?: string | null;
    civil_law_default_interest?: string | null;
    general_law_file_ref?: string;
    general_law_subject?: string;
    general_law_doc_date?: string | null;
    general_law_prior_ref?: string;
    general_law_appendices?: string;
    general_law_invoice_number?: string;
    general_law_invoice_date?: string | null;
    general_law_due_date?: string | null;
    general_law_amount_total?: string | null;
    general_law_amount_net?: string | null;
    general_law_vat?: string | null;
    general_law_payment_terms?: string;
    general_law_court_name?: string;
    general_law_case_number?: string;
    general_law_hearing_date?: string | null;
    general_law_judgment_date?: string | null;
    general_law_court_costs?: string | null;
    medicine_law_medical_report_date?: string | null;
    medicine_law_medical_report_treatment_period?: string | null;
    medicine_law_medical_report_diagnosis_icd_code?: string | null;
    medicine_law_medical_report_diagnosis_short_text?: string | null;
    medicine_law_medical_report_treatment_measures?: string | null;
    medicine_law_medical_report_surgery_date?: string | null;
    medicine_law_medical_report_complications?: string | null;
    medicine_law_medical_report_further_treatment?: string | null;
    medicine_law_hospital_records_admission_date?: string | null;
    medicine_law_hospital_records_discharge_date?: string | null;
    medicine_law_hospital_records_station?: string | null;
    medicine_law_hospital_records_diagnoses_icd_codes?: string | null;
    medicine_law_hospital_records_operations?: string | null;
    medicine_law_hospital_records_operation_date?: string | null;
    medicine_law_hospital_records_medication_during_stay?: string | null;
    medicine_law_hospital_records_documented_complications?: string | null;
    medicine_law_hospital_records_discharge_prognosis?: string | null;
    medicine_law_medical_expertise_date?: string | null;
    medicine_law_medical_expertise_question_posed?: string | null;
    medicine_law_medical_expertise_medical_assessment?: string | null;
    medicine_law_medical_expertise_justification?: string | null;
    medicine_law_medical_expertise_result?: string | null;
    medicine_law_laboratory_results_examination_date?: string | null;
    medicine_law_laboratory_results_examination_type?: string | null;
    medicine_law_laboratory_results?: string | null;
    medicine_law_laboratory_results_relevant_deviations?: string | null;
    medicine_law_laboratory_results_further_investigation_recommendation?: string | null;
    medicine_law_health_insurance_letter_date?: string | null;
    medicine_law_health_insurance_letter_reference_to_application?: string | null;
    medicine_law_health_insurance_letter_decision?: string | null;
    medicine_law_health_insurance_letter_decision_justification?: string | null;
    medicine_law_health_insurance_letter_legal_remedy_instruction?: string | null;
    medicine_law_medical_bill_invoice_date?: string | null;
    medicine_law_medical_bill_invoice_number?: string | null;
    medicine_law_medical_bill_service_period?: string | null;
    medicine_law_medical_bill_services_list?: string | null;
    medicine_law_medical_bill_total_amount?: string | null;
    medicine_law_medical_bill_cost_bearer?: string | null;
    medicine_law_medical_bill_payment_deadline?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

export type LawDataRequest = {
    uuid?: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_end_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_local_transfer_clause?: boolean | null;
    labor_law_VSOP?: boolean | null;
    labor_law_LTI?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_notice_period_observed?: boolean | null;
    labor_law_termination_without_notice?: boolean | null;
    labor_law_reason_for_termination_given?: boolean | null;
    labor_law_exemption_revocable?: boolean | null;
    labor_law_exemption_irrevocable?: boolean | null;
    labor_law_return_of_company_property?: boolean | null;
    labor_law_termination_operational_reasons?: boolean | null;
    labor_law_company_hearing?: boolean | null;
    labor_law_reaction_company_hering?: string | null;
    labor_law_termination_authorization?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_warning_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_special_sentence?: boolean | null;
    labor_law_sprinter_clause?: boolean | null;
    labor_law_percent_sprinter_clause?: number | null;
    labor_law_certificate_clause?: boolean | null;
    labor_law_grade_certificate_clause?: string;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    labor_law_dependent_children?: boolean | null;
    labor_law_amount_dependent_children?: number | null;
    labor_law_years_of_employment?: string | null;
    labor_law_total_gross_salary?: string | null;
    labor_law_severance_amount?: string | null;
    labor_law_works_council_membership?: boolean | null;
    labor_law_pregnancy?: boolean | null;
    labor_law_disability?: boolean | null;
    labor_law_special_personal_circumstances?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_value_improvement?: string | null;
    traffic_law_damage_amount_net?: string | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    traffic_law_repair_damage?: boolean | null;
    traffic_law_total_damage?: boolean | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_application_file_reference?: string | null;
    social_law_legal_basis?: string | null;
    social_law_benefit_type?: string | null;
    social_law_own_income_amount?: string | null;
    social_law_social_benefit_type?: string | null;
    social_law_residence_status?: string | null;
    social_law_income_type?: string | null;
    social_law_asset_type?: string | null;
    social_law_approval_file_reference?: string | null;
    social_law_approval_notice_date?: string | null;
    social_law_approval_legal_basis?: string | null;
    social_law_approval_internal_reference?: string | null;
    social_law_approved_benefit_type?: string | null;
    social_law_approved_benefit_amount?: string | null;
    social_law_approved_benefit_period?: string | null;
    social_law_follow_up_application_notes?: string | null;
    social_law_approval_period_start?: string | null;
    social_law_approval_period_end?: string | null;
    social_law_regelbedarf_amount?: string | null;
    social_law_housing_costs_amount?: string | null;
    social_law_total_need_amount?: string | null;
    social_law_monthly_payment_amount?: string | null;
    social_law_employment_income?: string | null;
    social_law_other_income?: string | null;
    social_law_creditable_income?: string | null;
    social_law_change_file_reference?: string | null;
    social_law_change_notification_date?: string | null;
    social_law_affected_benefit?: string | null;
    social_law_change_description?: string | null;
    social_law_change_reason?: string | null;
    social_law_attachment_list?: string | null;
    social_law_rejection_file_reference?: string | null;
    social_law_rejection_legal_norm?: string | null;
    social_law_rejection_reason?: string | null;
    social_law_rejection_notice_date?: string | null;
    social_law_revocation_file_reference?: string | null;
    social_law_revocation_legal_norm?: string | null;
    social_law_revocation_reason?: string | null;
    social_law_revocation_notice_date?: string | null;
    social_law_revocation_reclaim_notes?: string | null;
    social_law_revocation_benefit_type?: string | null;
    social_law_revocation_period_start?: string | null;
    social_law_revocation_period_end?: string | null;
    social_law_original_decision_date?: string | null;
    social_law_total_reclaim_amount?: string | null;
    social_law_income_source?: string | null;
    social_law_income_amount?: string | null;
    social_law_income_date?: string | null;
    social_law_income_provider?: string | null;
    social_law_notification_date?: string | null;
    social_law_notification_source?: string | null;
    social_law_violation_type?: string | null;
    social_law_income_legal_basis?: string | null;
    social_law_reclaim_legal_basis?: string | null;
    social_law_notification_legal_basis?: string | null;
    social_law_reclaim_file_reference?: string | null;
    social_law_reclaim_legal_norm?: string | null;
    social_law_reclaim_amount?: string | null;
    social_law_reclaim_payment_deadline?: string | null;
    social_law_reclaim_notice_date?: string | null;
    social_law_reclaim_payment_terms?: string | null;
    social_law_objection_file_reference?: string | null;
    social_law_objection_challenged_notice?: string | null;
    social_law_objection_reasoning?: string | null;
    social_law_objection_date?: string | null;
    social_law_objection_suspension_request?: string | null;
    social_law_objection_evidence?: string | null;
    social_law_notice_of_objection_file_reference?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    social_law_lawsuit_file_reference?: string | null;
    social_law_lawsuit_subject?: string | null;
    social_law_lawsuit_filing_date?: string | null;
    social_law_lawsuit_evidence_requests?: string | null;
    social_law_lawsuit_attachment_list?: string | null;
    social_law_lawsuit_court_file_number?: string | null;
    social_law_lawsuit_legal_basis?: string | null;
    social_law_lawsuit_type?: string | null;
    social_law_lawsuit_main_request?: string | null;
    social_law_lawsuit_alternative_request?: string | null;
    social_law_lawsuit_cost_request?: string | null;
    social_law_lawsuit_original_decision_date?: string | null;
    social_law_lawsuit_objection_decision_date?: string | null;
    social_law_lawsuit_objection_filing_date?: string | null;
    social_law_lawsuit_delivery_date?: string | null;
    social_law_lawsuit_dispute_value?: string | null;
    social_law_lawsuit_disputed_amount?: string | null;
    social_law_lawsuit_monthly_benefit_amount?: string | null;
    social_law_lawsuit_income_amount?: string | null;
    social_law_interim_protection_file_reference?: string | null;
    social_law_interim_protection_request_text?: string | null;
    social_law_interim_protection_urgency_reason?: string | null;
    social_law_interim_protection_request_date?: string | null;
    social_law_interim_protection_affidavit?: boolean | null;
    social_law_interim_protection_attachment_list?: string | null;
    social_law_medical_file_reference?: string | null;
    social_law_medical_examination_date?: string | null;
    social_law_medical_diagnosis?: string | null;
    social_law_medical_work_capacity_relation?: string | null;
    social_law_medical_prognosis?: string | null;
    social_law_medical_limitations?: string | null;
    social_law_medical_icd_code?: string | null;
    social_law_needs_file_reference?: string | null;
    social_law_needs_type?: string | null;
    social_law_needs_proof_basis?: string | null;
    social_law_needs_cost_breakdown?: string | null;
    social_law_needs_proof_date?: string | null;
    social_law_disability_file_reference?: string | null;
    social_law_disability_degree?: string | null;
    social_law_disability_card_issue_date?: string | null;
    social_law_disability_card_markers?: string | null;
    social_law_disability_card_validity_period?: string | null;
    social_law_hearing_file_reference?: string | null;
    social_law_hearing_planned_administrative_act?: string | null;
    social_law_hearing_letter_date?: string | null;
    social_law_appointment_file_reference?: string | null;
    social_law_appointment_date?: string | null;
    social_law_appointment_time?: string | null;
    social_law_appointment_purpose?: string | null;
    social_law_appointment_required_documents?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_object_size_sqm?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_last_signature_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_duration?: number | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_value_security_clause?: boolean | null;
    tenancy_law_tenant_extension_option?: boolean | null;
    tenancy_law_extension_option_count?: number | null;
    tenancy_law_extension_option_duration?: string | null;
    tenancy_law_security_deposit_amount?: string | null;
    tenancy_law_security_deposit_additional_regulations?: string | null;
    tenancy_law_cash_deposit_agreed?: boolean | null;
    tenancy_law_cash_deposit_payment_date?: string | null;
    tenancy_law_bank_guarantee?: boolean | null;
    tenancy_law_operating_costs_agreement?: string | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_garage_available?: boolean | null;
    tenancy_law_garage_costs?: string | null;
    tenancy_law_parking_space_available?: boolean | null;
    tenancy_law_parking_space_costs?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    tenancy_law_expert_report_damage_number?: string | null;
    tenancy_law_expert_report_object_address?: string | null;
    tenancy_law_expert_report_subject?: string | null;
    tenancy_law_expert_report_date?: string | null;
    tenancy_law_expert_report_purpose?: string | null;
    tenancy_law_expert_report_commission_date?: string | null;
    tenancy_law_expert_report_inspection_date?: string | null;
    tenancy_law_expert_report_damage_description?: string | null;
    tenancy_law_expert_report_repair_duration?: string | null;
    tenancy_law_tenant_warned?: boolean | null;
    tenancy_law_warning_letter_date?: string | null;
    tenancy_law_landlord_termination_given?: boolean | null;
    tenancy_law_termination_declared_date?: string | null;
    tenancy_law_termination_notice_period?: string | null;
    tenancy_law_termination_letter_date?: string | null;
    tenancy_law_tenancy_terminated?: boolean | null;
    tenancy_law_tenancy_termination_date?: string | null;
    tenancy_law_property_return_date?: string | null;
    tenancy_law_court_proceedings_pending?: boolean | null;
    tenancy_law_competent_court?: string | null;
    tenancy_law_court_case_number?: string | null;
    tenancy_law_last_rent_increase_letter_date?: string | null;
    tenancy_law_rent_increase_effective_date?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_plot_size?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    real_estate_law_purchase_contract_registration_number?: string | null;
    real_estate_law_brokerage_fee?: string | null;
    real_estate_law_property_brokered_by_agent?: boolean | null;
    real_estate_law_purchase_object_rented?: boolean | null;
    real_estate_law_encumbrances_section_ii?: string | null;
    real_estate_law_encumbrances_section_iii?: string | null;
    real_estate_law_building_restrictions_clause?: string | null;
    real_estate_law_contaminated_sites_clause?: string | null;
    real_estate_law_legal_defects_clause?: string | null;
    real_estate_law_purchase_price_loan_financed?: boolean | null;
    real_estate_law_withdrawal_instruction_date?: string | null;
    real_estate_law_building_permit_validity_duration?: string | null;
    real_estate_law_building_permit_date?: string | null;
    real_estate_law_building_permit_number?: string | null;
    real_estate_law_co_ownership_share?: string | null;
    real_estate_law_division_declaration_date?: string | null;
    real_estate_law_plan_designation?: string | null;
    real_estate_law_plan_scale?: string | null;
    real_estate_law_plan_author?: string | null;
    real_estate_law_building_usage?: string | null;
    real_estate_law_building_dimensions?: string | null;
    real_estate_law_monument_protection_order_number?: string | null;
    real_estate_law_monument_protection_order_date?: string | null;
    real_estate_law_monument_protection_basis?: string | null;
    real_estate_law_monument_registration_date?: string | null;
    real_estate_law_monument_protection_requirements?: string | null;
    real_estate_law_loan_amount?: string | null;
    real_estate_law_interest_rate?: string | null;
    real_estate_law_installment_amount?: string | null;
    real_estate_law_full_repayment_date?: string | null;
    real_estate_law_loan_security?: string | null;
    real_estate_law_repayment_rate?: string | null;
    real_estate_law_broker_commission_amount?: string | null;
    real_estate_law_broker_scope_of_work?: string | null;
    real_estate_law_broker_termination_periods?: string | null;
    real_estate_law_broker_contract_type?: string | null;
    real_estate_law_brokerage_contract_date?: string | null;
    real_estate_law_exclusive_brokerage_contract?: boolean | null;
    real_estate_law_commission_percentage?: string | null;
    migration_law_residence_permit_issue_date?: string | null;
    migration_law_residence_permit_valid_until?: string | null;
    migration_law_residence_permit_type?: string | null;
    migration_law_residence_permit_purpose?: string | null;
    migration_law_residence_permit_issuing_authority?: string | null;
    migration_law_residence_permit_conditions?: string | null;
    migration_law_residence_permit_passport_number?: string | null;
    migration_law_residence_permit_national_id_number?: string | null;
    migration_law_fictional_certificate_issue_date?: string | null;
    migration_law_fictional_certificate_valid_until?: string | null;
    migration_law_fictional_certificate_legal_basis?: string | null;
    migration_law_fictional_certificate_fiction_type?: string | null;
    migration_law_fictional_certificate_reason_for_issuance?: string | null;
    migration_law_fictional_certificate_authority?: string | null;
    migration_law_toleration_issue_date?: string | null;
    migration_law_toleration_valid_until?: string | null;
    migration_law_toleration_reason?: string | null;
    migration_law_toleration_legal_basis?: string | null;
    migration_law_toleration_restrictions?: string | null;
    migration_law_toleration_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_issue_date?: string | null;
    migration_law_asylum_seeker_certificate_valid_until?: string | null;
    migration_law_asylum_seeker_certificate_application_number?: string | null;
    migration_law_asylum_seeker_certificate_first_registration_date?: string | null;
    migration_law_asylum_seeker_certificate_residence_obligation?: string | null;
    migration_law_asylum_seeker_certificate_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_work_permission?: string | null;
    migration_law_rejection_notice_case_number?: string | null;
    migration_law_rejection_notice_decision_date?: string | null;
    migration_law_rejection_notice_subject?: string | null;
    migration_law_rejection_notice_legal_remedy_deadline?: string | null;
    migration_law_rejection_notice_reasoning?: string | null;
    migration_law_rejection_notice_legal_grounds?: string | null;
    migration_law_rejection_notice_officer_name?: string | null;
    migration_law_rejection_notice_signature_seal?: string | null;
    migration_law_approval_notice_case_number?: string | null;
    migration_law_approval_notice_decision_date?: string | null;
    migration_law_approval_notice_permit_type?: string | null;
    migration_law_approval_notice_validity_period?: string | null;
    migration_law_approval_notice_conditions?: string | null;
    migration_law_approval_notice_pickup_deadline?: string | null;
    migration_law_approval_notice_issuing_authority?: string | null;
    migration_law_hearing_letter_date?: string | null;
    migration_law_hearing_letter_response_deadline?: string | null;
    migration_law_hearing_letter_intended_measure_justification?: string | null;
    migration_law_hearing_letter_legal_advice?: string | null;
    migration_law_hearing_letter_requested_documents?: string | null;
    migration_law_cooperation_letter_date?: string | null;
    migration_law_cooperation_letter_file_number?: string | null;
    migration_law_cooperation_letter_specified_obligations?: string | null;
    migration_law_cooperation_letter_non_cooperation_consequences?: string | null;
    migration_law_cooperation_letter_deadlines?: string | null;
    migration_law_cooperation_letter_attachments?: string | null;
    migration_law_other_letters_issuing_authority?: string | null;
    migration_law_other_letters_file_number?: string | null;
    migration_law_other_letters_date?: string | null;
    migration_law_other_letters_subject?: string | null;
    migration_law_other_letters_matter_purpose?: string | null;
    migration_law_other_letters_legal_basis?: string | null;
    migration_law_other_letters_deadlines?: string | null;
    migration_law_other_letters_action_required?: string | null;
    civil_law_file_reference?: string | null;
    civil_law_document_date?: string | null;
    civil_law_subject_line?: string | null;
    civil_law_contract_date?: string | null;
    civil_law_contract_start_date?: string | null;
    civil_law_contract_end_date?: string | null;
    civil_law_contract_duration?: number | null;
    civil_law_contract_value?: string | null;
    civil_law_contract_object?: string | null;
    civil_law_termination_notice_period?: string | null;
    civil_law_notarial_certification_date?: string | null;
    civil_law_purchase_price?: string | null;
    civil_law_purchase_price_components?: string | null;
    civil_law_accessories_sold_separately?: boolean | null;
    civil_law_purchase_contract_file_reference?: string | null;
    civil_law_handover_date?: string | null;
    civil_law_purchase_price_paid?: boolean | null;
    civil_law_purchase_price_payment_date?: string | null;
    civil_law_purchase_price_paid_boolean?: boolean | null;
    civil_law_purchase_price_paid_date?: string | null;
    civil_law_purchase_price_paid_amount?: string | null;
    civil_law_purchase_object?: string | null;
    civil_law_purchase_date?: string | null;
    civil_law_delivery_date?: string | null;
    civil_law_warranty_period?: string | null;
    civil_law_defects?: string | null;
    civil_law_defects_present?: boolean | null;
    civil_law_vehicle_make?: string | null;
    civil_law_vehicle_model?: string | null;
    civil_law_vehicle_year?: number | null;
    civil_law_vehicle_mileage?: number | null;
    civil_law_vehicle_vin?: string | null;
    civil_law_damage_amount?: string | null;
    civil_law_damage_date?: string | null;
    civil_law_damage_description?: string | null;
    civil_law_damage_cause?: string | null;
    civil_law_liability_percentage?: string | null;
    civil_law_insurance_claim_number?: string | null;
    civil_law_court_name?: string | null;
    civil_law_case_number?: string | null;
    civil_law_hearing_date?: string | null;
    civil_law_judgment_date?: string | null;
    civil_law_claim_amount?: string | null;
    civil_law_court_costs?: string | null;
    civil_law_payment_due_date?: string | null;
    civil_law_interest_rate?: string | null;
    civil_law_default_interest?: string | null;
    general_law_file_ref?: string;
    general_law_subject?: string;
    general_law_doc_date?: string | null;
    general_law_prior_ref?: string;
    general_law_appendices?: string;
    general_law_invoice_number?: string;
    general_law_invoice_date?: string | null;
    general_law_due_date?: string | null;
    general_law_amount_total?: string | null;
    general_law_amount_net?: string | null;
    general_law_vat?: string | null;
    general_law_payment_terms?: string;
    general_law_court_name?: string;
    general_law_case_number?: string;
    general_law_hearing_date?: string | null;
    general_law_judgment_date?: string | null;
    general_law_court_costs?: string | null;
    medicine_law_medical_report_date?: string | null;
    medicine_law_medical_report_treatment_period?: string | null;
    medicine_law_medical_report_diagnosis_icd_code?: string | null;
    medicine_law_medical_report_diagnosis_short_text?: string | null;
    medicine_law_medical_report_treatment_measures?: string | null;
    medicine_law_medical_report_surgery_date?: string | null;
    medicine_law_medical_report_complications?: string | null;
    medicine_law_medical_report_further_treatment?: string | null;
    medicine_law_hospital_records_admission_date?: string | null;
    medicine_law_hospital_records_discharge_date?: string | null;
    medicine_law_hospital_records_station?: string | null;
    medicine_law_hospital_records_diagnoses_icd_codes?: string | null;
    medicine_law_hospital_records_operations?: string | null;
    medicine_law_hospital_records_operation_date?: string | null;
    medicine_law_hospital_records_medication_during_stay?: string | null;
    medicine_law_hospital_records_documented_complications?: string | null;
    medicine_law_hospital_records_discharge_prognosis?: string | null;
    medicine_law_medical_expertise_date?: string | null;
    medicine_law_medical_expertise_question_posed?: string | null;
    medicine_law_medical_expertise_medical_assessment?: string | null;
    medicine_law_medical_expertise_justification?: string | null;
    medicine_law_medical_expertise_result?: string | null;
    medicine_law_laboratory_results_examination_date?: string | null;
    medicine_law_laboratory_results_examination_type?: string | null;
    medicine_law_laboratory_results?: string | null;
    medicine_law_laboratory_results_relevant_deviations?: string | null;
    medicine_law_laboratory_results_further_investigation_recommendation?: string | null;
    medicine_law_health_insurance_letter_date?: string | null;
    medicine_law_health_insurance_letter_reference_to_application?: string | null;
    medicine_law_health_insurance_letter_decision?: string | null;
    medicine_law_health_insurance_letter_decision_justification?: string | null;
    medicine_law_health_insurance_letter_legal_remedy_instruction?: string | null;
    medicine_law_medical_bill_invoice_date?: string | null;
    medicine_law_medical_bill_invoice_number?: string | null;
    medicine_law_medical_bill_service_period?: string | null;
    medicine_law_medical_bill_services_list?: string | null;
    medicine_law_medical_bill_total_amount?: string | null;
    medicine_law_medical_bill_cost_bearer?: string | null;
    medicine_law_medical_bill_payment_deadline?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

/**
 * * `Allgemein` - Allgemein
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - IT Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-und Presserecht
 * * `Medizinrecht` - Medizinrecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla_Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export type LawFieldEnum = 'Allgemein' | 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'Immobilienrecht' | 'Inkasso' | 'IT Recht' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Medizinrecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';

/**
 * * `Allgemein` - Allgemein
 * * `Arbeitsrecht` - Arbeitsrecht
 * * `Asylrecht` - Asylrecht
 * * `Ausländerrecht` - Ausländerrecht
 * * `Bankrecht` - Bankrecht
 * * `Baurecht` - Baurecht
 * * `Beamtenrecht` - Beamtenrecht
 * * `Bewertungen löschen` - Bewertungen löschen
 * * `Casino` - Casino
 * * `Coaching` - Coaching
 * * `Compliance` - Compliance
 * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
 * * `Datenleck` - Datenleck
 * * `Erbrecht` - Erbrecht
 * * `Familienrecht` - Familienrecht
 * * `Gesellschaftsrecht` - Gesellschaftsrecht
 * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
 * * `Hochschulrecht` - Hochschulrecht
 * * `Immobilienrecht` - Immobilienrecht
 * * `Inkasso` - Inkasso
 * * `IT Recht` - IT Recht
 * * `Insolvenzberatung` - Insolvenzberatung
 * * `Markenrecht` - Markenrecht
 * * `Medien-und Presserecht` - Medien-und Presserecht
 * * `Medizinrecht` - Medizinrecht
 * * `Mietrecht` - Mietrecht
 * * `Migrationsrecht` - Migrationsrecht
 * * `Musikrecht` - Musikrecht
 * * `Notariat` - Notariat
 * * `Personenschäden` - Personenschäden
 * * `Schufa` - Schufa
 * * `Schulrecht` - Schulrecht
 * * `Social Media Recht` - Social Media Recht
 * * `Sozialrecht` - Sozialrecht
 * * `Steuerberatung` - Steuerberatung
 * * `Steuerrecht` - Steuerrecht
 * * `Strafrecht` - Strafrecht
 * * `Tesla_Widerruf` - Tesla_Widerruf
 * * `Tierrecht` - Tierrecht
 * * `Verkehrsrecht` - Verkehrsrecht
 * * `Versicherungsrecht` - Versicherungsrecht
 * * `Verwaltungsrecht` - Verwaltungsrecht
 * * `Wegrecht` - Wegrecht
 * * `Zivilrecht` - Zivilrecht
 */
export const LawFieldEnum = {
    ALLGEMEIN: 'Allgemein',
    ARBEITSRECHT: 'Arbeitsrecht',
    ASYLRECHT: 'Asylrecht',
    'AUSLÄNDERRECHT': 'Ausländerrecht',
    BANKRECHT: 'Bankrecht',
    BAURECHT: 'Baurecht',
    BEAMTENRECHT: 'Beamtenrecht',
    'BEWERTUNGEN_LÖSCHEN': 'Bewertungen löschen',
    CASINO: 'Casino',
    COACHING: 'Coaching',
    COMPLIANCE: 'Compliance',
    'CORONA_ÜBERBRÜCKUNGSHILFE': 'Corona Überbrückungshilfe',
    DATENLECK: 'Datenleck',
    ERBRECHT: 'Erbrecht',
    FAMILIENRECHT: 'Familienrecht',
    GESELLSCHAFTSRECHT: 'Gesellschaftsrecht',
    GEWERBLICHER_RECHTSSCHUTZ_URHEBERRECHT: 'Gewerblicher Rechtsschutz/Urheberrecht',
    HOCHSCHULRECHT: 'Hochschulrecht',
    IMMOBILIENRECHT: 'Immobilienrecht',
    INKASSO: 'Inkasso',
    IT_RECHT: 'IT Recht',
    INSOLVENZBERATUNG: 'Insolvenzberatung',
    MARKENRECHT: 'Markenrecht',
    MEDIEN_UND_PRESSERECHT: 'Medien-und Presserecht',
    MEDIZINRECHT: 'Medizinrecht',
    MIETRECHT: 'Mietrecht',
    MIGRATIONSRECHT: 'Migrationsrecht',
    MUSIKRECHT: 'Musikrecht',
    NOTARIAT: 'Notariat',
    'PERSONENSCHÄDEN': 'Personenschäden',
    SCHUFA: 'Schufa',
    SCHULRECHT: 'Schulrecht',
    SOCIAL_MEDIA_RECHT: 'Social Media Recht',
    SOZIALRECHT: 'Sozialrecht',
    STEUERBERATUNG: 'Steuerberatung',
    STEUERRECHT: 'Steuerrecht',
    STRAFRECHT: 'Strafrecht',
    TESLA_WIDERRUF: 'Tesla_Widerruf',
    TIERRECHT: 'Tierrecht',
    VERKEHRSRECHT: 'Verkehrsrecht',
    VERSICHERUNGSRECHT: 'Versicherungsrecht',
    VERWALTUNGSRECHT: 'Verwaltungsrecht',
    WEGRECHT: 'Wegrecht',
    ZIVILRECHT: 'Zivilrecht'
} as const;

export type LawFields = {
    data: {
        [key: string]: Array<(string)>;
    };
};

export type LawFirmSoftwareDataRequest = {
    fileData?: Array<FileDataRequest>;
    entities_with_relationships: Array<(string)>;
};

/**
 * * `AGB` - AGB
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung nicht eingehalten
 * * `Account hacking` - Account hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/ALG/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Diskriminierung` - Diskriminierung
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Eingruppierung` - Eingruppierung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Mobbing` - Mobbing
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflegerecht` - Pflegerecht
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß gegen die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung zu Lebzeiten
 */
export type LawTopicEnum = 'AGB' | 'Abfindung' | 'Abmahnung' | 'Abmahnung Wettbewerbsrecht' | 'Abschiebungshaft' | 'Abschlussarbeit' | 'Abstandsregelung nicht eingehalten' | 'Account hacking' | 'Allgemein' | 'Allgemeines Prüfungsrecht' | 'Anderes' | 'Arbeitsamt/ALG/Sperrzeit' | 'Arbeitsunfall' | 'Arbeitsvertrag' | 'Arbeitszeugnis' | 'Aufbau Compliancesystem' | 'Aufenthaltserlaubnis' | 'Aufhebungsvertrag' | 'Auftragsdatenverarbeitung' | 'Auseinandersetzung Erbengemeinschaft' | 'Auskunft prüfen' | 'Ausweisung' | 'Autokauf' | 'Bankkonto leergeräumt' | 'Bankrecht' | 'Baumangel' | 'Bauvertrag' | 'Behandlungsfehler Allgemein' | 'Behandlungsfehler Querschnittslähmung' | 'Behandlungsfehler Schlaganfall' | 'Beißvorfall' | 'Beratung zu Erbfall' | 'Beschlagnahme Allgemein' | 'Beschlagnahme Tierquälerei' | 'Betreuungsrecht' | 'Betrug Geldanlage' | 'Betäubungsmittel' | 'Burgschild Inkasso' | 'Bußgeldbescheid' | 'Bürgergeld' | 'Coaching' | 'Datenschutz' | 'Datenschutz Schadensersatz' | 'Datenschutzverstoß' | 'Diskriminierung' | 'Domains' | 'Ehevertrag' | 'Eigentumsdelikte' | 'Einbürgerung' | 'Eingruppierung' | 'Einreisesperre' | 'Eintrag löschen' | 'Erbauseinandersetzung' | 'Erbausschlagung' | 'Erben/Schenken' | 'Erbengemeinschaft' | 'Erbschein' | 'Erbscheinsantrag' | 'Erbvertrag' | 'Exmatrikulation' | 'Fahren ohne Führerschein' | 'Fahren unter Alkohol - / Drogeneinfluss' | 'Fahrer - / Unfallflucht' | 'Fahrverbot / Führerscheinentzug' | 'Falschaussage/ Meineid' | 'Familie Vorsorge' | 'Forderung löschen' | 'Geburtsfehler' | 'Geburtsfehler Mutter' | 'Geschwindigkeitsüberschreitung' | 'Gesetzliche Erbfolge' | 'Gewerblicher Rechtsschutz' | 'Grundschuld' | 'Gründung' | 'Handy am Steuer' | 'Hauskauf' | 'Härtefallantrag' | 'Immobilien' | 'Immobilienübertragung' | 'Kaufvertragsprüfung' | 'Körperverletzung' | 'Kündigung' | 'Lohnzahlung' | 'Maklerangelegenheit' | 'Markenanmeldung' | 'Markenverteidigung' | 'Markenüberwachung' | 'Mieterhöhung' | 'Mietkaution' | 'Mietminderung' | 'Mietvertrag' | 'Mobbing' | 'Nebenkostenabrechnung' | 'Niederlassungserlaubnis' | 'Nutzerbewertungen Verfasser' | 'Patientenverfügung/Vorsorgevollmacht' | 'Personenverwechselung' | 'Pflege-/Krankenversicherung' | 'Pflegerecht' | 'Pflichtteil' | 'Pflichtteil Geltendmachung' | 'Pflichtteil abwehren' | 'Plagiatsvorwurf' | 'Remonstration' | 'Rente' | 'Rotlichtverstoß' | 'Räumungsklage' | 'Schadensersatz' | 'Scheidung' | 'Schenkung' | 'Schenkung Immobilie' | 'Schulplatz einklagen' | 'Schwerbehinderung' | 'Sexualdelikt' | 'Software Hardware' | 'Sonstige Beglaubigung' | 'Sorgerecht und Umgangsrecht' | 'Testament' | 'Testament/Erbvertrag' | 'Tierkauf' | 'Tierärztliche Behandlungsfehler' | 'Trennung' | 'Tuning' | 'Täuschungsversuch' | 'Tötungsdelikte' | 'Unfall Querschnittslähmung' | 'Unfall mit Personenschaden' | 'Unterhalt' | 'Unternehmen' | 'Unternehmensauflösung' | 'Unternehmensgründung' | 'Unternehmenskauf' | 'Urheberrecht' | 'Urlaub' | 'Vaterschaftsanerkennung' | 'Vererben' | 'Verkehrsunfall' | 'Vermögensauseinandersetzung' | 'Vermögensdelikte' | 'Verstoß gegen die Anschnallpflicht' | 'Vertragsprüfung' | 'Vertragsrecht' | 'Visum' | 'Vorfälligkeitsentschädigung' | 'Vorsorge' | 'Vorsorgevollmacht/Patientenverfügung' | 'Waffendelikte' | 'Wettbewerbsrecht' | 'Widerrufsrechte' | 'Widerspruch/ Klage' | 'Wucherzinsen Darlehen' | 'Zugewinnausgleich' | 'Zweiradunfall' | 'unbezahlte Rechnungen' | 'unerlaubtes Glücksspiel' | 'Überstunden' | 'Übertragung zu Lebzeiten';

/**
 * * `AGB` - AGB
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung nicht eingehalten
 * * `Account hacking` - Account hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/ALG/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Diskriminierung` - Diskriminierung
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Eingruppierung` - Eingruppierung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Mobbing` - Mobbing
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflegerecht` - Pflegerecht
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß gegen die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung zu Lebzeiten
 */
export const LawTopicEnum = {
    AGB: 'AGB',
    ABFINDUNG: 'Abfindung',
    ABMAHNUNG: 'Abmahnung',
    ABMAHNUNG_WETTBEWERBSRECHT: 'Abmahnung Wettbewerbsrecht',
    ABSCHIEBUNGSHAFT: 'Abschiebungshaft',
    ABSCHLUSSARBEIT: 'Abschlussarbeit',
    ABSTANDSREGELUNG_NICHT_EINGEHALTEN: 'Abstandsregelung nicht eingehalten',
    ACCOUNT_HACKING: 'Account hacking',
    ALLGEMEIN: 'Allgemein',
    'ALLGEMEINES_PRÜFUNGSRECHT': 'Allgemeines Prüfungsrecht',
    ANDERES: 'Anderes',
    ARBEITSAMT_ALG_SPERRZEIT: 'Arbeitsamt/ALG/Sperrzeit',
    ARBEITSUNFALL: 'Arbeitsunfall',
    ARBEITSVERTRAG: 'Arbeitsvertrag',
    ARBEITSZEUGNIS: 'Arbeitszeugnis',
    AUFBAU_COMPLIANCESYSTEM: 'Aufbau Compliancesystem',
    AUFENTHALTSERLAUBNIS: 'Aufenthaltserlaubnis',
    AUFHEBUNGSVERTRAG: 'Aufhebungsvertrag',
    AUFTRAGSDATENVERARBEITUNG: 'Auftragsdatenverarbeitung',
    AUSEINANDERSETZUNG_ERBENGEMEINSCHAFT: 'Auseinandersetzung Erbengemeinschaft',
    'AUSKUNFT_PRÜFEN': 'Auskunft prüfen',
    AUSWEISUNG: 'Ausweisung',
    AUTOKAUF: 'Autokauf',
    'BANKKONTO_LEERGERÄUMT': 'Bankkonto leergeräumt',
    BANKRECHT: 'Bankrecht',
    BAUMANGEL: 'Baumangel',
    BAUVERTRAG: 'Bauvertrag',
    BEHANDLUNGSFEHLER_ALLGEMEIN: 'Behandlungsfehler Allgemein',
    'BEHANDLUNGSFEHLER_QUERSCHNITTSLÄHMUNG': 'Behandlungsfehler Querschnittslähmung',
    BEHANDLUNGSFEHLER_SCHLAGANFALL: 'Behandlungsfehler Schlaganfall',
    BEISSVORFALL: 'Beißvorfall',
    BERATUNG_ZU_ERBFALL: 'Beratung zu Erbfall',
    BESCHLAGNAHME_ALLGEMEIN: 'Beschlagnahme Allgemein',
    'BESCHLAGNAHME_TIERQUÄLEREI': 'Beschlagnahme Tierquälerei',
    BETREUUNGSRECHT: 'Betreuungsrecht',
    BETRUG_GELDANLAGE: 'Betrug Geldanlage',
    'BETÄUBUNGSMITTEL': 'Betäubungsmittel',
    BURGSCHILD_INKASSO: 'Burgschild Inkasso',
    BUSSGELDBESCHEID: 'Bußgeldbescheid',
    'BÜRGERGELD': 'Bürgergeld',
    COACHING: 'Coaching',
    DATENSCHUTZ: 'Datenschutz',
    DATENSCHUTZ_SCHADENSERSATZ: 'Datenschutz Schadensersatz',
    DATENSCHUTZVERSTOSS: 'Datenschutzverstoß',
    DISKRIMINIERUNG: 'Diskriminierung',
    DOMAINS: 'Domains',
    EHEVERTRAG: 'Ehevertrag',
    EIGENTUMSDELIKTE: 'Eigentumsdelikte',
    'EINBÜRGERUNG': 'Einbürgerung',
    EINGRUPPIERUNG: 'Eingruppierung',
    EINREISESPERRE: 'Einreisesperre',
    'EINTRAG_LÖSCHEN': 'Eintrag löschen',
    ERBAUSEINANDERSETZUNG: 'Erbauseinandersetzung',
    ERBAUSSCHLAGUNG: 'Erbausschlagung',
    ERBEN_SCHENKEN: 'Erben/Schenken',
    ERBENGEMEINSCHAFT: 'Erbengemeinschaft',
    ERBSCHEIN: 'Erbschein',
    ERBSCHEINSANTRAG: 'Erbscheinsantrag',
    ERBVERTRAG: 'Erbvertrag',
    EXMATRIKULATION: 'Exmatrikulation',
    'FAHREN_OHNE_FÜHRERSCHEIN': 'Fahren ohne Führerschein',
    FAHREN_UNTER_ALKOHOL_____DROGENEINFLUSS: 'Fahren unter Alkohol - / Drogeneinfluss',
    FAHRER_____UNFALLFLUCHT: 'Fahrer - / Unfallflucht',
    'FAHRVERBOT___FÜHRERSCHEINENTZUG': 'Fahrverbot / Führerscheinentzug',
    FALSCHAUSSAGE__MEINEID: 'Falschaussage/ Meineid',
    FAMILIE_VORSORGE: 'Familie Vorsorge',
    'FORDERUNG_LÖSCHEN': 'Forderung löschen',
    GEBURTSFEHLER: 'Geburtsfehler',
    GEBURTSFEHLER_MUTTER: 'Geburtsfehler Mutter',
    'GESCHWINDIGKEITSÜBERSCHREITUNG': 'Geschwindigkeitsüberschreitung',
    GESETZLICHE_ERBFOLGE: 'Gesetzliche Erbfolge',
    GEWERBLICHER_RECHTSSCHUTZ: 'Gewerblicher Rechtsschutz',
    GRUNDSCHULD: 'Grundschuld',
    'GRÜNDUNG': 'Gründung',
    HANDY_AM_STEUER: 'Handy am Steuer',
    HAUSKAUF: 'Hauskauf',
    'HÄRTEFALLANTRAG': 'Härtefallantrag',
    IMMOBILIEN: 'Immobilien',
    'IMMOBILIENÜBERTRAGUNG': 'Immobilienübertragung',
    'KAUFVERTRAGSPRÜFUNG': 'Kaufvertragsprüfung',
    'KÖRPERVERLETZUNG': 'Körperverletzung',
    'KÜNDIGUNG': 'Kündigung',
    LOHNZAHLUNG: 'Lohnzahlung',
    MAKLERANGELEGENHEIT: 'Maklerangelegenheit',
    MARKENANMELDUNG: 'Markenanmeldung',
    MARKENVERTEIDIGUNG: 'Markenverteidigung',
    'MARKENÜBERWACHUNG': 'Markenüberwachung',
    'MIETERHÖHUNG': 'Mieterhöhung',
    MIETKAUTION: 'Mietkaution',
    MIETMINDERUNG: 'Mietminderung',
    MIETVERTRAG: 'Mietvertrag',
    MOBBING: 'Mobbing',
    NEBENKOSTENABRECHNUNG: 'Nebenkostenabrechnung',
    NIEDERLASSUNGSERLAUBNIS: 'Niederlassungserlaubnis',
    NUTZERBEWERTUNGEN_VERFASSER: 'Nutzerbewertungen Verfasser',
    'PATIENTENVERFÜGUNG_VORSORGEVOLLMACHT': 'Patientenverfügung/Vorsorgevollmacht',
    PERSONENVERWECHSELUNG: 'Personenverwechselung',
    PFLEGE__KRANKENVERSICHERUNG: 'Pflege-/Krankenversicherung',
    PFLEGERECHT: 'Pflegerecht',
    PFLICHTTEIL: 'Pflichtteil',
    PFLICHTTEIL_GELTENDMACHUNG: 'Pflichtteil Geltendmachung',
    PFLICHTTEIL_ABWEHREN: 'Pflichtteil abwehren',
    PLAGIATSVORWURF: 'Plagiatsvorwurf',
    REMONSTRATION: 'Remonstration',
    RENTE: 'Rente',
    ROTLICHTVERSTOSS: 'Rotlichtverstoß',
    'RÄUMUNGSKLAGE': 'Räumungsklage',
    SCHADENSERSATZ: 'Schadensersatz',
    SCHEIDUNG: 'Scheidung',
    SCHENKUNG: 'Schenkung',
    SCHENKUNG_IMMOBILIE: 'Schenkung Immobilie',
    SCHULPLATZ_EINKLAGEN: 'Schulplatz einklagen',
    SCHWERBEHINDERUNG: 'Schwerbehinderung',
    SEXUALDELIKT: 'Sexualdelikt',
    SOFTWARE_HARDWARE: 'Software Hardware',
    SONSTIGE_BEGLAUBIGUNG: 'Sonstige Beglaubigung',
    SORGERECHT_UND_UMGANGSRECHT: 'Sorgerecht und Umgangsrecht',
    TESTAMENT: 'Testament',
    TESTAMENT_ERBVERTRAG: 'Testament/Erbvertrag',
    TIERKAUF: 'Tierkauf',
    'TIERÄRZTLICHE_BEHANDLUNGSFEHLER': 'Tierärztliche Behandlungsfehler',
    TRENNUNG: 'Trennung',
    TUNING: 'Tuning',
    'TÄUSCHUNGSVERSUCH': 'Täuschungsversuch',
    'TÖTUNGSDELIKTE': 'Tötungsdelikte',
    'UNFALL_QUERSCHNITTSLÄHMUNG': 'Unfall Querschnittslähmung',
    UNFALL_MIT_PERSONENSCHADEN: 'Unfall mit Personenschaden',
    UNTERHALT: 'Unterhalt',
    UNTERNEHMEN: 'Unternehmen',
    'UNTERNEHMENSAUFLÖSUNG': 'Unternehmensauflösung',
    'UNTERNEHMENSGRÜNDUNG': 'Unternehmensgründung',
    UNTERNEHMENSKAUF: 'Unternehmenskauf',
    URHEBERRECHT: 'Urheberrecht',
    URLAUB: 'Urlaub',
    VATERSCHAFTSANERKENNUNG: 'Vaterschaftsanerkennung',
    VERERBEN: 'Vererben',
    VERKEHRSUNFALL: 'Verkehrsunfall',
    'VERMÖGENSAUSEINANDERSETZUNG': 'Vermögensauseinandersetzung',
    'VERMÖGENSDELIKTE': 'Vermögensdelikte',
    VERSTOSS_GEGEN_DIE_ANSCHNALLPFLICHT: 'Verstoß gegen die Anschnallpflicht',
    'VERTRAGSPRÜFUNG': 'Vertragsprüfung',
    VERTRAGSRECHT: 'Vertragsrecht',
    VISUM: 'Visum',
    'VORFÄLLIGKEITSENTSCHÄDIGUNG': 'Vorfälligkeitsentschädigung',
    VORSORGE: 'Vorsorge',
    'VORSORGEVOLLMACHT_PATIENTENVERFÜGUNG': 'Vorsorgevollmacht/Patientenverfügung',
    WAFFENDELIKTE: 'Waffendelikte',
    WETTBEWERBSRECHT: 'Wettbewerbsrecht',
    WIDERRUFSRECHTE: 'Widerrufsrechte',
    WIDERSPRUCH__KLAGE: 'Widerspruch/ Klage',
    WUCHERZINSEN_DARLEHEN: 'Wucherzinsen Darlehen',
    ZUGEWINNAUSGLEICH: 'Zugewinnausgleich',
    ZWEIRADUNFALL: 'Zweiradunfall',
    UNBEZAHLTE_RECHNUNGEN: 'unbezahlte Rechnungen',
    'UNERLAUBTES_GLÜCKSSPIEL': 'unerlaubtes Glücksspiel',
    'ÜBERSTUNDEN': 'Überstunden',
    'ÜBERTRAGUNG_ZU_LEBZEITEN': 'Übertragung zu Lebzeiten'
} as const;

/**
 * Serializer for LawFirm integration settings in Organisation model.
 */
export type LawfirmSettings = {
    is_law_firm_software_exportation_enabled?: boolean;
};

/**
 * Serializer for LawFirm integration settings in Organisation model.
 */
export type LawfirmSettingsRequest = {
    is_law_firm_software_exportation_enabled?: boolean;
};

export type LawyerFeedback = {
    readonly uuid: string;
};

/**
 * Serializer for a single link decision value in party matching.
 */
export type LinkDecisionValueRequest = {
    action: ActionEnum;
    contact_id?: string | null;
    update?: boolean;
};

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export type LocationTypeEnum = 'ONLINE' | 'TELEPHONE' | 'IN_PERSON';

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export const LocationTypeEnum = {
    ONLINE: 'ONLINE',
    TELEPHONE: 'TELEPHONE',
    IN_PERSON: 'IN_PERSON'
} as const;

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export type LocationTypesEnum = 'ONLINE' | 'TELEPHONE' | 'IN_PERSON';

/**
 * * `ONLINE` - Online-Termin
 * * `TELEPHONE` - Telefon-Termin
 * * `IN_PERSON` - Termin vor Ort
 */
export const LocationTypesEnum = {
    ONLINE: 'ONLINE',
    TELEPHONE: 'TELEPHONE',
    IN_PERSON: 'IN_PERSON'
} as const;

/**
 * * `INFO` - Info
 * * `WARNING` - Warning
 * * `ERROR` - Error
 * * `SUCCESS` - Success
 */
export type MessageTypeEnum = 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';

/**
 * * `INFO` - Info
 * * `WARNING` - Warning
 * * `ERROR` - Error
 * * `SUCCESS` - Success
 */
export const MessageTypeEnum = {
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS'
} as const;

/**
 * Minimal organisation representation with only uuid and name.
 * Used for dropdowns and lightweight lists.
 */
export type MinimalOrganisation = {
    readonly uuid: string;
    readonly name: string | null;
};

/**
 * * `CREATED` - Created
 * * `CLIENT_INFO_GATHERING` - Client Info Gathering
 * * `PRE_CASE_CONTEXT_GATHERING` - Pre Case Context Gathering
 * * `CASE_CONTEXT_GATHERING` - Case Context Gathering
 * * `POST_CASE_CONTEXT_GATHERING` - Post Case Context Gathering
 * * `LEGAL_DOMAIN_CLASSIFICATION` - Legal Domain Classification
 * * `WORKFLOW_ASSIGNMENT` - Workflow Assignment
 * * `READY_FOR_ONBOARDING_STEP_1` - Ready For Onboarding Step 1
 * * `READY_FOR_ONBOARDING_STEP_2` - Ready For Onboarding Step 2
 * * `DATA_COLLECTION` - Data Collection
 * * `ALL_DATA_COLLECTED` - All Data Collected
 * * `DOCUMENT_DRAFTING` - Document Drafting
 * * `ALL_DOCUMENTS_DRAFTED` - All Documents Drafted
 * * `READY_FOR_EXPORT` - Ready For Export
 * * `EXPORTED` - Exported
 * * `ABORTED` - Aborted
 */
export type NextStateEnum = 'CREATED' | 'CLIENT_INFO_GATHERING' | 'PRE_CASE_CONTEXT_GATHERING' | 'CASE_CONTEXT_GATHERING' | 'POST_CASE_CONTEXT_GATHERING' | 'LEGAL_DOMAIN_CLASSIFICATION' | 'WORKFLOW_ASSIGNMENT' | 'READY_FOR_ONBOARDING_STEP_1' | 'READY_FOR_ONBOARDING_STEP_2' | 'DATA_COLLECTION' | 'ALL_DATA_COLLECTED' | 'DOCUMENT_DRAFTING' | 'ALL_DOCUMENTS_DRAFTED' | 'READY_FOR_EXPORT' | 'EXPORTED' | 'ABORTED';

/**
 * * `CREATED` - Created
 * * `CLIENT_INFO_GATHERING` - Client Info Gathering
 * * `PRE_CASE_CONTEXT_GATHERING` - Pre Case Context Gathering
 * * `CASE_CONTEXT_GATHERING` - Case Context Gathering
 * * `POST_CASE_CONTEXT_GATHERING` - Post Case Context Gathering
 * * `LEGAL_DOMAIN_CLASSIFICATION` - Legal Domain Classification
 * * `WORKFLOW_ASSIGNMENT` - Workflow Assignment
 * * `READY_FOR_ONBOARDING_STEP_1` - Ready For Onboarding Step 1
 * * `READY_FOR_ONBOARDING_STEP_2` - Ready For Onboarding Step 2
 * * `DATA_COLLECTION` - Data Collection
 * * `ALL_DATA_COLLECTED` - All Data Collected
 * * `DOCUMENT_DRAFTING` - Document Drafting
 * * `ALL_DOCUMENTS_DRAFTED` - All Documents Drafted
 * * `READY_FOR_EXPORT` - Ready For Export
 * * `EXPORTED` - Exported
 * * `ABORTED` - Aborted
 */
export const NextStateEnum = {
    CREATED: 'CREATED',
    CLIENT_INFO_GATHERING: 'CLIENT_INFO_GATHERING',
    PRE_CASE_CONTEXT_GATHERING: 'PRE_CASE_CONTEXT_GATHERING',
    CASE_CONTEXT_GATHERING: 'CASE_CONTEXT_GATHERING',
    POST_CASE_CONTEXT_GATHERING: 'POST_CASE_CONTEXT_GATHERING',
    LEGAL_DOMAIN_CLASSIFICATION: 'LEGAL_DOMAIN_CLASSIFICATION',
    WORKFLOW_ASSIGNMENT: 'WORKFLOW_ASSIGNMENT',
    READY_FOR_ONBOARDING_STEP_1: 'READY_FOR_ONBOARDING_STEP_1',
    READY_FOR_ONBOARDING_STEP_2: 'READY_FOR_ONBOARDING_STEP_2',
    DATA_COLLECTION: 'DATA_COLLECTION',
    ALL_DATA_COLLECTED: 'ALL_DATA_COLLECTED',
    DOCUMENT_DRAFTING: 'DOCUMENT_DRAFTING',
    ALL_DOCUMENTS_DRAFTED: 'ALL_DOCUMENTS_DRAFTED',
    READY_FOR_EXPORT: 'READY_FOR_EXPORT',
    EXPORTED: 'EXPORTED',
    ABORTED: 'ABORTED'
} as const;

/**
 * Serializer for NotificationSettings.
 */
export type NotificationSettings = {
    /**
     * List of available notification settings parameters
     */
    params: Array<{
        [key: string]: unknown;
    }>;
};

export type NullEnum = unknown;

export type OnboardingPackageSession = {
    uuid?: string;
    session_token?: string;
    status?: Status7a8Enum;
    package_name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly created_at: string;
};

export type OnboardingPackageSessionDetail = {
    uuid?: string;
    session_token?: string;
    status?: Status7a8Enum;
    package_name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly questionnaires: Array<CustomerQuestionnaire>;
    readonly forms: Array<CustomerForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    readonly questionnaire_submissions: Array<QuestionnaireSubmission>;
    readonly form_requests: Array<ClientRequest>;
    readonly pdf_form_submissions: Array<ClientPDFFormSubmission>;
    readonly case: ClientCase;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * * `merge` - Merge
 * * `split` - Split
 * * `reorganize` - Reorganize
 */
export type OperationTypeEnum = 'merge' | 'split' | 'reorganize';

/**
 * * `merge` - Merge
 * * `split` - Split
 * * `reorganize` - Reorganize
 */
export const OperationTypeEnum = {
    MERGE: 'merge',
    SPLIT: 'split',
    REORGANIZE: 'reorganize'
} as const;

/**
 * Serializer for organisation employees.
 */
export type OrganisationEmployee = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
    readonly is_lawfirm_admin: string;
    readonly role: Role5ccEnum | NullEnum | null;
};

/**
 * Serializer for organisation logo updates.
 */
export type OrganisationLogoUpdateRequest = {
    /**
     * The new logo image file to upload
     */
    logo: (Blob | File);
};

export type OrganizationAiContext = {
    uuid: string;
    name: string;
    customer_number: string;
    law_firm: boolean;
    law_fields: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    description?: string | null;
};

/**
 * PDF form submission serializer for all user roles.
 */
export type PDFFormSubmissionBase = {
    readonly uuid: string;
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    form_fields: Array<SubmissionFormField>;
    /**
     * Completion percentage (0-100)
     */
    readonly progress_percentage: number;
    readonly created_at: string;
    /**
     * When the form was completed
     */
    readonly completed_at: string | null;
    readonly processed_pdf: string;
    readonly flattened_pdf: string | null;
    /**
     * Snapshot of template name at submission creation time
     */
    readonly template_name: string;
    /**
     * Snapshot of template description at submission creation time
     */
    readonly template_description: string;
    /**
     * Standalone submission that creates a new case (like questionnaires from settings)
     */
    readonly is_standalone: boolean;
    /**
     * External submission linked to existing case for third-party completion
     */
    readonly is_external: boolean;
    readonly org: ClientOrganisation;
    readonly images: Array<ImageproxyImagePreset>;
};

/**
 * PDF form submission serializer for all user roles.
 */
export type PDFFormSubmissionBaseRequest = {
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    form_fields: Array<SubmissionFormFieldRequest>;
};

/**
 * Base serializer for PDF form templates.
 */
export type PDFFormTemplate = {
    readonly uuid: string;
    name: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf: string;
    /**
     * Processed PDF with annotations stripped for clean display
     */
    readonly processed_pdf: string | null;
    form_fields?: Array<FormField>;
    /**
     * Token used to create standalone form submissions via public URLs
     */
    readonly template_creation_token: string | null;
    readonly created_at: string;
    readonly created_by: CustomerUser;
    readonly updated_at: string;
    readonly modified_by: CustomerUser;
};

/**
 * Base serializer for PDF form templates.
 */
export type PDFFormTemplateRequest = {
    name: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf: (Blob | File);
    form_fields?: Array<FormFieldRequest>;
};

/**
 * Serializer for individual page state.
 */
export type PageStateRequest = {
    /**
     * Frontend-generated page identifier
     */
    uuid: string;
    /**
     * UUID of the document this page belongs to
     */
    document_uuid: string;
    /**
     * Page number within the document group
     */
    page_number: number;
    /**
     * Original filename of the page
     */
    filename: string;
};

export type PaginatedCaseAppointmentsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CaseAppointments>;
};

export type PaginatedDocumentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Document>;
};

export type PaginatedDocumentPlaceholderList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<DocumentPlaceholder>;
};

export type PaginatedGenericMetricEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<GenericMetricEvent>;
};

export type PaginatedHubSpotCompanyCandidateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<HubSpotCompanyCandidate>;
};

export type PaginatedMinimalOrganisationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<MinimalOrganisation>;
};

export type PaginatedOrganisationEmployeeList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<OrganisationEmployee>;
};

export type PaginatedSessionGroupList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SessionGroup>;
};

export type PaginatedSuperUserHubSpotCompanyList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SuperUserHubSpotCompany>;
};

export type PaginatedSuperUserHubSpotContactList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<SuperUserHubSpotContact>;
};

export type PaginatedTAIChatSessionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAIChatSession>;
};

export type PaginatedTAccountList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAccount>;
};

export type PaginatedTActionAutoCommitSettingsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TActionAutoCommitSettings>;
};

export type PaginatedTActiveAnnouncementList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TActiveAnnouncement>;
};

export type PaginatedTActivityList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TActivity>;
};

export type PaginatedTAgentActionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAgentAction>;
};

export type PaginatedTAiAnalysisList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiAnalysis>;
};

export type PaginatedTAiAugmentationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiAugmentation>;
};

export type PaginatedTAiChatQuestionTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiChatQuestionTemplate>;
};

export type PaginatedTAiSettingsList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAiSettings>;
};

export type PaginatedTAnnouncementList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAnnouncement>;
};

export type PaginatedTAppointmentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAppointment>;
};

export type PaginatedTAppointmentProposalList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TAppointmentProposal>;
};

export type PaginatedTCalendarList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCalendar>;
};

export type PaginatedTCallList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCall>;
};

export type PaginatedTCaseCreatorTempDocumentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCaseCreatorTempDocument>;
};

export type PaginatedTCaseLifecycleStateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCaseLifecycleState>;
};

export type PaginatedTCaseLifecycleStateReasoningList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCaseLifecycleStateReasoning>;
};

export type PaginatedTCaseLifecycleWorkflowList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCaseLifecycleWorkflow>;
};

export type PaginatedTCaseList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TCase>;
};

export type PaginatedTChatPreferenceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TChatPreference>;
};

export type PaginatedTDeliveryEventList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TDeliveryEvent>;
};

export type PaginatedTDocumentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TDocument>;
};

export type PaginatedTDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TDocumentTemplate>;
};

export type PaginatedTEmailList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEmail>;
};

export type PaginatedTEmailTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEmailTemplate>;
};

export type PaginatedTEntityList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TEntity>;
};

export type PaginatedTFeedbackList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TFeedback>;
};

export type PaginatedTFormList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TForm>;
};

export type PaginatedTGenericDataMapperList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TGenericDataMapper>;
};

export type PaginatedTInboundEmailList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TInboundEmail>;
};

export type PaginatedTLawyerFeedbackList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TLawyerFeedback>;
};

export type PaginatedTOnboardingPackageList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TOnboardingPackage>;
};

export type PaginatedTOrganisationList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TOrganisation>;
};

export type PaginatedTPDFFormSubmissionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TPDFFormSubmission>;
};

export type PaginatedTPDFFormTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TPDFFormTemplate>;
};

export type PaginatedTPhoneForwardingRuleList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TPhoneForwardingRule>;
};

export type PaginatedTPhoneNumberList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TPhoneNumber>;
};

export type PaginatedTQuestionnaireList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TQuestionnaire>;
};

export type PaginatedTQuestionnaireSubmissionList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TQuestionnaireSubmission>;
};

export type PaginatedTRetellAgentList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TRetellAgent>;
};

export type PaginatedTSavedResponseList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TSavedResponse>;
};

export type PaginatedTServiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TService>;
};

export type PaginatedTStripeCustomerList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TStripeCustomer>;
};

export type PaginatedTStripeInvoiceList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TStripeInvoice>;
};

export type PaginatedTUserList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TUser>;
};

export type PaginatedTWordDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<TWordDocumentTemplate>;
};

export type PaginatedUnifiedDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<UnifiedDocumentTemplate>;
};

export type PaginatedWordDocumentTemplateList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<WordDocumentTemplate>;
};

export type PatchedAIChatSessionRequest = {
    title?: string;
    description?: string;
    session_type?: AIChatSessionTypeEnum;
    case_uuid?: string;
    session_group_uuid?: string | null;
    human_rating?: string | null;
};

/**
 * Serializer for admins updating other users' passwords
 */
export type PatchedAdminPasswordUpdateRequest = {
    new_password?: string;
};

export type PatchedAiChatQuestionTemplateRequest = {
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    prompt?: string;
    title?: string;
    description?: string;
};

/**
 * Serializer for assigning a workflow to a case.
 */
export type PatchedAssignWorkflowRequestRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
};

export type PatchedCaseCreatorTempDocumentRequest = {
    original_filename?: string;
    file?: (Blob | File);
};

/**
 * Serializer for the ChatPreference model.
 */
export type PatchedChatPreferenceRequest = {
    title?: string;
    content?: string;
    scope?: ScopeEnum;
    source?: ChatPreferenceSourceEnum | BlankEnum | NullEnum | null;
    org?: number | null;
    created_by_user?: number | null;
    user?: number | null;
    case?: number | null;
    /**
     * UUID of the AI chat message this preference was created from
     */
    message_uuid?: string | null;
    is_active?: boolean;
    /**
     * Sentiment classification (like, dislike, neutral, etc.)
     */
    sentiment?: string | null;
    /**
     * Confidence score for the sentiment classification (0.0-1.0)
     */
    confidence?: number | null;
    /**
     * Entity or topic this preference relates to
     */
    entity?: string | null;
    /**
     * Number of positive interactions with this preference
     */
    frequency_positive?: number;
    /**
     * Number of negative interactions with this preference
     */
    frequency_negative?: number;
    /**
     * Last time this preference was accessed/used
     */
    last_accessed?: string | null;
};

export type PatchedClientAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedClientAiAugmentationRequest = {
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

/**
 * Entity representation for clients.
 */
export type PatchedClientEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Questionnaire submission representation for clients.
 */
export type PatchedClientQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

/**
 * Serializer for creating new PDF form templates.
 */
export type PatchedCreatePDFFormTemplateRequest = {
    name?: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf?: (Blob | File);
};

export type PatchedCustomerAccountRequest = {
    uuid?: string;
    account_id?: string;
};

/**
 * ActionAutoCommitSettings representation for customers.
 */
export type PatchedCustomerActionAutoCommitSettingsRequest = {
    auto_commit_settings_key?: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for customer role.
 */
export type PatchedCustomerActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type?: ActivityTypeEnum;
};

export type PatchedCustomerAdminAccountRequest = {
    uuid?: string;
    account_id?: string;
};

/**
 * ActionAutoCommitSettings representation for customer admins.
 */
export type PatchedCustomerAdminActionAutoCommitSettingsRequest = {
    auto_commit_settings_key?: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for customer admin role.
 */
export type PatchedCustomerAdminActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type?: ActivityTypeEnum;
};

export type PatchedCustomerAdminAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedCustomerAdminAiAugmentationRequest = {
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

/**
 * AI Settings representation for customer admins.
 */
export type PatchedCustomerAdminAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

export type PatchedCustomerAdminAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

export type PatchedCustomerAdminCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Case Lifecycle State representation for customer admins.
 */
export type PatchedCustomerAdminCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for customer admins.
 */
export type PatchedCustomerAdminCaseLifecycleWorkflowRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerAdminActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for customer admins.
 */
export type PatchedCustomerAdminCaseRequest = {
    uuid?: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerAdminCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    user_access_token?: string;
};

export type PatchedCustomerAdminDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedCustomerAdminEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for customer admins.
 */
export type PatchedCustomerAdminEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Form representation for customer admins.
 */
export type PatchedCustomerAdminFormRequest = {
    title?: string;
    description?: string;
};

export type PatchedCustomerAdminOnboardingPackageRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Organisation representation for customer admins.
 */
export type PatchedCustomerAdminOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    is_datev_export_integration_enabled?: boolean;
    has_churned?: boolean;
    theme?: ThemeEnum;
};

/**
 * PhoneNumber representation for customer admins.
 */
export type PatchedCustomerAdminPhoneNumberRequest = {
    active?: boolean;
    phone_number?: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for customer admins.
 */
export type PatchedCustomerAdminQuestionnaireRequest = {
    title?: string;
    description?: string;
    schema?: Array<QuestionnaireSectionRequest>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
};

/**
 * Questionnaire submission representation for customer admins.
 */
export type PatchedCustomerAdminQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedCustomerAdminServiceRequest = {
    uuid?: string;
    org?: number;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: number;
    buffer_mins?: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for customer admins.
 */
export type PatchedCustomerAdminUserRequest = {
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    email_signature?: string;
    case_dashboard_widgets?: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type PatchedCustomerAdminWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type PatchedCustomerAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedCustomerAiAugmentationRequest = {
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

/**
 * AI Settings representation for customers.
 */
export type PatchedCustomerAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

export type PatchedCustomerAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

/**
 * Appointment representation for customers.
 */
export type PatchedCustomerAppointmentRequest = {
    service?: CustomerServiceRequest;
    calendar?: CustomerCalendarRequest;
    start?: string;
    location_types?: LocationTypesEnum;
    case?: number;
};

export type PatchedCustomerCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Call representation for customers.
 */
export type PatchedCustomerCallRequest = {
    result?: CustomerCallResultRequest;
    note?: string | null;
    clerk_id?: string | null;
    forward?: (ForwardRequest) | null;
};

/**
 * Case Lifecycle State representation for customers.
 */
export type PatchedCustomerCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for customers.
 */
export type PatchedCustomerCaseLifecycleWorkflowRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<CustomerActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for customers.
 */
export type PatchedCustomerCaseRequest = {
    uuid?: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: CustomerCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
    kleos_case_id?: string | null;
    user_access_token?: string;
};

export type PatchedCustomerDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedCustomerEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for customers.
 */
export type PatchedCustomerEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

/**
 * Form representation for customers.
 */
export type PatchedCustomerFormRequest = {
    title?: string;
    description?: string;
};

export type PatchedCustomerLawyerFeedbackRequest = {
    rating?: string;
    feedback?: string;
    call_uuid?: string;
};

export type PatchedCustomerOnboardingPackageRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Organisation representation for customers.
 */
export type PatchedCustomerOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    enable_inbound_email_replies?: boolean;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_upload_limit_mb?: number;
    webhook_urls?: string | null;
    email_egress_address?: string | null;
    enable_cases?: boolean;
    is_datev_export_integration_enabled?: boolean;
    receive_monthly_updates_summary?: boolean;
    theme?: ThemeEnum;
};

/**
 * Questionnaire representation for customers.
 */
export type PatchedCustomerQuestionnaireRequest = {
    title?: string;
    description?: string;
    schema?: Array<QuestionnaireSectionRequest>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
};

/**
 * Questionnaire submission representation for customers.
 */
export type PatchedCustomerQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedCustomerServiceRequest = {
    uuid?: string;
    org?: number;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: number;
    buffer_mins?: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
};

/**
 * User representation for customers.
 */
export type PatchedCustomerUserRequest = {
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    email_signature?: string;
    case_dashboard_widgets?: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type PatchedCustomerWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
};

export type PatchedDeliveryEventRequest = {
    uuid?: string;
};

export type PatchedDocumentPlaceholderUpdateRequest = {
    german_label?: string | null;
    english_label?: string | null;
};

export type PatchedEmailRequest = {
    uuid?: string;
};

export type PatchedFeedbackRequest = {
    url?: string;
    rating?: string;
    feature?: FeatureEnum;
    comment?: string;
    related_data?: FeedbackRelatedData;
};

/**
 * Serializer for generic metric events from frontend.
 */
export type PatchedGenericMetricEventRequest = {
    /**
     * Name of the event to track
     *
     * * `Logout` - Logout
     * * `Login` - Login
     * * `Bot Display` - Bot Display
     * * `Bot Session Started` - Bot Session Started
     * * `Bot Session Ended` - Bot Session Ended
     * * `Questionnaire Sent` - Questionnaire Sent
     * * `Questionnaire Completed` - Questionnaire Completed
     * * `PDFDocument Sent` - Form Sent
     * * `PDFDocument Completed` - Form Completed
     * * `Email Sent` - Email Sent
     * * `Email Received` - Email Received
     * * `Email Template Edited` - Email Template Edited
     * * `Case Created` - Case Created
     * * `Case Rejected` - Case Rejected
     * * `Case Accepted` - Case Completed
     * * `Case In Progress` - Case In Progress
     * * `Case Deleted` - Case Deleted
     * * `Case Exported` - Case Exported
     * * `Calculator Opened` - Calculator Opened
     * * `Calculator Saved` - Calculator Saved
     * * `Appointment Account Authorized` - Appointment Account Authorized
     * * `Appointment Account Revoked` - Appointment Account Revoked
     * * `Appointment Service Created` - Appointment Service Created
     * * `Appointment Service Edited` - Appointment Service Edited
     * * `Appointment Service Enabled` - Appointment Service Enabled
     * * `Appointment Service Disabled` - Appointment Service Disabled
     * * `Appointment Service Soft Deleted` - Appointment Service Soft Deleted
     * * `Appointment Service Recovered` - Appointment Service Recovered
     * * `Appointment Calendar Created` - Appointment Calendar Created
     * * `Appointment Calendar Edited` - Appointment Calendar Edited
     * * `Appointment Calendar Enabled` - Appointment Calendar Enabled
     * * `Appointment Calendar Disabled` - Appointment Calendar Disabled
     * * `Appointment Lawfields Edited` - Appointment Lawfields Edited
     * * `Appointment Setup Completed` - Appointment Setup Completed
     * * `Appointment Created` - Appointment Created
     * * `Appointment Proposal Created` - Appointment Proposal Created
     * * `Appointment Settings Edited` - Appointment Settings Edited
     * * `Call Started` - Call Started
     * * `Call Ended` - Call Ended
     * * `Call Automated Rating Received` - Call Automated Rating
     * * `Call Human Rating Received` - Call Human Rating
     * * `Call Lawer Rating Received` - Call Lawer Rating
     * * `Phone Forwarding Rule Created` - Phone Forwarding Rule Created
     * * `Phone Forwarding Rule Updated` - Phone Forwarding Rule Updated
     * * `Entity Extraction Instructions Set` - Entity Extraction Instructions Set
     * * `AI Token Used` - Ai Token Used
     * * `AI Embedding Token Used` - Ai Embedding Token Used
     * * `AI Function Voice Call Used` - Ai Function Voice Call Used
     * * `AI Function Document Analysis Used` - Ai Function Document Analysis Used
     * * `AI Function Document Title Generation Used` - Ai Function Document Title Generation Used
     * * `AI Function Questionnaire Title Generation Used` - Ai Function Questionnaire Title Generation Used
     * * `AI Function Email Extraction Used` - Ai Function Email Extraction Used
     * * `AI Function Gender Detection Used` - Ai Function Gender Detection Used
     * * `AI Function Document Type Classification Used` - Ai Function Document Type Classification Used
     * * `AI Function Document Analysis Entity Classification Used` - Ai Function Document Analysis Entity Classification Used
     * * `AI Function Document Generation Used` - Ai Function Document Generation Used
     * * `AI Function Inquiry Summary Used` - Ai Function Inquiry Summary Used
     * * `AI Function Used Case Chat` - Ai Function Used Case Chat
     * * `AI Function Used Update Case Chat Document Context` - Ai Function Used Update Case Chat Document Context
     * * `AI Function Used Update Case Chat Document Context Alternative Queries` - Ai Function Used Update Case Chat Document Context Alternative Queries
     * * `AI Function Used Update Case Chat Document Context Alternative Queries Create Embeddings` - Ai Function Used Update Case Chat Document Context Alternative Queries Create Embeddings
     * * `AI Function Case Create Document Entities Extraction Used` - Ai Function Case Create Document Entities Extraction Used
     * * `AI Function Universal Entity Extraction Used` - Ai Function Universal Entity Extraction Used
     * * `AI Function Document Template Generation Used` - Ai Function Document Template Generation Used
     * * `User Feedback` - User Feedback
     * * `Help Link Clicked` - Help Link Clicked
     * * `AI Function Document Summarization Used` - Ai Function Document Summarization Used
     * * `AI Function Document Raptor Summarization Used` - Ai Function Document Raptor Summarization Used
     * * `AI Function Used Rate AI Chat Session` - Ai Function Used Rate Ai Chat Session
     * * `AI Chat Session Rating` - Ai Chat Session Rating
     * * `AI Chat Session Human Rating` - Ai Chat Session Human Rating
     * * `Global AI Chat Folder Created` - Global Ai Chat Folder Created
     * * `Global AI Chat Folder Updated` - Global Ai Chat Folder Updated
     * * `Global AI Chat Folder Deleted` - Global Ai Chat Folder Deleted
     * * `Global AI Chat Session Created` - Global Ai Chat Session Created
     * * `Global AI Chat Session Deleted` - Global Ai Chat Session Deleted
     * * `Global AI Chat Visited` - Global Ai Chat Visited
     * * `AI Function Used Global Chat` - Ai Function Used Global Chat
     * * `Global Chat Case Specific Info Requested` - Global Chat Case Specific Info Requested
     * * `AI Function Template Description Generation Used` - Ai Function Template Description Generation Used
     * * `AI Function Memory Title Generation Used` - Ai Function Memory Title Generation Used
     * * `AI Function Used Chat Memory Embedding` - Ai Function Used Chat Memory Embedding
     * * `AI Function Used Chat Memory Importance Evaluation` - Ai Function Used Chat Memory Importance
     * * `AI Function Used Rate Memory Evaluation` - Ai Function Used Rate Memory Evaluation
     * * `AI Function Used Prompt Enhancement` - Ai Function Used Prompt Enhancement
     * * `AI Function Used Preference Suggestion Analysis` - Ai Function Used Preference Suggestion Analysis
     * * `AI Function Used Feedback Preference Suggestion` - Ai Function Used Feedback Preference Suggestion
     * * `AI Function Used Chat Preference Embedding` - Ai Function Used Chat Preference Embedding
     * * `AI Function Used Chat Preference Importance Evaluation` - Ai Function Used Chat Preference Importance
     * * `Snippet Button Clicked in Document Generator` - Snippet Button Clicked In Document Generator
     * * `Snippet Selected in Document Generator` - Snippet Selected In Document Generator
     * * `Document Metadata Enrichment Started` - Document Metadata Enrichment Started
     * * `Document Metadata Enrichment Finished` - Document Metadata Enrichment Finished
     * * `Document Metadata Enrichment Retry` - Document Metadata Enrichment Retry
     * * `Document OCR Started` - Document Ocr Started
     * * `Document OCR Finished` - Document Ocr Finished
     * * `Document Embeddings Started` - Document Embeddings Started
     * * `Document Embeddings Finished` - Document Embeddings Finished
     * * `Document Summary Started` - Document Summary Started
     * * `Document Summary Finished` - Document Summary Finished
     * * `Document Analysis Started` - Document Analysis Started
     * * `Document Analysis Finished` - Document Analysis Finished
     * * `Document Entity Extraction Started` - Document Entity Extraction Started
     * * `Document Entity Extraction Finished` - Document Entity Extraction Finished
     * * `Document Raptor Summaries Started` - Document Raptor Summaries Started
     * * `Document Raptor Summaries Finished` - Document Raptor Summaries Finished
     * * `Document Inline Edit Started` - Document Inline Edit Started
     * * `Document Rename AI Clicked` - Document Rename Ai Clicked
     * * `Document Rename AI Completed` - Document Rename Ai Completed
     * * `Document Rename AI Failed` - Document Rename Ai Failed
     * * `Document Rename Saved` - Document Rename Saved
     * * `Document Rename Cancelled` - Document Rename Cancelled
     * * `Document Preview Opened` - Document Preview Opened
     * * `Document Preview Closed` - Document Preview Closed
     * * `Document Downloaded` - Document Downloaded
     * * `Document Deleted` - Document Deleted
     * * `Document Organize Pages Opened` - Document Organize Pages Opened
     * * `Documents Bulk Selected` - Documents Bulk Selected
     * * `Documents Bulk Deselected` - Documents Bulk Deselected
     * * `Documents Bulk Rename Started` - Documents Bulk Rename Started
     * * `Documents Bulk Rename Completed` - Documents Bulk Rename Completed
     * * `Documents Bulk Rename Failed` - Documents Bulk Rename Failed
     * * `Documents Bulk Merge Started` - Documents Bulk Merge Started
     * * `Documents Bulk Download Started` - Documents Bulk Download Started
     * * `Documents Bulk Download Completed` - Documents Bulk Download Completed
     * * `Documents Bulk Download Failed` - Documents Bulk Download Failed
     * * `Documents Bulk Delete Started` - Documents Bulk Delete Started
     * * `Documents Bulk Delete Completed` - Documents Bulk Delete Completed
     * * `Documents Bulk Delete Failed` - Documents Bulk Delete Failed
     * * `PDF Organize View Opened` - Pdf Organize View Opened
     * * `PDF Organize View Closed` - Pdf Organize View Closed
     * * `PDF Organize Changes Saved` - Pdf Organize Changes Saved
     * * `PDF Organize Changes Discarded` - Pdf Organize Changes Discarded
     * * `PDF Organize Download Started` - Pdf Organize Download Started
     * * `PDF Organize Download Completed` - Pdf Organize Download Completed
     * * `PDF Organize Download Failed` - Pdf Organize Download Failed
     * * `PDF Document Merged` - Pdf Document Merged
     * * `PDF Documents Merged All` - Pdf Documents Merged All
     * * `PDF Document Split Manual` - Pdf Document Split Manual
     * * `PDF Document Split AI Started` - Pdf Document Split Ai Started
     * * `PDF Document Split AI Completed` - Pdf Document Split Ai Completed
     * * `PDF Document Split AI Failed` - Pdf Document Split Ai Failed
     * * `PDF Document Duplicated` - Pdf Document Duplicated
     * * `PDF Document Group Deleted` - Pdf Document Group Deleted
     * * `PDF Document Group Created` - Pdf Document Group Created
     * * `PDF Document Group Renamed` - Pdf Document Group Renamed
     * * `PDF Document Title AI Generated` - Pdf Document Title Ai Generated
     * * `PDF Pages Moved` - Pdf Pages Moved
     * * `PDF Pages Deleted` - Pdf Pages Deleted
     * * `PDF Pages Rotated` - Pdf Pages Rotated
     * * `PDF Pages Reordered` - Pdf Pages Reordered
     * * `PDF Pages Merged` - Pdf Pages Merged
     * * `PDF Add Documents Opened` - Pdf Add Documents Opened
     * * `PDF Documents Added` - Pdf Documents Added
     * * `PDF Viewer Edit Page Clicked` - Pdf Viewer Edit Page Clicked
     * * `PDF Viewer Organize Pages Clicked` - Pdf Viewer Organize Pages Clicked
     * * `PDF Viewer Download Clicked` - Pdf Viewer Download Clicked
     * * `PDF Viewer Reset Edits Started` - Pdf Viewer Reset Edits Started
     * * `PDF Viewer Reset Edits Completed` - Pdf Viewer Reset Edits Completed
     * * `PDF Viewer Reset Edits Cancelled` - Pdf Viewer Reset Edits Cancelled
     * * `Image Editor Opened` - Image Editor Opened
     * * `Image Editor Closed` - Image Editor Closed
     * * `Image Editor Mode Changed` - Image Editor Mode Changed
     * * `Image Editor Changes Applied` - Image Editor Changes Applied
     * * `Image Editor Changes Discarded` - Image Editor Changes Discarded
     * * `Image Editor Crop Region Added` - Image Editor Crop Region Added
     * * `Image Editor Crop Region Removed` - Image Editor Crop Region Removed
     * * `Image Editor Crop Applied` - Image Editor Crop Applied
     * * `Image Editor Crop Reset` - Image Editor Crop Reset
     * * `Image Editor Rotated` - Image Editor Rotated
     * * `Image Editor Rotation Reset` - Image Editor Rotation Reset
     * * `Image Editor Adjustment Changed` - Image Editor Adjustment Changed
     * * `Image Editor Adjustments Reset` - Image Editor Adjustments Reset
     * * `Image Editor Trim Applied` - Image Editor Trim Applied
     * * `Image Editor Trim Reset` - Image Editor Trim Reset
     * * `Actaport Document Imported` - Actaport Document Imported
     * * `Actaport Document Import Failed` - Actaport Document Import Failed
     * * `Actaport Document Exported` - Actaport Document Exported
     * * `Actaport Document Export Failed` - Actaport Document Export Failed
     * * `Actaport Documents Refresh` - Actaport Documents Refresh
     * * `Actaport API Rate Limit Hit` - Actaport Api Rate Limit Hit
     * * `Actaport Party Matching Searched` - Actaport Party Matching Searched
     * * `Actaport Case Exported` - Actaport Case Exported
     * * `PDF Form Template Created` - Pdf Form Template Created
     * * `PDF Form Template Duplicated` - Pdf Form Template Duplicated
     * * `PDF Form Template Updated` - Pdf Form Template Updated
     * * `PDF Form Template Deleted` - Pdf Form Template Deleted
     * * `PDF Form Template Edit Started` - Pdf Form Template Edit Started
     * * `PDF Form Template Edit Saved` - Pdf Form Template Edit Saved
     * * `PDF Form Template Edit Abandoned` - Pdf Form Template Edit Abandoned
     * * `PDF Form Template Field Added` - Pdf Form Template Field Added
     * * `PDF Form Template Field Removed` - Pdf Form Template Field Removed
     * * `PDF Form Template Previewed` - Pdf Form Template Previewed
     * * `PDF Form Template Used` - Pdf Form Template Used
     * * `PDF Form Submission Created` - Pdf Form Submission Created
     * * `PDF Form Submission Completed` - Pdf Form Submission Completed
     * * `PDF Form Submission Sent` - Pdf Form Submission Sent
     * * `PDF Form Flattened` - Pdf Form Flattened
     * * `Self Questionnaire Created` - Self Questionnaire Created
     * * `Self Questionnaire Updated` - Self Questionnaire Updated
     * * `Self Questionnaire Published` - Self Questionnaire Published
     * * `Self Questionnaire AI Generated` - Self Questionnaire Ai Generated
     * * `Self Questionnaire Copy` - Self Questionnaire Copy
     * * `Self Questionnaire Submission Partial Updated` - Self Questionnaire Submission Partial Updated
     * * `Self Questionnaire Submission Completed` - Self Questionnaire Submission Completed
     * * `Self Questionnaire Submission Created` - Self Questionnaire Submission Created
     * * `Onboarding Package Created` - Onboarding Package Created
     * * `Onboarding Package Edited` - Onboarding Package Edited
     * * `Onboarding Package Document Added` - Onboarding Package Document Added
     * * `Onboarding Package Questionnaire Added` - Onboarding Package Questionnaire Added
     * * `Onboarding Package Link Used` - Onboarding Package Link Used
     * * `Onboarding Package QR Code Used` - Onboarding Package Qr Code Used
     * * `Onboarding Package Inquiry Created` - Onboarding Package Inquiry Created
     * * `Case List Note Added` - Case List Note Added
     * * `Case List Note Edited` - Case List Note Edited
     * * `Case List Search Performed` - Case List Search Performed
     * * `Case List Clerk Assigned` - Case List Clerk Assigned
     * * `Case List Clerk Changed` - Case List Clerk Changed
     * * `Case List Clerk Removed` - Case List Clerk Removed
     * * `Case List Clerk Filter Used` - Case List Clerk Filter Used
     * * `Case List Law Field Filter Used` - Case List Law Field Filter Used
     * * `Case List Unseen Activity Filter Used` - Case List Unseen Activity Filter Used
     * * `Case List Sort Changed` - Case List Sort Changed
     */
    event_name?: EventNameEnum;
    /**
     * Additional properties for the event
     */
    properties?: unknown;
};

export type PatchedInboundEmailRequest = {
    uuid?: string;
};

/**
 * PDF form submission serializer for all user roles.
 */
export type PatchedPDFFormSubmissionBaseRequest = {
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    form_fields?: Array<SubmissionFormFieldRequest>;
};

/**
 * Base serializer for PhoneForwardingRule model.
 */
export type PatchedPhoneForwardingRuleRequest = {
    /**
     * A descriptive name for this forwarding rule
     */
    title?: string;
    /**
     * The type of condition this rule uses
     *
     * * `phonenumber` - Phone Number
     * * `entity` - Entity Type
     * * `text` - Text Context
     */
    rule_type?: RuleTypeEnum;
    /**
     * Whether this rule is currently active
     */
    active?: boolean;
    /**
     * List of phone numbers to match (for phone number rules)
     */
    from_numbers?: unknown;
    /**
     * List of entity types to match (for entity rules)
     */
    from_entity_types?: unknown;
    /**
     * Text context to match (for text rules)
     */
    from_text_context?: string;
    /**
     * Phone number to forward calls to
     */
    target_phone_number?: string;
    /**
     * Message to play before forwarding the call
     */
    forwarding_message?: string;
    /**
     * List of phone number UUIDs to associate with this rule
     */
    phone_number_uuids?: Array<(string)>;
};

/**
 * Serializer for the SavedResponse model.
 */
export type PatchedSavedResponseRequest = {
    title?: string;
    content?: string;
    session_type?: AIChatSessionTypeEnum;
};

export type PatchedSessionGroupRequest = {
    /**
     * Name of the session group/folder
     */
    name?: string;
    /**
     * Optional description of the session group
     */
    description?: string;
    /**
     * Custom instructions for all chats in this group
     */
    instructions?: string;
};

export type PatchedSuperUserAccountRequest = {
    uuid?: string;
    account_id?: string;
};

/**
 * ActionAutoCommitSettings representation for superusers.
 */
export type PatchedSuperUserActionAutoCommitSettingsRequest = {
    auto_commit_settings_key?: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for superuser role.
 */
export type PatchedSuperUserActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type?: ActivityTypeEnum;
};

export type PatchedSuperUserAiAnalysisRequest = {
    case_uuid?: string;
    document_uuid?: string;
};

export type PatchedSuperUserAiAugmentationRequest = {
    value?: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages?: Array<(number)>;
    explanation?: string;
};

/**
 * AI Settings representation for superusers.
 */
export type PatchedSuperUserAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * Full announcement serializer for superusers.
 *
 * Provides access to all fields for managing announcements.
 */
export type PatchedSuperUserAnnouncementRequest = {
    /**
     * The announcement message to display
     */
    message?: string;
    /**
     * The type of announcement (determines color/styling)
     *
     * * `INFO` - Info
     * * `WARNING` - Warning
     * * `ERROR` - Error
     * * `SUCCESS` - Success
     */
    message_type?: MessageTypeEnum;
    /**
     * Whether this announcement should be displayed
     */
    is_active?: boolean;
    /**
     * Optional start date for the announcement
     */
    start_date?: string | null;
    /**
     * Optional end date for the announcement
     */
    end_date?: string | null;
    /**
     * Whether users can dismiss this announcement
     */
    dismissible?: boolean;
};

export type PatchedSuperUserAppointmentProposalRequest = {
    uuid?: string;
    case_uuid?: string;
    start?: string | null;
    location_type?: LocationTypeEnum;
    message?: string | null;
    service_uuid?: string;
    calendar_uuid?: string;
};

export type PatchedSuperUserCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile?: number;
    calendar_id?: string;
    calendar_name?: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level?: string;
};

/**
 * Call representation for super users.
 */
export type PatchedSuperUserCallRequest = {
    user_phone_number?: string;
    phone_number_uuid?: string;
    retell_call_id?: string;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResultRequest;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    had_caller_accent?: boolean | null;
    note?: string | null;
    clerk_id?: string | null;
    forward?: (ForwardRequest) | null;
};

/**
 * Case Lifecycle State representation for superusers.
 */
export type PatchedSuperUserCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for superusers.
 */
export type PatchedSuperUserCaseLifecycleWorkflowRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for super users.
 */
export type PatchedSuperUserCaseRequest = {
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: SuperUserCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
};

/**
 * Serializer for superusers to create PDF form templates with org selection.
 */
export type PatchedSuperUserCreatePDFFormTemplateRequest = {
    name?: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf?: (Blob | File);
    org_uuid?: string;
};

export type PatchedSuperUserDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
};

export type PatchedSuperUserEmailTemplateRequest = {
    type?: EmailTemplateType;
    name?: string;
    subject?: string;
    html?: string;
    default?: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Entity representation for super users.
 */
export type PatchedSuperUserEntityRequest = {
    entity_type?: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type PatchedSuperUserFeedbackRequest = {
    url?: string;
    rating?: string;
    feature?: FeatureEnum;
    comment?: string;
    related_data?: FeedbackRelatedData;
};

/**
 * Form representation for superusers.
 */
export type PatchedSuperUserFormRequest = {
    organisation_uuid?: string;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: (Blob | File) | null;
};

export type PatchedSuperUserLawyerFeedbackRequest = {
    rating?: string;
    feedback?: string;
    call_uuid?: string;
};

export type PatchedSuperUserOnboardingPackageRequest = {
    name?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Serializer for creating a new organisation with users.
 *
 * This serializer handles the creation of a new organisation along with
 * its initial users. It follows best practices for database transactions:
 *
 * **Transaction Flow:**
 * 1. Inside atomic transaction:
 * - Create organisation in database
 * - Create User records in Django with temporary usernames
 * 2. After transaction commits (via transaction.on_commit):
 * - Create users in Keycloak (external API call)
 * - Update User records with actual Keycloak usernames
 * - Send welcome emails to all users
 *
 * This approach ensures that:
 * - Database changes are atomic and can be rolled back if needed
 * - External API calls (Keycloak) don't hold the transaction open
 * - System remains consistent even if Keycloak operations fail
 */
export type PatchedSuperUserOrganisationCreateRequest = {
    name?: string | null;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    monsum_customer_number?: string;
    seats?: number;
    law_fields?: unknown;
    appointments_seats?: number;
    onboarding_start_date?: string | null;
    is_test?: boolean;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    can_configure_email?: boolean;
    is_new_ui_switch_enabled?: boolean;
    is_forced_to_use_new_ui?: boolean;
    ai_enabled?: boolean;
    enable_ai_workflows?: boolean;
    enable_cases?: boolean;
    enable_voice?: boolean;
    enable_appointments?: boolean;
    enable_law_specific_data?: boolean;
    stripe_customer_uuid?: string | null;
    users?: Array<UserCreateRequest>;
};

/**
 * Organisation representation for superusers.
 */
export type PatchedSuperUserOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    enable_ai_workflows?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    stripe_customer_uuid?: string | null;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    is_datev_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    hubspot_company_uuid?: string | null;
    has_churned?: boolean;
    onboarding_start_date?: string | null;
    enable_law_specific_data?: boolean;
    is_new_ui_switch_enabled?: boolean;
    is_forced_to_use_new_ui?: boolean;
    is_phonebot_self_service_customer?: boolean;
    phonebot_self_service_plan?: PhonebotSelfServicePlanEnum | BlankEnum | NullEnum | null;
    phonebot_self_service_plan_enterprise_included_minutes?: number;
    phonebot_trial_ends_at?: string | null;
    monsum_customer_number?: string;
    can_configure_email?: boolean;
    theme?: ThemeEnum;
};

/**
 * Serializer for superusers - full access to all fields.
 */
export type PatchedSuperUserPDFFormSubmissionRequest = {
    uuid?: string;
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    /**
     * Snapshot of template name at submission creation time
     */
    template_name?: string;
    /**
     * Snapshot of template description at submission creation time
     */
    template_description?: string;
    form_fields?: Array<SubmissionFormFieldRequest>;
    /**
     * Completion percentage (0-100)
     */
    progress_percentage?: number;
    /**
     * When the form was completed
     */
    completed_at?: string | null;
    created_by?: number | null;
    org?: number;
    template?: PDFFormTemplateRequest;
    /**
     * Standalone submission that creates a new case (like questionnaires from settings)
     */
    is_standalone?: boolean;
    /**
     * External submission linked to existing case for third-party completion
     */
    is_external?: boolean;
};

/**
 * PhoneNumber representation for superusers.
 */
export type PatchedSuperUserPhoneNumberRequest = {
    uuid?: string;
    active?: boolean;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    agent_uuid?: string;
    org_uuid?: string;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for superusers.
 */
export type PatchedSuperUserQuestionnaireRequest = {
    title?: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema?: Array<QuestionnaireSectionRequest>;
    org_uuid?: string | null;
    /**
     * True if this questionnaire is a Jupus template that can be copied by organizations
     */
    is_jupus_template?: boolean;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type PatchedSuperUserQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type PatchedSuperUserServiceRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    duration_mins?: number;
    buffer_mins?: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * User representation for superusers.
 */
export type PatchedSuperUserUserRequest = {
    uuid?: string;
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
    case_dashboard_widgets?: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type PatchedSuperUserWordDocumentTemplateRequest = {
    uuid?: string;
    name?: string;
    description?: string;
    system_prompt?: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    /**
     * AI-generated template with placeholders created from docx_template
     */
    ai_docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template?: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
    /**
     * Stores AI extraction confidence scores and metadata
     */
    ai_extraction_metadata?: unknown;
};

export type PatchedTAIChatSessionRequest = PatchedAIChatSessionRequest;

export type PatchedTAccountRequest = PatchedCustomerAccountRequest | PatchedCustomerAdminAccountRequest | PatchedSuperUserAccountRequest;

export type PatchedTActionAutoCommitSettingsRequest = PatchedCustomerActionAutoCommitSettingsRequest | PatchedCustomerAdminActionAutoCommitSettingsRequest | PatchedSuperUserActionAutoCommitSettingsRequest;

export type PatchedTActivityRequest = PatchedCustomerActivityRequest | PatchedCustomerAdminActivityRequest | PatchedSuperUserActivityRequest;

export type PatchedTAgentActionRequest = unknown;

export type PatchedTAiAnalysisRequest = PatchedClientAiAnalysisRequest | PatchedCustomerAiAnalysisRequest | PatchedCustomerAdminAiAnalysisRequest | PatchedSuperUserAiAnalysisRequest;

export type PatchedTAiAugmentationRequest = PatchedClientAiAugmentationRequest | PatchedCustomerAiAugmentationRequest | PatchedCustomerAdminAiAugmentationRequest | PatchedSuperUserAiAugmentationRequest;

export type PatchedTAiChatQuestionTemplateRequest = PatchedAiChatQuestionTemplateRequest;

export type PatchedTAiSettingsRequest = PatchedCustomerAiSettingsRequest | PatchedCustomerAdminAiSettingsRequest | PatchedSuperUserAiSettingsRequest;

export type PatchedTAnnouncementRequest = PatchedSuperUserAnnouncementRequest;

export type PatchedTAppointmentProposalRequest = PatchedCustomerAppointmentProposalRequest | PatchedCustomerAdminAppointmentProposalRequest | PatchedSuperUserAppointmentProposalRequest;

export type PatchedTAppointmentRequest = PatchedCustomerAppointmentRequest | PatchedCustomerAdminAccountRequest | PatchedSuperUserAccountRequest;

export type PatchedTCalendarRequest = PatchedCustomerCalendarRequest | PatchedCustomerAdminCalendarRequest | PatchedSuperUserCalendarRequest;

export type PatchedTCallRequest = PatchedCustomerCallRequest | PatchedSuperUserCallRequest;

export type PatchedTCaseCreatorTempDocumentRequest = PatchedCaseCreatorTempDocumentRequest;

export type PatchedTCaseLifecycleStateRequestRequest = PatchedCustomerCaseLifecycleStateRequest | PatchedCustomerAdminCaseLifecycleStateRequest | PatchedSuperUserCaseLifecycleStateRequest;

export type PatchedTCaseLifecycleWorkflowRequest = PatchedCustomerCaseLifecycleWorkflowRequest | PatchedCustomerAdminCaseLifecycleWorkflowRequest | PatchedSuperUserCaseLifecycleWorkflowRequest;

export type PatchedTCaseRequest = PatchedCustomerCaseRequest | PatchedCustomerAdminCaseRequest | PatchedSuperUserCaseRequest;

export type PatchedTChatPreferenceRequest = PatchedChatPreferenceRequest;

export type PatchedTDocumentRequest = unknown;

export type PatchedTDocumentTemplateRequest = PatchedCustomerDocumentTemplateRequest | PatchedCustomerAdminDocumentTemplateRequest | PatchedSuperUserDocumentTemplateRequest;

export type PatchedTEmailTemplateRequest = PatchedCustomerEmailTemplateRequest | PatchedCustomerAdminEmailTemplateRequest | PatchedSuperUserEmailTemplateRequest;

export type PatchedTEntityRequest = PatchedClientEntityRequest | PatchedCustomerEntityRequest | PatchedCustomerAdminEntityRequest | PatchedSuperUserEntityRequest;

export type PatchedTFeedbackRequest = PatchedFeedbackRequest | PatchedSuperUserFeedbackRequest;

export type PatchedTFormRequest = PatchedCustomerFormRequest | PatchedCustomerAdminFormRequest | PatchedSuperUserFormRequest;

export type PatchedTLawyerFeedbackRequest = PatchedCustomerLawyerFeedbackRequest | PatchedSuperUserLawyerFeedbackRequest;

export type PatchedTOnboardingPackageRequest = PatchedCustomerOnboardingPackageRequest | PatchedCustomerAdminOnboardingPackageRequest | PatchedSuperUserOnboardingPackageRequest;

export type PatchedTOrganisationRequestRequest = PatchedCustomerOrganisationRequest | PatchedCustomerAdminOrganisationRequest | PatchedSuperUserOrganisationRequest | PatchedSuperUserOrganisationCreateRequest;

export type PatchedTPDFFormSubmissionRequest = PatchedPDFFormSubmissionBaseRequest | PatchedSuperUserPDFFormSubmissionRequest;

export type PatchedTPDFFormTemplateRequestRequest = PatchedCreatePDFFormTemplateRequest | PatchedSuperUserCreatePDFFormTemplateRequest;

export type PatchedTPhoneNumberRequest = PatchedCustomerAdminPhoneNumberRequest | PatchedSuperUserPhoneNumberRequest;

export type PatchedTQuestionnaireRequest = PatchedCustomerQuestionnaireRequest | PatchedCustomerAdminQuestionnaireRequest | PatchedSuperUserQuestionnaireRequest;

export type PatchedTQuestionnaireSubmissionRequest = PatchedClientQuestionnaireSubmissionRequest | PatchedCustomerQuestionnaireSubmissionRequest | PatchedCustomerAdminQuestionnaireSubmissionRequest | PatchedSuperUserQuestionnaireSubmissionRequest;

export type PatchedTRetellAgentRequest = unknown;

export type PatchedTSavedResponseRequest = PatchedSavedResponseRequest;

export type PatchedTServiceRequest = PatchedCustomerServiceRequest | PatchedCustomerAdminServiceRequest | PatchedSuperUserServiceRequest;

export type PatchedTStripeCustomerRequest = unknown;

export type PatchedTStripeInvoiceRequest = unknown;

export type PatchedTUserRequest = PatchedCustomerUserRequest | PatchedCustomerAdminUserRequest | PatchedSuperUserUserRequest;

export type PatchedTWordDocumentTemplateRequest = PatchedCustomerWordDocumentTemplateRequest | PatchedCustomerAdminWordDocumentTemplateRequest | PatchedSuperUserWordDocumentTemplateRequest;

/**
 * Unified serializer that normalizes both Form (MASTER) and PDFFormTemplate models
 * into a common format for the frontend.
 */
export type PatchedUnifiedDocumentTemplateRequest = {
    template_type?: string;
    title?: string;
    description?: string;
};

/**
 * Serializer for updating validation data request.
 */
export type PatchedUpdateValidationDataRequestRequest = {
    /**
     * Dictionary of placeholder key-value pairs to update
     */
    placeholder_values?: unknown;
    /**
     * Use AI-generated template
     */
    use_ai_template?: boolean;
};

/**
 * Base serializer for PhoneForwardingRule model.
 */
export type PhoneForwardingRule = {
    readonly uuid: string;
    /**
     * A descriptive name for this forwarding rule
     */
    title?: string;
    /**
     * The type of condition this rule uses
     *
     * * `phonenumber` - Phone Number
     * * `entity` - Entity Type
     * * `text` - Text Context
     */
    rule_type: RuleTypeEnum;
    /**
     * Whether this rule is currently active
     */
    active?: boolean;
    /**
     * List of phone numbers to match (for phone number rules)
     */
    from_numbers?: unknown;
    /**
     * List of entity types to match (for entity rules)
     */
    from_entity_types?: unknown;
    /**
     * Text context to match (for text rules)
     */
    from_text_context?: string;
    /**
     * Phone number to forward calls to
     */
    target_phone_number?: string;
    /**
     * Message to play before forwarding the call
     */
    forwarding_message?: string;
    /**
     * List of phone number UUIDs to associate with this rule
     */
    phone_number_uuids?: Array<(string)>;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Simplified serializer for listing phone forwarding rules.
 */
export type PhoneForwardingRuleList = {
    readonly uuid: string;
    /**
     * A descriptive name for this forwarding rule
     */
    title?: string;
    /**
     * The type of condition this rule uses
     *
     * * `phonenumber` - Phone Number
     * * `entity` - Entity Type
     * * `text` - Text Context
     */
    rule_type: RuleTypeEnum;
    /**
     * Whether this rule is currently active
     */
    active?: boolean;
    /**
     * List of phone numbers to match (for phone number rules)
     */
    from_numbers?: unknown;
    /**
     * List of entity types to match (for entity rules)
     */
    from_entity_types?: unknown;
    /**
     * Text context to match (for text rules)
     */
    from_text_context?: string;
    /**
     * Phone number to forward calls to
     */
    target_phone_number?: string;
    /**
     * Message to play before forwarding the call
     */
    forwarding_message?: string;
    /**
     * List of phone number UUIDs associated with this rule
     */
    readonly phone_number_uuids: Array<(string)>;
    readonly created_at: string;
    readonly updated_at: string;
    readonly condition_summary: string;
};

/**
 * Simplified serializer for listing phone forwarding rules.
 */
export type PhoneForwardingRuleListRequest = {
    /**
     * A descriptive name for this forwarding rule
     */
    title?: string;
    /**
     * The type of condition this rule uses
     *
     * * `phonenumber` - Phone Number
     * * `entity` - Entity Type
     * * `text` - Text Context
     */
    rule_type: RuleTypeEnum;
    /**
     * Whether this rule is currently active
     */
    active?: boolean;
    /**
     * List of phone numbers to match (for phone number rules)
     */
    from_numbers?: unknown;
    /**
     * List of entity types to match (for entity rules)
     */
    from_entity_types?: unknown;
    /**
     * Text context to match (for text rules)
     */
    from_text_context?: string;
    /**
     * Phone number to forward calls to
     */
    target_phone_number?: string;
    /**
     * Message to play before forwarding the call
     */
    forwarding_message?: string;
};

/**
 * Base serializer for PhoneForwardingRule model.
 */
export type PhoneForwardingRuleRequest = {
    /**
     * A descriptive name for this forwarding rule
     */
    title?: string;
    /**
     * The type of condition this rule uses
     *
     * * `phonenumber` - Phone Number
     * * `entity` - Entity Type
     * * `text` - Text Context
     */
    rule_type: RuleTypeEnum;
    /**
     * Whether this rule is currently active
     */
    active?: boolean;
    /**
     * List of phone numbers to match (for phone number rules)
     */
    from_numbers?: unknown;
    /**
     * List of entity types to match (for entity rules)
     */
    from_entity_types?: unknown;
    /**
     * Text context to match (for text rules)
     */
    from_text_context?: string;
    /**
     * Phone number to forward calls to
     */
    target_phone_number?: string;
    /**
     * Message to play before forwarding the call
     */
    forwarding_message?: string;
    /**
     * List of phone number UUIDs to associate with this rule
     */
    phone_number_uuids?: Array<(string)>;
};

/**
 * * `phone_beginner_plan` - Phone Beginner
 * * `phone_professional_plan` - Phone Professional
 * * `phone_professional_plus_plan` - Phone Professional Plus
 * * `phone_enterprise_plan` - Phone Enterprise
 */
export type PhonebotSelfServicePlanEnum = 'phone_beginner_plan' | 'phone_professional_plan' | 'phone_professional_plus_plan' | 'phone_enterprise_plan';

/**
 * * `phone_beginner_plan` - Phone Beginner
 * * `phone_professional_plan` - Phone Professional
 * * `phone_professional_plus_plan` - Phone Professional Plus
 * * `phone_enterprise_plan` - Phone Enterprise
 */
export const PhonebotSelfServicePlanEnum = {
    PHONE_BEGINNER_PLAN: 'phone_beginner_plan',
    PHONE_PROFESSIONAL_PLAN: 'phone_professional_plan',
    PHONE_PROFESSIONAL_PLUS_PLAN: 'phone_professional_plus_plan',
    PHONE_ENTERPRISE_PLAN: 'phone_enterprise_plan'
} as const;

export type Placeholder = {
    key: PlaceholderKeyEnum;
    placeholder: string;
    label: string;
    html: string;
    is_context_aware: boolean;
    demo_context_dict?: unknown;
    rendered_demo_context_html?: string | null;
    variant: string;
    description: string;
};

/**
 * * `clerk_first_name` - clerk_first_name
 * * `clerk_last_name` - clerk_last_name
 * * `lawfirm_name` - lawfirm_name
 * * `client_first_name` - client_first_name
 * * `client_formal_greeting` - client_formal_greeting
 * * `client_last_name` - client_last_name
 * * `client_title` - client_title
 * * `clerk_signature` - clerk_signature
 * * `full_signature` - full_signature
 * * `lawfirm_signature` - lawfirm_signature
 * * `appointment_key_facts` - appointment_key_facts
 * * `appointment_proposal_message` - appointment_proposal_message
 * * `appointment_proposal_url` - appointment_proposal_url
 * * `appointment_url` - appointment_url
 * * `questionnaires_and_documents` - questionnaires_and_documents
 */
export type PlaceholderKeyEnum = 'clerk_first_name' | 'clerk_last_name' | 'lawfirm_name' | 'client_first_name' | 'client_formal_greeting' | 'client_last_name' | 'client_title' | 'clerk_signature' | 'full_signature' | 'lawfirm_signature' | 'appointment_key_facts' | 'appointment_proposal_message' | 'appointment_proposal_url' | 'appointment_url' | 'questionnaires_and_documents';

/**
 * * `clerk_first_name` - clerk_first_name
 * * `clerk_last_name` - clerk_last_name
 * * `lawfirm_name` - lawfirm_name
 * * `client_first_name` - client_first_name
 * * `client_formal_greeting` - client_formal_greeting
 * * `client_last_name` - client_last_name
 * * `client_title` - client_title
 * * `clerk_signature` - clerk_signature
 * * `full_signature` - full_signature
 * * `lawfirm_signature` - lawfirm_signature
 * * `appointment_key_facts` - appointment_key_facts
 * * `appointment_proposal_message` - appointment_proposal_message
 * * `appointment_proposal_url` - appointment_proposal_url
 * * `appointment_url` - appointment_url
 * * `questionnaires_and_documents` - questionnaires_and_documents
 */
export const PlaceholderKeyEnum = {
    CLERK_FIRST_NAME: 'clerk_first_name',
    CLERK_LAST_NAME: 'clerk_last_name',
    LAWFIRM_NAME: 'lawfirm_name',
    CLIENT_FIRST_NAME: 'client_first_name',
    CLIENT_FORMAL_GREETING: 'client_formal_greeting',
    CLIENT_LAST_NAME: 'client_last_name',
    CLIENT_TITLE: 'client_title',
    CLERK_SIGNATURE: 'clerk_signature',
    FULL_SIGNATURE: 'full_signature',
    LAWFIRM_SIGNATURE: 'lawfirm_signature',
    APPOINTMENT_KEY_FACTS: 'appointment_key_facts',
    APPOINTMENT_PROPOSAL_MESSAGE: 'appointment_proposal_message',
    APPOINTMENT_PROPOSAL_URL: 'appointment_proposal_url',
    APPOINTMENT_URL: 'appointment_url',
    QUESTIONNAIRES_AND_DOCUMENTS: 'questionnaires_and_documents'
} as const;

export type PlaceholderSuggestion = {
    suggested_value: string;
    score: number;
};

export type PlaceholderValueRequest = {
    placeholder: string;
    value: string;
};

export type PlaceholderValueSuggestions = {
    placeholder_variable: string;
    german_label?: string | null;
    english_label?: string | null;
    suggestions: PlaceholderSuggestion;
};

/**
 * * `only_jupus` - Only in Jupus
 * * `only_actaport` - Only in Actaport
 * * `in_both` - In Both
 * * `syncing` - Syncing
 */
export type PlatformSyncStatusEnum = 'only_jupus' | 'only_actaport' | 'in_both' | 'syncing';

/**
 * * `only_jupus` - Only in Jupus
 * * `only_actaport` - Only in Actaport
 * * `in_both` - In Both
 * * `syncing` - Syncing
 */
export const PlatformSyncStatusEnum = {
    ONLY_JUPUS: 'only_jupus',
    ONLY_ACTAPORT: 'only_actaport',
    IN_BOTH: 'in_both',
    SYNCING: 'syncing'
} as const;

export type PreferenceSuggestionData = {
    id: string;
    title: string;
    content: string;
    reasoning: string;
    suggested_scope: string;
    state: string;
    created_preference_uuid?: string | null;
};

/**
 * Serializer for preference suggestion data in feedback responses.
 */
export type PreferenceSuggestionDataRequest = {
    /**
     * Suggested title for the preference
     */
    title: string;
    /**
     * Suggested content for the preference
     */
    content: string;
    /**
     * AI reasoning for why this should be a preference
     */
    reasoning: string;
    /**
     * Suggested scope (USER, ORGANIZATION, CASE)
     */
    suggested_scope: string;
    /**
     * Source of the suggestion (FEEDBACK)
     */
    source: string;
};

export type QuestionnaireGenerateRequest = {
    file?: (Blob | File) | null;
    prompt?: string | null;
};

export type QuestionnaireQuestion = {
    uuid: string;
    help: string;
    type: QuestionnaireQuestionTypeEnum;
    tag: QuestionnaireQuestionTagEnum | BlankEnum | NullEnum | null;
    tag_relationship: TagRelationshipEnum | BlankEnum | NullEnum | null;
    tag_number: number | null;
    label: string;
    value: string | null;
    choices?: Array<(string)>;
    jump_to: Array<JumpTo> | null;
    optional: boolean;
    starts_ai_analysis: boolean;
};

export type QuestionnaireQuestionRequest = {
    uuid: string;
    help: string;
    type: QuestionnaireQuestionTypeEnum;
    tag: QuestionnaireQuestionTagEnum | BlankEnum | NullEnum | null;
    tag_relationship: TagRelationshipEnum | BlankEnum | NullEnum | null;
    tag_number: number | null;
    label: string;
    value: string | null;
    choices?: Array<(string)>;
    jump_to: Array<JumpToRequest> | null;
    optional: boolean;
    starts_ai_analysis: boolean;
};

/**
 * * `entities.field.address_line_2` - Adresszusatz
 * * `entities.field.bank_name` - Bankname
 * * `entities.field.bic` - BIC
 * * `entities.field.city` - Ort
 * * `entities.field.company_legal_form` - Rechtsform
 * * `entities.field.company_name` - Firmenname
 * * `entities.field.company_register_court` - Amtsgericht
 * * `entities.field.company_register_number` - Handelsregisternummer
 * * `entities.field.company_tax_id` - Steuernummer
 * * `entities.field.company_vat_id` - USt. ID
 * * `entities.field.date_of_birth` - Geburtsdatum
 * * `entities.field.date_of_death` - Sterbedatum
 * * `entities.field.email` - E-Mail
 * * `entities.field.entity_type` - Personentyp
 * * `entities.field.fax` - Fax
 * * `entities.field.first_name` - Vorname
 * * `entities.field.iban` - IBAN
 * * `entities.field.institution_name` - Name der Institution
 * * `entities.field.is_entitled_to_deduct_vat` - Vorsteuerabzugsberechtigt
 * * `entities.field.is_valid_email` - Gültige E-Mail
 * * `entities.field.is_valid_phone_number` - Gültige Telefonnummer
 * * `entities.field.last_name` - Nachname
 * * `entities.field.legal_insurance_deductible_amount` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
 * * `entities.field.legal_insurance` - Rechtsschutzversicherung
 * * `entities.field.legal_insurance_name` - Name der Rechtsschutzversicherung
 * * `entities.field.legal_insurance_number` - Nummer der Rechtsschutzversicherung
 * * `entities.field.marital_status` - Familienstand
 * * `entities.field.phone` - Telefon
 * * `entities.field.specific_title` - Titel
 * * `entities.field.street` - Straße
 * * `entities.field.street_number` - Hausnummer
 * * `entities.field.title` - Anrede
 * * `entities.field.website` - Website
 * * `entities.field.zip` - PLZ
 * * `law.civil_law_accessories_sold_separately` - Zubehör separat veräußert?
 * * `law.civil_law_case_number` - Geschäftsnummer
 * * `law.civil_law_claim_amount` - Streitwert
 * * `law.civil_law_contract_date` - Vertragsdatum
 * * `law.civil_law_contract_duration` - Vertragslaufzeit in Monaten
 * * `law.civil_law_contract_end_date` - Vertragsende
 * * `law.civil_law_contract` - Vertrag
 * * `law.civil_law_contract_object` - Vertragsgegenstand
 * * `law.civil_law_contract_start_date` - Vertragsbeginn
 * * `law.civil_law_contract_value` - Vertragswert
 * * `law.civil_law_correspondence` - Schriftverkehr
 * * `law.civil_law_court_costs` - Gerichtskosten
 * * `law.civil_law_court_document` - Gerichtsdokument
 * * `law.civil_law_court_name` - Gericht
 * * `law.civil_law_damage_amount` - Schadenshöhe
 * * `law.civil_law_damage_cause` - Schadensursache
 * * `law.civil_law_damage_claim` - Schadensersatzforderung
 * * `law.civil_law_damage_date` - Schadensdatum
 * * `law.civil_law_damage_description` - Schadensbeschreibung
 * * `law.civil_law_default_interest` - Verzugszinsen
 * * `law.civil_law_defects` - Mängel
 * * `law.civil_law_defects_present` - Sachmängel vorhanden
 * * `law.civil_law_delivery_date` - Lieferdatum
 * * `law.civil_law_document_date` - Dokumentdatum
 * * `law.civil_law_file_reference` - Aktenzeichen
 * * `law.civil_law_handover_date` - Übergabedatum
 * * `law.civil_law_hearing_date` - Verhandlungstermin
 * * `law.civil_law_insurance_claim_number` - Versicherungsschadensnummer
 * * `law.civil_law_interest_rate` - Zinssatz
 * * `law.civil_law_judgment_date` - Urteilsdatum
 * * `law.civil_law_liability_percentage` - Haftungsquote in Prozent
 * * `law.civil_law_notarial_certification_date` - Notarielle Beurkundung Datum
 * * `law.civil_law_payment_due_date` - Fälligkeitsdatum
 * * `law.civil_law_purchase_agreement` - Kaufvertrag
 * * `law.civil_law_purchase_contract_file_reference` - Kaufvertragsaktenzeichen
 * * `law.civil_law_purchase_date` - Kaufdatum
 * * `law.civil_law_purchase_object` - Kaufgegenstand
 * * `law.civil_law_purchase_price_components` - Bestandteile Kaufpreis
 * * `law.civil_law_purchase_price` - Kaufpreis
 * * `law.civil_law_purchase_price_paid_amount` - Höhe bezahlten Kaufpreises
 * * `law.civil_law_purchase_price_paid_boolean` - Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_paid_date` - Datum Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_paid` - Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_payment_date` - Datum Zahlung Kaufpreis
 * * `law.civil_law_subject_line` - Betreff
 * * `law.civil_law_termination_notice_period` - Kündigungsfrist
 * * `law.civil_law_vehicle_make` - Fahrzeugmarke
 * * `law.civil_law_vehicle_mileage` - Kilometerstand
 * * `law.civil_law_vehicle_model` - Fahrzeugmodell
 * * `law.civil_law_vehicle_vin` - Fahrgestellnummer
 * * `law.civil_law_vehicle_year` - Baujahr
 * * `law.civil_law_warranty_period` - Gewährleistungsfrist
 * * `law.criminal_law_amount_of_daily_rates` - Betrag des Tagessatzes
 * * `law.criminal_law_applicable_laws` - Anwendbare Vorschriften
 * * `law.criminal_law_charge_description` - Anklagesatz
 * * `law.criminal_law_complaint` - Anzeige
 * * `law.criminal_law_criminal_warrant` - Strafbefehl
 * * `law.criminal_law_damage_description` - Beschreibung des Schadens
 * * `law.criminal_law_damage_value` - Schadenshöhe in EUR
 * * `law.criminal_law_date_of_offense` - Datum der Tat
 * * `law.criminal_law_duration_of_prison_sentence` - Dauer der Freiheitsstrafe
 * * `law.criminal_law_evidence_location` - Standort der Beweismittel
 * * `law.criminal_law_evidence` - Beweis
 * * `law.criminal_law_incident_description` - Sachverhalt
 * * `law.criminal_law_indictment_date` - Datum der Anklageschrift
 * * `law.criminal_law_indictment_delivery_date` - Datum der Zustellung der Anklageschrift
 * * `law.criminal_law_indictment` - Anklageschrift
 * * `law.criminal_law_legal_classification_of_offense` - Vergehen auf der Grundlage von
 * * `law.criminal_law_means_of_evidence` - Beweismittel
 * * `law.criminal_law_number_of_daily_rates` - Tagessatz
 * * `law.criminal_law_offense_type` - Art des Delikts
 * * `law.criminal_law_penalty_infromation` - Strafe
 * * `law.criminal_law_physical_evidence` - Beschreibung der Beweismittel
 * * `law.criminal_law_place_of_offense` - Ort der Tat
 * * `law.criminal_law_police_file_number` - Vorgangsnummer
 * * `law.criminal_law_preliminary_proceedings_date` - Datum der Einleitung des Ermittlungsverfahrens
 * * `law.criminal_law_prison_sentence` - Freiheitsstrafe
 * * `law.criminal_law_probation` - Bewährung
 * * `law.criminal_law_prosecution_file_number` - Aktenzeichen der Staatsanwaltschaft
 * * `law.criminal_law_report_date` - Datum der Anzeigenerstattung
 * * `law.criminal_law_report_time` - Uhrzeit der Anzeigenerstattung
 * * `law.criminal_law_time_of_offense` - Uhrzeit der Tat
 * * `law.debt_collection_law_business_fee` - 1,3 Geschäftsgebühr (Nr. 2300 VV RVG)
 * * `law.debt_collection_law_case_value` - Gegenstandswert
 * * `law.debt_collection_law_invoice_amount` - Rechnungsbetrag
 * * `law.debt_collection_law_invoice_date` - Rechnungsdatum
 * * `law.debt_collection_law_invoice_ground` - Rechnungsgrund
 * * `law.debt_collection_law_invoice_lawyer` - Rechnung Anwalt
 * * `law.debt_collection_law_invoice` - Rechnung
 * * `law.debt_collection_law_invoice_number` - Rechnungsnummer
 * * `law.debt_collection_law_invoice_recipient` - Rechnungsadressat
 * * `law.debt_collection_law_invoice_tax_number` - Steuernummer
 * * `law.debt_collection_law_lumps_sum_expenses` - Auslagenpauschale (Nr. 7002 VV RVG)
 * * `law.debt_collection_law_sales_tax` - Umsatzsteuer (19%)
 * * `law.debt_collection_law_subtotal_lawyer_fees` - Zwischensumme Netto
 * * `law.debt_collection_law_total_amount` - Gesamtbetrag
 * * `law.external_case_id` - external case id
 * * `law.family_law_average_net_income` - Durchschnittliches Nettoeinkommen
 * * `law.family_law_birth_certificate` - Geburtsurkunden
 * * `law.family_law_birth_register_number` - Geburtsurkundennummer
 * * `law.family_law_birth_register_office_location` - Standesamt Geburtsurkunde
 * * `law.family_law_children` - Kinder vorhanden
 * * `law.family_law_date_of_marriage` - Eheschließungsdatum
 * * `law.family_law_divorce_application` - Ehescheidungsantrag
 * * `law.family_law_divorce_settlement_agreement` - Scheidungsfolgenvereinbarung
 * * `law.family_law_marriage_certificate` - Eheurkunde
 * * `law.family_law_marriage_contract_date` - Ehevertragsdatum
 * * `law.family_law_marriage_contract` - Ehevertrag
 * * `law.family_law_marriage_register_number` - Eheregisternummer
 * * `law.family_law_registry_office_location` - Standesamt Ort
 * * `law.family_law_separation_date` - Trennungsdatumdatum
 * * `law.field` - Rechtsgebiet
 * * `law.general_law_amount_net` - Nettobetrag
 * * `law.general_law_amount_total` - Gesamtbetrag
 * * `law.general_law_appendices` - Anlagen
 * * `law.general_law_case_number` - Geschäftsnummer
 * * `law.general_law_court_costs` - Gerichtskosten
 * * `law.general_law_court_name` - Gericht
 * * `law.general_law_doc_date` - Dokumentendatum
 * * `law.general_law_due_date` - Fälligkeitsdatum
 * * `law.general_law_file_ref` - Aktenzeichen
 * * `law.general_law_hearing_date` - Verhandlungstermin
 * * `law.general_law_invoice_date` - Rechnungsdatum
 * * `law.general_law_invoice_number` - Rechnungsnummer
 * * `law.general_law_judgment_date` - Urteilsdatum
 * * `law.general_law_correspondence` - Schriftverkehr
 * * `law.general_law_court_document` - Gerichtsdokument
 * * `law.general_law_invoice` - Rechnung
 * * `law.general_law_payment_terms` - Zahlungsbedingungen
 * * `law.general_law_prior_ref` - Zeichen unseres Schreibens
 * * `law.general_law_subject` - Betreff
 * * `law.general_law_vat` - MwSt / Umsatzsteuer
 * * `law.generic_document` - Anderes Dokument
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - Anwendbares Recht
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - Todesdatum
 * * `law.inheritance_law_certificate_of_inheritance_date` - Datum Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance` - Erbschein
 * * `law.inheritance_law_certificate_of_inheritance_number` - Nummer des Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - Todesort
 * * `law.inheritance_law_death_certificate_date_death` - Todesdatum
 * * `law.inheritance_law_death_certificate_date` - Datum Sterbeurkunde
 * * `law.inheritance_law_death_certificate` - Sterbeurkunde
 * * `law.inheritance_law_death_certificate_number` - Nummer Sterbeurkunde
 * * `law.inheritance_law_death_certificate_place_death` - Ort des Todes
 * * `law.inheritance_law_death_certificate_place` - Ort Sterbeurkunde
 * * `law.inheritance_law_death_certificate_time_death` - Uhrzeit des Todes
 * * `law.inheritance_law_estate_inventory_amount` - Nettonachlass
 * * `law.inheritance_law_estate_inventory_date` - Datum Nachlassverzeichnis
 * * `law.inheritance_law_estate_inventory_status` - Güterstand
 * * `law.inheritance_law_inheritance_contract_date` - Datum des Erbvertrags
 * * `law.inheritance_law_inheritance_contract` - Erbvertrag
 * * `law.inheritance_law_lasting_power_of_attorney_date` - Datum Vorsorgevollmacht
 * * `law.inheritance_law_lasting_power_of_attorney` - Vorsorgevollmacht
 * * `law.inheritance_law_list_of_estate` - Nachlassverzeichnis
 * * `law.inheritance_law_living_will` - Patientenverfügung
 * * `law.inheritance_law_patient_enrollment_date` - Datum Patientenverfügung
 * * `law.inheritance_law_testament_date` - Datum des Testaments
 * * `law.inheritance_law_will` - Testament
 * * `law.labor_law_amount_dependent_children` - Anzahl unterhaltspflichtiger Kinder
 * * `law.labor_law_beginning_of_employment` - Datum Beginn des Arbeitsverhältnisses
 * * `law.labor_law_certificate_clause` - Zeugnisklausel
 * * `law.labor_law_child_allowances` - Kinderfreibeträge
 * * `law.labor_law_collective_agreement` - Tarifvertrag
 * * `law.labor_law_company_agreement` - Betriebsvereinbarung
 * * `law.labor_law_company_hearing` - Betriebsanhörung durchgeführt
 * * `law.labor_law_dependent_children` - Unterhaltspflichtige Kinder
 * * `law.labor_law_different_place_of_work` - Abweichender Arbeitsort
 * * `law.labor_law_disability` - Behinderung
 * * `law.labor_law_employee_probation_period_end_date` - Datum Ende der Probezeit
 * * `law.labor_law_end_of_employment` - Datum Ende des Arbeitsverhältnisses
 * * `law.labor_law_exemption_irrevocable` - Freistellung unwiderruflich
 * * `law.labor_law_exemption_revocable` - Freistellung widerruflich
 * * `law.labor_law_fixed_term_contract_duration` - Ende befristetes Arbeitsverhältnis
 * * `law.labor_law_fixed_term_contract` - Befristetes Arbeitsverhältnis
 * * `law.labor_law_grade_certificate_clause` - Note Zeugnisklausel
 * * `law.labor_law_is_employee_in_probation_period` - Arbeitnehmer in Probezeit
 * * `law.labor_law_job_title` - Berufsbezeichnung
 * * `law.labor_law_local_transfer_clause` - Örtliche Versetzungsklausel
 * * `law.labor_law_LTI` - LTI
 * * `law.labor_law_married` - Verheiratet
 * * `law.labor_law_monthly_gross_salary` - Gehalt, monatlich, brutto
 * * `law.labor_law_monthly_working_days` - Arbeitsstunden pro Monat
 * * `law.labor_law_notice_period` - Kündigungsfrist in Monaten
 * * `law.labor_law_notice_period_observed` - Kündigungsfrist eingehalten
 * * `law.labor_law_payslip` - Lohnabrechnung
 * * `law.labor_law_percent_sprinter_clause` - Prozent Sprinterklausel
 * * `law.labor_law_place_of_work` - Arbeitsort
 * * `law.labor_law_pregnancy` - Schwangerschaft
 * * `law.labor_law_reaction_company_hering` - Reaktion des Betriebsrats
 * * `law.labor_law_reason_for_termination_given` - Kündigungsgrund angegeben
 * * `law.labor_law_return_of_company_property` - Rückgabe Firmeneigentum
 * * `law.labor_law_settlement_agreement_date` - Datum Abwicklungsvertrag
 * * `law.labor_law_settlement_agreement` - Abwicklungsvertrag
 * * `law.labor_law_severance_amount` - Abfindungssumme
 * * `law.labor_law_signature_of_employer` - Unterschrift Arbeitgeber
 * * `law.labor_law_special_documents` - Besondere Dokumente
 * * `law.labor_law_special_payments_amount` - Höhe der Sonderzahlungen
 * * `law.labor_law_special_payments` - Sonderzahlungen
 * * `law.labor_law_special_personal_circumstances` - Besondere persönliche Umstände
 * * `law.labor_law_special_protection_against_dismissal` - Sonderkündigungsschutz
 * * `law.labor_law_special_sentence` - zur Vermeidung Kündigung aus dringenden betrieblichen Gründen
 * * `law.labor_law_sprinter_clause` - Sprinterklausel
 * * `law.labor_law_termination_access_to_termination_to_employee` - Datum Zugang Kündigung beim Arbeitnehmer
 * * `law.labor_law_termination_agreement_date` - Datum Aufhebungsvertrag
 * * `law.labor_law_termination_agreement` - Aufhebungsvertrag
 * * `law.labor_law_termination_agreement_severance_pay_amount` - Höhe der Abfindung
 * * `law.labor_law_termination_agreement_termination_date` - Datum Beendigung Arbeitsverhältnis
 * * `law.labor_law_termination_authorization` - Befugnis zur Kündigung
 * * `law.labor_law_termination_date_effective` - Kündigung erfolgt zu welchem Datum
 * * `law.labor_law_termination_date` - Datum Kündigung durch Arbeitgeber
 * * `law.labor_law_termination_employer_more_than_10_employees` - Arbeitgeber hat mehr als 10 Mitarbeiter
 * * `law.labor_law_termination_is_agreement_severance_pay` - Abfindung vereinbart
 * * `law.labor_law_termination` - Kündigung
 * * `law.labor_law_termination_operational_reasons` - 1a KSchG dringende betriebliche Kündigung
 * * `law.labor_law_termination_without_notice` - fristlose Kündigung
 * * `law.labor_law_total_gross_salary` - Gesamtgehalt Brutto
 * * `law.labor_law_vacation_days` - Urlaubstage
 * * `law.labor_law_visum` - Visum / Aufenthaltstitel
 * * `law.labor_law_VSOP` - VSOP
 * * `law.labor_law_warning_letter_access_to_warning_letter_to_employee` - Datum Zugang Abmahnung beim Arbeitnehmer
 * * `law.labor_law_warning_letter_date` - Datum Abmahnung
 * * `law.labor_law_warning_letter_incident_date` - Datum des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_location` - Ort des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_time` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter` - Abmahnung
 * * `law.labor_law_warning_letter_reason` - Grund der Abmahnung
 * * `law.labor_law_work_contract` - Arbeitsvertrag
 * * `law.labor_law_work_council` - Betriebsrat
 * * `law.labor_law_work_hours_per_week` - Arbeitsstunden pro Woche
 * * `law.labor_law_works_council_membership` - Mitgliedschaft Betriebsrat
 * * `law.labor_law_yearly_gross_salary` - Gehalt, jährlich, brutto
 * * `law.labor_law_years_of_employment` - Jahre der Betriebszugehörigkeit
 * * `law.medicine_law_health_insurance_letter_date` - Datum des Schreibens
 * * `law.medicine_law_health_insurance_letter_decision_justification` - Begründung der Entscheidung
 * * `law.medicine_law_health_insurance_letter_decision` - Entscheidung der Krankenkasse
 * * `law.medicine_law_health_insurance_letter_legal_remedy_instruction` - Rechtsbehelfsbelehrung
 * * `law.medicine_law_health_insurance_letter` - Schreiben von Krankenkasse
 * * `law.medicine_law_health_insurance_letter_reference_to_application` - Bezug auf Schreiben
 * * `law.medicine_law_hospital_records_admission_date` - Aufnahmedatum
 * * `law.medicine_law_hospital_records_diagnoses_icd_codes` - Diagnosen ICD-Codes
 * * `law.medicine_law_hospital_records_discharge_date` - Entlassungsdatum
 * * `law.medicine_law_hospital_records_discharge_prognosis` - Prognose
 * * `law.medicine_law_hospital_records_documented_complications` - Dokumentierte Komplikationen
 * * `law.medicine_law_hospital_records` - Krankenhausakte
 * * `law.medicine_law_hospital_records_medication_during_stay` - Medikation während Aufenthalt
 * * `law.medicine_law_hospital_records_operation_date` - Operation Datum
 * * `law.medicine_law_hospital_records_operations` - Operationen
 * * `law.medicine_law_hospital_records_station` - Station
 * * `law.medicine_law_laboratory_results_examination_date` - Datum der Untersuchung
 * * `law.medicine_law_laboratory_results_examination_type` - Art der Untersuchung
 * * `law.medicine_law_laboratory_results_further_investigation_recommendation` - Empfehlung zur weiteren Abklärung
 * * `law.medicine_law_laboratory_results` - Befund
 * * `law.medicine_law_laboratory_results_relevant_deviations` - Relevante Abweichungen
 * * `law.medicine_law_medical_bill_cost_bearer` - Kostenträger
 * * `law.medicine_law_medical_bill_invoice_date` - Rechnungsdatum
 * * `law.medicine_law_medical_bill_invoice_number` - Rechnungsnummer
 * * `law.medicine_law_medical_bill` - Arztrechnung
 * * `law.medicine_law_medical_bill_payment_deadline` - Zahlungsfrist
 * * `law.medicine_law_medical_bill_service_period` - Zeitraum der Leistung
 * * `law.medicine_law_medical_bill_services_list` - Auflistung der Leistungen
 * * `law.medicine_law_medical_bill_total_amount` - Gesamtsumme der Rechnung
 * * `law.medicine_law_medical_expertise_date` - Datum des Gutachtens
 * * `law.medicine_law_medical_expertise_justification` - Begründung des Ergebnisses
 * * `law.medicine_law_medical_expertise` - Medizinisches Gutachten
 * * `law.medicine_law_medical_expertise_medical_assessment` - Medizinische Einschätzung
 * * `law.medicine_law_medical_expertise_question_posed` - Fragestellung des Gutachtens
 * * `law.medicine_law_medical_expertise_result` - Ergebnis des Gutachtens
 * * `law.medicine_law_medical_report_complications` - Komplikationen
 * * `law.medicine_law_medical_report_date` - Datum des Berichts
 * * `law.medicine_law_medical_report_diagnosis_icd_code` - Diagnose ICD-Code
 * * `law.medicine_law_medical_report_diagnosis_short_text` - Diagnose Kurztext
 * * `law.medicine_law_medical_report_further_treatment` - Weitere Behandlung
 * * `law.medicine_law_medical_report` - Arztbericht
 * * `law.medicine_law_medical_report_surgery_date` - OP-Datum
 * * `law.medicine_law_medical_report_treatment_measures` - Therapie Behandlungsmaßnahmen
 * * `law.medicine_law_medical_report_treatment_period` - Zeitraum der Behandlung
 * * `law.migration_law_approval_notice_case_number` - Aktenzeichen
 * * `law.migration_law_approval_notice_conditions` - Auflagen
 * * `law.migration_law_approval_notice_decision_date` - Datum des Bescheids
 * * `law.migration_law_approval_notice_issuing_authority` - Ausstellende Behörde
 * * `law.migration_law_approval_notice` - Bewilligungsbescheid
 * * `law.migration_law_approval_notice_permit_type` - Art des Aufenthaltstitels
 * * `law.migration_law_approval_notice_pickup_deadline` - Abholfrist
 * * `law.migration_law_approval_notice_validity_period` - Gültigkeitszeitraum
 * * `law.migration_law_asylum_seeker_certificate_application_number` - Asylantragsnummer
 * * `law.migration_law_asylum_seeker_certificate_first_registration_date` - Erstregistrierung
 * * `law.migration_law_asylum_seeker_certificate_issue_date` - Ausstellungsdatum
 * * `law.migration_law_asylum_seeker_certificate_issuing_authority` - Behörde
 * * `law.migration_law_asylum_seeker_certificate` - Bescheinigung über die Aufenthaltsgestattung
 * * `law.migration_law_asylum_seeker_certificate_residence_obligation` - Wohnsitzauflage
 * * `law.migration_law_asylum_seeker_certificate_valid_until` - Gültig bis
 * * `law.migration_law_asylum_seeker_certificate_work_permission` - Arbeitserlaubnis
 * * `law.migration_law_cooperation_letter_attachments` - Anlagen / Formulare
 * * `law.migration_law_cooperation_letter_date` - Datum des Schreibens
 * * `law.migration_law_cooperation_letter_deadlines` - Fristen
 * * `law.migration_law_cooperation_letter_file_number` - Aktenzeichen
 * * `law.migration_law_cooperation_letter` - Mitwirkungspflichtschreiben
 * * `law.migration_law_cooperation_letter_non_cooperation_consequences` - Rechtsfolgen bei Nichtmitwirkung
 * * `law.migration_law_cooperation_letter_specified_obligations` - Benannte Mitwirkungspflichten
 * * `law.migration_law_fictional_certificate_authority` - Behörde
 * * `law.migration_law_fictional_certificate_fiction_type` - Art der Fiktion
 * * `law.migration_law_fictional_certificate_issue_date` - Ausgestellt am
 * * `law.migration_law_fictional_certificate_legal_basis` - Rechtsgrundlage
 * * `law.migration_law_fictional_certificate` - Fiktionsbescheinigung
 * * `law.migration_law_fictional_certificate_reason_for_issuance` - Zweck der Erteilung
 * * `law.migration_law_fictional_certificate_valid_until` - Gültig bis
 * * `law.migration_law_hearing_letter_date` - Datum des Schreibens
 * * `law.migration_law_hearing_letter_intended_measure_justification` - Begründung der beabsichtigten Maßnahme
 * * `law.migration_law_hearing_letter_legal_advice` - Rechtsbehelfshinweis
 * * `law.migration_law_hearing_letter` - Anhörungsschreiben
 * * `law.migration_law_hearing_letter_requested_documents` - Dokumente beizufügen
 * * `law.migration_law_hearing_letter_response_deadline` - Frist zur Stellungnahme
 * * `law.migration_law_other_letters_action_required` - Handlungsaufforderung
 * * `law.migration_law_other_letters_date` - Datum des Schreibens
 * * `law.migration_law_other_letters_deadlines` - Fristen
 * * `law.migration_law_other_letters_file_number` - Aktenzeichen / Geschäftszeichen
 * * `law.migration_law_other_letters_issuing_authority` - Absenderbehörde
 * * `law.migration_law_other_letters_legal_basis` - Rechtsgrundlage (sofern genannt)
 * * `law.migration_law_other_letters` - Sonstige Schreiben der Ausländerbehörde
 * * `law.migration_law_other_letters_matter_purpose` - Anliegen / Inhalt des Schreibens
 * * `law.migration_law_other_letters_subject` - Betreff
 * * `law.migration_law_rejection_notice_case_number` - Aktenzeichen
 * * `law.migration_law_rejection_notice_decision_date` - Datum des Bescheids
 * * `law.migration_law_rejection_notice_legal_grounds` - Gesetzesgrundlagen
 * * `law.migration_law_rejection_notice_legal_remedy_deadline` - Rechtsbehelf / Frist
 * * `law.migration_law_rejection_notice` - Ablehnungsbescheid
 * * `law.migration_law_rejection_notice_officer_name` - Name des Sachbearbeiters
 * * `law.migration_law_rejection_notice_reasoning` - Begründung
 * * `law.migration_law_rejection_notice_signature_seal` - Unterschrift / Dienstsiegel
 * * `law.migration_law_rejection_notice_subject` - Betreff
 * * `law.migration_law_residence_permit_conditions` - Auflagen / Nebenbestimmungen
 * * `law.migration_law_residence_permit_issue_date` - Ausstellungsdatum
 * * `law.migration_law_residence_permit_issuing_authority` - Behörde
 * * `law.migration_law_residence_permit` - Aufenthaltstitel
 * * `law.migration_law_residence_permit_national_id_number` - Nationale Identitätsnummer
 * * `law.migration_law_residence_permit_passport_number` - Passnummer
 * * `law.migration_law_residence_permit_purpose` - Zweck des Aufenthalts
 * * `law.migration_law_residence_permit_type` - Titelart
 * * `law.migration_law_residence_permit_valid_until` - Gültig bis
 * * `law.migration_law_toleration_issue_date` - Ausgestellt am
 * * `law.migration_law_toleration_issuing_authority` - Behörde
 * * `law.migration_law_toleration_legal_basis` - Rechtsgrundlage
 * * `law.migration_law_toleration` - Duldung
 * * `law.migration_law_toleration_reason` - Grund der Duldung
 * * `law.migration_law_toleration_restrictions` - Beschränkungen
 * * `law.migration_law_toleration_valid_until` - Gültig bis
 * * `law.real_estate_law_basic_debts_amount` - Grundschulden
 * * `law.real_estate_law_broker_commission_amount` - Provisionshöhe
 * * `law.real_estate_law_broker_contract_type` - Art des Maklervertrags
 * * `law.real_estate_law_broker_scope_of_work` - Tätigkeitsumfang
 * * `law.real_estate_law_broker_termination_periods` - Kündigungsfristen
 * * `law.real_estate_law_brokerage_contract_date` - Maklervertrag Datum
 * * `law.real_estate_law_brokerage_contract` - Maklervertrag
 * * `law.real_estate_law_brokerage_fee` - Makler Provision
 * * `law.real_estate_law_building_dimensions` - Baukörperabmessung
 * * `law.real_estate_law_building_permit_date` - Baugenehmigungsdatum
 * * `law.real_estate_law_building_permit` - Baugenehmigung
 * * `law.real_estate_law_building_permit_number` - Genehmigungsnummer
 * * `law.real_estate_law_building_permit_validity_duration` - Gültigkeitsdauer
 * * `law.real_estate_law_building_plan` - Bauplan
 * * `law.real_estate_law_building_restrictions_clause` - Regelungen zu Baulasten
 * * `law.real_estate_law_building_usage` - Gebäudenutzung
 * * `law.real_estate_law_co_ownership_share` - Miteigentumsanteil
 * * `law.real_estate_law_commission_percentage` - Provisionshöhe in %
 * * `law.real_estate_law_contaminated_sites_clause` - Regelung zu Altlasten
 * * `law.real_estate_law_declaration_of_division` - Teilungserklärung
 * * `law.real_estate_law_division_declaration_date` - Datum Teilungserklärung
 * * `law.real_estate_law_encumbrance_restrictions` - Lasten und Beschränkungen
 * * `law.real_estate_law_encumbrances_section_ii` - Belastungen Abt. II Grundbuch
 * * `law.real_estate_law_encumbrances_section_iii` - Belastungen Abt. III Grundbuch
 * * `law.real_estate_law_exclusive_brokerage_contract` - Alleinauftrag
 * * `law.real_estate_law_full_repayment_date` - vollständige Rückzahlung
 * * `law.real_estate_law_installment_amount` - Ratenhöhe
 * * `law.real_estate_law_interest_rate` - Zinssatz
 * * `law.real_estate_law_land_register_address` - Grundbuch Lage
 * * `law.real_estate_law_land_register_city` - Grundbuch Stadt
 * * `law.real_estate_law_land_register_date` - Grundbuchauszugdatum
 * * `law.real_estate_law_land_register` - Grundbuchauszug
 * * `law.real_estate_law_land_register_number` - Grundbuch Nr.
 * * `law.real_estate_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.real_estate_law_legal_defects_clause` - Klausel zu Rechtsmängeln
 * * `law.real_estate_law_loan_agreement` - Immobiliendarlehensvertrag
 * * `law.real_estate_law_loan_amount` - Darlehenssumme
 * * `law.real_estate_law_loan_security` - Darlehnsabsicherung
 * * `law.real_estate_law_monument_protection_basis` - Schutzgrundlage
 * * `law.real_estate_law_monument_protection_notice` - Denkmalschutzbescheid
 * * `law.real_estate_law_monument_protection_order_date` - Datum des Denkmalschutzbescheides
 * * `law.real_estate_law_monument_protection_order_number` - Bescheid - Nr.
 * * `law.real_estate_law_monument_protection_requirements` - Auflagen
 * * `law.real_estate_law_monument_registration_date` - Eintragungsdatum
 * * `law.real_estate_law_plan_author` - Planverfasser
 * * `law.real_estate_law_plan_designation` - Planbezeichnung
 * * `law.real_estate_law_plan_scale` - Maßstab
 * * `law.real_estate_law_plot_size` - Grundstücksgröße
 * * `law.real_estate_law_property_brokered_by_agent` - Objekt durch Makler vermittelt
 * * `law.real_estate_law_purchase_contract_amount` - Kaufvertragsbetrag
 * * `law.real_estate_law_purchase_contract_date` - Kaufvertragsdatum
 * * `law.real_estate_law_purchase_contract_description` - Kaufvertrag Objektbeschreibung
 * * `law.real_estate_law_purchase_contract` - Kaufvertrag
 * * `law.real_estate_law_purchase_contract_registration_date` - Kaufvertragsbeurkundungsdatum
 * * `law.real_estate_law_purchase_contract_registration_number` - Urkundenrollennummer
 * * `law.real_estate_law_purchase_object_rented` - Kaufobjekt vermietet
 * * `law.real_estate_law_purchase_price_loan_financed` - Kaufpreis durch Darlehen finanziert
 * * `law.real_estate_law_repayment_rate` - Tilgungssatz
 * * `law.real_estate_law_withdrawal_instruction_date` - Widerrufsbelehrung Datum
 * * `law.residential_property_law_co_ownership_shares` - Miteigentumsanteile
 * * `law.residential_property_law_contract_date` - Wegvertragsdatum
 * * `law.residential_property_law_contract` - Wegvertrag
 * * `law.residential_property_law_inventory` - Bestandsverzeichnis
 * * `law.residential_property_law_land_register_address` - Grundbuch Lage
 * * `law.residential_property_law_land_register_city` - Grundbuch Stadt
 * * `law.residential_property_law_land_register_number` - Grundbuch Nr.
 * * `law.residential_property_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.social_law_affected_benefit` - Betroffene Leistung
 * * `law.social_law_application_arrival_date` - Eingang Antrag Datum
 * * `law.social_law_application_date` - Antrag Datum
 * * `law.social_law_application_file_reference` - Aktenzeichen
 * * `law.social_law_application_form` - Antragsformular
 * * `law.social_law_appointment_date` - Termin (Datum)
 * * `law.social_law_appointment_file_reference` - Aktenzeichen
 * * `law.social_law_appointment_invitation` - Einladungstermin
 * * `law.social_law_appointment_purpose` - Zweck des Termins
 * * `law.social_law_appointment_required_documents` - Mitzubringende Unterlagen
 * * `law.social_law_appointment_time` - Termin (Uhrzeit)
 * * `law.social_law_approval_file_reference` - Aktenzeichen
 * * `law.social_law_approval_internal_reference` - Interne Referenznummer der Behörde
 * * `law.social_law_approval_legal_basis` - Rechtsgrundlage der Entscheidung
 * * `law.social_law_approval_notice_date` - Datum des Bescheids
 * * `law.social_law_approval_notice` - Bewilligungsbescheid
 * * `law.social_law_approval_period_end` - Bewilligungszeitraum Ende
 * * `law.social_law_approval_period_start` - Bewilligungszeitraum Beginn
 * * `law.social_law_approved_benefit_amount` - Bewilligte Leistung (Betrag)
 * * `law.social_law_approved_benefit_period` - Bewilligte Leistung (Zeitraum)
 * * `law.social_law_approved_benefit_type` - Bewilligte Leistung (Art)
 * * `law.social_law_asset_type` - Art des Vermögens
 * * `law.social_law_attachment_list` - Anlagenliste
 * * `law.social_law_benefit_type` - Leistungsart
 * * `law.social_law_change_description` - Beschreibung der Änderung
 * * `law.social_law_change_file_reference` - Aktenzeichen
 * * `law.social_law_change_notification_date` - Datum der Mitteilung
 * * `law.social_law_change_notification` - Änderungsmitteilung
 * * `law.social_law_change_reason` - Grund der Änderung
 * * `law.social_law_creditable_income` - Anrechenbares Einkommen
 * * `law.social_law_disability_card_issue_date` - Ausstellungsdatum
 * * `law.social_law_disability_card` - Schwerbehindertenausweis
 * * `law.social_law_disability_card_markers` - Merkzeichen
 * * `law.social_law_disability_card_validity_period` - Gültigkeitsdauer
 * * `law.social_law_disability_degree` - Grad der Behinderung (GdB)
 * * `law.social_law_disability_file_reference` - Aktenzeichen
 * * `law.social_law_employment_income` - Erwerbseinkommen
 * * `law.social_law_follow_up_application_notes` - Hinweise zu Folgeanträgen
 * * `law.social_law_hearing_file_reference` - Aktenzeichen
 * * `law.social_law_hearing_letter_date` - Datum Anhörungsschreiben
 * * `law.social_law_hearing_letter` - Anhörungsschreiben
 * * `law.social_law_hearing_planned_administrative_act` - Geplanter Verwaltungsakt
 * * `law.social_law_housing_costs_amount` - Kosten für Unterkunft und Heizung
 * * `law.social_law_income_amount` - Einkommensbetrag
 * * `law.social_law_income_date` - Datum der Einnahme
 * * `law.social_law_income_legal_basis` - Rechtsgrundlage Einkommensberücksichtigung
 * * `law.social_law_income_provider` - Einkommensgeber
 * * `law.social_law_income_source` - Einkommensquelle
 * * `law.social_law_income_type` - Art des Einkommens
 * * `law.social_law_interim_legal_protection` - Antrag auf einstweiligen Rechtsschutz
 * * `law.social_law_interim_protection_affidavit` - Eidesstattliche Versicherung
 * * `law.social_law_interim_protection_attachment_list` - Anlagenliste
 * * `law.social_law_interim_protection_file_reference` - Aktenzeichen
 * * `law.social_law_interim_protection_request_date` - Datum des Antrags
 * * `law.social_law_interim_protection_request_text` - Antragstext
 * * `law.social_law_interim_protection_urgency_reason` - Dringlichkeitsbegründung
 * * `law.social_law_lawsuit_alternative_request` - Hilfsantrag
 * * `law.social_law_lawsuit_attachment_list` - Anlagenliste
 * * `law.social_law_lawsuit_cost_request` - Kostenantrag
 * * `law.social_law_lawsuit_court_file_number` - BG-Nummer
 * * `law.social_law_lawsuit_delivery_date` - Zustellungsdatum
 * * `law.social_law_lawsuit_dispute_value` - Streitwert
 * * `law.social_law_lawsuit_disputed_amount` - Streitiger Betrag
 * * `law.social_law_lawsuit_evidence_requests` - Beweisanträge
 * * `law.social_law_lawsuit_file_reference` - Aktenzeichen
 * * `law.social_law_lawsuit_filing_date` - Datum der Klageerhebung
 * * `law.social_law_lawsuit_income_amount` - Einkommensbetrag
 * * `law.social_law_lawsuit_legal_basis` - Rechtliche Grundlage der Klage
 * * `law.social_law_lawsuit_main_request` - Hauptantrag
 * * `law.social_law_lawsuit` - Klage (Sozialgericht)
 * * `law.social_law_lawsuit_monthly_benefit_amount` - Monatliche Leistung
 * * `law.social_law_lawsuit_objection_decision_date` - Datum des Widerspruchsbescheids
 * * `law.social_law_lawsuit_objection_filing_date` - Datum der Widerspruchseinlegung
 * * `law.social_law_lawsuit_original_decision_date` - Datum des ursprünglichen Bescheids
 * * `law.social_law_lawsuit_subject` - Gegenstand des Verfahrens
 * * `law.social_law_lawsuit_type` - Art der Klage
 * * `law.social_law_legal_basis` - Rechtsgrundlage
 * * `law.social_law_medical_certificate` - Ärztliches Attest / Medizinisches Gutachten
 * * `law.social_law_medical_diagnosis` - Medizinische Diagnose
 * * `law.social_law_medical_examination_date` - Untersuchungsdatum
 * * `law.social_law_medical_file_reference` - Aktenzeichen
 * * `law.social_law_medical_icd_code` - ICD-Code
 * * `law.social_law_medical_limitations` - Einschränkungen
 * * `law.social_law_medical_prognosis` - Prognose
 * * `law.social_law_medical_work_capacity_relation` - Bezug zur Leistungsfähigkeit
 * * `law.social_law_monthly_payment_amount` - Monatliche Leistung
 * * `law.social_law_needs_cost_breakdown` - Kostenaufstellung
 * * `law.social_law_needs_file_reference` - Aktenzeichen
 * * `law.social_law_needs_proof_basis` - Nachweisgrundlage
 * * `law.social_law_needs_proof_date` - Datum Bedarfsnachweis
 * * `law.social_law_needs_proof` - Bedarfsnachweis
 * * `law.social_law_needs_type` - Art des Bedarfs
 * * `law.social_law_notice_date` - Bescheid Datum
 * * `law.social_law_notice_of_objection_date` - Widerspruchbescheid Datum
 * * `law.social_law_notice_of_objection_file_reference` - Aktenzeichen
 * * `law.social_law_notice_of_objection` - Widerspruchbescheid
 * * `law.social_law_notification_date` - Datum der Kenntnisnahme
 * * `law.social_law_notification_legal_basis` - Rechtsgrundlage Mitteilungspflicht
 * * `law.social_law_notification_source` - Quelle der Kenntnisnahme
 * * `law.social_law_objection_challenged_notice` - Angegriffener Bescheid
 * * `law.social_law_objection_date` - Datum des Widerspruchs
 * * `law.social_law_objection_evidence` - Beweismittel
 * * `law.social_law_objection_file_reference` - Aktenzeichen (des angegriffenen Bescheids)
 * * `law.social_law_objection` - Widerspruch
 * * `law.social_law_objection_reasoning` - Widerspruchsbegründung
 * * `law.social_law_objection_suspension_request` - Antrag auf Aussetzung der Vollziehung
 * * `law.social_law_original_decision_date` - Datum des ursprünglichen Bescheids
 * * `law.social_law_other_income` - Sonstiges Einkommen
 * * `law.social_law_own_income_amount` - Höhe eigenes Einkommen
 * * `law.social_law_reclaim_amount` - Rückforderungsbetrag
 * * `law.social_law_reclaim_file_reference` - Aktenzeichen
 * * `law.social_law_reclaim_legal_basis` - Rechtsgrundlage Erstattung
 * * `law.social_law_reclaim_legal_norm` - Rechtsnorm
 * * `law.social_law_reclaim_notice_date` - Datum des Bescheids
 * * `law.social_law_reclaim_notice` - Rückforderungsbescheid
 * * `law.social_law_reclaim_payment_deadline` -  Datum Zahlungsfrist
 * * `law.social_law_reclaim_payment_terms` - Zahlungsmodalitäten
 * * `law.social_law_regelbedarf_amount` - Regelbedarf
 * * `law.social_law_rejection_file_reference` - Aktenzeichen
 * * `law.social_law_rejection_legal_norm` - Rechtsnorm
 * * `law.social_law_rejection_notice_date` - Datum des Bescheids
 * * `law.social_law_rejection_notice` - Ablehnungsbescheid
 * * `law.social_law_rejection_reason` - Ablehnungsgrund
 * * `law.social_law_residence_status` - Aufenthaltsstatus
 * * `law.social_law_revocation_benefit_type` - Leistungsart
 * * `law.social_law_revocation_file_reference` - Aktenzeichen
 * * `law.social_law_revocation_legal_norm` - Rechtsnorm
 * * `law.social_law_revocation_notice_date` - Datum des Bescheids
 * * `law.social_law_revocation_notice` - Aufhebungsbescheid
 * * `law.social_law_revocation_period_end` - Aufhebungszeitraum Ende
 * * `law.social_law_revocation_period_start` - Aufhebungszeitraum Beginn
 * * `law.social_law_revocation_reason` - Begründung der Aufhebung
 * * `law.social_law_revocation_reclaim_notes` - Hinweise zu Rückforderungen
 * * `law.social_law_social_benefit_type` - Art der Sozialleistung
 * * `law.social_law_summary_grounds_opposition` - Begründung des Widerspruchs
 * * `law.social_law_total_need_amount` - Gesamtbedarf
 * * `law.social_law_total_reclaim_amount` - Gesamtforderung
 * * `law.social_law_violation_type` - Art der Pflichtverletzung
 * * `law.tenancy_law_adress_rental_property` - Adresse des Mietobjekts
 * * `law.tenancy_law_advance_payment_service_charge` - Vorauszahlungen Nebenkostenabrechnung
 * * `law.tenancy_law_advance_payment_service_charges` - Nebenkostenvorauszahlungshöhe
 * * `law.tenancy_law_bank_guarantee` - Bankbürgschaft
 * * `law.tenancy_law_cash_deposit_agreed` - Barkaution vertraglich vereinbart
 * * `law.tenancy_law_cash_deposit_payment_date` - Barkaution Datum Zahlung
 * * `law.tenancy_law_competent_court` - Zuständiges Gericht
 * * `law.tenancy_law_cost_share` - Kostenanteil Mieter
 * * `law.tenancy_law_cost_shares` - Umlageschlüssel
 * * `law.tenancy_law_counter_number` - Zählerstandnummer
 * * `law.tenancy_law_court_case_number` - Gerichtliches Aktenzeichen
 * * `law.tenancy_law_court_proceedings_pending` - Gerichtliches Verfahren anhängig
 * * `law.tenancy_law_description_of_rental_property` - Beschreibung des Mietobjekts
 * * `law.tenancy_law_duration_of_lease` - Dauer des Pachtvertrags
 * * `law.tenancy_law_expert_report_commission_date` - Beauftragung Datum
 * * `law.tenancy_law_expert_report_damage_description` - Schaden
 * * `law.tenancy_law_expert_report_damage_number` - Schadennummer
 * * `law.tenancy_law_expert_report_date` - Datum Gutachten
 * * `law.tenancy_law_expert_report_inspection_date` - Ortsbesichtigung Datum
 * * `law.tenancy_law_expert_report` - Sachverständigengutachten
 * * `law.tenancy_law_expert_report_object_address` - Objekt Adresse
 * * `law.tenancy_law_expert_report_purpose` - Zweck des Gutachtens
 * * `law.tenancy_law_expert_report_repair_duration` - Dauer Schadenbeseitigung
 * * `law.tenancy_law_expert_report_subject` - Gegenstand
 * * `law.tenancy_law_extension_option_count` - Anzahl Verlängerungsoptionen
 * * `law.tenancy_law_extension_option_duration` - Dauer Verlängerungsoption
 * * `law.tenancy_law_fixed_term_tenancy` - Befristeter Mietvertrag
 * * `law.tenancy_law_garage_available` - Garage vorhanden
 * * `law.tenancy_law_garage_costs` - Kosten Garage
 * * `law.tenancy_law_general_status_documents` - Allgemeine Angaben zum Mietverhältnis
 * * `law.tenancy_law_gross_rent` - Bruttomiete
 * * `law.tenancy_law_handover_counter` - Zählerstand
 * * `law.tenancy_law_handover_date` - Übergabedatum
 * * `law.tenancy_law_handover_defects` - Mängel
 * * `law.tenancy_law_handover_protocol` - Übergabeprotokoll
 * * `law.tenancy_law_landlord_termination_given` - Kündigung durch Vermieter erfolgt
 * * `law.tenancy_law_last_rent_increase_letter_date` - Datum letztes Mieterhöhungsschreiben
 * * `law.tenancy_law_last_signature_date` - Datum letzte Unterschrift Mietvertrag
 * * `law.tenancy_law_lease_agreement` - Pachtvertrag
 * * `law.tenancy_law_location_in_rental_property` - Lage im Mietobjekt
 * * `law.tenancy_law_net_rent` - Nettomiete
 * * `law.tenancy_law_operating_costs_agreement` - Betriebskostenvereinbarung
 * * `law.tenancy_law_parking_space_available` - Stellplatz vorhanden
 * * `law.tenancy_law_parking_space_costs` - Kosten des Stellplatzes
 * * `law.tenancy_law_property_return_date` - Rückgabe des Objekts Datum
 * * `law.tenancy_law_rent_increase_effective_date` - Mieterhöhung wirksam geworden zum
 * * `law.tenancy_law_rent_increase_notice` - Mieterhöhungsschreiben
 * * `law.tenancy_law_rental_agreement_date` - Mietvertragsdatum
 * * `law.tenancy_law_rental_agreement_duration` - Dauer Mietvertrag
 * * `law.tenancy_law_rental_agreement` - Mietvertrag
 * * `law.tenancy_law_rental_agreement_validity_end` - Mietvertragsende
 * * `law.tenancy_law_rental_agreement_validity_start` - Mietvertragsbeginn
 * * `law.tenancy_law_rental_object_size_sqm` - Größe Mietobjekt Quadratmeter
 * * `law.tenancy_law_repayment` - Nachzahlung/Guthaben
 * * `law.tenancy_law_repayment_period_end` - Ende des Abrechnungszeitraums
 * * `law.tenancy_law_repayment_period_start` - Beginn des Abrechnungszeitraums
 * * `law.tenancy_law_security_deposit_additional_regulations` - Zusätzliche Regelungen zur Kaution
 * * `law.tenancy_law_security_deposit_amount` - Kautionshöhe
 * * `law.tenancy_law_service_charge_settlement` - Nebenkostenabrechnung
 * * `law.tenancy_law_staggered_rental_agreement` - Staffelmietvereinbarung
 * * `law.tenancy_law_start_of_lease` - Beginn des Pachtvertrags
 * * `law.tenancy_law_tenancy_terminated` - Mietverhältnis beendet
 * * `law.tenancy_law_tenancy_termination_date` - Datum Beendigung Mietverhältnisses
 * * `law.tenancy_law_tenant_extension_option` - Verlängerungsoption zugunsten Mieter
 * * `law.tenancy_law_tenant_warned` - Mieter abgemahnt
 * * `law.tenancy_law_termination_declared_date` - Datum Kündigungserklärung
 * * `law.tenancy_law_termination_letter_date` - Kündigungsschreiben vom
 * * `law.tenancy_law_termination_notice` - Kündigung
 * * `law.tenancy_law_termination_notice_period` - Kündigungsfrist
 * * `law.tenancy_law_total_cost_service_charge` - Gesamtkosten Nebenkostenabrechnung
 * * `law.tenancy_law_total_rent` - Gesamtmiete
 * * `law.tenancy_law_unlimited_term_tenancy` - Unbefristeter Mietvertrag
 * * `law.tenancy_law_value_security_clause` - Wertsicherungsklausel
 * * `law.tenancy_law_warning_letter_date` - Datum Mahnschreiben
 * * `law.tenancy_law_warning_letter` - Abmahnung
 * * `law.topic` - Rechtsthema
 * * `law.traffic_law_accident_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_accident_report` - Unfallbericht
 * * `law.traffic_law_amount_of_fine` - Bußgeldhöhe
 * * `law.traffic_law_appeal_instruction` - Rechtsbehelfsbelehrung
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - Unfallverursacher - Führerschein ausgestellt durch
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - Unfallverursacher - Führerschein gültig bis
 * * `law.traffic_law_at_fault_driver_green_card_number` - Unfallverursacher - Nr. der Grünen Karte
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_at_fault_driver_insurance_number` - Unfallverursacher - Vers.-Nr.
 * * `law.traffic_law_at_fault_driver_insurer` - Unfallverursacher - Versicherer
 * * `law.traffic_law_blood_alcohol_concentration` - Blutalkoholkonzentration
 * * `law.traffic_law_calculated_total_damage_costs` - Gesamtschadenshöhe
 * * `law.traffic_law_calculated_total_days` - Gesamttage
 * * `law.traffic_law_charges` - Tatvorwurf
 * * `law.traffic_law_cost_per_scale` - Kostenpauschale
 * * `law.traffic_law_daily_rate` - Höhe des Tagessatzes
 * * `law.traffic_law_damage_amount_net` - Schadenshöhe netto
 * * `law.traffic_law_damage_number` - Schadensnummer
 * * `law.traffic_law_damage_scope` - Schadensumfang
 * * `law.traffic_law_date_of_accident` - Unfalltag
 * * `law.traffic_law_date_of_crime` - Datum der Tat
 * * `law.traffic_law_date_of_fine` - Datum Bußgeldbescheid
 * * `law.traffic_law_date_of_infraction` - Datum der Ordnungswidrigkeit
 * * `law.traffic_law_date_of_inspection` - Besichtigungsdatum
 * * `law.traffic_law_date_of_issue` - Datum der Ausstellung
 * * `law.traffic_law_date_of_offense` - Datum der Tat
 * * `law.traffic_law_date_of_report` - Datum Sachverständigengutachten
 * * `law.traffic_law_differencial_tax` - Differenzsteuer
 * * `law.traffic_law_driver_logbook_required` - Fahrtenbuch erforderlich
 * * `law.traffic_law_driving_ban_duration` - Fahrverbot Dauer
 * * `law.traffic_law_driving_ban` - Fahrverbot verhängt
 * * `law.traffic_law_evidence_infraction` - Beweismittel
 * * `law.traffic_law_expert_cost` - Sachverständigenkosten
 * * `law.traffic_law_expert_date` - Unfallverursacher - Sachverständigengutachten
 * * `law.traffic_law_expert_report` - Sachverständigengutachten
 * * `law.traffic_law_expert_report_number` - Gutachten Nummer
 * * `law.traffic_law_file_number` - Aktenzeichen
 * * `law.traffic_law_fine` - Geldstrafe
 * * `law.traffic_law_fine_notice` - Bußgeldbescheid
 * * `law.traffic_law_gross_gross_replacement_value` - Brutto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_gross_replacement_value` - Bruttowiederbeschaffungswert
 * * `law.traffic_law_injured` - Verletzte
 * * `law.traffic_law_insurance_holder` - Versicherungsnehmer
 * * `law.traffic_law_insurance` - Versicherung
 * * `law.traffic_law_insurance_policy_number` - Versicherungsscheinnummer
 * * `law.traffic_law_legal_basis_infraction` - Gesetzliche Grundlage
 * * `law.traffic_law_legal_basis` - Gesetzliche Grundlage
 * * `law.traffic_law_licenseplate_at_fault_driver` - KFZ-Kennzeichen des Unfallverursachers
 * * `law.traffic_law_licenseplate` - KFZ-Kennzeichen
 * * `law.traffic_law_licenseplate_victim_driver` - KFZ-Kennzeichen des Unfallgeschädigten
 * * `law.traffic_law_loss_amount_repair_case` - Restschaden Reparaturschaden
 * * `law.traffic_law_loss_amount_total_damage_case` - Restschaden Totalschaden
 * * `law.traffic_law_loss_of_use_per_day` - Nutzungsausfallentschädigung pro Tag
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - Unfallverursacher - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_mark_and_type_of_victim_driver` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_merantile_value_loss` - Merkantile Wertminderung
 * * `law.traffic_law_net_gross_replacement_value` - Netto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_net_replacement_value` - Nettowiederbeschaffungswert
 * * `law.traffic_law_number_of_daily_rates` - Anzahl der Tagessätze
 * * `law.traffic_law_offense_infraction_description` - Tatbestand
 * * `law.traffic_law_other_damages` - Andere Sachschäden
 * * `law.traffic_law_payment_deadline` - Zahlungsfrist
 * * `law.traffic_law_penalty_order` - Strafbefehl
 * * `law.traffic_law_place_of_accident` - Unfallort
 * * `law.traffic_law_place_of_crime` - Ort der Tat
 * * `law.traffic_law_place_of_infraction` - Ort der Ordnungswidrigkeit
 * * `law.traffic_law_place_of_inspection` - Besichtigungsort
 * * `law.traffic_law_place_of_issue` - Ort der Ausstellung
 * * `law.traffic_law_place_of_offense` - Ort der Tat
 * * `law.traffic_law_points_for_offense` - Punkte
 * * `law.traffic_law_police_case_number` - Polizeiliches Aktenzeichen
 * * `law.traffic_law_procedure_costs` - Verfahrenskosten
 * * `law.traffic_law_prosecution_number` - Geschäftsnummer
 * * `law.traffic_law_regular_tax` - Regelsteuer
 * * `law.traffic_law_repair_costs_with_vat` - Reparaturkosten Brutto
 * * `law.traffic_law_repair_costs_without_vat` - Reparaturkosten Netto
 * * `law.traffic_law_repair_damage` - Reparaturschaden
 * * `law.traffic_law_repair_duration` - Reparaturdauer Tage
 * * `law.traffic_law_replacement_cost` - Wiederbeschaffungsaufwand
 * * `law.traffic_law_replacement_value` - Wiederbeschaffungswert
 * * `law.traffic_law_reregistration_cost` - Ummeldekosten
 * * `law.traffic_law_residual_value` - Restwert Brutto
 * * `law.traffic_law_speed_allowed` - Erlaubte Geschwindigkeit
 * * `law.traffic_law_speed_driven` - Gefahrene Geschwindigkeit
 * * `law.traffic_law_speed_too_high` - Überschreitung Geschwindigkeit
 * * `law.traffic_law_time_of_accident` - Uhrzeit Unfall
 * * `law.traffic_law_time_of_crime` - Uhrzeit der Tat
 * * `law.traffic_law_time_of_infraction` - Uhrzeit der Ordnungswidrigkeit
 * * `law.traffic_law_time_of_inspection` - Besichtigungszeit
 * * `law.traffic_law_time_of_issue` - Tag der Ausstellung
 * * `law.traffic_law_time_of_offense` - Uhrzeit der Tat
 * * `law.traffic_law_total_damage` - Totalschaden
 * * `law.traffic_law_value_improvement` - Wertverbesserung
 * * `law.traffic_law_vehicle_age_months` - Fahrzeugalter in Monaten
 * * `law.traffic_law_vehicle_mileage` - Fahrzeugleistung in km
 * * `law.traffic_law_vehicle_type_and_brand` - Fahrzeugtyp und Marke
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - Unfallgeschädigter - Führerschein ausgestellt durch
 * * `law.traffic_law_victim_driver_green_card_number` - Unfallgeschädigter - Nr. der Grünen Karte
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - Unfallgeschädigter - Vers.-Schein gültig bis
 * * `law.traffic_law_victim_driver_insurance_number` - Unfallgeschädigter - Vers.-Nr.
 * * `law.traffic_law_victim_driver_insurer` - Unfallgeschädigter - Versicherer
 * * `law.traffic_law_victim_driver_license_valid_until` - Unfallgeschädigter - Führerschein gültig bis
 * * `law.traffic_law_violated_section` - Verletzte Vorschrift
 * * `law.traffic_law_violation_type` - Tatvorwurf
 * * `law.traffic_law_warning_fee_infraction` - Verwarnungsgeldbetrag
 * * `law.traffic_law_warning_notice` - Verwarnungsgeldbescheid
 */
export type QuestionnaireQuestionTagEnum = 'entities.field.address_line_2' | 'entities.field.bank_name' | 'entities.field.bic' | 'entities.field.city' | 'entities.field.company_legal_form' | 'entities.field.company_name' | 'entities.field.company_register_court' | 'entities.field.company_register_number' | 'entities.field.company_tax_id' | 'entities.field.company_vat_id' | 'entities.field.date_of_birth' | 'entities.field.date_of_death' | 'entities.field.email' | 'entities.field.entity_type' | 'entities.field.fax' | 'entities.field.first_name' | 'entities.field.iban' | 'entities.field.institution_name' | 'entities.field.is_entitled_to_deduct_vat' | 'entities.field.is_valid_email' | 'entities.field.is_valid_phone_number' | 'entities.field.last_name' | 'entities.field.legal_insurance_deductible_amount' | 'entities.field.legal_insurance' | 'entities.field.legal_insurance_name' | 'entities.field.legal_insurance_number' | 'entities.field.marital_status' | 'entities.field.phone' | 'entities.field.specific_title' | 'entities.field.street' | 'entities.field.street_number' | 'entities.field.title' | 'entities.field.website' | 'entities.field.zip' | 'law.civil_law_accessories_sold_separately' | 'law.civil_law_case_number' | 'law.civil_law_claim_amount' | 'law.civil_law_contract_date' | 'law.civil_law_contract_duration' | 'law.civil_law_contract_end_date' | 'law.civil_law_contract' | 'law.civil_law_contract_object' | 'law.civil_law_contract_start_date' | 'law.civil_law_contract_value' | 'law.civil_law_correspondence' | 'law.civil_law_court_costs' | 'law.civil_law_court_document' | 'law.civil_law_court_name' | 'law.civil_law_damage_amount' | 'law.civil_law_damage_cause' | 'law.civil_law_damage_claim' | 'law.civil_law_damage_date' | 'law.civil_law_damage_description' | 'law.civil_law_default_interest' | 'law.civil_law_defects' | 'law.civil_law_defects_present' | 'law.civil_law_delivery_date' | 'law.civil_law_document_date' | 'law.civil_law_file_reference' | 'law.civil_law_handover_date' | 'law.civil_law_hearing_date' | 'law.civil_law_insurance_claim_number' | 'law.civil_law_interest_rate' | 'law.civil_law_judgment_date' | 'law.civil_law_liability_percentage' | 'law.civil_law_notarial_certification_date' | 'law.civil_law_payment_due_date' | 'law.civil_law_purchase_agreement' | 'law.civil_law_purchase_contract_file_reference' | 'law.civil_law_purchase_date' | 'law.civil_law_purchase_object' | 'law.civil_law_purchase_price_components' | 'law.civil_law_purchase_price' | 'law.civil_law_purchase_price_paid_amount' | 'law.civil_law_purchase_price_paid_boolean' | 'law.civil_law_purchase_price_paid_date' | 'law.civil_law_purchase_price_paid' | 'law.civil_law_purchase_price_payment_date' | 'law.civil_law_subject_line' | 'law.civil_law_termination_notice_period' | 'law.civil_law_vehicle_make' | 'law.civil_law_vehicle_mileage' | 'law.civil_law_vehicle_model' | 'law.civil_law_vehicle_vin' | 'law.civil_law_vehicle_year' | 'law.civil_law_warranty_period' | 'law.criminal_law_amount_of_daily_rates' | 'law.criminal_law_applicable_laws' | 'law.criminal_law_charge_description' | 'law.criminal_law_complaint' | 'law.criminal_law_criminal_warrant' | 'law.criminal_law_damage_description' | 'law.criminal_law_damage_value' | 'law.criminal_law_date_of_offense' | 'law.criminal_law_duration_of_prison_sentence' | 'law.criminal_law_evidence_location' | 'law.criminal_law_evidence' | 'law.criminal_law_incident_description' | 'law.criminal_law_indictment_date' | 'law.criminal_law_indictment_delivery_date' | 'law.criminal_law_indictment' | 'law.criminal_law_legal_classification_of_offense' | 'law.criminal_law_means_of_evidence' | 'law.criminal_law_number_of_daily_rates' | 'law.criminal_law_offense_type' | 'law.criminal_law_penalty_infromation' | 'law.criminal_law_physical_evidence' | 'law.criminal_law_place_of_offense' | 'law.criminal_law_police_file_number' | 'law.criminal_law_preliminary_proceedings_date' | 'law.criminal_law_prison_sentence' | 'law.criminal_law_probation' | 'law.criminal_law_prosecution_file_number' | 'law.criminal_law_report_date' | 'law.criminal_law_report_time' | 'law.criminal_law_time_of_offense' | 'law.debt_collection_law_business_fee' | 'law.debt_collection_law_case_value' | 'law.debt_collection_law_invoice_amount' | 'law.debt_collection_law_invoice_date' | 'law.debt_collection_law_invoice_ground' | 'law.debt_collection_law_invoice_lawyer' | 'law.debt_collection_law_invoice' | 'law.debt_collection_law_invoice_number' | 'law.debt_collection_law_invoice_recipient' | 'law.debt_collection_law_invoice_tax_number' | 'law.debt_collection_law_lumps_sum_expenses' | 'law.debt_collection_law_sales_tax' | 'law.debt_collection_law_subtotal_lawyer_fees' | 'law.debt_collection_law_total_amount' | 'law.external_case_id' | 'law.family_law_average_net_income' | 'law.family_law_birth_certificate' | 'law.family_law_birth_register_number' | 'law.family_law_birth_register_office_location' | 'law.family_law_children' | 'law.family_law_date_of_marriage' | 'law.family_law_divorce_application' | 'law.family_law_divorce_settlement_agreement' | 'law.family_law_marriage_certificate' | 'law.family_law_marriage_contract_date' | 'law.family_law_marriage_contract' | 'law.family_law_marriage_register_number' | 'law.family_law_registry_office_location' | 'law.family_law_separation_date' | 'law.field' | 'law.general_law_amount_net' | 'law.general_law_amount_total' | 'law.general_law_appendices' | 'law.general_law_case_number' | 'law.general_law_court_costs' | 'law.general_law_court_name' | 'law.general_law_doc_date' | 'law.general_law_due_date' | 'law.general_law_file_ref' | 'law.general_law_hearing_date' | 'law.general_law_invoice_date' | 'law.general_law_invoice_number' | 'law.general_law_judgment_date' | 'law.general_law_correspondence' | 'law.general_law_court_document' | 'law.general_law_invoice' | 'law.general_law_payment_terms' | 'law.general_law_prior_ref' | 'law.general_law_subject' | 'law.general_law_vat' | 'law.generic_document' | 'law.inheritance_law_certificate_of_inheritance_applicable_law' | 'law.inheritance_law_certificate_of_inheritance_date_death' | 'law.inheritance_law_certificate_of_inheritance_date' | 'law.inheritance_law_certificate_of_inheritance' | 'law.inheritance_law_certificate_of_inheritance_number' | 'law.inheritance_law_certificate_of_inheritance_place_of_death' | 'law.inheritance_law_death_certificate_date_death' | 'law.inheritance_law_death_certificate_date' | 'law.inheritance_law_death_certificate' | 'law.inheritance_law_death_certificate_number' | 'law.inheritance_law_death_certificate_place_death' | 'law.inheritance_law_death_certificate_place' | 'law.inheritance_law_death_certificate_time_death' | 'law.inheritance_law_estate_inventory_amount' | 'law.inheritance_law_estate_inventory_date' | 'law.inheritance_law_estate_inventory_status' | 'law.inheritance_law_inheritance_contract_date' | 'law.inheritance_law_inheritance_contract' | 'law.inheritance_law_lasting_power_of_attorney_date' | 'law.inheritance_law_lasting_power_of_attorney' | 'law.inheritance_law_list_of_estate' | 'law.inheritance_law_living_will' | 'law.inheritance_law_patient_enrollment_date' | 'law.inheritance_law_testament_date' | 'law.inheritance_law_will' | 'law.labor_law_amount_dependent_children' | 'law.labor_law_beginning_of_employment' | 'law.labor_law_certificate_clause' | 'law.labor_law_child_allowances' | 'law.labor_law_collective_agreement' | 'law.labor_law_company_agreement' | 'law.labor_law_company_hearing' | 'law.labor_law_dependent_children' | 'law.labor_law_different_place_of_work' | 'law.labor_law_disability' | 'law.labor_law_employee_probation_period_end_date' | 'law.labor_law_end_of_employment' | 'law.labor_law_exemption_irrevocable' | 'law.labor_law_exemption_revocable' | 'law.labor_law_fixed_term_contract_duration' | 'law.labor_law_fixed_term_contract' | 'law.labor_law_grade_certificate_clause' | 'law.labor_law_is_employee_in_probation_period' | 'law.labor_law_job_title' | 'law.labor_law_local_transfer_clause' | 'law.labor_law_LTI' | 'law.labor_law_married' | 'law.labor_law_monthly_gross_salary' | 'law.labor_law_monthly_working_days' | 'law.labor_law_notice_period' | 'law.labor_law_notice_period_observed' | 'law.labor_law_payslip' | 'law.labor_law_percent_sprinter_clause' | 'law.labor_law_place_of_work' | 'law.labor_law_pregnancy' | 'law.labor_law_reaction_company_hering' | 'law.labor_law_reason_for_termination_given' | 'law.labor_law_return_of_company_property' | 'law.labor_law_settlement_agreement_date' | 'law.labor_law_settlement_agreement' | 'law.labor_law_severance_amount' | 'law.labor_law_signature_of_employer' | 'law.labor_law_special_documents' | 'law.labor_law_special_payments_amount' | 'law.labor_law_special_payments' | 'law.labor_law_special_personal_circumstances' | 'law.labor_law_special_protection_against_dismissal' | 'law.labor_law_special_sentence' | 'law.labor_law_sprinter_clause' | 'law.labor_law_termination_access_to_termination_to_employee' | 'law.labor_law_termination_agreement_date' | 'law.labor_law_termination_agreement' | 'law.labor_law_termination_agreement_severance_pay_amount' | 'law.labor_law_termination_agreement_termination_date' | 'law.labor_law_termination_authorization' | 'law.labor_law_termination_date_effective' | 'law.labor_law_termination_date' | 'law.labor_law_termination_employer_more_than_10_employees' | 'law.labor_law_termination_is_agreement_severance_pay' | 'law.labor_law_termination' | 'law.labor_law_termination_operational_reasons' | 'law.labor_law_termination_without_notice' | 'law.labor_law_total_gross_salary' | 'law.labor_law_vacation_days' | 'law.labor_law_visum' | 'law.labor_law_VSOP' | 'law.labor_law_warning_letter_access_to_warning_letter_to_employee' | 'law.labor_law_warning_letter_date' | 'law.labor_law_warning_letter_incident_date' | 'law.labor_law_warning_letter_incident_location' | 'law.labor_law_warning_letter_incident_time' | 'law.labor_law_warning_letter' | 'law.labor_law_warning_letter_reason' | 'law.labor_law_work_contract' | 'law.labor_law_work_council' | 'law.labor_law_work_hours_per_week' | 'law.labor_law_works_council_membership' | 'law.labor_law_yearly_gross_salary' | 'law.labor_law_years_of_employment' | 'law.medicine_law_health_insurance_letter_date' | 'law.medicine_law_health_insurance_letter_decision_justification' | 'law.medicine_law_health_insurance_letter_decision' | 'law.medicine_law_health_insurance_letter_legal_remedy_instruction' | 'law.medicine_law_health_insurance_letter' | 'law.medicine_law_health_insurance_letter_reference_to_application' | 'law.medicine_law_hospital_records_admission_date' | 'law.medicine_law_hospital_records_diagnoses_icd_codes' | 'law.medicine_law_hospital_records_discharge_date' | 'law.medicine_law_hospital_records_discharge_prognosis' | 'law.medicine_law_hospital_records_documented_complications' | 'law.medicine_law_hospital_records' | 'law.medicine_law_hospital_records_medication_during_stay' | 'law.medicine_law_hospital_records_operation_date' | 'law.medicine_law_hospital_records_operations' | 'law.medicine_law_hospital_records_station' | 'law.medicine_law_laboratory_results_examination_date' | 'law.medicine_law_laboratory_results_examination_type' | 'law.medicine_law_laboratory_results_further_investigation_recommendation' | 'law.medicine_law_laboratory_results' | 'law.medicine_law_laboratory_results_relevant_deviations' | 'law.medicine_law_medical_bill_cost_bearer' | 'law.medicine_law_medical_bill_invoice_date' | 'law.medicine_law_medical_bill_invoice_number' | 'law.medicine_law_medical_bill' | 'law.medicine_law_medical_bill_payment_deadline' | 'law.medicine_law_medical_bill_service_period' | 'law.medicine_law_medical_bill_services_list' | 'law.medicine_law_medical_bill_total_amount' | 'law.medicine_law_medical_expertise_date' | 'law.medicine_law_medical_expertise_justification' | 'law.medicine_law_medical_expertise' | 'law.medicine_law_medical_expertise_medical_assessment' | 'law.medicine_law_medical_expertise_question_posed' | 'law.medicine_law_medical_expertise_result' | 'law.medicine_law_medical_report_complications' | 'law.medicine_law_medical_report_date' | 'law.medicine_law_medical_report_diagnosis_icd_code' | 'law.medicine_law_medical_report_diagnosis_short_text' | 'law.medicine_law_medical_report_further_treatment' | 'law.medicine_law_medical_report' | 'law.medicine_law_medical_report_surgery_date' | 'law.medicine_law_medical_report_treatment_measures' | 'law.medicine_law_medical_report_treatment_period' | 'law.migration_law_approval_notice_case_number' | 'law.migration_law_approval_notice_conditions' | 'law.migration_law_approval_notice_decision_date' | 'law.migration_law_approval_notice_issuing_authority' | 'law.migration_law_approval_notice' | 'law.migration_law_approval_notice_permit_type' | 'law.migration_law_approval_notice_pickup_deadline' | 'law.migration_law_approval_notice_validity_period' | 'law.migration_law_asylum_seeker_certificate_application_number' | 'law.migration_law_asylum_seeker_certificate_first_registration_date' | 'law.migration_law_asylum_seeker_certificate_issue_date' | 'law.migration_law_asylum_seeker_certificate_issuing_authority' | 'law.migration_law_asylum_seeker_certificate' | 'law.migration_law_asylum_seeker_certificate_residence_obligation' | 'law.migration_law_asylum_seeker_certificate_valid_until' | 'law.migration_law_asylum_seeker_certificate_work_permission' | 'law.migration_law_cooperation_letter_attachments' | 'law.migration_law_cooperation_letter_date' | 'law.migration_law_cooperation_letter_deadlines' | 'law.migration_law_cooperation_letter_file_number' | 'law.migration_law_cooperation_letter' | 'law.migration_law_cooperation_letter_non_cooperation_consequences' | 'law.migration_law_cooperation_letter_specified_obligations' | 'law.migration_law_fictional_certificate_authority' | 'law.migration_law_fictional_certificate_fiction_type' | 'law.migration_law_fictional_certificate_issue_date' | 'law.migration_law_fictional_certificate_legal_basis' | 'law.migration_law_fictional_certificate' | 'law.migration_law_fictional_certificate_reason_for_issuance' | 'law.migration_law_fictional_certificate_valid_until' | 'law.migration_law_hearing_letter_date' | 'law.migration_law_hearing_letter_intended_measure_justification' | 'law.migration_law_hearing_letter_legal_advice' | 'law.migration_law_hearing_letter' | 'law.migration_law_hearing_letter_requested_documents' | 'law.migration_law_hearing_letter_response_deadline' | 'law.migration_law_other_letters_action_required' | 'law.migration_law_other_letters_date' | 'law.migration_law_other_letters_deadlines' | 'law.migration_law_other_letters_file_number' | 'law.migration_law_other_letters_issuing_authority' | 'law.migration_law_other_letters_legal_basis' | 'law.migration_law_other_letters' | 'law.migration_law_other_letters_matter_purpose' | 'law.migration_law_other_letters_subject' | 'law.migration_law_rejection_notice_case_number' | 'law.migration_law_rejection_notice_decision_date' | 'law.migration_law_rejection_notice_legal_grounds' | 'law.migration_law_rejection_notice_legal_remedy_deadline' | 'law.migration_law_rejection_notice' | 'law.migration_law_rejection_notice_officer_name' | 'law.migration_law_rejection_notice_reasoning' | 'law.migration_law_rejection_notice_signature_seal' | 'law.migration_law_rejection_notice_subject' | 'law.migration_law_residence_permit_conditions' | 'law.migration_law_residence_permit_issue_date' | 'law.migration_law_residence_permit_issuing_authority' | 'law.migration_law_residence_permit' | 'law.migration_law_residence_permit_national_id_number' | 'law.migration_law_residence_permit_passport_number' | 'law.migration_law_residence_permit_purpose' | 'law.migration_law_residence_permit_type' | 'law.migration_law_residence_permit_valid_until' | 'law.migration_law_toleration_issue_date' | 'law.migration_law_toleration_issuing_authority' | 'law.migration_law_toleration_legal_basis' | 'law.migration_law_toleration' | 'law.migration_law_toleration_reason' | 'law.migration_law_toleration_restrictions' | 'law.migration_law_toleration_valid_until' | 'law.real_estate_law_basic_debts_amount' | 'law.real_estate_law_broker_commission_amount' | 'law.real_estate_law_broker_contract_type' | 'law.real_estate_law_broker_scope_of_work' | 'law.real_estate_law_broker_termination_periods' | 'law.real_estate_law_brokerage_contract_date' | 'law.real_estate_law_brokerage_contract' | 'law.real_estate_law_brokerage_fee' | 'law.real_estate_law_building_dimensions' | 'law.real_estate_law_building_permit_date' | 'law.real_estate_law_building_permit' | 'law.real_estate_law_building_permit_number' | 'law.real_estate_law_building_permit_validity_duration' | 'law.real_estate_law_building_plan' | 'law.real_estate_law_building_restrictions_clause' | 'law.real_estate_law_building_usage' | 'law.real_estate_law_co_ownership_share' | 'law.real_estate_law_commission_percentage' | 'law.real_estate_law_contaminated_sites_clause' | 'law.real_estate_law_declaration_of_division' | 'law.real_estate_law_division_declaration_date' | 'law.real_estate_law_encumbrance_restrictions' | 'law.real_estate_law_encumbrances_section_ii' | 'law.real_estate_law_encumbrances_section_iii' | 'law.real_estate_law_exclusive_brokerage_contract' | 'law.real_estate_law_full_repayment_date' | 'law.real_estate_law_installment_amount' | 'law.real_estate_law_interest_rate' | 'law.real_estate_law_land_register_address' | 'law.real_estate_law_land_register_city' | 'law.real_estate_law_land_register_date' | 'law.real_estate_law_land_register' | 'law.real_estate_law_land_register_number' | 'law.real_estate_law_land_register_plot_of_land' | 'law.real_estate_law_legal_defects_clause' | 'law.real_estate_law_loan_agreement' | 'law.real_estate_law_loan_amount' | 'law.real_estate_law_loan_security' | 'law.real_estate_law_monument_protection_basis' | 'law.real_estate_law_monument_protection_notice' | 'law.real_estate_law_monument_protection_order_date' | 'law.real_estate_law_monument_protection_order_number' | 'law.real_estate_law_monument_protection_requirements' | 'law.real_estate_law_monument_registration_date' | 'law.real_estate_law_plan_author' | 'law.real_estate_law_plan_designation' | 'law.real_estate_law_plan_scale' | 'law.real_estate_law_plot_size' | 'law.real_estate_law_property_brokered_by_agent' | 'law.real_estate_law_purchase_contract_amount' | 'law.real_estate_law_purchase_contract_date' | 'law.real_estate_law_purchase_contract_description' | 'law.real_estate_law_purchase_contract' | 'law.real_estate_law_purchase_contract_registration_date' | 'law.real_estate_law_purchase_contract_registration_number' | 'law.real_estate_law_purchase_object_rented' | 'law.real_estate_law_purchase_price_loan_financed' | 'law.real_estate_law_repayment_rate' | 'law.real_estate_law_withdrawal_instruction_date' | 'law.residential_property_law_co_ownership_shares' | 'law.residential_property_law_contract_date' | 'law.residential_property_law_contract' | 'law.residential_property_law_inventory' | 'law.residential_property_law_land_register_address' | 'law.residential_property_law_land_register_city' | 'law.residential_property_law_land_register_number' | 'law.residential_property_law_land_register_plot_of_land' | 'law.social_law_affected_benefit' | 'law.social_law_application_arrival_date' | 'law.social_law_application_date' | 'law.social_law_application_file_reference' | 'law.social_law_application_form' | 'law.social_law_appointment_date' | 'law.social_law_appointment_file_reference' | 'law.social_law_appointment_invitation' | 'law.social_law_appointment_purpose' | 'law.social_law_appointment_required_documents' | 'law.social_law_appointment_time' | 'law.social_law_approval_file_reference' | 'law.social_law_approval_internal_reference' | 'law.social_law_approval_legal_basis' | 'law.social_law_approval_notice_date' | 'law.social_law_approval_notice' | 'law.social_law_approval_period_end' | 'law.social_law_approval_period_start' | 'law.social_law_approved_benefit_amount' | 'law.social_law_approved_benefit_period' | 'law.social_law_approved_benefit_type' | 'law.social_law_asset_type' | 'law.social_law_attachment_list' | 'law.social_law_benefit_type' | 'law.social_law_change_description' | 'law.social_law_change_file_reference' | 'law.social_law_change_notification_date' | 'law.social_law_change_notification' | 'law.social_law_change_reason' | 'law.social_law_creditable_income' | 'law.social_law_disability_card_issue_date' | 'law.social_law_disability_card' | 'law.social_law_disability_card_markers' | 'law.social_law_disability_card_validity_period' | 'law.social_law_disability_degree' | 'law.social_law_disability_file_reference' | 'law.social_law_employment_income' | 'law.social_law_follow_up_application_notes' | 'law.social_law_hearing_file_reference' | 'law.social_law_hearing_letter_date' | 'law.social_law_hearing_letter' | 'law.social_law_hearing_planned_administrative_act' | 'law.social_law_housing_costs_amount' | 'law.social_law_income_amount' | 'law.social_law_income_date' | 'law.social_law_income_legal_basis' | 'law.social_law_income_provider' | 'law.social_law_income_source' | 'law.social_law_income_type' | 'law.social_law_interim_legal_protection' | 'law.social_law_interim_protection_affidavit' | 'law.social_law_interim_protection_attachment_list' | 'law.social_law_interim_protection_file_reference' | 'law.social_law_interim_protection_request_date' | 'law.social_law_interim_protection_request_text' | 'law.social_law_interim_protection_urgency_reason' | 'law.social_law_lawsuit_alternative_request' | 'law.social_law_lawsuit_attachment_list' | 'law.social_law_lawsuit_cost_request' | 'law.social_law_lawsuit_court_file_number' | 'law.social_law_lawsuit_delivery_date' | 'law.social_law_lawsuit_dispute_value' | 'law.social_law_lawsuit_disputed_amount' | 'law.social_law_lawsuit_evidence_requests' | 'law.social_law_lawsuit_file_reference' | 'law.social_law_lawsuit_filing_date' | 'law.social_law_lawsuit_income_amount' | 'law.social_law_lawsuit_legal_basis' | 'law.social_law_lawsuit_main_request' | 'law.social_law_lawsuit' | 'law.social_law_lawsuit_monthly_benefit_amount' | 'law.social_law_lawsuit_objection_decision_date' | 'law.social_law_lawsuit_objection_filing_date' | 'law.social_law_lawsuit_original_decision_date' | 'law.social_law_lawsuit_subject' | 'law.social_law_lawsuit_type' | 'law.social_law_legal_basis' | 'law.social_law_medical_certificate' | 'law.social_law_medical_diagnosis' | 'law.social_law_medical_examination_date' | 'law.social_law_medical_file_reference' | 'law.social_law_medical_icd_code' | 'law.social_law_medical_limitations' | 'law.social_law_medical_prognosis' | 'law.social_law_medical_work_capacity_relation' | 'law.social_law_monthly_payment_amount' | 'law.social_law_needs_cost_breakdown' | 'law.social_law_needs_file_reference' | 'law.social_law_needs_proof_basis' | 'law.social_law_needs_proof_date' | 'law.social_law_needs_proof' | 'law.social_law_needs_type' | 'law.social_law_notice_date' | 'law.social_law_notice_of_objection_date' | 'law.social_law_notice_of_objection_file_reference' | 'law.social_law_notice_of_objection' | 'law.social_law_notification_date' | 'law.social_law_notification_legal_basis' | 'law.social_law_notification_source' | 'law.social_law_objection_challenged_notice' | 'law.social_law_objection_date' | 'law.social_law_objection_evidence' | 'law.social_law_objection_file_reference' | 'law.social_law_objection' | 'law.social_law_objection_reasoning' | 'law.social_law_objection_suspension_request' | 'law.social_law_original_decision_date' | 'law.social_law_other_income' | 'law.social_law_own_income_amount' | 'law.social_law_reclaim_amount' | 'law.social_law_reclaim_file_reference' | 'law.social_law_reclaim_legal_basis' | 'law.social_law_reclaim_legal_norm' | 'law.social_law_reclaim_notice_date' | 'law.social_law_reclaim_notice' | 'law.social_law_reclaim_payment_deadline' | 'law.social_law_reclaim_payment_terms' | 'law.social_law_regelbedarf_amount' | 'law.social_law_rejection_file_reference' | 'law.social_law_rejection_legal_norm' | 'law.social_law_rejection_notice_date' | 'law.social_law_rejection_notice' | 'law.social_law_rejection_reason' | 'law.social_law_residence_status' | 'law.social_law_revocation_benefit_type' | 'law.social_law_revocation_file_reference' | 'law.social_law_revocation_legal_norm' | 'law.social_law_revocation_notice_date' | 'law.social_law_revocation_notice' | 'law.social_law_revocation_period_end' | 'law.social_law_revocation_period_start' | 'law.social_law_revocation_reason' | 'law.social_law_revocation_reclaim_notes' | 'law.social_law_social_benefit_type' | 'law.social_law_summary_grounds_opposition' | 'law.social_law_total_need_amount' | 'law.social_law_total_reclaim_amount' | 'law.social_law_violation_type' | 'law.tenancy_law_adress_rental_property' | 'law.tenancy_law_advance_payment_service_charge' | 'law.tenancy_law_advance_payment_service_charges' | 'law.tenancy_law_bank_guarantee' | 'law.tenancy_law_cash_deposit_agreed' | 'law.tenancy_law_cash_deposit_payment_date' | 'law.tenancy_law_competent_court' | 'law.tenancy_law_cost_share' | 'law.tenancy_law_cost_shares' | 'law.tenancy_law_counter_number' | 'law.tenancy_law_court_case_number' | 'law.tenancy_law_court_proceedings_pending' | 'law.tenancy_law_description_of_rental_property' | 'law.tenancy_law_duration_of_lease' | 'law.tenancy_law_expert_report_commission_date' | 'law.tenancy_law_expert_report_damage_description' | 'law.tenancy_law_expert_report_damage_number' | 'law.tenancy_law_expert_report_date' | 'law.tenancy_law_expert_report_inspection_date' | 'law.tenancy_law_expert_report' | 'law.tenancy_law_expert_report_object_address' | 'law.tenancy_law_expert_report_purpose' | 'law.tenancy_law_expert_report_repair_duration' | 'law.tenancy_law_expert_report_subject' | 'law.tenancy_law_extension_option_count' | 'law.tenancy_law_extension_option_duration' | 'law.tenancy_law_fixed_term_tenancy' | 'law.tenancy_law_garage_available' | 'law.tenancy_law_garage_costs' | 'law.tenancy_law_general_status_documents' | 'law.tenancy_law_gross_rent' | 'law.tenancy_law_handover_counter' | 'law.tenancy_law_handover_date' | 'law.tenancy_law_handover_defects' | 'law.tenancy_law_handover_protocol' | 'law.tenancy_law_landlord_termination_given' | 'law.tenancy_law_last_rent_increase_letter_date' | 'law.tenancy_law_last_signature_date' | 'law.tenancy_law_lease_agreement' | 'law.tenancy_law_location_in_rental_property' | 'law.tenancy_law_net_rent' | 'law.tenancy_law_operating_costs_agreement' | 'law.tenancy_law_parking_space_available' | 'law.tenancy_law_parking_space_costs' | 'law.tenancy_law_property_return_date' | 'law.tenancy_law_rent_increase_effective_date' | 'law.tenancy_law_rent_increase_notice' | 'law.tenancy_law_rental_agreement_date' | 'law.tenancy_law_rental_agreement_duration' | 'law.tenancy_law_rental_agreement' | 'law.tenancy_law_rental_agreement_validity_end' | 'law.tenancy_law_rental_agreement_validity_start' | 'law.tenancy_law_rental_object_size_sqm' | 'law.tenancy_law_repayment' | 'law.tenancy_law_repayment_period_end' | 'law.tenancy_law_repayment_period_start' | 'law.tenancy_law_security_deposit_additional_regulations' | 'law.tenancy_law_security_deposit_amount' | 'law.tenancy_law_service_charge_settlement' | 'law.tenancy_law_staggered_rental_agreement' | 'law.tenancy_law_start_of_lease' | 'law.tenancy_law_tenancy_terminated' | 'law.tenancy_law_tenancy_termination_date' | 'law.tenancy_law_tenant_extension_option' | 'law.tenancy_law_tenant_warned' | 'law.tenancy_law_termination_declared_date' | 'law.tenancy_law_termination_letter_date' | 'law.tenancy_law_termination_notice' | 'law.tenancy_law_termination_notice_period' | 'law.tenancy_law_total_cost_service_charge' | 'law.tenancy_law_total_rent' | 'law.tenancy_law_unlimited_term_tenancy' | 'law.tenancy_law_value_security_clause' | 'law.tenancy_law_warning_letter_date' | 'law.tenancy_law_warning_letter' | 'law.topic' | 'law.traffic_law_accident_date' | 'law.traffic_law_accident_report' | 'law.traffic_law_amount_of_fine' | 'law.traffic_law_appeal_instruction' | 'law.traffic_law_at_fault_driver_drivers_license_issued_by' | 'law.traffic_law_at_fault_driver_drivers_license_valid_until' | 'law.traffic_law_at_fault_driver_green_card_number' | 'law.traffic_law_at_fault_driver_insurance_expiry_date' | 'law.traffic_law_at_fault_driver_insurance_number' | 'law.traffic_law_at_fault_driver_insurer' | 'law.traffic_law_blood_alcohol_concentration' | 'law.traffic_law_calculated_total_damage_costs' | 'law.traffic_law_calculated_total_days' | 'law.traffic_law_charges' | 'law.traffic_law_cost_per_scale' | 'law.traffic_law_daily_rate' | 'law.traffic_law_damage_amount_net' | 'law.traffic_law_damage_number' | 'law.traffic_law_damage_scope' | 'law.traffic_law_date_of_accident' | 'law.traffic_law_date_of_crime' | 'law.traffic_law_date_of_fine' | 'law.traffic_law_date_of_infraction' | 'law.traffic_law_date_of_inspection' | 'law.traffic_law_date_of_issue' | 'law.traffic_law_date_of_offense' | 'law.traffic_law_date_of_report' | 'law.traffic_law_differencial_tax' | 'law.traffic_law_driver_logbook_required' | 'law.traffic_law_driving_ban_duration' | 'law.traffic_law_driving_ban' | 'law.traffic_law_evidence_infraction' | 'law.traffic_law_expert_cost' | 'law.traffic_law_expert_date' | 'law.traffic_law_expert_report' | 'law.traffic_law_expert_report_number' | 'law.traffic_law_file_number' | 'law.traffic_law_fine' | 'law.traffic_law_fine_notice' | 'law.traffic_law_gross_gross_replacement_value' | 'law.traffic_law_gross_replacement_value' | 'law.traffic_law_injured' | 'law.traffic_law_insurance_holder' | 'law.traffic_law_insurance' | 'law.traffic_law_insurance_policy_number' | 'law.traffic_law_legal_basis_infraction' | 'law.traffic_law_legal_basis' | 'law.traffic_law_licenseplate_at_fault_driver' | 'law.traffic_law_licenseplate' | 'law.traffic_law_licenseplate_victim_driver' | 'law.traffic_law_loss_amount_repair_case' | 'law.traffic_law_loss_amount_total_damage_case' | 'law.traffic_law_loss_of_use_per_day' | 'law.traffic_law_mark_and_type_of_at_fault_driver' | 'law.traffic_law_mark_and_type_of_victim_driver' | 'law.traffic_law_merantile_value_loss' | 'law.traffic_law_net_gross_replacement_value' | 'law.traffic_law_net_replacement_value' | 'law.traffic_law_number_of_daily_rates' | 'law.traffic_law_offense_infraction_description' | 'law.traffic_law_other_damages' | 'law.traffic_law_payment_deadline' | 'law.traffic_law_penalty_order' | 'law.traffic_law_place_of_accident' | 'law.traffic_law_place_of_crime' | 'law.traffic_law_place_of_infraction' | 'law.traffic_law_place_of_inspection' | 'law.traffic_law_place_of_issue' | 'law.traffic_law_place_of_offense' | 'law.traffic_law_points_for_offense' | 'law.traffic_law_police_case_number' | 'law.traffic_law_procedure_costs' | 'law.traffic_law_prosecution_number' | 'law.traffic_law_regular_tax' | 'law.traffic_law_repair_costs_with_vat' | 'law.traffic_law_repair_costs_without_vat' | 'law.traffic_law_repair_damage' | 'law.traffic_law_repair_duration' | 'law.traffic_law_replacement_cost' | 'law.traffic_law_replacement_value' | 'law.traffic_law_reregistration_cost' | 'law.traffic_law_residual_value' | 'law.traffic_law_speed_allowed' | 'law.traffic_law_speed_driven' | 'law.traffic_law_speed_too_high' | 'law.traffic_law_time_of_accident' | 'law.traffic_law_time_of_crime' | 'law.traffic_law_time_of_infraction' | 'law.traffic_law_time_of_inspection' | 'law.traffic_law_time_of_issue' | 'law.traffic_law_time_of_offense' | 'law.traffic_law_total_damage' | 'law.traffic_law_value_improvement' | 'law.traffic_law_vehicle_age_months' | 'law.traffic_law_vehicle_mileage' | 'law.traffic_law_vehicle_type_and_brand' | 'law.traffic_law_victim_driver_drivers_license_issued_by' | 'law.traffic_law_victim_driver_green_card_number' | 'law.traffic_law_victim_driver_insurance_expiry_date' | 'law.traffic_law_victim_driver_insurance_number' | 'law.traffic_law_victim_driver_insurer' | 'law.traffic_law_victim_driver_license_valid_until' | 'law.traffic_law_violated_section' | 'law.traffic_law_violation_type' | 'law.traffic_law_warning_fee_infraction' | 'law.traffic_law_warning_notice';

/**
 * * `entities.field.address_line_2` - Adresszusatz
 * * `entities.field.bank_name` - Bankname
 * * `entities.field.bic` - BIC
 * * `entities.field.city` - Ort
 * * `entities.field.company_legal_form` - Rechtsform
 * * `entities.field.company_name` - Firmenname
 * * `entities.field.company_register_court` - Amtsgericht
 * * `entities.field.company_register_number` - Handelsregisternummer
 * * `entities.field.company_tax_id` - Steuernummer
 * * `entities.field.company_vat_id` - USt. ID
 * * `entities.field.date_of_birth` - Geburtsdatum
 * * `entities.field.date_of_death` - Sterbedatum
 * * `entities.field.email` - E-Mail
 * * `entities.field.entity_type` - Personentyp
 * * `entities.field.fax` - Fax
 * * `entities.field.first_name` - Vorname
 * * `entities.field.iban` - IBAN
 * * `entities.field.institution_name` - Name der Institution
 * * `entities.field.is_entitled_to_deduct_vat` - Vorsteuerabzugsberechtigt
 * * `entities.field.is_valid_email` - Gültige E-Mail
 * * `entities.field.is_valid_phone_number` - Gültige Telefonnummer
 * * `entities.field.last_name` - Nachname
 * * `entities.field.legal_insurance_deductible_amount` - Höhe der Selbstbeteiligung der Rechtsschutzversicherung
 * * `entities.field.legal_insurance` - Rechtsschutzversicherung
 * * `entities.field.legal_insurance_name` - Name der Rechtsschutzversicherung
 * * `entities.field.legal_insurance_number` - Nummer der Rechtsschutzversicherung
 * * `entities.field.marital_status` - Familienstand
 * * `entities.field.phone` - Telefon
 * * `entities.field.specific_title` - Titel
 * * `entities.field.street` - Straße
 * * `entities.field.street_number` - Hausnummer
 * * `entities.field.title` - Anrede
 * * `entities.field.website` - Website
 * * `entities.field.zip` - PLZ
 * * `law.civil_law_accessories_sold_separately` - Zubehör separat veräußert?
 * * `law.civil_law_case_number` - Geschäftsnummer
 * * `law.civil_law_claim_amount` - Streitwert
 * * `law.civil_law_contract_date` - Vertragsdatum
 * * `law.civil_law_contract_duration` - Vertragslaufzeit in Monaten
 * * `law.civil_law_contract_end_date` - Vertragsende
 * * `law.civil_law_contract` - Vertrag
 * * `law.civil_law_contract_object` - Vertragsgegenstand
 * * `law.civil_law_contract_start_date` - Vertragsbeginn
 * * `law.civil_law_contract_value` - Vertragswert
 * * `law.civil_law_correspondence` - Schriftverkehr
 * * `law.civil_law_court_costs` - Gerichtskosten
 * * `law.civil_law_court_document` - Gerichtsdokument
 * * `law.civil_law_court_name` - Gericht
 * * `law.civil_law_damage_amount` - Schadenshöhe
 * * `law.civil_law_damage_cause` - Schadensursache
 * * `law.civil_law_damage_claim` - Schadensersatzforderung
 * * `law.civil_law_damage_date` - Schadensdatum
 * * `law.civil_law_damage_description` - Schadensbeschreibung
 * * `law.civil_law_default_interest` - Verzugszinsen
 * * `law.civil_law_defects` - Mängel
 * * `law.civil_law_defects_present` - Sachmängel vorhanden
 * * `law.civil_law_delivery_date` - Lieferdatum
 * * `law.civil_law_document_date` - Dokumentdatum
 * * `law.civil_law_file_reference` - Aktenzeichen
 * * `law.civil_law_handover_date` - Übergabedatum
 * * `law.civil_law_hearing_date` - Verhandlungstermin
 * * `law.civil_law_insurance_claim_number` - Versicherungsschadensnummer
 * * `law.civil_law_interest_rate` - Zinssatz
 * * `law.civil_law_judgment_date` - Urteilsdatum
 * * `law.civil_law_liability_percentage` - Haftungsquote in Prozent
 * * `law.civil_law_notarial_certification_date` - Notarielle Beurkundung Datum
 * * `law.civil_law_payment_due_date` - Fälligkeitsdatum
 * * `law.civil_law_purchase_agreement` - Kaufvertrag
 * * `law.civil_law_purchase_contract_file_reference` - Kaufvertragsaktenzeichen
 * * `law.civil_law_purchase_date` - Kaufdatum
 * * `law.civil_law_purchase_object` - Kaufgegenstand
 * * `law.civil_law_purchase_price_components` - Bestandteile Kaufpreis
 * * `law.civil_law_purchase_price` - Kaufpreis
 * * `law.civil_law_purchase_price_paid_amount` - Höhe bezahlten Kaufpreises
 * * `law.civil_law_purchase_price_paid_boolean` - Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_paid_date` - Datum Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_paid` - Kaufpreis bezahlt
 * * `law.civil_law_purchase_price_payment_date` - Datum Zahlung Kaufpreis
 * * `law.civil_law_subject_line` - Betreff
 * * `law.civil_law_termination_notice_period` - Kündigungsfrist
 * * `law.civil_law_vehicle_make` - Fahrzeugmarke
 * * `law.civil_law_vehicle_mileage` - Kilometerstand
 * * `law.civil_law_vehicle_model` - Fahrzeugmodell
 * * `law.civil_law_vehicle_vin` - Fahrgestellnummer
 * * `law.civil_law_vehicle_year` - Baujahr
 * * `law.civil_law_warranty_period` - Gewährleistungsfrist
 * * `law.criminal_law_amount_of_daily_rates` - Betrag des Tagessatzes
 * * `law.criminal_law_applicable_laws` - Anwendbare Vorschriften
 * * `law.criminal_law_charge_description` - Anklagesatz
 * * `law.criminal_law_complaint` - Anzeige
 * * `law.criminal_law_criminal_warrant` - Strafbefehl
 * * `law.criminal_law_damage_description` - Beschreibung des Schadens
 * * `law.criminal_law_damage_value` - Schadenshöhe in EUR
 * * `law.criminal_law_date_of_offense` - Datum der Tat
 * * `law.criminal_law_duration_of_prison_sentence` - Dauer der Freiheitsstrafe
 * * `law.criminal_law_evidence_location` - Standort der Beweismittel
 * * `law.criminal_law_evidence` - Beweis
 * * `law.criminal_law_incident_description` - Sachverhalt
 * * `law.criminal_law_indictment_date` - Datum der Anklageschrift
 * * `law.criminal_law_indictment_delivery_date` - Datum der Zustellung der Anklageschrift
 * * `law.criminal_law_indictment` - Anklageschrift
 * * `law.criminal_law_legal_classification_of_offense` - Vergehen auf der Grundlage von
 * * `law.criminal_law_means_of_evidence` - Beweismittel
 * * `law.criminal_law_number_of_daily_rates` - Tagessatz
 * * `law.criminal_law_offense_type` - Art des Delikts
 * * `law.criminal_law_penalty_infromation` - Strafe
 * * `law.criminal_law_physical_evidence` - Beschreibung der Beweismittel
 * * `law.criminal_law_place_of_offense` - Ort der Tat
 * * `law.criminal_law_police_file_number` - Vorgangsnummer
 * * `law.criminal_law_preliminary_proceedings_date` - Datum der Einleitung des Ermittlungsverfahrens
 * * `law.criminal_law_prison_sentence` - Freiheitsstrafe
 * * `law.criminal_law_probation` - Bewährung
 * * `law.criminal_law_prosecution_file_number` - Aktenzeichen der Staatsanwaltschaft
 * * `law.criminal_law_report_date` - Datum der Anzeigenerstattung
 * * `law.criminal_law_report_time` - Uhrzeit der Anzeigenerstattung
 * * `law.criminal_law_time_of_offense` - Uhrzeit der Tat
 * * `law.debt_collection_law_business_fee` - 1,3 Geschäftsgebühr (Nr. 2300 VV RVG)
 * * `law.debt_collection_law_case_value` - Gegenstandswert
 * * `law.debt_collection_law_invoice_amount` - Rechnungsbetrag
 * * `law.debt_collection_law_invoice_date` - Rechnungsdatum
 * * `law.debt_collection_law_invoice_ground` - Rechnungsgrund
 * * `law.debt_collection_law_invoice_lawyer` - Rechnung Anwalt
 * * `law.debt_collection_law_invoice` - Rechnung
 * * `law.debt_collection_law_invoice_number` - Rechnungsnummer
 * * `law.debt_collection_law_invoice_recipient` - Rechnungsadressat
 * * `law.debt_collection_law_invoice_tax_number` - Steuernummer
 * * `law.debt_collection_law_lumps_sum_expenses` - Auslagenpauschale (Nr. 7002 VV RVG)
 * * `law.debt_collection_law_sales_tax` - Umsatzsteuer (19%)
 * * `law.debt_collection_law_subtotal_lawyer_fees` - Zwischensumme Netto
 * * `law.debt_collection_law_total_amount` - Gesamtbetrag
 * * `law.external_case_id` - external case id
 * * `law.family_law_average_net_income` - Durchschnittliches Nettoeinkommen
 * * `law.family_law_birth_certificate` - Geburtsurkunden
 * * `law.family_law_birth_register_number` - Geburtsurkundennummer
 * * `law.family_law_birth_register_office_location` - Standesamt Geburtsurkunde
 * * `law.family_law_children` - Kinder vorhanden
 * * `law.family_law_date_of_marriage` - Eheschließungsdatum
 * * `law.family_law_divorce_application` - Ehescheidungsantrag
 * * `law.family_law_divorce_settlement_agreement` - Scheidungsfolgenvereinbarung
 * * `law.family_law_marriage_certificate` - Eheurkunde
 * * `law.family_law_marriage_contract_date` - Ehevertragsdatum
 * * `law.family_law_marriage_contract` - Ehevertrag
 * * `law.family_law_marriage_register_number` - Eheregisternummer
 * * `law.family_law_registry_office_location` - Standesamt Ort
 * * `law.family_law_separation_date` - Trennungsdatumdatum
 * * `law.field` - Rechtsgebiet
 * * `law.general_law_amount_net` - Nettobetrag
 * * `law.general_law_amount_total` - Gesamtbetrag
 * * `law.general_law_appendices` - Anlagen
 * * `law.general_law_case_number` - Geschäftsnummer
 * * `law.general_law_court_costs` - Gerichtskosten
 * * `law.general_law_court_name` - Gericht
 * * `law.general_law_doc_date` - Dokumentendatum
 * * `law.general_law_due_date` - Fälligkeitsdatum
 * * `law.general_law_file_ref` - Aktenzeichen
 * * `law.general_law_hearing_date` - Verhandlungstermin
 * * `law.general_law_invoice_date` - Rechnungsdatum
 * * `law.general_law_invoice_number` - Rechnungsnummer
 * * `law.general_law_judgment_date` - Urteilsdatum
 * * `law.general_law_correspondence` - Schriftverkehr
 * * `law.general_law_court_document` - Gerichtsdokument
 * * `law.general_law_invoice` - Rechnung
 * * `law.general_law_payment_terms` - Zahlungsbedingungen
 * * `law.general_law_prior_ref` - Zeichen unseres Schreibens
 * * `law.general_law_subject` - Betreff
 * * `law.general_law_vat` - MwSt / Umsatzsteuer
 * * `law.generic_document` - Anderes Dokument
 * * `law.inheritance_law_certificate_of_inheritance_applicable_law` - Anwendbares Recht
 * * `law.inheritance_law_certificate_of_inheritance_date_death` - Todesdatum
 * * `law.inheritance_law_certificate_of_inheritance_date` - Datum Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance` - Erbschein
 * * `law.inheritance_law_certificate_of_inheritance_number` - Nummer des Erbscheins
 * * `law.inheritance_law_certificate_of_inheritance_place_of_death` - Todesort
 * * `law.inheritance_law_death_certificate_date_death` - Todesdatum
 * * `law.inheritance_law_death_certificate_date` - Datum Sterbeurkunde
 * * `law.inheritance_law_death_certificate` - Sterbeurkunde
 * * `law.inheritance_law_death_certificate_number` - Nummer Sterbeurkunde
 * * `law.inheritance_law_death_certificate_place_death` - Ort des Todes
 * * `law.inheritance_law_death_certificate_place` - Ort Sterbeurkunde
 * * `law.inheritance_law_death_certificate_time_death` - Uhrzeit des Todes
 * * `law.inheritance_law_estate_inventory_amount` - Nettonachlass
 * * `law.inheritance_law_estate_inventory_date` - Datum Nachlassverzeichnis
 * * `law.inheritance_law_estate_inventory_status` - Güterstand
 * * `law.inheritance_law_inheritance_contract_date` - Datum des Erbvertrags
 * * `law.inheritance_law_inheritance_contract` - Erbvertrag
 * * `law.inheritance_law_lasting_power_of_attorney_date` - Datum Vorsorgevollmacht
 * * `law.inheritance_law_lasting_power_of_attorney` - Vorsorgevollmacht
 * * `law.inheritance_law_list_of_estate` - Nachlassverzeichnis
 * * `law.inheritance_law_living_will` - Patientenverfügung
 * * `law.inheritance_law_patient_enrollment_date` - Datum Patientenverfügung
 * * `law.inheritance_law_testament_date` - Datum des Testaments
 * * `law.inheritance_law_will` - Testament
 * * `law.labor_law_amount_dependent_children` - Anzahl unterhaltspflichtiger Kinder
 * * `law.labor_law_beginning_of_employment` - Datum Beginn des Arbeitsverhältnisses
 * * `law.labor_law_certificate_clause` - Zeugnisklausel
 * * `law.labor_law_child_allowances` - Kinderfreibeträge
 * * `law.labor_law_collective_agreement` - Tarifvertrag
 * * `law.labor_law_company_agreement` - Betriebsvereinbarung
 * * `law.labor_law_company_hearing` - Betriebsanhörung durchgeführt
 * * `law.labor_law_dependent_children` - Unterhaltspflichtige Kinder
 * * `law.labor_law_different_place_of_work` - Abweichender Arbeitsort
 * * `law.labor_law_disability` - Behinderung
 * * `law.labor_law_employee_probation_period_end_date` - Datum Ende der Probezeit
 * * `law.labor_law_end_of_employment` - Datum Ende des Arbeitsverhältnisses
 * * `law.labor_law_exemption_irrevocable` - Freistellung unwiderruflich
 * * `law.labor_law_exemption_revocable` - Freistellung widerruflich
 * * `law.labor_law_fixed_term_contract_duration` - Ende befristetes Arbeitsverhältnis
 * * `law.labor_law_fixed_term_contract` - Befristetes Arbeitsverhältnis
 * * `law.labor_law_grade_certificate_clause` - Note Zeugnisklausel
 * * `law.labor_law_is_employee_in_probation_period` - Arbeitnehmer in Probezeit
 * * `law.labor_law_job_title` - Berufsbezeichnung
 * * `law.labor_law_local_transfer_clause` - Örtliche Versetzungsklausel
 * * `law.labor_law_LTI` - LTI
 * * `law.labor_law_married` - Verheiratet
 * * `law.labor_law_monthly_gross_salary` - Gehalt, monatlich, brutto
 * * `law.labor_law_monthly_working_days` - Arbeitsstunden pro Monat
 * * `law.labor_law_notice_period` - Kündigungsfrist in Monaten
 * * `law.labor_law_notice_period_observed` - Kündigungsfrist eingehalten
 * * `law.labor_law_payslip` - Lohnabrechnung
 * * `law.labor_law_percent_sprinter_clause` - Prozent Sprinterklausel
 * * `law.labor_law_place_of_work` - Arbeitsort
 * * `law.labor_law_pregnancy` - Schwangerschaft
 * * `law.labor_law_reaction_company_hering` - Reaktion des Betriebsrats
 * * `law.labor_law_reason_for_termination_given` - Kündigungsgrund angegeben
 * * `law.labor_law_return_of_company_property` - Rückgabe Firmeneigentum
 * * `law.labor_law_settlement_agreement_date` - Datum Abwicklungsvertrag
 * * `law.labor_law_settlement_agreement` - Abwicklungsvertrag
 * * `law.labor_law_severance_amount` - Abfindungssumme
 * * `law.labor_law_signature_of_employer` - Unterschrift Arbeitgeber
 * * `law.labor_law_special_documents` - Besondere Dokumente
 * * `law.labor_law_special_payments_amount` - Höhe der Sonderzahlungen
 * * `law.labor_law_special_payments` - Sonderzahlungen
 * * `law.labor_law_special_personal_circumstances` - Besondere persönliche Umstände
 * * `law.labor_law_special_protection_against_dismissal` - Sonderkündigungsschutz
 * * `law.labor_law_special_sentence` - zur Vermeidung Kündigung aus dringenden betrieblichen Gründen
 * * `law.labor_law_sprinter_clause` - Sprinterklausel
 * * `law.labor_law_termination_access_to_termination_to_employee` - Datum Zugang Kündigung beim Arbeitnehmer
 * * `law.labor_law_termination_agreement_date` - Datum Aufhebungsvertrag
 * * `law.labor_law_termination_agreement` - Aufhebungsvertrag
 * * `law.labor_law_termination_agreement_severance_pay_amount` - Höhe der Abfindung
 * * `law.labor_law_termination_agreement_termination_date` - Datum Beendigung Arbeitsverhältnis
 * * `law.labor_law_termination_authorization` - Befugnis zur Kündigung
 * * `law.labor_law_termination_date_effective` - Kündigung erfolgt zu welchem Datum
 * * `law.labor_law_termination_date` - Datum Kündigung durch Arbeitgeber
 * * `law.labor_law_termination_employer_more_than_10_employees` - Arbeitgeber hat mehr als 10 Mitarbeiter
 * * `law.labor_law_termination_is_agreement_severance_pay` - Abfindung vereinbart
 * * `law.labor_law_termination` - Kündigung
 * * `law.labor_law_termination_operational_reasons` - 1a KSchG dringende betriebliche Kündigung
 * * `law.labor_law_termination_without_notice` - fristlose Kündigung
 * * `law.labor_law_total_gross_salary` - Gesamtgehalt Brutto
 * * `law.labor_law_vacation_days` - Urlaubstage
 * * `law.labor_law_visum` - Visum / Aufenthaltstitel
 * * `law.labor_law_VSOP` - VSOP
 * * `law.labor_law_warning_letter_access_to_warning_letter_to_employee` - Datum Zugang Abmahnung beim Arbeitnehmer
 * * `law.labor_law_warning_letter_date` - Datum Abmahnung
 * * `law.labor_law_warning_letter_incident_date` - Datum des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_location` - Ort des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter_incident_time` - Uhrzeit des Vorfalls der zur Abmahnung geführt hat
 * * `law.labor_law_warning_letter` - Abmahnung
 * * `law.labor_law_warning_letter_reason` - Grund der Abmahnung
 * * `law.labor_law_work_contract` - Arbeitsvertrag
 * * `law.labor_law_work_council` - Betriebsrat
 * * `law.labor_law_work_hours_per_week` - Arbeitsstunden pro Woche
 * * `law.labor_law_works_council_membership` - Mitgliedschaft Betriebsrat
 * * `law.labor_law_yearly_gross_salary` - Gehalt, jährlich, brutto
 * * `law.labor_law_years_of_employment` - Jahre der Betriebszugehörigkeit
 * * `law.medicine_law_health_insurance_letter_date` - Datum des Schreibens
 * * `law.medicine_law_health_insurance_letter_decision_justification` - Begründung der Entscheidung
 * * `law.medicine_law_health_insurance_letter_decision` - Entscheidung der Krankenkasse
 * * `law.medicine_law_health_insurance_letter_legal_remedy_instruction` - Rechtsbehelfsbelehrung
 * * `law.medicine_law_health_insurance_letter` - Schreiben von Krankenkasse
 * * `law.medicine_law_health_insurance_letter_reference_to_application` - Bezug auf Schreiben
 * * `law.medicine_law_hospital_records_admission_date` - Aufnahmedatum
 * * `law.medicine_law_hospital_records_diagnoses_icd_codes` - Diagnosen ICD-Codes
 * * `law.medicine_law_hospital_records_discharge_date` - Entlassungsdatum
 * * `law.medicine_law_hospital_records_discharge_prognosis` - Prognose
 * * `law.medicine_law_hospital_records_documented_complications` - Dokumentierte Komplikationen
 * * `law.medicine_law_hospital_records` - Krankenhausakte
 * * `law.medicine_law_hospital_records_medication_during_stay` - Medikation während Aufenthalt
 * * `law.medicine_law_hospital_records_operation_date` - Operation Datum
 * * `law.medicine_law_hospital_records_operations` - Operationen
 * * `law.medicine_law_hospital_records_station` - Station
 * * `law.medicine_law_laboratory_results_examination_date` - Datum der Untersuchung
 * * `law.medicine_law_laboratory_results_examination_type` - Art der Untersuchung
 * * `law.medicine_law_laboratory_results_further_investigation_recommendation` - Empfehlung zur weiteren Abklärung
 * * `law.medicine_law_laboratory_results` - Befund
 * * `law.medicine_law_laboratory_results_relevant_deviations` - Relevante Abweichungen
 * * `law.medicine_law_medical_bill_cost_bearer` - Kostenträger
 * * `law.medicine_law_medical_bill_invoice_date` - Rechnungsdatum
 * * `law.medicine_law_medical_bill_invoice_number` - Rechnungsnummer
 * * `law.medicine_law_medical_bill` - Arztrechnung
 * * `law.medicine_law_medical_bill_payment_deadline` - Zahlungsfrist
 * * `law.medicine_law_medical_bill_service_period` - Zeitraum der Leistung
 * * `law.medicine_law_medical_bill_services_list` - Auflistung der Leistungen
 * * `law.medicine_law_medical_bill_total_amount` - Gesamtsumme der Rechnung
 * * `law.medicine_law_medical_expertise_date` - Datum des Gutachtens
 * * `law.medicine_law_medical_expertise_justification` - Begründung des Ergebnisses
 * * `law.medicine_law_medical_expertise` - Medizinisches Gutachten
 * * `law.medicine_law_medical_expertise_medical_assessment` - Medizinische Einschätzung
 * * `law.medicine_law_medical_expertise_question_posed` - Fragestellung des Gutachtens
 * * `law.medicine_law_medical_expertise_result` - Ergebnis des Gutachtens
 * * `law.medicine_law_medical_report_complications` - Komplikationen
 * * `law.medicine_law_medical_report_date` - Datum des Berichts
 * * `law.medicine_law_medical_report_diagnosis_icd_code` - Diagnose ICD-Code
 * * `law.medicine_law_medical_report_diagnosis_short_text` - Diagnose Kurztext
 * * `law.medicine_law_medical_report_further_treatment` - Weitere Behandlung
 * * `law.medicine_law_medical_report` - Arztbericht
 * * `law.medicine_law_medical_report_surgery_date` - OP-Datum
 * * `law.medicine_law_medical_report_treatment_measures` - Therapie Behandlungsmaßnahmen
 * * `law.medicine_law_medical_report_treatment_period` - Zeitraum der Behandlung
 * * `law.migration_law_approval_notice_case_number` - Aktenzeichen
 * * `law.migration_law_approval_notice_conditions` - Auflagen
 * * `law.migration_law_approval_notice_decision_date` - Datum des Bescheids
 * * `law.migration_law_approval_notice_issuing_authority` - Ausstellende Behörde
 * * `law.migration_law_approval_notice` - Bewilligungsbescheid
 * * `law.migration_law_approval_notice_permit_type` - Art des Aufenthaltstitels
 * * `law.migration_law_approval_notice_pickup_deadline` - Abholfrist
 * * `law.migration_law_approval_notice_validity_period` - Gültigkeitszeitraum
 * * `law.migration_law_asylum_seeker_certificate_application_number` - Asylantragsnummer
 * * `law.migration_law_asylum_seeker_certificate_first_registration_date` - Erstregistrierung
 * * `law.migration_law_asylum_seeker_certificate_issue_date` - Ausstellungsdatum
 * * `law.migration_law_asylum_seeker_certificate_issuing_authority` - Behörde
 * * `law.migration_law_asylum_seeker_certificate` - Bescheinigung über die Aufenthaltsgestattung
 * * `law.migration_law_asylum_seeker_certificate_residence_obligation` - Wohnsitzauflage
 * * `law.migration_law_asylum_seeker_certificate_valid_until` - Gültig bis
 * * `law.migration_law_asylum_seeker_certificate_work_permission` - Arbeitserlaubnis
 * * `law.migration_law_cooperation_letter_attachments` - Anlagen / Formulare
 * * `law.migration_law_cooperation_letter_date` - Datum des Schreibens
 * * `law.migration_law_cooperation_letter_deadlines` - Fristen
 * * `law.migration_law_cooperation_letter_file_number` - Aktenzeichen
 * * `law.migration_law_cooperation_letter` - Mitwirkungspflichtschreiben
 * * `law.migration_law_cooperation_letter_non_cooperation_consequences` - Rechtsfolgen bei Nichtmitwirkung
 * * `law.migration_law_cooperation_letter_specified_obligations` - Benannte Mitwirkungspflichten
 * * `law.migration_law_fictional_certificate_authority` - Behörde
 * * `law.migration_law_fictional_certificate_fiction_type` - Art der Fiktion
 * * `law.migration_law_fictional_certificate_issue_date` - Ausgestellt am
 * * `law.migration_law_fictional_certificate_legal_basis` - Rechtsgrundlage
 * * `law.migration_law_fictional_certificate` - Fiktionsbescheinigung
 * * `law.migration_law_fictional_certificate_reason_for_issuance` - Zweck der Erteilung
 * * `law.migration_law_fictional_certificate_valid_until` - Gültig bis
 * * `law.migration_law_hearing_letter_date` - Datum des Schreibens
 * * `law.migration_law_hearing_letter_intended_measure_justification` - Begründung der beabsichtigten Maßnahme
 * * `law.migration_law_hearing_letter_legal_advice` - Rechtsbehelfshinweis
 * * `law.migration_law_hearing_letter` - Anhörungsschreiben
 * * `law.migration_law_hearing_letter_requested_documents` - Dokumente beizufügen
 * * `law.migration_law_hearing_letter_response_deadline` - Frist zur Stellungnahme
 * * `law.migration_law_other_letters_action_required` - Handlungsaufforderung
 * * `law.migration_law_other_letters_date` - Datum des Schreibens
 * * `law.migration_law_other_letters_deadlines` - Fristen
 * * `law.migration_law_other_letters_file_number` - Aktenzeichen / Geschäftszeichen
 * * `law.migration_law_other_letters_issuing_authority` - Absenderbehörde
 * * `law.migration_law_other_letters_legal_basis` - Rechtsgrundlage (sofern genannt)
 * * `law.migration_law_other_letters` - Sonstige Schreiben der Ausländerbehörde
 * * `law.migration_law_other_letters_matter_purpose` - Anliegen / Inhalt des Schreibens
 * * `law.migration_law_other_letters_subject` - Betreff
 * * `law.migration_law_rejection_notice_case_number` - Aktenzeichen
 * * `law.migration_law_rejection_notice_decision_date` - Datum des Bescheids
 * * `law.migration_law_rejection_notice_legal_grounds` - Gesetzesgrundlagen
 * * `law.migration_law_rejection_notice_legal_remedy_deadline` - Rechtsbehelf / Frist
 * * `law.migration_law_rejection_notice` - Ablehnungsbescheid
 * * `law.migration_law_rejection_notice_officer_name` - Name des Sachbearbeiters
 * * `law.migration_law_rejection_notice_reasoning` - Begründung
 * * `law.migration_law_rejection_notice_signature_seal` - Unterschrift / Dienstsiegel
 * * `law.migration_law_rejection_notice_subject` - Betreff
 * * `law.migration_law_residence_permit_conditions` - Auflagen / Nebenbestimmungen
 * * `law.migration_law_residence_permit_issue_date` - Ausstellungsdatum
 * * `law.migration_law_residence_permit_issuing_authority` - Behörde
 * * `law.migration_law_residence_permit` - Aufenthaltstitel
 * * `law.migration_law_residence_permit_national_id_number` - Nationale Identitätsnummer
 * * `law.migration_law_residence_permit_passport_number` - Passnummer
 * * `law.migration_law_residence_permit_purpose` - Zweck des Aufenthalts
 * * `law.migration_law_residence_permit_type` - Titelart
 * * `law.migration_law_residence_permit_valid_until` - Gültig bis
 * * `law.migration_law_toleration_issue_date` - Ausgestellt am
 * * `law.migration_law_toleration_issuing_authority` - Behörde
 * * `law.migration_law_toleration_legal_basis` - Rechtsgrundlage
 * * `law.migration_law_toleration` - Duldung
 * * `law.migration_law_toleration_reason` - Grund der Duldung
 * * `law.migration_law_toleration_restrictions` - Beschränkungen
 * * `law.migration_law_toleration_valid_until` - Gültig bis
 * * `law.real_estate_law_basic_debts_amount` - Grundschulden
 * * `law.real_estate_law_broker_commission_amount` - Provisionshöhe
 * * `law.real_estate_law_broker_contract_type` - Art des Maklervertrags
 * * `law.real_estate_law_broker_scope_of_work` - Tätigkeitsumfang
 * * `law.real_estate_law_broker_termination_periods` - Kündigungsfristen
 * * `law.real_estate_law_brokerage_contract_date` - Maklervertrag Datum
 * * `law.real_estate_law_brokerage_contract` - Maklervertrag
 * * `law.real_estate_law_brokerage_fee` - Makler Provision
 * * `law.real_estate_law_building_dimensions` - Baukörperabmessung
 * * `law.real_estate_law_building_permit_date` - Baugenehmigungsdatum
 * * `law.real_estate_law_building_permit` - Baugenehmigung
 * * `law.real_estate_law_building_permit_number` - Genehmigungsnummer
 * * `law.real_estate_law_building_permit_validity_duration` - Gültigkeitsdauer
 * * `law.real_estate_law_building_plan` - Bauplan
 * * `law.real_estate_law_building_restrictions_clause` - Regelungen zu Baulasten
 * * `law.real_estate_law_building_usage` - Gebäudenutzung
 * * `law.real_estate_law_co_ownership_share` - Miteigentumsanteil
 * * `law.real_estate_law_commission_percentage` - Provisionshöhe in %
 * * `law.real_estate_law_contaminated_sites_clause` - Regelung zu Altlasten
 * * `law.real_estate_law_declaration_of_division` - Teilungserklärung
 * * `law.real_estate_law_division_declaration_date` - Datum Teilungserklärung
 * * `law.real_estate_law_encumbrance_restrictions` - Lasten und Beschränkungen
 * * `law.real_estate_law_encumbrances_section_ii` - Belastungen Abt. II Grundbuch
 * * `law.real_estate_law_encumbrances_section_iii` - Belastungen Abt. III Grundbuch
 * * `law.real_estate_law_exclusive_brokerage_contract` - Alleinauftrag
 * * `law.real_estate_law_full_repayment_date` - vollständige Rückzahlung
 * * `law.real_estate_law_installment_amount` - Ratenhöhe
 * * `law.real_estate_law_interest_rate` - Zinssatz
 * * `law.real_estate_law_land_register_address` - Grundbuch Lage
 * * `law.real_estate_law_land_register_city` - Grundbuch Stadt
 * * `law.real_estate_law_land_register_date` - Grundbuchauszugdatum
 * * `law.real_estate_law_land_register` - Grundbuchauszug
 * * `law.real_estate_law_land_register_number` - Grundbuch Nr.
 * * `law.real_estate_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.real_estate_law_legal_defects_clause` - Klausel zu Rechtsmängeln
 * * `law.real_estate_law_loan_agreement` - Immobiliendarlehensvertrag
 * * `law.real_estate_law_loan_amount` - Darlehenssumme
 * * `law.real_estate_law_loan_security` - Darlehnsabsicherung
 * * `law.real_estate_law_monument_protection_basis` - Schutzgrundlage
 * * `law.real_estate_law_monument_protection_notice` - Denkmalschutzbescheid
 * * `law.real_estate_law_monument_protection_order_date` - Datum des Denkmalschutzbescheides
 * * `law.real_estate_law_monument_protection_order_number` - Bescheid - Nr.
 * * `law.real_estate_law_monument_protection_requirements` - Auflagen
 * * `law.real_estate_law_monument_registration_date` - Eintragungsdatum
 * * `law.real_estate_law_plan_author` - Planverfasser
 * * `law.real_estate_law_plan_designation` - Planbezeichnung
 * * `law.real_estate_law_plan_scale` - Maßstab
 * * `law.real_estate_law_plot_size` - Grundstücksgröße
 * * `law.real_estate_law_property_brokered_by_agent` - Objekt durch Makler vermittelt
 * * `law.real_estate_law_purchase_contract_amount` - Kaufvertragsbetrag
 * * `law.real_estate_law_purchase_contract_date` - Kaufvertragsdatum
 * * `law.real_estate_law_purchase_contract_description` - Kaufvertrag Objektbeschreibung
 * * `law.real_estate_law_purchase_contract` - Kaufvertrag
 * * `law.real_estate_law_purchase_contract_registration_date` - Kaufvertragsbeurkundungsdatum
 * * `law.real_estate_law_purchase_contract_registration_number` - Urkundenrollennummer
 * * `law.real_estate_law_purchase_object_rented` - Kaufobjekt vermietet
 * * `law.real_estate_law_purchase_price_loan_financed` - Kaufpreis durch Darlehen finanziert
 * * `law.real_estate_law_repayment_rate` - Tilgungssatz
 * * `law.real_estate_law_withdrawal_instruction_date` - Widerrufsbelehrung Datum
 * * `law.residential_property_law_co_ownership_shares` - Miteigentumsanteile
 * * `law.residential_property_law_contract_date` - Wegvertragsdatum
 * * `law.residential_property_law_contract` - Wegvertrag
 * * `law.residential_property_law_inventory` - Bestandsverzeichnis
 * * `law.residential_property_law_land_register_address` - Grundbuch Lage
 * * `law.residential_property_law_land_register_city` - Grundbuch Stadt
 * * `law.residential_property_law_land_register_number` - Grundbuch Nr.
 * * `law.residential_property_law_land_register_plot_of_land` - Grundbuch Flurstück
 * * `law.social_law_affected_benefit` - Betroffene Leistung
 * * `law.social_law_application_arrival_date` - Eingang Antrag Datum
 * * `law.social_law_application_date` - Antrag Datum
 * * `law.social_law_application_file_reference` - Aktenzeichen
 * * `law.social_law_application_form` - Antragsformular
 * * `law.social_law_appointment_date` - Termin (Datum)
 * * `law.social_law_appointment_file_reference` - Aktenzeichen
 * * `law.social_law_appointment_invitation` - Einladungstermin
 * * `law.social_law_appointment_purpose` - Zweck des Termins
 * * `law.social_law_appointment_required_documents` - Mitzubringende Unterlagen
 * * `law.social_law_appointment_time` - Termin (Uhrzeit)
 * * `law.social_law_approval_file_reference` - Aktenzeichen
 * * `law.social_law_approval_internal_reference` - Interne Referenznummer der Behörde
 * * `law.social_law_approval_legal_basis` - Rechtsgrundlage der Entscheidung
 * * `law.social_law_approval_notice_date` - Datum des Bescheids
 * * `law.social_law_approval_notice` - Bewilligungsbescheid
 * * `law.social_law_approval_period_end` - Bewilligungszeitraum Ende
 * * `law.social_law_approval_period_start` - Bewilligungszeitraum Beginn
 * * `law.social_law_approved_benefit_amount` - Bewilligte Leistung (Betrag)
 * * `law.social_law_approved_benefit_period` - Bewilligte Leistung (Zeitraum)
 * * `law.social_law_approved_benefit_type` - Bewilligte Leistung (Art)
 * * `law.social_law_asset_type` - Art des Vermögens
 * * `law.social_law_attachment_list` - Anlagenliste
 * * `law.social_law_benefit_type` - Leistungsart
 * * `law.social_law_change_description` - Beschreibung der Änderung
 * * `law.social_law_change_file_reference` - Aktenzeichen
 * * `law.social_law_change_notification_date` - Datum der Mitteilung
 * * `law.social_law_change_notification` - Änderungsmitteilung
 * * `law.social_law_change_reason` - Grund der Änderung
 * * `law.social_law_creditable_income` - Anrechenbares Einkommen
 * * `law.social_law_disability_card_issue_date` - Ausstellungsdatum
 * * `law.social_law_disability_card` - Schwerbehindertenausweis
 * * `law.social_law_disability_card_markers` - Merkzeichen
 * * `law.social_law_disability_card_validity_period` - Gültigkeitsdauer
 * * `law.social_law_disability_degree` - Grad der Behinderung (GdB)
 * * `law.social_law_disability_file_reference` - Aktenzeichen
 * * `law.social_law_employment_income` - Erwerbseinkommen
 * * `law.social_law_follow_up_application_notes` - Hinweise zu Folgeanträgen
 * * `law.social_law_hearing_file_reference` - Aktenzeichen
 * * `law.social_law_hearing_letter_date` - Datum Anhörungsschreiben
 * * `law.social_law_hearing_letter` - Anhörungsschreiben
 * * `law.social_law_hearing_planned_administrative_act` - Geplanter Verwaltungsakt
 * * `law.social_law_housing_costs_amount` - Kosten für Unterkunft und Heizung
 * * `law.social_law_income_amount` - Einkommensbetrag
 * * `law.social_law_income_date` - Datum der Einnahme
 * * `law.social_law_income_legal_basis` - Rechtsgrundlage Einkommensberücksichtigung
 * * `law.social_law_income_provider` - Einkommensgeber
 * * `law.social_law_income_source` - Einkommensquelle
 * * `law.social_law_income_type` - Art des Einkommens
 * * `law.social_law_interim_legal_protection` - Antrag auf einstweiligen Rechtsschutz
 * * `law.social_law_interim_protection_affidavit` - Eidesstattliche Versicherung
 * * `law.social_law_interim_protection_attachment_list` - Anlagenliste
 * * `law.social_law_interim_protection_file_reference` - Aktenzeichen
 * * `law.social_law_interim_protection_request_date` - Datum des Antrags
 * * `law.social_law_interim_protection_request_text` - Antragstext
 * * `law.social_law_interim_protection_urgency_reason` - Dringlichkeitsbegründung
 * * `law.social_law_lawsuit_alternative_request` - Hilfsantrag
 * * `law.social_law_lawsuit_attachment_list` - Anlagenliste
 * * `law.social_law_lawsuit_cost_request` - Kostenantrag
 * * `law.social_law_lawsuit_court_file_number` - BG-Nummer
 * * `law.social_law_lawsuit_delivery_date` - Zustellungsdatum
 * * `law.social_law_lawsuit_dispute_value` - Streitwert
 * * `law.social_law_lawsuit_disputed_amount` - Streitiger Betrag
 * * `law.social_law_lawsuit_evidence_requests` - Beweisanträge
 * * `law.social_law_lawsuit_file_reference` - Aktenzeichen
 * * `law.social_law_lawsuit_filing_date` - Datum der Klageerhebung
 * * `law.social_law_lawsuit_income_amount` - Einkommensbetrag
 * * `law.social_law_lawsuit_legal_basis` - Rechtliche Grundlage der Klage
 * * `law.social_law_lawsuit_main_request` - Hauptantrag
 * * `law.social_law_lawsuit` - Klage (Sozialgericht)
 * * `law.social_law_lawsuit_monthly_benefit_amount` - Monatliche Leistung
 * * `law.social_law_lawsuit_objection_decision_date` - Datum des Widerspruchsbescheids
 * * `law.social_law_lawsuit_objection_filing_date` - Datum der Widerspruchseinlegung
 * * `law.social_law_lawsuit_original_decision_date` - Datum des ursprünglichen Bescheids
 * * `law.social_law_lawsuit_subject` - Gegenstand des Verfahrens
 * * `law.social_law_lawsuit_type` - Art der Klage
 * * `law.social_law_legal_basis` - Rechtsgrundlage
 * * `law.social_law_medical_certificate` - Ärztliches Attest / Medizinisches Gutachten
 * * `law.social_law_medical_diagnosis` - Medizinische Diagnose
 * * `law.social_law_medical_examination_date` - Untersuchungsdatum
 * * `law.social_law_medical_file_reference` - Aktenzeichen
 * * `law.social_law_medical_icd_code` - ICD-Code
 * * `law.social_law_medical_limitations` - Einschränkungen
 * * `law.social_law_medical_prognosis` - Prognose
 * * `law.social_law_medical_work_capacity_relation` - Bezug zur Leistungsfähigkeit
 * * `law.social_law_monthly_payment_amount` - Monatliche Leistung
 * * `law.social_law_needs_cost_breakdown` - Kostenaufstellung
 * * `law.social_law_needs_file_reference` - Aktenzeichen
 * * `law.social_law_needs_proof_basis` - Nachweisgrundlage
 * * `law.social_law_needs_proof_date` - Datum Bedarfsnachweis
 * * `law.social_law_needs_proof` - Bedarfsnachweis
 * * `law.social_law_needs_type` - Art des Bedarfs
 * * `law.social_law_notice_date` - Bescheid Datum
 * * `law.social_law_notice_of_objection_date` - Widerspruchbescheid Datum
 * * `law.social_law_notice_of_objection_file_reference` - Aktenzeichen
 * * `law.social_law_notice_of_objection` - Widerspruchbescheid
 * * `law.social_law_notification_date` - Datum der Kenntnisnahme
 * * `law.social_law_notification_legal_basis` - Rechtsgrundlage Mitteilungspflicht
 * * `law.social_law_notification_source` - Quelle der Kenntnisnahme
 * * `law.social_law_objection_challenged_notice` - Angegriffener Bescheid
 * * `law.social_law_objection_date` - Datum des Widerspruchs
 * * `law.social_law_objection_evidence` - Beweismittel
 * * `law.social_law_objection_file_reference` - Aktenzeichen (des angegriffenen Bescheids)
 * * `law.social_law_objection` - Widerspruch
 * * `law.social_law_objection_reasoning` - Widerspruchsbegründung
 * * `law.social_law_objection_suspension_request` - Antrag auf Aussetzung der Vollziehung
 * * `law.social_law_original_decision_date` - Datum des ursprünglichen Bescheids
 * * `law.social_law_other_income` - Sonstiges Einkommen
 * * `law.social_law_own_income_amount` - Höhe eigenes Einkommen
 * * `law.social_law_reclaim_amount` - Rückforderungsbetrag
 * * `law.social_law_reclaim_file_reference` - Aktenzeichen
 * * `law.social_law_reclaim_legal_basis` - Rechtsgrundlage Erstattung
 * * `law.social_law_reclaim_legal_norm` - Rechtsnorm
 * * `law.social_law_reclaim_notice_date` - Datum des Bescheids
 * * `law.social_law_reclaim_notice` - Rückforderungsbescheid
 * * `law.social_law_reclaim_payment_deadline` -  Datum Zahlungsfrist
 * * `law.social_law_reclaim_payment_terms` - Zahlungsmodalitäten
 * * `law.social_law_regelbedarf_amount` - Regelbedarf
 * * `law.social_law_rejection_file_reference` - Aktenzeichen
 * * `law.social_law_rejection_legal_norm` - Rechtsnorm
 * * `law.social_law_rejection_notice_date` - Datum des Bescheids
 * * `law.social_law_rejection_notice` - Ablehnungsbescheid
 * * `law.social_law_rejection_reason` - Ablehnungsgrund
 * * `law.social_law_residence_status` - Aufenthaltsstatus
 * * `law.social_law_revocation_benefit_type` - Leistungsart
 * * `law.social_law_revocation_file_reference` - Aktenzeichen
 * * `law.social_law_revocation_legal_norm` - Rechtsnorm
 * * `law.social_law_revocation_notice_date` - Datum des Bescheids
 * * `law.social_law_revocation_notice` - Aufhebungsbescheid
 * * `law.social_law_revocation_period_end` - Aufhebungszeitraum Ende
 * * `law.social_law_revocation_period_start` - Aufhebungszeitraum Beginn
 * * `law.social_law_revocation_reason` - Begründung der Aufhebung
 * * `law.social_law_revocation_reclaim_notes` - Hinweise zu Rückforderungen
 * * `law.social_law_social_benefit_type` - Art der Sozialleistung
 * * `law.social_law_summary_grounds_opposition` - Begründung des Widerspruchs
 * * `law.social_law_total_need_amount` - Gesamtbedarf
 * * `law.social_law_total_reclaim_amount` - Gesamtforderung
 * * `law.social_law_violation_type` - Art der Pflichtverletzung
 * * `law.tenancy_law_adress_rental_property` - Adresse des Mietobjekts
 * * `law.tenancy_law_advance_payment_service_charge` - Vorauszahlungen Nebenkostenabrechnung
 * * `law.tenancy_law_advance_payment_service_charges` - Nebenkostenvorauszahlungshöhe
 * * `law.tenancy_law_bank_guarantee` - Bankbürgschaft
 * * `law.tenancy_law_cash_deposit_agreed` - Barkaution vertraglich vereinbart
 * * `law.tenancy_law_cash_deposit_payment_date` - Barkaution Datum Zahlung
 * * `law.tenancy_law_competent_court` - Zuständiges Gericht
 * * `law.tenancy_law_cost_share` - Kostenanteil Mieter
 * * `law.tenancy_law_cost_shares` - Umlageschlüssel
 * * `law.tenancy_law_counter_number` - Zählerstandnummer
 * * `law.tenancy_law_court_case_number` - Gerichtliches Aktenzeichen
 * * `law.tenancy_law_court_proceedings_pending` - Gerichtliches Verfahren anhängig
 * * `law.tenancy_law_description_of_rental_property` - Beschreibung des Mietobjekts
 * * `law.tenancy_law_duration_of_lease` - Dauer des Pachtvertrags
 * * `law.tenancy_law_expert_report_commission_date` - Beauftragung Datum
 * * `law.tenancy_law_expert_report_damage_description` - Schaden
 * * `law.tenancy_law_expert_report_damage_number` - Schadennummer
 * * `law.tenancy_law_expert_report_date` - Datum Gutachten
 * * `law.tenancy_law_expert_report_inspection_date` - Ortsbesichtigung Datum
 * * `law.tenancy_law_expert_report` - Sachverständigengutachten
 * * `law.tenancy_law_expert_report_object_address` - Objekt Adresse
 * * `law.tenancy_law_expert_report_purpose` - Zweck des Gutachtens
 * * `law.tenancy_law_expert_report_repair_duration` - Dauer Schadenbeseitigung
 * * `law.tenancy_law_expert_report_subject` - Gegenstand
 * * `law.tenancy_law_extension_option_count` - Anzahl Verlängerungsoptionen
 * * `law.tenancy_law_extension_option_duration` - Dauer Verlängerungsoption
 * * `law.tenancy_law_fixed_term_tenancy` - Befristeter Mietvertrag
 * * `law.tenancy_law_garage_available` - Garage vorhanden
 * * `law.tenancy_law_garage_costs` - Kosten Garage
 * * `law.tenancy_law_general_status_documents` - Allgemeine Angaben zum Mietverhältnis
 * * `law.tenancy_law_gross_rent` - Bruttomiete
 * * `law.tenancy_law_handover_counter` - Zählerstand
 * * `law.tenancy_law_handover_date` - Übergabedatum
 * * `law.tenancy_law_handover_defects` - Mängel
 * * `law.tenancy_law_handover_protocol` - Übergabeprotokoll
 * * `law.tenancy_law_landlord_termination_given` - Kündigung durch Vermieter erfolgt
 * * `law.tenancy_law_last_rent_increase_letter_date` - Datum letztes Mieterhöhungsschreiben
 * * `law.tenancy_law_last_signature_date` - Datum letzte Unterschrift Mietvertrag
 * * `law.tenancy_law_lease_agreement` - Pachtvertrag
 * * `law.tenancy_law_location_in_rental_property` - Lage im Mietobjekt
 * * `law.tenancy_law_net_rent` - Nettomiete
 * * `law.tenancy_law_operating_costs_agreement` - Betriebskostenvereinbarung
 * * `law.tenancy_law_parking_space_available` - Stellplatz vorhanden
 * * `law.tenancy_law_parking_space_costs` - Kosten des Stellplatzes
 * * `law.tenancy_law_property_return_date` - Rückgabe des Objekts Datum
 * * `law.tenancy_law_rent_increase_effective_date` - Mieterhöhung wirksam geworden zum
 * * `law.tenancy_law_rent_increase_notice` - Mieterhöhungsschreiben
 * * `law.tenancy_law_rental_agreement_date` - Mietvertragsdatum
 * * `law.tenancy_law_rental_agreement_duration` - Dauer Mietvertrag
 * * `law.tenancy_law_rental_agreement` - Mietvertrag
 * * `law.tenancy_law_rental_agreement_validity_end` - Mietvertragsende
 * * `law.tenancy_law_rental_agreement_validity_start` - Mietvertragsbeginn
 * * `law.tenancy_law_rental_object_size_sqm` - Größe Mietobjekt Quadratmeter
 * * `law.tenancy_law_repayment` - Nachzahlung/Guthaben
 * * `law.tenancy_law_repayment_period_end` - Ende des Abrechnungszeitraums
 * * `law.tenancy_law_repayment_period_start` - Beginn des Abrechnungszeitraums
 * * `law.tenancy_law_security_deposit_additional_regulations` - Zusätzliche Regelungen zur Kaution
 * * `law.tenancy_law_security_deposit_amount` - Kautionshöhe
 * * `law.tenancy_law_service_charge_settlement` - Nebenkostenabrechnung
 * * `law.tenancy_law_staggered_rental_agreement` - Staffelmietvereinbarung
 * * `law.tenancy_law_start_of_lease` - Beginn des Pachtvertrags
 * * `law.tenancy_law_tenancy_terminated` - Mietverhältnis beendet
 * * `law.tenancy_law_tenancy_termination_date` - Datum Beendigung Mietverhältnisses
 * * `law.tenancy_law_tenant_extension_option` - Verlängerungsoption zugunsten Mieter
 * * `law.tenancy_law_tenant_warned` - Mieter abgemahnt
 * * `law.tenancy_law_termination_declared_date` - Datum Kündigungserklärung
 * * `law.tenancy_law_termination_letter_date` - Kündigungsschreiben vom
 * * `law.tenancy_law_termination_notice` - Kündigung
 * * `law.tenancy_law_termination_notice_period` - Kündigungsfrist
 * * `law.tenancy_law_total_cost_service_charge` - Gesamtkosten Nebenkostenabrechnung
 * * `law.tenancy_law_total_rent` - Gesamtmiete
 * * `law.tenancy_law_unlimited_term_tenancy` - Unbefristeter Mietvertrag
 * * `law.tenancy_law_value_security_clause` - Wertsicherungsklausel
 * * `law.tenancy_law_warning_letter_date` - Datum Mahnschreiben
 * * `law.tenancy_law_warning_letter` - Abmahnung
 * * `law.topic` - Rechtsthema
 * * `law.traffic_law_accident_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_accident_report` - Unfallbericht
 * * `law.traffic_law_amount_of_fine` - Bußgeldhöhe
 * * `law.traffic_law_appeal_instruction` - Rechtsbehelfsbelehrung
 * * `law.traffic_law_at_fault_driver_drivers_license_issued_by` - Unfallverursacher - Führerschein ausgestellt durch
 * * `law.traffic_law_at_fault_driver_drivers_license_valid_until` - Unfallverursacher - Führerschein gültig bis
 * * `law.traffic_law_at_fault_driver_green_card_number` - Unfallverursacher - Nr. der Grünen Karte
 * * `law.traffic_law_at_fault_driver_insurance_expiry_date` - Unfallverursacher - Vers.-Schein gültig bis
 * * `law.traffic_law_at_fault_driver_insurance_number` - Unfallverursacher - Vers.-Nr.
 * * `law.traffic_law_at_fault_driver_insurer` - Unfallverursacher - Versicherer
 * * `law.traffic_law_blood_alcohol_concentration` - Blutalkoholkonzentration
 * * `law.traffic_law_calculated_total_damage_costs` - Gesamtschadenshöhe
 * * `law.traffic_law_calculated_total_days` - Gesamttage
 * * `law.traffic_law_charges` - Tatvorwurf
 * * `law.traffic_law_cost_per_scale` - Kostenpauschale
 * * `law.traffic_law_daily_rate` - Höhe des Tagessatzes
 * * `law.traffic_law_damage_amount_net` - Schadenshöhe netto
 * * `law.traffic_law_damage_number` - Schadensnummer
 * * `law.traffic_law_damage_scope` - Schadensumfang
 * * `law.traffic_law_date_of_accident` - Unfalltag
 * * `law.traffic_law_date_of_crime` - Datum der Tat
 * * `law.traffic_law_date_of_fine` - Datum Bußgeldbescheid
 * * `law.traffic_law_date_of_infraction` - Datum der Ordnungswidrigkeit
 * * `law.traffic_law_date_of_inspection` - Besichtigungsdatum
 * * `law.traffic_law_date_of_issue` - Datum der Ausstellung
 * * `law.traffic_law_date_of_offense` - Datum der Tat
 * * `law.traffic_law_date_of_report` - Datum Sachverständigengutachten
 * * `law.traffic_law_differencial_tax` - Differenzsteuer
 * * `law.traffic_law_driver_logbook_required` - Fahrtenbuch erforderlich
 * * `law.traffic_law_driving_ban_duration` - Fahrverbot Dauer
 * * `law.traffic_law_driving_ban` - Fahrverbot verhängt
 * * `law.traffic_law_evidence_infraction` - Beweismittel
 * * `law.traffic_law_expert_cost` - Sachverständigenkosten
 * * `law.traffic_law_expert_date` - Unfallverursacher - Sachverständigengutachten
 * * `law.traffic_law_expert_report` - Sachverständigengutachten
 * * `law.traffic_law_expert_report_number` - Gutachten Nummer
 * * `law.traffic_law_file_number` - Aktenzeichen
 * * `law.traffic_law_fine` - Geldstrafe
 * * `law.traffic_law_fine_notice` - Bußgeldbescheid
 * * `law.traffic_law_gross_gross_replacement_value` - Brutto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_gross_replacement_value` - Bruttowiederbeschaffungswert
 * * `law.traffic_law_injured` - Verletzte
 * * `law.traffic_law_insurance_holder` - Versicherungsnehmer
 * * `law.traffic_law_insurance` - Versicherung
 * * `law.traffic_law_insurance_policy_number` - Versicherungsscheinnummer
 * * `law.traffic_law_legal_basis_infraction` - Gesetzliche Grundlage
 * * `law.traffic_law_legal_basis` - Gesetzliche Grundlage
 * * `law.traffic_law_licenseplate_at_fault_driver` - KFZ-Kennzeichen des Unfallverursachers
 * * `law.traffic_law_licenseplate` - KFZ-Kennzeichen
 * * `law.traffic_law_licenseplate_victim_driver` - KFZ-Kennzeichen des Unfallgeschädigten
 * * `law.traffic_law_loss_amount_repair_case` - Restschaden Reparaturschaden
 * * `law.traffic_law_loss_amount_total_damage_case` - Restschaden Totalschaden
 * * `law.traffic_law_loss_of_use_per_day` - Nutzungsausfallentschädigung pro Tag
 * * `law.traffic_law_mark_and_type_of_at_fault_driver` - Unfallverursacher - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_mark_and_type_of_victim_driver` - Unfallgeschädigter - Marke, Typ des Fahrzeugs
 * * `law.traffic_law_merantile_value_loss` - Merkantile Wertminderung
 * * `law.traffic_law_net_gross_replacement_value` - Netto-Brutto-Wiederbeschaffungswert
 * * `law.traffic_law_net_replacement_value` - Nettowiederbeschaffungswert
 * * `law.traffic_law_number_of_daily_rates` - Anzahl der Tagessätze
 * * `law.traffic_law_offense_infraction_description` - Tatbestand
 * * `law.traffic_law_other_damages` - Andere Sachschäden
 * * `law.traffic_law_payment_deadline` - Zahlungsfrist
 * * `law.traffic_law_penalty_order` - Strafbefehl
 * * `law.traffic_law_place_of_accident` - Unfallort
 * * `law.traffic_law_place_of_crime` - Ort der Tat
 * * `law.traffic_law_place_of_infraction` - Ort der Ordnungswidrigkeit
 * * `law.traffic_law_place_of_inspection` - Besichtigungsort
 * * `law.traffic_law_place_of_issue` - Ort der Ausstellung
 * * `law.traffic_law_place_of_offense` - Ort der Tat
 * * `law.traffic_law_points_for_offense` - Punkte
 * * `law.traffic_law_police_case_number` - Polizeiliches Aktenzeichen
 * * `law.traffic_law_procedure_costs` - Verfahrenskosten
 * * `law.traffic_law_prosecution_number` - Geschäftsnummer
 * * `law.traffic_law_regular_tax` - Regelsteuer
 * * `law.traffic_law_repair_costs_with_vat` - Reparaturkosten Brutto
 * * `law.traffic_law_repair_costs_without_vat` - Reparaturkosten Netto
 * * `law.traffic_law_repair_damage` - Reparaturschaden
 * * `law.traffic_law_repair_duration` - Reparaturdauer Tage
 * * `law.traffic_law_replacement_cost` - Wiederbeschaffungsaufwand
 * * `law.traffic_law_replacement_value` - Wiederbeschaffungswert
 * * `law.traffic_law_reregistration_cost` - Ummeldekosten
 * * `law.traffic_law_residual_value` - Restwert Brutto
 * * `law.traffic_law_speed_allowed` - Erlaubte Geschwindigkeit
 * * `law.traffic_law_speed_driven` - Gefahrene Geschwindigkeit
 * * `law.traffic_law_speed_too_high` - Überschreitung Geschwindigkeit
 * * `law.traffic_law_time_of_accident` - Uhrzeit Unfall
 * * `law.traffic_law_time_of_crime` - Uhrzeit der Tat
 * * `law.traffic_law_time_of_infraction` - Uhrzeit der Ordnungswidrigkeit
 * * `law.traffic_law_time_of_inspection` - Besichtigungszeit
 * * `law.traffic_law_time_of_issue` - Tag der Ausstellung
 * * `law.traffic_law_time_of_offense` - Uhrzeit der Tat
 * * `law.traffic_law_total_damage` - Totalschaden
 * * `law.traffic_law_value_improvement` - Wertverbesserung
 * * `law.traffic_law_vehicle_age_months` - Fahrzeugalter in Monaten
 * * `law.traffic_law_vehicle_mileage` - Fahrzeugleistung in km
 * * `law.traffic_law_vehicle_type_and_brand` - Fahrzeugtyp und Marke
 * * `law.traffic_law_victim_driver_drivers_license_issued_by` - Unfallgeschädigter - Führerschein ausgestellt durch
 * * `law.traffic_law_victim_driver_green_card_number` - Unfallgeschädigter - Nr. der Grünen Karte
 * * `law.traffic_law_victim_driver_insurance_expiry_date` - Unfallgeschädigter - Vers.-Schein gültig bis
 * * `law.traffic_law_victim_driver_insurance_number` - Unfallgeschädigter - Vers.-Nr.
 * * `law.traffic_law_victim_driver_insurer` - Unfallgeschädigter - Versicherer
 * * `law.traffic_law_victim_driver_license_valid_until` - Unfallgeschädigter - Führerschein gültig bis
 * * `law.traffic_law_violated_section` - Verletzte Vorschrift
 * * `law.traffic_law_violation_type` - Tatvorwurf
 * * `law.traffic_law_warning_fee_infraction` - Verwarnungsgeldbetrag
 * * `law.traffic_law_warning_notice` - Verwarnungsgeldbescheid
 */
export const QuestionnaireQuestionTagEnum = {
    ENTITIES_FIELD_ADDRESS_LINE_2: 'entities.field.address_line_2',
    ENTITIES_FIELD_BANK_NAME: 'entities.field.bank_name',
    ENTITIES_FIELD_BIC: 'entities.field.bic',
    ENTITIES_FIELD_CITY: 'entities.field.city',
    ENTITIES_FIELD_COMPANY_LEGAL_FORM: 'entities.field.company_legal_form',
    ENTITIES_FIELD_COMPANY_NAME: 'entities.field.company_name',
    ENTITIES_FIELD_COMPANY_REGISTER_COURT: 'entities.field.company_register_court',
    ENTITIES_FIELD_COMPANY_REGISTER_NUMBER: 'entities.field.company_register_number',
    ENTITIES_FIELD_COMPANY_TAX_ID: 'entities.field.company_tax_id',
    ENTITIES_FIELD_COMPANY_VAT_ID: 'entities.field.company_vat_id',
    ENTITIES_FIELD_DATE_OF_BIRTH: 'entities.field.date_of_birth',
    ENTITIES_FIELD_DATE_OF_DEATH: 'entities.field.date_of_death',
    ENTITIES_FIELD_EMAIL: 'entities.field.email',
    ENTITIES_FIELD_ENTITY_TYPE: 'entities.field.entity_type',
    ENTITIES_FIELD_FAX: 'entities.field.fax',
    ENTITIES_FIELD_FIRST_NAME: 'entities.field.first_name',
    ENTITIES_FIELD_IBAN: 'entities.field.iban',
    ENTITIES_FIELD_INSTITUTION_NAME: 'entities.field.institution_name',
    ENTITIES_FIELD_IS_ENTITLED_TO_DEDUCT_VAT: 'entities.field.is_entitled_to_deduct_vat',
    ENTITIES_FIELD_IS_VALID_EMAIL: 'entities.field.is_valid_email',
    ENTITIES_FIELD_IS_VALID_PHONE_NUMBER: 'entities.field.is_valid_phone_number',
    ENTITIES_FIELD_LAST_NAME: 'entities.field.last_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_DEDUCTIBLE_AMOUNT: 'entities.field.legal_insurance_deductible_amount',
    ENTITIES_FIELD_LEGAL_INSURANCE: 'entities.field.legal_insurance',
    ENTITIES_FIELD_LEGAL_INSURANCE_NAME: 'entities.field.legal_insurance_name',
    ENTITIES_FIELD_LEGAL_INSURANCE_NUMBER: 'entities.field.legal_insurance_number',
    ENTITIES_FIELD_MARITAL_STATUS: 'entities.field.marital_status',
    ENTITIES_FIELD_PHONE: 'entities.field.phone',
    ENTITIES_FIELD_SPECIFIC_TITLE: 'entities.field.specific_title',
    ENTITIES_FIELD_STREET: 'entities.field.street',
    ENTITIES_FIELD_STREET_NUMBER: 'entities.field.street_number',
    ENTITIES_FIELD_TITLE: 'entities.field.title',
    ENTITIES_FIELD_WEBSITE: 'entities.field.website',
    ENTITIES_FIELD_ZIP: 'entities.field.zip',
    LAW_CIVIL_LAW_ACCESSORIES_SOLD_SEPARATELY: 'law.civil_law_accessories_sold_separately',
    LAW_CIVIL_LAW_CASE_NUMBER: 'law.civil_law_case_number',
    LAW_CIVIL_LAW_CLAIM_AMOUNT: 'law.civil_law_claim_amount',
    LAW_CIVIL_LAW_CONTRACT_DATE: 'law.civil_law_contract_date',
    LAW_CIVIL_LAW_CONTRACT_DURATION: 'law.civil_law_contract_duration',
    LAW_CIVIL_LAW_CONTRACT_END_DATE: 'law.civil_law_contract_end_date',
    LAW_CIVIL_LAW_CONTRACT: 'law.civil_law_contract',
    LAW_CIVIL_LAW_CONTRACT_OBJECT: 'law.civil_law_contract_object',
    LAW_CIVIL_LAW_CONTRACT_START_DATE: 'law.civil_law_contract_start_date',
    LAW_CIVIL_LAW_CONTRACT_VALUE: 'law.civil_law_contract_value',
    LAW_CIVIL_LAW_CORRESPONDENCE: 'law.civil_law_correspondence',
    LAW_CIVIL_LAW_COURT_COSTS: 'law.civil_law_court_costs',
    LAW_CIVIL_LAW_COURT_DOCUMENT: 'law.civil_law_court_document',
    LAW_CIVIL_LAW_COURT_NAME: 'law.civil_law_court_name',
    LAW_CIVIL_LAW_DAMAGE_AMOUNT: 'law.civil_law_damage_amount',
    LAW_CIVIL_LAW_DAMAGE_CAUSE: 'law.civil_law_damage_cause',
    LAW_CIVIL_LAW_DAMAGE_CLAIM: 'law.civil_law_damage_claim',
    LAW_CIVIL_LAW_DAMAGE_DATE: 'law.civil_law_damage_date',
    LAW_CIVIL_LAW_DAMAGE_DESCRIPTION: 'law.civil_law_damage_description',
    LAW_CIVIL_LAW_DEFAULT_INTEREST: 'law.civil_law_default_interest',
    LAW_CIVIL_LAW_DEFECTS: 'law.civil_law_defects',
    LAW_CIVIL_LAW_DEFECTS_PRESENT: 'law.civil_law_defects_present',
    LAW_CIVIL_LAW_DELIVERY_DATE: 'law.civil_law_delivery_date',
    LAW_CIVIL_LAW_DOCUMENT_DATE: 'law.civil_law_document_date',
    LAW_CIVIL_LAW_FILE_REFERENCE: 'law.civil_law_file_reference',
    LAW_CIVIL_LAW_HANDOVER_DATE: 'law.civil_law_handover_date',
    LAW_CIVIL_LAW_HEARING_DATE: 'law.civil_law_hearing_date',
    LAW_CIVIL_LAW_INSURANCE_CLAIM_NUMBER: 'law.civil_law_insurance_claim_number',
    LAW_CIVIL_LAW_INTEREST_RATE: 'law.civil_law_interest_rate',
    LAW_CIVIL_LAW_JUDGMENT_DATE: 'law.civil_law_judgment_date',
    LAW_CIVIL_LAW_LIABILITY_PERCENTAGE: 'law.civil_law_liability_percentage',
    LAW_CIVIL_LAW_NOTARIAL_CERTIFICATION_DATE: 'law.civil_law_notarial_certification_date',
    LAW_CIVIL_LAW_PAYMENT_DUE_DATE: 'law.civil_law_payment_due_date',
    LAW_CIVIL_LAW_PURCHASE_AGREEMENT: 'law.civil_law_purchase_agreement',
    LAW_CIVIL_LAW_PURCHASE_CONTRACT_FILE_REFERENCE: 'law.civil_law_purchase_contract_file_reference',
    LAW_CIVIL_LAW_PURCHASE_DATE: 'law.civil_law_purchase_date',
    LAW_CIVIL_LAW_PURCHASE_OBJECT: 'law.civil_law_purchase_object',
    LAW_CIVIL_LAW_PURCHASE_PRICE_COMPONENTS: 'law.civil_law_purchase_price_components',
    LAW_CIVIL_LAW_PURCHASE_PRICE: 'law.civil_law_purchase_price',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_AMOUNT: 'law.civil_law_purchase_price_paid_amount',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_BOOLEAN: 'law.civil_law_purchase_price_paid_boolean',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID_DATE: 'law.civil_law_purchase_price_paid_date',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAID: 'law.civil_law_purchase_price_paid',
    LAW_CIVIL_LAW_PURCHASE_PRICE_PAYMENT_DATE: 'law.civil_law_purchase_price_payment_date',
    LAW_CIVIL_LAW_SUBJECT_LINE: 'law.civil_law_subject_line',
    LAW_CIVIL_LAW_TERMINATION_NOTICE_PERIOD: 'law.civil_law_termination_notice_period',
    LAW_CIVIL_LAW_VEHICLE_MAKE: 'law.civil_law_vehicle_make',
    LAW_CIVIL_LAW_VEHICLE_MILEAGE: 'law.civil_law_vehicle_mileage',
    LAW_CIVIL_LAW_VEHICLE_MODEL: 'law.civil_law_vehicle_model',
    LAW_CIVIL_LAW_VEHICLE_VIN: 'law.civil_law_vehicle_vin',
    LAW_CIVIL_LAW_VEHICLE_YEAR: 'law.civil_law_vehicle_year',
    LAW_CIVIL_LAW_WARRANTY_PERIOD: 'law.civil_law_warranty_period',
    LAW_CRIMINAL_LAW_AMOUNT_OF_DAILY_RATES: 'law.criminal_law_amount_of_daily_rates',
    LAW_CRIMINAL_LAW_APPLICABLE_LAWS: 'law.criminal_law_applicable_laws',
    LAW_CRIMINAL_LAW_CHARGE_DESCRIPTION: 'law.criminal_law_charge_description',
    LAW_CRIMINAL_LAW_COMPLAINT: 'law.criminal_law_complaint',
    LAW_CRIMINAL_LAW_CRIMINAL_WARRANT: 'law.criminal_law_criminal_warrant',
    LAW_CRIMINAL_LAW_DAMAGE_DESCRIPTION: 'law.criminal_law_damage_description',
    LAW_CRIMINAL_LAW_DAMAGE_VALUE: 'law.criminal_law_damage_value',
    LAW_CRIMINAL_LAW_DATE_OF_OFFENSE: 'law.criminal_law_date_of_offense',
    LAW_CRIMINAL_LAW_DURATION_OF_PRISON_SENTENCE: 'law.criminal_law_duration_of_prison_sentence',
    LAW_CRIMINAL_LAW_EVIDENCE_LOCATION: 'law.criminal_law_evidence_location',
    LAW_CRIMINAL_LAW_EVIDENCE: 'law.criminal_law_evidence',
    LAW_CRIMINAL_LAW_INCIDENT_DESCRIPTION: 'law.criminal_law_incident_description',
    LAW_CRIMINAL_LAW_INDICTMENT_DATE: 'law.criminal_law_indictment_date',
    LAW_CRIMINAL_LAW_INDICTMENT_DELIVERY_DATE: 'law.criminal_law_indictment_delivery_date',
    LAW_CRIMINAL_LAW_INDICTMENT: 'law.criminal_law_indictment',
    LAW_CRIMINAL_LAW_LEGAL_CLASSIFICATION_OF_OFFENSE: 'law.criminal_law_legal_classification_of_offense',
    LAW_CRIMINAL_LAW_MEANS_OF_EVIDENCE: 'law.criminal_law_means_of_evidence',
    LAW_CRIMINAL_LAW_NUMBER_OF_DAILY_RATES: 'law.criminal_law_number_of_daily_rates',
    LAW_CRIMINAL_LAW_OFFENSE_TYPE: 'law.criminal_law_offense_type',
    LAW_CRIMINAL_LAW_PENALTY_INFROMATION: 'law.criminal_law_penalty_infromation',
    LAW_CRIMINAL_LAW_PHYSICAL_EVIDENCE: 'law.criminal_law_physical_evidence',
    LAW_CRIMINAL_LAW_PLACE_OF_OFFENSE: 'law.criminal_law_place_of_offense',
    LAW_CRIMINAL_LAW_POLICE_FILE_NUMBER: 'law.criminal_law_police_file_number',
    LAW_CRIMINAL_LAW_PRELIMINARY_PROCEEDINGS_DATE: 'law.criminal_law_preliminary_proceedings_date',
    LAW_CRIMINAL_LAW_PRISON_SENTENCE: 'law.criminal_law_prison_sentence',
    LAW_CRIMINAL_LAW_PROBATION: 'law.criminal_law_probation',
    LAW_CRIMINAL_LAW_PROSECUTION_FILE_NUMBER: 'law.criminal_law_prosecution_file_number',
    LAW_CRIMINAL_LAW_REPORT_DATE: 'law.criminal_law_report_date',
    LAW_CRIMINAL_LAW_REPORT_TIME: 'law.criminal_law_report_time',
    LAW_CRIMINAL_LAW_TIME_OF_OFFENSE: 'law.criminal_law_time_of_offense',
    LAW_DEBT_COLLECTION_LAW_BUSINESS_FEE: 'law.debt_collection_law_business_fee',
    LAW_DEBT_COLLECTION_LAW_CASE_VALUE: 'law.debt_collection_law_case_value',
    LAW_DEBT_COLLECTION_LAW_INVOICE_AMOUNT: 'law.debt_collection_law_invoice_amount',
    LAW_DEBT_COLLECTION_LAW_INVOICE_DATE: 'law.debt_collection_law_invoice_date',
    LAW_DEBT_COLLECTION_LAW_INVOICE_GROUND: 'law.debt_collection_law_invoice_ground',
    LAW_DEBT_COLLECTION_LAW_INVOICE_LAWYER: 'law.debt_collection_law_invoice_lawyer',
    LAW_DEBT_COLLECTION_LAW_INVOICE: 'law.debt_collection_law_invoice',
    LAW_DEBT_COLLECTION_LAW_INVOICE_NUMBER: 'law.debt_collection_law_invoice_number',
    LAW_DEBT_COLLECTION_LAW_INVOICE_RECIPIENT: 'law.debt_collection_law_invoice_recipient',
    LAW_DEBT_COLLECTION_LAW_INVOICE_TAX_NUMBER: 'law.debt_collection_law_invoice_tax_number',
    LAW_DEBT_COLLECTION_LAW_LUMPS_SUM_EXPENSES: 'law.debt_collection_law_lumps_sum_expenses',
    LAW_DEBT_COLLECTION_LAW_SALES_TAX: 'law.debt_collection_law_sales_tax',
    LAW_DEBT_COLLECTION_LAW_SUBTOTAL_LAWYER_FEES: 'law.debt_collection_law_subtotal_lawyer_fees',
    LAW_DEBT_COLLECTION_LAW_TOTAL_AMOUNT: 'law.debt_collection_law_total_amount',
    LAW_EXTERNAL_CASE_ID: 'law.external_case_id',
    LAW_FAMILY_LAW_AVERAGE_NET_INCOME: 'law.family_law_average_net_income',
    LAW_FAMILY_LAW_BIRTH_CERTIFICATE: 'law.family_law_birth_certificate',
    LAW_FAMILY_LAW_BIRTH_REGISTER_NUMBER: 'law.family_law_birth_register_number',
    LAW_FAMILY_LAW_BIRTH_REGISTER_OFFICE_LOCATION: 'law.family_law_birth_register_office_location',
    LAW_FAMILY_LAW_CHILDREN: 'law.family_law_children',
    LAW_FAMILY_LAW_DATE_OF_MARRIAGE: 'law.family_law_date_of_marriage',
    LAW_FAMILY_LAW_DIVORCE_APPLICATION: 'law.family_law_divorce_application',
    LAW_FAMILY_LAW_DIVORCE_SETTLEMENT_AGREEMENT: 'law.family_law_divorce_settlement_agreement',
    LAW_FAMILY_LAW_MARRIAGE_CERTIFICATE: 'law.family_law_marriage_certificate',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT_DATE: 'law.family_law_marriage_contract_date',
    LAW_FAMILY_LAW_MARRIAGE_CONTRACT: 'law.family_law_marriage_contract',
    LAW_FAMILY_LAW_MARRIAGE_REGISTER_NUMBER: 'law.family_law_marriage_register_number',
    LAW_FAMILY_LAW_REGISTRY_OFFICE_LOCATION: 'law.family_law_registry_office_location',
    LAW_FAMILY_LAW_SEPARATION_DATE: 'law.family_law_separation_date',
    LAW_FIELD: 'law.field',
    LAW_GENERAL_LAW_AMOUNT_NET: 'law.general_law_amount_net',
    LAW_GENERAL_LAW_AMOUNT_TOTAL: 'law.general_law_amount_total',
    LAW_GENERAL_LAW_APPENDICES: 'law.general_law_appendices',
    LAW_GENERAL_LAW_CASE_NUMBER: 'law.general_law_case_number',
    LAW_GENERAL_LAW_COURT_COSTS: 'law.general_law_court_costs',
    LAW_GENERAL_LAW_COURT_NAME: 'law.general_law_court_name',
    LAW_GENERAL_LAW_DOC_DATE: 'law.general_law_doc_date',
    LAW_GENERAL_LAW_DUE_DATE: 'law.general_law_due_date',
    LAW_GENERAL_LAW_FILE_REF: 'law.general_law_file_ref',
    LAW_GENERAL_LAW_HEARING_DATE: 'law.general_law_hearing_date',
    LAW_GENERAL_LAW_INVOICE_DATE: 'law.general_law_invoice_date',
    LAW_GENERAL_LAW_INVOICE_NUMBER: 'law.general_law_invoice_number',
    LAW_GENERAL_LAW_JUDGMENT_DATE: 'law.general_law_judgment_date',
    LAW_GENERAL_LAW_CORRESPONDENCE: 'law.general_law_correspondence',
    LAW_GENERAL_LAW_COURT_DOCUMENT: 'law.general_law_court_document',
    LAW_GENERAL_LAW_INVOICE: 'law.general_law_invoice',
    LAW_GENERAL_LAW_PAYMENT_TERMS: 'law.general_law_payment_terms',
    LAW_GENERAL_LAW_PRIOR_REF: 'law.general_law_prior_ref',
    LAW_GENERAL_LAW_SUBJECT: 'law.general_law_subject',
    LAW_GENERAL_LAW_VAT: 'law.general_law_vat',
    LAW_GENERIC_DOCUMENT: 'law.generic_document',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_APPLICABLE_LAW: 'law.inheritance_law_certificate_of_inheritance_applicable_law',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE_DEATH: 'law.inheritance_law_certificate_of_inheritance_date_death',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_DATE: 'law.inheritance_law_certificate_of_inheritance_date',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE: 'law.inheritance_law_certificate_of_inheritance',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_NUMBER: 'law.inheritance_law_certificate_of_inheritance_number',
    LAW_INHERITANCE_LAW_CERTIFICATE_OF_INHERITANCE_PLACE_OF_DEATH: 'law.inheritance_law_certificate_of_inheritance_place_of_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE_DEATH: 'law.inheritance_law_death_certificate_date_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_DATE: 'law.inheritance_law_death_certificate_date',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE: 'law.inheritance_law_death_certificate',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_NUMBER: 'law.inheritance_law_death_certificate_number',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE_DEATH: 'law.inheritance_law_death_certificate_place_death',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_PLACE: 'law.inheritance_law_death_certificate_place',
    LAW_INHERITANCE_LAW_DEATH_CERTIFICATE_TIME_DEATH: 'law.inheritance_law_death_certificate_time_death',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_AMOUNT: 'law.inheritance_law_estate_inventory_amount',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_DATE: 'law.inheritance_law_estate_inventory_date',
    LAW_INHERITANCE_LAW_ESTATE_INVENTORY_STATUS: 'law.inheritance_law_estate_inventory_status',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT_DATE: 'law.inheritance_law_inheritance_contract_date',
    LAW_INHERITANCE_LAW_INHERITANCE_CONTRACT: 'law.inheritance_law_inheritance_contract',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY_DATE: 'law.inheritance_law_lasting_power_of_attorney_date',
    LAW_INHERITANCE_LAW_LASTING_POWER_OF_ATTORNEY: 'law.inheritance_law_lasting_power_of_attorney',
    LAW_INHERITANCE_LAW_LIST_OF_ESTATE: 'law.inheritance_law_list_of_estate',
    LAW_INHERITANCE_LAW_LIVING_WILL: 'law.inheritance_law_living_will',
    LAW_INHERITANCE_LAW_PATIENT_ENROLLMENT_DATE: 'law.inheritance_law_patient_enrollment_date',
    LAW_INHERITANCE_LAW_TESTAMENT_DATE: 'law.inheritance_law_testament_date',
    LAW_INHERITANCE_LAW_WILL: 'law.inheritance_law_will',
    LAW_LABOR_LAW_AMOUNT_DEPENDENT_CHILDREN: 'law.labor_law_amount_dependent_children',
    LAW_LABOR_LAW_BEGINNING_OF_EMPLOYMENT: 'law.labor_law_beginning_of_employment',
    LAW_LABOR_LAW_CERTIFICATE_CLAUSE: 'law.labor_law_certificate_clause',
    LAW_LABOR_LAW_CHILD_ALLOWANCES: 'law.labor_law_child_allowances',
    LAW_LABOR_LAW_COLLECTIVE_AGREEMENT: 'law.labor_law_collective_agreement',
    LAW_LABOR_LAW_COMPANY_AGREEMENT: 'law.labor_law_company_agreement',
    LAW_LABOR_LAW_COMPANY_HEARING: 'law.labor_law_company_hearing',
    LAW_LABOR_LAW_DEPENDENT_CHILDREN: 'law.labor_law_dependent_children',
    LAW_LABOR_LAW_DIFFERENT_PLACE_OF_WORK: 'law.labor_law_different_place_of_work',
    LAW_LABOR_LAW_DISABILITY: 'law.labor_law_disability',
    LAW_LABOR_LAW_EMPLOYEE_PROBATION_PERIOD_END_DATE: 'law.labor_law_employee_probation_period_end_date',
    LAW_LABOR_LAW_END_OF_EMPLOYMENT: 'law.labor_law_end_of_employment',
    LAW_LABOR_LAW_EXEMPTION_IRREVOCABLE: 'law.labor_law_exemption_irrevocable',
    LAW_LABOR_LAW_EXEMPTION_REVOCABLE: 'law.labor_law_exemption_revocable',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT_DURATION: 'law.labor_law_fixed_term_contract_duration',
    LAW_LABOR_LAW_FIXED_TERM_CONTRACT: 'law.labor_law_fixed_term_contract',
    LAW_LABOR_LAW_GRADE_CERTIFICATE_CLAUSE: 'law.labor_law_grade_certificate_clause',
    LAW_LABOR_LAW_IS_EMPLOYEE_IN_PROBATION_PERIOD: 'law.labor_law_is_employee_in_probation_period',
    LAW_LABOR_LAW_JOB_TITLE: 'law.labor_law_job_title',
    LAW_LABOR_LAW_LOCAL_TRANSFER_CLAUSE: 'law.labor_law_local_transfer_clause',
    LAW_LABOR_LAW_LTI: 'law.labor_law_LTI',
    LAW_LABOR_LAW_MARRIED: 'law.labor_law_married',
    LAW_LABOR_LAW_MONTHLY_GROSS_SALARY: 'law.labor_law_monthly_gross_salary',
    LAW_LABOR_LAW_MONTHLY_WORKING_DAYS: 'law.labor_law_monthly_working_days',
    LAW_LABOR_LAW_NOTICE_PERIOD: 'law.labor_law_notice_period',
    LAW_LABOR_LAW_NOTICE_PERIOD_OBSERVED: 'law.labor_law_notice_period_observed',
    LAW_LABOR_LAW_PAYSLIP: 'law.labor_law_payslip',
    LAW_LABOR_LAW_PERCENT_SPRINTER_CLAUSE: 'law.labor_law_percent_sprinter_clause',
    LAW_LABOR_LAW_PLACE_OF_WORK: 'law.labor_law_place_of_work',
    LAW_LABOR_LAW_PREGNANCY: 'law.labor_law_pregnancy',
    LAW_LABOR_LAW_REACTION_COMPANY_HERING: 'law.labor_law_reaction_company_hering',
    LAW_LABOR_LAW_REASON_FOR_TERMINATION_GIVEN: 'law.labor_law_reason_for_termination_given',
    LAW_LABOR_LAW_RETURN_OF_COMPANY_PROPERTY: 'law.labor_law_return_of_company_property',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT_DATE: 'law.labor_law_settlement_agreement_date',
    LAW_LABOR_LAW_SETTLEMENT_AGREEMENT: 'law.labor_law_settlement_agreement',
    LAW_LABOR_LAW_SEVERANCE_AMOUNT: 'law.labor_law_severance_amount',
    LAW_LABOR_LAW_SIGNATURE_OF_EMPLOYER: 'law.labor_law_signature_of_employer',
    LAW_LABOR_LAW_SPECIAL_DOCUMENTS: 'law.labor_law_special_documents',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS_AMOUNT: 'law.labor_law_special_payments_amount',
    LAW_LABOR_LAW_SPECIAL_PAYMENTS: 'law.labor_law_special_payments',
    LAW_LABOR_LAW_SPECIAL_PERSONAL_CIRCUMSTANCES: 'law.labor_law_special_personal_circumstances',
    LAW_LABOR_LAW_SPECIAL_PROTECTION_AGAINST_DISMISSAL: 'law.labor_law_special_protection_against_dismissal',
    LAW_LABOR_LAW_SPECIAL_SENTENCE: 'law.labor_law_special_sentence',
    LAW_LABOR_LAW_SPRINTER_CLAUSE: 'law.labor_law_sprinter_clause',
    LAW_LABOR_LAW_TERMINATION_ACCESS_TO_TERMINATION_TO_EMPLOYEE: 'law.labor_law_termination_access_to_termination_to_employee',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_DATE: 'law.labor_law_termination_agreement_date',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT: 'law.labor_law_termination_agreement',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_SEVERANCE_PAY_AMOUNT: 'law.labor_law_termination_agreement_severance_pay_amount',
    LAW_LABOR_LAW_TERMINATION_AGREEMENT_TERMINATION_DATE: 'law.labor_law_termination_agreement_termination_date',
    LAW_LABOR_LAW_TERMINATION_AUTHORIZATION: 'law.labor_law_termination_authorization',
    LAW_LABOR_LAW_TERMINATION_DATE_EFFECTIVE: 'law.labor_law_termination_date_effective',
    LAW_LABOR_LAW_TERMINATION_DATE: 'law.labor_law_termination_date',
    LAW_LABOR_LAW_TERMINATION_EMPLOYER_MORE_THAN_10_EMPLOYEES: 'law.labor_law_termination_employer_more_than_10_employees',
    LAW_LABOR_LAW_TERMINATION_IS_AGREEMENT_SEVERANCE_PAY: 'law.labor_law_termination_is_agreement_severance_pay',
    LAW_LABOR_LAW_TERMINATION: 'law.labor_law_termination',
    LAW_LABOR_LAW_TERMINATION_OPERATIONAL_REASONS: 'law.labor_law_termination_operational_reasons',
    LAW_LABOR_LAW_TERMINATION_WITHOUT_NOTICE: 'law.labor_law_termination_without_notice',
    LAW_LABOR_LAW_TOTAL_GROSS_SALARY: 'law.labor_law_total_gross_salary',
    LAW_LABOR_LAW_VACATION_DAYS: 'law.labor_law_vacation_days',
    LAW_LABOR_LAW_VISUM: 'law.labor_law_visum',
    LAW_LABOR_LAW_VSOP: 'law.labor_law_VSOP',
    LAW_LABOR_LAW_WARNING_LETTER_ACCESS_TO_WARNING_LETTER_TO_EMPLOYEE: 'law.labor_law_warning_letter_access_to_warning_letter_to_employee',
    LAW_LABOR_LAW_WARNING_LETTER_DATE: 'law.labor_law_warning_letter_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_DATE: 'law.labor_law_warning_letter_incident_date',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_LOCATION: 'law.labor_law_warning_letter_incident_location',
    LAW_LABOR_LAW_WARNING_LETTER_INCIDENT_TIME: 'law.labor_law_warning_letter_incident_time',
    LAW_LABOR_LAW_WARNING_LETTER: 'law.labor_law_warning_letter',
    LAW_LABOR_LAW_WARNING_LETTER_REASON: 'law.labor_law_warning_letter_reason',
    LAW_LABOR_LAW_WORK_CONTRACT: 'law.labor_law_work_contract',
    LAW_LABOR_LAW_WORK_COUNCIL: 'law.labor_law_work_council',
    LAW_LABOR_LAW_WORK_HOURS_PER_WEEK: 'law.labor_law_work_hours_per_week',
    LAW_LABOR_LAW_WORKS_COUNCIL_MEMBERSHIP: 'law.labor_law_works_council_membership',
    LAW_LABOR_LAW_YEARLY_GROSS_SALARY: 'law.labor_law_yearly_gross_salary',
    LAW_LABOR_LAW_YEARS_OF_EMPLOYMENT: 'law.labor_law_years_of_employment',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DATE: 'law.medicine_law_health_insurance_letter_date',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DECISION_JUSTIFICATION: 'law.medicine_law_health_insurance_letter_decision_justification',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_DECISION: 'law.medicine_law_health_insurance_letter_decision',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_LEGAL_REMEDY_INSTRUCTION: 'law.medicine_law_health_insurance_letter_legal_remedy_instruction',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER: 'law.medicine_law_health_insurance_letter',
    LAW_MEDICINE_LAW_HEALTH_INSURANCE_LETTER_REFERENCE_TO_APPLICATION: 'law.medicine_law_health_insurance_letter_reference_to_application',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_ADMISSION_DATE: 'law.medicine_law_hospital_records_admission_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DIAGNOSES_ICD_CODES: 'law.medicine_law_hospital_records_diagnoses_icd_codes',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DISCHARGE_DATE: 'law.medicine_law_hospital_records_discharge_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DISCHARGE_PROGNOSIS: 'law.medicine_law_hospital_records_discharge_prognosis',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_DOCUMENTED_COMPLICATIONS: 'law.medicine_law_hospital_records_documented_complications',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS: 'law.medicine_law_hospital_records',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_MEDICATION_DURING_STAY: 'law.medicine_law_hospital_records_medication_during_stay',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_OPERATION_DATE: 'law.medicine_law_hospital_records_operation_date',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_OPERATIONS: 'law.medicine_law_hospital_records_operations',
    LAW_MEDICINE_LAW_HOSPITAL_RECORDS_STATION: 'law.medicine_law_hospital_records_station',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_EXAMINATION_DATE: 'law.medicine_law_laboratory_results_examination_date',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_EXAMINATION_TYPE: 'law.medicine_law_laboratory_results_examination_type',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_FURTHER_INVESTIGATION_RECOMMENDATION: 'law.medicine_law_laboratory_results_further_investigation_recommendation',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS: 'law.medicine_law_laboratory_results',
    LAW_MEDICINE_LAW_LABORATORY_RESULTS_RELEVANT_DEVIATIONS: 'law.medicine_law_laboratory_results_relevant_deviations',
    LAW_MEDICINE_LAW_MEDICAL_BILL_COST_BEARER: 'law.medicine_law_medical_bill_cost_bearer',
    LAW_MEDICINE_LAW_MEDICAL_BILL_INVOICE_DATE: 'law.medicine_law_medical_bill_invoice_date',
    LAW_MEDICINE_LAW_MEDICAL_BILL_INVOICE_NUMBER: 'law.medicine_law_medical_bill_invoice_number',
    LAW_MEDICINE_LAW_MEDICAL_BILL: 'law.medicine_law_medical_bill',
    LAW_MEDICINE_LAW_MEDICAL_BILL_PAYMENT_DEADLINE: 'law.medicine_law_medical_bill_payment_deadline',
    LAW_MEDICINE_LAW_MEDICAL_BILL_SERVICE_PERIOD: 'law.medicine_law_medical_bill_service_period',
    LAW_MEDICINE_LAW_MEDICAL_BILL_SERVICES_LIST: 'law.medicine_law_medical_bill_services_list',
    LAW_MEDICINE_LAW_MEDICAL_BILL_TOTAL_AMOUNT: 'law.medicine_law_medical_bill_total_amount',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_DATE: 'law.medicine_law_medical_expertise_date',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_JUSTIFICATION: 'law.medicine_law_medical_expertise_justification',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE: 'law.medicine_law_medical_expertise',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_MEDICAL_ASSESSMENT: 'law.medicine_law_medical_expertise_medical_assessment',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_QUESTION_POSED: 'law.medicine_law_medical_expertise_question_posed',
    LAW_MEDICINE_LAW_MEDICAL_EXPERTISE_RESULT: 'law.medicine_law_medical_expertise_result',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_COMPLICATIONS: 'law.medicine_law_medical_report_complications',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DATE: 'law.medicine_law_medical_report_date',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DIAGNOSIS_ICD_CODE: 'law.medicine_law_medical_report_diagnosis_icd_code',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_DIAGNOSIS_SHORT_TEXT: 'law.medicine_law_medical_report_diagnosis_short_text',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_FURTHER_TREATMENT: 'law.medicine_law_medical_report_further_treatment',
    LAW_MEDICINE_LAW_MEDICAL_REPORT: 'law.medicine_law_medical_report',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_SURGERY_DATE: 'law.medicine_law_medical_report_surgery_date',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_TREATMENT_MEASURES: 'law.medicine_law_medical_report_treatment_measures',
    LAW_MEDICINE_LAW_MEDICAL_REPORT_TREATMENT_PERIOD: 'law.medicine_law_medical_report_treatment_period',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_CASE_NUMBER: 'law.migration_law_approval_notice_case_number',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_CONDITIONS: 'law.migration_law_approval_notice_conditions',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_DECISION_DATE: 'law.migration_law_approval_notice_decision_date',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_ISSUING_AUTHORITY: 'law.migration_law_approval_notice_issuing_authority',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE: 'law.migration_law_approval_notice',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_PERMIT_TYPE: 'law.migration_law_approval_notice_permit_type',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_PICKUP_DEADLINE: 'law.migration_law_approval_notice_pickup_deadline',
    LAW_MIGRATION_LAW_APPROVAL_NOTICE_VALIDITY_PERIOD: 'law.migration_law_approval_notice_validity_period',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_APPLICATION_NUMBER: 'law.migration_law_asylum_seeker_certificate_application_number',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_FIRST_REGISTRATION_DATE: 'law.migration_law_asylum_seeker_certificate_first_registration_date',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_ISSUE_DATE: 'law.migration_law_asylum_seeker_certificate_issue_date',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_ISSUING_AUTHORITY: 'law.migration_law_asylum_seeker_certificate_issuing_authority',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE: 'law.migration_law_asylum_seeker_certificate',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_RESIDENCE_OBLIGATION: 'law.migration_law_asylum_seeker_certificate_residence_obligation',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_VALID_UNTIL: 'law.migration_law_asylum_seeker_certificate_valid_until',
    LAW_MIGRATION_LAW_ASYLUM_SEEKER_CERTIFICATE_WORK_PERMISSION: 'law.migration_law_asylum_seeker_certificate_work_permission',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_ATTACHMENTS: 'law.migration_law_cooperation_letter_attachments',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_DATE: 'law.migration_law_cooperation_letter_date',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_DEADLINES: 'law.migration_law_cooperation_letter_deadlines',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_FILE_NUMBER: 'law.migration_law_cooperation_letter_file_number',
    LAW_MIGRATION_LAW_COOPERATION_LETTER: 'law.migration_law_cooperation_letter',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_NON_COOPERATION_CONSEQUENCES: 'law.migration_law_cooperation_letter_non_cooperation_consequences',
    LAW_MIGRATION_LAW_COOPERATION_LETTER_SPECIFIED_OBLIGATIONS: 'law.migration_law_cooperation_letter_specified_obligations',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_AUTHORITY: 'law.migration_law_fictional_certificate_authority',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_FICTION_TYPE: 'law.migration_law_fictional_certificate_fiction_type',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_ISSUE_DATE: 'law.migration_law_fictional_certificate_issue_date',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_LEGAL_BASIS: 'law.migration_law_fictional_certificate_legal_basis',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE: 'law.migration_law_fictional_certificate',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_REASON_FOR_ISSUANCE: 'law.migration_law_fictional_certificate_reason_for_issuance',
    LAW_MIGRATION_LAW_FICTIONAL_CERTIFICATE_VALID_UNTIL: 'law.migration_law_fictional_certificate_valid_until',
    LAW_MIGRATION_LAW_HEARING_LETTER_DATE: 'law.migration_law_hearing_letter_date',
    LAW_MIGRATION_LAW_HEARING_LETTER_INTENDED_MEASURE_JUSTIFICATION: 'law.migration_law_hearing_letter_intended_measure_justification',
    LAW_MIGRATION_LAW_HEARING_LETTER_LEGAL_ADVICE: 'law.migration_law_hearing_letter_legal_advice',
    LAW_MIGRATION_LAW_HEARING_LETTER: 'law.migration_law_hearing_letter',
    LAW_MIGRATION_LAW_HEARING_LETTER_REQUESTED_DOCUMENTS: 'law.migration_law_hearing_letter_requested_documents',
    LAW_MIGRATION_LAW_HEARING_LETTER_RESPONSE_DEADLINE: 'law.migration_law_hearing_letter_response_deadline',
    LAW_MIGRATION_LAW_OTHER_LETTERS_ACTION_REQUIRED: 'law.migration_law_other_letters_action_required',
    LAW_MIGRATION_LAW_OTHER_LETTERS_DATE: 'law.migration_law_other_letters_date',
    LAW_MIGRATION_LAW_OTHER_LETTERS_DEADLINES: 'law.migration_law_other_letters_deadlines',
    LAW_MIGRATION_LAW_OTHER_LETTERS_FILE_NUMBER: 'law.migration_law_other_letters_file_number',
    LAW_MIGRATION_LAW_OTHER_LETTERS_ISSUING_AUTHORITY: 'law.migration_law_other_letters_issuing_authority',
    LAW_MIGRATION_LAW_OTHER_LETTERS_LEGAL_BASIS: 'law.migration_law_other_letters_legal_basis',
    LAW_MIGRATION_LAW_OTHER_LETTERS: 'law.migration_law_other_letters',
    LAW_MIGRATION_LAW_OTHER_LETTERS_MATTER_PURPOSE: 'law.migration_law_other_letters_matter_purpose',
    LAW_MIGRATION_LAW_OTHER_LETTERS_SUBJECT: 'law.migration_law_other_letters_subject',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_CASE_NUMBER: 'law.migration_law_rejection_notice_case_number',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_DECISION_DATE: 'law.migration_law_rejection_notice_decision_date',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_LEGAL_GROUNDS: 'law.migration_law_rejection_notice_legal_grounds',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_LEGAL_REMEDY_DEADLINE: 'law.migration_law_rejection_notice_legal_remedy_deadline',
    LAW_MIGRATION_LAW_REJECTION_NOTICE: 'law.migration_law_rejection_notice',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_OFFICER_NAME: 'law.migration_law_rejection_notice_officer_name',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_REASONING: 'law.migration_law_rejection_notice_reasoning',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_SIGNATURE_SEAL: 'law.migration_law_rejection_notice_signature_seal',
    LAW_MIGRATION_LAW_REJECTION_NOTICE_SUBJECT: 'law.migration_law_rejection_notice_subject',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_CONDITIONS: 'law.migration_law_residence_permit_conditions',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_ISSUE_DATE: 'law.migration_law_residence_permit_issue_date',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_ISSUING_AUTHORITY: 'law.migration_law_residence_permit_issuing_authority',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT: 'law.migration_law_residence_permit',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_NATIONAL_ID_NUMBER: 'law.migration_law_residence_permit_national_id_number',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_PASSPORT_NUMBER: 'law.migration_law_residence_permit_passport_number',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_PURPOSE: 'law.migration_law_residence_permit_purpose',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_TYPE: 'law.migration_law_residence_permit_type',
    LAW_MIGRATION_LAW_RESIDENCE_PERMIT_VALID_UNTIL: 'law.migration_law_residence_permit_valid_until',
    LAW_MIGRATION_LAW_TOLERATION_ISSUE_DATE: 'law.migration_law_toleration_issue_date',
    LAW_MIGRATION_LAW_TOLERATION_ISSUING_AUTHORITY: 'law.migration_law_toleration_issuing_authority',
    LAW_MIGRATION_LAW_TOLERATION_LEGAL_BASIS: 'law.migration_law_toleration_legal_basis',
    LAW_MIGRATION_LAW_TOLERATION: 'law.migration_law_toleration',
    LAW_MIGRATION_LAW_TOLERATION_REASON: 'law.migration_law_toleration_reason',
    LAW_MIGRATION_LAW_TOLERATION_RESTRICTIONS: 'law.migration_law_toleration_restrictions',
    LAW_MIGRATION_LAW_TOLERATION_VALID_UNTIL: 'law.migration_law_toleration_valid_until',
    LAW_REAL_ESTATE_LAW_BASIC_DEBTS_AMOUNT: 'law.real_estate_law_basic_debts_amount',
    LAW_REAL_ESTATE_LAW_BROKER_COMMISSION_AMOUNT: 'law.real_estate_law_broker_commission_amount',
    LAW_REAL_ESTATE_LAW_BROKER_CONTRACT_TYPE: 'law.real_estate_law_broker_contract_type',
    LAW_REAL_ESTATE_LAW_BROKER_SCOPE_OF_WORK: 'law.real_estate_law_broker_scope_of_work',
    LAW_REAL_ESTATE_LAW_BROKER_TERMINATION_PERIODS: 'law.real_estate_law_broker_termination_periods',
    LAW_REAL_ESTATE_LAW_BROKERAGE_CONTRACT_DATE: 'law.real_estate_law_brokerage_contract_date',
    LAW_REAL_ESTATE_LAW_BROKERAGE_CONTRACT: 'law.real_estate_law_brokerage_contract',
    LAW_REAL_ESTATE_LAW_BROKERAGE_FEE: 'law.real_estate_law_brokerage_fee',
    LAW_REAL_ESTATE_LAW_BUILDING_DIMENSIONS: 'law.real_estate_law_building_dimensions',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_DATE: 'law.real_estate_law_building_permit_date',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT: 'law.real_estate_law_building_permit',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_NUMBER: 'law.real_estate_law_building_permit_number',
    LAW_REAL_ESTATE_LAW_BUILDING_PERMIT_VALIDITY_DURATION: 'law.real_estate_law_building_permit_validity_duration',
    LAW_REAL_ESTATE_LAW_BUILDING_PLAN: 'law.real_estate_law_building_plan',
    LAW_REAL_ESTATE_LAW_BUILDING_RESTRICTIONS_CLAUSE: 'law.real_estate_law_building_restrictions_clause',
    LAW_REAL_ESTATE_LAW_BUILDING_USAGE: 'law.real_estate_law_building_usage',
    LAW_REAL_ESTATE_LAW_CO_OWNERSHIP_SHARE: 'law.real_estate_law_co_ownership_share',
    LAW_REAL_ESTATE_LAW_COMMISSION_PERCENTAGE: 'law.real_estate_law_commission_percentage',
    LAW_REAL_ESTATE_LAW_CONTAMINATED_SITES_CLAUSE: 'law.real_estate_law_contaminated_sites_clause',
    LAW_REAL_ESTATE_LAW_DECLARATION_OF_DIVISION: 'law.real_estate_law_declaration_of_division',
    LAW_REAL_ESTATE_LAW_DIVISION_DECLARATION_DATE: 'law.real_estate_law_division_declaration_date',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCE_RESTRICTIONS: 'law.real_estate_law_encumbrance_restrictions',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCES_SECTION_II: 'law.real_estate_law_encumbrances_section_ii',
    LAW_REAL_ESTATE_LAW_ENCUMBRANCES_SECTION_III: 'law.real_estate_law_encumbrances_section_iii',
    LAW_REAL_ESTATE_LAW_EXCLUSIVE_BROKERAGE_CONTRACT: 'law.real_estate_law_exclusive_brokerage_contract',
    LAW_REAL_ESTATE_LAW_FULL_REPAYMENT_DATE: 'law.real_estate_law_full_repayment_date',
    LAW_REAL_ESTATE_LAW_INSTALLMENT_AMOUNT: 'law.real_estate_law_installment_amount',
    LAW_REAL_ESTATE_LAW_INTEREST_RATE: 'law.real_estate_law_interest_rate',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_ADDRESS: 'law.real_estate_law_land_register_address',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_CITY: 'law.real_estate_law_land_register_city',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_DATE: 'law.real_estate_law_land_register_date',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER: 'law.real_estate_law_land_register',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_NUMBER: 'law.real_estate_law_land_register_number',
    LAW_REAL_ESTATE_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.real_estate_law_land_register_plot_of_land',
    LAW_REAL_ESTATE_LAW_LEGAL_DEFECTS_CLAUSE: 'law.real_estate_law_legal_defects_clause',
    LAW_REAL_ESTATE_LAW_LOAN_AGREEMENT: 'law.real_estate_law_loan_agreement',
    LAW_REAL_ESTATE_LAW_LOAN_AMOUNT: 'law.real_estate_law_loan_amount',
    LAW_REAL_ESTATE_LAW_LOAN_SECURITY: 'law.real_estate_law_loan_security',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_BASIS: 'law.real_estate_law_monument_protection_basis',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_NOTICE: 'law.real_estate_law_monument_protection_notice',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_ORDER_DATE: 'law.real_estate_law_monument_protection_order_date',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_ORDER_NUMBER: 'law.real_estate_law_monument_protection_order_number',
    LAW_REAL_ESTATE_LAW_MONUMENT_PROTECTION_REQUIREMENTS: 'law.real_estate_law_monument_protection_requirements',
    LAW_REAL_ESTATE_LAW_MONUMENT_REGISTRATION_DATE: 'law.real_estate_law_monument_registration_date',
    LAW_REAL_ESTATE_LAW_PLAN_AUTHOR: 'law.real_estate_law_plan_author',
    LAW_REAL_ESTATE_LAW_PLAN_DESIGNATION: 'law.real_estate_law_plan_designation',
    LAW_REAL_ESTATE_LAW_PLAN_SCALE: 'law.real_estate_law_plan_scale',
    LAW_REAL_ESTATE_LAW_PLOT_SIZE: 'law.real_estate_law_plot_size',
    LAW_REAL_ESTATE_LAW_PROPERTY_BROKERED_BY_AGENT: 'law.real_estate_law_property_brokered_by_agent',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_AMOUNT: 'law.real_estate_law_purchase_contract_amount',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DATE: 'law.real_estate_law_purchase_contract_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_DESCRIPTION: 'law.real_estate_law_purchase_contract_description',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT: 'law.real_estate_law_purchase_contract',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_DATE: 'law.real_estate_law_purchase_contract_registration_date',
    LAW_REAL_ESTATE_LAW_PURCHASE_CONTRACT_REGISTRATION_NUMBER: 'law.real_estate_law_purchase_contract_registration_number',
    LAW_REAL_ESTATE_LAW_PURCHASE_OBJECT_RENTED: 'law.real_estate_law_purchase_object_rented',
    LAW_REAL_ESTATE_LAW_PURCHASE_PRICE_LOAN_FINANCED: 'law.real_estate_law_purchase_price_loan_financed',
    LAW_REAL_ESTATE_LAW_REPAYMENT_RATE: 'law.real_estate_law_repayment_rate',
    LAW_REAL_ESTATE_LAW_WITHDRAWAL_INSTRUCTION_DATE: 'law.real_estate_law_withdrawal_instruction_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CO_OWNERSHIP_SHARES: 'law.residential_property_law_co_ownership_shares',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT_DATE: 'law.residential_property_law_contract_date',
    LAW_RESIDENTIAL_PROPERTY_LAW_CONTRACT: 'law.residential_property_law_contract',
    LAW_RESIDENTIAL_PROPERTY_LAW_INVENTORY: 'law.residential_property_law_inventory',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_ADDRESS: 'law.residential_property_law_land_register_address',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_CITY: 'law.residential_property_law_land_register_city',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_NUMBER: 'law.residential_property_law_land_register_number',
    LAW_RESIDENTIAL_PROPERTY_LAW_LAND_REGISTER_PLOT_OF_LAND: 'law.residential_property_law_land_register_plot_of_land',
    LAW_SOCIAL_LAW_AFFECTED_BENEFIT: 'law.social_law_affected_benefit',
    LAW_SOCIAL_LAW_APPLICATION_ARRIVAL_DATE: 'law.social_law_application_arrival_date',
    LAW_SOCIAL_LAW_APPLICATION_DATE: 'law.social_law_application_date',
    LAW_SOCIAL_LAW_APPLICATION_FILE_REFERENCE: 'law.social_law_application_file_reference',
    LAW_SOCIAL_LAW_APPLICATION_FORM: 'law.social_law_application_form',
    LAW_SOCIAL_LAW_APPOINTMENT_DATE: 'law.social_law_appointment_date',
    LAW_SOCIAL_LAW_APPOINTMENT_FILE_REFERENCE: 'law.social_law_appointment_file_reference',
    LAW_SOCIAL_LAW_APPOINTMENT_INVITATION: 'law.social_law_appointment_invitation',
    LAW_SOCIAL_LAW_APPOINTMENT_PURPOSE: 'law.social_law_appointment_purpose',
    LAW_SOCIAL_LAW_APPOINTMENT_REQUIRED_DOCUMENTS: 'law.social_law_appointment_required_documents',
    LAW_SOCIAL_LAW_APPOINTMENT_TIME: 'law.social_law_appointment_time',
    LAW_SOCIAL_LAW_APPROVAL_FILE_REFERENCE: 'law.social_law_approval_file_reference',
    LAW_SOCIAL_LAW_APPROVAL_INTERNAL_REFERENCE: 'law.social_law_approval_internal_reference',
    LAW_SOCIAL_LAW_APPROVAL_LEGAL_BASIS: 'law.social_law_approval_legal_basis',
    LAW_SOCIAL_LAW_APPROVAL_NOTICE_DATE: 'law.social_law_approval_notice_date',
    LAW_SOCIAL_LAW_APPROVAL_NOTICE: 'law.social_law_approval_notice',
    LAW_SOCIAL_LAW_APPROVAL_PERIOD_END: 'law.social_law_approval_period_end',
    LAW_SOCIAL_LAW_APPROVAL_PERIOD_START: 'law.social_law_approval_period_start',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_AMOUNT: 'law.social_law_approved_benefit_amount',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_PERIOD: 'law.social_law_approved_benefit_period',
    LAW_SOCIAL_LAW_APPROVED_BENEFIT_TYPE: 'law.social_law_approved_benefit_type',
    LAW_SOCIAL_LAW_ASSET_TYPE: 'law.social_law_asset_type',
    LAW_SOCIAL_LAW_ATTACHMENT_LIST: 'law.social_law_attachment_list',
    LAW_SOCIAL_LAW_BENEFIT_TYPE: 'law.social_law_benefit_type',
    LAW_SOCIAL_LAW_CHANGE_DESCRIPTION: 'law.social_law_change_description',
    LAW_SOCIAL_LAW_CHANGE_FILE_REFERENCE: 'law.social_law_change_file_reference',
    LAW_SOCIAL_LAW_CHANGE_NOTIFICATION_DATE: 'law.social_law_change_notification_date',
    LAW_SOCIAL_LAW_CHANGE_NOTIFICATION: 'law.social_law_change_notification',
    LAW_SOCIAL_LAW_CHANGE_REASON: 'law.social_law_change_reason',
    LAW_SOCIAL_LAW_CREDITABLE_INCOME: 'law.social_law_creditable_income',
    LAW_SOCIAL_LAW_DISABILITY_CARD_ISSUE_DATE: 'law.social_law_disability_card_issue_date',
    LAW_SOCIAL_LAW_DISABILITY_CARD: 'law.social_law_disability_card',
    LAW_SOCIAL_LAW_DISABILITY_CARD_MARKERS: 'law.social_law_disability_card_markers',
    LAW_SOCIAL_LAW_DISABILITY_CARD_VALIDITY_PERIOD: 'law.social_law_disability_card_validity_period',
    LAW_SOCIAL_LAW_DISABILITY_DEGREE: 'law.social_law_disability_degree',
    LAW_SOCIAL_LAW_DISABILITY_FILE_REFERENCE: 'law.social_law_disability_file_reference',
    LAW_SOCIAL_LAW_EMPLOYMENT_INCOME: 'law.social_law_employment_income',
    LAW_SOCIAL_LAW_FOLLOW_UP_APPLICATION_NOTES: 'law.social_law_follow_up_application_notes',
    LAW_SOCIAL_LAW_HEARING_FILE_REFERENCE: 'law.social_law_hearing_file_reference',
    LAW_SOCIAL_LAW_HEARING_LETTER_DATE: 'law.social_law_hearing_letter_date',
    LAW_SOCIAL_LAW_HEARING_LETTER: 'law.social_law_hearing_letter',
    LAW_SOCIAL_LAW_HEARING_PLANNED_ADMINISTRATIVE_ACT: 'law.social_law_hearing_planned_administrative_act',
    LAW_SOCIAL_LAW_HOUSING_COSTS_AMOUNT: 'law.social_law_housing_costs_amount',
    LAW_SOCIAL_LAW_INCOME_AMOUNT: 'law.social_law_income_amount',
    LAW_SOCIAL_LAW_INCOME_DATE: 'law.social_law_income_date',
    LAW_SOCIAL_LAW_INCOME_LEGAL_BASIS: 'law.social_law_income_legal_basis',
    LAW_SOCIAL_LAW_INCOME_PROVIDER: 'law.social_law_income_provider',
    LAW_SOCIAL_LAW_INCOME_SOURCE: 'law.social_law_income_source',
    LAW_SOCIAL_LAW_INCOME_TYPE: 'law.social_law_income_type',
    LAW_SOCIAL_LAW_INTERIM_LEGAL_PROTECTION: 'law.social_law_interim_legal_protection',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_AFFIDAVIT: 'law.social_law_interim_protection_affidavit',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_ATTACHMENT_LIST: 'law.social_law_interim_protection_attachment_list',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_FILE_REFERENCE: 'law.social_law_interim_protection_file_reference',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_REQUEST_DATE: 'law.social_law_interim_protection_request_date',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_REQUEST_TEXT: 'law.social_law_interim_protection_request_text',
    LAW_SOCIAL_LAW_INTERIM_PROTECTION_URGENCY_REASON: 'law.social_law_interim_protection_urgency_reason',
    LAW_SOCIAL_LAW_LAWSUIT_ALTERNATIVE_REQUEST: 'law.social_law_lawsuit_alternative_request',
    LAW_SOCIAL_LAW_LAWSUIT_ATTACHMENT_LIST: 'law.social_law_lawsuit_attachment_list',
    LAW_SOCIAL_LAW_LAWSUIT_COST_REQUEST: 'law.social_law_lawsuit_cost_request',
    LAW_SOCIAL_LAW_LAWSUIT_COURT_FILE_NUMBER: 'law.social_law_lawsuit_court_file_number',
    LAW_SOCIAL_LAW_LAWSUIT_DELIVERY_DATE: 'law.social_law_lawsuit_delivery_date',
    LAW_SOCIAL_LAW_LAWSUIT_DISPUTE_VALUE: 'law.social_law_lawsuit_dispute_value',
    LAW_SOCIAL_LAW_LAWSUIT_DISPUTED_AMOUNT: 'law.social_law_lawsuit_disputed_amount',
    LAW_SOCIAL_LAW_LAWSUIT_EVIDENCE_REQUESTS: 'law.social_law_lawsuit_evidence_requests',
    LAW_SOCIAL_LAW_LAWSUIT_FILE_REFERENCE: 'law.social_law_lawsuit_file_reference',
    LAW_SOCIAL_LAW_LAWSUIT_FILING_DATE: 'law.social_law_lawsuit_filing_date',
    LAW_SOCIAL_LAW_LAWSUIT_INCOME_AMOUNT: 'law.social_law_lawsuit_income_amount',
    LAW_SOCIAL_LAW_LAWSUIT_LEGAL_BASIS: 'law.social_law_lawsuit_legal_basis',
    LAW_SOCIAL_LAW_LAWSUIT_MAIN_REQUEST: 'law.social_law_lawsuit_main_request',
    LAW_SOCIAL_LAW_LAWSUIT: 'law.social_law_lawsuit',
    LAW_SOCIAL_LAW_LAWSUIT_MONTHLY_BENEFIT_AMOUNT: 'law.social_law_lawsuit_monthly_benefit_amount',
    LAW_SOCIAL_LAW_LAWSUIT_OBJECTION_DECISION_DATE: 'law.social_law_lawsuit_objection_decision_date',
    LAW_SOCIAL_LAW_LAWSUIT_OBJECTION_FILING_DATE: 'law.social_law_lawsuit_objection_filing_date',
    LAW_SOCIAL_LAW_LAWSUIT_ORIGINAL_DECISION_DATE: 'law.social_law_lawsuit_original_decision_date',
    LAW_SOCIAL_LAW_LAWSUIT_SUBJECT: 'law.social_law_lawsuit_subject',
    LAW_SOCIAL_LAW_LAWSUIT_TYPE: 'law.social_law_lawsuit_type',
    LAW_SOCIAL_LAW_LEGAL_BASIS: 'law.social_law_legal_basis',
    LAW_SOCIAL_LAW_MEDICAL_CERTIFICATE: 'law.social_law_medical_certificate',
    LAW_SOCIAL_LAW_MEDICAL_DIAGNOSIS: 'law.social_law_medical_diagnosis',
    LAW_SOCIAL_LAW_MEDICAL_EXAMINATION_DATE: 'law.social_law_medical_examination_date',
    LAW_SOCIAL_LAW_MEDICAL_FILE_REFERENCE: 'law.social_law_medical_file_reference',
    LAW_SOCIAL_LAW_MEDICAL_ICD_CODE: 'law.social_law_medical_icd_code',
    LAW_SOCIAL_LAW_MEDICAL_LIMITATIONS: 'law.social_law_medical_limitations',
    LAW_SOCIAL_LAW_MEDICAL_PROGNOSIS: 'law.social_law_medical_prognosis',
    LAW_SOCIAL_LAW_MEDICAL_WORK_CAPACITY_RELATION: 'law.social_law_medical_work_capacity_relation',
    LAW_SOCIAL_LAW_MONTHLY_PAYMENT_AMOUNT: 'law.social_law_monthly_payment_amount',
    LAW_SOCIAL_LAW_NEEDS_COST_BREAKDOWN: 'law.social_law_needs_cost_breakdown',
    LAW_SOCIAL_LAW_NEEDS_FILE_REFERENCE: 'law.social_law_needs_file_reference',
    LAW_SOCIAL_LAW_NEEDS_PROOF_BASIS: 'law.social_law_needs_proof_basis',
    LAW_SOCIAL_LAW_NEEDS_PROOF_DATE: 'law.social_law_needs_proof_date',
    LAW_SOCIAL_LAW_NEEDS_PROOF: 'law.social_law_needs_proof',
    LAW_SOCIAL_LAW_NEEDS_TYPE: 'law.social_law_needs_type',
    LAW_SOCIAL_LAW_NOTICE_DATE: 'law.social_law_notice_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_DATE: 'law.social_law_notice_of_objection_date',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION_FILE_REFERENCE: 'law.social_law_notice_of_objection_file_reference',
    LAW_SOCIAL_LAW_NOTICE_OF_OBJECTION: 'law.social_law_notice_of_objection',
    LAW_SOCIAL_LAW_NOTIFICATION_DATE: 'law.social_law_notification_date',
    LAW_SOCIAL_LAW_NOTIFICATION_LEGAL_BASIS: 'law.social_law_notification_legal_basis',
    LAW_SOCIAL_LAW_NOTIFICATION_SOURCE: 'law.social_law_notification_source',
    LAW_SOCIAL_LAW_OBJECTION_CHALLENGED_NOTICE: 'law.social_law_objection_challenged_notice',
    LAW_SOCIAL_LAW_OBJECTION_DATE: 'law.social_law_objection_date',
    LAW_SOCIAL_LAW_OBJECTION_EVIDENCE: 'law.social_law_objection_evidence',
    LAW_SOCIAL_LAW_OBJECTION_FILE_REFERENCE: 'law.social_law_objection_file_reference',
    LAW_SOCIAL_LAW_OBJECTION: 'law.social_law_objection',
    LAW_SOCIAL_LAW_OBJECTION_REASONING: 'law.social_law_objection_reasoning',
    LAW_SOCIAL_LAW_OBJECTION_SUSPENSION_REQUEST: 'law.social_law_objection_suspension_request',
    LAW_SOCIAL_LAW_ORIGINAL_DECISION_DATE: 'law.social_law_original_decision_date',
    LAW_SOCIAL_LAW_OTHER_INCOME: 'law.social_law_other_income',
    LAW_SOCIAL_LAW_OWN_INCOME_AMOUNT: 'law.social_law_own_income_amount',
    LAW_SOCIAL_LAW_RECLAIM_AMOUNT: 'law.social_law_reclaim_amount',
    LAW_SOCIAL_LAW_RECLAIM_FILE_REFERENCE: 'law.social_law_reclaim_file_reference',
    LAW_SOCIAL_LAW_RECLAIM_LEGAL_BASIS: 'law.social_law_reclaim_legal_basis',
    LAW_SOCIAL_LAW_RECLAIM_LEGAL_NORM: 'law.social_law_reclaim_legal_norm',
    LAW_SOCIAL_LAW_RECLAIM_NOTICE_DATE: 'law.social_law_reclaim_notice_date',
    LAW_SOCIAL_LAW_RECLAIM_NOTICE: 'law.social_law_reclaim_notice',
    LAW_SOCIAL_LAW_RECLAIM_PAYMENT_DEADLINE: 'law.social_law_reclaim_payment_deadline',
    LAW_SOCIAL_LAW_RECLAIM_PAYMENT_TERMS: 'law.social_law_reclaim_payment_terms',
    LAW_SOCIAL_LAW_REGELBEDARF_AMOUNT: 'law.social_law_regelbedarf_amount',
    LAW_SOCIAL_LAW_REJECTION_FILE_REFERENCE: 'law.social_law_rejection_file_reference',
    LAW_SOCIAL_LAW_REJECTION_LEGAL_NORM: 'law.social_law_rejection_legal_norm',
    LAW_SOCIAL_LAW_REJECTION_NOTICE_DATE: 'law.social_law_rejection_notice_date',
    LAW_SOCIAL_LAW_REJECTION_NOTICE: 'law.social_law_rejection_notice',
    LAW_SOCIAL_LAW_REJECTION_REASON: 'law.social_law_rejection_reason',
    LAW_SOCIAL_LAW_RESIDENCE_STATUS: 'law.social_law_residence_status',
    LAW_SOCIAL_LAW_REVOCATION_BENEFIT_TYPE: 'law.social_law_revocation_benefit_type',
    LAW_SOCIAL_LAW_REVOCATION_FILE_REFERENCE: 'law.social_law_revocation_file_reference',
    LAW_SOCIAL_LAW_REVOCATION_LEGAL_NORM: 'law.social_law_revocation_legal_norm',
    LAW_SOCIAL_LAW_REVOCATION_NOTICE_DATE: 'law.social_law_revocation_notice_date',
    LAW_SOCIAL_LAW_REVOCATION_NOTICE: 'law.social_law_revocation_notice',
    LAW_SOCIAL_LAW_REVOCATION_PERIOD_END: 'law.social_law_revocation_period_end',
    LAW_SOCIAL_LAW_REVOCATION_PERIOD_START: 'law.social_law_revocation_period_start',
    LAW_SOCIAL_LAW_REVOCATION_REASON: 'law.social_law_revocation_reason',
    LAW_SOCIAL_LAW_REVOCATION_RECLAIM_NOTES: 'law.social_law_revocation_reclaim_notes',
    LAW_SOCIAL_LAW_SOCIAL_BENEFIT_TYPE: 'law.social_law_social_benefit_type',
    LAW_SOCIAL_LAW_SUMMARY_GROUNDS_OPPOSITION: 'law.social_law_summary_grounds_opposition',
    LAW_SOCIAL_LAW_TOTAL_NEED_AMOUNT: 'law.social_law_total_need_amount',
    LAW_SOCIAL_LAW_TOTAL_RECLAIM_AMOUNT: 'law.social_law_total_reclaim_amount',
    LAW_SOCIAL_LAW_VIOLATION_TYPE: 'law.social_law_violation_type',
    LAW_TENANCY_LAW_ADRESS_RENTAL_PROPERTY: 'law.tenancy_law_adress_rental_property',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGE: 'law.tenancy_law_advance_payment_service_charge',
    LAW_TENANCY_LAW_ADVANCE_PAYMENT_SERVICE_CHARGES: 'law.tenancy_law_advance_payment_service_charges',
    LAW_TENANCY_LAW_BANK_GUARANTEE: 'law.tenancy_law_bank_guarantee',
    LAW_TENANCY_LAW_CASH_DEPOSIT_AGREED: 'law.tenancy_law_cash_deposit_agreed',
    LAW_TENANCY_LAW_CASH_DEPOSIT_PAYMENT_DATE: 'law.tenancy_law_cash_deposit_payment_date',
    LAW_TENANCY_LAW_COMPETENT_COURT: 'law.tenancy_law_competent_court',
    LAW_TENANCY_LAW_COST_SHARE: 'law.tenancy_law_cost_share',
    LAW_TENANCY_LAW_COST_SHARES: 'law.tenancy_law_cost_shares',
    LAW_TENANCY_LAW_COUNTER_NUMBER: 'law.tenancy_law_counter_number',
    LAW_TENANCY_LAW_COURT_CASE_NUMBER: 'law.tenancy_law_court_case_number',
    LAW_TENANCY_LAW_COURT_PROCEEDINGS_PENDING: 'law.tenancy_law_court_proceedings_pending',
    LAW_TENANCY_LAW_DESCRIPTION_OF_RENTAL_PROPERTY: 'law.tenancy_law_description_of_rental_property',
    LAW_TENANCY_LAW_DURATION_OF_LEASE: 'law.tenancy_law_duration_of_lease',
    LAW_TENANCY_LAW_EXPERT_REPORT_COMMISSION_DATE: 'law.tenancy_law_expert_report_commission_date',
    LAW_TENANCY_LAW_EXPERT_REPORT_DAMAGE_DESCRIPTION: 'law.tenancy_law_expert_report_damage_description',
    LAW_TENANCY_LAW_EXPERT_REPORT_DAMAGE_NUMBER: 'law.tenancy_law_expert_report_damage_number',
    LAW_TENANCY_LAW_EXPERT_REPORT_DATE: 'law.tenancy_law_expert_report_date',
    LAW_TENANCY_LAW_EXPERT_REPORT_INSPECTION_DATE: 'law.tenancy_law_expert_report_inspection_date',
    LAW_TENANCY_LAW_EXPERT_REPORT: 'law.tenancy_law_expert_report',
    LAW_TENANCY_LAW_EXPERT_REPORT_OBJECT_ADDRESS: 'law.tenancy_law_expert_report_object_address',
    LAW_TENANCY_LAW_EXPERT_REPORT_PURPOSE: 'law.tenancy_law_expert_report_purpose',
    LAW_TENANCY_LAW_EXPERT_REPORT_REPAIR_DURATION: 'law.tenancy_law_expert_report_repair_duration',
    LAW_TENANCY_LAW_EXPERT_REPORT_SUBJECT: 'law.tenancy_law_expert_report_subject',
    LAW_TENANCY_LAW_EXTENSION_OPTION_COUNT: 'law.tenancy_law_extension_option_count',
    LAW_TENANCY_LAW_EXTENSION_OPTION_DURATION: 'law.tenancy_law_extension_option_duration',
    LAW_TENANCY_LAW_FIXED_TERM_TENANCY: 'law.tenancy_law_fixed_term_tenancy',
    LAW_TENANCY_LAW_GARAGE_AVAILABLE: 'law.tenancy_law_garage_available',
    LAW_TENANCY_LAW_GARAGE_COSTS: 'law.tenancy_law_garage_costs',
    LAW_TENANCY_LAW_GENERAL_STATUS_DOCUMENTS: 'law.tenancy_law_general_status_documents',
    LAW_TENANCY_LAW_GROSS_RENT: 'law.tenancy_law_gross_rent',
    LAW_TENANCY_LAW_HANDOVER_COUNTER: 'law.tenancy_law_handover_counter',
    LAW_TENANCY_LAW_HANDOVER_DATE: 'law.tenancy_law_handover_date',
    LAW_TENANCY_LAW_HANDOVER_DEFECTS: 'law.tenancy_law_handover_defects',
    LAW_TENANCY_LAW_HANDOVER_PROTOCOL: 'law.tenancy_law_handover_protocol',
    LAW_TENANCY_LAW_LANDLORD_TERMINATION_GIVEN: 'law.tenancy_law_landlord_termination_given',
    LAW_TENANCY_LAW_LAST_RENT_INCREASE_LETTER_DATE: 'law.tenancy_law_last_rent_increase_letter_date',
    LAW_TENANCY_LAW_LAST_SIGNATURE_DATE: 'law.tenancy_law_last_signature_date',
    LAW_TENANCY_LAW_LEASE_AGREEMENT: 'law.tenancy_law_lease_agreement',
    LAW_TENANCY_LAW_LOCATION_IN_RENTAL_PROPERTY: 'law.tenancy_law_location_in_rental_property',
    LAW_TENANCY_LAW_NET_RENT: 'law.tenancy_law_net_rent',
    LAW_TENANCY_LAW_OPERATING_COSTS_AGREEMENT: 'law.tenancy_law_operating_costs_agreement',
    LAW_TENANCY_LAW_PARKING_SPACE_AVAILABLE: 'law.tenancy_law_parking_space_available',
    LAW_TENANCY_LAW_PARKING_SPACE_COSTS: 'law.tenancy_law_parking_space_costs',
    LAW_TENANCY_LAW_PROPERTY_RETURN_DATE: 'law.tenancy_law_property_return_date',
    LAW_TENANCY_LAW_RENT_INCREASE_EFFECTIVE_DATE: 'law.tenancy_law_rent_increase_effective_date',
    LAW_TENANCY_LAW_RENT_INCREASE_NOTICE: 'law.tenancy_law_rent_increase_notice',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DATE: 'law.tenancy_law_rental_agreement_date',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_DURATION: 'law.tenancy_law_rental_agreement_duration',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT: 'law.tenancy_law_rental_agreement',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_END: 'law.tenancy_law_rental_agreement_validity_end',
    LAW_TENANCY_LAW_RENTAL_AGREEMENT_VALIDITY_START: 'law.tenancy_law_rental_agreement_validity_start',
    LAW_TENANCY_LAW_RENTAL_OBJECT_SIZE_SQM: 'law.tenancy_law_rental_object_size_sqm',
    LAW_TENANCY_LAW_REPAYMENT: 'law.tenancy_law_repayment',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_END: 'law.tenancy_law_repayment_period_end',
    LAW_TENANCY_LAW_REPAYMENT_PERIOD_START: 'law.tenancy_law_repayment_period_start',
    LAW_TENANCY_LAW_SECURITY_DEPOSIT_ADDITIONAL_REGULATIONS: 'law.tenancy_law_security_deposit_additional_regulations',
    LAW_TENANCY_LAW_SECURITY_DEPOSIT_AMOUNT: 'law.tenancy_law_security_deposit_amount',
    LAW_TENANCY_LAW_SERVICE_CHARGE_SETTLEMENT: 'law.tenancy_law_service_charge_settlement',
    LAW_TENANCY_LAW_STAGGERED_RENTAL_AGREEMENT: 'law.tenancy_law_staggered_rental_agreement',
    LAW_TENANCY_LAW_START_OF_LEASE: 'law.tenancy_law_start_of_lease',
    LAW_TENANCY_LAW_TENANCY_TERMINATED: 'law.tenancy_law_tenancy_terminated',
    LAW_TENANCY_LAW_TENANCY_TERMINATION_DATE: 'law.tenancy_law_tenancy_termination_date',
    LAW_TENANCY_LAW_TENANT_EXTENSION_OPTION: 'law.tenancy_law_tenant_extension_option',
    LAW_TENANCY_LAW_TENANT_WARNED: 'law.tenancy_law_tenant_warned',
    LAW_TENANCY_LAW_TERMINATION_DECLARED_DATE: 'law.tenancy_law_termination_declared_date',
    LAW_TENANCY_LAW_TERMINATION_LETTER_DATE: 'law.tenancy_law_termination_letter_date',
    LAW_TENANCY_LAW_TERMINATION_NOTICE: 'law.tenancy_law_termination_notice',
    LAW_TENANCY_LAW_TERMINATION_NOTICE_PERIOD: 'law.tenancy_law_termination_notice_period',
    LAW_TENANCY_LAW_TOTAL_COST_SERVICE_CHARGE: 'law.tenancy_law_total_cost_service_charge',
    LAW_TENANCY_LAW_TOTAL_RENT: 'law.tenancy_law_total_rent',
    LAW_TENANCY_LAW_UNLIMITED_TERM_TENANCY: 'law.tenancy_law_unlimited_term_tenancy',
    LAW_TENANCY_LAW_VALUE_SECURITY_CLAUSE: 'law.tenancy_law_value_security_clause',
    LAW_TENANCY_LAW_WARNING_LETTER_DATE: 'law.tenancy_law_warning_letter_date',
    LAW_TENANCY_LAW_WARNING_LETTER: 'law.tenancy_law_warning_letter',
    LAW_TOPIC: 'law.topic',
    LAW_TRAFFIC_LAW_ACCIDENT_DATE: 'law.traffic_law_accident_date',
    LAW_TRAFFIC_LAW_ACCIDENT_REPORT: 'law.traffic_law_accident_report',
    LAW_TRAFFIC_LAW_AMOUNT_OF_FINE: 'law.traffic_law_amount_of_fine',
    LAW_TRAFFIC_LAW_APPEAL_INSTRUCTION: 'law.traffic_law_appeal_instruction',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_at_fault_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_DRIVERS_LICENSE_VALID_UNTIL: 'law.traffic_law_at_fault_driver_drivers_license_valid_until',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_at_fault_driver_green_card_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_at_fault_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_at_fault_driver_insurance_number',
    LAW_TRAFFIC_LAW_AT_FAULT_DRIVER_INSURER: 'law.traffic_law_at_fault_driver_insurer',
    LAW_TRAFFIC_LAW_BLOOD_ALCOHOL_CONCENTRATION: 'law.traffic_law_blood_alcohol_concentration',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAMAGE_COSTS: 'law.traffic_law_calculated_total_damage_costs',
    LAW_TRAFFIC_LAW_CALCULATED_TOTAL_DAYS: 'law.traffic_law_calculated_total_days',
    LAW_TRAFFIC_LAW_CHARGES: 'law.traffic_law_charges',
    LAW_TRAFFIC_LAW_COST_PER_SCALE: 'law.traffic_law_cost_per_scale',
    LAW_TRAFFIC_LAW_DAILY_RATE: 'law.traffic_law_daily_rate',
    LAW_TRAFFIC_LAW_DAMAGE_AMOUNT_NET: 'law.traffic_law_damage_amount_net',
    LAW_TRAFFIC_LAW_DAMAGE_NUMBER: 'law.traffic_law_damage_number',
    LAW_TRAFFIC_LAW_DAMAGE_SCOPE: 'law.traffic_law_damage_scope',
    LAW_TRAFFIC_LAW_DATE_OF_ACCIDENT: 'law.traffic_law_date_of_accident',
    LAW_TRAFFIC_LAW_DATE_OF_CRIME: 'law.traffic_law_date_of_crime',
    LAW_TRAFFIC_LAW_DATE_OF_FINE: 'law.traffic_law_date_of_fine',
    LAW_TRAFFIC_LAW_DATE_OF_INFRACTION: 'law.traffic_law_date_of_infraction',
    LAW_TRAFFIC_LAW_DATE_OF_INSPECTION: 'law.traffic_law_date_of_inspection',
    LAW_TRAFFIC_LAW_DATE_OF_ISSUE: 'law.traffic_law_date_of_issue',
    LAW_TRAFFIC_LAW_DATE_OF_OFFENSE: 'law.traffic_law_date_of_offense',
    LAW_TRAFFIC_LAW_DATE_OF_REPORT: 'law.traffic_law_date_of_report',
    LAW_TRAFFIC_LAW_DIFFERENCIAL_TAX: 'law.traffic_law_differencial_tax',
    LAW_TRAFFIC_LAW_DRIVER_LOGBOOK_REQUIRED: 'law.traffic_law_driver_logbook_required',
    LAW_TRAFFIC_LAW_DRIVING_BAN_DURATION: 'law.traffic_law_driving_ban_duration',
    LAW_TRAFFIC_LAW_DRIVING_BAN: 'law.traffic_law_driving_ban',
    LAW_TRAFFIC_LAW_EVIDENCE_INFRACTION: 'law.traffic_law_evidence_infraction',
    LAW_TRAFFIC_LAW_EXPERT_COST: 'law.traffic_law_expert_cost',
    LAW_TRAFFIC_LAW_EXPERT_DATE: 'law.traffic_law_expert_date',
    LAW_TRAFFIC_LAW_EXPERT_REPORT: 'law.traffic_law_expert_report',
    LAW_TRAFFIC_LAW_EXPERT_REPORT_NUMBER: 'law.traffic_law_expert_report_number',
    LAW_TRAFFIC_LAW_FILE_NUMBER: 'law.traffic_law_file_number',
    LAW_TRAFFIC_LAW_FINE: 'law.traffic_law_fine',
    LAW_TRAFFIC_LAW_FINE_NOTICE: 'law.traffic_law_fine_notice',
    LAW_TRAFFIC_LAW_GROSS_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_gross_replacement_value',
    LAW_TRAFFIC_LAW_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_gross_replacement_value',
    LAW_TRAFFIC_LAW_INJURED: 'law.traffic_law_injured',
    LAW_TRAFFIC_LAW_INSURANCE_HOLDER: 'law.traffic_law_insurance_holder',
    LAW_TRAFFIC_LAW_INSURANCE: 'law.traffic_law_insurance',
    LAW_TRAFFIC_LAW_INSURANCE_POLICY_NUMBER: 'law.traffic_law_insurance_policy_number',
    LAW_TRAFFIC_LAW_LEGAL_BASIS_INFRACTION: 'law.traffic_law_legal_basis_infraction',
    LAW_TRAFFIC_LAW_LEGAL_BASIS: 'law.traffic_law_legal_basis',
    LAW_TRAFFIC_LAW_LICENSEPLATE_AT_FAULT_DRIVER: 'law.traffic_law_licenseplate_at_fault_driver',
    LAW_TRAFFIC_LAW_LICENSEPLATE: 'law.traffic_law_licenseplate',
    LAW_TRAFFIC_LAW_LICENSEPLATE_VICTIM_DRIVER: 'law.traffic_law_licenseplate_victim_driver',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_REPAIR_CASE: 'law.traffic_law_loss_amount_repair_case',
    LAW_TRAFFIC_LAW_LOSS_AMOUNT_TOTAL_DAMAGE_CASE: 'law.traffic_law_loss_amount_total_damage_case',
    LAW_TRAFFIC_LAW_LOSS_OF_USE_PER_DAY: 'law.traffic_law_loss_of_use_per_day',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_AT_FAULT_DRIVER: 'law.traffic_law_mark_and_type_of_at_fault_driver',
    LAW_TRAFFIC_LAW_MARK_AND_TYPE_OF_VICTIM_DRIVER: 'law.traffic_law_mark_and_type_of_victim_driver',
    LAW_TRAFFIC_LAW_MERANTILE_VALUE_LOSS: 'law.traffic_law_merantile_value_loss',
    LAW_TRAFFIC_LAW_NET_GROSS_REPLACEMENT_VALUE: 'law.traffic_law_net_gross_replacement_value',
    LAW_TRAFFIC_LAW_NET_REPLACEMENT_VALUE: 'law.traffic_law_net_replacement_value',
    LAW_TRAFFIC_LAW_NUMBER_OF_DAILY_RATES: 'law.traffic_law_number_of_daily_rates',
    LAW_TRAFFIC_LAW_OFFENSE_INFRACTION_DESCRIPTION: 'law.traffic_law_offense_infraction_description',
    LAW_TRAFFIC_LAW_OTHER_DAMAGES: 'law.traffic_law_other_damages',
    LAW_TRAFFIC_LAW_PAYMENT_DEADLINE: 'law.traffic_law_payment_deadline',
    LAW_TRAFFIC_LAW_PENALTY_ORDER: 'law.traffic_law_penalty_order',
    LAW_TRAFFIC_LAW_PLACE_OF_ACCIDENT: 'law.traffic_law_place_of_accident',
    LAW_TRAFFIC_LAW_PLACE_OF_CRIME: 'law.traffic_law_place_of_crime',
    LAW_TRAFFIC_LAW_PLACE_OF_INFRACTION: 'law.traffic_law_place_of_infraction',
    LAW_TRAFFIC_LAW_PLACE_OF_INSPECTION: 'law.traffic_law_place_of_inspection',
    LAW_TRAFFIC_LAW_PLACE_OF_ISSUE: 'law.traffic_law_place_of_issue',
    LAW_TRAFFIC_LAW_PLACE_OF_OFFENSE: 'law.traffic_law_place_of_offense',
    LAW_TRAFFIC_LAW_POINTS_FOR_OFFENSE: 'law.traffic_law_points_for_offense',
    LAW_TRAFFIC_LAW_POLICE_CASE_NUMBER: 'law.traffic_law_police_case_number',
    LAW_TRAFFIC_LAW_PROCEDURE_COSTS: 'law.traffic_law_procedure_costs',
    LAW_TRAFFIC_LAW_PROSECUTION_NUMBER: 'law.traffic_law_prosecution_number',
    LAW_TRAFFIC_LAW_REGULAR_TAX: 'law.traffic_law_regular_tax',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITH_VAT: 'law.traffic_law_repair_costs_with_vat',
    LAW_TRAFFIC_LAW_REPAIR_COSTS_WITHOUT_VAT: 'law.traffic_law_repair_costs_without_vat',
    LAW_TRAFFIC_LAW_REPAIR_DAMAGE: 'law.traffic_law_repair_damage',
    LAW_TRAFFIC_LAW_REPAIR_DURATION: 'law.traffic_law_repair_duration',
    LAW_TRAFFIC_LAW_REPLACEMENT_COST: 'law.traffic_law_replacement_cost',
    LAW_TRAFFIC_LAW_REPLACEMENT_VALUE: 'law.traffic_law_replacement_value',
    LAW_TRAFFIC_LAW_REREGISTRATION_COST: 'law.traffic_law_reregistration_cost',
    LAW_TRAFFIC_LAW_RESIDUAL_VALUE: 'law.traffic_law_residual_value',
    LAW_TRAFFIC_LAW_SPEED_ALLOWED: 'law.traffic_law_speed_allowed',
    LAW_TRAFFIC_LAW_SPEED_DRIVEN: 'law.traffic_law_speed_driven',
    LAW_TRAFFIC_LAW_SPEED_TOO_HIGH: 'law.traffic_law_speed_too_high',
    LAW_TRAFFIC_LAW_TIME_OF_ACCIDENT: 'law.traffic_law_time_of_accident',
    LAW_TRAFFIC_LAW_TIME_OF_CRIME: 'law.traffic_law_time_of_crime',
    LAW_TRAFFIC_LAW_TIME_OF_INFRACTION: 'law.traffic_law_time_of_infraction',
    LAW_TRAFFIC_LAW_TIME_OF_INSPECTION: 'law.traffic_law_time_of_inspection',
    LAW_TRAFFIC_LAW_TIME_OF_ISSUE: 'law.traffic_law_time_of_issue',
    LAW_TRAFFIC_LAW_TIME_OF_OFFENSE: 'law.traffic_law_time_of_offense',
    LAW_TRAFFIC_LAW_TOTAL_DAMAGE: 'law.traffic_law_total_damage',
    LAW_TRAFFIC_LAW_VALUE_IMPROVEMENT: 'law.traffic_law_value_improvement',
    LAW_TRAFFIC_LAW_VEHICLE_AGE_MONTHS: 'law.traffic_law_vehicle_age_months',
    LAW_TRAFFIC_LAW_VEHICLE_MILEAGE: 'law.traffic_law_vehicle_mileage',
    LAW_TRAFFIC_LAW_VEHICLE_TYPE_AND_BRAND: 'law.traffic_law_vehicle_type_and_brand',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_DRIVERS_LICENSE_ISSUED_BY: 'law.traffic_law_victim_driver_drivers_license_issued_by',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_GREEN_CARD_NUMBER: 'law.traffic_law_victim_driver_green_card_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_EXPIRY_DATE: 'law.traffic_law_victim_driver_insurance_expiry_date',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURANCE_NUMBER: 'law.traffic_law_victim_driver_insurance_number',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_INSURER: 'law.traffic_law_victim_driver_insurer',
    LAW_TRAFFIC_LAW_VICTIM_DRIVER_LICENSE_VALID_UNTIL: 'law.traffic_law_victim_driver_license_valid_until',
    LAW_TRAFFIC_LAW_VIOLATED_SECTION: 'law.traffic_law_violated_section',
    LAW_TRAFFIC_LAW_VIOLATION_TYPE: 'law.traffic_law_violation_type',
    LAW_TRAFFIC_LAW_WARNING_FEE_INFRACTION: 'law.traffic_law_warning_fee_infraction',
    LAW_TRAFFIC_LAW_WARNING_NOTICE: 'law.traffic_law_warning_notice'
} as const;

/**
 * * `multiselect` - Multiple choice
 * * `select` - Single choice
 * * `textarea` - Long text
 * * `filefield` - File input
 * * `multifilefield` - Multi file input
 * * `timefield` - Time field
 * * `decimalnumberinput` - Decimal number
 * * `datefield` - Date
 * * `textinput` - Short text
 * * `numberinput` - Number
 * * `emailinput` - Email
 * * `phoneinput` - Phone
 * * `urlinput` - URL
 * * `yesno` - Yes/No
 */
export type QuestionnaireQuestionTypeEnum = 'multiselect' | 'select' | 'textarea' | 'filefield' | 'multifilefield' | 'timefield' | 'decimalnumberinput' | 'datefield' | 'textinput' | 'numberinput' | 'emailinput' | 'phoneinput' | 'urlinput' | 'yesno';

/**
 * * `multiselect` - Multiple choice
 * * `select` - Single choice
 * * `textarea` - Long text
 * * `filefield` - File input
 * * `multifilefield` - Multi file input
 * * `timefield` - Time field
 * * `decimalnumberinput` - Decimal number
 * * `datefield` - Date
 * * `textinput` - Short text
 * * `numberinput` - Number
 * * `emailinput` - Email
 * * `phoneinput` - Phone
 * * `urlinput` - URL
 * * `yesno` - Yes/No
 */
export const QuestionnaireQuestionTypeEnum = {
    MULTISELECT: 'multiselect',
    SELECT: 'select',
    TEXTAREA: 'textarea',
    FILEFIELD: 'filefield',
    MULTIFILEFIELD: 'multifilefield',
    TIMEFIELD: 'timefield',
    DECIMALNUMBERINPUT: 'decimalnumberinput',
    DATEFIELD: 'datefield',
    TEXTINPUT: 'textinput',
    NUMBERINPUT: 'numberinput',
    EMAILINPUT: 'emailinput',
    PHONEINPUT: 'phoneinput',
    URLINPUT: 'urlinput',
    YESNO: 'yesno'
} as const;

export type QuestionnaireSection = {
    uuid: string;
    items: Array<QuestionnaireQuestion>;
    title: string;
    type?: QuestionnaireSectionTypeEnum;
    participant_type?: string | null;
    repeatable?: boolean;
    min_repetitions?: number | null;
    max_repetitions?: number | null;
};

export type QuestionnaireSectionRequest = {
    uuid: string;
    items: Array<QuestionnaireQuestionRequest>;
    title: string;
    type?: QuestionnaireSectionTypeEnum;
    participant_type?: string | null;
    repeatable?: boolean;
    min_repetitions?: number | null;
    max_repetitions?: number | null;
};

/**
 * * `law_specific` - Law-specific
 * * `participant` - Participant
 */
export type QuestionnaireSectionTypeEnum = 'law_specific' | 'participant';

/**
 * * `law_specific` - Law-specific
 * * `participant` - Participant
 */
export const QuestionnaireSectionTypeEnum = {
    LAW_SPECIFIC: 'law_specific',
    PARTICIPANT: 'participant'
} as const;

/**
 * Serializer for questionnaire submission responses.
 */
export type QuestionnaireSubmission = {
    readonly id: number;
    readonly created_at: string;
    readonly org_id: number;
    readonly user_id: number | null;
    readonly case_id: number | null;
    readonly short_id: string;
    readonly third_party_access_token: string;
    readonly token: string;
    readonly is_third_party_questionnaire: boolean;
};

export type RaMicroApiDataRequest = {
    entities_with_relationships: Array<(string)>;
    fileData?: Array<FileDataRequest>;
};

export type RaMicroDataRequest = {
    entities_with_relationships: Array<(string)>;
};

/**
 * * `DOWNLOAD` - Oma Download
 * * `OMA_EMAIL` - Oma Email
 */
export type RaMicroExportIntegrationTypeEnum = 'DOWNLOAD' | 'OMA_EMAIL';

/**
 * * `DOWNLOAD` - Oma Download
 * * `OMA_EMAIL` - Oma Email
 */
export const RaMicroExportIntegrationTypeEnum = {
    DOWNLOAD: 'DOWNLOAD',
    OMA_EMAIL: 'OMA_EMAIL'
} as const;

/**
 * * `INSTRUCTIONS_NOT_FOLLOWED` - Instructions Not Followed
 * * `PAYLOAD_NOT_CORRECT` - Payload Not Correct
 * * `ACTION_NOT_NEEDED` - Action Not Needed
 * * `OTHER` - Other
 */
export type RatingNegativeVariantEnum = 'INSTRUCTIONS_NOT_FOLLOWED' | 'PAYLOAD_NOT_CORRECT' | 'ACTION_NOT_NEEDED' | 'OTHER';

/**
 * * `INSTRUCTIONS_NOT_FOLLOWED` - Instructions Not Followed
 * * `PAYLOAD_NOT_CORRECT` - Payload Not Correct
 * * `ACTION_NOT_NEEDED` - Action Not Needed
 * * `OTHER` - Other
 */
export const RatingNegativeVariantEnum = {
    INSTRUCTIONS_NOT_FOLLOWED: 'INSTRUCTIONS_NOT_FOLLOWED',
    PAYLOAD_NOT_CORRECT: 'PAYLOAD_NOT_CORRECT',
    ACTION_NOT_NEEDED: 'ACTION_NOT_NEEDED',
    OTHER: 'OTHER'
} as const;

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.foreigners_authority` - Foreigners Authority
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.principal_client` - Principal Client
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 * * `entities.defendant_representative` - Defendant Representative
 * * `entities.plaintiff_representative` - Plaintiff Representative
 * * `entities.community_of_homeowners` - Community Of Homeowners
 * * `entities.fractional_owner` - Fractional Owner
 * * `entities.joint_debtor` - Joint Debtor
 * * `entities.joint_creditor` - Joint Creditor
 * * `entities.application_respondent` - Application Respondent
 * * `entities.hereditary_building_grantor` - Hereditary Building Grantor
 * * `entities.professional_liability_insurance` - Professional Liability Insurance
 * * `entities.building_owners_association` - Building Owners Association
 * * `entities.landlord_association` - Landlord Association
 * * `entities.landlord_community` - Landlord Community
 * * `entities.special_property_manager` - Special Property Manager
 * * `entities.house_manager` - House Manager
 * * `entities.appellant` - Appellant
 * * `entities.appellee` - Appellee
 * * `entities.counter_claimant` - Counter Claimant
 * * `entities.counter_defendant` - Counter Defendant
 * * `entities.doctor` - Doctor
 * * `entities.legal_guardian` - Legal Guardian
 * * `entities.guardian` - Guardian
 * * `entities.caretaker` - Caretaker
 * * `entities.youth_welfare_office` - Youth Welfare Office
 * * `entities.foster_parent` - Foster Parent
 * * `entities.parent` - Parent
 * * `entities.maintenance_obligor` - Maintenance Obligor
 * * `entities.beneficiary` - Beneficiary
 * * `entities.administrative_assistant` - Administrative Assistant
 * * `entities.case_worker` - Case Worker
 * * `entities.managing_director` - Managing Director
 * * `entities.shareholder` - Shareholder
 * * `entities.supervisory_board` - Supervisory Board
 * * `entities.commercial_agent` - Commercial Agent
 * * `entities.limited_partner` - Limited Partner
 * * `entities.authorized_signatory` - Authorized Signatory
 * * `entities.social_security_office` - Social Security Office
 * * `entities.employment_agency` - Employment Agency
 * * `entities.job_center` - Job Center
 * * `entities.pension_insurance` - Pension Insurance
 * * `entities.health_insurance` - Health Insurance
 * * `entities.disability_office` - Disability Office
 * * `entities.social_court` - Social Court
 * * `entities.medical_service` - Medical Service
 * * `entities.rehabilitation_provider` - Rehabilitation Provider
 * * `entities.patient` - Patient
 * * `entities.medical_institution` - Medical Institution
 * * `entities.legal_assistant` - Legal Assistant
 * * `entities.tax_authority` - Tax Authority
 * * `entities.affected_person` - Affected Person
 * * `entities.opponent_insurance` - Opponent Insurance
 * * `entities.workshop` - Workshop
 * * `entities.joint_plaintiff` - Joint Plaintiff
 */
export type RelationshipTypeEnum = 'entities.opponent' | 'entities.client' | 'entities.other' | 'entities.labor_law_employee' | 'entities.labor_law_employer' | 'entities.witness' | 'entities.at_fault_driver' | 'entities.victim_driver' | 'entities.accused' | 'entities.defendant' | 'entities.plaintiff' | 'entities.complaint' | 'entities.victim' | 'entities.vehicle_expert' | 'entities.agency' | 'entities.foreigners_authority' | 'entities.vehicle_owner' | 'entities.insurance' | 'entities.driver' | 'entities.police_officer' | 'entities.police_station' | 'entities.judge' | 'entities.court' | 'entities.prosecutor' | 'entities.public_prosecutor' | 'entities.opposing_counsel' | 'entities.co_plaintiff' | 'entities.probation_officer' | 'entities.tenant' | 'entities.landlord' | 'entities.subtenant' | 'entities.owner' | 'entities.property_management' | 'entities.real_estate_agent' | 'entities.guarantor' | 'entities.co_owner' | 'entities.co_tenant' | 'entities.tenants_association' | 'entities.property_owners_association' | 'entities.complainant' | 'entities.applicant' | 'entities.respondent' | 'entities.principal_client' | 'entities.child' | 'entities.officiant' | 'entities.wife' | 'entities.husband' | 'entities.legal_representative' | 'entities.korrespondence_lawyer' | 'entities.opposing_lawyer' | 'entities.lawyer' | 'entities.legal_expenses_insurance' | 'entities.liability_insurance' | 'entities.first_instance_court' | 'entities.second_instance_court' | 'entities.third_instance_court' | 'entities.contact_person' | 'entities.third_party_debtor' | 'entities.road_traffic_office' | 'entities.debt_collection_agency' | 'entities.expert' | 'entities.tax_office' | 'entities.land_registry' | 'entities.bank' | 'entities.buyer' | 'entities.dunning_court' | 'entities.enforcement_court' | 'entities.general_prosecutor' | 'entities.seller' | 'entities.expert_committee' | 'entities.municipality' | 'entities.administrator' | 'entities.register_court' | 'entities.probate_court' | 'entities.registry_office' | 'entities.hereditary_leaseholder' | 'entities.legal_aid_court' | 'entities.secondary_client' | 'entities.secondary_opponent' | 'entities.court_complaint' | 'entities.fine_authority' | 'entities.resident_registration_office' | 'entities.investigator' | 'entities.bailiff' | 'entities.insolvency_court' | 'entities.integration_office' | 'entities.execution_organ' | 'entities.debtor' | 'entities.creditor' | 'entities.lessee' | 'entities.lessor' | 'entities.principal' | 'entities.authorized_representative' | 'entities.testator' | 'entities.heir' | 'entities.preliminary_heir' | 'entities.subsequent_heir' | 'entities.curator_of_the_estate' | 'entities.executor_of_the_will' | 'entities.estate_administrator' | 'entities.compulsory_portion_beneficiary' | 'entities.notary' | 'entities.trustee' | 'entities.insolvency_administrator' | 'entities.defendant_representative' | 'entities.plaintiff_representative' | 'entities.community_of_homeowners' | 'entities.fractional_owner' | 'entities.joint_debtor' | 'entities.joint_creditor' | 'entities.application_respondent' | 'entities.hereditary_building_grantor' | 'entities.professional_liability_insurance' | 'entities.building_owners_association' | 'entities.landlord_association' | 'entities.landlord_community' | 'entities.special_property_manager' | 'entities.house_manager' | 'entities.appellant' | 'entities.appellee' | 'entities.counter_claimant' | 'entities.counter_defendant' | 'entities.doctor' | 'entities.legal_guardian' | 'entities.guardian' | 'entities.caretaker' | 'entities.youth_welfare_office' | 'entities.foster_parent' | 'entities.parent' | 'entities.maintenance_obligor' | 'entities.beneficiary' | 'entities.administrative_assistant' | 'entities.case_worker' | 'entities.managing_director' | 'entities.shareholder' | 'entities.supervisory_board' | 'entities.commercial_agent' | 'entities.limited_partner' | 'entities.authorized_signatory' | 'entities.social_security_office' | 'entities.employment_agency' | 'entities.job_center' | 'entities.pension_insurance' | 'entities.health_insurance' | 'entities.disability_office' | 'entities.social_court' | 'entities.medical_service' | 'entities.rehabilitation_provider' | 'entities.patient' | 'entities.medical_institution' | 'entities.legal_assistant' | 'entities.tax_authority' | 'entities.affected_person' | 'entities.opponent_insurance' | 'entities.workshop' | 'entities.joint_plaintiff';

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.foreigners_authority` - Foreigners Authority
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.principal_client` - Principal Client
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 * * `entities.defendant_representative` - Defendant Representative
 * * `entities.plaintiff_representative` - Plaintiff Representative
 * * `entities.community_of_homeowners` - Community Of Homeowners
 * * `entities.fractional_owner` - Fractional Owner
 * * `entities.joint_debtor` - Joint Debtor
 * * `entities.joint_creditor` - Joint Creditor
 * * `entities.application_respondent` - Application Respondent
 * * `entities.hereditary_building_grantor` - Hereditary Building Grantor
 * * `entities.professional_liability_insurance` - Professional Liability Insurance
 * * `entities.building_owners_association` - Building Owners Association
 * * `entities.landlord_association` - Landlord Association
 * * `entities.landlord_community` - Landlord Community
 * * `entities.special_property_manager` - Special Property Manager
 * * `entities.house_manager` - House Manager
 * * `entities.appellant` - Appellant
 * * `entities.appellee` - Appellee
 * * `entities.counter_claimant` - Counter Claimant
 * * `entities.counter_defendant` - Counter Defendant
 * * `entities.doctor` - Doctor
 * * `entities.legal_guardian` - Legal Guardian
 * * `entities.guardian` - Guardian
 * * `entities.caretaker` - Caretaker
 * * `entities.youth_welfare_office` - Youth Welfare Office
 * * `entities.foster_parent` - Foster Parent
 * * `entities.parent` - Parent
 * * `entities.maintenance_obligor` - Maintenance Obligor
 * * `entities.beneficiary` - Beneficiary
 * * `entities.administrative_assistant` - Administrative Assistant
 * * `entities.case_worker` - Case Worker
 * * `entities.managing_director` - Managing Director
 * * `entities.shareholder` - Shareholder
 * * `entities.supervisory_board` - Supervisory Board
 * * `entities.commercial_agent` - Commercial Agent
 * * `entities.limited_partner` - Limited Partner
 * * `entities.authorized_signatory` - Authorized Signatory
 * * `entities.social_security_office` - Social Security Office
 * * `entities.employment_agency` - Employment Agency
 * * `entities.job_center` - Job Center
 * * `entities.pension_insurance` - Pension Insurance
 * * `entities.health_insurance` - Health Insurance
 * * `entities.disability_office` - Disability Office
 * * `entities.social_court` - Social Court
 * * `entities.medical_service` - Medical Service
 * * `entities.rehabilitation_provider` - Rehabilitation Provider
 * * `entities.patient` - Patient
 * * `entities.medical_institution` - Medical Institution
 * * `entities.legal_assistant` - Legal Assistant
 * * `entities.tax_authority` - Tax Authority
 * * `entities.affected_person` - Affected Person
 * * `entities.opponent_insurance` - Opponent Insurance
 * * `entities.workshop` - Workshop
 * * `entities.joint_plaintiff` - Joint Plaintiff
 */
export const RelationshipTypeEnum = {
    ENTITIES_OPPONENT: 'entities.opponent',
    ENTITIES_CLIENT: 'entities.client',
    ENTITIES_OTHER: 'entities.other',
    ENTITIES_LABOR_LAW_EMPLOYEE: 'entities.labor_law_employee',
    ENTITIES_LABOR_LAW_EMPLOYER: 'entities.labor_law_employer',
    ENTITIES_WITNESS: 'entities.witness',
    ENTITIES_AT_FAULT_DRIVER: 'entities.at_fault_driver',
    ENTITIES_VICTIM_DRIVER: 'entities.victim_driver',
    ENTITIES_ACCUSED: 'entities.accused',
    ENTITIES_DEFENDANT: 'entities.defendant',
    ENTITIES_PLAINTIFF: 'entities.plaintiff',
    ENTITIES_COMPLAINT: 'entities.complaint',
    ENTITIES_VICTIM: 'entities.victim',
    ENTITIES_VEHICLE_EXPERT: 'entities.vehicle_expert',
    ENTITIES_AGENCY: 'entities.agency',
    ENTITIES_FOREIGNERS_AUTHORITY: 'entities.foreigners_authority',
    ENTITIES_VEHICLE_OWNER: 'entities.vehicle_owner',
    ENTITIES_INSURANCE: 'entities.insurance',
    ENTITIES_DRIVER: 'entities.driver',
    ENTITIES_POLICE_OFFICER: 'entities.police_officer',
    ENTITIES_POLICE_STATION: 'entities.police_station',
    ENTITIES_JUDGE: 'entities.judge',
    ENTITIES_COURT: 'entities.court',
    ENTITIES_PROSECUTOR: 'entities.prosecutor',
    ENTITIES_PUBLIC_PROSECUTOR: 'entities.public_prosecutor',
    ENTITIES_OPPOSING_COUNSEL: 'entities.opposing_counsel',
    ENTITIES_CO_PLAINTIFF: 'entities.co_plaintiff',
    ENTITIES_PROBATION_OFFICER: 'entities.probation_officer',
    ENTITIES_TENANT: 'entities.tenant',
    ENTITIES_LANDLORD: 'entities.landlord',
    ENTITIES_SUBTENANT: 'entities.subtenant',
    ENTITIES_OWNER: 'entities.owner',
    ENTITIES_PROPERTY_MANAGEMENT: 'entities.property_management',
    ENTITIES_REAL_ESTATE_AGENT: 'entities.real_estate_agent',
    ENTITIES_GUARANTOR: 'entities.guarantor',
    ENTITIES_CO_OWNER: 'entities.co_owner',
    ENTITIES_CO_TENANT: 'entities.co_tenant',
    ENTITIES_TENANTS_ASSOCIATION: 'entities.tenants_association',
    ENTITIES_PROPERTY_OWNERS_ASSOCIATION: 'entities.property_owners_association',
    ENTITIES_COMPLAINANT: 'entities.complainant',
    ENTITIES_APPLICANT: 'entities.applicant',
    ENTITIES_RESPONDENT: 'entities.respondent',
    ENTITIES_PRINCIPAL_CLIENT: 'entities.principal_client',
    ENTITIES_CHILD: 'entities.child',
    ENTITIES_OFFICIANT: 'entities.officiant',
    ENTITIES_WIFE: 'entities.wife',
    ENTITIES_HUSBAND: 'entities.husband',
    ENTITIES_LEGAL_REPRESENTATIVE: 'entities.legal_representative',
    ENTITIES_KORRESPONDENCE_LAWYER: 'entities.korrespondence_lawyer',
    ENTITIES_OPPOSING_LAWYER: 'entities.opposing_lawyer',
    ENTITIES_LAWYER: 'entities.lawyer',
    ENTITIES_LEGAL_EXPENSES_INSURANCE: 'entities.legal_expenses_insurance',
    ENTITIES_LIABILITY_INSURANCE: 'entities.liability_insurance',
    ENTITIES_FIRST_INSTANCE_COURT: 'entities.first_instance_court',
    ENTITIES_SECOND_INSTANCE_COURT: 'entities.second_instance_court',
    ENTITIES_THIRD_INSTANCE_COURT: 'entities.third_instance_court',
    ENTITIES_CONTACT_PERSON: 'entities.contact_person',
    ENTITIES_THIRD_PARTY_DEBTOR: 'entities.third_party_debtor',
    ENTITIES_ROAD_TRAFFIC_OFFICE: 'entities.road_traffic_office',
    ENTITIES_DEBT_COLLECTION_AGENCY: 'entities.debt_collection_agency',
    ENTITIES_EXPERT: 'entities.expert',
    ENTITIES_TAX_OFFICE: 'entities.tax_office',
    ENTITIES_LAND_REGISTRY: 'entities.land_registry',
    ENTITIES_BANK: 'entities.bank',
    ENTITIES_BUYER: 'entities.buyer',
    ENTITIES_DUNNING_COURT: 'entities.dunning_court',
    ENTITIES_ENFORCEMENT_COURT: 'entities.enforcement_court',
    ENTITIES_GENERAL_PROSECUTOR: 'entities.general_prosecutor',
    ENTITIES_SELLER: 'entities.seller',
    ENTITIES_EXPERT_COMMITTEE: 'entities.expert_committee',
    ENTITIES_MUNICIPALITY: 'entities.municipality',
    ENTITIES_ADMINISTRATOR: 'entities.administrator',
    ENTITIES_REGISTER_COURT: 'entities.register_court',
    ENTITIES_PROBATE_COURT: 'entities.probate_court',
    ENTITIES_REGISTRY_OFFICE: 'entities.registry_office',
    ENTITIES_HEREDITARY_LEASEHOLDER: 'entities.hereditary_leaseholder',
    ENTITIES_LEGAL_AID_COURT: 'entities.legal_aid_court',
    ENTITIES_SECONDARY_CLIENT: 'entities.secondary_client',
    ENTITIES_SECONDARY_OPPONENT: 'entities.secondary_opponent',
    ENTITIES_COURT_COMPLAINT: 'entities.court_complaint',
    ENTITIES_FINE_AUTHORITY: 'entities.fine_authority',
    ENTITIES_RESIDENT_REGISTRATION_OFFICE: 'entities.resident_registration_office',
    ENTITIES_INVESTIGATOR: 'entities.investigator',
    ENTITIES_BAILIFF: 'entities.bailiff',
    ENTITIES_INSOLVENCY_COURT: 'entities.insolvency_court',
    ENTITIES_INTEGRATION_OFFICE: 'entities.integration_office',
    ENTITIES_EXECUTION_ORGAN: 'entities.execution_organ',
    ENTITIES_DEBTOR: 'entities.debtor',
    ENTITIES_CREDITOR: 'entities.creditor',
    ENTITIES_LESSEE: 'entities.lessee',
    ENTITIES_LESSOR: 'entities.lessor',
    ENTITIES_PRINCIPAL: 'entities.principal',
    ENTITIES_AUTHORIZED_REPRESENTATIVE: 'entities.authorized_representative',
    ENTITIES_TESTATOR: 'entities.testator',
    ENTITIES_HEIR: 'entities.heir',
    ENTITIES_PRELIMINARY_HEIR: 'entities.preliminary_heir',
    ENTITIES_SUBSEQUENT_HEIR: 'entities.subsequent_heir',
    ENTITIES_CURATOR_OF_THE_ESTATE: 'entities.curator_of_the_estate',
    ENTITIES_EXECUTOR_OF_THE_WILL: 'entities.executor_of_the_will',
    ENTITIES_ESTATE_ADMINISTRATOR: 'entities.estate_administrator',
    ENTITIES_COMPULSORY_PORTION_BENEFICIARY: 'entities.compulsory_portion_beneficiary',
    ENTITIES_NOTARY: 'entities.notary',
    ENTITIES_TRUSTEE: 'entities.trustee',
    ENTITIES_INSOLVENCY_ADMINISTRATOR: 'entities.insolvency_administrator',
    ENTITIES_DEFENDANT_REPRESENTATIVE: 'entities.defendant_representative',
    ENTITIES_PLAINTIFF_REPRESENTATIVE: 'entities.plaintiff_representative',
    ENTITIES_COMMUNITY_OF_HOMEOWNERS: 'entities.community_of_homeowners',
    ENTITIES_FRACTIONAL_OWNER: 'entities.fractional_owner',
    ENTITIES_JOINT_DEBTOR: 'entities.joint_debtor',
    ENTITIES_JOINT_CREDITOR: 'entities.joint_creditor',
    ENTITIES_APPLICATION_RESPONDENT: 'entities.application_respondent',
    ENTITIES_HEREDITARY_BUILDING_GRANTOR: 'entities.hereditary_building_grantor',
    ENTITIES_PROFESSIONAL_LIABILITY_INSURANCE: 'entities.professional_liability_insurance',
    ENTITIES_BUILDING_OWNERS_ASSOCIATION: 'entities.building_owners_association',
    ENTITIES_LANDLORD_ASSOCIATION: 'entities.landlord_association',
    ENTITIES_LANDLORD_COMMUNITY: 'entities.landlord_community',
    ENTITIES_SPECIAL_PROPERTY_MANAGER: 'entities.special_property_manager',
    ENTITIES_HOUSE_MANAGER: 'entities.house_manager',
    ENTITIES_APPELLANT: 'entities.appellant',
    ENTITIES_APPELLEE: 'entities.appellee',
    ENTITIES_COUNTER_CLAIMANT: 'entities.counter_claimant',
    ENTITIES_COUNTER_DEFENDANT: 'entities.counter_defendant',
    ENTITIES_DOCTOR: 'entities.doctor',
    ENTITIES_LEGAL_GUARDIAN: 'entities.legal_guardian',
    ENTITIES_GUARDIAN: 'entities.guardian',
    ENTITIES_CARETAKER: 'entities.caretaker',
    ENTITIES_YOUTH_WELFARE_OFFICE: 'entities.youth_welfare_office',
    ENTITIES_FOSTER_PARENT: 'entities.foster_parent',
    ENTITIES_PARENT: 'entities.parent',
    ENTITIES_MAINTENANCE_OBLIGOR: 'entities.maintenance_obligor',
    ENTITIES_BENEFICIARY: 'entities.beneficiary',
    ENTITIES_ADMINISTRATIVE_ASSISTANT: 'entities.administrative_assistant',
    ENTITIES_CASE_WORKER: 'entities.case_worker',
    ENTITIES_MANAGING_DIRECTOR: 'entities.managing_director',
    ENTITIES_SHAREHOLDER: 'entities.shareholder',
    ENTITIES_SUPERVISORY_BOARD: 'entities.supervisory_board',
    ENTITIES_COMMERCIAL_AGENT: 'entities.commercial_agent',
    ENTITIES_LIMITED_PARTNER: 'entities.limited_partner',
    ENTITIES_AUTHORIZED_SIGNATORY: 'entities.authorized_signatory',
    ENTITIES_SOCIAL_SECURITY_OFFICE: 'entities.social_security_office',
    ENTITIES_EMPLOYMENT_AGENCY: 'entities.employment_agency',
    ENTITIES_JOB_CENTER: 'entities.job_center',
    ENTITIES_PENSION_INSURANCE: 'entities.pension_insurance',
    ENTITIES_HEALTH_INSURANCE: 'entities.health_insurance',
    ENTITIES_DISABILITY_OFFICE: 'entities.disability_office',
    ENTITIES_SOCIAL_COURT: 'entities.social_court',
    ENTITIES_MEDICAL_SERVICE: 'entities.medical_service',
    ENTITIES_REHABILITATION_PROVIDER: 'entities.rehabilitation_provider',
    ENTITIES_PATIENT: 'entities.patient',
    ENTITIES_MEDICAL_INSTITUTION: 'entities.medical_institution',
    ENTITIES_LEGAL_ASSISTANT: 'entities.legal_assistant',
    ENTITIES_TAX_AUTHORITY: 'entities.tax_authority',
    ENTITIES_AFFECTED_PERSON: 'entities.affected_person',
    ENTITIES_OPPONENT_INSURANCE: 'entities.opponent_insurance',
    ENTITIES_WORKSHOP: 'entities.workshop',
    ENTITIES_JOINT_PLAINTIFF: 'entities.joint_plaintiff'
} as const;

/**
 * Serializer for a single reorganization operation.
 */
export type ReorganizationOperationRequest = {
    /**
     * Type of reorganization operation
     *
     * * `merge` - Merge
     * * `split` - Split
     * * `reorganize` - Reorganize
     */
    operation_type: OperationTypeEnum;
    /**
     * UUIDs of documents to be reorganized
     */
    old_document_uuids: Array<(string)>;
    /**
     * Data for the new documents after reorganization
     */
    new_document_data: {
        [key: string]: unknown;
    };
};

export type ReplaceableVariables = {
    placeholders?: PlaceholderValueSuggestions | null;
    blocks?: BlockEvaluation | null;
};

/**
 * Serializer for form data in request/form endpoint.
 */
export type RequestForm = {
    readonly id: string;
    title?: string;
    description?: string;
    tag?: FormTag | BlankEnum;
    readonly documentProperties: DocumentProperties;
};

/**
 * * `document` - Document
 * * `word_template` - Word Template
 */
export type ResourceTypeEnum = 'document' | 'word_template';

/**
 * * `document` - Document
 * * `word_template` - Word Template
 */
export const ResourceTypeEnum = {
    DOCUMENT: 'document',
    WORD_TEMPLATE: 'word_template'
} as const;

/**
 * * `LAWYER` - Anwalt
 * * `ADMIN` - Kanzlei-Administrator
 * * `CLERK` - Sachbearbeiter
 * * `CLIENT` - Mandant
 */
export type Role5ccEnum = 'LAWYER' | 'ADMIN' | 'CLERK' | 'CLIENT';

/**
 * * `LAWYER` - Anwalt
 * * `ADMIN` - Kanzlei-Administrator
 * * `CLERK` - Sachbearbeiter
 * * `CLIENT` - Mandant
 */
export const Role5ccEnum = {
    LAWYER: 'LAWYER',
    ADMIN: 'ADMIN',
    CLERK: 'CLERK',
    CLIENT: 'CLIENT'
} as const;

/**
 * * `phonenumber` - Phone Number
 * * `entity` - Entity Type
 * * `text` - Text Context
 */
export type RuleTypeEnum = 'phonenumber' | 'entity' | 'text';

/**
 * * `phonenumber` - Phone Number
 * * `entity` - Entity Type
 * * `text` - Text Context
 */
export const RuleTypeEnum = {
    PHONENUMBER: 'phonenumber',
    ENTITY: 'entity',
    TEXT: 'text'
} as const;

/**
 * Serializer for the SavedResponse model.
 */
export type SavedResponse = {
    readonly uuid: string;
    title: string;
    content: string;
    session_type: AIChatSessionTypeEnum;
    readonly org: number;
    readonly created_by_user: number;
    readonly created_by_user_name: string;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Serializer for the SavedResponse model.
 */
export type SavedResponseRequest = {
    title: string;
    content: string;
    session_type: AIChatSessionTypeEnum;
};

export type SchemaExternalIntegrationCaseCreationRequest = {
    integrationType: IntegrationTypeEnum;
    mandateId: number;
    integrationSpecificData: IntegrationSpecificDataRequest;
};

/**
 * * `ORGANIZATION` - Organization
 * * `USER` - User
 * * `CASE` - Case
 */
export type ScopeEnum = 'ORGANIZATION' | 'USER' | 'CASE';

/**
 * * `ORGANIZATION` - Organization
 * * `USER` - User
 * * `CASE` - Case
 */
export const ScopeEnum = {
    ORGANIZATION: 'ORGANIZATION',
    USER: 'USER',
    CASE: 'CASE'
} as const;

/**
 * Serializer for sending an email related to a case.
 */
export type SendCaseEmailRequestRequest = {
    subject: string;
    body: string;
    attachments?: Array<unknown>;
    auto_reject?: boolean;
    email_template_uuid?: string | null;
};

/**
 * Response serializer for the sent email.
 */
export type SendCaseEmailResponse = {
    readonly uuid: string;
    readonly from_email: number;
    readonly to: Array<(number)>;
    readonly cc: Array<(number)>;
    readonly bcc: Array<(number)>;
    subject: string;
    text?: string;
    html?: string;
    readonly direction: string;
    readonly source: string;
    readonly sent_at: string;
};

/**
 * Error response serializer for send-to-actaport endpoint.
 */
export type SendToActaportError = {
    /**
     * Error message
     */
    error: string;
};

/**
 * Response serializer for send-to-actaport endpoint.
 */
export type SendToActaportResponse = {
    /**
     * Status of the sync operation
     *
     * * `syncing` - syncing
     * * `already_synced` - already_synced
     */
    status: SendToActaportResponseStatusEnum;
};

/**
 * * `syncing` - syncing
 * * `already_synced` - already_synced
 */
export type SendToActaportResponseStatusEnum = 'syncing' | 'already_synced';

/**
 * * `syncing` - syncing
 * * `already_synced` - already_synced
 */
export const SendToActaportResponseStatusEnum = {
    SYNCING: 'syncing',
    ALREADY_SYNCED: 'already_synced'
} as const;

export type SessionGroup = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    /**
     * Name of the session group/folder
     */
    name: string;
    /**
     * Optional description of the session group
     */
    description?: string;
    /**
     * Custom instructions for all chats in this group
     */
    instructions?: string;
    readonly org: string;
    readonly created_by_user: string;
    readonly chat_sessions_count: string;
    readonly documents: Array<Document>;
};

export type SessionGroupRequest = {
    /**
     * Name of the session group/folder
     */
    name: string;
    /**
     * Optional description of the session group
     */
    description?: string;
    /**
     * Custom instructions for all chats in this group
     */
    instructions?: string;
};

/**
 * * `READY` - Ready
 * * `UPDATING_CONTEXT` - Updating Context
 * * `SEARCHING_DOCUMENTS` - Searching Documents
 * * `REASONING` - Reasoning
 */
export type SessionStateEnum = 'READY' | 'UPDATING_CONTEXT' | 'SEARCHING_DOCUMENTS' | 'REASONING';

/**
 * * `READY` - Ready
 * * `UPDATING_CONTEXT` - Updating Context
 * * `SEARCHING_DOCUMENTS` - Searching Documents
 * * `REASONING` - Reasoning
 */
export const SessionStateEnum = {
    READY: 'READY',
    UPDATING_CONTEXT: 'UPDATING_CONTEXT',
    SEARCHING_DOCUMENTS: 'SEARCHING_DOCUMENTS',
    REASONING: 'REASONING'
} as const;

export type ShallowCaseData = {
    uuid?: string;
    client: ShallowEntity;
    opponent: ShallowEntity;
    law: ShallowLawData;
};

export type ShallowCaseDataRequest = {
    uuid?: string;
    client: ShallowEntityRequest;
    opponent: ShallowEntityRequest;
    law: ShallowLawDataRequest;
};

export type ShallowEntity = {
    uuid?: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    is_valid_email?: boolean | null;
    is_valid_phone_number?: boolean | null;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    changes: Array<(number)>;
};

export type ShallowEntityRequest = {
    uuid?: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    is_valid_email?: boolean | null;
    is_valid_phone_number?: boolean | null;
    street?: string;
    street_number?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    changes: Array<(number)>;
};

export type ShallowLawData = {
    uuid?: string;
    readonly created_at: string;
    readonly updated_at: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_end_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_local_transfer_clause?: boolean | null;
    labor_law_VSOP?: boolean | null;
    labor_law_LTI?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_notice_period_observed?: boolean | null;
    labor_law_termination_without_notice?: boolean | null;
    labor_law_reason_for_termination_given?: boolean | null;
    labor_law_exemption_revocable?: boolean | null;
    labor_law_exemption_irrevocable?: boolean | null;
    labor_law_return_of_company_property?: boolean | null;
    labor_law_termination_operational_reasons?: boolean | null;
    labor_law_company_hearing?: boolean | null;
    labor_law_reaction_company_hering?: string | null;
    labor_law_termination_authorization?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_warning_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_special_sentence?: boolean | null;
    labor_law_sprinter_clause?: boolean | null;
    labor_law_percent_sprinter_clause?: number | null;
    labor_law_certificate_clause?: boolean | null;
    labor_law_grade_certificate_clause?: string;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    labor_law_dependent_children?: boolean | null;
    labor_law_amount_dependent_children?: number | null;
    labor_law_years_of_employment?: string | null;
    labor_law_total_gross_salary?: string | null;
    labor_law_severance_amount?: string | null;
    labor_law_works_council_membership?: boolean | null;
    labor_law_pregnancy?: boolean | null;
    labor_law_disability?: boolean | null;
    labor_law_special_personal_circumstances?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_value_improvement?: string | null;
    traffic_law_damage_amount_net?: string | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    traffic_law_repair_damage?: boolean | null;
    traffic_law_total_damage?: boolean | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_application_file_reference?: string | null;
    social_law_legal_basis?: string | null;
    social_law_benefit_type?: string | null;
    social_law_own_income_amount?: string | null;
    social_law_social_benefit_type?: string | null;
    social_law_residence_status?: string | null;
    social_law_income_type?: string | null;
    social_law_asset_type?: string | null;
    social_law_approval_file_reference?: string | null;
    social_law_approval_notice_date?: string | null;
    social_law_approval_legal_basis?: string | null;
    social_law_approval_internal_reference?: string | null;
    social_law_approved_benefit_type?: string | null;
    social_law_approved_benefit_amount?: string | null;
    social_law_approved_benefit_period?: string | null;
    social_law_follow_up_application_notes?: string | null;
    social_law_approval_period_start?: string | null;
    social_law_approval_period_end?: string | null;
    social_law_regelbedarf_amount?: string | null;
    social_law_housing_costs_amount?: string | null;
    social_law_total_need_amount?: string | null;
    social_law_monthly_payment_amount?: string | null;
    social_law_employment_income?: string | null;
    social_law_other_income?: string | null;
    social_law_creditable_income?: string | null;
    social_law_change_file_reference?: string | null;
    social_law_change_notification_date?: string | null;
    social_law_affected_benefit?: string | null;
    social_law_change_description?: string | null;
    social_law_change_reason?: string | null;
    social_law_attachment_list?: string | null;
    social_law_rejection_file_reference?: string | null;
    social_law_rejection_legal_norm?: string | null;
    social_law_rejection_reason?: string | null;
    social_law_rejection_notice_date?: string | null;
    social_law_revocation_file_reference?: string | null;
    social_law_revocation_legal_norm?: string | null;
    social_law_revocation_reason?: string | null;
    social_law_revocation_notice_date?: string | null;
    social_law_revocation_reclaim_notes?: string | null;
    social_law_revocation_benefit_type?: string | null;
    social_law_revocation_period_start?: string | null;
    social_law_revocation_period_end?: string | null;
    social_law_original_decision_date?: string | null;
    social_law_total_reclaim_amount?: string | null;
    social_law_income_source?: string | null;
    social_law_income_amount?: string | null;
    social_law_income_date?: string | null;
    social_law_income_provider?: string | null;
    social_law_notification_date?: string | null;
    social_law_notification_source?: string | null;
    social_law_violation_type?: string | null;
    social_law_income_legal_basis?: string | null;
    social_law_reclaim_legal_basis?: string | null;
    social_law_notification_legal_basis?: string | null;
    social_law_reclaim_file_reference?: string | null;
    social_law_reclaim_legal_norm?: string | null;
    social_law_reclaim_amount?: string | null;
    social_law_reclaim_payment_deadline?: string | null;
    social_law_reclaim_notice_date?: string | null;
    social_law_reclaim_payment_terms?: string | null;
    social_law_objection_file_reference?: string | null;
    social_law_objection_challenged_notice?: string | null;
    social_law_objection_reasoning?: string | null;
    social_law_objection_date?: string | null;
    social_law_objection_suspension_request?: string | null;
    social_law_objection_evidence?: string | null;
    social_law_notice_of_objection_file_reference?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    social_law_lawsuit_file_reference?: string | null;
    social_law_lawsuit_subject?: string | null;
    social_law_lawsuit_filing_date?: string | null;
    social_law_lawsuit_evidence_requests?: string | null;
    social_law_lawsuit_attachment_list?: string | null;
    social_law_lawsuit_court_file_number?: string | null;
    social_law_lawsuit_legal_basis?: string | null;
    social_law_lawsuit_type?: string | null;
    social_law_lawsuit_main_request?: string | null;
    social_law_lawsuit_alternative_request?: string | null;
    social_law_lawsuit_cost_request?: string | null;
    social_law_lawsuit_original_decision_date?: string | null;
    social_law_lawsuit_objection_decision_date?: string | null;
    social_law_lawsuit_objection_filing_date?: string | null;
    social_law_lawsuit_delivery_date?: string | null;
    social_law_lawsuit_dispute_value?: string | null;
    social_law_lawsuit_disputed_amount?: string | null;
    social_law_lawsuit_monthly_benefit_amount?: string | null;
    social_law_lawsuit_income_amount?: string | null;
    social_law_interim_protection_file_reference?: string | null;
    social_law_interim_protection_request_text?: string | null;
    social_law_interim_protection_urgency_reason?: string | null;
    social_law_interim_protection_request_date?: string | null;
    social_law_interim_protection_affidavit?: boolean | null;
    social_law_interim_protection_attachment_list?: string | null;
    social_law_medical_file_reference?: string | null;
    social_law_medical_examination_date?: string | null;
    social_law_medical_diagnosis?: string | null;
    social_law_medical_work_capacity_relation?: string | null;
    social_law_medical_prognosis?: string | null;
    social_law_medical_limitations?: string | null;
    social_law_medical_icd_code?: string | null;
    social_law_needs_file_reference?: string | null;
    social_law_needs_type?: string | null;
    social_law_needs_proof_basis?: string | null;
    social_law_needs_cost_breakdown?: string | null;
    social_law_needs_proof_date?: string | null;
    social_law_disability_file_reference?: string | null;
    social_law_disability_degree?: string | null;
    social_law_disability_card_issue_date?: string | null;
    social_law_disability_card_markers?: string | null;
    social_law_disability_card_validity_period?: string | null;
    social_law_hearing_file_reference?: string | null;
    social_law_hearing_planned_administrative_act?: string | null;
    social_law_hearing_letter_date?: string | null;
    social_law_appointment_file_reference?: string | null;
    social_law_appointment_date?: string | null;
    social_law_appointment_time?: string | null;
    social_law_appointment_purpose?: string | null;
    social_law_appointment_required_documents?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_object_size_sqm?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_last_signature_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_duration?: number | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_value_security_clause?: boolean | null;
    tenancy_law_tenant_extension_option?: boolean | null;
    tenancy_law_extension_option_count?: number | null;
    tenancy_law_extension_option_duration?: string | null;
    tenancy_law_security_deposit_amount?: string | null;
    tenancy_law_security_deposit_additional_regulations?: string | null;
    tenancy_law_cash_deposit_agreed?: boolean | null;
    tenancy_law_cash_deposit_payment_date?: string | null;
    tenancy_law_bank_guarantee?: boolean | null;
    tenancy_law_operating_costs_agreement?: string | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_garage_available?: boolean | null;
    tenancy_law_garage_costs?: string | null;
    tenancy_law_parking_space_available?: boolean | null;
    tenancy_law_parking_space_costs?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    tenancy_law_expert_report_damage_number?: string | null;
    tenancy_law_expert_report_object_address?: string | null;
    tenancy_law_expert_report_subject?: string | null;
    tenancy_law_expert_report_date?: string | null;
    tenancy_law_expert_report_purpose?: string | null;
    tenancy_law_expert_report_commission_date?: string | null;
    tenancy_law_expert_report_inspection_date?: string | null;
    tenancy_law_expert_report_damage_description?: string | null;
    tenancy_law_expert_report_repair_duration?: string | null;
    tenancy_law_tenant_warned?: boolean | null;
    tenancy_law_warning_letter_date?: string | null;
    tenancy_law_landlord_termination_given?: boolean | null;
    tenancy_law_termination_declared_date?: string | null;
    tenancy_law_termination_notice_period?: string | null;
    tenancy_law_termination_letter_date?: string | null;
    tenancy_law_tenancy_terminated?: boolean | null;
    tenancy_law_tenancy_termination_date?: string | null;
    tenancy_law_property_return_date?: string | null;
    tenancy_law_court_proceedings_pending?: boolean | null;
    tenancy_law_competent_court?: string | null;
    tenancy_law_court_case_number?: string | null;
    tenancy_law_last_rent_increase_letter_date?: string | null;
    tenancy_law_rent_increase_effective_date?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_plot_size?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    real_estate_law_purchase_contract_registration_number?: string | null;
    real_estate_law_brokerage_fee?: string | null;
    real_estate_law_property_brokered_by_agent?: boolean | null;
    real_estate_law_purchase_object_rented?: boolean | null;
    real_estate_law_encumbrances_section_ii?: string | null;
    real_estate_law_encumbrances_section_iii?: string | null;
    real_estate_law_building_restrictions_clause?: string | null;
    real_estate_law_contaminated_sites_clause?: string | null;
    real_estate_law_legal_defects_clause?: string | null;
    real_estate_law_purchase_price_loan_financed?: boolean | null;
    real_estate_law_withdrawal_instruction_date?: string | null;
    real_estate_law_building_permit_validity_duration?: string | null;
    real_estate_law_building_permit_date?: string | null;
    real_estate_law_building_permit_number?: string | null;
    real_estate_law_co_ownership_share?: string | null;
    real_estate_law_division_declaration_date?: string | null;
    real_estate_law_plan_designation?: string | null;
    real_estate_law_plan_scale?: string | null;
    real_estate_law_plan_author?: string | null;
    real_estate_law_building_usage?: string | null;
    real_estate_law_building_dimensions?: string | null;
    real_estate_law_monument_protection_order_number?: string | null;
    real_estate_law_monument_protection_order_date?: string | null;
    real_estate_law_monument_protection_basis?: string | null;
    real_estate_law_monument_registration_date?: string | null;
    real_estate_law_monument_protection_requirements?: string | null;
    real_estate_law_loan_amount?: string | null;
    real_estate_law_interest_rate?: string | null;
    real_estate_law_installment_amount?: string | null;
    real_estate_law_full_repayment_date?: string | null;
    real_estate_law_loan_security?: string | null;
    real_estate_law_repayment_rate?: string | null;
    real_estate_law_broker_commission_amount?: string | null;
    real_estate_law_broker_scope_of_work?: string | null;
    real_estate_law_broker_termination_periods?: string | null;
    real_estate_law_broker_contract_type?: string | null;
    real_estate_law_brokerage_contract_date?: string | null;
    real_estate_law_exclusive_brokerage_contract?: boolean | null;
    real_estate_law_commission_percentage?: string | null;
    migration_law_residence_permit_issue_date?: string | null;
    migration_law_residence_permit_valid_until?: string | null;
    migration_law_residence_permit_type?: string | null;
    migration_law_residence_permit_purpose?: string | null;
    migration_law_residence_permit_issuing_authority?: string | null;
    migration_law_residence_permit_conditions?: string | null;
    migration_law_residence_permit_passport_number?: string | null;
    migration_law_residence_permit_national_id_number?: string | null;
    migration_law_fictional_certificate_issue_date?: string | null;
    migration_law_fictional_certificate_valid_until?: string | null;
    migration_law_fictional_certificate_legal_basis?: string | null;
    migration_law_fictional_certificate_fiction_type?: string | null;
    migration_law_fictional_certificate_reason_for_issuance?: string | null;
    migration_law_fictional_certificate_authority?: string | null;
    migration_law_toleration_issue_date?: string | null;
    migration_law_toleration_valid_until?: string | null;
    migration_law_toleration_reason?: string | null;
    migration_law_toleration_legal_basis?: string | null;
    migration_law_toleration_restrictions?: string | null;
    migration_law_toleration_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_issue_date?: string | null;
    migration_law_asylum_seeker_certificate_valid_until?: string | null;
    migration_law_asylum_seeker_certificate_application_number?: string | null;
    migration_law_asylum_seeker_certificate_first_registration_date?: string | null;
    migration_law_asylum_seeker_certificate_residence_obligation?: string | null;
    migration_law_asylum_seeker_certificate_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_work_permission?: string | null;
    migration_law_rejection_notice_case_number?: string | null;
    migration_law_rejection_notice_decision_date?: string | null;
    migration_law_rejection_notice_subject?: string | null;
    migration_law_rejection_notice_legal_remedy_deadline?: string | null;
    migration_law_rejection_notice_reasoning?: string | null;
    migration_law_rejection_notice_legal_grounds?: string | null;
    migration_law_rejection_notice_officer_name?: string | null;
    migration_law_rejection_notice_signature_seal?: string | null;
    migration_law_approval_notice_case_number?: string | null;
    migration_law_approval_notice_decision_date?: string | null;
    migration_law_approval_notice_permit_type?: string | null;
    migration_law_approval_notice_validity_period?: string | null;
    migration_law_approval_notice_conditions?: string | null;
    migration_law_approval_notice_pickup_deadline?: string | null;
    migration_law_approval_notice_issuing_authority?: string | null;
    migration_law_hearing_letter_date?: string | null;
    migration_law_hearing_letter_response_deadline?: string | null;
    migration_law_hearing_letter_intended_measure_justification?: string | null;
    migration_law_hearing_letter_legal_advice?: string | null;
    migration_law_hearing_letter_requested_documents?: string | null;
    migration_law_cooperation_letter_date?: string | null;
    migration_law_cooperation_letter_file_number?: string | null;
    migration_law_cooperation_letter_specified_obligations?: string | null;
    migration_law_cooperation_letter_non_cooperation_consequences?: string | null;
    migration_law_cooperation_letter_deadlines?: string | null;
    migration_law_cooperation_letter_attachments?: string | null;
    migration_law_other_letters_issuing_authority?: string | null;
    migration_law_other_letters_file_number?: string | null;
    migration_law_other_letters_date?: string | null;
    migration_law_other_letters_subject?: string | null;
    migration_law_other_letters_matter_purpose?: string | null;
    migration_law_other_letters_legal_basis?: string | null;
    migration_law_other_letters_deadlines?: string | null;
    migration_law_other_letters_action_required?: string | null;
    civil_law_file_reference?: string | null;
    civil_law_document_date?: string | null;
    civil_law_subject_line?: string | null;
    civil_law_contract_date?: string | null;
    civil_law_contract_start_date?: string | null;
    civil_law_contract_end_date?: string | null;
    civil_law_contract_duration?: number | null;
    civil_law_contract_value?: string | null;
    civil_law_contract_object?: string | null;
    civil_law_termination_notice_period?: string | null;
    civil_law_notarial_certification_date?: string | null;
    civil_law_purchase_price?: string | null;
    civil_law_purchase_price_components?: string | null;
    civil_law_accessories_sold_separately?: boolean | null;
    civil_law_purchase_contract_file_reference?: string | null;
    civil_law_handover_date?: string | null;
    civil_law_purchase_price_paid?: boolean | null;
    civil_law_purchase_price_payment_date?: string | null;
    civil_law_purchase_price_paid_boolean?: boolean | null;
    civil_law_purchase_price_paid_date?: string | null;
    civil_law_purchase_price_paid_amount?: string | null;
    civil_law_purchase_object?: string | null;
    civil_law_purchase_date?: string | null;
    civil_law_delivery_date?: string | null;
    civil_law_warranty_period?: string | null;
    civil_law_defects?: string | null;
    civil_law_defects_present?: boolean | null;
    civil_law_vehicle_make?: string | null;
    civil_law_vehicle_model?: string | null;
    civil_law_vehicle_year?: number | null;
    civil_law_vehicle_mileage?: number | null;
    civil_law_vehicle_vin?: string | null;
    civil_law_damage_amount?: string | null;
    civil_law_damage_date?: string | null;
    civil_law_damage_description?: string | null;
    civil_law_damage_cause?: string | null;
    civil_law_liability_percentage?: string | null;
    civil_law_insurance_claim_number?: string | null;
    civil_law_court_name?: string | null;
    civil_law_case_number?: string | null;
    civil_law_hearing_date?: string | null;
    civil_law_judgment_date?: string | null;
    civil_law_claim_amount?: string | null;
    civil_law_court_costs?: string | null;
    civil_law_payment_due_date?: string | null;
    civil_law_interest_rate?: string | null;
    civil_law_default_interest?: string | null;
    general_law_file_ref?: string;
    general_law_subject?: string;
    general_law_doc_date?: string | null;
    general_law_prior_ref?: string;
    general_law_appendices?: string;
    general_law_invoice_number?: string;
    general_law_invoice_date?: string | null;
    general_law_due_date?: string | null;
    general_law_amount_total?: string | null;
    general_law_amount_net?: string | null;
    general_law_vat?: string | null;
    general_law_payment_terms?: string;
    general_law_court_name?: string;
    general_law_case_number?: string;
    general_law_hearing_date?: string | null;
    general_law_judgment_date?: string | null;
    general_law_court_costs?: string | null;
    medicine_law_medical_report_date?: string | null;
    medicine_law_medical_report_treatment_period?: string | null;
    medicine_law_medical_report_diagnosis_icd_code?: string | null;
    medicine_law_medical_report_diagnosis_short_text?: string | null;
    medicine_law_medical_report_treatment_measures?: string | null;
    medicine_law_medical_report_surgery_date?: string | null;
    medicine_law_medical_report_complications?: string | null;
    medicine_law_medical_report_further_treatment?: string | null;
    medicine_law_hospital_records_admission_date?: string | null;
    medicine_law_hospital_records_discharge_date?: string | null;
    medicine_law_hospital_records_station?: string | null;
    medicine_law_hospital_records_diagnoses_icd_codes?: string | null;
    medicine_law_hospital_records_operations?: string | null;
    medicine_law_hospital_records_operation_date?: string | null;
    medicine_law_hospital_records_medication_during_stay?: string | null;
    medicine_law_hospital_records_documented_complications?: string | null;
    medicine_law_hospital_records_discharge_prognosis?: string | null;
    medicine_law_medical_expertise_date?: string | null;
    medicine_law_medical_expertise_question_posed?: string | null;
    medicine_law_medical_expertise_medical_assessment?: string | null;
    medicine_law_medical_expertise_justification?: string | null;
    medicine_law_medical_expertise_result?: string | null;
    medicine_law_laboratory_results_examination_date?: string | null;
    medicine_law_laboratory_results_examination_type?: string | null;
    medicine_law_laboratory_results?: string | null;
    medicine_law_laboratory_results_relevant_deviations?: string | null;
    medicine_law_laboratory_results_further_investigation_recommendation?: string | null;
    medicine_law_health_insurance_letter_date?: string | null;
    medicine_law_health_insurance_letter_reference_to_application?: string | null;
    medicine_law_health_insurance_letter_decision?: string | null;
    medicine_law_health_insurance_letter_decision_justification?: string | null;
    medicine_law_health_insurance_letter_legal_remedy_instruction?: string | null;
    medicine_law_medical_bill_invoice_date?: string | null;
    medicine_law_medical_bill_invoice_number?: string | null;
    medicine_law_medical_bill_service_period?: string | null;
    medicine_law_medical_bill_services_list?: string | null;
    medicine_law_medical_bill_total_amount?: string | null;
    medicine_law_medical_bill_cost_bearer?: string | null;
    medicine_law_medical_bill_payment_deadline?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

export type ShallowLawDataRequest = {
    uuid?: string;
    labor_law_beginning_of_employment?: string | null;
    labor_law_end_of_employment?: string | null;
    labor_law_job_title?: string;
    labor_law_yearly_gross_salary?: number | null;
    labor_law_monthly_gross_salary?: number | null;
    labor_law_monthly_working_days?: number | null;
    labor_law_vacation_days?: number | null;
    labor_law_work_hours_per_week?: number | null;
    labor_law_is_employee_in_probation_period?: boolean | null;
    labor_law_employee_probation_period_end_date?: string | null;
    labor_law_place_of_work?: string;
    labor_law_different_place_of_work?: string;
    labor_law_fixed_term_contract?: boolean | null;
    labor_law_fixed_term_contract_duration?: string | null;
    labor_law_special_payments?: string;
    labor_law_special_payments_amount?: number | null;
    labor_law_special_protection_against_dismissal?: boolean | null;
    labor_law_work_council?: boolean | null;
    labor_law_collective_agreement?: boolean | null;
    labor_law_company_agreement?: boolean | null;
    labor_law_notice_period?: number | null;
    labor_law_signature_of_employer?: boolean | null;
    labor_law_local_transfer_clause?: boolean | null;
    labor_law_VSOP?: boolean | null;
    labor_law_LTI?: boolean | null;
    labor_law_termination_date?: string | null;
    labor_law_termination_date_effective?: string | null;
    labor_law_termination_employer_more_than_10_employees?: boolean | null;
    labor_law_termination_access_to_termination_to_employee?: string | null;
    labor_law_notice_period_observed?: boolean | null;
    labor_law_termination_without_notice?: boolean | null;
    labor_law_reason_for_termination_given?: boolean | null;
    labor_law_exemption_revocable?: boolean | null;
    labor_law_exemption_irrevocable?: boolean | null;
    labor_law_return_of_company_property?: boolean | null;
    labor_law_termination_operational_reasons?: boolean | null;
    labor_law_company_hearing?: boolean | null;
    labor_law_reaction_company_hering?: string | null;
    labor_law_termination_authorization?: string | null;
    labor_law_warning_letter_date?: string | null;
    labor_law_warning_letter_access_to_warning_letter_to_employee?: string | null;
    labor_law_warning_letter_incident_date?: string | null;
    labor_law_warning_letter_incident_time?: string | null;
    labor_law_warning_letter_incident_location?: string;
    labor_law_warning_letter_reason?: string;
    labor_law_termination_agreement_date?: string | null;
    labor_law_settlement_agreement_date?: string | null;
    labor_law_termination_agreement_termination_date?: string | null;
    labor_law_termination_is_agreement_severance_pay?: boolean | null;
    labor_law_termination_agreement_severance_pay_amount?: number | null;
    labor_law_special_sentence?: boolean | null;
    labor_law_sprinter_clause?: boolean | null;
    labor_law_percent_sprinter_clause?: number | null;
    labor_law_certificate_clause?: boolean | null;
    labor_law_grade_certificate_clause?: string;
    labor_law_child_allowances?: boolean | null;
    labor_law_married?: boolean | null;
    labor_law_dependent_children?: boolean | null;
    labor_law_amount_dependent_children?: number | null;
    labor_law_years_of_employment?: string | null;
    labor_law_total_gross_salary?: string | null;
    labor_law_severance_amount?: string | null;
    labor_law_works_council_membership?: boolean | null;
    labor_law_pregnancy?: boolean | null;
    labor_law_disability?: boolean | null;
    labor_law_special_personal_circumstances?: boolean | null;
    traffic_law_place_of_accident?: string;
    traffic_law_date_of_accident?: string | null;
    traffic_law_time_of_accident?: string | null;
    traffic_law_driving_ban_duration?: number | null;
    traffic_law_driving_ban?: boolean | null;
    traffic_law_licenseplate?: string;
    traffic_law_vehicle_type_and_brand?: string;
    traffic_law_amount_of_fine?: number | null;
    traffic_law_date_of_fine?: string | null;
    traffic_law_speed_allowed?: number | null;
    traffic_law_speed_driven?: number | null;
    traffic_law_speed_too_high?: number | null;
    traffic_law_points_for_offense?: number | null;
    traffic_law_date_of_offense?: string | null;
    traffic_law_time_of_offense?: string | null;
    traffic_law_place_of_offense?: string;
    traffic_law_violation_type?: string;
    traffic_law_violated_section?: string;
    traffic_law_file_number?: string;
    traffic_law_driver_logbook_required?: boolean | null;
    traffic_law_licenseplate_at_fault_driver?: string;
    traffic_law_licenseplate_victim_driver?: string;
    traffic_law_injured?: boolean | null;
    traffic_law_other_damages?: boolean | null;
    traffic_law_mark_and_type_of_at_fault_driver?: string;
    traffic_law_mark_and_type_of_victim_driver?: string;
    traffic_law_at_fault_driver_insurer?: string;
    traffic_law_victim_driver_insurer?: string;
    traffic_law_at_fault_driver_insurance_number?: string;
    traffic_law_victim_driver_insurance_number?: string;
    traffic_law_at_fault_driver_green_card_number?: string;
    traffic_law_victim_driver_green_card_number?: string;
    traffic_law_at_fault_driver_insurance_expiry_date?: string | null;
    traffic_law_victim_driver_insurance_expiry_date?: string | null;
    traffic_law_at_fault_driver_drivers_license_issued_by?: string;
    traffic_law_victim_driver_drivers_license_issued_by?: string;
    traffic_law_at_fault_driver_drivers_license_valid_until?: string | null;
    traffic_law_victim_driver_license_valid_until?: string | null;
    traffic_law_date_of_report?: string | null;
    traffic_law_place_of_inspection?: string;
    traffic_law_date_of_inspection?: string | null;
    traffic_law_time_of_inspection?: string | null;
    traffic_law_insurance_holder?: string;
    traffic_law_insurance?: string;
    traffic_law_police_case_number?: string;
    traffic_law_repair_costs_without_vat?: string | null;
    traffic_law_repair_costs_with_vat?: string | null;
    traffic_law_replacement_value?: string | null;
    traffic_law_differencial_tax?: boolean | null;
    traffic_law_regular_tax?: boolean | null;
    traffic_law_merantile_value_loss?: string | null;
    traffic_law_loss_of_use_per_day?: string | null;
    traffic_law_repair_duration?: number | null;
    traffic_law_residual_value?: string | null;
    traffic_law_reregistration_cost?: string | null;
    traffic_law_damage_scope?: string;
    traffic_law_expert_report_number?: number | null;
    traffic_law_value_improvement?: string | null;
    traffic_law_damage_amount_net?: string | null;
    traffic_law_insurance_policy_number?: string;
    traffic_law_damage_number?: string;
    traffic_law_expert_cost?: string | null;
    traffic_law_cost_per_scale?: string | null;
    traffic_law_loss_amount_repair_case?: string | null;
    traffic_law_loss_amount_total_damage_case?: string | null;
    traffic_law_replacement_cost?: string | null;
    traffic_law_date_of_infraction?: string | null;
    traffic_law_time_of_infraction?: string | null;
    traffic_law_place_of_infraction?: string;
    traffic_law_offense_infraction_description?: string;
    traffic_law_legal_basis_infraction?: string;
    traffic_law_evidence_infraction?: string;
    traffic_law_warning_fee_infraction?: number | null;
    traffic_law_payment_deadline?: number | null;
    traffic_law_prosecution_number?: string;
    traffic_law_place_of_issue?: string;
    traffic_law_date_of_issue?: string | null;
    traffic_law_time_of_issue?: string | null;
    traffic_law_charges?: string;
    traffic_law_legal_basis?: string;
    traffic_law_fine?: number | null;
    traffic_law_daily_rate?: number | null;
    traffic_law_number_of_daily_rates?: number | null;
    traffic_law_procedure_costs?: string;
    traffic_law_date_of_crime?: string | null;
    traffic_law_time_of_crime?: string | null;
    traffic_law_place_of_crime?: string;
    traffic_law_blood_alcohol_concentration?: number | null;
    traffic_law_appeal_instruction?: string;
    traffic_law_vehicle_age_months?: number | null;
    traffic_law_vehicle_mileage?: number | null;
    traffic_law_accident_date?: string | null;
    traffic_law_expert_date?: string | null;
    traffic_law_net_replacement_value?: string | null;
    traffic_law_gross_replacement_value?: string | null;
    traffic_law_net_gross_replacement_value?: string | null;
    traffic_law_gross_gross_replacement_value?: string | null;
    traffic_law_calculated_total_damage_costs?: string | null;
    traffic_law_calculated_total_days?: number | null;
    traffic_law_repair_damage?: boolean | null;
    traffic_law_total_damage?: boolean | null;
    criminal_law_legal_classification_of_offense?: string | null;
    criminal_law_date_of_offense?: string | null;
    criminal_law_time_of_offense?: string | null;
    criminal_law_place_of_offense?: string | null;
    criminal_law_penalty_infromation?: string | null;
    criminal_law_number_of_daily_rates?: number | null;
    criminal_law_amount_of_daily_rates?: string | null;
    criminal_law_evidence?: string | null;
    criminal_law_probation?: boolean | null;
    criminal_law_prison_sentence?: boolean | null;
    criminal_law_duration_of_prison_sentence?: string | null;
    criminal_law_police_file_number?: string | null;
    criminal_law_report_date?: string | null;
    criminal_law_report_time?: string | null;
    criminal_law_offense_type?: string | null;
    criminal_law_incident_description?: string | null;
    criminal_law_physical_evidence?: string | null;
    criminal_law_evidence_location?: string | null;
    criminal_law_damage_description?: string | null;
    criminal_law_damage_value?: string | null;
    criminal_law_prosecution_file_number?: string | null;
    criminal_law_charge_description?: string | null;
    criminal_law_means_of_evidence?: string | null;
    criminal_law_applicable_laws?: string | null;
    criminal_law_preliminary_proceedings_date?: string | null;
    criminal_law_indictment_date?: string | null;
    criminal_law_indictment_delivery_date?: string | null;
    family_law_divorce_settlement_agreement?: boolean | null;
    family_law_marriage_contract_date?: string | null;
    family_law_average_net_income?: string | null;
    family_law_children?: boolean | null;
    family_law_registry_office_location?: string | null;
    family_law_date_of_marriage?: string | null;
    family_law_marriage_register_number?: string | null;
    family_law_separation_date?: string | null;
    family_law_birth_register_number?: string | null;
    family_law_birth_register_office_location?: string | null;
    social_law_application_file_reference?: string | null;
    social_law_legal_basis?: string | null;
    social_law_benefit_type?: string | null;
    social_law_own_income_amount?: string | null;
    social_law_social_benefit_type?: string | null;
    social_law_residence_status?: string | null;
    social_law_income_type?: string | null;
    social_law_asset_type?: string | null;
    social_law_approval_file_reference?: string | null;
    social_law_approval_notice_date?: string | null;
    social_law_approval_legal_basis?: string | null;
    social_law_approval_internal_reference?: string | null;
    social_law_approved_benefit_type?: string | null;
    social_law_approved_benefit_amount?: string | null;
    social_law_approved_benefit_period?: string | null;
    social_law_follow_up_application_notes?: string | null;
    social_law_approval_period_start?: string | null;
    social_law_approval_period_end?: string | null;
    social_law_regelbedarf_amount?: string | null;
    social_law_housing_costs_amount?: string | null;
    social_law_total_need_amount?: string | null;
    social_law_monthly_payment_amount?: string | null;
    social_law_employment_income?: string | null;
    social_law_other_income?: string | null;
    social_law_creditable_income?: string | null;
    social_law_change_file_reference?: string | null;
    social_law_change_notification_date?: string | null;
    social_law_affected_benefit?: string | null;
    social_law_change_description?: string | null;
    social_law_change_reason?: string | null;
    social_law_attachment_list?: string | null;
    social_law_rejection_file_reference?: string | null;
    social_law_rejection_legal_norm?: string | null;
    social_law_rejection_reason?: string | null;
    social_law_rejection_notice_date?: string | null;
    social_law_revocation_file_reference?: string | null;
    social_law_revocation_legal_norm?: string | null;
    social_law_revocation_reason?: string | null;
    social_law_revocation_notice_date?: string | null;
    social_law_revocation_reclaim_notes?: string | null;
    social_law_revocation_benefit_type?: string | null;
    social_law_revocation_period_start?: string | null;
    social_law_revocation_period_end?: string | null;
    social_law_original_decision_date?: string | null;
    social_law_total_reclaim_amount?: string | null;
    social_law_income_source?: string | null;
    social_law_income_amount?: string | null;
    social_law_income_date?: string | null;
    social_law_income_provider?: string | null;
    social_law_notification_date?: string | null;
    social_law_notification_source?: string | null;
    social_law_violation_type?: string | null;
    social_law_income_legal_basis?: string | null;
    social_law_reclaim_legal_basis?: string | null;
    social_law_notification_legal_basis?: string | null;
    social_law_reclaim_file_reference?: string | null;
    social_law_reclaim_legal_norm?: string | null;
    social_law_reclaim_amount?: string | null;
    social_law_reclaim_payment_deadline?: string | null;
    social_law_reclaim_notice_date?: string | null;
    social_law_reclaim_payment_terms?: string | null;
    social_law_objection_file_reference?: string | null;
    social_law_objection_challenged_notice?: string | null;
    social_law_objection_reasoning?: string | null;
    social_law_objection_date?: string | null;
    social_law_objection_suspension_request?: string | null;
    social_law_objection_evidence?: string | null;
    social_law_notice_of_objection_file_reference?: string | null;
    social_law_notice_of_objection_date?: string | null;
    social_law_notice_date?: string | null;
    social_law_application_date?: string | null;
    social_law_application_arrival_date?: string | null;
    social_law_summary_grounds_opposition?: string | null;
    social_law_lawsuit_file_reference?: string | null;
    social_law_lawsuit_subject?: string | null;
    social_law_lawsuit_filing_date?: string | null;
    social_law_lawsuit_evidence_requests?: string | null;
    social_law_lawsuit_attachment_list?: string | null;
    social_law_lawsuit_court_file_number?: string | null;
    social_law_lawsuit_legal_basis?: string | null;
    social_law_lawsuit_type?: string | null;
    social_law_lawsuit_main_request?: string | null;
    social_law_lawsuit_alternative_request?: string | null;
    social_law_lawsuit_cost_request?: string | null;
    social_law_lawsuit_original_decision_date?: string | null;
    social_law_lawsuit_objection_decision_date?: string | null;
    social_law_lawsuit_objection_filing_date?: string | null;
    social_law_lawsuit_delivery_date?: string | null;
    social_law_lawsuit_dispute_value?: string | null;
    social_law_lawsuit_disputed_amount?: string | null;
    social_law_lawsuit_monthly_benefit_amount?: string | null;
    social_law_lawsuit_income_amount?: string | null;
    social_law_interim_protection_file_reference?: string | null;
    social_law_interim_protection_request_text?: string | null;
    social_law_interim_protection_urgency_reason?: string | null;
    social_law_interim_protection_request_date?: string | null;
    social_law_interim_protection_affidavit?: boolean | null;
    social_law_interim_protection_attachment_list?: string | null;
    social_law_medical_file_reference?: string | null;
    social_law_medical_examination_date?: string | null;
    social_law_medical_diagnosis?: string | null;
    social_law_medical_work_capacity_relation?: string | null;
    social_law_medical_prognosis?: string | null;
    social_law_medical_limitations?: string | null;
    social_law_medical_icd_code?: string | null;
    social_law_needs_file_reference?: string | null;
    social_law_needs_type?: string | null;
    social_law_needs_proof_basis?: string | null;
    social_law_needs_cost_breakdown?: string | null;
    social_law_needs_proof_date?: string | null;
    social_law_disability_file_reference?: string | null;
    social_law_disability_degree?: string | null;
    social_law_disability_card_issue_date?: string | null;
    social_law_disability_card_markers?: string | null;
    social_law_disability_card_validity_period?: string | null;
    social_law_hearing_file_reference?: string | null;
    social_law_hearing_planned_administrative_act?: string | null;
    social_law_hearing_letter_date?: string | null;
    social_law_appointment_file_reference?: string | null;
    social_law_appointment_date?: string | null;
    social_law_appointment_time?: string | null;
    social_law_appointment_purpose?: string | null;
    social_law_appointment_required_documents?: string | null;
    debt_collection_law_invoice_date?: string | null;
    debt_collection_law_invoice_number?: string | null;
    debt_collection_law_invoice_amount?: string | null;
    debt_collection_law_invoice_ground?: string | null;
    debt_collection_law_invoice_recipient?: string | null;
    debt_collection_law_invoice_tax_number?: string | null;
    debt_collection_law_case_value?: string | null;
    debt_collection_law_business_fee?: string | null;
    debt_collection_law_lumps_sum_expenses?: string | null;
    debt_collection_law_subtotal_lawyer_fees?: string | null;
    debt_collection_law_sales_tax?: string | null;
    debt_collection_law_total_amount?: string | null;
    tenancy_law_rental_object_size_sqm?: string | null;
    tenancy_law_rental_agreement_date?: string | null;
    tenancy_law_last_signature_date?: string | null;
    tenancy_law_net_rent?: string | null;
    tenancy_law_gross_rent?: string | null;
    tenancy_law_total_rent?: string | null;
    tenancy_law_unlimited_term_tenancy?: boolean | null;
    tenancy_law_fixed_term_tenancy?: boolean | null;
    tenancy_law_rental_agreement_duration?: number | null;
    tenancy_law_rental_agreement_validity_start?: string | null;
    tenancy_law_rental_agreement_validity_end?: string | null;
    tenancy_law_staggered_rental_agreement?: boolean | null;
    tenancy_law_value_security_clause?: boolean | null;
    tenancy_law_tenant_extension_option?: boolean | null;
    tenancy_law_extension_option_count?: number | null;
    tenancy_law_extension_option_duration?: string | null;
    tenancy_law_security_deposit_amount?: string | null;
    tenancy_law_security_deposit_additional_regulations?: string | null;
    tenancy_law_cash_deposit_agreed?: boolean | null;
    tenancy_law_cash_deposit_payment_date?: string | null;
    tenancy_law_bank_guarantee?: boolean | null;
    tenancy_law_operating_costs_agreement?: string | null;
    tenancy_law_advance_payment_service_charges?: string | null;
    tenancy_law_adress_rental_property?: string | null;
    tenancy_law_description_of_rental_property?: string | null;
    tenancy_law_location_in_rental_property?: string | null;
    tenancy_law_garage_available?: boolean | null;
    tenancy_law_garage_costs?: string | null;
    tenancy_law_parking_space_available?: boolean | null;
    tenancy_law_parking_space_costs?: string | null;
    tenancy_law_start_of_lease?: string | null;
    tenancy_law_duration_of_lease?: number | null;
    tenancy_law_repayment_period_start?: string | null;
    tenancy_law_repayment_period_end?: string | null;
    tenancy_law_total_cost_service_charge?: string | null;
    tenancy_law_cost_shares?: string | null;
    tenancy_law_cost_share?: string | null;
    tenancy_law_advance_payment_service_charge?: string | null;
    tenancy_law_repayment?: string | null;
    tenancy_law_handover_date?: string | null;
    tenancy_law_handover_counter?: string | null;
    tenancy_law_counter_number?: string | null;
    tenancy_law_handover_defects?: string | null;
    tenancy_law_expert_report_damage_number?: string | null;
    tenancy_law_expert_report_object_address?: string | null;
    tenancy_law_expert_report_subject?: string | null;
    tenancy_law_expert_report_date?: string | null;
    tenancy_law_expert_report_purpose?: string | null;
    tenancy_law_expert_report_commission_date?: string | null;
    tenancy_law_expert_report_inspection_date?: string | null;
    tenancy_law_expert_report_damage_description?: string | null;
    tenancy_law_expert_report_repair_duration?: string | null;
    tenancy_law_tenant_warned?: boolean | null;
    tenancy_law_warning_letter_date?: string | null;
    tenancy_law_landlord_termination_given?: boolean | null;
    tenancy_law_termination_declared_date?: string | null;
    tenancy_law_termination_notice_period?: string | null;
    tenancy_law_termination_letter_date?: string | null;
    tenancy_law_tenancy_terminated?: boolean | null;
    tenancy_law_tenancy_termination_date?: string | null;
    tenancy_law_property_return_date?: string | null;
    tenancy_law_court_proceedings_pending?: boolean | null;
    tenancy_law_competent_court?: string | null;
    tenancy_law_court_case_number?: string | null;
    tenancy_law_last_rent_increase_letter_date?: string | null;
    tenancy_law_rent_increase_effective_date?: string | null;
    residential_property_law_contract_date?: string | null;
    residential_property_law_land_register_number?: string | null;
    residential_property_law_land_register_city?: string | null;
    residential_property_law_land_register_plot_of_land?: string | null;
    residential_property_law_land_register_address?: string | null;
    residential_property_law_co_ownership_shares?: string | null;
    residential_property_law_inventory?: string | null;
    inheritance_law_certificate_of_inheritance_date?: string | null;
    inheritance_law_certificate_of_inheritance_number?: string | null;
    inheritance_law_certificate_of_inheritance_date_death?: string | null;
    inheritance_law_certificate_of_inheritance_place_of_death?: string | null;
    inheritance_law_certificate_of_inheritance_applicable_law?: string | null;
    inheritance_law_inheritance_contract_date?: string | null;
    inheritance_law_death_certificate_number?: string | null;
    inheritance_law_death_certificate_date?: string | null;
    inheritance_law_death_certificate_place?: string | null;
    inheritance_law_death_certificate_date_death?: string | null;
    inheritance_law_death_certificate_time_death?: string | null;
    inheritance_law_death_certificate_place_death?: string | null;
    inheritance_law_testament_date?: string | null;
    inheritance_law_estate_inventory_status?: string | null;
    inheritance_law_estate_inventory_date?: string | null;
    inheritance_law_estate_inventory_amount?: string | null;
    inheritance_law_patient_enrollment_date?: string | null;
    inheritance_law_lasting_power_of_attorney_date?: string | null;
    real_estate_law_land_register_date?: string | null;
    real_estate_law_encumbrance_restrictions?: string | null;
    real_estate_law_basic_debts_amount?: string | null;
    real_estate_law_land_register_number?: string | null;
    real_estate_law_land_register_city?: string | null;
    real_estate_law_land_register_plot_of_land?: string | null;
    real_estate_law_land_register_address?: string | null;
    real_estate_law_plot_size?: string | null;
    real_estate_law_purchase_contract_date?: string | null;
    real_estate_law_purchase_contract_amount?: string | null;
    real_estate_law_purchase_contract_description?: string | null;
    real_estate_law_purchase_contract_registration_date?: string | null;
    real_estate_law_purchase_contract_registration_number?: string | null;
    real_estate_law_brokerage_fee?: string | null;
    real_estate_law_property_brokered_by_agent?: boolean | null;
    real_estate_law_purchase_object_rented?: boolean | null;
    real_estate_law_encumbrances_section_ii?: string | null;
    real_estate_law_encumbrances_section_iii?: string | null;
    real_estate_law_building_restrictions_clause?: string | null;
    real_estate_law_contaminated_sites_clause?: string | null;
    real_estate_law_legal_defects_clause?: string | null;
    real_estate_law_purchase_price_loan_financed?: boolean | null;
    real_estate_law_withdrawal_instruction_date?: string | null;
    real_estate_law_building_permit_validity_duration?: string | null;
    real_estate_law_building_permit_date?: string | null;
    real_estate_law_building_permit_number?: string | null;
    real_estate_law_co_ownership_share?: string | null;
    real_estate_law_division_declaration_date?: string | null;
    real_estate_law_plan_designation?: string | null;
    real_estate_law_plan_scale?: string | null;
    real_estate_law_plan_author?: string | null;
    real_estate_law_building_usage?: string | null;
    real_estate_law_building_dimensions?: string | null;
    real_estate_law_monument_protection_order_number?: string | null;
    real_estate_law_monument_protection_order_date?: string | null;
    real_estate_law_monument_protection_basis?: string | null;
    real_estate_law_monument_registration_date?: string | null;
    real_estate_law_monument_protection_requirements?: string | null;
    real_estate_law_loan_amount?: string | null;
    real_estate_law_interest_rate?: string | null;
    real_estate_law_installment_amount?: string | null;
    real_estate_law_full_repayment_date?: string | null;
    real_estate_law_loan_security?: string | null;
    real_estate_law_repayment_rate?: string | null;
    real_estate_law_broker_commission_amount?: string | null;
    real_estate_law_broker_scope_of_work?: string | null;
    real_estate_law_broker_termination_periods?: string | null;
    real_estate_law_broker_contract_type?: string | null;
    real_estate_law_brokerage_contract_date?: string | null;
    real_estate_law_exclusive_brokerage_contract?: boolean | null;
    real_estate_law_commission_percentage?: string | null;
    migration_law_residence_permit_issue_date?: string | null;
    migration_law_residence_permit_valid_until?: string | null;
    migration_law_residence_permit_type?: string | null;
    migration_law_residence_permit_purpose?: string | null;
    migration_law_residence_permit_issuing_authority?: string | null;
    migration_law_residence_permit_conditions?: string | null;
    migration_law_residence_permit_passport_number?: string | null;
    migration_law_residence_permit_national_id_number?: string | null;
    migration_law_fictional_certificate_issue_date?: string | null;
    migration_law_fictional_certificate_valid_until?: string | null;
    migration_law_fictional_certificate_legal_basis?: string | null;
    migration_law_fictional_certificate_fiction_type?: string | null;
    migration_law_fictional_certificate_reason_for_issuance?: string | null;
    migration_law_fictional_certificate_authority?: string | null;
    migration_law_toleration_issue_date?: string | null;
    migration_law_toleration_valid_until?: string | null;
    migration_law_toleration_reason?: string | null;
    migration_law_toleration_legal_basis?: string | null;
    migration_law_toleration_restrictions?: string | null;
    migration_law_toleration_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_issue_date?: string | null;
    migration_law_asylum_seeker_certificate_valid_until?: string | null;
    migration_law_asylum_seeker_certificate_application_number?: string | null;
    migration_law_asylum_seeker_certificate_first_registration_date?: string | null;
    migration_law_asylum_seeker_certificate_residence_obligation?: string | null;
    migration_law_asylum_seeker_certificate_issuing_authority?: string | null;
    migration_law_asylum_seeker_certificate_work_permission?: string | null;
    migration_law_rejection_notice_case_number?: string | null;
    migration_law_rejection_notice_decision_date?: string | null;
    migration_law_rejection_notice_subject?: string | null;
    migration_law_rejection_notice_legal_remedy_deadline?: string | null;
    migration_law_rejection_notice_reasoning?: string | null;
    migration_law_rejection_notice_legal_grounds?: string | null;
    migration_law_rejection_notice_officer_name?: string | null;
    migration_law_rejection_notice_signature_seal?: string | null;
    migration_law_approval_notice_case_number?: string | null;
    migration_law_approval_notice_decision_date?: string | null;
    migration_law_approval_notice_permit_type?: string | null;
    migration_law_approval_notice_validity_period?: string | null;
    migration_law_approval_notice_conditions?: string | null;
    migration_law_approval_notice_pickup_deadline?: string | null;
    migration_law_approval_notice_issuing_authority?: string | null;
    migration_law_hearing_letter_date?: string | null;
    migration_law_hearing_letter_response_deadline?: string | null;
    migration_law_hearing_letter_intended_measure_justification?: string | null;
    migration_law_hearing_letter_legal_advice?: string | null;
    migration_law_hearing_letter_requested_documents?: string | null;
    migration_law_cooperation_letter_date?: string | null;
    migration_law_cooperation_letter_file_number?: string | null;
    migration_law_cooperation_letter_specified_obligations?: string | null;
    migration_law_cooperation_letter_non_cooperation_consequences?: string | null;
    migration_law_cooperation_letter_deadlines?: string | null;
    migration_law_cooperation_letter_attachments?: string | null;
    migration_law_other_letters_issuing_authority?: string | null;
    migration_law_other_letters_file_number?: string | null;
    migration_law_other_letters_date?: string | null;
    migration_law_other_letters_subject?: string | null;
    migration_law_other_letters_matter_purpose?: string | null;
    migration_law_other_letters_legal_basis?: string | null;
    migration_law_other_letters_deadlines?: string | null;
    migration_law_other_letters_action_required?: string | null;
    civil_law_file_reference?: string | null;
    civil_law_document_date?: string | null;
    civil_law_subject_line?: string | null;
    civil_law_contract_date?: string | null;
    civil_law_contract_start_date?: string | null;
    civil_law_contract_end_date?: string | null;
    civil_law_contract_duration?: number | null;
    civil_law_contract_value?: string | null;
    civil_law_contract_object?: string | null;
    civil_law_termination_notice_period?: string | null;
    civil_law_notarial_certification_date?: string | null;
    civil_law_purchase_price?: string | null;
    civil_law_purchase_price_components?: string | null;
    civil_law_accessories_sold_separately?: boolean | null;
    civil_law_purchase_contract_file_reference?: string | null;
    civil_law_handover_date?: string | null;
    civil_law_purchase_price_paid?: boolean | null;
    civil_law_purchase_price_payment_date?: string | null;
    civil_law_purchase_price_paid_boolean?: boolean | null;
    civil_law_purchase_price_paid_date?: string | null;
    civil_law_purchase_price_paid_amount?: string | null;
    civil_law_purchase_object?: string | null;
    civil_law_purchase_date?: string | null;
    civil_law_delivery_date?: string | null;
    civil_law_warranty_period?: string | null;
    civil_law_defects?: string | null;
    civil_law_defects_present?: boolean | null;
    civil_law_vehicle_make?: string | null;
    civil_law_vehicle_model?: string | null;
    civil_law_vehicle_year?: number | null;
    civil_law_vehicle_mileage?: number | null;
    civil_law_vehicle_vin?: string | null;
    civil_law_damage_amount?: string | null;
    civil_law_damage_date?: string | null;
    civil_law_damage_description?: string | null;
    civil_law_damage_cause?: string | null;
    civil_law_liability_percentage?: string | null;
    civil_law_insurance_claim_number?: string | null;
    civil_law_court_name?: string | null;
    civil_law_case_number?: string | null;
    civil_law_hearing_date?: string | null;
    civil_law_judgment_date?: string | null;
    civil_law_claim_amount?: string | null;
    civil_law_court_costs?: string | null;
    civil_law_payment_due_date?: string | null;
    civil_law_interest_rate?: string | null;
    civil_law_default_interest?: string | null;
    general_law_file_ref?: string;
    general_law_subject?: string;
    general_law_doc_date?: string | null;
    general_law_prior_ref?: string;
    general_law_appendices?: string;
    general_law_invoice_number?: string;
    general_law_invoice_date?: string | null;
    general_law_due_date?: string | null;
    general_law_amount_total?: string | null;
    general_law_amount_net?: string | null;
    general_law_vat?: string | null;
    general_law_payment_terms?: string;
    general_law_court_name?: string;
    general_law_case_number?: string;
    general_law_hearing_date?: string | null;
    general_law_judgment_date?: string | null;
    general_law_court_costs?: string | null;
    medicine_law_medical_report_date?: string | null;
    medicine_law_medical_report_treatment_period?: string | null;
    medicine_law_medical_report_diagnosis_icd_code?: string | null;
    medicine_law_medical_report_diagnosis_short_text?: string | null;
    medicine_law_medical_report_treatment_measures?: string | null;
    medicine_law_medical_report_surgery_date?: string | null;
    medicine_law_medical_report_complications?: string | null;
    medicine_law_medical_report_further_treatment?: string | null;
    medicine_law_hospital_records_admission_date?: string | null;
    medicine_law_hospital_records_discharge_date?: string | null;
    medicine_law_hospital_records_station?: string | null;
    medicine_law_hospital_records_diagnoses_icd_codes?: string | null;
    medicine_law_hospital_records_operations?: string | null;
    medicine_law_hospital_records_operation_date?: string | null;
    medicine_law_hospital_records_medication_during_stay?: string | null;
    medicine_law_hospital_records_documented_complications?: string | null;
    medicine_law_hospital_records_discharge_prognosis?: string | null;
    medicine_law_medical_expertise_date?: string | null;
    medicine_law_medical_expertise_question_posed?: string | null;
    medicine_law_medical_expertise_medical_assessment?: string | null;
    medicine_law_medical_expertise_justification?: string | null;
    medicine_law_medical_expertise_result?: string | null;
    medicine_law_laboratory_results_examination_date?: string | null;
    medicine_law_laboratory_results_examination_type?: string | null;
    medicine_law_laboratory_results?: string | null;
    medicine_law_laboratory_results_relevant_deviations?: string | null;
    medicine_law_laboratory_results_further_investigation_recommendation?: string | null;
    medicine_law_health_insurance_letter_date?: string | null;
    medicine_law_health_insurance_letter_reference_to_application?: string | null;
    medicine_law_health_insurance_letter_decision?: string | null;
    medicine_law_health_insurance_letter_decision_justification?: string | null;
    medicine_law_health_insurance_letter_legal_remedy_instruction?: string | null;
    medicine_law_medical_bill_invoice_date?: string | null;
    medicine_law_medical_bill_invoice_number?: string | null;
    medicine_law_medical_bill_service_period?: string | null;
    medicine_law_medical_bill_services_list?: string | null;
    medicine_law_medical_bill_total_amount?: string | null;
    medicine_law_medical_bill_cost_bearer?: string | null;
    medicine_law_medical_bill_payment_deadline?: string | null;
    field?: string;
    topic?: string;
    external_case_id?: string | null;
};

/**
 * * `bot` - bot
 * * `caller` - caller
 */
export type SpeakerEnum = 'bot' | 'caller';

/**
 * * `bot` - bot
 * * `caller` - caller
 */
export const SpeakerEnum = {
    BOT: 'bot',
    CALLER: 'caller'
} as const;

export type StartFormRequest = {
    form_id?: string | null;
    pdf_form_template_uuid?: string | null;
};

export type StartFormResponse = PDFFormSubmissionBase | ClientRequest;

export type StartQuestionnaireRequest = {
    questionnaire_uuid: string;
};

/**
 * Serializer for individual state count data.
 *
 * Contains the count of cases and whether there are any
 * unseen activities in that state.
 */
export type StateCount = {
    count: number;
    has_unseen_activity: boolean;
};

/**
 * * `NEW` - neu
 * * `IN_PROGRESS` - in Bearbeitung
 * * `COMPLETED` - abgeschlossen
 * * `REJECTED` - abgelehnt
 */
export type StateEnum = 'NEW' | 'IN_PROGRESS' | 'COMPLETED' | 'REJECTED';

/**
 * * `NEW` - neu
 * * `IN_PROGRESS` - in Bearbeitung
 * * `COMPLETED` - abgeschlossen
 * * `REJECTED` - abgelehnt
 */
export const StateEnum = {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED'
} as const;

/**
 * * `started` - Started
 * * `in_progress` - In Progress
 * * `completed` - Completed
 */
export type Status7a8Enum = 'started' | 'in_progress' | 'completed';

/**
 * * `started` - Started
 * * `in_progress` - In Progress
 * * `completed` - Completed
 */
export const Status7a8Enum = {
    STARTED: 'started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
} as const;

/**
 * Serializer for creating a new Stripe customer.
 */
export type StripeCustomerCreateRequest = {
    name: string;
    email: string;
    phone?: string;
    street?: string;
    street_number?: string;
    city?: string;
    zip_code?: string;
    country?: string;
};

export type StripeInvoiceExportRequestRequest = {
    month: number;
    year: number;
};

export type StripeInvoiceExportResponse = {
    success: boolean;
    error?: string;
    url?: string;
};

/**
 * Serializer for form fields in PDF form submissions.
 */
export type SubmissionFormField = {
    uuid?: string;
    type: FormFieldTypeEnum;
    tag?: string | null;
    tag_relationship?: TagRelationshipEnum | BlankEnum | NullEnum | null;
    placeholder?: string;
    required: boolean;
    assigned_to: AssignedToEnum;
    coordinates: FormFieldCoordinates;
    value?: string;
    signed_at?: string | null;
};

/**
 * Serializer for form fields in PDF form submissions.
 */
export type SubmissionFormFieldRequest = {
    uuid?: string;
    type: FormFieldTypeEnum;
    tag?: string | null;
    tag_relationship?: TagRelationshipEnum | BlankEnum | NullEnum | null;
    placeholder?: string;
    required: boolean;
    assigned_to: AssignedToEnum;
    coordinates: FormFieldCoordinatesRequest;
    value?: string;
    signed_at?: string | null;
};

/**
 * * `in_progress` - In Progress
 * * `completed` - Completed
 */
export type SubmissionStatusEnum = 'in_progress' | 'completed';

/**
 * * `in_progress` - In Progress
 * * `completed` - Completed
 */
export const SubmissionStatusEnum = {
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
} as const;

/**
 * Serializer for submitting request responses.
 */
export type SubmitRequestRequest = {
    /**
     * Annotation data for the form fields
     */
    annotation_data?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Signature data for the form
     */
    signatures?: {
        [key: string]: unknown;
    };
};

export type SuperUserAccount = {
    uuid?: string;
    account_id: string;
};

export type SuperUserAccountRequest = {
    uuid?: string;
    account_id: string;
};

/**
 * ActionAutoCommitSettings representation for superusers.
 */
export type SuperUserActionAutoCommitSettings = {
    readonly uuid: string;
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * ActionAutoCommitSettings representation for superusers.
 */
export type SuperUserActionAutoCommitSettingsRequest = {
    auto_commit_settings_key: string;
    can_auto_commit?: boolean;
    additional_user_instructions?: string;
    confidence_threshold?: number;
};

/**
 * Activity serializer for superuser role.
 */
export type SuperUserActivity = {
    uuid?: string;
    readonly created_at: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
    readonly case_uuid: string;
    readonly case_client_display_name: string;
    readonly case_client_initials: string;
    readonly case_client_email: string;
    readonly clerk_uuid: string | null;
    readonly clerk_first_name: string | null;
    readonly clerk_last_name: string | null;
    readonly document_title: string | null;
    readonly questionnaire_title: string | null;
    readonly email_from: string | null;
    readonly email_to: string;
    readonly appointment_start: string | null;
    readonly appointment_is_confirmed: boolean | null;
};

/**
 * Activity serializer for superuser role.
 */
export type SuperUserActivityRequest = {
    uuid?: string;
    seen_at?: string | null;
    activity_type: ActivityTypeEnum;
};

/**
 * AgentAction representation for superusers.
 */
export type SuperUserAgentAction = {
    readonly uuid: string;
    readonly created_at: string;
    readonly updated_at: string;
    readonly agent: string;
    readonly agent_trace_id: string;
    readonly calling_agent: string | null;
    readonly calling_agent_trace_id: string | null;
    readonly action_type: ActionTypeEnum;
    readonly delivery_mode: DeliveryModeEnum;
    readonly reasoning_translation: string;
    readonly reasoning_commit_decision_translation: string;
    readonly payload: string;
    readonly revert_payload: string;
    readonly is_commitable: boolean;
    readonly is_committed: boolean;
    readonly is_committing: boolean;
    readonly commit_return_value: unknown;
    readonly commited_at: string | null;
    readonly commited_by_uuid: string;
    readonly has_commit_error: boolean | null;
    readonly commit_error: string | null;
    readonly is_revertable: boolean;
    readonly is_reverted: boolean;
    readonly is_reverting: boolean;
    readonly revert_return_value: unknown;
    readonly reverted_at: string | null;
    readonly reverted_by_uuid: string;
    readonly has_revert_error: boolean | null;
    readonly revert_error: string | null;
    readonly case_uuid: string;
    readonly org_uuid: string;
    readonly rating: string | null;
    readonly langfuse_trace_url: string;
};

export type SuperUserAiAnalysis = {
    readonly uuid: string;
    readonly mapper_key: string;
    readonly ai_augments_mapper_keys: unknown;
    readonly started_at: string | null;
    readonly finished_at: string | null;
    readonly is_finished: boolean;
    case_uuid: string;
    document_uuid: string;
};

export type SuperUserAiAnalysisRequest = {
    case_uuid: string;
    document_uuid: string;
};

export type SuperUserAiAugmentation = {
    readonly uuid: string;
    readonly augmentation_variant: AugmentationVariantEnum;
    document: Document;
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    readonly analysis_mapper_key: string | null;
    readonly augmented_mapper_key: string;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

export type SuperUserAiAugmentationRequest = {
    value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    referenced_document_pages: Array<(number)>;
    explanation: string;
};

/**
 * AI Settings representation for superusers.
 */
export type SuperUserAiSettings = {
    readonly uuid: string;
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    readonly organisation: number;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * AI Settings representation for superusers.
 */
export type SuperUserAiSettingsRequest = {
    /**
     * Instructions for AI agents when performing entity extraction
     */
    entity_extraction_instructions?: string;
    auto_commit_settings?: string;
    notification_settings?: string;
    /**
     * Enable or disable AI workflows for this organisation. When disabled, AI workflows will not be executed for cases in this organisation.
     */
    ai_workflows_enabled?: boolean;
    /**
     * Whether to send notifications bundled or individually
     */
    send_notifications_bundled?: boolean;
    /**
     * Maximum delay in seconds before sending bundled notifications
     */
    bundled_notifications_max_delay?: number;
    /**
     * Instructions for AI agents during pre case context gathering
     */
    on_case_pre_case_context_gathering_instructions?: string;
    /**
     * Instructions for AI agents during post case context gathering
     */
    on_case_post_case_context_gathering_instructions?: string;
};

/**
 * Full announcement serializer for superusers.
 *
 * Provides access to all fields for managing announcements.
 */
export type SuperUserAnnouncement = {
    readonly uuid: string;
    /**
     * The announcement message to display
     */
    message: string;
    /**
     * The type of announcement (determines color/styling)
     *
     * * `INFO` - Info
     * * `WARNING` - Warning
     * * `ERROR` - Error
     * * `SUCCESS` - Success
     */
    message_type?: MessageTypeEnum;
    /**
     * Whether this announcement should be displayed
     */
    is_active?: boolean;
    /**
     * Optional start date for the announcement
     */
    start_date?: string | null;
    /**
     * Optional end date for the announcement
     */
    end_date?: string | null;
    /**
     * Whether users can dismiss this announcement
     */
    dismissible?: boolean;
    readonly created_at: string;
    readonly updated_at: string;
};

/**
 * Full announcement serializer for superusers.
 *
 * Provides access to all fields for managing announcements.
 */
export type SuperUserAnnouncementRequest = {
    /**
     * The announcement message to display
     */
    message: string;
    /**
     * The type of announcement (determines color/styling)
     *
     * * `INFO` - Info
     * * `WARNING` - Warning
     * * `ERROR` - Error
     * * `SUCCESS` - Success
     */
    message_type?: MessageTypeEnum;
    /**
     * Whether this announcement should be displayed
     */
    is_active?: boolean;
    /**
     * Optional start date for the announcement
     */
    start_date?: string | null;
    /**
     * Optional end date for the announcement
     */
    end_date?: string | null;
    /**
     * Whether users can dismiss this announcement
     */
    dismissible?: boolean;
};

/**
 * Appointment representation for superusers.
 */
export type SuperUserAppointment = {
    uuid?: string;
    readonly service: SuperUserService;
    readonly calendar: SuperUserCalendar;
    start: string;
    end: string;
    location_types?: LocationTypesEnum;
    location?: unknown;
    conferencing?: unknown;
    description?: string;
    status: AppointmentStatusEnum;
    summary: string;
    /**
     * Whether this appointment was successfully synced to Cronofy calendar
     */
    cronofy_synced?: boolean;
};

export type SuperUserAppointmentProposal = {
    uuid?: string;
    readonly service: SuperUserService;
    readonly calendar: SuperUserCalendar;
    start: string | null;
    location_type: LocationTypeEnum;
    readonly booked: boolean;
    readonly slug: string;
    message?: string | null;
    readonly channel: string | null;
};

export type SuperUserAppointmentProposalRequest = {
    uuid?: string;
    case_uuid: string;
    start: string | null;
    location_type: LocationTypeEnum;
    message?: string | null;
    service_uuid: string;
    calendar_uuid: string;
};

/**
 * Super user workflow assignment response.
 */
export type SuperUserAssignWorkflowResponse = {
    /**
     * Assigned workflow details, null if no workflow is assigned
     */
    assigned_workflow: (SuperUserCaseLifecycleWorkflow) | null;
};

export type SuperUserCalendar = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: string | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    readonly account: SuperUserAccount;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

export type SuperUserCalendarRequest = {
    uuid?: string;
    active?: boolean;
    name?: string;
    description?: string;
    long_description?: string;
    avatar?: (Blob | File) | null;
    services?: Array<(number)>;
    slug?: string;
    deactivated?: boolean;
    profile: number;
    calendar_id: string;
    calendar_name: string;
    calendar_readonly?: boolean;
    calendar_deleted?: boolean;
    calendar_primary?: boolean;
    calendar_integrated_conferencing_available?: boolean;
    calendar_attachments_available?: boolean;
    permission_level: string;
};

/**
 * Call representation for super users.
 */
export type SuperUserCall = {
    readonly uuid: string;
    /**
     * 32-char hex trace ID for Langfuse observability
     */
    readonly langfuse_trace_id: string | null;
    user_phone_number: string;
    phone_number_uuid: string;
    readonly phone_number: SuperUserPhoneNumber;
    retell_call_id?: string;
    /**
     * Return the URL of the audio recording of the call.
     */
    readonly audio_recording_url: string | null;
    /**
     * Return the URL of the langfuse traces of the call.
     */
    readonly langfuse_traces_url: string;
    /**
     * Return the URL of the retell dashboard of the call.
     */
    readonly retell_dashboard_url: string;
    /**
     * Return the URL of the twilio console of the call.
     */
    readonly twilio_console_url: string;
    readonly transcript: Array<CallTranscriptMessage>;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResult;
    readonly user_feedback: (SuperUserCallUserFeedback) | null;
    readonly lawyer_feedback: SuperUserLawyerFeedback;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    readonly case_uuid: string;
    readonly case_id: number;
    readonly case: SuperUserCaseInfo;
    readonly is_rated: boolean;
    had_caller_accent?: boolean | null;
    note?: string | null;
    readonly clerk: SuperUserOrganisationUser;
    forward?: (Forward) | null;
    readonly gemini_shadow_comparison: (GeminiShadowComparison) | null;
};

/**
 * Call representation for super users.
 */
export type SuperUserCallRequest = {
    user_phone_number: string;
    phone_number_uuid: string;
    retell_call_id?: string;
    twilio_call_sid?: string;
    call_start_time?: string;
    call_end_time?: string | null;
    data?: unknown;
    result?: SuperUserCallResultRequest;
    agent_rating?: string | null;
    agent_rating_by_human?: string | null;
    system_rating?: string | null;
    system_rating_by_human?: string | null;
    system_rating_summary?: string;
    system_rating_summary_by_human?: string;
    was_name_asked?: boolean | null;
    was_name_mentioned?: boolean | null;
    is_name_correct?: boolean | null;
    was_email_asked?: boolean | null;
    was_email_mentioned?: boolean | null;
    is_email_correct?: boolean | null;
    was_phone_asked?: boolean | null;
    was_phone_mentioned?: boolean | null;
    is_phone_correct?: boolean | null;
    needed_to_ask_for_case_number?: boolean | null;
    was_case_number_asked?: boolean | null;
    is_case_number_correct?: boolean | null;
    is_lawfield_correct?: boolean | null;
    is_lawtopic_correct?: boolean | null;
    is_classification_correct?: boolean | null;
    did_caller_hang_up_early?: boolean | null;
    did_caller_hang_up_early_due_to_conversation?: boolean | null;
    did_caller_speak_in_single_words?: boolean | null;
    is_inquiry_helpful?: boolean | null;
    can_customer_derive_value?: boolean | null;
    did_call_have_background_noise?: boolean | null;
    was_caller_annoyed?: boolean | null;
    consumed_tokens?: number;
    total_cost?: string;
    duration?: number;
    had_caller_accent?: boolean | null;
    note?: string | null;
    clerk_id?: string | null;
    forward?: (ForwardRequest) | null;
};

export type SuperUserCallResult = {
    readonly uuid: string;
    classification: ClassificationEnum;
    inquiry?: string;
    data: ShallowCaseData;
    first_name_recording_start_seconds?: string | null;
    first_name_recording_end_seconds?: string | null;
    last_name_recording_start_seconds?: string | null;
    last_name_recording_end_seconds?: string | null;
    email_recording_start_seconds?: string | null;
    email_recording_end_seconds?: string | null;
    phone_number_recording_start_seconds?: string | null;
    phone_number_recording_end_seconds?: string | null;
};

export type SuperUserCallResultRequest = {
    classification: ClassificationEnum;
    inquiry?: string;
    data: ShallowCaseDataRequest;
    first_name_recording_start_seconds?: string | null;
    first_name_recording_end_seconds?: string | null;
    last_name_recording_start_seconds?: string | null;
    last_name_recording_end_seconds?: string | null;
    email_recording_start_seconds?: string | null;
    email_recording_end_seconds?: string | null;
    phone_number_recording_start_seconds?: string | null;
    phone_number_recording_end_seconds?: string | null;
};

/**
 * Call user feedback representation for super users.
 */
export type SuperUserCallUserFeedback = {
    readonly uuid: string;
    rating?: string | null;
    feedback?: string;
    would_call_again?: boolean;
    email?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    is_submitted?: boolean;
};

/**
 * Call user feedback representation for super users.
 */
export type SuperUserCallUserFeedbackRequest = {
    rating?: string | null;
    feedback?: string;
    would_call_again?: boolean;
    email?: string;
    phone?: string;
    first_name?: string;
    last_name?: string;
    is_submitted?: boolean;
};

/**
 * Case representation for super users.
 */
export type SuperUserCase = {
    readonly id: number;
    readonly uuid: string;
    readonly questionnaire_submissions: Array<SuperUserQuestionnaireSubmission>;
    readonly form_requests: Array<SuperUserRequest>;
    readonly org: SuperUserOrganisation;
    readonly modified_at: string;
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: SuperUserCaseData;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
    readonly pdf_form_submissions: string;
    readonly virtual_documents: string;
    readonly clerk: SuperUserOrganisationUser;
    readonly services: string;
    readonly chat_sessions: Array<AIChatSession>;
    readonly activities: Array<Activity>;
    readonly case_lifecycle_state: SuperUserCaseLifecycleState;
    jupus_case_number?: string | null;
};

export type SuperUserCaseData = {
    uuid?: string;
    client: Entity;
    opponent: Entity;
    law: LawData;
    readonly entities: Array<SuperUserEntityWithRelationship>;
    readonly changes: Array<SuperUserCaseDataChange>;
    readonly mappers: Array<GenericDataMapper>;
};

export type SuperUserCaseDataChange = {
    uuid?: string;
    readonly created_at: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: SuperUserOrganisationUser;
    ai_augmentation: SuperUserAiAugmentation;
};

export type SuperUserCaseDataChangeRequest = {
    uuid?: string;
    mapper_key: string;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: SuperUserAiAugmentationRequest;
};

export type SuperUserCaseDataRequest = {
    uuid?: string;
    client: EntityRequest;
    opponent: EntityRequest;
    law: LawDataRequest;
};

/**
 * Minimal case info for calls that are connected to cases (SuperUser version)
 */
export type SuperUserCaseInfo = {
    uuid: string;
    pk: number;
    note: string | null;
    readonly clerk: SuperUserOrganisationUser;
    law_field: string;
    law_topic: string;
};

/**
 * Minimal case info for calls that are connected to cases (SuperUser version)
 */
export type SuperUserCaseInfoRequest = {
    uuid: string;
    pk: number;
    note: string | null;
    law_field: string;
    law_topic: string;
};

/**
 * Case Lifecycle State representation for superusers.
 */
export type SuperUserCaseLifecycleState = {
    readonly uuid: string;
    readonly current_state: CurrentStateEnum;
    readonly assigned_workflow: SuperUserCaseLifecycleWorkflow;
    readonly state_transition_results: Array<CaseLifecycleStateTransitionResult>;
    is_agent_active?: boolean;
    readonly rating: string | null;
    readonly langfuse_session_url: string;
};

/**
 * Case Lifecycle State representation for superusers.
 */
export type SuperUserCaseLifecycleStateRequest = {
    /**
     * UUID of the workflow to assign to the case. Set to null to remove workflow assignment.
     */
    workflow_uuid?: string | null;
    is_agent_active?: boolean;
};

/**
 * Case Lifecycle Workflow representation for superusers.
 */
export type SuperUserCaseLifecycleWorkflow = {
    readonly uuid: string;
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<SuperUserActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<SuperUserActionAutoCommitSettings>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<SuperUserActionAutoCommitSettings>;
    on_all_documents_drafted_auto_commit_settings?: Array<SuperUserActionAutoCommitSettings>;
    readonly created_at: string;
    readonly updated_at: string;
    readonly org: number;
};

/**
 * Case Lifecycle Workflow representation for superusers.
 */
export type SuperUserCaseLifecycleWorkflowRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    /**
     * Instructions for AI agents when handling a new case - Step 1
     */
    on_case_ready_for_onboarding_step_1_instructions?: string;
    on_case_ready_for_onboarding_step_1_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when handling a new case - Step 2
     */
    on_case_ready_for_onboarding_step_2_instructions?: string;
    on_case_ready_for_onboarding_step_2_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    /**
     * Instructions for AI agents when all data for a case has been collected
     */
    on_all_data_collected_instructions?: string;
    on_all_data_collected_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
    on_all_documents_drafted_auto_commit_settings?: Array<SuperUserActionAutoCommitSettingsRequest>;
};

/**
 * Case representation for super users.
 */
export type SuperUserCaseRequest = {
    created_at?: string;
    note?: string | null;
    type?: CaseType;
    state?: StateEnum;
    inquiry?: string;
    data?: SuperUserCaseDataRequest;
    client_document_email_reminder_sent_at?: string | null;
    client_document_email_reminder_opt_out?: boolean;
    send_outstanding_document_email_reminder?: boolean;
    sent_to_actaport_at?: string | null;
    actaport_case_id?: string | null;
    sent_to_advoware_at?: string | null;
    advoware_case_id?: string | null;
    sent_to_iusta_at?: string | null;
    iusta_data?: unknown;
    is_selected_for_export_to?: unknown;
    exported_to?: unknown;
    export_data?: unknown;
    sent_to_ra_micro_at?: string | null;
    sent_to_advolux_at?: string | null;
    last_activity_at?: string;
    last_activity_seen_at?: string;
    user_access_token?: string;
    kleos_case_id?: string | null;
    kleos_reference?: string | null;
    clerk_id?: string | null;
    jupus_case_number?: string | null;
};

/**
 * Serializer for superusers to create PDF form templates with org selection.
 */
export type SuperUserCreatePDFFormTemplateRequest = {
    name: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf: (Blob | File);
    org_uuid: string;
};

export type SuperUserDeliveryEvent = {
    readonly uuid: string;
    readonly email: number;
    readonly event: EventEnum;
    readonly event_description: string | null;
    readonly created_at: string;
    readonly updated_at: string;
};

export type SuperUserDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
};

export type SuperUserDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    document_template?: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
};

export type SuperUserEmail = {
    readonly uuid: string;
    readonly from_email: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    readonly bcc: Array<EmailAddress>;
    subject: string;
    text?: string;
    html?: string;
    readonly direction: string;
    readonly source: string;
    readonly sent_at: string;
    readonly pdf_url: string;
    readonly relevant_delivery_event: SuperUserDeliveryEvent;
    readonly email_service: EmailServiceEnum;
};

export type SuperUserEmailTemplate = {
    readonly uuid: string;
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    readonly questionnaires: Array<SuperUserQuestionnaire>;
    readonly forms: Array<SuperUserForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type SuperUserEmailTemplateRequest = {
    type: EmailTemplateType;
    name: string;
    subject: string;
    html: string;
    default: boolean;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids: Array<(string)>;
    form_uuids: Array<(string)>;
};

/**
 * Entity representation for super users.
 */
export type SuperUserEntity = {
    readonly uuid: string;
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    readonly is_company: string;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
    readonly changes: Array<SuperUserEntityChange>;
};

export type SuperUserEntityChange = {
    uuid?: string;
    readonly created_at: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    user: SuperUserOrganisationUser;
    ai_augmentation: SuperUserAiAugmentation;
};

export type SuperUserEntityChangeRequest = {
    uuid?: string;
    entities_mapper_key: EntitiesMapperKeyEnum;
    old_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    new_value: string | number | boolean | {
    [key: string]: unknown;
} | Array<unknown>;
    change_source: ChangeSourceEnum;
    ai_augmentation: SuperUserAiAugmentationRequest;
};

/**
 * Entity representation for super users.
 */
export type SuperUserEntityRequest = {
    entity_type: EntityTypeEnum;
    title?: TitleEnum | BlankEnum;
    specific_title?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    street?: string;
    street_number?: string;
    address_line_2?: string;
    zip?: string;
    city?: string;
    date_of_birth?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string;
    legal_insurance_name?: string;
    legal_insurance_deductible_amount?: string | null;
    company_name?: string;
    company_legal_form?: CompanyLegalFormEnum | BlankEnum;
    company_register_number?: string;
    company_register_court?: string;
    company_vat_id?: string;
    company_tax_id?: string;
    bank_name?: string;
    iban?: string;
    bic?: string;
    institution_name?: string;
};

export type SuperUserEntityWithRelationship = {
    uuid?: string;
    entity: SuperUserEntity;
    relationships: Array<EntityRelationship>;
};

export type SuperUserEntityWithRelationshipRequest = {
    uuid?: string;
    entity: SuperUserEntityRequest;
    relationships: Array<EntityRelationshipRequest>;
};

export type SuperUserFeedback = {
    readonly uuid: string;
    readonly created_at: string;
    url: string;
    readonly user: SuperUserUser;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

export type SuperUserFeedbackRequest = {
    url: string;
    rating: string;
    feature: FeatureEnum;
    comment?: string;
    related_data: FeedbackRelatedData;
};

/**
 * Form representation for superusers.
 */
export type SuperUserForm = {
    readonly id: string;
    readonly organisation: SuperUserOrganisation;
    organisation_uuid: string;
    readonly created_at: string;
    readonly modified_at: string;
    readonly created_by: SuperUserUser;
    readonly modified_by: SuperUserUser;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: string | null;
    readonly due_at: string;
    readonly document_name: string;
};

/**
 * Form representation for superusers.
 */
export type SuperUserFormRequest = {
    organisation_uuid: string;
    tag?: FormTag | BlankEnum;
    title?: string;
    description?: string;
    file?: (Blob | File) | null;
};

export type SuperUserHubSpotCompany = {
    readonly uuid: string;
    readonly hubspot_id: string | null;
    readonly hubspot_archived: boolean | null;
    readonly hubspot_archived_at: string | null;
    readonly hubspot_created_at: string | null;
    readonly hubspot_updated_at: string | null;
    readonly create_date: string | null;
    readonly domain: string | null;
    readonly hs_last_modified_date: string | null;
    readonly hs_object_id: string | null;
    readonly hubspot_url: string;
    readonly name: string | null;
};

export type SuperUserHubSpotContact = {
    readonly uuid: string;
    readonly hubspot_id: string | null;
    readonly hubspot_archived: boolean | null;
    readonly hubspot_archived_at: string | null;
    readonly hubspot_created_at: string | null;
    readonly hubspot_updated_at: string | null;
    readonly create_date: string | null;
    readonly email: string | null;
    readonly first_name: string | null;
    readonly hs_object_id: string | null;
    readonly last_modified_date: string | null;
    readonly last_name: string | null;
};

export type SuperUserInboundEmail = {
    uuid?: string;
    readonly email: SuperUserEmail;
    readonly created_at: string;
    readonly org: SuperUserOrganisation;
    is_failed?: boolean;
    readonly from_email: EmailAddress;
    readonly reply_to: EmailAddress;
    readonly to: Array<EmailAddress>;
    readonly cc: Array<EmailAddress>;
    subject: string;
    html: string;
    text: string;
    readonly attachments: Array<InboundEmailAttachment>;
};

export type SuperUserLawyerFeedback = {
    readonly uuid: string;
    rating: string;
    feedback?: string;
};

export type SuperUserLawyerFeedbackRequest = {
    rating: string;
    feedback?: string;
    call_uuid: string;
};

export type SuperUserOnboardingPackage = {
    readonly uuid: string;
    name: string;
    readonly questionnaires: Array<SuperUserQuestionnaire>;
    readonly forms: Array<SuperUserForm>;
    readonly pdf_form_templates: Array<PDFFormTemplate>;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly updated_at: string;
};

export type SuperUserOnboardingPackageRequest = {
    name: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    questionnaire_uuids?: Array<(string)>;
    form_uuids?: Array<(string)>;
};

/**
 * Organisation representation for superusers.
 */
export type SuperUserOrganisation = {
    readonly uuid: string;
    readonly oid: number;
    name?: string | null;
    logo?: string | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    readonly inbound_email_address: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    enable_ai_workflows?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    readonly stripe_customer: SuperUserStripeCustomer;
    stripe_customer_uuid: string | null;
    readonly customer_number: string;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    is_datev_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    readonly hubspot_company: SuperUserHubSpotCompany;
    hubspot_company_uuid: string | null;
    readonly advoware_clerk_options: string;
    readonly advoware_law_field_options: string;
    readonly actaport_clerk_options: string;
    readonly jurnodes_datapool_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_lawyer_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_law_category_options: Array<{
        id: number;
        name: string;
    }>;
    readonly jurnodes_record_schema_options: Array<{
        id: number;
        name: string;
    }>;
    readonly actaport_assistant_options: string;
    readonly kleos_case_type_options: string;
    readonly users: Array<SuperUserOrganisationUser>;
    has_churned?: boolean;
    onboarding_start_date?: string | null;
    enable_law_specific_data?: boolean;
    readonly ai_chat_question_templates: Array<AiChatQuestionTemplate>;
    is_new_ui_switch_enabled?: boolean;
    is_forced_to_use_new_ui?: boolean;
    readonly vitally_id: string;
    readonly vitally_updated_at: string | null;
    readonly vitally_health_score: string | null;
    is_phonebot_self_service_customer?: boolean;
    phonebot_self_service_plan?: PhonebotSelfServicePlanEnum | BlankEnum | NullEnum | null;
    phonebot_self_service_plan_enterprise_included_minutes?: number;
    phonebot_trial_ends_at?: string | null;
    monsum_customer_number?: string;
    can_configure_email?: boolean;
    theme?: ThemeEnum;
};

/**
 * Serializer for creating a new organisation with users.
 *
 * This serializer handles the creation of a new organisation along with
 * its initial users. It follows best practices for database transactions:
 *
 * **Transaction Flow:**
 * 1. Inside atomic transaction:
 * - Create organisation in database
 * - Create User records in Django with temporary usernames
 * 2. After transaction commits (via transaction.on_commit):
 * - Create users in Keycloak (external API call)
 * - Update User records with actual Keycloak usernames
 * - Send welcome emails to all users
 *
 * This approach ensures that:
 * - Database changes are atomic and can be rolled back if needed
 * - External API calls (Keycloak) don't hold the transaction open
 * - System remains consistent even if Keycloak operations fail
 */
export type SuperUserOrganisationCreateRequest = {
    name?: string | null;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
    monsum_customer_number?: string;
    seats?: number;
    law_fields?: unknown;
    appointments_seats?: number;
    onboarding_start_date?: string | null;
    is_test?: boolean;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    can_configure_email?: boolean;
    is_new_ui_switch_enabled?: boolean;
    is_forced_to_use_new_ui?: boolean;
    ai_enabled?: boolean;
    enable_ai_workflows?: boolean;
    enable_cases?: boolean;
    enable_voice?: boolean;
    enable_appointments?: boolean;
    enable_law_specific_data?: boolean;
    stripe_customer_uuid?: string | null;
    users: Array<UserCreateRequest>;
};

/**
 * Organisation representation for superusers.
 */
export type SuperUserOrganisationRequest = {
    name?: string | null;
    logo?: (Blob | File) | null;
    description?: string;
    slug?: string;
    law_fields?: unknown;
    law_firm?: boolean;
    short_id?: string;
    street?: string | null;
    street_number?: string | null;
    zip?: string | null;
    city?: string | null;
    country?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    phone?: string | null;
    email?: string | null;
    inbound_email_slug?: string;
    enable_inbound_email_replies?: boolean;
    seats?: number;
    appointments_seats?: number;
    email_text_color?: EmailTextColorEnum;
    email_text_font?: EmailTextFontEnum;
    email_text_size?: EmailTextSizeEnum;
    email_signature?: string;
    email_blocked_senders?: unknown;
    email_spam_filter_active?: boolean;
    track_email_delivery_events?: boolean;
    track_opened_click_email_delivery_events?: boolean;
    receive_questionnaire_closed_mail?: boolean;
    receive_document_signed_mail?: boolean;
    receive_new_case_mail?: boolean;
    receive_new_case_email_mail?: boolean;
    receive_new_appointment_mail?: boolean;
    receive_email_new_call?: boolean;
    receive_email_forwarded_call?: boolean;
    send_document_email_reminders?: boolean;
    send_document_email_reminders_every_x_days?: number;
    /**
     * Maximum number of reminders that can be sent per document or questionnaire
     */
    max_reminders?: number;
    send_email_client_confirmation_on_new_case?: boolean;
    send_email_client_confirmation_on_new_case_via_email?: boolean;
    receive_clerk_change_mail?: boolean;
    receive_email_bounce_notifications?: boolean;
    is_actaport_export_integration_enabled?: boolean;
    questionnaire_creation_token?: string;
    ai_enabled?: boolean;
    enable_ai_workflows?: boolean;
    is_iusta_egress_integration_enabled?: boolean;
    is_ra_micro_export_integration_enabled?: boolean;
    ra_micro_export_integration_type?: RaMicroExportIntegrationTypeEnum | NullEnum | null;
    ra_micro_oma_email_id?: string | null;
    ra_micro_oma_email?: string | null;
    ra_micro_upload_limit_mb?: number;
    is_advolux_export_integration_enabled?: boolean;
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
    is_email_egress_integration_enabled?: boolean;
    email_egress_address?: string | null;
    is_kleos_integration_enabled?: boolean;
    is_advoware_export_integration_enabled?: boolean;
    is_law_firm_software_exportation_enabled?: boolean;
    enable_appointments?: boolean;
    enable_voice?: boolean;
    enable_cases?: boolean;
    stripe_customer_uuid: string | null;
    is_hubspot_egress_integration_enabled?: boolean;
    is_haveibeenpwned_integration_enabled?: boolean;
    is_jurnodes_export_integration_enabled?: boolean;
    is_datev_export_integration_enabled?: boolean;
    bot_title?: string;
    bot_embed_uuid?: string;
    bot_starttime?: string;
    bot_attention_message?: string;
    bot_title_background_color?: string;
    bot_title_text_color?: string;
    bot_chat_bubble_operator_color?: string;
    bot_message_input_text_color?: string;
    bot_custom_font_family?: string;
    bot_chat_auto_open?: boolean;
    bot_chat_auto_open_delay?: number;
    bot_chat_target_element?: string;
    bot_button_auto_show?: boolean;
    bot_button_auto_show_delay?: number;
    bot_button_position?: BotButtonPositionEnum;
    bot_chat_bubble_operator_text_color?: string;
    bot_button_background_color?: string;
    bot_button_text_color?: string;
    bot_chat_bubble_contact_color?: string;
    bot_chat_bubble_contact_text_color?: string;
    bot_floating_custom?: string;
    bot_footer_content?: string;
    bot_background_color?: string;
    bot_message_input_background_color?: string;
    bot_start_without_bot?: unknown;
    bot_start_without_bot_buttons?: unknown;
    bot_floating_custom_button_background_color?: string;
    bot_floating_custom_button_text_color?: string;
    bot_floating_custom_button_width?: number;
    bot_floating_custom_button_height?: number;
    bot_floating_custom_button_text?: string;
    receive_monthly_updates_summary?: boolean;
    hubspot_company_uuid: string | null;
    has_churned?: boolean;
    onboarding_start_date?: string | null;
    enable_law_specific_data?: boolean;
    is_new_ui_switch_enabled?: boolean;
    is_forced_to_use_new_ui?: boolean;
    is_phonebot_self_service_customer?: boolean;
    phonebot_self_service_plan?: PhonebotSelfServicePlanEnum | BlankEnum | NullEnum | null;
    phonebot_self_service_plan_enterprise_included_minutes?: number;
    phonebot_trial_ends_at?: string | null;
    monsum_customer_number?: string;
    can_configure_email?: boolean;
    theme?: ThemeEnum;
};

export type SuperUserOrganisationUser = {
    readonly uuid: string;
    readonly email: string;
    readonly first_name: string;
    readonly last_name: string;
    readonly avatar: string | null;
};

/**
 * Serializer for superusers - full access to all fields.
 */
export type SuperUserPDFFormSubmission = {
    uuid?: string;
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    /**
     * Snapshot of template name at submission creation time
     */
    template_name?: string;
    /**
     * Snapshot of template description at submission creation time
     */
    template_description?: string;
    form_fields: Array<SubmissionFormField>;
    /**
     * Completion percentage (0-100)
     */
    progress_percentage?: number;
    readonly created_at: string;
    /**
     * When the form was completed
     */
    completed_at?: string | null;
    readonly updated_at: string;
    created_by?: number | null;
    org: number;
    template: PDFFormTemplate;
    document: Document;
    /**
     * Standalone submission that creates a new case (like questionnaires from settings)
     */
    is_standalone?: boolean;
    /**
     * External submission linked to existing case for third-party completion
     */
    is_external?: boolean;
};

/**
 * Serializer for superusers - full access to all fields.
 */
export type SuperUserPDFFormSubmissionRequest = {
    uuid?: string;
    /**
     * Current status of the form submission
     *
     * * `in_progress` - In Progress
     * * `completed` - Completed
     */
    submission_status?: SubmissionStatusEnum;
    /**
     * Snapshot of template name at submission creation time
     */
    template_name?: string;
    /**
     * Snapshot of template description at submission creation time
     */
    template_description?: string;
    form_fields: Array<SubmissionFormFieldRequest>;
    /**
     * Completion percentage (0-100)
     */
    progress_percentage?: number;
    /**
     * When the form was completed
     */
    completed_at?: string | null;
    created_by?: number | null;
    org: number;
    template: PDFFormTemplateRequest;
    /**
     * Standalone submission that creates a new case (like questionnaires from settings)
     */
    is_standalone?: boolean;
    /**
     * External submission linked to existing case for third-party completion
     */
    is_external?: boolean;
};

/**
 * Serializer for superusers - includes organization information.
 */
export type SuperUserPDFFormTemplate = {
    readonly uuid: string;
    name: string;
    description?: string;
    /**
     * Original PDF template uploaded by user (preserved, never modified)
     */
    original_pdf: string;
    /**
     * Processed PDF with annotations stripped for clean display
     */
    readonly processed_pdf: string | null;
    form_fields?: Array<FormField>;
    /**
     * Token used to create standalone form submissions via public URLs
     */
    readonly template_creation_token: string | null;
    readonly created_at: string;
    readonly created_by: CustomerUser;
    readonly updated_at: string;
    readonly modified_by: CustomerUser;
    readonly org: ClientOrganisation;
};

/**
 * PhoneNumber representation for superusers.
 */
export type SuperUserPhoneNumber = {
    uuid?: string;
    readonly created_at: string;
    active?: boolean;
    readonly org: SuperUserOrganisation;
    readonly phone_number: string | null;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * COMPATIBILITY: Return the old field name for the free initial consultation.
     */
    readonly free_initial_consultation: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    readonly phone_number_sid: string | null;
    readonly agent: SuperUserRetellAgent;
    readonly voice_url: string | null;
    readonly voice_method: string | null;
    readonly status_callback: string | null;
    readonly status_callback_method: string | null;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
    readonly forwarding_rules: Array<PhoneForwardingRuleList>;
};

/**
 * PhoneNumber representation for superusers.
 */
export type SuperUserPhoneNumberRequest = {
    uuid?: string;
    active?: boolean;
    law_fields?: unknown;
    /**
     * Hier können Sie eine interne Bezeichnung für die Rufnummer hinterlegen.
     */
    description?: string;
    /**
     * Geben Sie hier den Namen Ihrer Kanzlei ein, wie er in der Begrüßungsansage genannt werden soll.
     */
    lawfirm_name?: string;
    /**
     * Hier können Sie die Adresse Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter. Wenn Sie keine unangekündigten Mandantenbesuch wünschen, dann geben Sie hier bitte einen entsprechenden Hinweis.
     */
    address?: string;
    /**
     * Hier können Sie Ihre Öffnungszeiten Ihrer Kanzlei hinterlegen. Bei Nachfrage geben wir diese an den Anrufer weiter.
     */
    opening_hours?: string;
    /**
     * Hier können Sie die Namen Ihrer Anwälte oder Sachbearbeiter hinterlegen. Dies hilft uns dabei, den Namen des Anrufers besser zu erkennen. Bitte tragen Sie nur den Namen ein und keine weitere Bezeichnung wie zum Beispiel Anwalt oder Sachbearbeiter.
     */
    lawyer_names?: string;
    /**
     * Bieten Sie eine kostenlose Erstberatung an? Wenn ja, dann aktivieren Sie diese Option und wir geben dies an den Anrufer weiter.
     */
    has_free_initial_consultation?: boolean;
    /**
     * Wenn Sie die von uns generierte Nummer intern weiterleiten, geben Sie hier unbedingt die Originalnummer an, welche von den Mandanten angerufen wird. So stellen Sie sicher, dass wir die Anrufe korrekt zuordnen können.
     */
    original_phone_number?: string;
    /**
     * Durch das Aktivieren dieser Option Stellen wir Ihnen auf der Detailseite eines Anrufs einen Mitschnitt des Namen bzw. der E-Mail-Addresse zur Verfügung. Die Aufzeichnung von Anrufen ist in Deutschland nur mit Zustimmung des Anrufers gestattet. Wir weisen Sie darauf hin, dass Sie diese Zustimmung von dem Anrufer einholen müssen.
     */
    can_record_calls?: boolean;
    is_in_answering_machine_mode?: boolean;
    agent_uuid: string;
    org_uuid: string;
    /**
     * Hier können Sie eine Begrüßung für den Anrufbeantworter hinterlegen. Diese wird am Anfang des Anrufes abgespielt.
     */
    begin_message?: string;
    /**
     * Diese Nachricht wird abgespielt, wenn eine weitergeleitete Nummer nicht abnimmt.
     */
    forwarding_no_answer_message?: string;
    /**
     * Hier können Sie eine Abschiedsnachricht für den Anrufbeantworter hinterlegen. Diese wird am Ende des Anrufes abgespielt.
     */
    end_message?: string;
};

/**
 * Questionnaire representation for superusers.
 */
export type SuperUserQuestionnaire = {
    readonly uuid: string;
    title: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema: Array<QuestionnaireSection>;
    readonly theme_color: string;
    readonly org: ClientOrganisation;
    /**
     * True if this questionnaire is a Jupus template that can be copied by organizations
     */
    is_jupus_template?: boolean;
    readonly created_by_name: string;
    readonly questionnaire_creation_token: string;
    readonly org_questionnaire_creation_token: string;
};

/**
 * Questionnaire representation for superusers.
 */
export type SuperUserQuestionnaireRequest = {
    title: string;
    description?: string;
    category?: CategoryEnum | BlankEnum;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    schema: Array<QuestionnaireSectionRequest>;
    org_uuid?: string | null;
    /**
     * True if this questionnaire is a Jupus template that can be copied by organizations
     */
    is_jupus_template?: boolean;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type SuperUserQuestionnaireSubmission = {
    readonly uuid: string;
    readonly case_uuid: string;
    readonly created_at: string;
    readonly short_id: string;
    readonly title: string;
    readonly law_field: LawFieldEnum;
    readonly law_topic: LawTopicEnum;
    readonly pdf_url: string;
    readonly question_count: number;
    readonly required_question_count: number;
    readonly optional_question_count: number;
    readonly answered_question_count: number;
    readonly answered_required_questions_percent: number;
    readonly answered_optional_questions_count: number;
    readonly answered_questions_percent: number;
    readonly answered_optional_questions_percent: number;
    readonly is_third_party_questionnaire: boolean;
    readonly due_at: string;
    readonly state: string;
    schema?: unknown;
    closed?: boolean;
};

/**
 * Questionnaire submission representation for superusers.
 */
export type SuperUserQuestionnaireSubmissionRequest = {
    schema?: unknown;
    closed?: boolean;
};

export type SuperUserRequest = {
    readonly id: string;
    token: string;
    form: string;
    readonly response_present: {
        [key: string]: unknown;
    };
    readonly document_uuid: string;
    is_third_party?: boolean;
};

export type SuperUserRequestRequest = {
    token: string;
    form: string;
    is_third_party?: boolean;
};

export type SuperUserRetellAgent = {
    readonly uuid: string;
    readonly retell_agent_id: string;
    readonly agent_name: string | null;
    readonly voice_id: string;
    readonly llm_websocket_url: string;
    readonly opt_out_sensitive_data_storage: boolean;
};

export type SuperUserService = {
    uuid?: string;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
    readonly calendars: Array<Calendar>;
    readonly location_types: string;
    readonly availability_query: {
        [key: string]: unknown;
    };
};

export type SuperUserServiceRequest = {
    uuid?: string;
    active?: boolean;
    name: string;
    description: string;
    duration_mins: number;
    buffer_mins: number;
    price?: string | null;
    currency?: string;
    unit?: string;
    /**
     * Wenn aktiviert, wird der Preis der Leistung während der Buchung des Termins angezeigt.
     */
    show_price?: boolean;
    slug?: string;
    online_appointment_enabled?: boolean;
    telephone_appointment_enabled?: boolean;
    in_person_appointment_enabled?: boolean;
};

/**
 * StripeCustomer representation for superusers.
 */
export type SuperUserStripeCustomer = {
    readonly uuid: string;
    readonly stripe_id: string;
    readonly stripe_url: string;
    readonly created: string | null;
    readonly name: string | null;
    readonly email: string | null;
    readonly description: string | null;
};

/**
 * StripeInvoice representation for superusers.
 */
export type SuperUserStripeInvoice = {
    readonly uuid: string;
    readonly stripe_id: string;
    readonly created: string;
    readonly customer: SuperUserStripeCustomer;
    readonly amount_due: number;
    readonly currency: string;
    readonly description: string | null;
    readonly invoice_pdf: string | null;
};

/**
 * User representation for superusers.
 */
export type SuperUserUser = {
    uuid?: string;
    readonly email: string;
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: string | null;
    readonly org: SuperUserOrganisation;
    readonly uid: number;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
    /**
     * Check if the current session is an impersonated session.
     *
     * :param obj: The user object being serialized
     * :return: True if this is an impersonated session, False otherwise
     */
    readonly is_impersonated_session: boolean;
};

/**
 * User representation for superusers.
 */
export type SuperUserUserRequest = {
    uuid?: string;
    first_name?: string;
    last_name?: string;
    phone?: string | null;
    avatar?: (Blob | File) | null;
    role?: Role5ccEnum | NullEnum | null;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    is_active?: boolean;
    /**
     * Legt fest, ob sich der Benutzer an der Administrationsseite anmelden kann.
     */
    is_staff?: boolean;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    is_superuser?: boolean;
    is_payments_superuser?: boolean;
    email_signature?: string;
    notifications_receive_monthly_summary?: boolean;
    case_dashboard_widgets: Array<CaseDashboardWidgetsEnum>;
    /**
     * Whether the user has seen and accepted the global AI chat intro page
     */
    global_ai_chat_intro_seen?: boolean;
    /**
     * Whether the user has clicked on Global AI Chat navigation item (badge should be hidden)
     */
    global_ai_chat_badge_dismissed?: boolean;
};

export type SuperUserWordDocumentTemplate = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    readonly original_docx_template: string | null;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: string | null;
    /**
     * AI-generated template with placeholders created from docx_template
     */
    ai_docx_template?: string | null;
    readonly created_at: string;
    readonly updated_at: string;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    readonly document: Document;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
    readonly org: ClientOrganisation;
    /**
     * Stores AI extraction confidence scores and metadata
     */
    ai_extraction_metadata?: unknown;
};

export type SuperUserWordDocumentTemplateRequest = {
    uuid?: string;
    name: string;
    description: string;
    system_prompt: string;
    /**
     * Active template used for document generation (can be original, AI-generated, or custom upload)
     */
    docx_template?: (Blob | File) | null;
    /**
     * AI-generated template with placeholders created from docx_template
     */
    ai_docx_template?: (Blob | File) | null;
    law_field?: LawFieldEnum | BlankEnum;
    law_topic?: LawTopicEnum | BlankEnum;
    is_jupus_template: boolean;
    replaceable_variables?: unknown;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: WordTemplateStatus;
    /**
     * Stores AI extraction confidence scores and metadata
     */
    ai_extraction_metadata?: unknown;
};

export type SwitchUniqueCaseDataRelationshipRequestRequest = {
    new_entity_relationship_which_should_hold_the_designated_relationship_uuid: string;
    case_data_uuid: string;
    relationship_type: RelationshipTypeEnum;
};

export type SwitchUniqueCaseDataRelationshipResponse = {
    new_entity_relationship_which_should_hold_the_designated_relationship: CustomerEntityWithRelationship;
    entity_relationship_currently_holding_the_designated_relationship: CustomerEntityWithRelationship;
};

export type TAIChatSession = AIChatSession;

export type TAIChatSessionRequest = AIChatSessionRequest;

export type TAccount = CustomerAccount | CustomerAdminAccount | SuperUserAccount;

export type TAccountRequest = CustomerAccountRequest | CustomerAdminAccountRequest | SuperUserAccountRequest;

export type TActionAutoCommitSettings = CustomerActionAutoCommitSettings | CustomerAdminActionAutoCommitSettings | SuperUserActionAutoCommitSettings;

export type TActionAutoCommitSettingsRequest = CustomerActionAutoCommitSettingsRequest | CustomerAdminActionAutoCommitSettingsRequest | SuperUserActionAutoCommitSettingsRequest;

export type TActiveAnnouncement = Announcement | SuperUserAnnouncement;

export type TActivity = CustomerActivity | CustomerAdminActivity | SuperUserActivity;

export type TActivityRequest = CustomerActivityRequest | CustomerAdminActivityRequest | SuperUserActivityRequest;

export type TAgentAction = CustomerAgentAction | CustomerAdminAgentAction | SuperUserAgentAction;

export type TAgentActionRequest = unknown;

export type TAiAnalysis = ClientAiAnalysis | CustomerAiAnalysis | CustomerAdminAiAnalysis | SuperUserAiAnalysis;

export type TAiAnalysisRequest = ClientAiAnalysisRequest | CustomerAiAnalysisRequest | CustomerAdminAiAnalysisRequest | SuperUserAiAnalysisRequest;

export type TAiAugmentation = ClientAiAugmentation | CustomerAiAugmentation | CustomerAdminAiAugmentation | SuperUserAiAugmentation;

export type TAiAugmentationRequest = ClientAiAugmentationRequest | CustomerAiAugmentationRequest | CustomerAdminAiAugmentationRequest | SuperUserAiAugmentationRequest;

export type TAiChatQuestionTemplate = AiChatQuestionTemplate;

export type TAiChatQuestionTemplateRequest = AiChatQuestionTemplateRequest;

export type TAiSettings = CustomerAiSettings | CustomerAdminAiSettings | SuperUserAiSettings;

export type TAiSettingsRequest = CustomerAiSettingsRequest | CustomerAdminAiSettingsRequest | SuperUserAiSettingsRequest;

export type TAnnouncement = Announcement | SuperUserAnnouncement;

export type TAnnouncementRequest = SuperUserAnnouncementRequest;

export type TAppointment = CustomerAppointment | CustomerAdminAccount | SuperUserAccount;

export type TAppointmentProposal = CustomerAppointmentProposal | CustomerAdminAppointmentProposal | SuperUserAppointmentProposal;

export type TAppointmentProposalRequest = CustomerAppointmentProposalRequest | CustomerAdminAppointmentProposalRequest | SuperUserAppointmentProposalRequest;

export type TAppointmentRequest = CustomerAppointmentRequest | CustomerAdminAccountRequest | SuperUserAccountRequest;

export type TAssignWorkflowResponse = CustomerAssignWorkflowResponse | CustomerAdminAssignWorkflowResponse | SuperUserAssignWorkflowResponse;

export type TCalendar = CustomerCalendar | CustomerAdminCalendar | SuperUserCalendar;

export type TCalendarRequest = CustomerCalendarRequest | CustomerAdminCalendarRequest | SuperUserCalendarRequest;

export type TCall = CustomerCall | SuperUserCall;

export type TCallRequest = CustomerCallRequest | SuperUserCallRequest;

export type TCase = ClientCase | CustomerCase | CustomerAdminCase | SuperUserCase;

export type TCaseCreatorTempDocument = CaseCreatorTempDocument;

export type TCaseCreatorTempDocumentRequest = CaseCreatorTempDocumentRequest;

export type TCaseLifecycleState = CustomerCaseLifecycleState | CustomerAdminCaseLifecycleState | SuperUserCaseLifecycleState;

export type TCaseLifecycleStateReasoning = CaseLifecycleStateReasoning;

export type TCaseLifecycleStateRequestRequest = CustomerCaseLifecycleStateRequest | CustomerAdminCaseLifecycleStateRequest | SuperUserCaseLifecycleStateRequest;

export type TCaseLifecycleWorkflow = CustomerCaseLifecycleWorkflow | CustomerAdminCaseLifecycleWorkflow | SuperUserCaseLifecycleWorkflow;

export type TCaseLifecycleWorkflowRequest = CustomerCaseLifecycleWorkflowRequest | CustomerAdminCaseLifecycleWorkflowRequest | SuperUserCaseLifecycleWorkflowRequest;

export type TCaseRequest = CustomerCaseRequest | CustomerAdminCaseRequest | SuperUserCaseRequest;

export type TChatPreference = ChatPreference;

export type TChatPreferenceRequest = ChatPreferenceRequest;

export type TDeliveryEvent = CustomerDeliveryEvent | CustomerAdminDeliveryEvent | SuperUserDeliveryEvent;

export type TDocument = Document;

export type TDocumentRequest = unknown;

export type TDocumentTemplate = CustomerDocumentTemplate | CustomerAdminDocumentTemplate | SuperUserDocumentTemplate;

export type TDocumentTemplateRequest = CustomerDocumentTemplateRequest | CustomerAdminDocumentTemplateRequest | SuperUserDocumentTemplateRequest;

export type TEmail = CustomerEmail | CustomerAdminEmail | SuperUserEmail;

export type TEmailTemplate = CustomerEmailTemplate | CustomerAdminEmailTemplate | SuperUserEmailTemplate;

export type TEmailTemplateRequest = CustomerEmailTemplateRequest | CustomerAdminEmailTemplateRequest | SuperUserEmailTemplateRequest;

export type TEntity = ClientEntity | CustomerEntity | CustomerAdminEntity | SuperUserEntity;

export type TEntityRemoveCaseDataRelationshipResponse = EntityRemoveCaseDataRelationshipCustomerResponse | EntityRemoveCaseDataRelationshipSuperUserResponse;

export type TEntityRequest = ClientEntityRequest | CustomerEntityRequest | CustomerAdminEntityRequest | SuperUserEntityRequest;

export type TEntityWithRelationship = CustomerEntityWithRelationship | CustomerAdminEntityWithRelationship | SuperUserEntityWithRelationship;

export type TFeedback = Feedback | SuperUserFeedback;

export type TFeedbackRequest = FeedbackRequest | SuperUserFeedbackRequest;

export type TForm = ClientForm | CustomerForm | CustomerAdminForm | SuperUserForm;

export type TFormRequest = CustomerFormRequest | CustomerAdminFormRequest | SuperUserFormRequest;

export type TGenericDataMapper = GenericDataMapper;

export type TInboundEmail = SuperUserInboundEmail;

export type TLawyerFeedback = LawyerFeedback | CustomerLawyerFeedback | SuperUserLawyerFeedback;

export type TLawyerFeedbackRequest = CustomerLawyerFeedbackRequest | SuperUserLawyerFeedbackRequest;

export type TOnboardingPackage = CustomerOnboardingPackage | CustomerAdminOnboardingPackage | SuperUserOnboardingPackage;

export type TOnboardingPackageRequest = CustomerOnboardingPackageRequest | CustomerAdminOnboardingPackageRequest | SuperUserOnboardingPackageRequest;

export type TOrganisation = ClientOrganisation | CustomerOrganisation | CustomerAdminOrganisation | SuperUserOrganisation;

export type TOrganisationRequestRequest = CustomerOrganisationRequest | CustomerAdminOrganisationRequest | SuperUserOrganisationRequest | SuperUserOrganisationCreateRequest;

export type TPDFFormSubmission = PDFFormSubmissionBase | SuperUserPDFFormSubmission;

export type TPDFFormSubmissionRequest = PDFFormSubmissionBaseRequest | SuperUserPDFFormSubmissionRequest;

export type TPDFFormSubmissionWithCase = PDFFormSubmissionBase;

export type TPDFFormTemplate = PDFFormTemplate | SuperUserPDFFormTemplate;

export type TPDFFormTemplateRequestRequest = CreatePDFFormTemplateRequest | SuperUserCreatePDFFormTemplateRequest;

export type TPhoneForwardingRule = PhoneForwardingRuleList | PhoneForwardingRule;

export type TPhoneNumber = CustomerPhoneNumber | CustomerAdminPhoneNumber | SuperUserPhoneNumber;

export type TPhoneNumberRequest = CustomerAdminPhoneNumberRequest | SuperUserPhoneNumberRequest;

export type TQuestionnaire = CustomerQuestionnaire | CustomerAdminQuestionnaire | SuperUserQuestionnaire;

export type TQuestionnaireRequest = CustomerQuestionnaireRequest | CustomerAdminQuestionnaireRequest | SuperUserQuestionnaireRequest;

export type TQuestionnaireSubmission = ClientQuestionnaireSubmission | CustomerQuestionnaireSubmission | CustomerAdminQuestionnaireSubmission | SuperUserQuestionnaireSubmission;

export type TQuestionnaireSubmissionRequest = ClientQuestionnaireSubmissionRequest | CustomerQuestionnaireSubmissionRequest | CustomerAdminQuestionnaireSubmissionRequest | SuperUserQuestionnaireSubmissionRequest;

export type TRetellAgent = SuperUserRetellAgent;

export type TRetellAgentRequest = unknown;

export type TSavedResponse = SavedResponse;

export type TSavedResponseRequest = SavedResponseRequest;

export type TService = CustomerService | CustomerAdminService | SuperUserService;

export type TServiceRequest = CustomerServiceRequest | CustomerAdminServiceRequest | SuperUserServiceRequest;

export type TStripeCustomer = SuperUserStripeCustomer;

export type TStripeCustomerRequest = unknown;

export type TStripeInvoice = SuperUserStripeInvoice;

export type TStripeInvoiceRequest = unknown;

export type TSwitchUniqueCaseDataRelationshipResponse = SwitchUniqueCaseDataRelationshipResponse;

export type TUser = CustomerUser | CustomerAdminUser | SuperUserUser;

export type TUserRequest = CustomerUserRequest | CustomerAdminUserRequest | SuperUserUserRequest;

export type TWordDocumentTemplate = CustomerWordDocumentTemplate | CustomerAdminWordDocumentTemplate | SuperUserWordDocumentTemplate;

export type TWordDocumentTemplateRequest = CustomerWordDocumentTemplateRequest | CustomerAdminWordDocumentTemplateRequest | SuperUserWordDocumentTemplateRequest;

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.foreigners_authority` - Foreigners Authority
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.principal_client` - Principal Client
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 * * `entities.defendant_representative` - Defendant Representative
 * * `entities.plaintiff_representative` - Plaintiff Representative
 * * `entities.community_of_homeowners` - Community Of Homeowners
 * * `entities.fractional_owner` - Fractional Owner
 * * `entities.joint_debtor` - Joint Debtor
 * * `entities.joint_creditor` - Joint Creditor
 * * `entities.application_respondent` - Application Respondent
 * * `entities.hereditary_building_grantor` - Hereditary Building Grantor
 * * `entities.professional_liability_insurance` - Professional Liability Insurance
 * * `entities.building_owners_association` - Building Owners Association
 * * `entities.landlord_association` - Landlord Association
 * * `entities.landlord_community` - Landlord Community
 * * `entities.special_property_manager` - Special Property Manager
 * * `entities.house_manager` - House Manager
 * * `entities.appellant` - Appellant
 * * `entities.appellee` - Appellee
 * * `entities.counter_claimant` - Counter Claimant
 * * `entities.counter_defendant` - Counter Defendant
 * * `entities.doctor` - Doctor
 * * `entities.legal_guardian` - Legal Guardian
 * * `entities.guardian` - Guardian
 * * `entities.caretaker` - Caretaker
 * * `entities.youth_welfare_office` - Youth Welfare Office
 * * `entities.foster_parent` - Foster Parent
 * * `entities.parent` - Parent
 * * `entities.maintenance_obligor` - Maintenance Obligor
 * * `entities.beneficiary` - Beneficiary
 * * `entities.administrative_assistant` - Administrative Assistant
 * * `entities.case_worker` - Case Worker
 * * `entities.managing_director` - Managing Director
 * * `entities.shareholder` - Shareholder
 * * `entities.supervisory_board` - Supervisory Board
 * * `entities.commercial_agent` - Commercial Agent
 * * `entities.limited_partner` - Limited Partner
 * * `entities.authorized_signatory` - Authorized Signatory
 * * `entities.social_security_office` - Social Security Office
 * * `entities.employment_agency` - Employment Agency
 * * `entities.job_center` - Job Center
 * * `entities.pension_insurance` - Pension Insurance
 * * `entities.health_insurance` - Health Insurance
 * * `entities.disability_office` - Disability Office
 * * `entities.social_court` - Social Court
 * * `entities.medical_service` - Medical Service
 * * `entities.rehabilitation_provider` - Rehabilitation Provider
 * * `entities.patient` - Patient
 * * `entities.medical_institution` - Medical Institution
 * * `entities.legal_assistant` - Legal Assistant
 * * `entities.tax_authority` - Tax Authority
 * * `entities.affected_person` - Affected Person
 * * `entities.opponent_insurance` - Opponent Insurance
 * * `entities.workshop` - Workshop
 * * `entities.joint_plaintiff` - Joint Plaintiff
 */
export type TagRelationshipEnum = 'entities.opponent' | 'entities.client' | 'entities.other' | 'entities.labor_law_employee' | 'entities.labor_law_employer' | 'entities.witness' | 'entities.at_fault_driver' | 'entities.victim_driver' | 'entities.accused' | 'entities.defendant' | 'entities.plaintiff' | 'entities.complaint' | 'entities.victim' | 'entities.vehicle_expert' | 'entities.agency' | 'entities.foreigners_authority' | 'entities.vehicle_owner' | 'entities.insurance' | 'entities.driver' | 'entities.police_officer' | 'entities.police_station' | 'entities.judge' | 'entities.court' | 'entities.prosecutor' | 'entities.public_prosecutor' | 'entities.opposing_counsel' | 'entities.co_plaintiff' | 'entities.probation_officer' | 'entities.tenant' | 'entities.landlord' | 'entities.subtenant' | 'entities.owner' | 'entities.property_management' | 'entities.real_estate_agent' | 'entities.guarantor' | 'entities.co_owner' | 'entities.co_tenant' | 'entities.tenants_association' | 'entities.property_owners_association' | 'entities.complainant' | 'entities.applicant' | 'entities.respondent' | 'entities.principal_client' | 'entities.child' | 'entities.officiant' | 'entities.wife' | 'entities.husband' | 'entities.legal_representative' | 'entities.korrespondence_lawyer' | 'entities.opposing_lawyer' | 'entities.lawyer' | 'entities.legal_expenses_insurance' | 'entities.liability_insurance' | 'entities.first_instance_court' | 'entities.second_instance_court' | 'entities.third_instance_court' | 'entities.contact_person' | 'entities.third_party_debtor' | 'entities.road_traffic_office' | 'entities.debt_collection_agency' | 'entities.expert' | 'entities.tax_office' | 'entities.land_registry' | 'entities.bank' | 'entities.buyer' | 'entities.dunning_court' | 'entities.enforcement_court' | 'entities.general_prosecutor' | 'entities.seller' | 'entities.expert_committee' | 'entities.municipality' | 'entities.administrator' | 'entities.register_court' | 'entities.probate_court' | 'entities.registry_office' | 'entities.hereditary_leaseholder' | 'entities.legal_aid_court' | 'entities.secondary_client' | 'entities.secondary_opponent' | 'entities.court_complaint' | 'entities.fine_authority' | 'entities.resident_registration_office' | 'entities.investigator' | 'entities.bailiff' | 'entities.insolvency_court' | 'entities.integration_office' | 'entities.execution_organ' | 'entities.debtor' | 'entities.creditor' | 'entities.lessee' | 'entities.lessor' | 'entities.principal' | 'entities.authorized_representative' | 'entities.testator' | 'entities.heir' | 'entities.preliminary_heir' | 'entities.subsequent_heir' | 'entities.curator_of_the_estate' | 'entities.executor_of_the_will' | 'entities.estate_administrator' | 'entities.compulsory_portion_beneficiary' | 'entities.notary' | 'entities.trustee' | 'entities.insolvency_administrator' | 'entities.defendant_representative' | 'entities.plaintiff_representative' | 'entities.community_of_homeowners' | 'entities.fractional_owner' | 'entities.joint_debtor' | 'entities.joint_creditor' | 'entities.application_respondent' | 'entities.hereditary_building_grantor' | 'entities.professional_liability_insurance' | 'entities.building_owners_association' | 'entities.landlord_association' | 'entities.landlord_community' | 'entities.special_property_manager' | 'entities.house_manager' | 'entities.appellant' | 'entities.appellee' | 'entities.counter_claimant' | 'entities.counter_defendant' | 'entities.doctor' | 'entities.legal_guardian' | 'entities.guardian' | 'entities.caretaker' | 'entities.youth_welfare_office' | 'entities.foster_parent' | 'entities.parent' | 'entities.maintenance_obligor' | 'entities.beneficiary' | 'entities.administrative_assistant' | 'entities.case_worker' | 'entities.managing_director' | 'entities.shareholder' | 'entities.supervisory_board' | 'entities.commercial_agent' | 'entities.limited_partner' | 'entities.authorized_signatory' | 'entities.social_security_office' | 'entities.employment_agency' | 'entities.job_center' | 'entities.pension_insurance' | 'entities.health_insurance' | 'entities.disability_office' | 'entities.social_court' | 'entities.medical_service' | 'entities.rehabilitation_provider' | 'entities.patient' | 'entities.medical_institution' | 'entities.legal_assistant' | 'entities.tax_authority' | 'entities.affected_person' | 'entities.opponent_insurance' | 'entities.workshop' | 'entities.joint_plaintiff';

/**
 * * `entities.opponent` - Opponent
 * * `entities.client` - Client
 * * `entities.other` - Other
 * * `entities.labor_law_employee` - Labor Law Employee
 * * `entities.labor_law_employer` - Labor Law Employer
 * * `entities.witness` - Witness
 * * `entities.at_fault_driver` - At Fault Driver
 * * `entities.victim_driver` - Victim Driver
 * * `entities.accused` - Accused
 * * `entities.defendant` - Defendant
 * * `entities.plaintiff` - Plaintiff
 * * `entities.complaint` - Complaint
 * * `entities.victim` - Victim
 * * `entities.vehicle_expert` - Vehicle Expert
 * * `entities.agency` - Agency
 * * `entities.foreigners_authority` - Foreigners Authority
 * * `entities.vehicle_owner` - Vehicle Owner
 * * `entities.insurance` - Insurance
 * * `entities.driver` - Driver
 * * `entities.police_officer` - Police Officer
 * * `entities.police_station` - Police Station
 * * `entities.judge` - Judge
 * * `entities.court` - Court
 * * `entities.prosecutor` - Prosecutor
 * * `entities.public_prosecutor` - Public Prosecutor
 * * `entities.opposing_counsel` - Opposing Counsel
 * * `entities.co_plaintiff` - Co Plaintiff
 * * `entities.probation_officer` - Probation Officer
 * * `entities.tenant` - Tenant
 * * `entities.landlord` - Landlord
 * * `entities.subtenant` - Subtenant
 * * `entities.owner` - Owner
 * * `entities.property_management` - Property Management
 * * `entities.real_estate_agent` - Real Estate Agent
 * * `entities.guarantor` - Guarantor
 * * `entities.co_owner` - Co Owner
 * * `entities.co_tenant` - Co Tenant
 * * `entities.tenants_association` - Tenants Association
 * * `entities.property_owners_association` - Property Owners Association
 * * `entities.complainant` - Complainant
 * * `entities.applicant` - Applicant
 * * `entities.respondent` - Respondent
 * * `entities.principal_client` - Principal Client
 * * `entities.child` - Child
 * * `entities.officiant` - Officiant
 * * `entities.wife` - Wife
 * * `entities.husband` - Husband
 * * `entities.legal_representative` - Legal Representative
 * * `entities.korrespondence_lawyer` - Korrespondence Lawyer
 * * `entities.opposing_lawyer` - Opposing Lawyer
 * * `entities.lawyer` - Lawyer
 * * `entities.legal_expenses_insurance` - Legal Expenses Insurance
 * * `entities.liability_insurance` - Liability Insurance
 * * `entities.first_instance_court` - First Instance Court
 * * `entities.second_instance_court` - Second Instance Court
 * * `entities.third_instance_court` - Third Instance Court
 * * `entities.contact_person` - Contact Person
 * * `entities.third_party_debtor` - Third Party Debtor
 * * `entities.road_traffic_office` - Road Traffic Office
 * * `entities.debt_collection_agency` - Debt Collection Agency
 * * `entities.expert` - Expert
 * * `entities.tax_office` - Tax Office
 * * `entities.land_registry` - Land Registry
 * * `entities.bank` - Bank
 * * `entities.buyer` - Buyer
 * * `entities.dunning_court` - Dunning Court
 * * `entities.enforcement_court` - Enforcement Court
 * * `entities.general_prosecutor` - General Prosecutor
 * * `entities.seller` - Seller
 * * `entities.expert_committee` - Expert Committee
 * * `entities.municipality` - Municipality
 * * `entities.administrator` - Administrator
 * * `entities.register_court` - Register Court
 * * `entities.probate_court` - Probate Court
 * * `entities.registry_office` - Registry Office
 * * `entities.hereditary_leaseholder` - Hereditary Leaseholder
 * * `entities.legal_aid_court` - Legal Aid Court
 * * `entities.secondary_client` - Secondary Client
 * * `entities.secondary_opponent` - Secondary Opponent
 * * `entities.court_complaint` - Court Complaint
 * * `entities.fine_authority` - Fine Authority
 * * `entities.resident_registration_office` - Resident Registration Office
 * * `entities.investigator` - Investigator
 * * `entities.bailiff` - Bailiff
 * * `entities.insolvency_court` - Insolvency Court
 * * `entities.integration_office` - Integration Office
 * * `entities.execution_organ` - Execution Organ
 * * `entities.debtor` - Debtor
 * * `entities.creditor` - Creditor
 * * `entities.lessee` - Lessee
 * * `entities.lessor` - Lessor
 * * `entities.principal` - Principal
 * * `entities.authorized_representative` - Authorized Representative
 * * `entities.testator` - Testator
 * * `entities.heir` - Heir
 * * `entities.preliminary_heir` - Preliminary Heir
 * * `entities.subsequent_heir` - Subsequent Heir
 * * `entities.curator_of_the_estate` - Curator Of The Estate
 * * `entities.executor_of_the_will` - Executor Of The Will
 * * `entities.estate_administrator` - Estate Administrator
 * * `entities.compulsory_portion_beneficiary` - Compulsory Portion Beneficiary
 * * `entities.notary` - Notary
 * * `entities.trustee` - Trustee
 * * `entities.insolvency_administrator` - Insolvency Administrator
 * * `entities.defendant_representative` - Defendant Representative
 * * `entities.plaintiff_representative` - Plaintiff Representative
 * * `entities.community_of_homeowners` - Community Of Homeowners
 * * `entities.fractional_owner` - Fractional Owner
 * * `entities.joint_debtor` - Joint Debtor
 * * `entities.joint_creditor` - Joint Creditor
 * * `entities.application_respondent` - Application Respondent
 * * `entities.hereditary_building_grantor` - Hereditary Building Grantor
 * * `entities.professional_liability_insurance` - Professional Liability Insurance
 * * `entities.building_owners_association` - Building Owners Association
 * * `entities.landlord_association` - Landlord Association
 * * `entities.landlord_community` - Landlord Community
 * * `entities.special_property_manager` - Special Property Manager
 * * `entities.house_manager` - House Manager
 * * `entities.appellant` - Appellant
 * * `entities.appellee` - Appellee
 * * `entities.counter_claimant` - Counter Claimant
 * * `entities.counter_defendant` - Counter Defendant
 * * `entities.doctor` - Doctor
 * * `entities.legal_guardian` - Legal Guardian
 * * `entities.guardian` - Guardian
 * * `entities.caretaker` - Caretaker
 * * `entities.youth_welfare_office` - Youth Welfare Office
 * * `entities.foster_parent` - Foster Parent
 * * `entities.parent` - Parent
 * * `entities.maintenance_obligor` - Maintenance Obligor
 * * `entities.beneficiary` - Beneficiary
 * * `entities.administrative_assistant` - Administrative Assistant
 * * `entities.case_worker` - Case Worker
 * * `entities.managing_director` - Managing Director
 * * `entities.shareholder` - Shareholder
 * * `entities.supervisory_board` - Supervisory Board
 * * `entities.commercial_agent` - Commercial Agent
 * * `entities.limited_partner` - Limited Partner
 * * `entities.authorized_signatory` - Authorized Signatory
 * * `entities.social_security_office` - Social Security Office
 * * `entities.employment_agency` - Employment Agency
 * * `entities.job_center` - Job Center
 * * `entities.pension_insurance` - Pension Insurance
 * * `entities.health_insurance` - Health Insurance
 * * `entities.disability_office` - Disability Office
 * * `entities.social_court` - Social Court
 * * `entities.medical_service` - Medical Service
 * * `entities.rehabilitation_provider` - Rehabilitation Provider
 * * `entities.patient` - Patient
 * * `entities.medical_institution` - Medical Institution
 * * `entities.legal_assistant` - Legal Assistant
 * * `entities.tax_authority` - Tax Authority
 * * `entities.affected_person` - Affected Person
 * * `entities.opponent_insurance` - Opponent Insurance
 * * `entities.workshop` - Workshop
 * * `entities.joint_plaintiff` - Joint Plaintiff
 */
export const TagRelationshipEnum = {
    ENTITIES_OPPONENT: 'entities.opponent',
    ENTITIES_CLIENT: 'entities.client',
    ENTITIES_OTHER: 'entities.other',
    ENTITIES_LABOR_LAW_EMPLOYEE: 'entities.labor_law_employee',
    ENTITIES_LABOR_LAW_EMPLOYER: 'entities.labor_law_employer',
    ENTITIES_WITNESS: 'entities.witness',
    ENTITIES_AT_FAULT_DRIVER: 'entities.at_fault_driver',
    ENTITIES_VICTIM_DRIVER: 'entities.victim_driver',
    ENTITIES_ACCUSED: 'entities.accused',
    ENTITIES_DEFENDANT: 'entities.defendant',
    ENTITIES_PLAINTIFF: 'entities.plaintiff',
    ENTITIES_COMPLAINT: 'entities.complaint',
    ENTITIES_VICTIM: 'entities.victim',
    ENTITIES_VEHICLE_EXPERT: 'entities.vehicle_expert',
    ENTITIES_AGENCY: 'entities.agency',
    ENTITIES_FOREIGNERS_AUTHORITY: 'entities.foreigners_authority',
    ENTITIES_VEHICLE_OWNER: 'entities.vehicle_owner',
    ENTITIES_INSURANCE: 'entities.insurance',
    ENTITIES_DRIVER: 'entities.driver',
    ENTITIES_POLICE_OFFICER: 'entities.police_officer',
    ENTITIES_POLICE_STATION: 'entities.police_station',
    ENTITIES_JUDGE: 'entities.judge',
    ENTITIES_COURT: 'entities.court',
    ENTITIES_PROSECUTOR: 'entities.prosecutor',
    ENTITIES_PUBLIC_PROSECUTOR: 'entities.public_prosecutor',
    ENTITIES_OPPOSING_COUNSEL: 'entities.opposing_counsel',
    ENTITIES_CO_PLAINTIFF: 'entities.co_plaintiff',
    ENTITIES_PROBATION_OFFICER: 'entities.probation_officer',
    ENTITIES_TENANT: 'entities.tenant',
    ENTITIES_LANDLORD: 'entities.landlord',
    ENTITIES_SUBTENANT: 'entities.subtenant',
    ENTITIES_OWNER: 'entities.owner',
    ENTITIES_PROPERTY_MANAGEMENT: 'entities.property_management',
    ENTITIES_REAL_ESTATE_AGENT: 'entities.real_estate_agent',
    ENTITIES_GUARANTOR: 'entities.guarantor',
    ENTITIES_CO_OWNER: 'entities.co_owner',
    ENTITIES_CO_TENANT: 'entities.co_tenant',
    ENTITIES_TENANTS_ASSOCIATION: 'entities.tenants_association',
    ENTITIES_PROPERTY_OWNERS_ASSOCIATION: 'entities.property_owners_association',
    ENTITIES_COMPLAINANT: 'entities.complainant',
    ENTITIES_APPLICANT: 'entities.applicant',
    ENTITIES_RESPONDENT: 'entities.respondent',
    ENTITIES_PRINCIPAL_CLIENT: 'entities.principal_client',
    ENTITIES_CHILD: 'entities.child',
    ENTITIES_OFFICIANT: 'entities.officiant',
    ENTITIES_WIFE: 'entities.wife',
    ENTITIES_HUSBAND: 'entities.husband',
    ENTITIES_LEGAL_REPRESENTATIVE: 'entities.legal_representative',
    ENTITIES_KORRESPONDENCE_LAWYER: 'entities.korrespondence_lawyer',
    ENTITIES_OPPOSING_LAWYER: 'entities.opposing_lawyer',
    ENTITIES_LAWYER: 'entities.lawyer',
    ENTITIES_LEGAL_EXPENSES_INSURANCE: 'entities.legal_expenses_insurance',
    ENTITIES_LIABILITY_INSURANCE: 'entities.liability_insurance',
    ENTITIES_FIRST_INSTANCE_COURT: 'entities.first_instance_court',
    ENTITIES_SECOND_INSTANCE_COURT: 'entities.second_instance_court',
    ENTITIES_THIRD_INSTANCE_COURT: 'entities.third_instance_court',
    ENTITIES_CONTACT_PERSON: 'entities.contact_person',
    ENTITIES_THIRD_PARTY_DEBTOR: 'entities.third_party_debtor',
    ENTITIES_ROAD_TRAFFIC_OFFICE: 'entities.road_traffic_office',
    ENTITIES_DEBT_COLLECTION_AGENCY: 'entities.debt_collection_agency',
    ENTITIES_EXPERT: 'entities.expert',
    ENTITIES_TAX_OFFICE: 'entities.tax_office',
    ENTITIES_LAND_REGISTRY: 'entities.land_registry',
    ENTITIES_BANK: 'entities.bank',
    ENTITIES_BUYER: 'entities.buyer',
    ENTITIES_DUNNING_COURT: 'entities.dunning_court',
    ENTITIES_ENFORCEMENT_COURT: 'entities.enforcement_court',
    ENTITIES_GENERAL_PROSECUTOR: 'entities.general_prosecutor',
    ENTITIES_SELLER: 'entities.seller',
    ENTITIES_EXPERT_COMMITTEE: 'entities.expert_committee',
    ENTITIES_MUNICIPALITY: 'entities.municipality',
    ENTITIES_ADMINISTRATOR: 'entities.administrator',
    ENTITIES_REGISTER_COURT: 'entities.register_court',
    ENTITIES_PROBATE_COURT: 'entities.probate_court',
    ENTITIES_REGISTRY_OFFICE: 'entities.registry_office',
    ENTITIES_HEREDITARY_LEASEHOLDER: 'entities.hereditary_leaseholder',
    ENTITIES_LEGAL_AID_COURT: 'entities.legal_aid_court',
    ENTITIES_SECONDARY_CLIENT: 'entities.secondary_client',
    ENTITIES_SECONDARY_OPPONENT: 'entities.secondary_opponent',
    ENTITIES_COURT_COMPLAINT: 'entities.court_complaint',
    ENTITIES_FINE_AUTHORITY: 'entities.fine_authority',
    ENTITIES_RESIDENT_REGISTRATION_OFFICE: 'entities.resident_registration_office',
    ENTITIES_INVESTIGATOR: 'entities.investigator',
    ENTITIES_BAILIFF: 'entities.bailiff',
    ENTITIES_INSOLVENCY_COURT: 'entities.insolvency_court',
    ENTITIES_INTEGRATION_OFFICE: 'entities.integration_office',
    ENTITIES_EXECUTION_ORGAN: 'entities.execution_organ',
    ENTITIES_DEBTOR: 'entities.debtor',
    ENTITIES_CREDITOR: 'entities.creditor',
    ENTITIES_LESSEE: 'entities.lessee',
    ENTITIES_LESSOR: 'entities.lessor',
    ENTITIES_PRINCIPAL: 'entities.principal',
    ENTITIES_AUTHORIZED_REPRESENTATIVE: 'entities.authorized_representative',
    ENTITIES_TESTATOR: 'entities.testator',
    ENTITIES_HEIR: 'entities.heir',
    ENTITIES_PRELIMINARY_HEIR: 'entities.preliminary_heir',
    ENTITIES_SUBSEQUENT_HEIR: 'entities.subsequent_heir',
    ENTITIES_CURATOR_OF_THE_ESTATE: 'entities.curator_of_the_estate',
    ENTITIES_EXECUTOR_OF_THE_WILL: 'entities.executor_of_the_will',
    ENTITIES_ESTATE_ADMINISTRATOR: 'entities.estate_administrator',
    ENTITIES_COMPULSORY_PORTION_BENEFICIARY: 'entities.compulsory_portion_beneficiary',
    ENTITIES_NOTARY: 'entities.notary',
    ENTITIES_TRUSTEE: 'entities.trustee',
    ENTITIES_INSOLVENCY_ADMINISTRATOR: 'entities.insolvency_administrator',
    ENTITIES_DEFENDANT_REPRESENTATIVE: 'entities.defendant_representative',
    ENTITIES_PLAINTIFF_REPRESENTATIVE: 'entities.plaintiff_representative',
    ENTITIES_COMMUNITY_OF_HOMEOWNERS: 'entities.community_of_homeowners',
    ENTITIES_FRACTIONAL_OWNER: 'entities.fractional_owner',
    ENTITIES_JOINT_DEBTOR: 'entities.joint_debtor',
    ENTITIES_JOINT_CREDITOR: 'entities.joint_creditor',
    ENTITIES_APPLICATION_RESPONDENT: 'entities.application_respondent',
    ENTITIES_HEREDITARY_BUILDING_GRANTOR: 'entities.hereditary_building_grantor',
    ENTITIES_PROFESSIONAL_LIABILITY_INSURANCE: 'entities.professional_liability_insurance',
    ENTITIES_BUILDING_OWNERS_ASSOCIATION: 'entities.building_owners_association',
    ENTITIES_LANDLORD_ASSOCIATION: 'entities.landlord_association',
    ENTITIES_LANDLORD_COMMUNITY: 'entities.landlord_community',
    ENTITIES_SPECIAL_PROPERTY_MANAGER: 'entities.special_property_manager',
    ENTITIES_HOUSE_MANAGER: 'entities.house_manager',
    ENTITIES_APPELLANT: 'entities.appellant',
    ENTITIES_APPELLEE: 'entities.appellee',
    ENTITIES_COUNTER_CLAIMANT: 'entities.counter_claimant',
    ENTITIES_COUNTER_DEFENDANT: 'entities.counter_defendant',
    ENTITIES_DOCTOR: 'entities.doctor',
    ENTITIES_LEGAL_GUARDIAN: 'entities.legal_guardian',
    ENTITIES_GUARDIAN: 'entities.guardian',
    ENTITIES_CARETAKER: 'entities.caretaker',
    ENTITIES_YOUTH_WELFARE_OFFICE: 'entities.youth_welfare_office',
    ENTITIES_FOSTER_PARENT: 'entities.foster_parent',
    ENTITIES_PARENT: 'entities.parent',
    ENTITIES_MAINTENANCE_OBLIGOR: 'entities.maintenance_obligor',
    ENTITIES_BENEFICIARY: 'entities.beneficiary',
    ENTITIES_ADMINISTRATIVE_ASSISTANT: 'entities.administrative_assistant',
    ENTITIES_CASE_WORKER: 'entities.case_worker',
    ENTITIES_MANAGING_DIRECTOR: 'entities.managing_director',
    ENTITIES_SHAREHOLDER: 'entities.shareholder',
    ENTITIES_SUPERVISORY_BOARD: 'entities.supervisory_board',
    ENTITIES_COMMERCIAL_AGENT: 'entities.commercial_agent',
    ENTITIES_LIMITED_PARTNER: 'entities.limited_partner',
    ENTITIES_AUTHORIZED_SIGNATORY: 'entities.authorized_signatory',
    ENTITIES_SOCIAL_SECURITY_OFFICE: 'entities.social_security_office',
    ENTITIES_EMPLOYMENT_AGENCY: 'entities.employment_agency',
    ENTITIES_JOB_CENTER: 'entities.job_center',
    ENTITIES_PENSION_INSURANCE: 'entities.pension_insurance',
    ENTITIES_HEALTH_INSURANCE: 'entities.health_insurance',
    ENTITIES_DISABILITY_OFFICE: 'entities.disability_office',
    ENTITIES_SOCIAL_COURT: 'entities.social_court',
    ENTITIES_MEDICAL_SERVICE: 'entities.medical_service',
    ENTITIES_REHABILITATION_PROVIDER: 'entities.rehabilitation_provider',
    ENTITIES_PATIENT: 'entities.patient',
    ENTITIES_MEDICAL_INSTITUTION: 'entities.medical_institution',
    ENTITIES_LEGAL_ASSISTANT: 'entities.legal_assistant',
    ENTITIES_TAX_AUTHORITY: 'entities.tax_authority',
    ENTITIES_AFFECTED_PERSON: 'entities.affected_person',
    ENTITIES_OPPONENT_INSURANCE: 'entities.opponent_insurance',
    ENTITIES_WORKSHOP: 'entities.workshop',
    ENTITIES_JOINT_PLAINTIFF: 'entities.joint_plaintiff'
} as const;

/**
 * * `red` - Rot
 * * `orange` - Orange
 * * `amber` - Bernstein
 * * `yellow` - Gelb
 * * `lime` - Limette
 * * `green` - Grün
 * * `emerald` - Smaragd
 * * `teal` - Türkis
 * * `cyan` - Cyan
 * * `sky` - Himmelblau
 * * `blue` - Blau
 * * `indigo` - Indigo
 * * `violet` - Violett
 * * `purple` - Purpur
 * * `fuchsia` - Fuchsie
 * * `pink` - Rosa
 * * `rose` - Rose
 */
export type ThemeEnum = 'red' | 'orange' | 'amber' | 'yellow' | 'lime' | 'green' | 'emerald' | 'teal' | 'cyan' | 'sky' | 'blue' | 'indigo' | 'violet' | 'purple' | 'fuchsia' | 'pink' | 'rose';

/**
 * * `red` - Rot
 * * `orange` - Orange
 * * `amber` - Bernstein
 * * `yellow` - Gelb
 * * `lime` - Limette
 * * `green` - Grün
 * * `emerald` - Smaragd
 * * `teal` - Türkis
 * * `cyan` - Cyan
 * * `sky` - Himmelblau
 * * `blue` - Blau
 * * `indigo` - Indigo
 * * `violet` - Violett
 * * `purple` - Purpur
 * * `fuchsia` - Fuchsie
 * * `pink` - Rosa
 * * `rose` - Rose
 */
export const ThemeEnum = {
    RED: 'red',
    ORANGE: 'orange',
    AMBER: 'amber',
    YELLOW: 'yellow',
    LIME: 'lime',
    GREEN: 'green',
    EMERALD: 'emerald',
    TEAL: 'teal',
    CYAN: 'cyan',
    SKY: 'sky',
    BLUE: 'blue',
    INDIGO: 'indigo',
    VIOLET: 'violet',
    PURPLE: 'purple',
    FUCHSIA: 'fuchsia',
    PINK: 'pink',
    ROSE: 'rose'
} as const;

export type ThirdPartyDocumentCreationTokenResponse = {
    creation_token: string;
};

/**
 * Serializer for third-party document link creation request.
 */
export type ThirdPartyDocumentLinkRequestRequest = {
    /**
     * External document creation token for the form
     */
    creation_token: string;
    /**
     * UUID of the case
     */
    case_uuid: string;
};

/**
 * Serializer for third-party document link creation response.
 */
export type ThirdPartyDocumentLinkResponse = {
    /**
     * Generated form token for the third-party request
     */
    form_token: string;
};

/**
 * Serializer for creating third-party questionnaire submissions.
 */
export type ThirdPartyQuestionnaireSubmissionCreateRequest = {
    questionnaire_id: string;
    case_id: string;
};

/**
 * * `` -
 * * `Herr` - Herr
 * * `Frau` - Frau
 * * `Divers` - Divers
 */
export type TitleEnum = 'Herr' | 'Frau' | 'Divers';

/**
 * * `` -
 * * `Herr` - Herr
 * * `Frau` - Frau
 * * `Divers` - Divers
 */
export const TitleEnum = {
    HERR: 'Herr',
    FRAU: 'Frau',
    DIVERS: 'Divers'
} as const;

/**
 * * `AGB` - Agb
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung Nicht Eingehalten
 * * `Account hacking` - Account Hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/Alg/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft Prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto Leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung Zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Diskriminierung` - Diskriminierung
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Eingruppierung` - Eingruppierung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag Löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren Ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren Unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung Löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy Am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Mobbing` - Mobbing
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflegerecht` - Pflegerecht
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil Abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz Einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht Und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall Mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß Gegen Die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - Unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - Unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung Zu Lebzeiten
 */
export type TopicEnum = 'AGB' | 'Abfindung' | 'Abmahnung' | 'Abmahnung Wettbewerbsrecht' | 'Abschiebungshaft' | 'Abschlussarbeit' | 'Abstandsregelung nicht eingehalten' | 'Account hacking' | 'Allgemein' | 'Allgemeines Prüfungsrecht' | 'Anderes' | 'Arbeitsamt/ALG/Sperrzeit' | 'Arbeitsunfall' | 'Arbeitsvertrag' | 'Arbeitszeugnis' | 'Aufbau Compliancesystem' | 'Aufenthaltserlaubnis' | 'Aufhebungsvertrag' | 'Auftragsdatenverarbeitung' | 'Auseinandersetzung Erbengemeinschaft' | 'Auskunft prüfen' | 'Ausweisung' | 'Autokauf' | 'Bankkonto leergeräumt' | 'Bankrecht' | 'Baumangel' | 'Bauvertrag' | 'Behandlungsfehler Allgemein' | 'Behandlungsfehler Querschnittslähmung' | 'Behandlungsfehler Schlaganfall' | 'Beißvorfall' | 'Beratung zu Erbfall' | 'Beschlagnahme Allgemein' | 'Beschlagnahme Tierquälerei' | 'Betreuungsrecht' | 'Betrug Geldanlage' | 'Betäubungsmittel' | 'Burgschild Inkasso' | 'Bußgeldbescheid' | 'Bürgergeld' | 'Coaching' | 'Datenschutz' | 'Datenschutz Schadensersatz' | 'Datenschutzverstoß' | 'Diskriminierung' | 'Domains' | 'Ehevertrag' | 'Eigentumsdelikte' | 'Einbürgerung' | 'Eingruppierung' | 'Einreisesperre' | 'Eintrag löschen' | 'Erbauseinandersetzung' | 'Erbausschlagung' | 'Erben/Schenken' | 'Erbengemeinschaft' | 'Erbschein' | 'Erbscheinsantrag' | 'Erbvertrag' | 'Exmatrikulation' | 'Fahren ohne Führerschein' | 'Fahren unter Alkohol - / Drogeneinfluss' | 'Fahrer - / Unfallflucht' | 'Fahrverbot / Führerscheinentzug' | 'Falschaussage/ Meineid' | 'Familie Vorsorge' | 'Forderung löschen' | 'Geburtsfehler' | 'Geburtsfehler Mutter' | 'Geschwindigkeitsüberschreitung' | 'Gesetzliche Erbfolge' | 'Gewerblicher Rechtsschutz' | 'Grundschuld' | 'Gründung' | 'Handy am Steuer' | 'Hauskauf' | 'Härtefallantrag' | 'Immobilien' | 'Immobilienübertragung' | 'Kaufvertragsprüfung' | 'Körperverletzung' | 'Kündigung' | 'Lohnzahlung' | 'Maklerangelegenheit' | 'Markenanmeldung' | 'Markenverteidigung' | 'Markenüberwachung' | 'Mieterhöhung' | 'Mietkaution' | 'Mietminderung' | 'Mietvertrag' | 'Mobbing' | 'Nebenkostenabrechnung' | 'Niederlassungserlaubnis' | 'Nutzerbewertungen Verfasser' | 'Patientenverfügung/Vorsorgevollmacht' | 'Personenverwechselung' | 'Pflege-/Krankenversicherung' | 'Pflegerecht' | 'Pflichtteil' | 'Pflichtteil Geltendmachung' | 'Pflichtteil abwehren' | 'Plagiatsvorwurf' | 'Remonstration' | 'Rente' | 'Rotlichtverstoß' | 'Räumungsklage' | 'Schadensersatz' | 'Scheidung' | 'Schenkung' | 'Schenkung Immobilie' | 'Schulplatz einklagen' | 'Schwerbehinderung' | 'Sexualdelikt' | 'Software Hardware' | 'Sonstige Beglaubigung' | 'Sorgerecht und Umgangsrecht' | 'Testament' | 'Testament/Erbvertrag' | 'Tierkauf' | 'Tierärztliche Behandlungsfehler' | 'Trennung' | 'Tuning' | 'Täuschungsversuch' | 'Tötungsdelikte' | 'Unfall Querschnittslähmung' | 'Unfall mit Personenschaden' | 'Unterhalt' | 'Unternehmen' | 'Unternehmensauflösung' | 'Unternehmensgründung' | 'Unternehmenskauf' | 'Urheberrecht' | 'Urlaub' | 'Vaterschaftsanerkennung' | 'Vererben' | 'Verkehrsunfall' | 'Vermögensauseinandersetzung' | 'Vermögensdelikte' | 'Verstoß gegen die Anschnallpflicht' | 'Vertragsprüfung' | 'Vertragsrecht' | 'Visum' | 'Vorfälligkeitsentschädigung' | 'Vorsorge' | 'Vorsorgevollmacht/Patientenverfügung' | 'Waffendelikte' | 'Wettbewerbsrecht' | 'Widerrufsrechte' | 'Widerspruch/ Klage' | 'Wucherzinsen Darlehen' | 'Zugewinnausgleich' | 'Zweiradunfall' | 'unbezahlte Rechnungen' | 'unerlaubtes Glücksspiel' | 'Überstunden' | 'Übertragung zu Lebzeiten';

/**
 * * `AGB` - Agb
 * * `Abfindung` - Abfindung
 * * `Abmahnung` - Abmahnung
 * * `Abmahnung Wettbewerbsrecht` - Abmahnung Wettbewerbsrecht
 * * `Abschiebungshaft` - Abschiebungshaft
 * * `Abschlussarbeit` - Abschlussarbeit
 * * `Abstandsregelung nicht eingehalten` - Abstandsregelung Nicht Eingehalten
 * * `Account hacking` - Account Hacking
 * * `Allgemein` - Allgemein
 * * `Allgemeines Prüfungsrecht` - Allgemeines Prüfungsrecht
 * * `Anderes` - Anderes
 * * `Arbeitsamt/ALG/Sperrzeit` - Arbeitsamt/Alg/Sperrzeit
 * * `Arbeitsunfall` - Arbeitsunfall
 * * `Arbeitsvertrag` - Arbeitsvertrag
 * * `Arbeitszeugnis` - Arbeitszeugnis
 * * `Aufbau Compliancesystem` - Aufbau Compliancesystem
 * * `Aufenthaltserlaubnis` - Aufenthaltserlaubnis
 * * `Aufhebungsvertrag` - Aufhebungsvertrag
 * * `Auftragsdatenverarbeitung` - Auftragsdatenverarbeitung
 * * `Auseinandersetzung Erbengemeinschaft` - Auseinandersetzung Erbengemeinschaft
 * * `Auskunft prüfen` - Auskunft Prüfen
 * * `Ausweisung` - Ausweisung
 * * `Autokauf` - Autokauf
 * * `Bankkonto leergeräumt` - Bankkonto Leergeräumt
 * * `Bankrecht` - Bankrecht
 * * `Baumangel` - Baumangel
 * * `Bauvertrag` - Bauvertrag
 * * `Behandlungsfehler Allgemein` - Behandlungsfehler Allgemein
 * * `Behandlungsfehler Querschnittslähmung` - Behandlungsfehler Querschnittslähmung
 * * `Behandlungsfehler Schlaganfall` - Behandlungsfehler Schlaganfall
 * * `Beißvorfall` - Beißvorfall
 * * `Beratung zu Erbfall` - Beratung Zu Erbfall
 * * `Beschlagnahme Allgemein` - Beschlagnahme Allgemein
 * * `Beschlagnahme Tierquälerei` - Beschlagnahme Tierquälerei
 * * `Betreuungsrecht` - Betreuungsrecht
 * * `Betrug Geldanlage` - Betrug Geldanlage
 * * `Betäubungsmittel` - Betäubungsmittel
 * * `Burgschild Inkasso` - Burgschild Inkasso
 * * `Bußgeldbescheid` - Bußgeldbescheid
 * * `Bürgergeld` - Bürgergeld
 * * `Coaching` - Coaching
 * * `Datenschutz` - Datenschutz
 * * `Datenschutz Schadensersatz` - Datenschutz Schadensersatz
 * * `Datenschutzverstoß` - Datenschutzverstoß
 * * `Diskriminierung` - Diskriminierung
 * * `Domains` - Domains
 * * `Ehevertrag` - Ehevertrag
 * * `Eigentumsdelikte` - Eigentumsdelikte
 * * `Einbürgerung` - Einbürgerung
 * * `Eingruppierung` - Eingruppierung
 * * `Einreisesperre` - Einreisesperre
 * * `Eintrag löschen` - Eintrag Löschen
 * * `Erbauseinandersetzung` - Erbauseinandersetzung
 * * `Erbausschlagung` - Erbausschlagung
 * * `Erben/Schenken` - Erben/Schenken
 * * `Erbengemeinschaft` - Erbengemeinschaft
 * * `Erbschein` - Erbschein
 * * `Erbscheinsantrag` - Erbscheinsantrag
 * * `Erbvertrag` - Erbvertrag
 * * `Exmatrikulation` - Exmatrikulation
 * * `Fahren ohne Führerschein` - Fahren Ohne Führerschein
 * * `Fahren unter Alkohol - / Drogeneinfluss` - Fahren Unter Alkohol - / Drogeneinfluss
 * * `Fahrer - / Unfallflucht` - Fahrer - / Unfallflucht
 * * `Fahrverbot / Führerscheinentzug` - Fahrverbot / Führerscheinentzug
 * * `Falschaussage/ Meineid` - Falschaussage/ Meineid
 * * `Familie Vorsorge` - Familie Vorsorge
 * * `Forderung löschen` - Forderung Löschen
 * * `Geburtsfehler` - Geburtsfehler
 * * `Geburtsfehler Mutter` - Geburtsfehler Mutter
 * * `Geschwindigkeitsüberschreitung` - Geschwindigkeitsüberschreitung
 * * `Gesetzliche Erbfolge` - Gesetzliche Erbfolge
 * * `Gewerblicher Rechtsschutz` - Gewerblicher Rechtsschutz
 * * `Grundschuld` - Grundschuld
 * * `Gründung` - Gründung
 * * `Handy am Steuer` - Handy Am Steuer
 * * `Hauskauf` - Hauskauf
 * * `Härtefallantrag` - Härtefallantrag
 * * `Immobilien` - Immobilien
 * * `Immobilienübertragung` - Immobilienübertragung
 * * `Kaufvertragsprüfung` - Kaufvertragsprüfung
 * * `Körperverletzung` - Körperverletzung
 * * `Kündigung` - Kündigung
 * * `Lohnzahlung` - Lohnzahlung
 * * `Maklerangelegenheit` - Maklerangelegenheit
 * * `Markenanmeldung` - Markenanmeldung
 * * `Markenverteidigung` - Markenverteidigung
 * * `Markenüberwachung` - Markenüberwachung
 * * `Mieterhöhung` - Mieterhöhung
 * * `Mietkaution` - Mietkaution
 * * `Mietminderung` - Mietminderung
 * * `Mietvertrag` - Mietvertrag
 * * `Mobbing` - Mobbing
 * * `Nebenkostenabrechnung` - Nebenkostenabrechnung
 * * `Niederlassungserlaubnis` - Niederlassungserlaubnis
 * * `Nutzerbewertungen Verfasser` - Nutzerbewertungen Verfasser
 * * `Patientenverfügung/Vorsorgevollmacht` - Patientenverfügung/Vorsorgevollmacht
 * * `Personenverwechselung` - Personenverwechselung
 * * `Pflege-/Krankenversicherung` - Pflege-/Krankenversicherung
 * * `Pflegerecht` - Pflegerecht
 * * `Pflichtteil` - Pflichtteil
 * * `Pflichtteil Geltendmachung` - Pflichtteil Geltendmachung
 * * `Pflichtteil abwehren` - Pflichtteil Abwehren
 * * `Plagiatsvorwurf` - Plagiatsvorwurf
 * * `Remonstration` - Remonstration
 * * `Rente` - Rente
 * * `Rotlichtverstoß` - Rotlichtverstoß
 * * `Räumungsklage` - Räumungsklage
 * * `Schadensersatz` - Schadensersatz
 * * `Scheidung` - Scheidung
 * * `Schenkung` - Schenkung
 * * `Schenkung Immobilie` - Schenkung Immobilie
 * * `Schulplatz einklagen` - Schulplatz Einklagen
 * * `Schwerbehinderung` - Schwerbehinderung
 * * `Sexualdelikt` - Sexualdelikt
 * * `Software Hardware` - Software Hardware
 * * `Sonstige Beglaubigung` - Sonstige Beglaubigung
 * * `Sorgerecht und Umgangsrecht` - Sorgerecht Und Umgangsrecht
 * * `Testament` - Testament
 * * `Testament/Erbvertrag` - Testament/Erbvertrag
 * * `Tierkauf` - Tierkauf
 * * `Tierärztliche Behandlungsfehler` - Tierärztliche Behandlungsfehler
 * * `Trennung` - Trennung
 * * `Tuning` - Tuning
 * * `Täuschungsversuch` - Täuschungsversuch
 * * `Tötungsdelikte` - Tötungsdelikte
 * * `Unfall Querschnittslähmung` - Unfall Querschnittslähmung
 * * `Unfall mit Personenschaden` - Unfall Mit Personenschaden
 * * `Unterhalt` - Unterhalt
 * * `Unternehmen` - Unternehmen
 * * `Unternehmensauflösung` - Unternehmensauflösung
 * * `Unternehmensgründung` - Unternehmensgründung
 * * `Unternehmenskauf` - Unternehmenskauf
 * * `Urheberrecht` - Urheberrecht
 * * `Urlaub` - Urlaub
 * * `Vaterschaftsanerkennung` - Vaterschaftsanerkennung
 * * `Vererben` - Vererben
 * * `Verkehrsunfall` - Verkehrsunfall
 * * `Vermögensauseinandersetzung` - Vermögensauseinandersetzung
 * * `Vermögensdelikte` - Vermögensdelikte
 * * `Verstoß gegen die Anschnallpflicht` - Verstoß Gegen Die Anschnallpflicht
 * * `Vertragsprüfung` - Vertragsprüfung
 * * `Vertragsrecht` - Vertragsrecht
 * * `Visum` - Visum
 * * `Vorfälligkeitsentschädigung` - Vorfälligkeitsentschädigung
 * * `Vorsorge` - Vorsorge
 * * `Vorsorgevollmacht/Patientenverfügung` - Vorsorgevollmacht/Patientenverfügung
 * * `Waffendelikte` - Waffendelikte
 * * `Wettbewerbsrecht` - Wettbewerbsrecht
 * * `Widerrufsrechte` - Widerrufsrechte
 * * `Widerspruch/ Klage` - Widerspruch/ Klage
 * * `Wucherzinsen Darlehen` - Wucherzinsen Darlehen
 * * `Zugewinnausgleich` - Zugewinnausgleich
 * * `Zweiradunfall` - Zweiradunfall
 * * `unbezahlte Rechnungen` - Unbezahlte Rechnungen
 * * `unerlaubtes Glücksspiel` - Unerlaubtes Glücksspiel
 * * `Überstunden` - Überstunden
 * * `Übertragung zu Lebzeiten` - Übertragung Zu Lebzeiten
 */
export const TopicEnum = {
    AGB: 'AGB',
    ABFINDUNG: 'Abfindung',
    ABMAHNUNG: 'Abmahnung',
    ABMAHNUNG_WETTBEWERBSRECHT: 'Abmahnung Wettbewerbsrecht',
    ABSCHIEBUNGSHAFT: 'Abschiebungshaft',
    ABSCHLUSSARBEIT: 'Abschlussarbeit',
    ABSTANDSREGELUNG_NICHT_EINGEHALTEN: 'Abstandsregelung nicht eingehalten',
    ACCOUNT_HACKING: 'Account hacking',
    ALLGEMEIN: 'Allgemein',
    'ALLGEMEINES_PRÜFUNGSRECHT': 'Allgemeines Prüfungsrecht',
    ANDERES: 'Anderes',
    ARBEITSAMT_ALG_SPERRZEIT: 'Arbeitsamt/ALG/Sperrzeit',
    ARBEITSUNFALL: 'Arbeitsunfall',
    ARBEITSVERTRAG: 'Arbeitsvertrag',
    ARBEITSZEUGNIS: 'Arbeitszeugnis',
    AUFBAU_COMPLIANCESYSTEM: 'Aufbau Compliancesystem',
    AUFENTHALTSERLAUBNIS: 'Aufenthaltserlaubnis',
    AUFHEBUNGSVERTRAG: 'Aufhebungsvertrag',
    AUFTRAGSDATENVERARBEITUNG: 'Auftragsdatenverarbeitung',
    AUSEINANDERSETZUNG_ERBENGEMEINSCHAFT: 'Auseinandersetzung Erbengemeinschaft',
    'AUSKUNFT_PRÜFEN': 'Auskunft prüfen',
    AUSWEISUNG: 'Ausweisung',
    AUTOKAUF: 'Autokauf',
    'BANKKONTO_LEERGERÄUMT': 'Bankkonto leergeräumt',
    BANKRECHT: 'Bankrecht',
    BAUMANGEL: 'Baumangel',
    BAUVERTRAG: 'Bauvertrag',
    BEHANDLUNGSFEHLER_ALLGEMEIN: 'Behandlungsfehler Allgemein',
    'BEHANDLUNGSFEHLER_QUERSCHNITTSLÄHMUNG': 'Behandlungsfehler Querschnittslähmung',
    BEHANDLUNGSFEHLER_SCHLAGANFALL: 'Behandlungsfehler Schlaganfall',
    BEISSVORFALL: 'Beißvorfall',
    BERATUNG_ZU_ERBFALL: 'Beratung zu Erbfall',
    BESCHLAGNAHME_ALLGEMEIN: 'Beschlagnahme Allgemein',
    'BESCHLAGNAHME_TIERQUÄLEREI': 'Beschlagnahme Tierquälerei',
    BETREUUNGSRECHT: 'Betreuungsrecht',
    BETRUG_GELDANLAGE: 'Betrug Geldanlage',
    'BETÄUBUNGSMITTEL': 'Betäubungsmittel',
    BURGSCHILD_INKASSO: 'Burgschild Inkasso',
    BUSSGELDBESCHEID: 'Bußgeldbescheid',
    'BÜRGERGELD': 'Bürgergeld',
    COACHING: 'Coaching',
    DATENSCHUTZ: 'Datenschutz',
    DATENSCHUTZ_SCHADENSERSATZ: 'Datenschutz Schadensersatz',
    DATENSCHUTZVERSTOSS: 'Datenschutzverstoß',
    DISKRIMINIERUNG: 'Diskriminierung',
    DOMAINS: 'Domains',
    EHEVERTRAG: 'Ehevertrag',
    EIGENTUMSDELIKTE: 'Eigentumsdelikte',
    'EINBÜRGERUNG': 'Einbürgerung',
    EINGRUPPIERUNG: 'Eingruppierung',
    EINREISESPERRE: 'Einreisesperre',
    'EINTRAG_LÖSCHEN': 'Eintrag löschen',
    ERBAUSEINANDERSETZUNG: 'Erbauseinandersetzung',
    ERBAUSSCHLAGUNG: 'Erbausschlagung',
    ERBEN_SCHENKEN: 'Erben/Schenken',
    ERBENGEMEINSCHAFT: 'Erbengemeinschaft',
    ERBSCHEIN: 'Erbschein',
    ERBSCHEINSANTRAG: 'Erbscheinsantrag',
    ERBVERTRAG: 'Erbvertrag',
    EXMATRIKULATION: 'Exmatrikulation',
    'FAHREN_OHNE_FÜHRERSCHEIN': 'Fahren ohne Führerschein',
    FAHREN_UNTER_ALKOHOL_____DROGENEINFLUSS: 'Fahren unter Alkohol - / Drogeneinfluss',
    FAHRER_____UNFALLFLUCHT: 'Fahrer - / Unfallflucht',
    'FAHRVERBOT___FÜHRERSCHEINENTZUG': 'Fahrverbot / Führerscheinentzug',
    FALSCHAUSSAGE__MEINEID: 'Falschaussage/ Meineid',
    FAMILIE_VORSORGE: 'Familie Vorsorge',
    'FORDERUNG_LÖSCHEN': 'Forderung löschen',
    GEBURTSFEHLER: 'Geburtsfehler',
    GEBURTSFEHLER_MUTTER: 'Geburtsfehler Mutter',
    'GESCHWINDIGKEITSÜBERSCHREITUNG': 'Geschwindigkeitsüberschreitung',
    GESETZLICHE_ERBFOLGE: 'Gesetzliche Erbfolge',
    GEWERBLICHER_RECHTSSCHUTZ: 'Gewerblicher Rechtsschutz',
    GRUNDSCHULD: 'Grundschuld',
    'GRÜNDUNG': 'Gründung',
    HANDY_AM_STEUER: 'Handy am Steuer',
    HAUSKAUF: 'Hauskauf',
    'HÄRTEFALLANTRAG': 'Härtefallantrag',
    IMMOBILIEN: 'Immobilien',
    'IMMOBILIENÜBERTRAGUNG': 'Immobilienübertragung',
    'KAUFVERTRAGSPRÜFUNG': 'Kaufvertragsprüfung',
    'KÖRPERVERLETZUNG': 'Körperverletzung',
    'KÜNDIGUNG': 'Kündigung',
    LOHNZAHLUNG: 'Lohnzahlung',
    MAKLERANGELEGENHEIT: 'Maklerangelegenheit',
    MARKENANMELDUNG: 'Markenanmeldung',
    MARKENVERTEIDIGUNG: 'Markenverteidigung',
    'MARKENÜBERWACHUNG': 'Markenüberwachung',
    'MIETERHÖHUNG': 'Mieterhöhung',
    MIETKAUTION: 'Mietkaution',
    MIETMINDERUNG: 'Mietminderung',
    MIETVERTRAG: 'Mietvertrag',
    MOBBING: 'Mobbing',
    NEBENKOSTENABRECHNUNG: 'Nebenkostenabrechnung',
    NIEDERLASSUNGSERLAUBNIS: 'Niederlassungserlaubnis',
    NUTZERBEWERTUNGEN_VERFASSER: 'Nutzerbewertungen Verfasser',
    'PATIENTENVERFÜGUNG_VORSORGEVOLLMACHT': 'Patientenverfügung/Vorsorgevollmacht',
    PERSONENVERWECHSELUNG: 'Personenverwechselung',
    PFLEGE__KRANKENVERSICHERUNG: 'Pflege-/Krankenversicherung',
    PFLEGERECHT: 'Pflegerecht',
    PFLICHTTEIL: 'Pflichtteil',
    PFLICHTTEIL_GELTENDMACHUNG: 'Pflichtteil Geltendmachung',
    PFLICHTTEIL_ABWEHREN: 'Pflichtteil abwehren',
    PLAGIATSVORWURF: 'Plagiatsvorwurf',
    REMONSTRATION: 'Remonstration',
    RENTE: 'Rente',
    ROTLICHTVERSTOSS: 'Rotlichtverstoß',
    'RÄUMUNGSKLAGE': 'Räumungsklage',
    SCHADENSERSATZ: 'Schadensersatz',
    SCHEIDUNG: 'Scheidung',
    SCHENKUNG: 'Schenkung',
    SCHENKUNG_IMMOBILIE: 'Schenkung Immobilie',
    SCHULPLATZ_EINKLAGEN: 'Schulplatz einklagen',
    SCHWERBEHINDERUNG: 'Schwerbehinderung',
    SEXUALDELIKT: 'Sexualdelikt',
    SOFTWARE_HARDWARE: 'Software Hardware',
    SONSTIGE_BEGLAUBIGUNG: 'Sonstige Beglaubigung',
    SORGERECHT_UND_UMGANGSRECHT: 'Sorgerecht und Umgangsrecht',
    TESTAMENT: 'Testament',
    TESTAMENT_ERBVERTRAG: 'Testament/Erbvertrag',
    TIERKAUF: 'Tierkauf',
    'TIERÄRZTLICHE_BEHANDLUNGSFEHLER': 'Tierärztliche Behandlungsfehler',
    TRENNUNG: 'Trennung',
    TUNING: 'Tuning',
    'TÄUSCHUNGSVERSUCH': 'Täuschungsversuch',
    'TÖTUNGSDELIKTE': 'Tötungsdelikte',
    'UNFALL_QUERSCHNITTSLÄHMUNG': 'Unfall Querschnittslähmung',
    UNFALL_MIT_PERSONENSCHADEN: 'Unfall mit Personenschaden',
    UNTERHALT: 'Unterhalt',
    UNTERNEHMEN: 'Unternehmen',
    'UNTERNEHMENSAUFLÖSUNG': 'Unternehmensauflösung',
    'UNTERNEHMENSGRÜNDUNG': 'Unternehmensgründung',
    UNTERNEHMENSKAUF: 'Unternehmenskauf',
    URHEBERRECHT: 'Urheberrecht',
    URLAUB: 'Urlaub',
    VATERSCHAFTSANERKENNUNG: 'Vaterschaftsanerkennung',
    VERERBEN: 'Vererben',
    VERKEHRSUNFALL: 'Verkehrsunfall',
    'VERMÖGENSAUSEINANDERSETZUNG': 'Vermögensauseinandersetzung',
    'VERMÖGENSDELIKTE': 'Vermögensdelikte',
    VERSTOSS_GEGEN_DIE_ANSCHNALLPFLICHT: 'Verstoß gegen die Anschnallpflicht',
    'VERTRAGSPRÜFUNG': 'Vertragsprüfung',
    VERTRAGSRECHT: 'Vertragsrecht',
    VISUM: 'Visum',
    'VORFÄLLIGKEITSENTSCHÄDIGUNG': 'Vorfälligkeitsentschädigung',
    VORSORGE: 'Vorsorge',
    'VORSORGEVOLLMACHT_PATIENTENVERFÜGUNG': 'Vorsorgevollmacht/Patientenverfügung',
    WAFFENDELIKTE: 'Waffendelikte',
    WETTBEWERBSRECHT: 'Wettbewerbsrecht',
    WIDERRUFSRECHTE: 'Widerrufsrechte',
    WIDERSPRUCH__KLAGE: 'Widerspruch/ Klage',
    WUCHERZINSEN_DARLEHEN: 'Wucherzinsen Darlehen',
    ZUGEWINNAUSGLEICH: 'Zugewinnausgleich',
    ZWEIRADUNFALL: 'Zweiradunfall',
    UNBEZAHLTE_RECHNUNGEN: 'unbezahlte Rechnungen',
    'UNERLAUBTES_GLÜCKSSPIEL': 'unerlaubtes Glücksspiel',
    'ÜBERSTUNDEN': 'Überstunden',
    'ÜBERTRAGUNG_ZU_LEBZEITEN': 'Übertragung zu Lebzeiten'
} as const;

/**
 * Total counts per state without any filters (except org).
 */
export type TotalCounts = {
    NEW: StateCount;
    IN_PROGRESS: StateCount;
    COMPLETED: StateCount;
    REJECTED: StateCount;
};

/**
 * Serializer for tracking events.
 */
export type TrackingEventRequest = {
    user: string;
    name: string;
    organization_uuid: string;
};

export type Translation = {
    en: string;
    de: string;
};

export type UUIDCaseCreatorEntity = {
    entity_type: EntityTypeC7aEnum;
    company_legal_form?: UUIDCaseCreatorEntityCompanyLegalFormEnum | BlankEnum | null;
    company_name?: string | null;
    institution_name?: string | null;
    title?: TitleEnum | BlankEnum | null;
    first_name?: string | null;
    last_name?: string | null;
    phone?: string | null;
    email?: string | null;
    date_of_birth?: string | null;
    street?: string | null;
    street_number?: string | null;
    address_line_2?: string | null;
    zip?: string | null;
    city?: string | null;
    iban?: string | null;
    bic?: string | null;
    bank_name?: string | null;
    legal_insurance?: boolean | null;
    legal_insurance_number?: string | null;
    legal_insurance_name?: string | null;
    client_probability: number;
    opponent_probability: number;
    uuid: string;
    document_uuid?: string | null;
};

export type UUIDCaseCreatorEntityCompanyLegalFormEnum = 'GmbH' | 'UG (haftungsbeschränkt)' | 'GmbH & Co. KG' | 'AG' | 'AG & Co. KG' | 'KG' | 'OHG' | 'GBR' | 'PartG' | 'PartG mbB' | 'KGaA' | 'eG' | 'eV' | 'Einzelunternehmen' | 'Stiftung' | 'WEG' | 'SE' | 'EWIV' | 'Limited' | 'PLC' | 'SARL' | 'SAS' | 'SA (FR)' | 'SCN' | 'S.A.R.L.' | 'SRL' | 'SPA' | 'SL' | 'SA (ES)' | 'BV' | 'NV' | 'AB' | 'Oy' | 'AS' | 's.r.o.' | 'Kft.' | 'Sp. z o.o.' | 'OOO';

export const UUIDCaseCreatorEntityCompanyLegalFormEnum = {
    GMB_H: 'GmbH',
    'UG__HAFTUNGSBESCHRÄNKT_': 'UG (haftungsbeschränkt)',
    GMB_H___CO__KG: 'GmbH & Co. KG',
    AG: 'AG',
    AG___CO__KG: 'AG & Co. KG',
    KG: 'KG',
    OHG: 'OHG',
    GBR: 'GBR',
    PART_G: 'PartG',
    PART_G_MB_B: 'PartG mbB',
    KGA_A: 'KGaA',
    E_G: 'eG',
    E_V: 'eV',
    EINZELUNTERNEHMEN: 'Einzelunternehmen',
    STIFTUNG: 'Stiftung',
    WEG: 'WEG',
    SE: 'SE',
    EWIV: 'EWIV',
    LIMITED: 'Limited',
    PLC: 'PLC',
    SARL: 'SARL',
    SAS: 'SAS',
    SA__FR_: 'SA (FR)',
    SCN: 'SCN',
    S_A_R_L_: 'S.A.R.L.',
    SRL: 'SRL',
    SPA: 'SPA',
    SL: 'SL',
    SA__ES_: 'SA (ES)',
    BV: 'BV',
    NV: 'NV',
    AB: 'AB',
    OY: 'Oy',
    AS: 'AS',
    S_R_O_: 's.r.o.',
    KFT_: 'Kft.',
    SP__Z_O_O_: 'Sp. z o.o.',
    OOO: 'OOO'
} as const;

export type UUIDExtractedLawData = {
    law_field?: (LawFieldEnum) | null;
    law_topic?: (LawTopicEnum) | null;
    uuid: string;
    document_uuid?: string | null;
};

export type UUIDExtractionResult = {
    extracted_entities: UUIDCaseCreatorEntity;
    extracted_law_data?: UUIDExtractedLawData | null;
    short_document_summary?: string | null;
};

/**
 * Unified serializer that normalizes both Form (MASTER) and PDFFormTemplate models
 * into a common format for the frontend.
 */
export type UnifiedDocumentTemplate = {
    readonly id: string;
    template_type: string;
    title?: string;
    description?: string;
    readonly file: string;
    readonly created_at: string;
    readonly modified_at: string;
    readonly created_by: CustomerUser;
    readonly modified_by: CustomerUser;
    readonly external_document_creation_token: string;
    readonly form_fields: Array<{
        [key: string]: unknown;
    }>;
};

/**
 * Serializer for updating validation data response.
 */
export type UpdateValidationDataResponse = {
    validation_data: unknown;
    updated_fields: Array<(string)>;
    preview_blob: string | null;
};

/**
 * * `None` - Not Set
 * * `Chatbot Upload` - Chatbot
 * * `Email Anhang` - Email
 * * `Terminbuchung` - Appointment
 * * `Fragebogen` - Questionnaire
 * * `Manuell hinzugefügt` - Manual
 * * `AI CASE CHAT` - Ai Case Chat
 * * `AI Global Chat` - Ai Global Chat
 * * `Dokument neu organisiert` - Reorganization
 * * `External platform` - External Platform
 */
export type UploadOriginEnum = 'None' | 'Chatbot Upload' | 'Email Anhang' | 'Terminbuchung' | 'Fragebogen' | 'Manuell hinzugefügt' | 'AI CASE CHAT' | 'AI Global Chat' | 'Dokument neu organisiert' | 'External platform';

/**
 * * `None` - Not Set
 * * `Chatbot Upload` - Chatbot
 * * `Email Anhang` - Email
 * * `Terminbuchung` - Appointment
 * * `Fragebogen` - Questionnaire
 * * `Manuell hinzugefügt` - Manual
 * * `AI CASE CHAT` - Ai Case Chat
 * * `AI Global Chat` - Ai Global Chat
 * * `Dokument neu organisiert` - Reorganization
 * * `External platform` - External Platform
 */
export const UploadOriginEnum = {
    NONE: 'None',
    CHATBOT_UPLOAD: 'Chatbot Upload',
    EMAIL_ANHANG: 'Email Anhang',
    TERMINBUCHUNG: 'Terminbuchung',
    FRAGEBOGEN: 'Fragebogen',
    'MANUELL_HINZUGEFÜGT': 'Manuell hinzugefügt',
    AI_CASE_CHAT: 'AI CASE CHAT',
    AI_GLOBAL_CHAT: 'AI Global Chat',
    DOKUMENT_NEU_ORGANISIERT: 'Dokument neu organisiert',
    EXTERNAL_PLATFORM: 'External platform'
} as const;

/**
 * Serializer for user avatar updates.
 */
export type UserAvatarUpdateRequest = {
    /**
     * The new avatar image file to upload
     */
    avatar: (Blob | File);
};

/**
 * Serializer for creating a user within an organisation.
 */
export type UserCreateRequest = {
    email: string;
    first_name: string;
    last_name: string;
    role: UserCreateRoleEnum;
};

/**
 * * `ADMIN` - ADMIN
 * * `LAWYER` - LAWYER
 * * `CLERK` - CLERK
 */
export type UserCreateRoleEnum = 'ADMIN' | 'LAWYER' | 'CLERK';

/**
 * * `ADMIN` - ADMIN
 * * `LAWYER` - LAWYER
 * * `CLERK` - CLERK
 */
export const UserCreateRoleEnum = {
    ADMIN: 'ADMIN',
    LAWYER: 'LAWYER',
    CLERK: 'CLERK'
} as const;

/**
 * Serializer for POST validate endpoint request.
 */
export type ValidatePostRequestRequest = {
    /**
     * Use AI-generated template
     */
    use_ai_template?: boolean;
};

/**
 * Serializer for validation data response.
 */
export type ValidationDataResponse = {
    template_id: string;
    template_name: string;
    placeholders: Array<(string)>;
    validation_data: unknown;
    preview_blob: string | null;
};

/**
 * Serializer for Webhooks integration settings in Organisation model.
 */
export type WebhooksSettings = {
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
};

/**
 * Serializer for Webhooks integration settings in Organisation model.
 */
export type WebhooksSettingsRequest = {
    is_webhooks_egress_integration_enabled?: boolean;
    webhook_urls?: string | null;
};

export type WordDocumentTemplate = {
    uuid?: string;
};

/**
 * * `draft` - Draft
 * * `in_review` - In Review
 * * `approved` - Approved
 */
export type WordTemplateStatus = 'draft' | 'in_review' | 'approved';

/**
 * * `draft` - Draft
 * * `in_review` - In Review
 * * `approved` - Approved
 */
export const WordTemplateStatus = {
    DRAFT: 'draft',
    IN_REVIEW: 'in_review',
    APPROVED: 'approved'
} as const;

export type AccountsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AccountsListResponse = PaginatedTAccountList;

export type AccountsCreateData = {
    requestBody?: TAccountRequest;
};

export type AccountsCreateResponse = TAccount;

export type AccountsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AccountsRetrieveResponse = TAccount;

export type AccountsUpdateData = {
    requestBody?: TAccountRequest;
    uuid: string;
};

export type AccountsUpdateResponse = TAccount;

export type AccountsPartialUpdateData = {
    requestBody?: PatchedTAccountRequest;
    uuid: string;
};

export type AccountsPartialUpdateResponse = TAccount;

export type AccountsDestroyData = {
    uuid: string;
};

export type AccountsDestroyResponse = TAccount;

export type AccountsAvailabilityTokenRetrieveData = {
    uuid: string;
};

export type AccountsAvailabilityTokenRetrieveResponse = TAccount;

export type ActaportPartyMatchingFindMatchesCreateData = {
    requestBody: ActaportPartyMatchingRequestRequest;
};

export type ActaportPartyMatchingFindMatchesCreateResponse = ActaportPartyMatchingResponse;

export type ActionAutoCommitSettingsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type ActionAutoCommitSettingsListResponse = PaginatedTActionAutoCommitSettingsList;

export type ActionAutoCommitSettingsCreateData = {
    requestBody?: TActionAutoCommitSettingsRequest;
};

export type ActionAutoCommitSettingsCreateResponse = TActionAutoCommitSettings;

export type ActionAutoCommitSettingsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type ActionAutoCommitSettingsRetrieveResponse = TActionAutoCommitSettings;

export type ActionAutoCommitSettingsUpdateData = {
    requestBody?: TActionAutoCommitSettingsRequest;
    uuid: string;
};

export type ActionAutoCommitSettingsUpdateResponse = TActionAutoCommitSettings;

export type ActionAutoCommitSettingsPartialUpdateData = {
    requestBody?: PatchedTActionAutoCommitSettingsRequest;
    uuid: string;
};

export type ActionAutoCommitSettingsPartialUpdateResponse = TActionAutoCommitSettings;

export type ActionAutoCommitSettingsDestroyData = {
    uuid: string;
};

export type ActionAutoCommitSettingsDestroyResponse = TActionAutoCommitSettings;

export type ActionAutoCommitSettingsAvailableActionsRetrieveResponse = unknown;

export type ActivitiesListData = {
    _case?: string;
    activityType?: string;
    clerk?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * Search activities by client name, client email, company name, document title, questionnaire title, or email sender
     */
    search?: string;
    /**
     * * `ALL` - All activities
     * * `UNSEEN` - Unseen activities
     */
    state?: 'ALL' | 'UNSEEN';
};

export type ActivitiesListResponse = PaginatedTActivityList;

export type ActivitiesCreateData = {
    requestBody?: TActivityRequest;
};

export type ActivitiesCreateResponse = TActivity;

export type ActivitiesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type ActivitiesRetrieveResponse = TActivity;

export type ActivitiesUpdateData = {
    requestBody?: TActivityRequest;
    uuid: string;
};

export type ActivitiesUpdateResponse = TActivity;

export type ActivitiesPartialUpdateData = {
    requestBody?: PatchedTActivityRequest;
    uuid: string;
};

export type ActivitiesPartialUpdateResponse = TActivity;

export type ActivitiesDestroyData = {
    uuid: string;
};

export type ActivitiesDestroyResponse = TActivity;

export type ActivitiesMarkSeenCreateData = {
    uuid: string;
};

export type ActivitiesMarkSeenCreateResponse = TActivity;

export type ActivitiesMarkUnseenCreateData = {
    uuid: string;
};

export type ActivitiesMarkUnseenCreateResponse = TActivity;

export type ActivitiesUnseenCountRetrieveResponse = {
    unseen_count?: number;
};

export type AdvowareRolesGetRoleMappingsCreateData = {
    requestBody: AdvowareRoleRequestRequest;
};

export type AdvowareRolesGetRoleMappingsCreateResponse = Array<AdvowareRoleMapping>;

export type AgentActionsListData = {
    /**
     * * `DRAFT_WORD_DOCUMENT_TEMPLATE` - Draft Word Document Template
     * * `CASE_ASSIGN_LIFECYCLE_WORKFLOW` - Case Assign Lifecycle Workflow
     * * `SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT` - Send Appointment Booking Link To Client
     * * `SEND_CLIENT_TEMPLATE_EMAIL` - Send Client Template Email
     * * `CASE_ASSIGN_LAWYER` - Case Assign Lawyer
     * * `CASE_ASSIGN_LAW_DOMAIN` - Case Assign Law Domain
     * * `CASE_ASSIGN_STATUS` - Case Assign Status
     */
    actionType?: 'CASE_ASSIGN_LAWYER' | 'CASE_ASSIGN_LAW_DOMAIN' | 'CASE_ASSIGN_LIFECYCLE_WORKFLOW' | 'CASE_ASSIGN_STATUS' | 'DRAFT_WORD_DOCUMENT_TEMPLATE' | 'SEND_APPOINTMENT_BOOKING_LINK_TO_CLIENT' | 'SEND_CLIENT_TEMPLATE_EMAIL';
    agent?: string;
    callingAgent?: string;
    caseUuid?: string;
    /**
     * * `RECOMMENDATION` - Recommendation
     * * `AUTO_COMMIT` - Auto Commit
     */
    deliveryMode?: 'AUTO_COMMIT' | 'RECOMMENDATION';
    hasCommitError?: boolean;
    hasRevertError?: boolean;
    isCommitted?: boolean;
    isReverted?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
};

export type AgentActionsListResponse = PaginatedTAgentActionList;

export type AgentActionsCreateData = {
    requestBody?: TAgentActionRequest;
};

export type AgentActionsCreateResponse = TAgentAction;

export type AgentActionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AgentActionsRetrieveResponse = TAgentAction;

export type AgentActionsUpdateData = {
    requestBody?: TAgentActionRequest;
    uuid: string;
};

export type AgentActionsUpdateResponse = TAgentAction;

export type AgentActionsPartialUpdateData = {
    requestBody?: PatchedTAgentActionRequest;
    uuid: string;
};

export type AgentActionsPartialUpdateResponse = TAgentAction;

export type AgentActionsDestroyData = {
    uuid: string;
};

export type AgentActionsDestroyResponse = TAgentAction;

export type AgentActionsCaseCreateInstructionsAdvisoryCreateData = {
    requestBody: CaseCreateInstructionsAdvisoryRequestRequest;
};

export type AgentActionsCaseCreateInstructionsAdvisoryCreateResponse = CaseCreateInstructionsAdvisoryResponse;

export type AgentActionsCommitCreateData = {
    requestBody: AgentActionCommitRequest;
};

export type AgentActionsCommitCreateResponse = unknown;

export type AgentActionsRateCreateData = {
    requestBody: AgentActionRateRequest;
};

export type AgentActionsRateCreateResponse = unknown;

export type AgentActionsRevertCreateData = {
    requestBody: AgentActionRevertRequest;
};

export type AgentActionsRevertCreateResponse = unknown;

export type AiAnalysisListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAnalysisListResponse = PaginatedTAiAnalysisList;

export type AiAnalysisCreateData = {
    requestBody?: TAiAnalysisRequest;
};

export type AiAnalysisCreateResponse = TAiAnalysis;

export type AiAnalysisRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiAnalysisRetrieveResponse = TAiAnalysis;

export type AiAnalysisUpdateData = {
    requestBody?: TAiAnalysisRequest;
    uuid: string;
};

export type AiAnalysisUpdateResponse = TAiAnalysis;

export type AiAnalysisPartialUpdateData = {
    requestBody?: PatchedTAiAnalysisRequest;
    uuid: string;
};

export type AiAnalysisPartialUpdateResponse = TAiAnalysis;

export type AiAnalysisDestroyData = {
    uuid: string;
};

export type AiAnalysisDestroyResponse = TAiAnalysis;

export type AiAnalysisByDocumentUuidListData = {
    documentUuid: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAnalysisByDocumentUuidListResponse = PaginatedTAiAnalysisList;

export type AiAugmentationListData = {
    /**
     * * `DOCUMENT ANALYSIS` - Document Analysis
     * * `EMAIL EXTRACTION` - Email Extraction
     * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
     * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
     * * `CALL` - Call
     * * `CHATBOT` - Chatbot
     * * `AGENT` - Agent
     */
    augmentationVariant?: 'AGENT' | 'CALL' | 'CHATBOT' | 'CONTEXTUAL ANALYSIS' | 'DOCUMENT ANALYSIS' | 'EMAIL EXTRACTION' | 'UNIVERSAL ENTITY EXTRACTION';
    caseUuid?: string;
    documentUuid?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAugmentationListResponse = PaginatedTAiAugmentationList;

export type AiAugmentationCreateData = {
    requestBody?: TAiAugmentationRequest;
};

export type AiAugmentationCreateResponse = TAiAugmentation;

export type AiAugmentationRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiAugmentationRetrieveResponse = TAiAugmentation;

export type AiAugmentationUpdateData = {
    requestBody?: TAiAugmentationRequest;
    uuid: string;
};

export type AiAugmentationUpdateResponse = TAiAugmentation;

export type AiAugmentationPartialUpdateData = {
    requestBody?: PatchedTAiAugmentationRequest;
    uuid: string;
};

export type AiAugmentationPartialUpdateResponse = TAiAugmentation;

export type AiAugmentationDestroyData = {
    uuid: string;
};

export type AiAugmentationDestroyResponse = TAiAugmentation;

export type AiAugmentationByDocumentUuidListData = {
    /**
     * * `DOCUMENT ANALYSIS` - Document Analysis
     * * `EMAIL EXTRACTION` - Email Extraction
     * * `CONTEXTUAL ANALYSIS` - Contextual Analysis
     * * `UNIVERSAL ENTITY EXTRACTION` - Universal Entity Extraction
     * * `CALL` - Call
     * * `CHATBOT` - Chatbot
     * * `AGENT` - Agent
     */
    augmentationVariant?: 'AGENT' | 'CALL' | 'CHATBOT' | 'CONTEXTUAL ANALYSIS' | 'DOCUMENT ANALYSIS' | 'EMAIL EXTRACTION' | 'UNIVERSAL ENTITY EXTRACTION';
    caseUuid?: string;
    documentUuid: string;
    documentUuid?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiAugmentationByDocumentUuidListResponse = PaginatedTAiAugmentationList;

export type AiChatQuestionTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiChatQuestionTemplatesListResponse = PaginatedTAiChatQuestionTemplateList;

export type AiChatQuestionTemplatesCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
};

export type AiChatQuestionTemplatesCreateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiChatQuestionTemplatesRetrieveResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesUpdateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesUpdateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesPartialUpdateData = {
    requestBody?: PatchedTAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesPartialUpdateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesDestroyData = {
    uuid: string;
};

export type AiChatQuestionTemplatesDestroyResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesCopyCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesCopyCreateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesFavoriteCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesFavoriteCreateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesUnfavoriteCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
    uuid: string;
};

export type AiChatQuestionTemplatesUnfavoriteCreateResponse = TAiChatQuestionTemplate;

export type AiChatQuestionTemplatesGenerateDescriptionCreateData = {
    requestBody?: TAiChatQuestionTemplateRequest;
};

export type AiChatQuestionTemplatesGenerateDescriptionCreateResponse = TAiChatQuestionTemplate;

export type AiChatSessionGroupsListData = {
    createdByUser?: number;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    name?: string;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type AiChatSessionGroupsListResponse = PaginatedSessionGroupList;

export type AiChatSessionGroupsCreateData = {
    requestBody: SessionGroupRequest;
};

export type AiChatSessionGroupsCreateResponse = SessionGroup;

export type AiChatSessionGroupsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiChatSessionGroupsRetrieveResponse = SessionGroup;

export type AiChatSessionGroupsUpdateData = {
    requestBody: SessionGroupRequest;
    uuid: string;
};

export type AiChatSessionGroupsUpdateResponse = SessionGroup;

export type AiChatSessionGroupsPartialUpdateData = {
    requestBody?: PatchedSessionGroupRequest;
    uuid: string;
};

export type AiChatSessionGroupsPartialUpdateResponse = SessionGroup;

export type AiChatSessionGroupsDestroyData = {
    uuid: string;
};

export type AiChatSessionGroupsDestroyResponse = void;

export type AiChatSessionGroupsChatSessionsRetrieveData = {
    uuid: string;
};

export type AiChatSessionGroupsChatSessionsRetrieveResponse = SessionGroup;

export type AiChatSessionGroupsCreateChatSessionCreateData = {
    requestBody: SessionGroupRequest;
    uuid: string;
};

export type AiChatSessionGroupsCreateChatSessionCreateResponse = SessionGroup;

export type AiChatSessionsListData = {
    /**
     * Created before (inclusive)
     */
    endDate?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * Search in message content
     */
    search?: string;
    /**
     * Roles to search in (comma-separated)
     */
    searchRoles?: string;
    sessionGroup?: string;
    /**
     * Type of chat session - GLOBAL or CASE
     *
     * * `GLOBAL` - Global
     * * `CASE` - Case
     */
    sessionType?: 'CASE' | 'GLOBAL';
    /**
     * Created after
     */
    startDate?: string;
};

export type AiChatSessionsListResponse = PaginatedTAIChatSessionList;

export type AiChatSessionsCreateData = {
    requestBody?: TAIChatSessionRequest;
};

export type AiChatSessionsCreateResponse = TAIChatSession;

export type AiChatSessionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiChatSessionsRetrieveResponse = TAIChatSession;

export type AiChatSessionsUpdateData = {
    requestBody?: TAIChatSessionRequest;
    uuid: string;
};

export type AiChatSessionsUpdateResponse = TAIChatSession;

export type AiChatSessionsPartialUpdateData = {
    requestBody?: PatchedTAIChatSessionRequest;
    uuid: string;
};

export type AiChatSessionsPartialUpdateResponse = TAIChatSession;

export type AiChatSessionsDestroyData = {
    uuid: string;
};

export type AiChatSessionsDestroyResponse = TAIChatSession;

export type AiChatSessionsExportPdfCreateData = {
    requestBody?: TAIChatSessionRequest;
    uuid: string;
};

export type AiChatSessionsExportPdfCreateResponse = TAIChatSession;

export type AiChatSessionsSendMessageCreateData = {
    requestBody: AIChatSessionSendMessageRequestRequest;
    uuid: string;
};

export type AiChatSessionsSendMessageCreateResponse = AIChatSessionSendMessageResponse;

export type AiChatSessionsEnhancePromptCreateData = {
    requestBody: AIChatSessionEnhancePromptRequestRequest;
};

export type AiChatSessionsEnhancePromptCreateResponse = AIChatSessionEnhancePromptResponse;

export type AiSettingsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AiSettingsListResponse = PaginatedTAiSettingsList;

export type AiSettingsCreateData = {
    requestBody?: TAiSettingsRequest;
};

export type AiSettingsCreateResponse = TAiSettings;

export type AiSettingsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AiSettingsRetrieveResponse = TAiSettings;

export type AiSettingsUpdateData = {
    requestBody?: TAiSettingsRequest;
    uuid: string;
};

export type AiSettingsUpdateResponse = TAiSettings;

export type AiSettingsPartialUpdateData = {
    requestBody?: PatchedTAiSettingsRequest;
    uuid: string;
};

export type AiSettingsPartialUpdateResponse = TAiSettings;

export type AiSettingsDestroyData = {
    uuid: string;
};

export type AiSettingsDestroyResponse = TAiSettings;

export type AiSettingsAvailableActionsRetrieveResponse = unknown;

export type AiSettingsAvailableNotificationActionsRetrieveResponse = NotificationSettings;

export type AnnouncementsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AnnouncementsListResponse = PaginatedTAnnouncementList;

export type AnnouncementsCreateData = {
    requestBody?: TAnnouncementRequest;
};

export type AnnouncementsCreateResponse = TAnnouncement;

export type AnnouncementsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AnnouncementsRetrieveResponse = TAnnouncement;

export type AnnouncementsUpdateData = {
    requestBody?: TAnnouncementRequest;
    uuid: string;
};

export type AnnouncementsUpdateResponse = TAnnouncement;

export type AnnouncementsPartialUpdateData = {
    requestBody?: PatchedTAnnouncementRequest;
    uuid: string;
};

export type AnnouncementsPartialUpdateResponse = TAnnouncement;

export type AnnouncementsDestroyData = {
    uuid: string;
};

export type AnnouncementsDestroyResponse = TAnnouncement;

export type AnnouncementsActiveListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AnnouncementsActiveListResponse = PaginatedTActiveAnnouncementList;

export type AppointmentProposalsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AppointmentProposalsListResponse = PaginatedTAppointmentProposalList;

export type AppointmentProposalsCreateData = {
    requestBody?: TAppointmentProposalRequest;
};

export type AppointmentProposalsCreateResponse = TAppointmentProposal;

export type AppointmentProposalsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AppointmentProposalsRetrieveResponse = TAppointmentProposal;

export type AppointmentProposalsUpdateData = {
    requestBody?: TAppointmentProposalRequest;
    uuid: string;
};

export type AppointmentProposalsUpdateResponse = TAppointmentProposal;

export type AppointmentProposalsPartialUpdateData = {
    requestBody?: PatchedTAppointmentProposalRequest;
    uuid: string;
};

export type AppointmentProposalsPartialUpdateResponse = TAppointmentProposal;

export type AppointmentProposalsDestroyData = {
    uuid: string;
};

export type AppointmentProposalsDestroyResponse = TAppointmentProposal;

export type AppointmentSettingsRetrieveResponse = AppointmentSettings;

export type AppointmentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type AppointmentsListResponse = PaginatedTAppointmentList;

export type AppointmentsCreateData = {
    requestBody?: TAppointmentRequest;
};

export type AppointmentsCreateResponse = TAppointment;

export type AppointmentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type AppointmentsRetrieveResponse = TAppointment;

export type AppointmentsUpdateData = {
    requestBody?: TAppointmentRequest;
    uuid: string;
};

export type AppointmentsUpdateResponse = TAppointment;

export type AppointmentsPartialUpdateData = {
    requestBody?: PatchedTAppointmentRequest;
    uuid: string;
};

export type AppointmentsPartialUpdateResponse = TAppointment;

export type AppointmentsDestroyData = {
    uuid: string;
};

export type AppointmentsDestroyResponse = TAppointment;

export type AppointmentsCancelCreateData = {
    requestBody?: TAppointmentRequest;
    uuid: string;
};

export type AppointmentsCancelCreateResponse = TAppointment;

export type AppointmentsConfirmCreateData = {
    requestBody?: TAppointmentRequest;
    uuid: string;
};

export type AppointmentsConfirmCreateResponse = TAppointment;

export type AppointmentsCreateCaseAppointmentCreateData = {
    requestBody?: TAppointmentRequest;
};

export type AppointmentsCreateCaseAppointmentCreateResponse = TAppointment;

export type CalendarsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CalendarsListResponse = PaginatedTCalendarList;

export type CalendarsCreateData = {
    requestBody?: TCalendarRequest;
};

export type CalendarsCreateResponse = TCalendar;

export type CalendarsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CalendarsRetrieveResponse = TCalendar;

export type CalendarsUpdateData = {
    requestBody?: TCalendarRequest;
    uuid: string;
};

export type CalendarsUpdateResponse = TCalendar;

export type CalendarsPartialUpdateData = {
    requestBody?: PatchedTCalendarRequest;
    uuid: string;
};

export type CalendarsPartialUpdateResponse = TCalendar;

export type CalendarsDestroyData = {
    uuid: string;
};

export type CalendarsDestroyResponse = TCalendar;

export type CallsListData = {
    /**
     * ai_ratings
     */
    aiRatings?: string;
    /**
     * duration_ranges
     */
    durationRanges?: string;
    excludeWithoutMessage?: boolean;
    forwardedOnly?: boolean;
    hasResult?: boolean;
    /**
     * human_ratings
     */
    humanRatings?: string;
    isDeleted?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * result_classification
     */
    resultClassification?: string;
    resultDataLawField?: string;
    /**
     * retell_call_id
     */
    retellCallId?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * twilio_call_sid
     */
    twilioCallSid?: string;
};

export type CallsListResponse = PaginatedTCallList;

export type CallsCreateData = {
    requestBody?: TCallRequest;
};

export type CallsCreateResponse = TCall;

export type CallsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CallsRetrieveResponse = TCall;

export type CallsUpdateData = {
    requestBody?: TCallRequest;
    uuid: string;
};

export type CallsUpdateResponse = TCall;

export type CallsPartialUpdateData = {
    requestBody?: PatchedTCallRequest;
    uuid: string;
};

export type CallsPartialUpdateResponse = TCall;

export type CallsDestroyData = {
    uuid: string;
};

export type CallsDestroyResponse = TCall;

export type CallsCreateCaseCreateData = {
    requestBody?: TCallRequest;
    uuid: string;
};

export type CallsCreateCaseCreateResponse = TCall;

export type CallsGeminiShadowComparisonCreateData = {
    requestBody: GeminiShadowComparisonInputRequest;
    uuid: string;
};

export type CallsGeminiShadowComparisonCreateResponse = GeminiShadowComparison;

export type CallsLawyerFeedbackListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CallsLawyerFeedbackListResponse = PaginatedTLawyerFeedbackList;

export type CallsLawyerFeedbackCreateData = {
    requestBody?: TLawyerFeedbackRequest;
};

export type CallsLawyerFeedbackCreateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CallsLawyerFeedbackRetrieveResponse = TLawyerFeedback;

export type CallsLawyerFeedbackUpdateData = {
    requestBody?: TLawyerFeedbackRequest;
    uuid: string;
};

export type CallsLawyerFeedbackUpdateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackPartialUpdateData = {
    requestBody?: PatchedTLawyerFeedbackRequest;
    uuid: string;
};

export type CallsLawyerFeedbackPartialUpdateResponse = TLawyerFeedback;

export type CallsLawyerFeedbackDestroyData = {
    uuid: string;
};

export type CallsLawyerFeedbackDestroyResponse = TLawyerFeedback;

export type CaseCreationIntegrationCreateData = {
    requestBody: SchemaExternalIntegrationCaseCreationRequest;
};

export type CaseCreationIntegrationCreateResponse = ExternalIntegrationFileDownloadResponse | ExternalIntegrationCaseCreationResponse;

export type CaseCreatorTempDocumentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CaseCreatorTempDocumentsListResponse = PaginatedTCaseCreatorTempDocumentList;

export type CaseCreatorTempDocumentsCreateData = {
    formData?: TCaseCreatorTempDocumentRequest;
};

export type CaseCreatorTempDocumentsCreateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CaseCreatorTempDocumentsRetrieveResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsUpdateData = {
    formData?: TCaseCreatorTempDocumentRequest;
    uuid: string;
};

export type CaseCreatorTempDocumentsUpdateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsPartialUpdateData = {
    formData?: PatchedTCaseCreatorTempDocumentRequest;
    uuid: string;
};

export type CaseCreatorTempDocumentsPartialUpdateResponse = TCaseCreatorTempDocument;

export type CaseCreatorTempDocumentsDestroyData = {
    uuid: string;
};

export type CaseCreatorTempDocumentsDestroyResponse = TCaseCreatorTempDocument;

export type CaseLifecycleStateReasoningListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CaseLifecycleStateReasoningListResponse = PaginatedTCaseLifecycleStateReasoningList;

export type CaseLifecycleStateReasoningRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CaseLifecycleStateReasoningRetrieveResponse = TCaseLifecycleStateReasoning;

export type CaseLifecycleStatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CaseLifecycleStatesListResponse = PaginatedTCaseLifecycleStateList;

export type CaseLifecycleStatesCreateData = {
    requestBody?: TCaseLifecycleStateRequestRequest;
};

export type CaseLifecycleStatesCreateResponse = TCaseLifecycleState;

export type CaseLifecycleStatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CaseLifecycleStatesRetrieveResponse = TCaseLifecycleState;

export type CaseLifecycleStatesUpdateData = {
    requestBody?: TCaseLifecycleStateRequestRequest;
    uuid: string;
};

export type CaseLifecycleStatesUpdateResponse = TCaseLifecycleState;

export type CaseLifecycleStatesPartialUpdateData = {
    requestBody?: PatchedTCaseLifecycleStateRequestRequest;
    uuid: string;
};

export type CaseLifecycleStatesPartialUpdateResponse = TCaseLifecycleState;

export type CaseLifecycleStatesDestroyData = {
    uuid: string;
};

export type CaseLifecycleStatesDestroyResponse = TCaseLifecycleState;

export type CaseLifecycleStatesAdvanceCreateData = {
    requestBody?: TCaseLifecycleStateRequestRequest;
    uuid: string;
};

export type CaseLifecycleStatesAdvanceCreateResponse = TCaseLifecycleState;

export type CaseLifecycleStatesRateCreateData = {
    requestBody: CaseLifecycleStateRateRequest;
    uuid: string;
};

export type CaseLifecycleStatesRateCreateResponse = unknown;

export type CaseLifecycleWorkflowsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type CaseLifecycleWorkflowsListResponse = PaginatedTCaseLifecycleWorkflowList;

export type CaseLifecycleWorkflowsCreateData = {
    requestBody?: TCaseLifecycleWorkflowRequest;
};

export type CaseLifecycleWorkflowsCreateResponse = TCaseLifecycleWorkflow;

export type CaseLifecycleWorkflowsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CaseLifecycleWorkflowsRetrieveResponse = TCaseLifecycleWorkflow;

export type CaseLifecycleWorkflowsUpdateData = {
    requestBody?: TCaseLifecycleWorkflowRequest;
    uuid: string;
};

export type CaseLifecycleWorkflowsUpdateResponse = TCaseLifecycleWorkflow;

export type CaseLifecycleWorkflowsPartialUpdateData = {
    requestBody?: PatchedTCaseLifecycleWorkflowRequest;
    uuid: string;
};

export type CaseLifecycleWorkflowsPartialUpdateResponse = TCaseLifecycleWorkflow;

export type CaseLifecycleWorkflowsDestroyData = {
    uuid: string;
};

export type CaseLifecycleWorkflowsDestroyResponse = TCaseLifecycleWorkflow;

export type CaseLifecycleWorkflowsAvailableActionsRetrieveResponse = unknown;

export type CasesListData = {
    clerk?: string;
    endDate?: string;
    hasUnseenActivity?: boolean;
    legalField?: string;
    legalTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    search?: string;
    startDate?: string;
    state?: string;
};

export type CasesListResponse = PaginatedTCaseList;

export type CasesCreateData = {
    requestBody: CaseCreateRequest;
};

export type CasesCreateResponse = TCase;

export type CasesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type CasesRetrieveResponse = TCase;

export type CasesUpdateData = {
    requestBody?: TCaseRequest;
    uuid: string;
};

export type CasesUpdateResponse = TCase;

export type CasesPartialUpdateData = {
    requestBody?: PatchedTCaseRequest;
    uuid: string;
};

export type CasesPartialUpdateResponse = TCase;

export type CasesDestroyData = {
    uuid: string;
};

export type CasesDestroyResponse = TCase;

export type CasesAiSummaryCreateData = {
    uuid: string;
};

export type CasesAiSummaryCreateResponse = string;

export type CasesAppointmentProposalsRetrieveData = {
    uuid: string;
};

export type CasesAppointmentProposalsRetrieveResponse = {
    [key: string]: unknown;
};

export type CasesAppointmentsListData = {
    clerk?: string;
    endDate?: string;
    hasUnseenActivity?: boolean;
    legalField?: string;
    legalTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    search?: string;
    startDate?: string;
    state?: string;
    uuid: string;
};

export type CasesAppointmentsListResponse = PaginatedCaseAppointmentsList;

export type CasesAssignWorkflowPartialUpdateData = {
    requestBody?: PatchedAssignWorkflowRequestRequest;
    uuid: string;
};

export type CasesAssignWorkflowPartialUpdateResponse = TAssignWorkflowResponse;

export type CasesCreateWordDocumentCreateData = {
    requestBody: CreateWordDocumentRequestRequest;
    uuid: string;
};

export type CasesCreateWordDocumentCreateResponse = CreateWordDocumentResponse;

export type CasesCreateWordDocumentFromPlaceholderValuesCreateData = {
    requestBody: CreateWordDocumentFromPlaceholderValuesRequestRequest;
    uuid: string;
};

export type CasesCreateWordDocumentFromPlaceholderValuesCreateResponse = CreateWordDocumentFromPlaceholderValuesResponse;

export type CasesCreateWordDocumentPreviewBlobCreateData = {
    requestBody: CreateWordDocumentPreviewBlobRequest;
    uuid: string;
};

export type CasesCreateWordDocumentPreviewBlobCreateResponse = (Blob | File);

export type CasesDocumentsListData = {
    clerk?: string;
    endDate?: string;
    hasUnseenActivity?: boolean;
    legalField?: string;
    legalTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    search?: string;
    startDate?: string;
    state?: string;
    uuid: string;
};

export type CasesDocumentsListResponse = PaginatedDocumentList;

export type CasesDownloadDocumentsZipRetrieveData = {
    uuid: string;
};

export type CasesDownloadDocumentsZipRetrieveResponse = unknown;

export type CasesFindWordDocumentTemplatePlaceholderValuesCreateData = {
    requestBody: FindWordDocumentTemplatePlaceholderValuesRequestRequest;
    uuid: string;
};

export type CasesFindWordDocumentTemplatePlaceholderValuesCreateResponse = FindWordDocumentTemplatePlaceholderValuesResponse;

export type CasesGenerateDocumentHtmlStreamCreateData = {
    requestBody: GenerateDocumentRequestRequest;
    uuid: string;
};

export type CasesGenerateDocumentHtmlStreamCreateResponse = string;

export type CasesSendEmailCreateData = {
    requestBody: SendCaseEmailRequestRequest;
    uuid: string;
};

export type CasesSendEmailCreateResponse = SendCaseEmailResponse;

export type CasesByAccessTokenRetrieveData = {
    /**
     * Case access token
     */
    accessToken?: string;
};

export type CasesByAccessTokenRetrieveResponse = TCase;

export type CasesGenericDatamappersListData = {
    clerk?: string;
    endDate?: string;
    hasUnseenActivity?: boolean;
    legalField?: string;
    legalTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    search?: string;
    startDate?: string;
    state?: string;
};

export type CasesGenericDatamappersListResponse = PaginatedTGenericDataMapperList;

export type CasesStateCountsRetrieveData = {
    /**
     * Filter by clerk UUID
     */
    clerk?: string;
    /**
     * Filter by unseen activity status
     */
    hasUnseenActivity?: boolean;
    /**
     * Filter by legal field
     */
    legalField?: string;
    /**
     * Search in client name, note, legal field, legal topic, clerk name
     */
    search?: string;
};

export type CasesStateCountsRetrieveResponse = CaseStateCounts;

export type ChatPreferencesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type ChatPreferencesListResponse = PaginatedTChatPreferenceList;

export type ChatPreferencesCreateData = {
    requestBody?: TChatPreferenceRequest;
};

export type ChatPreferencesCreateResponse = TChatPreference;

export type ChatPreferencesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type ChatPreferencesRetrieveResponse = TChatPreference;

export type ChatPreferencesUpdateData = {
    requestBody?: TChatPreferenceRequest;
    uuid: string;
};

export type ChatPreferencesUpdateResponse = TChatPreference;

export type ChatPreferencesPartialUpdateData = {
    requestBody?: PatchedTChatPreferenceRequest;
    uuid: string;
};

export type ChatPreferencesPartialUpdateResponse = TChatPreference;

export type ChatPreferencesDestroyData = {
    uuid: string;
};

export type ChatPreferencesDestroyResponse = TChatPreference;

export type ChatPreferencesDismissSuggestionCreateData = {
    requestBody?: TChatPreferenceRequest;
};

export type ChatPreferencesDismissSuggestionCreateResponse = TChatPreference;

export type ChatPreferencesGenerateTitleCreateData = {
    requestBody?: TChatPreferenceRequest;
};

export type ChatPreferencesGenerateTitleCreateResponse = TChatPreference;

export type ChatPreferencesSaveSuggestionCreateData = {
    requestBody?: TChatPreferenceRequest;
};

export type ChatPreferencesSaveSuggestionCreateResponse = TChatPreference;

export type DeliveryEventsListData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type DeliveryEventsListResponse = PaginatedTDeliveryEventList;

export type DeliveryEventsCreateData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    requestBody?: DeliveryEventRequest;
};

export type DeliveryEventsCreateResponse = TDeliveryEvent;

export type DeliveryEventsRetrieveData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    /**
     * Record UUID
     */
    uuid: string;
};

export type DeliveryEventsRetrieveResponse = TDeliveryEvent;

export type DeliveryEventsUpdateData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    requestBody?: DeliveryEventRequest;
    uuid: string;
};

export type DeliveryEventsUpdateResponse = TDeliveryEvent;

export type DeliveryEventsPartialUpdateData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    requestBody?: PatchedDeliveryEventRequest;
    uuid: string;
};

export type DeliveryEventsPartialUpdateResponse = TDeliveryEvent;

export type DeliveryEventsDestroyData = {
    /**
     * Filter delivery events by email UUID
     */
    email?: string;
    /**
     * Filter delivery events by event type
     */
    event?: string;
    uuid: string;
};

export type DeliveryEventsDestroyResponse = TDeliveryEvent;

export type DocumentPlaceholdersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type DocumentPlaceholdersListResponse = PaginatedDocumentPlaceholderList;

export type DocumentPlaceholdersCreateData = {
    requestBody: DocumentPlaceholderRequest;
};

export type DocumentPlaceholdersCreateResponse = DocumentPlaceholder;

export type DocumentPlaceholdersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type DocumentPlaceholdersRetrieveResponse = DocumentPlaceholder;

export type DocumentPlaceholdersUpdateData = {
    requestBody?: DocumentPlaceholderUpdateRequest;
    uuid: string;
};

export type DocumentPlaceholdersUpdateResponse = DocumentPlaceholderUpdate;

export type DocumentPlaceholdersPartialUpdateData = {
    requestBody?: PatchedDocumentPlaceholderUpdateRequest;
    uuid: string;
};

export type DocumentPlaceholdersPartialUpdateResponse = DocumentPlaceholderUpdate;

export type DocumentPlaceholdersDestroyData = {
    uuid: string;
};

export type DocumentPlaceholdersDestroyResponse = void;

export type DocumentPlaceholdersGenerateLabelsCreateData = {
    requestBody: DocumentPlaceholderGenerateLabelsRequest;
};

export type DocumentPlaceholdersGenerateLabelsCreateResponse = DocumentPlaceholderLabelsResponse;

export type DocumentTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type DocumentTemplatesListResponse = PaginatedTDocumentTemplateList;

export type DocumentTemplatesCreateData = {
    requestBody?: TDocumentTemplateRequest;
};

export type DocumentTemplatesCreateResponse = TDocumentTemplate;

export type DocumentTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type DocumentTemplatesRetrieveResponse = TDocumentTemplate;

export type DocumentTemplatesUpdateData = {
    requestBody?: TDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesUpdateResponse = TDocumentTemplate;

export type DocumentTemplatesPartialUpdateData = {
    requestBody?: PatchedTDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesPartialUpdateResponse = TDocumentTemplate;

export type DocumentTemplatesDestroyData = {
    uuid: string;
};

export type DocumentTemplatesDestroyResponse = TDocumentTemplate;

export type DocumentTemplatesCopyCreateData = {
    requestBody?: TDocumentTemplateRequest;
    uuid: string;
};

export type DocumentTemplatesCopyCreateResponse = TDocumentTemplate;

export type DocumentsListData = {
    caseUuid?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type DocumentsListResponse = PaginatedTDocumentList;

export type DocumentsCreateData = {
    requestBody?: TDocumentRequest;
};

export type DocumentsCreateResponse = TDocument;

export type DocumentsBulkSyncPlatformsCreateData = {
    /**
     * UUID of the case containing the documents
     */
    caseUuid: string;
    requestBody?: BulkSyncDocumentsRequestRequest;
};

export type DocumentsBulkSyncPlatformsCreateResponse = BulkSyncDocumentsResponse;

export type DocumentsImportFromActaportCreateData = {
    /**
     * UUID of the case
     */
    caseUuid: string;
    requestBody: ImportDocumentRequestRequest;
};

export type DocumentsImportFromActaportCreateResponse = ImportDocumentResponse;

export type DocumentsRefreshActaportDocumentsCreateData = {
    /**
     * UUID of the case
     */
    caseUuid: string;
    requestBody?: TDocumentRequest;
};

export type DocumentsRefreshActaportDocumentsCreateResponse = {
    [key: string]: unknown;
};

export type DocumentsUploadCreateData = {
    /**
     * UUID of the case
     */
    caseUuid: string;
    formData: DocumentUploadRequest;
};

export type DocumentsUploadCreateResponse = Document;

export type DocumentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type DocumentsRetrieveResponse = TDocument;

export type DocumentsUpdateData = {
    requestBody?: TDocumentRequest;
    uuid: string;
};

export type DocumentsUpdateResponse = TDocument;

export type DocumentsPartialUpdateData = {
    requestBody?: PatchedTDocumentRequest;
    uuid: string;
};

export type DocumentsPartialUpdateResponse = TDocument;

export type DocumentsDestroyData = {
    uuid: string;
};

export type DocumentsDestroyResponse = TDocument;

export type DocumentsCreateEditTokenCreateData = {
    requestBody?: TDocumentRequest;
    uuid: string;
};

export type DocumentsCreateEditTokenCreateResponse = DocumentEditTokenResponse;

export type DocumentsGenerateTitleCreateData = {
    requestBody?: GenerateTitleWithStateRequestRequest;
    uuid: string;
};

export type DocumentsGenerateTitleCreateResponse = GenerateTitleResponse;

export type DocumentsRetryProcessingCreateData = {
    requestBody?: TDocumentRequest;
    uuid: string;
};

export type DocumentsRetryProcessingCreateResponse = TDocument;

export type DocumentsRevertToOriginalCreateData = {
    requestBody?: TDocumentRequest;
    uuid: string;
};

export type DocumentsRevertToOriginalCreateResponse = Document;

export type DocumentsSendToActaportCreateData = {
    uuid: string;
};

export type DocumentsSendToActaportCreateResponse = SendToActaportResponse;

export type DocumentsThumbnailsRetrieveData = {
    uuid: string;
};

export type DocumentsThumbnailsRetrieveResponse = DocumentThumbnails;

export type DocumentsUploadModifiedCreateData = {
    formData?: {
        /**
         * Modified PDF file
         */
        file: (Blob | File);
    };
    uuid: string;
};

export type DocumentsUploadModifiedCreateResponse = Document;

export type DocumentsChatSessionGroupUploadCreateData = {
    formData: DocumentUploadRequest;
    /**
     * UUID of the chat session group
     */
    groupUuid: string;
};

export type DocumentsChatSessionGroupUploadCreateResponse = Document;

export type DocumentsChatSessionUploadCreateData = {
    formData: DocumentUploadRequest;
    /**
     * UUID of the chat session
     */
    sessionUuid: string;
};

export type DocumentsChatSessionUploadCreateResponse = Document;

export type DocumentsReorganizeCreateData = {
    requestBody: DocumentReorganizationRequestRequest;
};

export type DocumentsReorganizeCreateResponse = DocumentReorganizationResponse;

export type DocumentsSplitWithAiCreateData = {
    requestBody: DocumentSplitWithAIRequestRequest;
};

export type DocumentsSplitWithAiCreateResponse = DocumentSplitWithAIResponse;

export type EditorUploadCreateData = {
    requestBody: EditorUploadRequest;
};

export type EditorUploadCreateResponse = EditorUploadResponse;

export type EmailTemplatesListData = {
    lawField?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    type?: string;
};

export type EmailTemplatesListResponse = PaginatedTEmailTemplateList;

export type EmailTemplatesCreateData = {
    requestBody?: TEmailTemplateRequest;
};

export type EmailTemplatesCreateResponse = TEmailTemplate;

export type EmailTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type EmailTemplatesRetrieveResponse = TEmailTemplate;

export type EmailTemplatesUpdateData = {
    requestBody?: TEmailTemplateRequest;
    uuid: string;
};

export type EmailTemplatesUpdateResponse = TEmailTemplate;

export type EmailTemplatesPartialUpdateData = {
    requestBody?: PatchedTEmailTemplateRequest;
    uuid: string;
};

export type EmailTemplatesPartialUpdateResponse = TEmailTemplate;

export type EmailTemplatesDestroyData = {
    uuid: string;
};

export type EmailTemplatesDestroyResponse = TEmailTemplate;

export type EmailsListData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type EmailsListResponse = PaginatedTEmailList;

export type EmailsCreateData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    requestBody?: EmailRequest;
};

export type EmailsCreateResponse = TEmail;

export type EmailsRetrieveData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    /**
     * A unique integer value identifying this email.
     */
    id: number;
};

export type EmailsRetrieveResponse = TEmail;

export type EmailsUpdateData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    /**
     * A unique integer value identifying this email.
     */
    id: number;
    requestBody?: EmailRequest;
};

export type EmailsUpdateResponse = TEmail;

export type EmailsPartialUpdateData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    /**
     * A unique integer value identifying this email.
     */
    id: number;
    requestBody?: PatchedEmailRequest;
};

export type EmailsPartialUpdateResponse = TEmail;

export type EmailsDestroyData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    /**
     * A unique integer value identifying this email.
     */
    id: number;
};

export type EmailsDestroyResponse = TEmail;

export type EmailsRenderTemplateCreateData = {
    /**
     * Filter emails by case UUID
     */
    _case?: string;
    requestBody: EmailRenderTemplateRequestRequest;
};

export type EmailsRenderTemplateCreateResponse = EmailRenderTemplateResponse;

export type EntitiesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type EntitiesListResponse = PaginatedTEntityList;

export type EntitiesCreateData = {
    requestBody?: TEntityRequest;
};

export type EntitiesCreateResponse = TEntity;

export type EntitiesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type EntitiesRetrieveResponse = TEntity;

export type EntitiesUpdateData = {
    requestBody?: TEntityRequest;
    uuid: string;
};

export type EntitiesUpdateResponse = TEntity;

export type EntitiesPartialUpdateData = {
    requestBody?: PatchedTEntityRequest;
    uuid: string;
};

export type EntitiesPartialUpdateResponse = TEntity;

export type EntitiesDestroyData = {
    uuid: string;
};

export type EntitiesDestroyResponse = TEntity;

export type EntitiesAddCaseDataRelationshipCreateData = {
    requestBody: EntityAddCaseDataRelationshipRequest;
    uuid: string;
};

export type EntitiesAddCaseDataRelationshipCreateResponse = TEntityWithRelationship;

export type EntitiesRemoveCaseDataRelationshipCreateData = {
    requestBody: EntityRemoveCaseDataRelationshipRequestRequest;
    uuid: string;
};

export type EntitiesRemoveCaseDataRelationshipCreateResponse = TEntityRemoveCaseDataRelationshipResponse;

export type EntitiesSwitchUniqueCaseDataRelationshipCreateData = {
    requestBody: SwitchUniqueCaseDataRelationshipRequestRequest;
};

export type EntitiesSwitchUniqueCaseDataRelationshipCreateResponse = TSwitchUniqueCaseDataRelationshipResponse;

export type EventCreateData = {
    requestBody: TrackingEventRequest;
};

export type EventCreateResponse = unknown;

export type EventsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type EventsListResponse = PaginatedGenericMetricEventList;

export type EventsCreateData = {
    requestBody: GenericMetricEventRequest;
};

export type EventsCreateResponse = GenericMetricEvent;

export type EventsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type EventsRetrieveResponse = GenericMetricEvent;

export type EventsUpdateData = {
    requestBody: GenericMetricEventRequest;
    uuid: string;
};

export type EventsUpdateResponse = GenericMetricEvent;

export type EventsPartialUpdateData = {
    requestBody?: PatchedGenericMetricEventRequest;
    uuid: string;
};

export type EventsPartialUpdateResponse = GenericMetricEvent;

export type EventsDestroyData = {
    uuid: string;
};

export type EventsDestroyResponse = void;

export type EventsTrackCreateData = {
    requestBody: GenericMetricEventRequest;
};

export type EventsTrackCreateResponse = {
    status?: string;
};

export type FeatureFlagsCheckCreateData = {
    requestBody: FeatureFlagCheckRequestRequest;
};

export type FeatureFlagsCheckCreateResponse = FeatureFlagCheckResponse;

export type FeatureFlagsCheckByAccessTokenCreateData = {
    requestBody: FeatureFlagCheckRequestRequest;
};

export type FeatureFlagsCheckByAccessTokenCreateResponse = FeatureFlagCheckResponse;

export type FeedbackListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
};

export type FeedbackListResponse = PaginatedTFeedbackList;

export type FeedbackCreateData = {
    requestBody?: TFeedbackRequest;
};

export type FeedbackCreateResponse = TFeedback;

export type FeedbackRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type FeedbackRetrieveResponse = TFeedback;

export type FeedbackUpdateData = {
    requestBody?: TFeedbackRequest;
    uuid: string;
};

export type FeedbackUpdateResponse = TFeedback;

export type FeedbackPartialUpdateData = {
    requestBody?: PatchedTFeedbackRequest;
    uuid: string;
};

export type FeedbackPartialUpdateResponse = TFeedback;

export type FeedbackDestroyData = {
    uuid: string;
};

export type FeedbackDestroyResponse = TFeedback;

export type FormsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * * `MASTER` - Master
     * * `PREFILLED` - Prefilled
     * * `SIGNED` - Signed
     */
    tag?: 'MASTER' | 'PREFILLED' | 'SIGNED';
};

export type FormsListResponse = PaginatedTFormList;

export type FormsCreateData = {
    formData?: TFormRequest;
};

export type FormsCreateResponse = TForm;

export type FormsRetrieveData = {
    /**
     * Record UUID
     */
    id: string;
};

export type FormsRetrieveResponse = TForm;

export type FormsUpdateData = {
    formData?: TFormRequest;
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsUpdateResponse = TForm;

export type FormsPartialUpdateData = {
    formData?: PatchedTFormRequest;
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsPartialUpdateResponse = TForm;

export type FormsDestroyData = {
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsDestroyResponse = TForm;

export type FormsThirdPartyTokenRetrieveData = {
    /**
     * A UUID string identifying this form.
     */
    id: string;
};

export type FormsThirdPartyTokenRetrieveResponse = ThirdPartyDocumentCreationTokenResponse;

export type FormsPdfFormRetrieveData = {
    /**
     * Request token
     */
    token: string;
};

export type FormsPdfFormRetrieveResponse = RequestForm;

export type FormsPdfFormSubmitCreateData = {
    requestBody?: SubmitRequestRequest;
    /**
     * Request token
     */
    token: string;
};

export type FormsPdfFormSubmitCreateResponse = RequestForm;

export type FormsThirdPartyLinkCreateData = {
    formData: ThirdPartyDocumentLinkRequestRequest;
};

export type FormsThirdPartyLinkCreateResponse = ThirdPartyDocumentLinkResponse;

export type HubspotCompaniesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type HubspotCompaniesListResponse = PaginatedSuperUserHubSpotCompanyList;

export type HubspotCompaniesCreateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type HubspotCompaniesRetrieveResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesUpdateData = {
    uuid: string;
};

export type HubspotCompaniesUpdateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesPartialUpdateData = {
    uuid: string;
};

export type HubspotCompaniesPartialUpdateResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesDestroyData = {
    uuid: string;
};

export type HubspotCompaniesDestroyResponse = SuperUserHubSpotCompany;

export type HubspotCompaniesOnboardingDataRetrieveData = {
    uuid: string;
};

export type HubspotCompaniesOnboardingDataRetrieveResponse = HubSpotCompanyOnboardingData;

export type HubspotCompaniesFindForOrganisationListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * UUID of the organisation to find HubSpot companies for
     */
    organisationUuid: string;
    /**
     * A search term.
     */
    search?: string;
};

export type HubspotCompaniesFindForOrganisationListResponse = PaginatedHubSpotCompanyCandidateList;

export type HubspotContactsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type HubspotContactsListResponse = PaginatedSuperUserHubSpotContactList;

export type HubspotContactsCreateResponse = SuperUserHubSpotContact;

export type HubspotContactsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type HubspotContactsRetrieveResponse = SuperUserHubSpotContact;

export type HubspotContactsUpdateData = {
    uuid: string;
};

export type HubspotContactsUpdateResponse = SuperUserHubSpotContact;

export type HubspotContactsPartialUpdateData = {
    uuid: string;
};

export type HubspotContactsPartialUpdateResponse = SuperUserHubSpotContact;

export type HubspotContactsDestroyData = {
    uuid: string;
};

export type HubspotContactsDestroyResponse = SuperUserHubSpotContact;

export type InboundEmailsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type InboundEmailsListResponse = PaginatedTInboundEmailList;

export type InboundEmailsCreateData = {
    requestBody?: InboundEmailRequest;
};

export type InboundEmailsCreateResponse = TInboundEmail;

export type InboundEmailsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type InboundEmailsRetrieveResponse = TInboundEmail;

export type InboundEmailsUpdateData = {
    requestBody?: InboundEmailRequest;
    uuid: string;
};

export type InboundEmailsUpdateResponse = TInboundEmail;

export type InboundEmailsPartialUpdateData = {
    requestBody?: PatchedInboundEmailRequest;
    uuid: string;
};

export type InboundEmailsPartialUpdateResponse = TInboundEmail;

export type InboundEmailsDestroyData = {
    uuid: string;
};

export type InboundEmailsDestroyResponse = TInboundEmail;

export type InboundEmailsCreateCaseCreateData = {
    requestBody: CreateCaseFromInboundEmailRequest;
    uuid: string;
};

export type InboundEmailsCreateCaseCreateResponse = {
    [key: string]: unknown;
};

export type JurnodesLawCategoriesListResponse = Array<JurnodesLawCategory>;

export type JurnodesRecordSchemasListResponse = Array<JurnodesRecordSchema>;

export type JurnodesUsersListResponse = Array<JurnodesUser>;

export type KleosCaseTypesRetrieveResponse = KleosCaseTypes;

export type KleosOauthLogoutCreateResponse = unknown;

export type LawFieldsRetrieveResponse = LawFields;

export type OnboardingPackagesListData = {
    lawField?: string;
    lawTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type OnboardingPackagesListResponse = PaginatedTOnboardingPackageList;

export type OnboardingPackagesCreateData = {
    requestBody?: TOnboardingPackageRequest;
};

export type OnboardingPackagesCreateResponse = TOnboardingPackage;

export type OnboardingPackagesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type OnboardingPackagesRetrieveResponse = TOnboardingPackage;

export type OnboardingPackagesUpdateData = {
    requestBody?: TOnboardingPackageRequest;
    uuid: string;
};

export type OnboardingPackagesUpdateResponse = TOnboardingPackage;

export type OnboardingPackagesPartialUpdateData = {
    requestBody?: PatchedTOnboardingPackageRequest;
    uuid: string;
};

export type OnboardingPackagesPartialUpdateResponse = TOnboardingPackage;

export type OnboardingPackagesDestroyData = {
    uuid: string;
};

export type OnboardingPackagesDestroyResponse = TOnboardingPackage;

export type OnboardingSessionsStartFormCreateData = {
    requestBody?: StartFormRequest;
    uuid: string;
};

export type OnboardingSessionsStartFormCreateResponse = StartFormResponse;

export type OnboardingSessionsStartQuestionnaireCreateData = {
    requestBody: StartQuestionnaireRequest;
    uuid: string;
};

export type OnboardingSessionsStartQuestionnaireCreateResponse = QuestionnaireSubmission;

export type OnboardingSessionsByTokenRetrieveData = {
    /**
     * Session token to retrieve the onboarding session
     */
    sessionToken: string;
};

export type OnboardingSessionsByTokenRetrieveResponse = OnboardingPackageSessionDetail;

export type OnboardingSessionsCreateFromPackageCreateData = {
    requestBody: CreateSessionFromPackageRequest;
};

export type OnboardingSessionsCreateFromPackageCreateResponse = OnboardingPackageSession;

export type OrganisationsListData = {
    /**
     * Has HubSpot Connection
     */
    hasHubspot?: boolean;
    /**
     * Has Platform
     */
    hasPlatform?: boolean;
    /**
     * Has Stripe Connection
     */
    hasStripe?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Phonebot Type
     */
    phonebotType?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type OrganisationsListResponse = PaginatedTOrganisationList;

export type OrganisationsCreateData = {
    requestBody?: TOrganisationRequestRequest;
};

export type OrganisationsCreateResponse = TOrganisation;

export type OrganisationsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type OrganisationsRetrieveResponse = TOrganisation;

export type OrganisationsUpdateData = {
    requestBody?: TOrganisationRequestRequest;
    uuid: string;
};

export type OrganisationsUpdateResponse = TOrganisation;

export type OrganisationsPartialUpdateData = {
    requestBody?: PatchedTOrganisationRequestRequest;
    uuid: string;
};

export type OrganisationsPartialUpdateResponse = TOrganisation;

export type OrganisationsDestroyData = {
    uuid: string;
};

export type OrganisationsDestroyResponse = TOrganisation;

export type OrganisationsEmployeesListData = {
    /**
     * Has HubSpot Connection
     */
    hasHubspot?: boolean;
    /**
     * Has Platform
     */
    hasPlatform?: boolean;
    /**
     * Has Stripe Connection
     */
    hasStripe?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Phonebot Type
     */
    phonebotType?: string;
    /**
     * Filter by role. Accepts: ADMIN, LAWYER, CLERK
     */
    role?: 'ADMIN' | 'CLERK' | 'LAWYER';
    /**
     * A search term.
     */
    search?: string;
    uuid: string;
};

export type OrganisationsEmployeesListResponse = PaginatedOrganisationEmployeeList;

export type OrganisationsEmployeesRemoveCreateData = {
    employeeUuid: string;
    requestBody?: TOrganisationRequestRequest;
    uuid: string;
};

export type OrganisationsEmployeesRemoveCreateResponse = void;

export type OrganisationsEmployeesCreateCreateData = {
    formData: CreateOrganisationEmployeeRequest;
    uuid: string;
};

export type OrganisationsEmployeesCreateCreateResponse = OrganisationEmployee;

export type OrganisationsUpdateLogoCreateData = {
    formData: OrganisationLogoUpdateRequest;
    uuid: string;
};

export type OrganisationsUpdateLogoCreateResponse = unknown;

export type OrganisationsByOrgTokenRetrieveResponse = TOrganisation;

export type OrganisationsOrganisationsListListData = {
    /**
     * Has HubSpot Connection
     */
    hasHubspot?: boolean;
    /**
     * Has Platform
     */
    hasPlatform?: boolean;
    /**
     * Has Stripe Connection
     */
    hasStripe?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Phonebot Type
     */
    phonebotType?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type OrganisationsOrganisationsListListResponse = PaginatedMinimalOrganisationList;

export type PdfFormSubmissionsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type PdfFormSubmissionsListResponse = PaginatedTPDFFormSubmissionList;

export type PdfFormSubmissionsCreateData = {
    requestBody?: TPDFFormSubmissionRequest;
};

export type PdfFormSubmissionsCreateResponse = TPDFFormSubmission;

export type PdfFormSubmissionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type PdfFormSubmissionsRetrieveResponse = TPDFFormSubmission;

export type PdfFormSubmissionsUpdateData = {
    requestBody?: TPDFFormSubmissionRequest;
    uuid: string;
};

export type PdfFormSubmissionsUpdateResponse = TPDFFormSubmission;

export type PdfFormSubmissionsPartialUpdateData = {
    requestBody?: PatchedTPDFFormSubmissionRequest;
    uuid: string;
};

export type PdfFormSubmissionsPartialUpdateResponse = TPDFFormSubmission;

export type PdfFormSubmissionsDestroyData = {
    uuid: string;
};

export type PdfFormSubmissionsDestroyResponse = TPDFFormSubmission;

export type PdfFormSubmissionsByAccessTokenRetrieveData = {
    /**
     * Third-party access token for the PDF form submission
     */
    accessToken?: string;
};

export type PdfFormSubmissionsByAccessTokenRetrieveResponse = TPDFFormSubmissionWithCase;

export type PdfFormSubmissionsExternalCreateData = {
    requestBody: ExternalPDFFormSubmissionCreateRequest;
};

export type PdfFormSubmissionsExternalCreateResponse = ExternalPDFFormSubmissionResponse;

export type PdfFormTemplatesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type PdfFormTemplatesListResponse = PaginatedTPDFFormTemplateList;

export type PdfFormTemplatesCreateData = {
    requestBody?: TPDFFormTemplateRequestRequest;
};

export type PdfFormTemplatesCreateResponse = TPDFFormTemplate;

export type PdfFormTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type PdfFormTemplatesRetrieveResponse = TPDFFormTemplate;

export type PdfFormTemplatesUpdateData = {
    requestBody?: TPDFFormTemplateRequestRequest;
    uuid: string;
};

export type PdfFormTemplatesUpdateResponse = TPDFFormTemplate;

export type PdfFormTemplatesPartialUpdateData = {
    requestBody?: PatchedTPDFFormTemplateRequestRequest;
    uuid: string;
};

export type PdfFormTemplatesPartialUpdateResponse = TPDFFormTemplate;

export type PdfFormTemplatesDestroyData = {
    uuid: string;
};

export type PdfFormTemplatesDestroyResponse = TPDFFormTemplate;

export type PdfFormTemplatesCopyCreateData = {
    requestBody?: TPDFFormTemplateRequestRequest;
    uuid: string;
};

export type PdfFormTemplatesCopyCreateResponse = TPDFFormTemplate;

export type PdfFormTemplatesReplaceDocumentCreateData = {
    formData?: {
        /**
         * New PDF file
         */
        file: (Blob | File);
    };
    uuid: string;
};

export type PdfFormTemplatesReplaceDocumentCreateResponse = {
    [key: string]: unknown;
};

export type PhoneForwardingRulesListData = {
    /**
     * Filter by active status
     */
    active?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * Filter by rule type (phonenumber, entity, text)
     */
    ruleType?: string;
    /**
     * Search term for title, forwarding message, target phone number, or text context
     */
    search?: string;
};

export type PhoneForwardingRulesListResponse = PaginatedTPhoneForwardingRuleList;

export type PhoneForwardingRulesCreateData = {
    requestBody: PhoneForwardingRuleRequest;
};

export type PhoneForwardingRulesCreateResponse = PhoneForwardingRule;

export type PhoneForwardingRulesRetrieveData = {
    /**
     * Filter by active status
     */
    active?: boolean;
    /**
     * Filter by rule type (phonenumber, entity, text)
     */
    ruleType?: string;
    /**
     * Search term for title, forwarding message, target phone number, or text context
     */
    search?: string;
    /**
     * Record UUID
     */
    uuid: string;
};

export type PhoneForwardingRulesRetrieveResponse = TPhoneForwardingRule;

export type PhoneForwardingRulesUpdateData = {
    requestBody: PhoneForwardingRuleRequest;
    uuid: string;
};

export type PhoneForwardingRulesUpdateResponse = PhoneForwardingRule;

export type PhoneForwardingRulesPartialUpdateData = {
    requestBody?: PatchedPhoneForwardingRuleRequest;
    uuid: string;
};

export type PhoneForwardingRulesPartialUpdateResponse = PhoneForwardingRule;

export type PhoneForwardingRulesDestroyData = {
    uuid: string;
};

export type PhoneForwardingRulesDestroyResponse = PhoneForwardingRule;

export type PhoneNumbersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type PhoneNumbersListResponse = PaginatedTPhoneNumberList;

export type PhoneNumbersCreateData = {
    requestBody?: TPhoneNumberRequest;
};

export type PhoneNumbersCreateResponse = TPhoneNumber;

export type PhoneNumbersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type PhoneNumbersRetrieveResponse = TPhoneNumber;

export type PhoneNumbersUpdateData = {
    requestBody?: TPhoneNumberRequest;
    uuid: string;
};

export type PhoneNumbersUpdateResponse = TPhoneNumber;

export type PhoneNumbersPartialUpdateData = {
    requestBody?: PatchedTPhoneNumberRequest;
    uuid: string;
};

export type PhoneNumbersPartialUpdateResponse = TPhoneNumber;

export type PhoneNumbersDestroyData = {
    uuid: string;
};

export type PhoneNumbersDestroyResponse = TPhoneNumber;

export type PlaceholdersListResponse = Array<Placeholder>;

export type QuestionnaireSubmissionsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type QuestionnaireSubmissionsListResponse = PaginatedTQuestionnaireSubmissionList;

export type QuestionnaireSubmissionsCreateData = {
    requestBody?: TQuestionnaireSubmissionRequest;
};

export type QuestionnaireSubmissionsCreateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type QuestionnaireSubmissionsRetrieveResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsUpdateData = {
    requestBody?: TQuestionnaireSubmissionRequest;
    uuid: string;
};

export type QuestionnaireSubmissionsUpdateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsPartialUpdateData = {
    requestBody?: PatchedTQuestionnaireSubmissionRequest;
    uuid: string;
};

export type QuestionnaireSubmissionsPartialUpdateResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsDestroyData = {
    uuid: string;
};

export type QuestionnaireSubmissionsDestroyResponse = TQuestionnaireSubmission;

export type QuestionnaireSubmissionsDeleteFileDestroyData = {
    uuid: string;
};

export type QuestionnaireSubmissionsDeleteFileDestroyResponse = void;

export type QuestionnaireSubmissionsUploadFileCreateData = {
    formData: FileUploadRequest;
    uuid: string;
};

export type QuestionnaireSubmissionsUploadFileCreateResponse = FileUploadResponse;

export type QuestionnaireSubmissionsCreateExternalCreateData = {
    requestBody: ExternalQuestionnaireSubmissionCreateRequest;
};

export type QuestionnaireSubmissionsCreateExternalCreateResponse = ExternalQuestionnaireSubmissionResponse;

export type QuestionnairesListData = {
    isJupusTemplate?: boolean;
    lawField?: string;
    lawTopic?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
};

export type QuestionnairesListResponse = PaginatedTQuestionnaireList;

export type QuestionnairesCreateData = {
    requestBody?: TQuestionnaireRequest;
};

export type QuestionnairesCreateResponse = TQuestionnaire;

export type QuestionnairesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type QuestionnairesRetrieveResponse = TQuestionnaire;

export type QuestionnairesUpdateData = {
    requestBody?: TQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesUpdateResponse = TQuestionnaire;

export type QuestionnairesPartialUpdateData = {
    requestBody?: PatchedTQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesPartialUpdateResponse = TQuestionnaire;

export type QuestionnairesDestroyData = {
    uuid: string;
};

export type QuestionnairesDestroyResponse = TQuestionnaire;

export type QuestionnairesCopyCreateData = {
    requestBody?: TQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesCopyCreateResponse = TQuestionnaire;

export type QuestionnairesGenerateCreateData = {
    formData?: QuestionnaireGenerateRequest;
    uuid: string;
};

export type QuestionnairesGenerateCreateResponse = TQuestionnaire;

export type QuestionnairesGenerateTitleCreateData = {
    requestBody?: TQuestionnaireRequest;
    uuid: string;
};

export type QuestionnairesGenerateTitleCreateResponse = TQuestionnaire;

export type QuestionnairesThirdPartyCreateData = {
    requestBody: ThirdPartyQuestionnaireSubmissionCreateRequest;
};

export type QuestionnairesThirdPartyCreateResponse = QuestionnaireSubmission;

export type RetellAgentsListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * A search term.
     */
    search?: string;
};

export type RetellAgentsListResponse = PaginatedTRetellAgentList;

export type RetellAgentsCreateData = {
    requestBody?: TRetellAgentRequest;
};

export type RetellAgentsCreateResponse = TRetellAgent;

export type RetellAgentsRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type RetellAgentsRetrieveResponse = TRetellAgent;

export type RetellAgentsUpdateData = {
    requestBody?: TRetellAgentRequest;
    uuid: string;
};

export type RetellAgentsUpdateResponse = TRetellAgent;

export type RetellAgentsPartialUpdateData = {
    requestBody?: PatchedTRetellAgentRequest;
    uuid: string;
};

export type RetellAgentsPartialUpdateResponse = TRetellAgent;

export type RetellAgentsDestroyData = {
    uuid: string;
};

export type RetellAgentsDestroyResponse = TRetellAgent;

export type SavedResponsesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Order results by field
     */
    ordering?: '-created_at' | '-title' | 'created_at' | 'title';
    /**
     * Search in title and content
     */
    search?: string;
    /**
     * Filter by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
};

export type SavedResponsesListResponse = PaginatedTSavedResponseList;

export type SavedResponsesCreateData = {
    requestBody?: TSavedResponseRequest;
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
};

export type SavedResponsesCreateResponse = TSavedResponse;

export type SavedResponsesRetrieveData = {
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
    /**
     * Record UUID
     */
    uuid: string;
};

export type SavedResponsesRetrieveResponse = TSavedResponse;

export type SavedResponsesUpdateData = {
    requestBody?: TSavedResponseRequest;
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
    uuid: string;
};

export type SavedResponsesUpdateResponse = TSavedResponse;

export type SavedResponsesPartialUpdateData = {
    requestBody?: PatchedTSavedResponseRequest;
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
    uuid: string;
};

export type SavedResponsesPartialUpdateResponse = TSavedResponse;

export type SavedResponsesDestroyData = {
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
    uuid: string;
};

export type SavedResponsesDestroyResponse = TSavedResponse;

export type SavedResponsesGenerateTitleCreateData = {
    requestBody: GenerateTitleRequestRequest;
    /**
     * Filter saved responses by session type
     */
    sessionType?: 'CASE' | 'GLOBAL';
};

export type SavedResponsesGenerateTitleCreateResponse = GenerateTitleResponse;

export type ServicesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    orgSlug?: string;
};

export type ServicesListResponse = PaginatedTServiceList;

export type ServicesCreateData = {
    requestBody?: TServiceRequest;
};

export type ServicesCreateResponse = TService;

export type ServicesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type ServicesRetrieveResponse = TService;

export type ServicesUpdateData = {
    requestBody?: TServiceRequest;
    uuid: string;
};

export type ServicesUpdateResponse = TService;

export type ServicesPartialUpdateData = {
    requestBody?: PatchedTServiceRequest;
    uuid: string;
};

export type ServicesPartialUpdateResponse = TService;

export type ServicesDestroyData = {
    uuid: string;
};

export type ServicesDestroyResponse = TService;

export type ServicesAvailabilitiesCreateData = {
    calendarSlug: string;
    requestBody?: TServiceRequest;
    uuid: string;
};

export type ServicesAvailabilitiesCreateResponse = TService;

export type SettingsActaportListResponse = Array<ActaportSettings>;

export type SettingsActaportCreateData = {
    requestBody?: ActaportSettingsRequest;
};

export type SettingsActaportCreateResponse = ActaportSettings;

export type SettingsActaportSyncUpdateResponse = unknown;

export type SettingsAdvoluxListResponse = Array<AdvoluxSettings>;

export type SettingsAdvoluxCreateData = {
    requestBody?: AdvoluxSettingsRequest;
};

export type SettingsAdvoluxCreateResponse = AdvoluxSettings;

export type SettingsAdvowareListResponse = Array<AdvowareSettings>;

export type SettingsAdvowareCreateData = {
    requestBody?: AdvowareSettingsRequest;
};

export type SettingsAdvowareCreateResponse = AdvowareSettings;

export type SettingsAdvowareSyncUpdateResponse = unknown;

export type SettingsEmailEgressListResponse = Array<EmailEgressSettings>;

export type SettingsEmailEgressCreateData = {
    requestBody?: EmailEgressSettingsRequest;
};

export type SettingsEmailEgressCreateResponse = EmailEgressSettings;

export type SettingsHibpListResponse = Array<HibpSettings>;

export type SettingsHibpCreateData = {
    requestBody?: HibpSettingsRequest;
};

export type SettingsHibpCreateResponse = HibpSettings;

export type SettingsHubspotListResponse = Array<HubspotSettings>;

export type SettingsHubspotCreateData = {
    requestBody?: HubspotSettingsRequest;
};

export type SettingsHubspotCreateResponse = HubspotSettings;

export type SettingsIustaListResponse = Array<IustaSettings>;

export type SettingsIustaCreateData = {
    requestBody?: IustaSettingsRequest;
};

export type SettingsIustaCreateResponse = IustaSettings;

export type SettingsJurnodesListResponse = Array<JurnodesSettings>;

export type SettingsJurnodesCreateData = {
    requestBody?: JurnodesSettingsRequest;
};

export type SettingsJurnodesCreateResponse = JurnodesSettings;

export type SettingsJurnodesSyncUpdateResponse = unknown;

export type SettingsKleosListResponse = Array<KleosSettings>;

export type SettingsKleosCreateData = {
    requestBody?: KleosSettingsRequest;
};

export type SettingsKleosCreateResponse = KleosSettings;

export type SettingsLawfirmListResponse = Array<LawfirmSettings>;

export type SettingsLawfirmCreateData = {
    requestBody?: LawfirmSettingsRequest;
};

export type SettingsLawfirmCreateResponse = LawfirmSettings;

export type SettingsWebhooksListResponse = Array<WebhooksSettings>;

export type SettingsWebhooksCreateData = {
    requestBody?: WebhooksSettingsRequest;
};

export type SettingsWebhooksCreateResponse = WebhooksSettings;

export type StaleDocumentsListData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
};

export type StaleDocumentsListResponse = PaginatedDocumentList;

export type StaleDocumentsCreateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
};

export type StaleDocumentsCreateResponse = Document;

export type StaleDocumentsRetrieveData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsRetrieveResponse = Document;

export type StaleDocumentsUpdateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsUpdateResponse = Document;

export type StaleDocumentsPartialUpdateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsPartialUpdateResponse = Document;

export type StaleDocumentsDestroyData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsDestroyResponse = void;

export type StaleDocumentsMarkCompletedCreateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsMarkCompletedCreateResponse = Document;

export type StaleDocumentsMarkFailedCreateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsMarkFailedCreateResponse = Document;

export type StaleDocumentsRetryProcessingCreateData = {
    /**
     * Filter by case UUID
     */
    caseId?: string;
    /**
     * End date for filtering stale documents (YYYY-MM-DD)
     */
    endDate?: string;
    /**
     * Number of hours to look back for stale documents (default: 24)
     */
    hours?: string;
    /**
     * Filter by organization UUID
     */
    orgId?: string;
    /**
     * Show documents with errors instead of stale documents (default: false)
     */
    showErrored?: boolean;
    /**
     * Minutes after which a document is considered stale (default: 15)
     */
    staleThresholdMinutes?: number;
    /**
     * Start date for filtering stale documents (YYYY-MM-DD)
     */
    startDate?: string;
    uuid: string;
};

export type StaleDocumentsRetryProcessingCreateResponse = Document;

export type StripeCustomersListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type StripeCustomersListResponse = PaginatedTStripeCustomerList;

export type StripeCustomersCreateData = {
    requestBody: StripeCustomerCreateRequest;
};

export type StripeCustomersCreateResponse = SuperUserStripeCustomer;

export type StripeCustomersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type StripeCustomersRetrieveResponse = TStripeCustomer;

export type StripeCustomersUpdateData = {
    requestBody?: TStripeCustomerRequest;
    uuid: string;
};

export type StripeCustomersUpdateResponse = TStripeCustomer;

export type StripeCustomersPartialUpdateData = {
    requestBody?: PatchedTStripeCustomerRequest;
    uuid: string;
};

export type StripeCustomersPartialUpdateResponse = TStripeCustomer;

export type StripeCustomersDestroyData = {
    uuid: string;
};

export type StripeCustomersDestroyResponse = TStripeCustomer;

export type StripeInvoicesListData = {
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
};

export type StripeInvoicesListResponse = PaginatedTStripeInvoiceList;

export type StripeInvoicesCreateData = {
    requestBody?: TStripeInvoiceRequest;
};

export type StripeInvoicesCreateResponse = TStripeInvoice;

export type StripeInvoicesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type StripeInvoicesRetrieveResponse = TStripeInvoice;

export type StripeInvoicesUpdateData = {
    requestBody?: TStripeInvoiceRequest;
    uuid: string;
};

export type StripeInvoicesUpdateResponse = TStripeInvoice;

export type StripeInvoicesPartialUpdateData = {
    requestBody?: PatchedTStripeInvoiceRequest;
    uuid: string;
};

export type StripeInvoicesPartialUpdateResponse = TStripeInvoice;

export type StripeInvoicesDestroyData = {
    uuid: string;
};

export type StripeInvoicesDestroyResponse = TStripeInvoice;

export type StripeInvoicesExportCreateData = {
    requestBody: StripeInvoiceExportRequestRequest;
};

export type StripeInvoicesExportCreateResponse = StripeInvoiceExportResponse;

export type UnifiedDocumentTemplatesListData = {
    /**
     * Number of results per page
     */
    limit?: number;
    /**
     * Starting position
     */
    offset?: number;
    /**
     * Order by field (prefix with - for descending). Options: created_at, modified_at, title
     */
    ordering?: string;
    /**
     * Search in title/name and description
     */
    search?: string;
};

export type UnifiedDocumentTemplatesListResponse = PaginatedUnifiedDocumentTemplateList;

export type UnifiedDocumentTemplatesPartialUpdateData = {
    id: string;
    requestBody?: PatchedUnifiedDocumentTemplateRequest;
};

export type UnifiedDocumentTemplatesPartialUpdateResponse = UnifiedDocumentTemplate;

export type UnifiedDocumentTemplatesDestroyData = {
    id: string;
};

export type UnifiedDocumentTemplatesDestroyResponse = void;

export type UnifiedDocumentTemplatesThirdPartyTokenRetrieveData = {
    id: string;
};

export type UnifiedDocumentTemplatesThirdPartyTokenRetrieveResponse = ThirdPartyDocumentCreationTokenResponse;

export type UsersListData = {
    /**
     * Filter by user active status. Defaults to true. Only SUPERUSERs may set false; other roles are restricted to active users only.
     */
    isActive?: boolean;
    /**
     * Filter by superuser status
     */
    isSuperuser?: boolean;
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Search by email, first name, last name, or UUID
     */
    search?: string;
};

export type UsersListResponse = PaginatedTUserList;

export type UsersCreateData = {
    requestBody?: TUserRequest;
};

export type UsersCreateResponse = TUser;

export type UsersRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type UsersRetrieveResponse = TUser;

export type UsersUpdateData = {
    requestBody?: TUserRequest;
    uuid: string;
};

export type UsersUpdateResponse = TUser;

export type UsersPartialUpdateData = {
    requestBody?: PatchedTUserRequest;
    uuid: string;
};

export type UsersPartialUpdateResponse = TUser;

export type UsersDestroyData = {
    uuid: string;
};

export type UsersDestroyResponse = TUser;

export type UsersAdminPasswordUpdatePartialUpdateData = {
    requestBody?: PatchedAdminPasswordUpdateRequest;
    uuid: string;
};

export type UsersAdminPasswordUpdatePartialUpdateResponse = void;

export type UsersUpdateAvatarCreateData = {
    formData: UserAvatarUpdateRequest;
    uuid: string;
};

export type UsersUpdateAvatarCreateResponse = TUser;

export type UsersChangePasswordCreateData = {
    requestBody: ChangePasswordRequest;
};

export type UsersChangePasswordCreateResponse = ChangePasswordResponse;

export type WordDocumentTemplatesListData = {
    /**
     * * `Allgemein` - Allgemein
     * * `Arbeitsrecht` - Arbeitsrecht
     * * `Asylrecht` - Asylrecht
     * * `Ausländerrecht` - Ausländerrecht
     * * `Bankrecht` - Bankrecht
     * * `Baurecht` - Baurecht
     * * `Beamtenrecht` - Beamtenrecht
     * * `Bewertungen löschen` - Bewertungen löschen
     * * `Casino` - Casino
     * * `Coaching` - Coaching
     * * `Compliance` - Compliance
     * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
     * * `Datenleck` - Datenleck
     * * `Erbrecht` - Erbrecht
     * * `Familienrecht` - Familienrecht
     * * `Gesellschaftsrecht` - Gesellschaftsrecht
     * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
     * * `Hochschulrecht` - Hochschulrecht
     * * `Immobilienrecht` - Immobilienrecht
     * * `Inkasso` - Inkasso
     * * `IT Recht` - IT Recht
     * * `Insolvenzberatung` - Insolvenzberatung
     * * `Markenrecht` - Markenrecht
     * * `Medien-und Presserecht` - Medien-und Presserecht
     * * `Medizinrecht` - Medizinrecht
     * * `Mietrecht` - Mietrecht
     * * `Migrationsrecht` - Migrationsrecht
     * * `Musikrecht` - Musikrecht
     * * `Notariat` - Notariat
     * * `Personenschäden` - Personenschäden
     * * `Schufa` - Schufa
     * * `Schulrecht` - Schulrecht
     * * `Social Media Recht` - Social Media Recht
     * * `Sozialrecht` - Sozialrecht
     * * `Steuerberatung` - Steuerberatung
     * * `Steuerrecht` - Steuerrecht
     * * `Strafrecht` - Strafrecht
     * * `Tesla_Widerruf` - Tesla_Widerruf
     * * `Tierrecht` - Tierrecht
     * * `Verkehrsrecht` - Verkehrsrecht
     * * `Versicherungsrecht` - Versicherungsrecht
     * * `Verwaltungsrecht` - Verwaltungsrecht
     * * `Wegrecht` - Wegrecht
     * * `Zivilrecht` - Zivilrecht
     */
    lawField?: 'Allgemein' | 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'IT Recht' | 'Immobilienrecht' | 'Inkasso' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Medizinrecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: 'approved' | 'draft' | 'in_review';
};

export type WordDocumentTemplatesListResponse = PaginatedTWordDocumentTemplateList;

export type WordDocumentTemplatesCreateData = {
    formData?: TWordDocumentTemplateRequest;
};

export type WordDocumentTemplatesCreateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesRetrieveData = {
    /**
     * Record UUID
     */
    uuid: string;
};

export type WordDocumentTemplatesRetrieveResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesUpdateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesUpdateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesPartialUpdateData = {
    formData?: PatchedTWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesPartialUpdateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesDestroyData = {
    uuid: string;
};

export type WordDocumentTemplatesDestroyResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesCopyCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesCopyCreateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesCopyAiToCurrentCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesCopyAiToCurrentCreateResponse = {
    [key: string]: unknown;
};

export type WordDocumentTemplatesCreateEditTokenCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesCreateEditTokenCreateResponse = {
    [key: string]: unknown;
};

export type WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData = {
    requestBody: CreateWordDocumentPreviewBlobRequest;
    uuid: string;
};

export type WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateResponse = (Blob | File);

export type WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData = {
    requestBody: CreateWordDocumentTemplateDocxWithPlaceholdersRequest;
    uuid: string;
};

export type WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateResponse = (Blob | File);

export type WordDocumentTemplatesDeleteDocumentCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesDeleteDocumentCreateResponse = TWordDocumentTemplate;

export type WordDocumentTemplatesExtractMetadataCreateData = {
    uuid: string;
};

export type WordDocumentTemplatesExtractMetadataCreateResponse = ExtractedMetadata;

export type WordDocumentTemplatesResetToOriginalCreateData = {
    formData?: TWordDocumentTemplateRequest;
    uuid: string;
};

export type WordDocumentTemplatesResetToOriginalCreateResponse = {
    [key: string]: unknown;
};

export type WordDocumentTemplatesValidateRetrieveData = {
    /**
     * Force refresh validation data from the template, ignoring cache
     */
    forceRefresh?: boolean;
    /**
     * Whether to use the AI-generated template for validation
     */
    useAiTemplate?: boolean;
    uuid: string;
};

export type WordDocumentTemplatesValidateRetrieveResponse = ValidationDataResponse;

export type WordDocumentTemplatesValidateCreateData = {
    requestBody?: ValidatePostRequestRequest;
    uuid: string;
};

export type WordDocumentTemplatesValidateCreateResponse = GenerateDocumentResponse;

export type WordDocumentTemplatesValidatePartialUpdateData = {
    requestBody?: PatchedUpdateValidationDataRequestRequest;
    uuid: string;
};

export type WordDocumentTemplatesValidatePartialUpdateResponse = UpdateValidationDataResponse;

export type WordDocumentTemplatesBulkUploadCreateData = {
    formData: BulkUploadRequest;
    /**
     * * `Allgemein` - Allgemein
     * * `Arbeitsrecht` - Arbeitsrecht
     * * `Asylrecht` - Asylrecht
     * * `Ausländerrecht` - Ausländerrecht
     * * `Bankrecht` - Bankrecht
     * * `Baurecht` - Baurecht
     * * `Beamtenrecht` - Beamtenrecht
     * * `Bewertungen löschen` - Bewertungen löschen
     * * `Casino` - Casino
     * * `Coaching` - Coaching
     * * `Compliance` - Compliance
     * * `Corona Überbrückungshilfe` - Corona Überbrückungshilfe
     * * `Datenleck` - Datenleck
     * * `Erbrecht` - Erbrecht
     * * `Familienrecht` - Familienrecht
     * * `Gesellschaftsrecht` - Gesellschaftsrecht
     * * `Gewerblicher Rechtsschutz/Urheberrecht` - Gewerblicher Rechtsschutz/Urheberrecht
     * * `Hochschulrecht` - Hochschulrecht
     * * `Immobilienrecht` - Immobilienrecht
     * * `Inkasso` - Inkasso
     * * `IT Recht` - IT Recht
     * * `Insolvenzberatung` - Insolvenzberatung
     * * `Markenrecht` - Markenrecht
     * * `Medien-und Presserecht` - Medien-und Presserecht
     * * `Medizinrecht` - Medizinrecht
     * * `Mietrecht` - Mietrecht
     * * `Migrationsrecht` - Migrationsrecht
     * * `Musikrecht` - Musikrecht
     * * `Notariat` - Notariat
     * * `Personenschäden` - Personenschäden
     * * `Schufa` - Schufa
     * * `Schulrecht` - Schulrecht
     * * `Social Media Recht` - Social Media Recht
     * * `Sozialrecht` - Sozialrecht
     * * `Steuerberatung` - Steuerberatung
     * * `Steuerrecht` - Steuerrecht
     * * `Strafrecht` - Strafrecht
     * * `Tesla_Widerruf` - Tesla_Widerruf
     * * `Tierrecht` - Tierrecht
     * * `Verkehrsrecht` - Verkehrsrecht
     * * `Versicherungsrecht` - Versicherungsrecht
     * * `Verwaltungsrecht` - Verwaltungsrecht
     * * `Wegrecht` - Wegrecht
     * * `Zivilrecht` - Zivilrecht
     */
    lawField?: 'Allgemein' | 'Arbeitsrecht' | 'Asylrecht' | 'Ausländerrecht' | 'Bankrecht' | 'Baurecht' | 'Beamtenrecht' | 'Bewertungen löschen' | 'Casino' | 'Coaching' | 'Compliance' | 'Corona Überbrückungshilfe' | 'Datenleck' | 'Erbrecht' | 'Familienrecht' | 'Gesellschaftsrecht' | 'Gewerblicher Rechtsschutz/Urheberrecht' | 'Hochschulrecht' | 'IT Recht' | 'Immobilienrecht' | 'Inkasso' | 'Insolvenzberatung' | 'Markenrecht' | 'Medien-und Presserecht' | 'Medizinrecht' | 'Mietrecht' | 'Migrationsrecht' | 'Musikrecht' | 'Notariat' | 'Personenschäden' | 'Schufa' | 'Schulrecht' | 'Social Media Recht' | 'Sozialrecht' | 'Steuerberatung' | 'Steuerrecht' | 'Strafrecht' | 'Tesla_Widerruf' | 'Tierrecht' | 'Verkehrsrecht' | 'Versicherungsrecht' | 'Verwaltungsrecht' | 'Wegrecht' | 'Zivilrecht';
    /**
     * Number of results to return per page.
     */
    limit?: number;
    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;
    /**
     * A search term.
     */
    search?: string;
    /**
     * Current status of the template in the review workflow
     *
     * * `draft` - Draft
     * * `in_review` - In Review
     * * `approved` - Approved
     */
    status?: 'approved' | 'draft' | 'in_review';
};

export type WordDocumentTemplatesBulkUploadCreateResponse = PaginatedWordDocumentTemplateList;

export type WordDocumentTemplatesTaskStatusRetrieveData = {
    taskId: string;
};

export type WordDocumentTemplatesTaskStatusRetrieveResponse = {
    [key: string]: unknown;
};

export type $OpenApiTs = {
    '/api/v3/accounts/': {
        get: {
            req: AccountsListData;
            res: {
                200: PaginatedTAccountList;
            };
        };
        post: {
            req: AccountsCreateData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/accounts/{uuid}/': {
        get: {
            req: AccountsRetrieveData;
            res: {
                200: TAccount;
            };
        };
        put: {
            req: AccountsUpdateData;
            res: {
                200: TAccount;
            };
        };
        patch: {
            req: AccountsPartialUpdateData;
            res: {
                200: TAccount;
            };
        };
        delete: {
            req: AccountsDestroyData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/accounts/{uuid}/availability_token/': {
        get: {
            req: AccountsAvailabilityTokenRetrieveData;
            res: {
                200: TAccount;
            };
        };
    };
    '/api/v3/actaport_party_matching/find-matches/': {
        post: {
            req: ActaportPartyMatchingFindMatchesCreateData;
            res: {
                200: ActaportPartyMatchingResponse;
                400: IntegrationError;
                403: IntegrationError;
            };
        };
    };
    '/api/v3/action_auto_commit_settings/': {
        get: {
            req: ActionAutoCommitSettingsListData;
            res: {
                200: PaginatedTActionAutoCommitSettingsList;
            };
        };
        post: {
            req: ActionAutoCommitSettingsCreateData;
            res: {
                200: TActionAutoCommitSettings;
            };
        };
    };
    '/api/v3/action_auto_commit_settings/{uuid}/': {
        get: {
            req: ActionAutoCommitSettingsRetrieveData;
            res: {
                200: TActionAutoCommitSettings;
            };
        };
        put: {
            req: ActionAutoCommitSettingsUpdateData;
            res: {
                200: TActionAutoCommitSettings;
            };
        };
        patch: {
            req: ActionAutoCommitSettingsPartialUpdateData;
            res: {
                200: TActionAutoCommitSettings;
            };
        };
        delete: {
            req: ActionAutoCommitSettingsDestroyData;
            res: {
                200: TActionAutoCommitSettings;
            };
        };
    };
    '/api/v3/action_auto_commit_settings/available-actions/': {
        get: {
            res: {
                /**
                 * No response body
                 */
                200: unknown;
            };
        };
    };
    '/api/v3/activities/': {
        get: {
            req: ActivitiesListData;
            res: {
                200: PaginatedTActivityList;
            };
        };
        post: {
            req: ActivitiesCreateData;
            res: {
                200: TActivity;
            };
        };
    };
    '/api/v3/activities/{uuid}/': {
        get: {
            req: ActivitiesRetrieveData;
            res: {
                200: TActivity;
            };
        };
        put: {
            req: ActivitiesUpdateData;
            res: {
                200: TActivity;
            };
        };
        patch: {
            req: ActivitiesPartialUpdateData;
            res: {
                200: TActivity;
            };
        };
        delete: {
            req: ActivitiesDestroyData;
            res: {
                200: TActivity;
            };
        };
    };
    '/api/v3/activities/{uuid}/mark-seen/': {
        post: {
            req: ActivitiesMarkSeenCreateData;
            res: {
                200: TActivity;
            };
        };
    };
    '/api/v3/activities/{uuid}/mark-unseen/': {
        post: {
            req: ActivitiesMarkUnseenCreateData;
            res: {
                200: TActivity;
            };
        };
    };
    '/api/v3/activities/unseen-count/': {
        get: {
            res: {
                200: {
                    unseen_count?: number;
                };
            };
        };
    };
    '/api/v3/advoware_roles/get-role-mappings/': {
        post: {
            req: AdvowareRolesGetRoleMappingsCreateData;
            res: {
                200: Array<AdvowareRoleMapping>;
            };
        };
    };
    '/api/v3/agent_actions/': {
        get: {
            req: AgentActionsListData;
            res: {
                200: PaginatedTAgentActionList;
            };
        };
        post: {
            req: AgentActionsCreateData;
            res: {
                200: TAgentAction;
            };
        };
    };
    '/api/v3/agent_actions/{uuid}/': {
        get: {
            req: AgentActionsRetrieveData;
            res: {
                200: TAgentAction;
            };
        };
        put: {
            req: AgentActionsUpdateData;
            res: {
                200: TAgentAction;
            };
        };
        patch: {
            req: AgentActionsPartialUpdateData;
            res: {
                200: TAgentAction;
            };
        };
        delete: {
            req: AgentActionsDestroyData;
            res: {
                200: TAgentAction;
            };
        };
    };
    '/api/v3/agent_actions/case-create-instructions-advisory/': {
        post: {
            req: AgentActionsCaseCreateInstructionsAdvisoryCreateData;
            res: {
                200: CaseCreateInstructionsAdvisoryResponse;
                400: unknown;
                403: unknown;
                500: unknown;
            };
        };
    };
    '/api/v3/agent_actions/commit/': {
        post: {
            req: AgentActionsCommitCreateData;
            res: {
                200: unknown;
                400: unknown;
                403: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/agent_actions/rate/': {
        post: {
            req: AgentActionsRateCreateData;
            res: {
                200: unknown;
                400: unknown;
                403: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/agent_actions/revert/': {
        post: {
            req: AgentActionsRevertCreateData;
            res: {
                200: unknown;
                400: unknown;
                403: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/ai_analysis/': {
        get: {
            req: AiAnalysisListData;
            res: {
                200: PaginatedTAiAnalysisList;
            };
        };
        post: {
            req: AiAnalysisCreateData;
            res: {
                200: TAiAnalysis;
            };
        };
    };
    '/api/v3/ai_analysis/{uuid}/': {
        get: {
            req: AiAnalysisRetrieveData;
            res: {
                200: TAiAnalysis;
            };
        };
        put: {
            req: AiAnalysisUpdateData;
            res: {
                200: TAiAnalysis;
            };
        };
        patch: {
            req: AiAnalysisPartialUpdateData;
            res: {
                200: TAiAnalysis;
            };
        };
        delete: {
            req: AiAnalysisDestroyData;
            res: {
                200: TAiAnalysis;
            };
        };
    };
    '/api/v3/ai_analysis/by-document-uuid/{document_uuid}/': {
        get: {
            req: AiAnalysisByDocumentUuidListData;
            res: {
                200: PaginatedTAiAnalysisList;
            };
        };
    };
    '/api/v3/ai_augmentation/': {
        get: {
            req: AiAugmentationListData;
            res: {
                200: PaginatedTAiAugmentationList;
            };
        };
        post: {
            req: AiAugmentationCreateData;
            res: {
                200: TAiAugmentation;
            };
        };
    };
    '/api/v3/ai_augmentation/{uuid}/': {
        get: {
            req: AiAugmentationRetrieveData;
            res: {
                200: TAiAugmentation;
            };
        };
        put: {
            req: AiAugmentationUpdateData;
            res: {
                200: TAiAugmentation;
            };
        };
        patch: {
            req: AiAugmentationPartialUpdateData;
            res: {
                200: TAiAugmentation;
            };
        };
        delete: {
            req: AiAugmentationDestroyData;
            res: {
                200: TAiAugmentation;
            };
        };
    };
    '/api/v3/ai_augmentation/by-document-uuid/{document_uuid}/': {
        get: {
            req: AiAugmentationByDocumentUuidListData;
            res: {
                200: PaginatedTAiAugmentationList;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/': {
        get: {
            req: AiChatQuestionTemplatesListData;
            res: {
                200: PaginatedTAiChatQuestionTemplateList;
            };
        };
        post: {
            req: AiChatQuestionTemplatesCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/': {
        get: {
            req: AiChatQuestionTemplatesRetrieveData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        put: {
            req: AiChatQuestionTemplatesUpdateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        patch: {
            req: AiChatQuestionTemplatesPartialUpdateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
        delete: {
            req: AiChatQuestionTemplatesDestroyData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/copy/': {
        post: {
            req: AiChatQuestionTemplatesCopyCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/favorite/': {
        post: {
            req: AiChatQuestionTemplatesFavoriteCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/{uuid}/unfavorite/': {
        post: {
            req: AiChatQuestionTemplatesUnfavoriteCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_question_templates/generate-description/': {
        post: {
            req: AiChatQuestionTemplatesGenerateDescriptionCreateData;
            res: {
                200: TAiChatQuestionTemplate;
            };
        };
    };
    '/api/v3/ai_chat_session_groups/': {
        get: {
            req: AiChatSessionGroupsListData;
            res: {
                200: PaginatedSessionGroupList;
            };
        };
        post: {
            req: AiChatSessionGroupsCreateData;
            res: {
                201: SessionGroup;
            };
        };
    };
    '/api/v3/ai_chat_session_groups/{uuid}/': {
        get: {
            req: AiChatSessionGroupsRetrieveData;
            res: {
                200: SessionGroup;
            };
        };
        put: {
            req: AiChatSessionGroupsUpdateData;
            res: {
                200: SessionGroup;
            };
        };
        patch: {
            req: AiChatSessionGroupsPartialUpdateData;
            res: {
                200: SessionGroup;
            };
        };
        delete: {
            req: AiChatSessionGroupsDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/ai_chat_session_groups/{uuid}/chat_sessions/': {
        get: {
            req: AiChatSessionGroupsChatSessionsRetrieveData;
            res: {
                200: SessionGroup;
            };
        };
    };
    '/api/v3/ai_chat_session_groups/{uuid}/create_chat_session/': {
        post: {
            req: AiChatSessionGroupsCreateChatSessionCreateData;
            res: {
                200: SessionGroup;
            };
        };
    };
    '/api/v3/ai_chat_sessions/': {
        get: {
            req: AiChatSessionsListData;
            res: {
                200: PaginatedTAIChatSessionList;
            };
        };
        post: {
            req: AiChatSessionsCreateData;
            res: {
                200: TAIChatSession;
            };
        };
    };
    '/api/v3/ai_chat_sessions/{uuid}/': {
        get: {
            req: AiChatSessionsRetrieveData;
            res: {
                200: TAIChatSession;
            };
        };
        put: {
            req: AiChatSessionsUpdateData;
            res: {
                200: TAIChatSession;
            };
        };
        patch: {
            req: AiChatSessionsPartialUpdateData;
            res: {
                200: TAIChatSession;
            };
        };
        delete: {
            req: AiChatSessionsDestroyData;
            res: {
                200: TAIChatSession;
            };
        };
    };
    '/api/v3/ai_chat_sessions/{uuid}/export_pdf/': {
        post: {
            req: AiChatSessionsExportPdfCreateData;
            res: {
                200: TAIChatSession;
            };
        };
    };
    '/api/v3/ai_chat_sessions/{uuid}/send_message/': {
        post: {
            req: AiChatSessionsSendMessageCreateData;
            res: {
                200: AIChatSessionSendMessageResponse;
            };
        };
    };
    '/api/v3/ai_chat_sessions/enhance_prompt/': {
        post: {
            req: AiChatSessionsEnhancePromptCreateData;
            res: {
                200: AIChatSessionEnhancePromptResponse;
            };
        };
    };
    '/api/v3/ai_settings/': {
        get: {
            req: AiSettingsListData;
            res: {
                200: PaginatedTAiSettingsList;
            };
        };
        post: {
            req: AiSettingsCreateData;
            res: {
                200: TAiSettings;
            };
        };
    };
    '/api/v3/ai_settings/{uuid}/': {
        get: {
            req: AiSettingsRetrieveData;
            res: {
                200: TAiSettings;
            };
        };
        put: {
            req: AiSettingsUpdateData;
            res: {
                200: TAiSettings;
            };
        };
        patch: {
            req: AiSettingsPartialUpdateData;
            res: {
                200: TAiSettings;
            };
        };
        delete: {
            req: AiSettingsDestroyData;
            res: {
                200: TAiSettings;
            };
        };
    };
    '/api/v3/ai_settings/available-actions/': {
        get: {
            res: {
                /**
                 * No response body
                 */
                200: unknown;
            };
        };
    };
    '/api/v3/ai_settings/available-notification-actions/': {
        get: {
            res: {
                200: NotificationSettings;
            };
        };
    };
    '/api/v3/announcements/': {
        get: {
            req: AnnouncementsListData;
            res: {
                200: PaginatedTAnnouncementList;
            };
        };
        post: {
            req: AnnouncementsCreateData;
            res: {
                200: TAnnouncement;
            };
        };
    };
    '/api/v3/announcements/{uuid}/': {
        get: {
            req: AnnouncementsRetrieveData;
            res: {
                200: TAnnouncement;
            };
        };
        put: {
            req: AnnouncementsUpdateData;
            res: {
                200: TAnnouncement;
            };
        };
        patch: {
            req: AnnouncementsPartialUpdateData;
            res: {
                200: TAnnouncement;
            };
        };
        delete: {
            req: AnnouncementsDestroyData;
            res: {
                200: TAnnouncement;
            };
        };
    };
    '/api/v3/announcements/active/': {
        get: {
            req: AnnouncementsActiveListData;
            res: {
                200: PaginatedTActiveAnnouncementList;
            };
        };
    };
    '/api/v3/appointment_proposals/': {
        get: {
            req: AppointmentProposalsListData;
            res: {
                200: PaginatedTAppointmentProposalList;
            };
        };
        post: {
            req: AppointmentProposalsCreateData;
            res: {
                200: TAppointmentProposal;
            };
        };
    };
    '/api/v3/appointment_proposals/{uuid}/': {
        get: {
            req: AppointmentProposalsRetrieveData;
            res: {
                200: TAppointmentProposal;
            };
        };
        put: {
            req: AppointmentProposalsUpdateData;
            res: {
                200: TAppointmentProposal;
            };
        };
        patch: {
            req: AppointmentProposalsPartialUpdateData;
            res: {
                200: TAppointmentProposal;
            };
        };
        delete: {
            req: AppointmentProposalsDestroyData;
            res: {
                200: TAppointmentProposal;
            };
        };
    };
    '/api/v3/appointment_settings/': {
        get: {
            res: {
                200: AppointmentSettings;
                403: {
                    [key: string]: unknown;
                };
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/appointments/': {
        get: {
            req: AppointmentsListData;
            res: {
                200: PaginatedTAppointmentList;
            };
        };
        post: {
            req: AppointmentsCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/{uuid}/': {
        get: {
            req: AppointmentsRetrieveData;
            res: {
                200: TAppointment;
            };
        };
        put: {
            req: AppointmentsUpdateData;
            res: {
                200: TAppointment;
            };
        };
        patch: {
            req: AppointmentsPartialUpdateData;
            res: {
                200: TAppointment;
            };
        };
        delete: {
            req: AppointmentsDestroyData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/{uuid}/cancel/': {
        post: {
            req: AppointmentsCancelCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/{uuid}/confirm/': {
        post: {
            req: AppointmentsConfirmCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/appointments/create_case_appointment/': {
        post: {
            req: AppointmentsCreateCaseAppointmentCreateData;
            res: {
                200: TAppointment;
            };
        };
    };
    '/api/v3/calendars/': {
        get: {
            req: CalendarsListData;
            res: {
                200: PaginatedTCalendarList;
            };
        };
        post: {
            req: CalendarsCreateData;
            res: {
                200: TCalendar;
            };
        };
    };
    '/api/v3/calendars/{uuid}/': {
        get: {
            req: CalendarsRetrieveData;
            res: {
                200: TCalendar;
            };
        };
        put: {
            req: CalendarsUpdateData;
            res: {
                200: TCalendar;
            };
        };
        patch: {
            req: CalendarsPartialUpdateData;
            res: {
                200: TCalendar;
            };
        };
        delete: {
            req: CalendarsDestroyData;
            res: {
                200: TCalendar;
            };
        };
    };
    '/api/v3/calls/': {
        get: {
            req: CallsListData;
            res: {
                200: PaginatedTCallList;
            };
        };
        post: {
            req: CallsCreateData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/{uuid}/': {
        get: {
            req: CallsRetrieveData;
            res: {
                200: TCall;
            };
        };
        put: {
            req: CallsUpdateData;
            res: {
                200: TCall;
            };
        };
        patch: {
            req: CallsPartialUpdateData;
            res: {
                200: TCall;
            };
        };
        delete: {
            req: CallsDestroyData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/{uuid}/create_case/': {
        post: {
            req: CallsCreateCaseCreateData;
            res: {
                200: TCall;
            };
        };
    };
    '/api/v3/calls/{uuid}/gemini-shadow-comparison/': {
        post: {
            req: CallsGeminiShadowComparisonCreateData;
            res: {
                201: GeminiShadowComparison;
            };
        };
    };
    '/api/v3/calls/lawyer_feedback/': {
        get: {
            req: CallsLawyerFeedbackListData;
            res: {
                200: PaginatedTLawyerFeedbackList;
            };
        };
        post: {
            req: CallsLawyerFeedbackCreateData;
            res: {
                200: TLawyerFeedback;
            };
        };
    };
    '/api/v3/calls/lawyer_feedback/{uuid}/': {
        get: {
            req: CallsLawyerFeedbackRetrieveData;
            res: {
                200: TLawyerFeedback;
            };
        };
        put: {
            req: CallsLawyerFeedbackUpdateData;
            res: {
                200: TLawyerFeedback;
            };
        };
        patch: {
            req: CallsLawyerFeedbackPartialUpdateData;
            res: {
                200: TLawyerFeedback;
            };
        };
        delete: {
            req: CallsLawyerFeedbackDestroyData;
            res: {
                200: TLawyerFeedback;
            };
        };
    };
    '/api/v3/case_creation_integration/': {
        post: {
            req: CaseCreationIntegrationCreateData;
            res: {
                200: ExternalIntegrationFileDownloadResponse;
                201: ExternalIntegrationCaseCreationResponse;
            };
        };
    };
    '/api/v3/case_creator_temp_documents/': {
        get: {
            req: CaseCreatorTempDocumentsListData;
            res: {
                200: PaginatedTCaseCreatorTempDocumentList;
            };
        };
        post: {
            req: CaseCreatorTempDocumentsCreateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
    };
    '/api/v3/case_creator_temp_documents/{uuid}/': {
        get: {
            req: CaseCreatorTempDocumentsRetrieveData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        put: {
            req: CaseCreatorTempDocumentsUpdateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        patch: {
            req: CaseCreatorTempDocumentsPartialUpdateData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
        delete: {
            req: CaseCreatorTempDocumentsDestroyData;
            res: {
                200: TCaseCreatorTempDocument;
            };
        };
    };
    '/api/v3/case_lifecycle_state_reasoning/': {
        get: {
            req: CaseLifecycleStateReasoningListData;
            res: {
                200: PaginatedTCaseLifecycleStateReasoningList;
            };
        };
    };
    '/api/v3/case_lifecycle_state_reasoning/{uuid}/': {
        get: {
            req: CaseLifecycleStateReasoningRetrieveData;
            res: {
                200: TCaseLifecycleStateReasoning;
            };
        };
    };
    '/api/v3/case_lifecycle_states/': {
        get: {
            req: CaseLifecycleStatesListData;
            res: {
                200: PaginatedTCaseLifecycleStateList;
            };
        };
        post: {
            req: CaseLifecycleStatesCreateData;
            res: {
                200: TCaseLifecycleState;
            };
        };
    };
    '/api/v3/case_lifecycle_states/{uuid}/': {
        get: {
            req: CaseLifecycleStatesRetrieveData;
            res: {
                200: TCaseLifecycleState;
            };
        };
        put: {
            req: CaseLifecycleStatesUpdateData;
            res: {
                200: TCaseLifecycleState;
            };
        };
        patch: {
            req: CaseLifecycleStatesPartialUpdateData;
            res: {
                200: TCaseLifecycleState;
            };
        };
        delete: {
            req: CaseLifecycleStatesDestroyData;
            res: {
                200: TCaseLifecycleState;
            };
        };
    };
    '/api/v3/case_lifecycle_states/{uuid}/advance/': {
        post: {
            req: CaseLifecycleStatesAdvanceCreateData;
            res: {
                200: TCaseLifecycleState;
            };
        };
    };
    '/api/v3/case_lifecycle_states/{uuid}/rate/': {
        post: {
            req: CaseLifecycleStatesRateCreateData;
            res: {
                200: unknown;
                400: unknown;
                403: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/case_lifecycle_workflows/': {
        get: {
            req: CaseLifecycleWorkflowsListData;
            res: {
                200: PaginatedTCaseLifecycleWorkflowList;
            };
        };
        post: {
            req: CaseLifecycleWorkflowsCreateData;
            res: {
                200: TCaseLifecycleWorkflow;
            };
        };
    };
    '/api/v3/case_lifecycle_workflows/{uuid}/': {
        get: {
            req: CaseLifecycleWorkflowsRetrieveData;
            res: {
                200: TCaseLifecycleWorkflow;
            };
        };
        put: {
            req: CaseLifecycleWorkflowsUpdateData;
            res: {
                200: TCaseLifecycleWorkflow;
            };
        };
        patch: {
            req: CaseLifecycleWorkflowsPartialUpdateData;
            res: {
                200: TCaseLifecycleWorkflow;
            };
        };
        delete: {
            req: CaseLifecycleWorkflowsDestroyData;
            res: {
                200: TCaseLifecycleWorkflow;
            };
        };
    };
    '/api/v3/case_lifecycle_workflows/available-actions/': {
        get: {
            res: {
                /**
                 * No response body
                 */
                200: unknown;
            };
        };
    };
    '/api/v3/cases/': {
        get: {
            req: CasesListData;
            res: {
                200: PaginatedTCaseList;
            };
        };
        post: {
            req: CasesCreateData;
            res: {
                201: TCase;
            };
        };
    };
    '/api/v3/cases/{uuid}/': {
        get: {
            req: CasesRetrieveData;
            res: {
                200: TCase;
            };
        };
        put: {
            req: CasesUpdateData;
            res: {
                200: TCase;
            };
        };
        patch: {
            req: CasesPartialUpdateData;
            res: {
                200: TCase;
            };
        };
        delete: {
            req: CasesDestroyData;
            res: {
                200: TCase;
            };
        };
    };
    '/api/v3/cases/{uuid}/ai-summary/': {
        post: {
            req: CasesAiSummaryCreateData;
            res: {
                /**
                 * Streaming response that delivers chunks of the AI-generated summary incrementally in `text/plain` format. Clients should consume the response progressively.
                 */
                200: string;
            };
        };
    };
    '/api/v3/cases/{uuid}/appointment-proposals/': {
        get: {
            req: CasesAppointmentProposalsRetrieveData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/cases/{uuid}/appointments/': {
        get: {
            req: CasesAppointmentsListData;
            res: {
                200: PaginatedCaseAppointmentsList;
            };
        };
    };
    '/api/v3/cases/{uuid}/assign-workflow/': {
        patch: {
            req: CasesAssignWorkflowPartialUpdateData;
            res: {
                200: TAssignWorkflowResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document/': {
        post: {
            req: CasesCreateWordDocumentCreateData;
            res: {
                200: CreateWordDocumentResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document_from_placeholder_values/': {
        post: {
            req: CasesCreateWordDocumentFromPlaceholderValuesCreateData;
            res: {
                200: CreateWordDocumentFromPlaceholderValuesResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/create_word_document_preview_blob/': {
        post: {
            req: CasesCreateWordDocumentPreviewBlobCreateData;
            res: {
                200: (Blob | File);
            };
        };
    };
    '/api/v3/cases/{uuid}/documents/': {
        get: {
            req: CasesDocumentsListData;
            res: {
                200: PaginatedDocumentList;
            };
        };
    };
    '/api/v3/cases/{uuid}/download-documents-zip/': {
        get: {
            req: CasesDownloadDocumentsZipRetrieveData;
            res: {
                200: unknown;
            };
        };
    };
    '/api/v3/cases/{uuid}/find_word_document_template_placeholder_values/': {
        post: {
            req: CasesFindWordDocumentTemplatePlaceholderValuesCreateData;
            res: {
                200: FindWordDocumentTemplatePlaceholderValuesResponse;
            };
        };
    };
    '/api/v3/cases/{uuid}/generate_document_html_stream/': {
        post: {
            req: CasesGenerateDocumentHtmlStreamCreateData;
            res: {
                /**
                 * Streaming response that delivers chunks of the document incrementally in `text/plain` format. Clients should consume the response progressively.
                 */
                200: string;
            };
        };
    };
    '/api/v3/cases/{uuid}/send_email/': {
        post: {
            req: CasesSendEmailCreateData;
            res: {
                200: SendCaseEmailResponse;
            };
        };
    };
    '/api/v3/cases/by-access-token/': {
        get: {
            req: CasesByAccessTokenRetrieveData;
            res: {
                200: TCase;
            };
        };
    };
    '/api/v3/cases/generic_datamappers/': {
        get: {
            req: CasesGenericDatamappersListData;
            res: {
                200: PaginatedTGenericDataMapperList;
            };
        };
    };
    '/api/v3/cases/state-counts/': {
        get: {
            req: CasesStateCountsRetrieveData;
            res: {
                200: CaseStateCounts;
            };
        };
    };
    '/api/v3/chat_preferences/': {
        get: {
            req: ChatPreferencesListData;
            res: {
                200: PaginatedTChatPreferenceList;
            };
        };
        post: {
            req: ChatPreferencesCreateData;
            res: {
                200: TChatPreference;
            };
        };
    };
    '/api/v3/chat_preferences/{uuid}/': {
        get: {
            req: ChatPreferencesRetrieveData;
            res: {
                200: TChatPreference;
            };
        };
        put: {
            req: ChatPreferencesUpdateData;
            res: {
                200: TChatPreference;
            };
        };
        patch: {
            req: ChatPreferencesPartialUpdateData;
            res: {
                200: TChatPreference;
            };
        };
        delete: {
            req: ChatPreferencesDestroyData;
            res: {
                200: TChatPreference;
            };
        };
    };
    '/api/v3/chat_preferences/dismiss-suggestion/': {
        post: {
            req: ChatPreferencesDismissSuggestionCreateData;
            res: {
                200: TChatPreference;
            };
        };
    };
    '/api/v3/chat_preferences/generate-title/': {
        post: {
            req: ChatPreferencesGenerateTitleCreateData;
            res: {
                200: TChatPreference;
            };
        };
    };
    '/api/v3/chat_preferences/save-suggestion/': {
        post: {
            req: ChatPreferencesSaveSuggestionCreateData;
            res: {
                200: TChatPreference;
            };
        };
    };
    '/api/v3/delivery_events/': {
        get: {
            req: DeliveryEventsListData;
            res: {
                200: PaginatedTDeliveryEventList;
            };
        };
        post: {
            req: DeliveryEventsCreateData;
            res: {
                200: TDeliveryEvent;
            };
        };
    };
    '/api/v3/delivery_events/{uuid}/': {
        get: {
            req: DeliveryEventsRetrieveData;
            res: {
                200: TDeliveryEvent;
            };
        };
        put: {
            req: DeliveryEventsUpdateData;
            res: {
                200: TDeliveryEvent;
            };
        };
        patch: {
            req: DeliveryEventsPartialUpdateData;
            res: {
                200: TDeliveryEvent;
            };
        };
        delete: {
            req: DeliveryEventsDestroyData;
            res: {
                200: TDeliveryEvent;
            };
        };
    };
    '/api/v3/document_placeholders/': {
        get: {
            req: DocumentPlaceholdersListData;
            res: {
                200: PaginatedDocumentPlaceholderList;
            };
        };
        post: {
            req: DocumentPlaceholdersCreateData;
            res: {
                201: DocumentPlaceholder;
            };
        };
    };
    '/api/v3/document_placeholders/{uuid}/': {
        get: {
            req: DocumentPlaceholdersRetrieveData;
            res: {
                200: DocumentPlaceholder;
            };
        };
        put: {
            req: DocumentPlaceholdersUpdateData;
            res: {
                200: DocumentPlaceholderUpdate;
            };
        };
        patch: {
            req: DocumentPlaceholdersPartialUpdateData;
            res: {
                200: DocumentPlaceholderUpdate;
            };
        };
        delete: {
            req: DocumentPlaceholdersDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/document_placeholders/generate_labels/': {
        post: {
            req: DocumentPlaceholdersGenerateLabelsCreateData;
            res: {
                200: DocumentPlaceholderLabelsResponse;
            };
        };
    };
    '/api/v3/document_templates/': {
        get: {
            req: DocumentTemplatesListData;
            res: {
                200: PaginatedTDocumentTemplateList;
            };
        };
        post: {
            req: DocumentTemplatesCreateData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/document_templates/{uuid}/': {
        get: {
            req: DocumentTemplatesRetrieveData;
            res: {
                200: TDocumentTemplate;
            };
        };
        put: {
            req: DocumentTemplatesUpdateData;
            res: {
                200: TDocumentTemplate;
            };
        };
        patch: {
            req: DocumentTemplatesPartialUpdateData;
            res: {
                200: TDocumentTemplate;
            };
        };
        delete: {
            req: DocumentTemplatesDestroyData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/document_templates/{uuid}/copy/': {
        post: {
            req: DocumentTemplatesCopyCreateData;
            res: {
                200: TDocumentTemplate;
            };
        };
    };
    '/api/v3/documents/': {
        get: {
            req: DocumentsListData;
            res: {
                200: PaginatedTDocumentList;
            };
        };
        post: {
            req: DocumentsCreateData;
            res: {
                200: TDocument;
            };
        };
    };
    '/api/v3/documents/{case_uuid}/bulk-sync-platforms/': {
        post: {
            req: DocumentsBulkSyncPlatformsCreateData;
            res: {
                202: BulkSyncDocumentsResponse;
                400: BulkSyncDocumentsResponse;
            };
        };
    };
    '/api/v3/documents/{case_uuid}/import-from-actaport/': {
        post: {
            req: DocumentsImportFromActaportCreateData;
            res: {
                202: ImportDocumentResponse;
                400: ImportDocumentResponse;
            };
        };
    };
    '/api/v3/documents/{case_uuid}/refresh-actaport-documents/': {
        post: {
            req: DocumentsRefreshActaportDocumentsCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{case_uuid}/upload/': {
        post: {
            req: DocumentsUploadCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{uuid}/': {
        get: {
            req: DocumentsRetrieveData;
            res: {
                200: TDocument;
            };
        };
        put: {
            req: DocumentsUpdateData;
            res: {
                200: TDocument;
            };
        };
        patch: {
            req: DocumentsPartialUpdateData;
            res: {
                200: TDocument;
            };
        };
        delete: {
            req: DocumentsDestroyData;
            res: {
                200: TDocument;
            };
        };
    };
    '/api/v3/documents/{uuid}/create-edit-token/': {
        post: {
            req: DocumentsCreateEditTokenCreateData;
            res: {
                201: DocumentEditTokenResponse;
            };
        };
    };
    '/api/v3/documents/{uuid}/generate-title/': {
        post: {
            req: DocumentsGenerateTitleCreateData;
            res: {
                200: GenerateTitleResponse;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{uuid}/retry-processing/': {
        post: {
            req: DocumentsRetryProcessingCreateData;
            res: {
                200: TDocument;
            };
        };
    };
    '/api/v3/documents/{uuid}/revert-to-original/': {
        post: {
            req: DocumentsRevertToOriginalCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{uuid}/send-to-actaport/': {
        post: {
            req: DocumentsSendToActaportCreateData;
            res: {
                200: SendToActaportResponse;
                202: SendToActaportResponse;
                400: SendToActaportError;
            };
        };
    };
    '/api/v3/documents/{uuid}/thumbnails/': {
        get: {
            req: DocumentsThumbnailsRetrieveData;
            res: {
                200: DocumentThumbnails;
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/{uuid}/upload-modified/': {
        post: {
            req: DocumentsUploadModifiedCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/chat-session-group/{group_uuid}/upload/': {
        post: {
            req: DocumentsChatSessionGroupUploadCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/chat-session/{session_uuid}/upload/': {
        post: {
            req: DocumentsChatSessionUploadCreateData;
            res: {
                200: Document;
                400: {
                    [key: string]: unknown;
                };
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/reorganize/': {
        post: {
            req: DocumentsReorganizeCreateData;
            res: {
                200: DocumentReorganizationResponse;
                400: DocumentReorganizationErrorResponse;
                404: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/documents/split-with-ai/': {
        post: {
            req: DocumentsSplitWithAiCreateData;
            res: {
                200: DocumentSplitWithAIResponse;
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/editor/upload': {
        post: {
            req: EditorUploadCreateData;
            res: {
                201: EditorUploadResponse;
                /**
                 * No response body
                 */
                400: unknown;
                /**
                 * No response body
                 */
                403: unknown;
            };
        };
    };
    '/api/v3/email_templates/': {
        get: {
            req: EmailTemplatesListData;
            res: {
                200: PaginatedTEmailTemplateList;
            };
        };
        post: {
            req: EmailTemplatesCreateData;
            res: {
                200: TEmailTemplate;
            };
        };
    };
    '/api/v3/email_templates/{uuid}/': {
        get: {
            req: EmailTemplatesRetrieveData;
            res: {
                200: TEmailTemplate;
            };
        };
        put: {
            req: EmailTemplatesUpdateData;
            res: {
                200: TEmailTemplate;
            };
        };
        patch: {
            req: EmailTemplatesPartialUpdateData;
            res: {
                200: TEmailTemplate;
            };
        };
        delete: {
            req: EmailTemplatesDestroyData;
            res: {
                200: TEmailTemplate;
            };
        };
    };
    '/api/v3/emails/': {
        get: {
            req: EmailsListData;
            res: {
                200: PaginatedTEmailList;
            };
        };
        post: {
            req: EmailsCreateData;
            res: {
                200: TEmail;
            };
        };
    };
    '/api/v3/emails/{id}/': {
        get: {
            req: EmailsRetrieveData;
            res: {
                200: TEmail;
            };
        };
        put: {
            req: EmailsUpdateData;
            res: {
                200: TEmail;
            };
        };
        patch: {
            req: EmailsPartialUpdateData;
            res: {
                200: TEmail;
            };
        };
        delete: {
            req: EmailsDestroyData;
            res: {
                200: TEmail;
            };
        };
    };
    '/api/v3/emails/render_template/': {
        post: {
            req: EmailsRenderTemplateCreateData;
            res: {
                200: EmailRenderTemplateResponse;
            };
        };
    };
    '/api/v3/entities/': {
        get: {
            req: EntitiesListData;
            res: {
                200: PaginatedTEntityList;
            };
        };
        post: {
            req: EntitiesCreateData;
            res: {
                200: TEntity;
            };
        };
    };
    '/api/v3/entities/{uuid}/': {
        get: {
            req: EntitiesRetrieveData;
            res: {
                200: TEntity;
            };
        };
        put: {
            req: EntitiesUpdateData;
            res: {
                200: TEntity;
            };
        };
        patch: {
            req: EntitiesPartialUpdateData;
            res: {
                200: TEntity;
            };
        };
        delete: {
            req: EntitiesDestroyData;
            res: {
                200: TEntity;
            };
        };
    };
    '/api/v3/entities/{uuid}/add_case_data_relationship/': {
        post: {
            req: EntitiesAddCaseDataRelationshipCreateData;
            res: {
                200: TEntityWithRelationship;
            };
        };
    };
    '/api/v3/entities/{uuid}/remove_case_data_relationship/': {
        post: {
            req: EntitiesRemoveCaseDataRelationshipCreateData;
            res: {
                200: TEntityRemoveCaseDataRelationshipResponse;
            };
        };
    };
    '/api/v3/entities/switch_unique_case_data_relationship/': {
        post: {
            req: EntitiesSwitchUniqueCaseDataRelationshipCreateData;
            res: {
                200: TSwitchUniqueCaseDataRelationshipResponse;
            };
        };
    };
    '/api/v3/event/': {
        post: {
            req: EventCreateData;
            res: {
                /**
                 * No response body
                 */
                201: unknown;
            };
        };
    };
    '/api/v3/events/': {
        get: {
            req: EventsListData;
            res: {
                200: PaginatedGenericMetricEventList;
            };
        };
        post: {
            req: EventsCreateData;
            res: {
                201: GenericMetricEvent;
            };
        };
    };
    '/api/v3/events/{uuid}/': {
        get: {
            req: EventsRetrieveData;
            res: {
                200: GenericMetricEvent;
            };
        };
        put: {
            req: EventsUpdateData;
            res: {
                200: GenericMetricEvent;
            };
        };
        patch: {
            req: EventsPartialUpdateData;
            res: {
                200: GenericMetricEvent;
            };
        };
        delete: {
            req: EventsDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/events/track/': {
        post: {
            req: EventsTrackCreateData;
            res: {
                201: {
                    status?: string;
                };
            };
        };
    };
    '/api/v3/feature_flags/check/': {
        post: {
            req: FeatureFlagsCheckCreateData;
            res: {
                200: FeatureFlagCheckResponse;
                400: {
                    [key: string]: unknown;
                };
                403: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/feature_flags/check_by_access_token/': {
        post: {
            req: FeatureFlagsCheckByAccessTokenCreateData;
            res: {
                200: FeatureFlagCheckResponse;
                400: {
                    [key: string]: unknown;
                };
                403: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/feedback/': {
        get: {
            req: FeedbackListData;
            res: {
                200: PaginatedTFeedbackList;
            };
        };
        post: {
            req: FeedbackCreateData;
            res: {
                200: TFeedback;
            };
        };
    };
    '/api/v3/feedback/{uuid}/': {
        get: {
            req: FeedbackRetrieveData;
            res: {
                200: TFeedback;
            };
        };
        put: {
            req: FeedbackUpdateData;
            res: {
                200: TFeedback;
            };
        };
        patch: {
            req: FeedbackPartialUpdateData;
            res: {
                200: TFeedback;
            };
        };
        delete: {
            req: FeedbackDestroyData;
            res: {
                200: TFeedback;
            };
        };
    };
    '/api/v3/forms/': {
        get: {
            req: FormsListData;
            res: {
                200: PaginatedTFormList;
            };
        };
        post: {
            req: FormsCreateData;
            res: {
                200: TForm;
            };
        };
    };
    '/api/v3/forms/{id}/': {
        get: {
            req: FormsRetrieveData;
            res: {
                200: TForm;
            };
        };
        put: {
            req: FormsUpdateData;
            res: {
                200: TForm;
            };
        };
        patch: {
            req: FormsPartialUpdateData;
            res: {
                200: TForm;
            };
        };
        delete: {
            req: FormsDestroyData;
            res: {
                200: TForm;
            };
        };
    };
    '/api/v3/forms/{id}/third-party-token/': {
        get: {
            req: FormsThirdPartyTokenRetrieveData;
            res: {
                200: ThirdPartyDocumentCreationTokenResponse;
            };
        };
    };
    '/api/v3/forms/pdf-form/{token}/': {
        get: {
            req: FormsPdfFormRetrieveData;
            res: {
                200: RequestForm;
            };
        };
    };
    '/api/v3/forms/pdf-form/{token}/submit/': {
        post: {
            req: FormsPdfFormSubmitCreateData;
            res: {
                200: RequestForm;
            };
        };
    };
    '/api/v3/forms/third-party/link/': {
        post: {
            req: FormsThirdPartyLinkCreateData;
            res: {
                200: ThirdPartyDocumentLinkResponse;
            };
        };
    };
    '/api/v3/hubspot/companies/': {
        get: {
            req: HubspotCompaniesListData;
            res: {
                200: PaginatedSuperUserHubSpotCompanyList;
            };
        };
        post: {
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
    };
    '/api/v3/hubspot/companies/{uuid}/': {
        get: {
            req: HubspotCompaniesRetrieveData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        put: {
            req: HubspotCompaniesUpdateData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        patch: {
            req: HubspotCompaniesPartialUpdateData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
        delete: {
            req: HubspotCompaniesDestroyData;
            res: {
                200: SuperUserHubSpotCompany;
            };
        };
    };
    '/api/v3/hubspot/companies/{uuid}/onboarding-data/': {
        get: {
            req: HubspotCompaniesOnboardingDataRetrieveData;
            res: {
                200: HubSpotCompanyOnboardingData;
            };
        };
    };
    '/api/v3/hubspot/companies/find-for-organisation/': {
        get: {
            req: HubspotCompaniesFindForOrganisationListData;
            res: {
                200: PaginatedHubSpotCompanyCandidateList;
            };
        };
    };
    '/api/v3/hubspot/contacts/': {
        get: {
            req: HubspotContactsListData;
            res: {
                200: PaginatedSuperUserHubSpotContactList;
            };
        };
        post: {
            res: {
                200: SuperUserHubSpotContact;
            };
        };
    };
    '/api/v3/hubspot/contacts/{uuid}/': {
        get: {
            req: HubspotContactsRetrieveData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        put: {
            req: HubspotContactsUpdateData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        patch: {
            req: HubspotContactsPartialUpdateData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
        delete: {
            req: HubspotContactsDestroyData;
            res: {
                200: SuperUserHubSpotContact;
            };
        };
    };
    '/api/v3/inbound_emails/': {
        get: {
            req: InboundEmailsListData;
            res: {
                200: PaginatedTInboundEmailList;
            };
        };
        post: {
            req: InboundEmailsCreateData;
            res: {
                200: TInboundEmail;
            };
        };
    };
    '/api/v3/inbound_emails/{uuid}/': {
        get: {
            req: InboundEmailsRetrieveData;
            res: {
                200: TInboundEmail;
            };
        };
        put: {
            req: InboundEmailsUpdateData;
            res: {
                200: TInboundEmail;
            };
        };
        patch: {
            req: InboundEmailsPartialUpdateData;
            res: {
                200: TInboundEmail;
            };
        };
        delete: {
            req: InboundEmailsDestroyData;
            res: {
                200: TInboundEmail;
            };
        };
    };
    '/api/v3/inbound_emails/{uuid}/create_case/': {
        post: {
            req: InboundEmailsCreateCaseCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/jurnodes/law-categories/': {
        get: {
            res: {
                200: Array<JurnodesLawCategory>;
            };
        };
    };
    '/api/v3/jurnodes/record-schemas/': {
        get: {
            res: {
                200: Array<JurnodesRecordSchema>;
            };
        };
    };
    '/api/v3/jurnodes/users/': {
        get: {
            res: {
                200: Array<JurnodesUser>;
            };
        };
    };
    '/api/v3/kleos/case-types/': {
        get: {
            res: {
                200: KleosCaseTypes;
                400: IntegrationError;
                403: IntegrationError;
            };
        };
    };
    '/api/v3/kleos_oauth/authorize/': {
        get: {
            res: {
                /**
                 * No response body
                 */
                302: unknown;
            };
        };
    };
    '/api/v3/kleos_oauth/logout/': {
        post: {
            res: {
                /**
                 * No response body
                 */
                200: unknown;
            };
        };
    };
    '/api/v3/law_fields/': {
        get: {
            res: {
                200: LawFields;
            };
        };
    };
    '/api/v3/onboarding_packages/': {
        get: {
            req: OnboardingPackagesListData;
            res: {
                200: PaginatedTOnboardingPackageList;
            };
        };
        post: {
            req: OnboardingPackagesCreateData;
            res: {
                200: TOnboardingPackage;
            };
        };
    };
    '/api/v3/onboarding_packages/{uuid}/': {
        get: {
            req: OnboardingPackagesRetrieveData;
            res: {
                200: TOnboardingPackage;
            };
        };
        put: {
            req: OnboardingPackagesUpdateData;
            res: {
                200: TOnboardingPackage;
            };
        };
        patch: {
            req: OnboardingPackagesPartialUpdateData;
            res: {
                200: TOnboardingPackage;
            };
        };
        delete: {
            req: OnboardingPackagesDestroyData;
            res: {
                200: TOnboardingPackage;
            };
        };
    };
    '/api/v3/onboarding_sessions/{uuid}/start-form/': {
        post: {
            req: OnboardingSessionsStartFormCreateData;
            res: {
                201: StartFormResponse;
            };
        };
    };
    '/api/v3/onboarding_sessions/{uuid}/start-questionnaire/': {
        post: {
            req: OnboardingSessionsStartQuestionnaireCreateData;
            res: {
                201: QuestionnaireSubmission;
            };
        };
    };
    '/api/v3/onboarding_sessions/by-token/': {
        get: {
            req: OnboardingSessionsByTokenRetrieveData;
            res: {
                200: OnboardingPackageSessionDetail;
            };
        };
    };
    '/api/v3/onboarding_sessions/create-from-package/': {
        post: {
            req: OnboardingSessionsCreateFromPackageCreateData;
            res: {
                201: OnboardingPackageSession;
            };
        };
    };
    '/api/v3/organisations/': {
        get: {
            req: OrganisationsListData;
            res: {
                200: PaginatedTOrganisationList;
            };
        };
        post: {
            req: OrganisationsCreateData;
            res: {
                200: TOrganisation;
            };
        };
    };
    '/api/v3/organisations/{uuid}/': {
        get: {
            req: OrganisationsRetrieveData;
            res: {
                200: TOrganisation;
            };
        };
        put: {
            req: OrganisationsUpdateData;
            res: {
                200: TOrganisation;
            };
        };
        patch: {
            req: OrganisationsPartialUpdateData;
            res: {
                200: TOrganisation;
            };
        };
        delete: {
            req: OrganisationsDestroyData;
            res: {
                200: TOrganisation;
            };
        };
    };
    '/api/v3/organisations/{uuid}/employees/': {
        get: {
            req: OrganisationsEmployeesListData;
            res: {
                200: PaginatedOrganisationEmployeeList;
                403: unknown;
            };
        };
    };
    '/api/v3/organisations/{uuid}/employees/{employee_uuid}/remove/': {
        post: {
            req: OrganisationsEmployeesRemoveCreateData;
            res: {
                /**
                 * No response body
                 */
                204: void;
                400: {
                    detail?: string;
                };
                403: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/organisations/{uuid}/employees/create/': {
        post: {
            req: OrganisationsEmployeesCreateCreateData;
            res: {
                201: OrganisationEmployee;
                400: {
                    email?: Array<(string)>;
                    password?: Array<(string)>;
                };
                403: unknown;
            };
        };
    };
    '/api/v3/organisations/{uuid}/update-logo/': {
        post: {
            req: OrganisationsUpdateLogoCreateData;
            res: {
                /**
                 * No response body
                 */
                200: unknown;
                400: {
                    logo?: Array<(string)>;
                };
            };
        };
    };
    '/api/v3/organisations/by-org-token/': {
        get: {
            res: {
                200: TOrganisation;
            };
        };
    };
    '/api/v3/organisations/organisations-list/': {
        get: {
            req: OrganisationsOrganisationsListListData;
            res: {
                200: PaginatedMinimalOrganisationList;
            };
        };
    };
    '/api/v3/pdf_form_submissions/': {
        get: {
            req: PdfFormSubmissionsListData;
            res: {
                200: PaginatedTPDFFormSubmissionList;
            };
        };
        post: {
            req: PdfFormSubmissionsCreateData;
            res: {
                200: TPDFFormSubmission;
            };
        };
    };
    '/api/v3/pdf_form_submissions/{uuid}/': {
        get: {
            req: PdfFormSubmissionsRetrieveData;
            res: {
                200: TPDFFormSubmission;
            };
        };
        put: {
            req: PdfFormSubmissionsUpdateData;
            res: {
                200: TPDFFormSubmission;
            };
        };
        patch: {
            req: PdfFormSubmissionsPartialUpdateData;
            res: {
                200: TPDFFormSubmission;
            };
        };
        delete: {
            req: PdfFormSubmissionsDestroyData;
            res: {
                200: TPDFFormSubmission;
            };
        };
    };
    '/api/v3/pdf_form_submissions/by-access-token/': {
        get: {
            req: PdfFormSubmissionsByAccessTokenRetrieveData;
            res: {
                200: TPDFFormSubmissionWithCase;
                400: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/pdf_form_submissions/external/': {
        post: {
            req: PdfFormSubmissionsExternalCreateData;
            res: {
                201: ExternalPDFFormSubmissionResponse;
                400: unknown;
                404: unknown;
            };
        };
    };
    '/api/v3/pdf_form_templates/': {
        get: {
            req: PdfFormTemplatesListData;
            res: {
                200: PaginatedTPDFFormTemplateList;
            };
        };
        post: {
            req: PdfFormTemplatesCreateData;
            res: {
                200: TPDFFormTemplate;
            };
        };
    };
    '/api/v3/pdf_form_templates/{uuid}/': {
        get: {
            req: PdfFormTemplatesRetrieveData;
            res: {
                200: TPDFFormTemplate;
            };
        };
        put: {
            req: PdfFormTemplatesUpdateData;
            res: {
                200: TPDFFormTemplate;
            };
        };
        patch: {
            req: PdfFormTemplatesPartialUpdateData;
            res: {
                200: TPDFFormTemplate;
            };
        };
        delete: {
            req: PdfFormTemplatesDestroyData;
            res: {
                200: TPDFFormTemplate;
            };
        };
    };
    '/api/v3/pdf_form_templates/{uuid}/copy/': {
        post: {
            req: PdfFormTemplatesCopyCreateData;
            res: {
                200: TPDFFormTemplate;
            };
        };
    };
    '/api/v3/pdf_form_templates/{uuid}/replace-document/': {
        post: {
            req: PdfFormTemplatesReplaceDocumentCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/phone_forwarding_rules/': {
        get: {
            req: PhoneForwardingRulesListData;
            res: {
                200: PaginatedTPhoneForwardingRuleList;
            };
        };
        post: {
            req: PhoneForwardingRulesCreateData;
            res: {
                201: PhoneForwardingRule;
            };
        };
    };
    '/api/v3/phone_forwarding_rules/{uuid}/': {
        get: {
            req: PhoneForwardingRulesRetrieveData;
            res: {
                200: TPhoneForwardingRule;
            };
        };
        put: {
            req: PhoneForwardingRulesUpdateData;
            res: {
                200: PhoneForwardingRule;
            };
        };
        patch: {
            req: PhoneForwardingRulesPartialUpdateData;
            res: {
                200: PhoneForwardingRule;
            };
        };
        delete: {
            req: PhoneForwardingRulesDestroyData;
            res: {
                200: PhoneForwardingRule;
            };
        };
    };
    '/api/v3/phone_numbers/': {
        get: {
            req: PhoneNumbersListData;
            res: {
                200: PaginatedTPhoneNumberList;
            };
        };
        post: {
            req: PhoneNumbersCreateData;
            res: {
                200: TPhoneNumber;
            };
        };
    };
    '/api/v3/phone_numbers/{uuid}/': {
        get: {
            req: PhoneNumbersRetrieveData;
            res: {
                200: TPhoneNumber;
            };
        };
        put: {
            req: PhoneNumbersUpdateData;
            res: {
                200: TPhoneNumber;
            };
        };
        patch: {
            req: PhoneNumbersPartialUpdateData;
            res: {
                200: TPhoneNumber;
            };
        };
        delete: {
            req: PhoneNumbersDestroyData;
            res: {
                200: TPhoneNumber;
            };
        };
    };
    '/api/v3/placeholders': {
        get: {
            res: {
                200: Array<Placeholder>;
            };
        };
    };
    '/api/v3/questionnaire_submissions/': {
        get: {
            req: QuestionnaireSubmissionsListData;
            res: {
                200: PaginatedTQuestionnaireSubmissionList;
            };
        };
        post: {
            req: QuestionnaireSubmissionsCreateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
    };
    '/api/v3/questionnaire_submissions/{uuid}/': {
        get: {
            req: QuestionnaireSubmissionsRetrieveData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        put: {
            req: QuestionnaireSubmissionsUpdateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        patch: {
            req: QuestionnaireSubmissionsPartialUpdateData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
        delete: {
            req: QuestionnaireSubmissionsDestroyData;
            res: {
                200: TQuestionnaireSubmission;
            };
        };
    };
    '/api/v3/questionnaire_submissions/{uuid}/delete-file/': {
        delete: {
            req: QuestionnaireSubmissionsDeleteFileDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/questionnaire_submissions/{uuid}/upload-file/': {
        post: {
            req: QuestionnaireSubmissionsUploadFileCreateData;
            res: {
                200: FileUploadResponse;
            };
        };
    };
    '/api/v3/questionnaire_submissions/create_external/': {
        post: {
            req: QuestionnaireSubmissionsCreateExternalCreateData;
            res: {
                201: ExternalQuestionnaireSubmissionResponse;
            };
        };
    };
    '/api/v3/questionnaires/': {
        get: {
            req: QuestionnairesListData;
            res: {
                200: PaginatedTQuestionnaireList;
            };
        };
        post: {
            req: QuestionnairesCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/': {
        get: {
            req: QuestionnairesRetrieveData;
            res: {
                200: TQuestionnaire;
            };
        };
        put: {
            req: QuestionnairesUpdateData;
            res: {
                200: TQuestionnaire;
            };
        };
        patch: {
            req: QuestionnairesPartialUpdateData;
            res: {
                200: TQuestionnaire;
            };
        };
        delete: {
            req: QuestionnairesDestroyData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/copy/': {
        post: {
            req: QuestionnairesCopyCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/generate/': {
        post: {
            req: QuestionnairesGenerateCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/{uuid}/generate-title/': {
        post: {
            req: QuestionnairesGenerateTitleCreateData;
            res: {
                200: TQuestionnaire;
            };
        };
    };
    '/api/v3/questionnaires/third-party/': {
        post: {
            req: QuestionnairesThirdPartyCreateData;
            res: {
                201: QuestionnaireSubmission;
            };
        };
    };
    '/api/v3/retell_agents/': {
        get: {
            req: RetellAgentsListData;
            res: {
                200: PaginatedTRetellAgentList;
            };
        };
        post: {
            req: RetellAgentsCreateData;
            res: {
                200: TRetellAgent;
            };
        };
    };
    '/api/v3/retell_agents/{uuid}/': {
        get: {
            req: RetellAgentsRetrieveData;
            res: {
                200: TRetellAgent;
            };
        };
        put: {
            req: RetellAgentsUpdateData;
            res: {
                200: TRetellAgent;
            };
        };
        patch: {
            req: RetellAgentsPartialUpdateData;
            res: {
                200: TRetellAgent;
            };
        };
        delete: {
            req: RetellAgentsDestroyData;
            res: {
                200: TRetellAgent;
            };
        };
    };
    '/api/v3/saved_responses/': {
        get: {
            req: SavedResponsesListData;
            res: {
                200: PaginatedTSavedResponseList;
            };
        };
        post: {
            req: SavedResponsesCreateData;
            res: {
                200: TSavedResponse;
            };
        };
    };
    '/api/v3/saved_responses/{uuid}/': {
        get: {
            req: SavedResponsesRetrieveData;
            res: {
                200: TSavedResponse;
            };
        };
        put: {
            req: SavedResponsesUpdateData;
            res: {
                200: TSavedResponse;
            };
        };
        patch: {
            req: SavedResponsesPartialUpdateData;
            res: {
                200: TSavedResponse;
            };
        };
        delete: {
            req: SavedResponsesDestroyData;
            res: {
                200: TSavedResponse;
            };
        };
    };
    '/api/v3/saved_responses/generate_title/': {
        post: {
            req: SavedResponsesGenerateTitleCreateData;
            res: {
                200: GenerateTitleResponse;
            };
        };
    };
    '/api/v3/services/': {
        get: {
            req: ServicesListData;
            res: {
                200: PaginatedTServiceList;
            };
        };
        post: {
            req: ServicesCreateData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/services/{uuid}/': {
        get: {
            req: ServicesRetrieveData;
            res: {
                200: TService;
            };
        };
        put: {
            req: ServicesUpdateData;
            res: {
                200: TService;
            };
        };
        patch: {
            req: ServicesPartialUpdateData;
            res: {
                200: TService;
            };
        };
        delete: {
            req: ServicesDestroyData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/services/{uuid}/{calendar_slug}/availabilities/': {
        post: {
            req: ServicesAvailabilitiesCreateData;
            res: {
                200: TService;
            };
        };
    };
    '/api/v3/settings/actaport/': {
        get: {
            res: {
                200: Array<ActaportSettings>;
            };
        };
        post: {
            req: SettingsActaportCreateData;
            res: {
                201: ActaportSettings;
            };
        };
    };
    '/api/v3/settings/actaport/sync/': {
        put: {
            res: {
                200: unknown;
                403: unknown;
            };
        };
    };
    '/api/v3/settings/advolux/': {
        get: {
            res: {
                200: Array<AdvoluxSettings>;
            };
        };
        post: {
            req: SettingsAdvoluxCreateData;
            res: {
                201: AdvoluxSettings;
            };
        };
    };
    '/api/v3/settings/advoware/': {
        get: {
            res: {
                200: Array<AdvowareSettings>;
            };
        };
        post: {
            req: SettingsAdvowareCreateData;
            res: {
                201: AdvowareSettings;
            };
        };
    };
    '/api/v3/settings/advoware/sync/': {
        put: {
            res: {
                200: unknown;
                400: unknown;
                401: unknown;
                403: unknown;
            };
        };
    };
    '/api/v3/settings/email_egress/': {
        get: {
            res: {
                200: Array<EmailEgressSettings>;
            };
        };
        post: {
            req: SettingsEmailEgressCreateData;
            res: {
                201: EmailEgressSettings;
            };
        };
    };
    '/api/v3/settings/hibp/': {
        get: {
            res: {
                200: Array<HibpSettings>;
            };
        };
        post: {
            req: SettingsHibpCreateData;
            res: {
                201: HibpSettings;
            };
        };
    };
    '/api/v3/settings/hubspot/': {
        get: {
            res: {
                200: Array<HubspotSettings>;
            };
        };
        post: {
            req: SettingsHubspotCreateData;
            res: {
                201: HubspotSettings;
            };
        };
    };
    '/api/v3/settings/iusta/': {
        get: {
            res: {
                200: Array<IustaSettings>;
            };
        };
        post: {
            req: SettingsIustaCreateData;
            res: {
                201: IustaSettings;
            };
        };
    };
    '/api/v3/settings/jurnodes/': {
        get: {
            res: {
                200: Array<JurnodesSettings>;
            };
        };
        post: {
            req: SettingsJurnodesCreateData;
            res: {
                201: JurnodesSettings;
            };
        };
    };
    '/api/v3/settings/jurnodes/sync/': {
        put: {
            res: {
                200: unknown;
                403: unknown;
            };
        };
    };
    '/api/v3/settings/kleos/': {
        get: {
            res: {
                200: Array<KleosSettings>;
            };
        };
        post: {
            req: SettingsKleosCreateData;
            res: {
                201: KleosSettings;
            };
        };
    };
    '/api/v3/settings/lawfirm/': {
        get: {
            res: {
                200: Array<LawfirmSettings>;
            };
        };
        post: {
            req: SettingsLawfirmCreateData;
            res: {
                201: LawfirmSettings;
            };
        };
    };
    '/api/v3/settings/webhooks/': {
        get: {
            res: {
                200: Array<WebhooksSettings>;
            };
        };
        post: {
            req: SettingsWebhooksCreateData;
            res: {
                201: WebhooksSettings;
            };
        };
    };
    '/api/v3/stale_documents/': {
        get: {
            req: StaleDocumentsListData;
            res: {
                200: PaginatedDocumentList;
            };
        };
        post: {
            req: StaleDocumentsCreateData;
            res: {
                201: Document;
            };
        };
    };
    '/api/v3/stale_documents/{uuid}/': {
        get: {
            req: StaleDocumentsRetrieveData;
            res: {
                200: Document;
            };
        };
        put: {
            req: StaleDocumentsUpdateData;
            res: {
                200: Document;
            };
        };
        patch: {
            req: StaleDocumentsPartialUpdateData;
            res: {
                200: Document;
            };
        };
        delete: {
            req: StaleDocumentsDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/stale_documents/{uuid}/mark_completed/': {
        post: {
            req: StaleDocumentsMarkCompletedCreateData;
            res: {
                200: Document;
            };
        };
    };
    '/api/v3/stale_documents/{uuid}/mark_failed/': {
        post: {
            req: StaleDocumentsMarkFailedCreateData;
            res: {
                200: Document;
            };
        };
    };
    '/api/v3/stale_documents/{uuid}/retry_processing/': {
        post: {
            req: StaleDocumentsRetryProcessingCreateData;
            res: {
                200: Document;
            };
        };
    };
    '/api/v3/stripe_customers/': {
        get: {
            req: StripeCustomersListData;
            res: {
                200: PaginatedTStripeCustomerList;
            };
        };
        post: {
            req: StripeCustomersCreateData;
            res: {
                201: SuperUserStripeCustomer;
            };
        };
    };
    '/api/v3/stripe_customers/{uuid}/': {
        get: {
            req: StripeCustomersRetrieveData;
            res: {
                200: TStripeCustomer;
            };
        };
        put: {
            req: StripeCustomersUpdateData;
            res: {
                200: TStripeCustomer;
            };
        };
        patch: {
            req: StripeCustomersPartialUpdateData;
            res: {
                200: TStripeCustomer;
            };
        };
        delete: {
            req: StripeCustomersDestroyData;
            res: {
                200: TStripeCustomer;
            };
        };
    };
    '/api/v3/stripe_invoices/': {
        get: {
            req: StripeInvoicesListData;
            res: {
                200: PaginatedTStripeInvoiceList;
            };
        };
        post: {
            req: StripeInvoicesCreateData;
            res: {
                200: TStripeInvoice;
            };
        };
    };
    '/api/v3/stripe_invoices/{uuid}/': {
        get: {
            req: StripeInvoicesRetrieveData;
            res: {
                200: TStripeInvoice;
            };
        };
        put: {
            req: StripeInvoicesUpdateData;
            res: {
                200: TStripeInvoice;
            };
        };
        patch: {
            req: StripeInvoicesPartialUpdateData;
            res: {
                200: TStripeInvoice;
            };
        };
        delete: {
            req: StripeInvoicesDestroyData;
            res: {
                200: TStripeInvoice;
            };
        };
    };
    '/api/v3/stripe_invoices/export/': {
        post: {
            req: StripeInvoicesExportCreateData;
            res: {
                200: StripeInvoiceExportResponse;
            };
        };
    };
    '/api/v3/unified_document_templates/': {
        get: {
            req: UnifiedDocumentTemplatesListData;
            res: {
                200: PaginatedUnifiedDocumentTemplateList;
            };
        };
    };
    '/api/v3/unified_document_templates/{id}/': {
        patch: {
            req: UnifiedDocumentTemplatesPartialUpdateData;
            res: {
                200: UnifiedDocumentTemplate;
            };
        };
        delete: {
            req: UnifiedDocumentTemplatesDestroyData;
            res: {
                /**
                 * No response body
                 */
                204: void;
            };
        };
    };
    '/api/v3/unified_document_templates/{id}/third-party-token/': {
        get: {
            req: UnifiedDocumentTemplatesThirdPartyTokenRetrieveData;
            res: {
                200: ThirdPartyDocumentCreationTokenResponse;
            };
        };
    };
    '/api/v3/users/': {
        get: {
            req: UsersListData;
            res: {
                200: PaginatedTUserList;
            };
        };
        post: {
            req: UsersCreateData;
            res: {
                200: TUser;
            };
        };
    };
    '/api/v3/users/{uuid}/': {
        get: {
            req: UsersRetrieveData;
            res: {
                200: TUser;
            };
        };
        put: {
            req: UsersUpdateData;
            res: {
                200: TUser;
            };
        };
        patch: {
            req: UsersPartialUpdateData;
            res: {
                200: TUser;
            };
        };
        delete: {
            req: UsersDestroyData;
            res: {
                200: TUser;
            };
        };
    };
    '/api/v3/users/{uuid}/admin_password_update/': {
        patch: {
            req: UsersAdminPasswordUpdatePartialUpdateData;
            res: {
                /**
                 * No response body
                 */
                204: void;
                400: {
                    new_password?: Array<(string)>;
                };
                403: unknown;
            };
        };
    };
    '/api/v3/users/{uuid}/update-avatar/': {
        post: {
            req: UsersUpdateAvatarCreateData;
            res: {
                200: TUser;
                400: {
                    avatar?: Array<(string)>;
                };
                403: unknown;
            };
        };
    };
    '/api/v3/users/change-password/': {
        post: {
            req: UsersChangePasswordCreateData;
            res: {
                200: ChangePasswordResponse;
            };
        };
    };
    '/api/v3/word_document_templates/': {
        get: {
            req: WordDocumentTemplatesListData;
            res: {
                200: PaginatedTWordDocumentTemplateList;
            };
        };
        post: {
            req: WordDocumentTemplatesCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/': {
        get: {
            req: WordDocumentTemplatesRetrieveData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        put: {
            req: WordDocumentTemplatesUpdateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        patch: {
            req: WordDocumentTemplatesPartialUpdateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
        delete: {
            req: WordDocumentTemplatesDestroyData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/copy/': {
        post: {
            req: WordDocumentTemplatesCopyCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/copy-ai-to-current/': {
        post: {
            req: WordDocumentTemplatesCopyAiToCurrentCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/create-edit-token/': {
        post: {
            req: WordDocumentTemplatesCreateEditTokenCreateData;
            res: {
                201: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/create_word_document_preview_blob/': {
        post: {
            req: WordDocumentTemplatesCreateWordDocumentPreviewBlobCreateData;
            res: {
                200: (Blob | File);
                400: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/create_word_document_template_docx_with_placeholders/': {
        post: {
            req: WordDocumentTemplatesCreateWordDocumentTemplateDocxWithPlaceholdersCreateData;
            res: {
                200: (Blob | File);
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/delete_document/': {
        post: {
            req: WordDocumentTemplatesDeleteDocumentCreateData;
            res: {
                200: TWordDocumentTemplate;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/extract_metadata/': {
        post: {
            req: WordDocumentTemplatesExtractMetadataCreateData;
            res: {
                200: ExtractedMetadata;
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/reset-to-original/': {
        post: {
            req: WordDocumentTemplatesResetToOriginalCreateData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/v3/word_document_templates/{uuid}/validate/': {
        get: {
            req: WordDocumentTemplatesValidateRetrieveData;
            res: {
                200: ValidationDataResponse;
            };
        };
        post: {
            req: WordDocumentTemplatesValidateCreateData;
            res: {
                200: GenerateDocumentResponse;
            };
        };
        patch: {
            req: WordDocumentTemplatesValidatePartialUpdateData;
            res: {
                200: UpdateValidationDataResponse;
            };
        };
    };
    '/api/v3/word_document_templates/bulk_upload/': {
        post: {
            req: WordDocumentTemplatesBulkUploadCreateData;
            res: {
                201: PaginatedWordDocumentTemplateList;
            };
        };
    };
    '/api/v3/word_document_templates/task_status/{task_id}/': {
        get: {
            req: WordDocumentTemplatesTaskStatusRetrieveData;
            res: {
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
};